import React from 'react';

export function ProfessionalLiabilitySvg({ className }: { className: string }) {
  return (
    <svg
      viewBox="0 0 1051 493"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M530.06 478.5C793.5 478.5 1007.06 446.712 1007.06 407.5C1007.06 368.288 793.5 336.5 530.06 336.5C266.62 336.5 53.0599 368.288 53.0599 407.5C53.0599 446.712 266.62 478.5 530.06 478.5Z"
        fill="#F9F9F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M297.01 313.91L288.26 44.0701C288.26 44.0701 408.82 59.3301 591.57 59.3301C774.32 59.3301 894.78 48.1001 894.78 48.1001L882.22 309.36C882.22 309.36 752.73 291.85 595.43 291.85C438.13 291.85 297.02 313.92 297.02 313.92L297.01 313.91Z"
        fill="url(#paint0_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M301.59 313.27L297.01 45.28C297.01 45.28 634.75 64.43 888.24 46.59L877.35 307.64C877.35 307.64 633.18 276.73 301.59 313.27Z"
        fill="white"
      />
      <path
        d="M884.67 178.27H299.3V180.3H884.67V178.27Z"
        fill="url(#paint1_linear_2072_10275)"
      />
      <path
        d="M598.71 101C436.34 101 298.29 88.94 296.92 88.81L297.1 86.79C298.47 86.91 436.44 98.97 598.72 98.97C761 98.97 884.12 89.59 885.35 89.5L885.51 91.52C884.28 91.61 761.09 101 598.73 101H598.71Z"
        fill="url(#paint2_linear_2072_10275)"
      />
      <path
        d="M301.04 269.98L300.82 267.96C302.14 267.82 434.46 253.43 596.85 253.43C759.24 253.43 880.56 265.33 881.76 265.45L881.56 267.47C880.35 267.35 759.12 255.46 596.85 255.46C434.58 255.46 302.36 269.83 301.05 269.98H301.04Z"
        fill="url(#paint3_linear_2072_10275)"
      />
      <path
        d="M733.946 56.5924L723.154 297.04L725.182 297.131L735.974 56.6834L733.946 56.5924Z"
        fill="url(#paint4_linear_2072_10275)"
      />
      <path
        d="M446.23 54.685L444.2 54.7063L446.744 297.563L448.774 297.542L446.23 54.685Z"
        fill="url(#paint5_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M595.42 291.84V59.3201L602 59.3801L598.71 291.97L595.42 291.84Z"
        fill="url(#paint6_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1038.4 327.16C953.08 312.36 787.35 288.79 597.27 288.79C320.21 288.79 83.9999 338.86 83.9999 338.86V342.59L83.9699 351.66C83.9699 351.66 84.0099 351.65 84.0899 351.64C90.3699 350.15 339.37 291.83 597.61 291.83C778.68 291.83 949.65 321.02 1037.73 338.99C1037.97 335.05 1038.21 331.1 1038.41 327.16H1038.4Z"
        fill="#F4F4F4"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.87">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1038.26 329.69C950.13 314.62 777.64 289.8 597.01 289.8C333.34 289.8 83.98 342.59 83.98 342.59L83.96 351.66C83.96 351.66 84 351.65 84.08 351.64C90.36 350.15 339.36 291.83 597.6 291.83C778.67 291.83 949.64 321.02 1037.72 338.99C1037.91 335.89 1038.09 332.79 1038.26 329.69Z"
          fill="#F4F4F4"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1045.38 14.88C971.13 31.19 820.63 56.36 598.73 56.36C270.4 56.36 83.96 0 83.96 0V16.75C83.96 16.75 262.02 62.29 598.7 62.29C829.9 62.29 979.52 40.82 1050.58 27.36C1048.74 23.22 1046.93 19.09 1045.38 14.88Z"
        fill="#F4F4F4"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.87">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1045.38 14.88C971.13 31.19 820.63 56.36 598.73 56.36C270.4 56.36 83.96 0 83.96 0V12.18C83.96 12.18 320.72 60.78 599.51 60.78C805.25 60.78 969.4 36.64 1048.4 22.39C1047.33 19.9 1046.31 17.41 1045.37 14.88H1045.38Z"
          fill="#F4F4F4"
        />
      </g>
      <path d="M517.53 189.51H516.22V223.91H517.53V189.51Z" fill="#CECECE" />
      <path d="M508.65 205.43H507.34V236.22H508.65V205.43Z" fill="#CECECE" />
      <path d="M511.19 203.66H510.27V237.41H511.19V203.66Z" fill="#CECECE" />
      <path
        d="M458.8 204.04H458.26V183.64L458.8 183.7V204.04Z"
        fill="#CECECE"
      />
      <path
        d="M459.95 199.16H459.41V178.76L459.95 178.82V199.16Z"
        fill="#CECECE"
      />
      <path
        d="M457.92 209.82H457.39V197.91L457.92 197.94V209.82Z"
        fill="#CECECE"
      />
      <path d="M514.3 218.61H513.38V243.73H514.3V218.61Z" fill="#CECECE" />
      <path d="M519.3 184.27H518.28V218.67H519.3V184.27Z" fill="#CECECE" />
      <path d="M520.87 195.5H519.85V207.32H520.87V195.5Z" fill="#CECECE" />
      <path
        d="M529.71 184.51L528.63 184.56V183.11L529.71 183.06V184.51Z"
        fill="#CECECE"
      />
      <path
        d="M529.7 188.76L528.63 188.78V187.29L529.7 187.27V188.76Z"
        fill="#CECECE"
      />
      <path
        d="M531.38 188.74L530.31 188.75V187.26L531.38 187.25V188.74Z"
        fill="#CECECE"
      />
      <path
        d="M533.02 184.37L531.95 184.42V182.97L533.02 182.91V184.37Z"
        fill="#CECECE"
      />
      <path
        d="M534.72 186.49L533.65 186.52V185.06L534.72 185.02V186.49Z"
        fill="#CECECE"
      />
      <path d="M534.72 189.37H533.65V190.88H534.72V189.37Z" fill="#CECECE" />
      <path
        d="M536.43 184.22L535.36 184.27V182.82L536.43 182.77V184.22Z"
        fill="#CECECE"
      />
      <path
        d="M550.66 184.06L549.15 184.01V182.54L550.66 182.59V184.06Z"
        fill="#CECECE"
      />
      <path
        d="M550.66 188.52L549.15 188.5V187L550.66 187.02V188.52Z"
        fill="#CECECE"
      />
      <path
        d="M550.66 186.39L549.15 186.37V184.87L550.66 184.89V186.39Z"
        fill="#CECECE"
      />
      <path
        d="M554.21 186.67L553.2 186.65V185.16L554.21 185.17V186.67Z"
        fill="#CECECE"
      />
      <path
        d="M554.21 188.81L553.2 188.79V187.3L554.21 187.32V188.81Z"
        fill="#CECECE"
      />
      <path
        d="M555.51 184.29L554.66 184.24V182.79L555.51 182.84V184.29Z"
        fill="#CECECE"
      />
      <path d="M555.51 189.23H554.66V190.74H555.51V189.23Z" fill="#CECECE" />
      <path
        d="M542.46 184.1L540.99 184.12V182.66C540.99 182.66 542.42 182.64 542.46 182.64V184.11V184.1Z"
        fill="#CECECE"
      />
      <path
        d="M542.45 188.62H540.99V187.13C540.99 187.13 542.44 187.13 542.45 187.13V188.62Z"
        fill="#CECECE"
      />
      <path
        d="M545.4 186.52H543.48V185.02C543.48 185.02 545.38 185.02 545.4 185.02V186.52Z"
        fill="#CECECE"
      />
      <path d="M545.39 189.37H543.48V190.88H545.39V189.37Z" fill="#CECECE" />
      <path
        d="M538.35 184.16L537.11 184.2V182.75L538.35 182.71V184.16Z"
        fill="#CECECE"
      />
      <path
        d="M538.35 186.4L537.11 186.43V184.96L538.35 184.93V186.4Z"
        fill="#CECECE"
      />
      <path
        d="M538.35 188.64L537.11 188.65V187.17L538.35 187.15V188.64Z"
        fill="#CECECE"
      />
      <path
        d="M529.7 195.56L528.63 195.58V194.09L529.7 194.07V195.56Z"
        fill="#CECECE"
      />
      <path
        d="M529.7 193.45L528.63 193.47V191.98L529.7 191.96V193.45Z"
        fill="#CECECE"
      />
      <path
        d="M531.38 195.53L530.31 195.55V194.06L531.38 194.05V195.53Z"
        fill="#CECECE"
      />
      <path
        d="M534.72 193.29L533.65 193.32V191.86L534.72 191.82V193.29Z"
        fill="#CECECE"
      />
      <path d="M534.72 196.17H533.65V197.68H534.72V196.17Z" fill="#CECECE" />
      <path d="M534.72 198.43H533.65V199.94H534.72V198.43Z" fill="#CECECE" />
      <path d="M536.43 194.05H535.36V195.56H536.43V194.05Z" fill="#CECECE" />
      <path d="M536.43 196.3H535.36V197.81H536.43V196.3Z" fill="#CECECE" />
      <path
        d="M550.66 195.32L549.15 195.3V193.8L550.66 193.82V195.32Z"
        fill="#CECECE"
      />
      <path
        d="M550.66 193.19L549.15 193.17V191.67L550.66 191.69V193.19Z"
        fill="#CECECE"
      />
      <path
        d="M554.21 193.46L553.2 193.45V191.96L554.21 191.97V193.46Z"
        fill="#CECECE"
      />
      <path
        d="M554.21 195.61L553.2 195.59V194.1L554.21 194.11V195.61Z"
        fill="#CECECE"
      />
      <path d="M555.51 196.03H554.66V197.54H555.51V196.03Z" fill="#CECECE" />
      <path
        d="M542.45 195.42H540.99V193.93C540.99 193.93 542.44 193.93 542.45 193.93V195.42Z"
        fill="#CECECE"
      />
      <path
        d="M545.4 193.32H543.48V191.82C543.48 191.82 545.38 191.82 545.4 191.82V193.32Z"
        fill="#CECECE"
      />
      <path d="M545.39 196.17H543.48V197.68H545.39V196.17Z" fill="#CECECE" />
      <path
        d="M538.35 193.2L537.11 193.23V191.76L538.35 191.73V193.2Z"
        fill="#CECECE"
      />
      <path
        d="M538.35 195.44L537.11 195.45V193.97L538.35 193.95V195.44Z"
        fill="#CECECE"
      />
      <path d="M522.14 197.97H521.13V199.39H522.14V197.97Z" fill="#CECECE" />
      <path d="M525.57 197.97H524.4V199.39H525.57V197.97Z" fill="#CECECE" />
      <path
        d="M508.28 198.77L507.34 198.82V197.57L508.28 197.51V198.77Z"
        fill="#CECECE"
      />
      <path
        d="M509.72 200.58L508.78 200.63V199.36L509.72 199.31V200.58Z"
        fill="#CECECE"
      />
      <path
        d="M511.21 198.6L510.27 198.66V197.41L511.21 197.34V198.6Z"
        fill="#CECECE"
      />
      <path
        d="M511.2 201.62L510.26 201.66V200.39L511.2 200.35V201.62Z"
        fill="#CECECE"
      />
      <path
        d="M511.21 202.44L510.27 202.47V201.19L511.21 201.16V202.44Z"
        fill="#CECECE"
      />
      <path
        d="M512.7 200.46L511.76 200.5V199.23L512.7 199.19V200.46Z"
        fill="#CECECE"
      />
      <path
        d="M514.39 198.44L513.3 198.49V197.24L514.39 197.19V198.44Z"
        fill="#CECECE"
      />
      <path
        d="M514.39 200.4L513.3 200.44V199.17L514.39 199.13V200.4Z"
        fill="#CECECE"
      />
      <path
        d="M514.39 202.36L513.3 202.39V201.1L514.39 201.08V202.36Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 158.96V159.88C416.63 159.88 412.55 160.13 410.39 161.75V161.21C410.39 161.21 412.41 159.5 416.63 158.96Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 161.91C416.63 161.91 412.45 162.14 410.39 163.7V163.14C410.39 163.14 412.59 161.51 416.63 160.99V161.91Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 163.92C416.63 163.92 412.36 164.14 410.39 165.63V165.05C410.39 165.05 412.78 163.49 416.63 162.99V163.92Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 165.94C416.63 165.94 412.26 166.15 410.39 167.57V166.97C410.39 166.97 412.96 165.48 416.63 165.01V165.94Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 167.96C416.63 167.96 412.17 168.16 410.39 169.5V168.89C410.39 168.89 413.14 167.48 416.63 167.03V167.96Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 169.98C416.63 169.98 412.08 170.17 410.39 171.44V170.81C410.39 170.81 413.33 169.47 416.63 169.05V169.98Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 174.02C416.63 174.02 411.89 174.19 410.39 175.32V174.65C410.39 174.65 413.69 173.46 416.63 173.08V174.01V174.02Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 176.03C416.63 176.03 411.8 176.19 410.39 177.25V176.57C410.39 176.57 413.88 175.46 416.63 175.1V176.03Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 178.05C416.63 178.05 411.7 178.2 410.39 179.19V178.49C410.39 178.49 414.06 177.45 416.63 177.12V178.05Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 180.07C416.63 180.07 411.61 180.21 410.39 181.13V180.41C410.39 180.41 414.24 179.44 416.63 179.14V180.08V180.07Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 182.09C416.63 182.09 411.52 182.22 410.39 183.07V182.33C410.39 182.33 414.43 181.44 416.63 181.16V182.1V182.09Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 186.13C416.63 186.13 411.33 186.24 410.39 186.94V186.17C410.39 186.17 414.79 185.43 416.63 185.19V186.13Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 188.15C416.63 188.15 411.23 188.25 410.39 188.88V188.09C410.39 188.09 414.98 187.42 416.63 187.21V188.15Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 192.18C416.63 192.18 411.05 192.25 410.39 192.75V191.92C410.39 191.92 415.34 191.4 416.63 191.24V192.18Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 194.2C416.63 194.2 410.95 194.26 410.39 194.69V193.84C410.39 193.84 415.53 193.39 416.63 193.25V194.2Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 196.22C416.63 196.22 410.86 196.27 410.39 196.63V195.77C410.39 195.77 415.71 195.4 416.63 195.28V196.23V196.22Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 200.26C416.63 200.26 410.67 200.29 410.39 200.5V199.6C410.39 199.6 416.08 199.38 416.63 199.31V200.26Z"
        fill="#CECECE"
      />
      <path
        d="M416.63 204.29C416.63 204.29 410.48 204.3 410.39 204.37V203.44C410.39 203.44 416.44 203.37 416.63 203.34V204.29Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 159.24V160.36L424.55 160.18V158.96L426.26 159.24Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 161.23V162.36L424.55 162.19V160.97L426.26 161.23Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 163.23V164.36L424.55 164.19V162.98L426.26 163.23Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 165.23V166.35L424.55 166.2V164.99L426.26 165.23Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 167.23V168.35L424.55 168.2V167L426.26 167.23Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 171.23V172.35L424.55 172.21V171.03L426.26 171.23Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 173.22V174.35L424.55 174.22V173.03L426.26 173.22Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 177.22V178.34L424.55 178.23V177.05L426.26 177.22Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 179.22V180.34L424.55 180.24V179.06L426.26 179.22Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 181.22V182.34L424.55 182.24V181.08L426.26 181.22Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 183.22V184.33L424.55 184.25V183.08L426.26 183.22Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 187.21V188.33L424.55 188.26V187.11L426.26 187.21Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 189.21V190.33L424.55 190.26V189.12L426.26 189.21Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 191.21V192.33L424.55 192.27V191.12L426.26 191.21Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 195.2V196.32L424.55 196.28V195.15L426.26 195.2Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 197.2V198.32L424.55 198.29V197.16L426.26 197.2Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 201.2V202.32L424.55 202.3V201.18L426.26 201.2Z"
        fill="#CECECE"
      />
      <path d="M426.26 205.2H424.55V206.32H426.26V205.2Z" fill="#CECECE" />
      <path
        d="M423.88 158.87V160.09L422.27 159.98V158.74L423.88 158.87Z"
        fill="#CECECE"
      />
      <path
        d="M423.89 160.88V162.1L422.27 162V160.76L423.89 160.88Z"
        fill="#CECECE"
      />
      <path
        d="M423.89 162.9V164.11L422.27 164.01V162.78L423.89 162.9Z"
        fill="#CECECE"
      />
      <path
        d="M423.89 164.91V166.12L422.27 166.02V164.8L423.89 164.91Z"
        fill="#CECECE"
      />
      <path
        d="M423.89 166.92V168.13L422.27 168.04V166.82L423.89 166.92Z"
        fill="#CECECE"
      />
      <path
        d="M423.89 168.94V170.14L422.27 170.05V168.84L423.89 168.94Z"
        fill="#CECECE"
      />
      <path
        d="M423.9 170.95V172.14L422.27 172.07V170.86L423.9 170.95Z"
        fill="#CECECE"
      />
      <path
        d="M423.9 172.97V174.16L422.27 174.08V172.88L423.9 172.97Z"
        fill="#CECECE"
      />
      <path
        d="M423.9 174.98V176.16L422.27 176.1V174.9L423.9 174.98Z"
        fill="#CECECE"
      />
      <path
        d="M423.9 179.01V180.18L422.27 180.12V178.94L423.9 179.01Z"
        fill="#CECECE"
      />
      <path
        d="M423.91 181.02V182.19L422.27 182.14V180.96L423.91 181.02Z"
        fill="#CECECE"
      />
      <path
        d="M423.91 185.05V186.21L422.27 186.17V185L423.91 185.05Z"
        fill="#CECECE"
      />
      <path
        d="M423.91 187.07V188.22L422.27 188.18V187.02L423.91 187.07Z"
        fill="#CECECE"
      />
      <path
        d="M423.91 189.08V190.23L422.27 190.2V189.04L423.91 189.08Z"
        fill="#CECECE"
      />
      <path
        d="M423.92 191.1V192.24L422.27 192.21V191.06L423.92 191.1Z"
        fill="#CECECE"
      />
      <path
        d="M423.92 193.11V194.25L422.27 194.23V193.08L423.92 193.11Z"
        fill="#CECECE"
      />
      <path
        d="M423.92 195.12V196.26L422.27 196.24V195.1L423.92 195.12Z"
        fill="#CECECE"
      />
      <path
        d="M423.92 199.15V200.28L422.27 200.27V199.14L423.92 199.15Z"
        fill="#CECECE"
      />
      <path
        d="M423.93 201.17V202.29L422.27 202.28V201.16L423.93 201.17Z"
        fill="#CECECE"
      />
      <path d="M423.93 205.2H422.27V206.32H423.93V205.2Z" fill="#CECECE" />
      <path
        d="M421.56 158.67V159.88L419.9 159.82V158.59L421.56 158.67Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 160.69V161.9L419.9 161.84V160.62L421.56 160.69Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 162.72V163.92L419.89 163.86V162.64L421.56 162.72Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 164.74V165.94L419.89 165.89V164.67L421.56 164.74Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 166.76V167.95L419.89 167.91V166.7L421.56 166.76Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 168.79V169.97L419.89 169.93V168.72L421.56 168.79Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 170.81V171.99L419.89 171.95V170.75L421.56 170.81Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 172.83V174.01L419.89 173.97V172.78L421.56 172.83Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 174.85V176.03L419.89 175.99V174.8L421.56 174.85Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 176.88V178.05L419.89 178.01V176.83L421.56 176.88Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 178.9V180.07L419.89 180.04V178.85L421.56 178.9Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 180.92V182.09L419.89 182.06V180.88L421.56 180.92Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 182.94V184.1L419.89 184.08V182.91L421.56 182.94Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 184.97V186.12L419.89 186.1V184.93L421.56 184.97Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 189.01V190.16L419.88 190.14V188.99L421.56 189.01Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 193.06V194.2L419.88 194.18V193.04L421.56 193.06Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 197.1V198.24L419.88 198.23V197.09L421.56 197.1Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 199.13V200.26L419.88 200.25V199.12L421.56 199.13Z"
        fill="#CECECE"
      />
      <path
        d="M421.56 201.15V202.27H419.88V201.14L421.56 201.15Z"
        fill="#CECECE"
      />
      <path d="M421.56 203.17V204.29H419.88V203.17H421.56Z" fill="#CECECE" />
      <path d="M419.1 158.56H417.62V159.8H419.1V158.56Z" fill="#CECECE" />
      <path d="M419.1 160.59H417.62V161.83H419.1V160.59Z" fill="#CECECE" />
      <path d="M419.1 162.62H417.62V163.85H419.1V162.62Z" fill="#CECECE" />
      <path d="M419.1 164.65H417.62V165.88H419.1V164.65Z" fill="#CECECE" />
      <path d="M419.1 166.67H417.62V167.89H419.1V166.67Z" fill="#CECECE" />
      <path d="M419.1 168.7H417.62V169.91H419.1V168.7Z" fill="#CECECE" />
      <path d="M419.1 170.73H417.62V171.94H419.1V170.73Z" fill="#CECECE" />
      <path d="M419.1 172.76H417.62V173.96H419.1V172.76Z" fill="#CECECE" />
      <path d="M419.1 174.78H417.62V175.98H419.1V174.78Z" fill="#CECECE" />
      <path d="M419.1 176.81H417.62V178H419.1V176.81Z" fill="#CECECE" />
      <path d="M419.1 178.84H417.62V180.03H419.1V178.84Z" fill="#CECECE" />
      <path d="M419.1 180.87H417.62V182.05H419.1V180.87Z" fill="#CECECE" />
      <path d="M419.1 182.89H417.62V184.07H419.1V182.89Z" fill="#CECECE" />
      <path d="M419.1 184.92H417.62V186.09H419.1V184.92Z" fill="#CECECE" />
      <path d="M419.1 186.95H417.62V188.11H419.1V186.95Z" fill="#CECECE" />
      <path d="M419.1 191H417.62V192.15H419.1V191Z" fill="#CECECE" />
      <path d="M419.1 193.03H417.62V194.18H419.1V193.03Z" fill="#CECECE" />
      <path d="M419.1 195.06H417.62V196.2H419.1V195.06Z" fill="#CECECE" />
      <path d="M419.1 197.09H417.62V198.23H419.1V197.09Z" fill="#CECECE" />
      <path d="M419.1 199.11H417.62V200.24H419.1V199.11Z" fill="#CECECE" />
      <path d="M419.1 201.14H417.62V202.27H419.1V201.14Z" fill="#CECECE" />
      <path d="M419.1 205.2H417.62V206.32H419.1V205.2Z" fill="#CECECE" />
      <path
        d="M416.63 212.78C416.63 212.78 410.48 212.79 410.39 212.86V211.92C410.39 211.92 416.44 211.85 416.63 211.82V212.77V212.78Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 159.6V160.52C427.32 160.52 430.24 160.76 431.79 162.39V161.85C431.79 161.85 430.34 160.14 427.32 159.6Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 162.54C427.32 162.54 430.31 162.77 431.79 164.33V163.77C431.79 163.77 430.21 162.14 427.32 161.62V162.54Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 164.56C427.32 164.56 430.38 164.78 431.79 166.27V165.69C431.79 165.69 430.08 164.13 427.32 163.63V164.56Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 166.58C427.32 166.58 430.45 166.79 431.79 168.21V167.61C431.79 167.61 429.95 166.12 427.32 165.65V166.58Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 168.6C427.32 168.6 430.51 168.8 431.79 170.15V169.54C431.79 169.54 429.82 168.13 427.32 167.68V168.61V168.6Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 170.62C427.32 170.62 430.58 170.81 431.79 172.08V171.45C431.79 171.45 429.69 170.11 427.32 169.69V170.62Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 174.65C427.32 174.65 430.71 174.82 431.79 175.95V175.28C431.79 175.28 429.43 174.09 427.32 173.71V174.64V174.65Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 176.67C427.32 176.67 430.78 176.83 431.79 177.89V177.21C431.79 177.21 429.29 176.1 427.32 175.74V176.67Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 178.69C427.32 178.69 430.85 178.84 431.79 179.83V179.13C431.79 179.13 429.16 178.09 427.32 177.76V178.69Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 180.71C427.32 180.71 430.91 180.85 431.79 181.77V181.05C431.79 181.05 429.03 180.08 427.32 179.78V180.72V180.71Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 182.73C427.32 182.73 430.98 182.86 431.79 183.71V182.97C431.79 182.97 428.9 182.08 427.32 181.8V182.74V182.73Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 186.77C427.32 186.77 431.12 186.88 431.79 187.58V186.81C431.79 186.81 428.64 186.07 427.32 185.83V186.77Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 188.78C427.32 188.78 431.18 188.88 431.79 189.51V188.72C431.79 188.72 428.51 188.05 427.32 187.84V188.78Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 192.82C427.32 192.82 431.32 192.89 431.79 193.39V192.56C431.79 192.56 428.24 192.04 427.32 191.88V192.82Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 194.84C427.32 194.84 431.38 194.9 431.79 195.33V194.48C431.79 194.48 428.11 194.03 427.32 193.89V194.84Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 196.86C427.32 196.86 431.45 196.91 431.79 197.27V196.41C431.79 196.41 427.98 196.04 427.32 195.92V196.87V196.86Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 200.89C427.32 200.89 431.58 200.92 431.79 201.13V200.23C431.79 200.23 427.72 200.01 427.32 199.94V200.89Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 204.93C427.32 204.93 431.72 204.94 431.79 205.01V204.08C431.79 204.08 427.46 204 427.32 203.98V204.93Z"
        fill="#CECECE"
      />
      <path
        d="M427.32 213.41C427.32 213.41 431.72 213.42 431.79 213.49V212.55C431.79 212.55 427.46 212.48 427.32 212.45V213.4V213.41Z"
        fill="#CECECE"
      />
      <path
        d="M426.26 208.5V209.62L424.55 209.6V208.48L426.26 208.5Z"
        fill="#CECECE"
      />
      <path d="M426.26 213.68H424.55V214.8H426.26V213.68Z" fill="#CECECE" />
      <path
        d="M423.93 208.47V209.59L422.27 209.58V208.46L423.93 208.47Z"
        fill="#CECECE"
      />
      <path d="M423.93 213.68H422.27V214.8H423.93V213.68Z" fill="#CECECE" />
      <path
        d="M421.56 208.45V209.57H419.88V208.44L421.56 208.45Z"
        fill="#CECECE"
      />
      <path d="M421.56 210.47V211.59H419.88V210.47H421.56Z" fill="#CECECE" />
      <path d="M419.1 208.44H417.62V209.57H419.1V208.44Z" fill="#CECECE" />
      <path d="M419.1 213.68H417.62V214.8H419.1V213.68Z" fill="#CECECE" />
      <path
        d="M528.52 106.74L529.63 106.12V106.99L528.52 107.57V106.74Z"
        fill="#CECECE"
      />
      <path
        d="M529.63 109.14L528.52 109.7V108.84L529.63 108.25V109.14Z"
        fill="#CECECE"
      />
      <path
        d="M529.63 111.28L528.52 111.82V110.95L529.63 110.37V111.28Z"
        fill="#CECECE"
      />
      <path
        d="M529.63 113.42L528.52 113.94V113.05L529.63 112.49V113.42Z"
        fill="#CECECE"
      />
      <path
        d="M529.63 115.56L528.52 116.07V115.16L529.63 114.61V115.56Z"
        fill="#CECECE"
      />
      <path
        d="M529.63 117.7L528.52 118.19V117.26L529.63 116.73V117.7Z"
        fill="#CECECE"
      />
      <path
        d="M529.63 119.84L528.52 120.32V119.37L529.63 118.86V119.84Z"
        fill="#CECECE"
      />
      <path
        d="M529.63 121.98L528.52 122.44V121.47L529.63 120.98V121.98Z"
        fill="#CECECE"
      />
      <path
        d="M529.62 124.12L528.52 124.56V123.57L529.62 123.1V124.12Z"
        fill="#CECECE"
      />
      <path
        d="M529.62 126.26L528.52 126.69V125.68L529.62 125.22V126.26Z"
        fill="#CECECE"
      />
      <path
        d="M529.62 128.4L528.52 128.81V127.78L529.62 127.34V128.4Z"
        fill="#CECECE"
      />
      <path
        d="M529.62 130.54L528.52 130.94V129.89L529.62 129.46V130.54Z"
        fill="#CECECE"
      />
      <path
        d="M529.62 136.96L528.52 137.31V136.2L529.62 135.83V136.96Z"
        fill="#CECECE"
      />
      <path
        d="M529.62 139.1L528.52 139.43V138.3L529.62 137.95V139.1Z"
        fill="#CECECE"
      />
      <path
        d="M529.62 141.24L528.52 141.56V140.41L529.62 140.07V141.24Z"
        fill="#CECECE"
      />
      <path
        d="M529.62 143.38L528.52 143.68V142.51L529.62 142.2V143.38Z"
        fill="#CECECE"
      />
      <path
        d="M529.62 147.66L528.52 147.93V146.72L529.62 146.44V147.66Z"
        fill="#CECECE"
      />
      <path
        d="M529.62 149.8L528.52 150.05V148.83L529.62 148.56V149.8Z"
        fill="#CECECE"
      />
      <path
        d="M529.61 156.22L528.52 156.42V155.14L529.61 154.93V156.22Z"
        fill="#CECECE"
      />
      <path
        d="M529.61 160.51L528.52 160.67V159.35L529.61 159.17V160.51Z"
        fill="#CECECE"
      />
      <path
        d="M529.61 162.65L528.52 162.8V161.45L529.61 161.29V162.65Z"
        fill="#CECECE"
      />
      <path
        d="M529.61 166.93L528.52 167.04V165.66L529.61 165.54V166.93Z"
        fill="#CECECE"
      />
      <path
        d="M529.61 169.07L528.52 169.17V167.76L529.61 167.66V169.07Z"
        fill="#CECECE"
      />
      <path
        d="M529.61 173.35L528.52 173.41V171.97L529.61 171.9V173.35Z"
        fill="#CECECE"
      />
      <path
        d="M529.61 175.49L528.52 175.54V174.08L529.61 174.02V175.49Z"
        fill="#CECECE"
      />
      <path
        d="M529.6 179.77L528.52 179.79V178.29L529.6 178.27V179.77Z"
        fill="#CECECE"
      />
      <path
        d="M530.19 105.87L531.3 105.26V106.13L530.19 106.71V105.87Z"
        fill="#CECECE"
      />
      <path
        d="M531.3 108.29L530.19 108.85V108L531.3 107.4V108.29Z"
        fill="#CECECE"
      />
      <path
        d="M531.3 110.46L530.19 111V110.13L531.3 109.55V110.46Z"
        fill="#CECECE"
      />
      <path
        d="M531.3 112.62L530.19 113.15V112.26L531.3 111.7V112.62Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 114.79L530.19 115.3V114.39L531.29 113.84V114.79Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 116.95L530.19 117.45V116.52L531.29 115.99V116.95Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 119.12L530.19 119.6V118.65L531.29 118.14V119.12Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 121.28L530.19 121.75V120.78L531.29 120.28V121.28Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 123.45L530.19 123.9V122.91L531.29 122.43V123.45Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 125.61L530.19 126.04V125.03L531.29 124.58V125.61Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 127.78L530.2 128.19V127.16L531.29 126.72V127.78Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 129.94L530.2 130.34V129.29L531.29 128.87V129.94Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 134.28L530.2 134.64V133.55L531.29 133.16V134.28Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 136.44L530.2 136.79V135.68L531.29 135.31V136.44Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 138.61L530.2 138.94V137.81L531.29 137.46V138.61Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 140.77L530.2 141.08V139.94L531.29 139.6V140.77Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 142.94L530.2 143.23V142.07L531.29 141.75V142.94Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 147.27L530.2 147.53V146.33L531.29 146.04V147.27Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 149.43L530.2 149.68V148.45L531.29 148.19V149.43Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 151.6L530.2 151.83V150.58L531.29 150.34V151.6Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 153.76L530.2 153.98V152.71L531.29 152.48V153.76Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 155.93L530.2 156.13V154.84L531.29 154.63V155.93Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 160.26L530.21 160.42V159.1L531.29 158.92V160.26Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 166.75L530.21 166.87V165.49L531.29 165.36V166.75Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 173.25L530.21 173.32V171.87L531.29 171.8V173.25Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 179.75L530.21 179.76V178.26L531.29 178.24V179.75Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 186.42L530.21 186.44V184.94L531.29 184.92V186.42Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 190.9L530.21 190.91V189.41L531.29 189.4V190.9Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 197.67L530.21 197.69V196.19L531.29 196.17V197.67Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 199.93L530.21 199.95V198.45L531.29 198.43V199.93Z"
        fill="#CECECE"
      />
      <path
        d="M531.85 105.02L532.96 104.4V105.27L531.85 105.85V105.02Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 107.46L531.85 108.03V107.17L532.96 106.58V107.46Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 109.65L531.85 110.2V109.33L532.96 108.75V109.65Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 111.84L531.86 112.37V111.48L532.96 110.92V111.84Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 114.03L531.86 114.55V113.63L532.96 113.09V114.03Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 116.22L531.86 116.72V115.79L532.96 115.26V116.22Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 118.41L531.86 118.89V117.94L532.96 117.43V118.41Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 120.6L531.86 121.06V120.09L532.96 119.6V120.6Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 122.79L531.86 123.24V122.25L532.96 121.77V122.79Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 124.98L531.86 125.41V124.4L532.96 123.94V124.98Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 127.17L531.86 127.58V126.55L532.96 126.11V127.17Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 131.55L531.86 131.93V130.86L532.96 130.46V131.55Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 135.93L531.86 136.28V135.17L532.96 134.8V135.93Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 138.12L531.86 138.45V137.32L532.96 136.97V138.12Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 140.31L531.86 140.62V139.48L532.96 139.14V140.31Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 142.5L531.86 142.79V141.63L532.96 141.31V142.5Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 149.07L531.86 149.31V148.09L532.96 147.82V149.07Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 151.26L531.86 151.49V150.24L532.96 150V151.26Z"
        fill="#CECECE"
      />
      <path
        d="M532.96 153.45L531.86 153.66V152.4L532.96 152.17V153.45Z"
        fill="#CECECE"
      />
      <path
        d="M532.95 155.63L531.86 155.83V154.55L532.95 154.34V155.63Z"
        fill="#CECECE"
      />
      <path
        d="M532.95 160.01L531.87 160.18V158.86L532.95 158.68V160.01Z"
        fill="#CECECE"
      />
      <path
        d="M532.95 164.39L531.87 164.53V163.16L532.95 163.02V164.39Z"
        fill="#CECECE"
      />
      <path
        d="M532.95 168.77L531.87 168.87V167.47L532.95 167.36V168.77Z"
        fill="#CECECE"
      />
      <path
        d="M532.95 170.96L531.87 171.04V169.62L532.95 169.53V170.96Z"
        fill="#CECECE"
      />
      <path
        d="M532.95 175.34L531.87 175.39V173.93L532.95 173.88V175.34Z"
        fill="#CECECE"
      />
      <path
        d="M533.55 104.19L534.66 103.57V104.44L533.55 105.02V104.19Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 106.66L533.56 107.22V106.37L534.66 105.77V106.66Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 111.08L533.56 111.61V110.72L534.66 110.16V111.08Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 113.3L533.56 113.81V112.9L534.66 112.35V113.3Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 115.51L533.56 116.01V115.07L534.66 114.55V115.51Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 117.72L533.56 118.2V117.25L534.66 116.74V117.72Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 122.15L533.56 122.6V121.61L534.66 121.13V122.15Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 124.36L533.56 124.79V123.78L534.66 123.32V124.36Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 126.58L533.56 126.99V125.96L534.66 125.52V126.58Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 128.79L533.56 129.19V128.14L534.66 127.71V128.79Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 131L533.56 131.38V130.31L534.66 129.91V131Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 133.22L533.57 133.58V132.49L534.66 132.1V133.22Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 135.43L533.57 135.78V134.67L534.66 134.3V135.43Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 137.64L533.57 137.97V136.85L534.66 136.49V137.64Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 142.07L533.57 142.37V141.2L534.66 140.88V142.07Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 144.28L533.57 144.56V143.38L534.66 143.08V144.28Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 146.5L533.57 146.76V145.55L534.66 145.27V146.5Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 148.71L533.57 148.96V147.73L534.66 147.47V148.71Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 150.92L533.57 151.15V149.91L534.66 149.66V150.92Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 153.14L533.57 153.35V152.09L534.66 151.86V153.14Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 157.56L533.58 157.74V156.44L534.66 156.25V157.56Z"
        fill="#CECECE"
      />
      <path
        d="M534.66 159.78L533.58 159.94V158.62L534.66 158.44V159.78Z"
        fill="#CECECE"
      />
      <path
        d="M534.67 164.2L533.58 164.34V162.97L534.67 162.83V164.2Z"
        fill="#CECECE"
      />
      <path
        d="M534.67 168.63L533.58 168.73V167.33L534.67 167.22V168.63Z"
        fill="#CECECE"
      />
      <path
        d="M534.67 170.84L533.58 170.93V169.5L534.67 169.42V170.84Z"
        fill="#CECECE"
      />
      <path
        d="M534.67 173.06L533.58 173.12V171.68L534.67 171.61V173.06Z"
        fill="#CECECE"
      />
      <path
        d="M534.65 176.53L533.57 176.58V175.12L534.65 175.07V176.53Z"
        fill="#CECECE"
      />
      <path
        d="M534.67 177.48L533.58 177.52V176.04L534.67 176V177.48Z"
        fill="#CECECE"
      />
      <path d="M534.67 180.39H533.59V181.91H534.67V180.39Z" fill="#CECECE" />
      <path
        d="M535.32 103.35L536.44 102.73V103.6L535.32 104.18V103.35Z"
        fill="#CECECE"
      />
      <path
        d="M536.44 105.84L535.32 106.41V105.55L536.44 104.95V105.84Z"
        fill="#CECECE"
      />
      <path
        d="M536.43 108.08L535.32 108.63V107.75L536.43 107.16V108.08Z"
        fill="#CECECE"
      />
      <path
        d="M536.43 110.31L535.32 110.85V109.95L536.43 109.38V110.31Z"
        fill="#CECECE"
      />
      <path
        d="M536.43 112.55L535.32 113.07V112.15L536.43 111.6V112.55Z"
        fill="#CECECE"
      />
      <path
        d="M536.43 114.79L535.32 115.29V114.35L536.43 113.82V114.79Z"
        fill="#CECECE"
      />
      <path
        d="M536.43 117.03L535.32 117.51V116.55L536.43 116.04V117.03Z"
        fill="#CECECE"
      />
      <path
        d="M536.43 119.26L535.32 119.73V118.76L536.43 118.26V119.26Z"
        fill="#CECECE"
      />
      <path
        d="M536.42 121.5L535.32 121.95V120.96L536.42 120.48V121.5Z"
        fill="#CECECE"
      />
      <path
        d="M536.42 123.74L535.32 124.17V123.16L536.42 122.7V123.74Z"
        fill="#CECECE"
      />
      <path
        d="M536.42 125.98L535.32 126.39V125.36L536.42 124.92V125.98Z"
        fill="#CECECE"
      />
      <path
        d="M536.42 128.21L535.32 128.61V127.56L536.42 127.13V128.21Z"
        fill="#CECECE"
      />
      <path
        d="M536.42 130.45L535.32 130.83V129.76L536.42 129.35V130.45Z"
        fill="#CECECE"
      />
      <path
        d="M536.42 132.69L535.31 133.05V131.96L536.42 131.57V132.69Z"
        fill="#CECECE"
      />
      <path
        d="M536.41 134.93L535.31 135.27V134.16L536.41 133.79V134.93Z"
        fill="#CECECE"
      />
      <path
        d="M536.41 137.16L535.31 137.5V136.37L536.41 136.01V137.16Z"
        fill="#CECECE"
      />
      <path
        d="M536.41 139.4L535.31 139.72V138.57L536.41 138.23V139.4Z"
        fill="#CECECE"
      />
      <path
        d="M536.41 141.64L535.31 141.94V140.77L536.41 140.45V141.64Z"
        fill="#CECECE"
      />
      <path
        d="M536.41 146.11L535.31 146.38V145.17L536.41 144.89V146.11Z"
        fill="#CECECE"
      />
      <path
        d="M536.4 148.35L535.31 148.6V147.37L536.4 147.11V148.35Z"
        fill="#CECECE"
      />
      <path
        d="M536.4 150.59L535.31 150.82V149.57L536.4 149.32V150.59Z"
        fill="#CECECE"
      />
      <path
        d="M536.4 152.82L535.31 153.04V151.77L536.4 151.54V152.82Z"
        fill="#CECECE"
      />
      <path
        d="M536.4 155.06L535.31 155.26V153.98L536.4 153.76V155.06Z"
        fill="#CECECE"
      />
      <path
        d="M536.4 157.3L535.31 157.48V156.18L536.4 155.98V157.3Z"
        fill="#CECECE"
      />
      <path
        d="M536.39 161.77L535.31 161.92V160.58L536.39 160.42V161.77Z"
        fill="#CECECE"
      />
      <path
        d="M536.39 164.01L535.31 164.14V162.78L536.39 162.64V164.01Z"
        fill="#CECECE"
      />
      <path
        d="M536.39 166.25L535.31 166.36V164.98L536.39 164.86V166.25Z"
        fill="#CECECE"
      />
      <path
        d="M536.39 170.72L535.3 170.81V169.38L536.39 169.29V170.72Z"
        fill="#CECECE"
      />
      <path
        d="M536.39 175.2L535.3 175.25V173.79L536.39 173.73V175.2Z"
        fill="#CECECE"
      />
      <path
        d="M549.24 102.8L550.72 103.39V102.26L549.24 101.69V102.8Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 105.63L549.24 105.06V103.94L550.72 104.49V105.63Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 107.88L549.24 107.32V106.19L550.72 106.73V107.88Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 110.12L549.24 109.58V108.44L550.72 108.96V110.12Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 112.36L549.24 111.84V110.68L550.72 111.19V112.36Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 114.61L549.24 114.1V112.93L550.72 113.42V114.61Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 116.85L549.24 116.36V115.18L550.72 115.66V116.85Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 119.09L549.24 118.62V117.43L550.72 117.89V119.09Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 121.34L549.23 120.88V119.68L550.72 120.12V121.34Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 123.58L549.23 123.14V121.93L550.72 122.35V123.58Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 125.83L549.23 125.4V124.18L550.72 124.59V125.83Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 128.07L549.23 127.66V126.42L550.72 126.82V128.07Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 130.31L549.23 129.92V128.67L550.72 129.05V130.31Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 132.55L549.23 132.18V130.92L550.72 131.28V132.55Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 134.8L549.23 134.44V133.17L550.72 133.51V134.8Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 139.29L549.23 138.96V137.67L550.72 137.98V139.29Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 141.53L549.23 141.22V139.92L550.72 140.21V141.53Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 143.77L549.22 143.48V142.16L550.72 142.44V143.77Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 146.02L549.22 145.74V144.41L550.72 144.67V146.02Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 148.26L549.22 148V146.66L550.72 146.91V148.26Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 150.5L549.22 150.26V148.91L550.72 149.14V150.5Z"
        fill="#CECECE"
      />
      <path
        d="M550.72 152.75L549.22 152.52V151.16L550.72 151.37V152.75Z"
        fill="#CECECE"
      />
      <path
        d="M550.73 157.23L549.22 157.05V155.66L550.73 155.84V157.23Z"
        fill="#CECECE"
      />
      <path
        d="M550.73 159.48L549.22 159.31V157.9L550.73 158.07V159.48Z"
        fill="#CECECE"
      />
      <path
        d="M550.73 161.72L549.22 161.57V160.15L550.73 160.3V161.72Z"
        fill="#CECECE"
      />
      <path
        d="M550.73 163.96L549.22 163.83V162.4L550.73 162.53V163.96Z"
        fill="#CECECE"
      />
      <path
        d="M550.73 166.21L549.21 166.09V164.65L550.73 164.76V166.21Z"
        fill="#CECECE"
      />
      <path
        d="M550.73 168.45L549.21 168.35V166.9L550.73 167V168.45Z"
        fill="#CECECE"
      />
      <path
        d="M550.73 172.94L549.21 172.87V171.4L550.73 171.46V172.94Z"
        fill="#CECECE"
      />
      <path
        d="M550.73 175.18L549.21 175.13V173.64L550.73 173.69V175.18Z"
        fill="#CECECE"
      />
      <path
        d="M550.73 179.67L549.21 179.65V178.14L550.73 178.16V179.67Z"
        fill="#CECECE"
      />
      <path
        d="M551.45 103.67L552.69 104.31V103.29L551.45 102.59V103.67Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 106.53L551.44 105.91V104.81L552.69 105.49V106.53Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 108.75L551.44 108.14V107.03L552.69 107.69V108.75Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 110.97L551.44 110.38V109.25L552.69 109.9V110.97Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 113.18L551.44 112.61V111.48L552.69 112.1V113.18Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 115.4L551.44 114.85V113.7L552.69 114.3V115.4Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 117.62L551.43 117.08V115.92L552.69 116.51V117.62Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 119.83L551.43 119.32V118.15L552.69 118.71V119.83Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 122.05L551.43 121.55V120.37L552.69 120.91V122.05Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 124.27L551.43 123.79V122.59L552.69 123.11V124.27Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 126.48L551.43 126.02V124.82L552.69 125.32V126.48Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 133.14L551.42 132.73V131.48L552.69 131.93V133.14Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 135.35L551.42 134.97V133.71L552.69 134.13V135.35Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 137.57L551.42 137.2V135.93L552.69 136.33V137.57Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 139.79L551.42 139.44V138.15L552.69 138.53V139.79Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 142L551.42 141.67V140.38L552.69 140.74V142Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 144.22L551.41 143.91V142.6L552.69 142.94V144.22Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 146.44L551.41 146.14V144.82L552.69 145.14V146.44Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 150.87L551.41 150.61V149.27L552.69 149.55V150.87Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 155.31L551.41 155.08V153.71L552.69 153.96V155.31Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 159.74L551.4 159.56V158.16L552.69 158.36V159.74Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 164.17L551.4 164.03V162.61L552.69 162.77V164.17Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 166.39L551.4 166.26V164.83L552.69 164.97V166.39Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 168.61L551.39 168.5V167.05L552.69 167.17V168.61Z"
        fill="#CECECE"
      />
      <path
        d="M552.71 170.77L551.42 170.68V169.23L552.71 169.33V170.77Z"
        fill="#CECECE"
      />
      <path
        d="M552.69 173.04L551.39 172.97V171.5L552.69 171.58V173.04Z"
        fill="#CECECE"
      />
      <path
        d="M553.29 104.61L554.3 105.26V104.31L553.29 103.64V104.61Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 107.45L553.29 106.82V105.84L554.3 106.49V107.45Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 109.64L553.29 109.03V108.03L554.3 108.66V109.64Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 111.83L553.29 111.24V110.22L554.3 110.84V111.83Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 116.21L553.29 115.65V114.61L554.3 115.18V116.21Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 118.4L553.29 117.86V116.8L554.3 117.36V118.4Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 120.59L553.29 120.07V118.99L554.3 119.53V120.59Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 122.78L553.29 122.28V121.19L554.3 121.7V122.78Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 124.97L553.29 124.49V123.38L554.3 123.88V124.97Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 127.16L553.29 126.7V125.57L554.3 126.05V127.16Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 129.35L553.29 128.91V127.76L554.3 128.22V129.35Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 131.54L553.29 131.11V129.96L554.3 130.4V131.54Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 135.92L553.29 135.53V134.34L554.3 134.74V135.92Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 142.49L553.29 142.16V140.92L554.3 141.27V142.49Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 144.68L553.29 144.36V143.11L554.3 143.44V144.68Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 151.25L553.29 150.99V149.69L554.3 149.96V151.25Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 153.44L553.29 153.2V151.88L554.3 152.13V153.44Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 155.63L553.29 155.41V154.08L554.3 154.31V155.63Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 157.82L553.29 157.62V156.27L554.3 156.48V157.82Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 162.2L553.29 162.03V160.66L554.3 160.83V162.2Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 164.39L553.29 164.24V162.85L554.3 163V164.39Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 173.15L553.29 173.08V171.62L554.3 171.7V173.15Z"
        fill="#CECECE"
      />
      <path
        d="M554.3 179.72L553.29 179.7V178.2L554.3 178.22V179.72Z"
        fill="#CECECE"
      />
      <path
        d="M554.8 105.5L555.64 106.03V105.16L554.8 104.6V105.5Z"
        fill="#CECECE"
      />
      <path
        d="M555.64 108.2L554.8 107.68V106.77L555.64 107.31V108.2Z"
        fill="#CECECE"
      />
      <path
        d="M555.64 110.37L554.8 109.87V108.93L555.64 109.46V110.37Z"
        fill="#CECECE"
      />
      <path
        d="M555.64 112.54L554.8 112.05V111.1L555.64 111.61V112.54Z"
        fill="#CECECE"
      />
      <path
        d="M555.64 114.71L554.8 114.23V113.27L555.64 113.76V114.71Z"
        fill="#CECECE"
      />
      <path
        d="M555.64 116.87L554.8 116.42V115.43L555.64 115.91V116.87Z"
        fill="#CECECE"
      />
      <path
        d="M555.64 119.04L554.8 118.6V117.6L555.64 118.06V119.04Z"
        fill="#CECECE"
      />
      <path
        d="M555.64 121.21L554.79 120.78V119.76L555.64 120.21V121.21Z"
        fill="#CECECE"
      />
      <path
        d="M555.64 123.38L554.79 122.97V121.93L555.64 122.36V123.38Z"
        fill="#CECECE"
      />
      <path
        d="M555.64 125.54L554.79 125.15V124.09L555.64 124.5V125.54Z"
        fill="#CECECE"
      />
      <path
        d="M555.64 129.88L554.79 129.51V128.42L555.64 128.8V129.88Z"
        fill="#CECECE"
      />
      <path
        d="M555.64 132.05L554.79 131.7V130.59L555.64 130.95V132.05Z"
        fill="#CECECE"
      />
      <path
        d="M555.63 136.38L554.79 136.06V134.92L555.63 135.25V136.38Z"
        fill="#CECECE"
      />
      <path
        d="M555.63 138.55L554.78 138.25V137.08L555.63 137.4V138.55Z"
        fill="#CECECE"
      />
      <path
        d="M555.63 140.72L554.78 140.43V139.25L555.63 139.55V140.72Z"
        fill="#CECECE"
      />
      <path
        d="M555.63 142.89L554.78 142.61V141.41L555.63 141.7V142.89Z"
        fill="#CECECE"
      />
      <path
        d="M555.63 145.06L554.78 144.8V143.58L555.63 143.85V145.06Z"
        fill="#CECECE"
      />
      <path
        d="M555.63 147.22L554.78 146.98V145.75L555.63 146V147.22Z"
        fill="#CECECE"
      />
      <path
        d="M555.63 149.39L554.78 149.16V147.91L555.63 148.15V149.39Z"
        fill="#CECECE"
      />
      <path
        d="M555.63 151.56L554.78 151.35V150.08L555.63 150.3V151.56Z"
        fill="#CECECE"
      />
      <path
        d="M555.63 160.23L554.77 160.08V158.74L555.63 158.9V160.23Z"
        fill="#CECECE"
      />
      <path
        d="M555.63 162.4L554.77 162.26V160.9L555.63 161.05V162.4Z"
        fill="#CECECE"
      />
      <path
        d="M555.62 168.9L554.77 168.81V167.4L555.62 167.49V168.9Z"
        fill="#CECECE"
      />
      <path
        d="M555.62 171.07L554.77 170.99V169.56L555.62 169.64V171.07Z"
        fill="#CECECE"
      />
      <path
        d="M555.62 175.41L554.76 175.36V173.89L555.62 173.94V175.41Z"
        fill="#CECECE"
      />
      <path d="M555.62 180.39H554.76V181.91H555.62V180.39Z" fill="#CECECE" />
      <path
        d="M556.18 105.59L556.74 106.09V106.65L556.18 106.25V105.59Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 108.8L556.17 108.42V107.72L556.74 108.21V108.8Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 110.95L556.17 110.58V109.86L556.74 110.33V110.95Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 113.1L556.17 112.74V112L556.74 112.46V113.1Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 115.25L556.17 114.9V114.14L556.74 114.58V115.25Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 117.4L556.17 117.06V116.27L556.74 116.7V117.4Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 119.55L556.17 119.22V118.41L556.74 118.82V119.55Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 121.7L556.16 121.39V120.55L556.74 120.95V121.7Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 123.85L556.16 123.55V122.68L556.74 123.07V123.85Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 126L556.16 125.71V124.82L556.74 125.19V126Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 128.15L556.16 127.87V126.96L556.74 127.32V128.15Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 130.3L556.16 130.03V129.1L556.74 129.44V130.3Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 132.45L556.16 132.19V131.23L556.74 131.56V132.45Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 134.6L556.16 134.35V133.37L556.74 133.69V134.6Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 136.75L556.15 136.52V135.51L556.74 135.81V136.75Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 138.9L556.15 138.68V137.65L556.74 137.93V138.9Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 141.05L556.15 140.84V139.78L556.74 140.05V141.05Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 143.2L556.15 143V141.92L556.74 142.18V143.2Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 147.5L556.15 147.32V146.19L556.74 146.42V147.5Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 149.65L556.14 149.49V148.33L556.74 148.55V149.65Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 151.81L556.14 151.65V150.47L556.74 150.67V151.81Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 153.96L556.14 153.81V152.61L556.74 152.79V153.96Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 156.11L556.14 155.97V154.74L556.74 154.91V156.11Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 160.41L556.14 160.29V159.02L556.74 159.16V160.41Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 162.56L556.13 162.46V161.15L556.74 161.28V162.56Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 166.86L556.13 166.78V165.43L556.74 165.53V166.86Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 171.16L556.13 171.1V169.7L556.74 169.78V171.16Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 173.36L556.13 173.3V171.91L556.74 171.98V173.36Z"
        fill="#CECECE"
      />
      <path
        d="M555.62 179.8L554.76 179.75V178.29L555.62 178.33V179.8Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 177.75L556.13 177.7V176.3L556.74 176.37V177.75Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 181.88L556.13 181.82V180.42L556.74 180.49V181.88Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 186.84L556.13 186.79V185.39L556.74 185.46V186.84Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 189.05L556.13 188.99V187.6L556.74 187.67V189.05Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 193.71L556.13 193.65V192.25L556.74 192.33V193.71Z"
        fill="#CECECE"
      />
      <path
        d="M542.51 101.09V102.12L540.93 102.3V101.32C540.93 101.32 542.13 101.14 542.51 101.09Z"
        fill="#CECECE"
      />
      <path
        d="M542.51 104.41L540.94 104.58V103.59C540.94 103.59 542.14 103.41 542.51 103.36V104.41Z"
        fill="#CECECE"
      />
      <path
        d="M542.5 106.69L540.93 106.86V105.85C540.93 105.85 542.14 105.68 542.5 105.63V106.69Z"
        fill="#CECECE"
      />
      <path
        d="M542.5 108.97L540.93 109.13V108.11C540.93 108.11 542.15 107.94 542.5 107.9V108.98V108.97Z"
        fill="#CECECE"
      />
      <path
        d="M542.5 111.25L540.94 111.41V110.37C540.94 110.37 542.17 110.21 542.5 110.16V111.25Z"
        fill="#CECECE"
      />
      <path
        d="M542.5 113.53L540.94 113.68V112.62C540.94 112.62 542.17 112.46 542.5 112.42V113.52V113.53Z"
        fill="#CECECE"
      />
      <path
        d="M542.5 115.81L540.94 115.96V114.89C540.94 114.89 542.18 114.74 542.5 114.7V115.82V115.81Z"
        fill="#CECECE"
      />
      <path
        d="M542.5 118.08L540.95 118.22V117.13C540.95 117.13 542.2 116.98 542.5 116.94V118.07V118.08Z"
        fill="#CECECE"
      />
      <path
        d="M542.5 120.36L540.95 120.5V119.4C540.95 119.4 542.21 119.26 542.5 119.22V120.37V120.36Z"
        fill="#CECECE"
      />
      <path
        d="M542.49 122.64L540.94 122.77V121.65C540.94 121.65 542.21 121.51 542.49 121.48V122.64Z"
        fill="#CECECE"
      />
      <path
        d="M542.49 124.92L540.94 125.05V123.92C540.94 123.92 542.21 123.79 542.49 123.75V124.92Z"
        fill="#CECECE"
      />
      <path
        d="M542.49 127.2L540.95 127.32V126.17C540.95 126.17 542.23 126.04 542.49 126.01V127.2Z"
        fill="#CECECE"
      />
      <path
        d="M542.49 129.48L540.95 129.6V128.44C540.95 128.44 542.24 128.32 542.49 128.29V129.49V129.48Z"
        fill="#CECECE"
      />
      <path
        d="M542.49 131.76L540.95 131.87V130.69C540.95 130.69 542.25 130.57 542.49 130.54V131.76Z"
        fill="#CECECE"
      />
      <path
        d="M542.49 134.04L540.96 134.15V132.96C540.96 132.96 542.27 132.85 542.49 132.82V134.05V134.04Z"
        fill="#CECECE"
      />
      <path
        d="M542.49 136.32L540.96 136.42V135.21C540.96 135.21 542.27 135.11 542.49 135.08V136.32Z"
        fill="#CECECE"
      />
      <path
        d="M542.48 138.6L540.95 138.7V137.47C540.95 137.47 542.27 137.37 542.48 137.34V138.6Z"
        fill="#CECECE"
      />
      <path
        d="M542.48 140.88L540.96 140.97V139.73C540.96 139.73 542.29 139.64 542.48 139.61V140.88Z"
        fill="#CECECE"
      />
      <path
        d="M542.48 143.16L540.96 143.25V141.99C540.96 141.99 542.3 141.9 542.48 141.88V143.16Z"
        fill="#CECECE"
      />
      <path
        d="M542.48 145.44L540.96 145.52V144.25C540.96 144.25 542.3 144.17 542.48 144.14V145.44Z"
        fill="#CECECE"
      />
      <path
        d="M542.48 147.72L540.96 147.8V146.51C540.96 146.51 542.31 146.43 542.48 146.41V147.72Z"
        fill="#CECECE"
      />
      <path
        d="M542.48 150L540.97 150.07V148.77C540.97 148.77 542.33 148.7 542.48 148.68V150.01V150Z"
        fill="#CECECE"
      />
      <path
        d="M542.48 152.28L540.97 152.35V151.03C540.97 151.03 542.34 150.96 542.48 150.94V152.28Z"
        fill="#CECECE"
      />
      <path
        d="M542.47 156.84L540.97 156.9V155.55C540.97 155.55 542.35 155.49 542.47 155.48V156.85V156.84Z"
        fill="#CECECE"
      />
      <path
        d="M542.47 159.11L540.97 159.16V157.79C540.97 157.79 542.36 157.74 542.47 157.72V159.1V159.11Z"
        fill="#CECECE"
      />
      <path
        d="M542.47 161.39L540.97 161.44V160.06C540.97 160.06 542.37 160.01 542.47 160V161.4V161.39Z"
        fill="#CECECE"
      />
      <path
        d="M542.47 163.67L540.98 163.71V162.31C540.98 162.31 542.39 162.27 542.47 162.26V163.67Z"
        fill="#CECECE"
      />
      <path
        d="M542.47 165.95L540.98 165.99V164.58C540.98 164.58 542.39 164.54 542.47 164.53V165.95Z"
        fill="#CECECE"
      />
      <path
        d="M542.46 170.51L540.98 170.54V169.1C540.98 169.1 542.41 169.07 542.46 169.07V170.52V170.51Z"
        fill="#CECECE"
      />
      <path
        d="M542.46 175.07L540.98 175.09V173.62C540.98 173.62 542.43 173.6 542.46 173.6V175.08V175.07Z"
        fill="#CECECE"
      />
      <path
        d="M542.46 179.63H540.99V178.13C540.99 178.13 542.45 178.13 542.46 178.13V179.64V179.63Z"
        fill="#CECECE"
      />
      <path
        d="M543.45 101.07C543.45 101.07 544.84 100.96 545.49 101.07V102.16H543.45V101.07Z"
        fill="#CECECE"
      />
      <path
        d="M545.49 104.44H543.45V103.33C543.45 103.33 544.85 103.22 545.49 103.33V104.44Z"
        fill="#CECECE"
      />
      <path
        d="M545.49 106.72H543.46V105.6C543.46 105.6 544.88 105.49 545.49 105.6V106.72Z"
        fill="#CECECE"
      />
      <path
        d="M545.49 109H543.46V107.87C543.46 107.87 544.89 107.77 545.49 107.87V109Z"
        fill="#CECECE"
      />
      <path
        d="M545.48 111.28H543.45V110.14C543.45 110.14 544.9 110.04 545.48 110.14V111.28Z"
        fill="#CECECE"
      />
      <path
        d="M545.48 113.56H543.46V112.4C543.46 112.4 544.92 112.3 545.48 112.4V113.56Z"
        fill="#CECECE"
      />
      <path
        d="M545.48 118.11H543.46V116.93C543.46 116.93 544.95 116.84 545.48 116.93V118.11Z"
        fill="#CECECE"
      />
      <path
        d="M545.48 120.39H543.46V119.2C543.46 119.2 544.97 119.11 545.48 119.2V120.39Z"
        fill="#CECECE"
      />
      <path
        d="M545.47 122.67H543.46V121.47C543.46 121.47 544.99 121.39 545.47 121.47V122.67Z"
        fill="#CECECE"
      />
      <path
        d="M545.47 124.95H543.46V123.73C543.46 123.73 545 123.65 545.47 123.73V124.95Z"
        fill="#CECECE"
      />
      <path
        d="M545.47 127.23H543.46V126C543.46 126 545.02 125.92 545.47 126V127.23Z"
        fill="#CECECE"
      />
      <path
        d="M545.47 129.51H543.47V128.27C543.47 128.27 545.04 128.2 545.47 128.27V129.51Z"
        fill="#CECECE"
      />
      <path
        d="M545.46 134.06H543.46V132.8C543.46 132.8 545.06 132.73 545.46 132.8V134.06Z"
        fill="#CECECE"
      />
      <path
        d="M545.46 136.34H543.47V135.06C543.47 135.06 545.09 135 545.46 135.06V136.34Z"
        fill="#CECECE"
      />
      <path
        d="M545.46 138.62H543.47V137.33C543.47 137.33 545.1 137.27 545.46 137.33V138.62Z"
        fill="#CECECE"
      />
      <path
        d="M545.46 140.9H543.47V139.6C543.47 139.6 545.12 139.54 545.46 139.6V140.9Z"
        fill="#CECECE"
      />
      <path
        d="M545.46 143.18H543.48V141.87C543.48 141.87 545.14 141.82 545.46 141.87V143.18Z"
        fill="#CECECE"
      />
      <path
        d="M545.45 145.46H543.47V144.13C543.47 144.13 545.15 144.08 545.45 144.13V145.46Z"
        fill="#CECECE"
      />
      <path
        d="M545.45 147.73H543.47V146.39C543.47 146.39 545.17 146.34 545.45 146.39V147.73Z"
        fill="#CECECE"
      />
      <path
        d="M545.45 150.01H543.48V148.66C543.48 148.66 545.19 148.61 545.45 148.66V150.01Z"
        fill="#CECECE"
      />
      <path
        d="M545.45 152.29H543.48V150.93C543.48 150.93 545.21 150.89 545.45 150.93V152.29Z"
        fill="#CECECE"
      />
      <path
        d="M545.44 154.57H543.47V153.2C543.47 153.2 545.21 153.16 545.44 153.2V154.57Z"
        fill="#CECECE"
      />
      <path
        d="M545.44 156.85H543.48V155.46C543.48 155.46 545.24 155.42 545.44 155.46V156.85Z"
        fill="#CECECE"
      />
      <path
        d="M545.44 159.13H543.48V157.73C543.48 157.73 545.25 157.7 545.44 157.73V159.13Z"
        fill="#CECECE"
      />
      <path
        d="M545.44 163.68H543.49V162.26C543.49 162.26 545.29 162.23 545.44 162.26V163.68Z"
        fill="#CECECE"
      />
      <path
        d="M545.43 165.96H543.48V164.53C543.48 164.53 545.3 164.51 545.43 164.53V165.96Z"
        fill="#CECECE"
      />
      <path
        d="M545.43 170.52H543.49V169.06C543.49 169.06 545.34 169.04 545.43 169.06V170.52Z"
        fill="#CECECE"
      />
      <path
        d="M545.43 175.07H543.49V173.59C543.49 173.59 545.37 173.59 545.43 173.59V175.07Z"
        fill="#CECECE"
      />
      <path
        d="M545.42 179.63H543.49V178.12C543.49 178.12 545.4 178.12 545.42 178.12V179.63Z"
        fill="#CECECE"
      />
      <path d="M545.42 180.39H543.49V181.91H545.42V180.39Z" fill="#CECECE" />
      <path
        d="M546.43 101.13C546.43 101.13 547.73 101.28 548.24 101.49V102.54C548.24 102.54 546.69 102.2 546.43 102.17V101.14V101.13Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 104.81C548.24 104.81 546.68 104.48 546.43 104.45V103.4C546.43 103.4 547.74 103.54 548.24 103.75V104.81Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 107.08C548.24 107.08 546.67 106.76 546.43 106.73V105.67C546.43 105.67 547.76 105.81 548.24 106.01V107.08Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 109.34C548.24 109.34 546.66 109.03 546.43 109V107.92C546.43 107.92 547.77 108.05 548.24 108.25V109.34Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 111.61C548.24 111.61 546.66 111.31 546.43 111.28V110.19C546.43 110.19 547.79 110.32 548.24 110.51V111.61Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 113.88C548.24 113.88 546.65 113.59 546.43 113.56V112.46C546.43 112.46 547.8 112.59 548.24 112.77V113.88Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 116.15C548.24 116.15 546.64 115.87 546.43 115.84V114.72C546.43 114.72 547.81 114.84 548.24 115.02V116.15Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 118.41C548.24 118.41 546.63 118.14 546.43 118.11V116.98C546.43 116.98 547.83 117.1 548.24 117.27V118.41Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 120.68C548.24 120.68 546.63 120.42 546.43 120.39V119.24C546.43 119.24 547.84 119.35 548.24 119.52V120.67V120.68Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 122.95C548.24 122.95 546.62 122.7 546.43 122.67V121.51C546.43 121.51 547.86 121.62 548.24 121.78V122.95Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 125.22C548.24 125.22 546.61 124.98 546.43 124.95V123.78C546.43 123.78 547.87 123.88 548.24 124.04V125.22Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 129.75C548.24 129.75 546.6 129.52 546.43 129.5V128.3C546.43 128.3 547.9 128.4 548.24 128.54V129.75Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 132.02C548.24 132.02 546.59 131.8 546.43 131.78V130.57C546.43 130.57 547.92 130.66 548.24 130.8V132.02Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 134.29C548.24 134.29 546.58 134.08 546.43 134.06V132.83C546.43 132.83 547.93 132.92 548.24 133.05V134.29Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 136.56C548.24 136.56 546.58 136.36 546.43 136.35V135.11C546.43 135.11 547.95 135.19 548.24 135.32V136.57V136.56Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 138.82C548.24 138.82 546.57 138.63 546.43 138.62V137.36C546.43 137.36 547.96 137.44 548.24 137.56V138.82Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 141.09C548.24 141.09 546.56 140.91 546.43 140.9V139.63C546.43 139.63 547.98 139.7 548.24 139.82V141.1V141.09Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 145.63C548.24 145.63 546.55 145.47 546.43 145.46V144.16C546.43 144.16 548.01 144.23 548.24 144.33V145.63Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 147.89C548.24 147.89 546.54 147.74 546.43 147.73V146.42C546.43 146.42 548.02 146.48 548.24 146.58V147.9V147.89Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 152.43C548.24 152.43 546.52 152.3 546.43 152.29V150.95C546.43 150.95 548.05 151 548.24 151.08V152.42V152.43Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 154.7C548.24 154.7 546.51 154.58 546.43 154.57V153.22C546.43 153.22 548.07 153.27 548.24 153.34V154.7Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 156.97C548.24 156.97 546.51 156.86 546.43 156.85V155.48C546.43 155.48 548.08 155.53 548.24 155.59V156.96V156.97Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 159.23C548.24 159.23 546.5 159.13 546.43 159.12V157.74C546.43 157.74 548.1 157.78 548.24 157.84V159.22V159.23Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 161.5C548.24 161.5 546.49 161.41 546.43 161.4V160C546.43 160 548.11 160.04 548.24 160.09V161.49V161.5Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 163.77C548.24 163.77 546.49 163.69 546.43 163.68V162.27C546.43 162.27 548.13 162.3 548.24 162.35V163.76V163.77Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 168.3C548.24 168.3 546.47 168.24 546.43 168.24V166.8C546.43 166.8 548.15 166.83 548.24 166.86V168.3Z"
        fill="#CECECE"
      />
      <path
        d="M548.24 170.57C548.24 170.57 546.46 170.52 546.43 170.52V169.07C546.43 169.07 548.17 169.09 548.24 169.12V170.57Z"
        fill="#CECECE"
      />
      <path
        d="M548.25 172.84C548.25 172.84 546.47 172.8 546.44 172.8V171.34C546.44 171.34 548.19 171.36 548.25 171.38V172.85V172.84Z"
        fill="#CECECE"
      />
      <path
        d="M540.25 102.4V101.49C540.25 101.49 539.35 101.64 538.92 101.82V102.69L540.25 102.39V102.4Z"
        fill="#CECECE"
      />
      <path
        d="M540.25 104.67L538.92 104.96V104.07C539.34 103.89 540.25 103.75 540.25 103.75V104.67Z"
        fill="#CECECE"
      />
      <path
        d="M540.24 106.94L538.91 107.22V106.31C539.32 106.14 540.24 106 540.24 106V106.94Z"
        fill="#CECECE"
      />
      <path
        d="M540.24 109.21L538.91 109.48V108.55C539.3 108.38 540.24 108.24 540.24 108.24V109.2V109.21Z"
        fill="#CECECE"
      />
      <path
        d="M540.24 111.49L538.91 111.76V110.81C539.29 110.65 540.24 110.51 540.24 110.51V111.49Z"
        fill="#CECECE"
      />
      <path
        d="M540.24 113.76L538.91 114.02V113.06C539.28 112.9 540.24 112.77 540.24 112.77V113.76Z"
        fill="#CECECE"
      />
      <path
        d="M540.24 116.03L538.91 116.28V115.3C539.27 115.15 540.24 115.02 540.24 115.02V116.03Z"
        fill="#CECECE"
      />
      <path
        d="M540.24 118.3L538.91 118.54V117.54C539.25 117.39 540.24 117.27 540.24 117.27V118.3Z"
        fill="#CECECE"
      />
      <path
        d="M540.24 120.57L538.91 120.8V119.78C539.24 119.64 540.24 119.52 540.24 119.52V120.57Z"
        fill="#CECECE"
      />
      <path
        d="M540.24 122.84L538.91 123.06V122.02C539.23 121.88 540.24 121.77 540.24 121.77V122.83V122.84Z"
        fill="#CECECE"
      />
      <path
        d="M540.24 127.39L538.9 127.6V126.52C539.19 126.39 540.24 126.29 540.24 126.29V127.39Z"
        fill="#CECECE"
      />
      <path
        d="M540.24 129.66L538.9 129.86V128.77C539.18 128.65 540.24 128.55 540.24 128.55V129.67V129.66Z"
        fill="#CECECE"
      />
      <path
        d="M540.24 131.93L538.9 132.12V131.01C539.17 130.89 540.24 130.8 540.24 130.8V131.93Z"
        fill="#CECECE"
      />
      <path
        d="M540.23 134.2L538.89 134.38V133.25C539.15 133.14 540.23 133.05 540.23 133.05V134.2Z"
        fill="#CECECE"
      />
      <path
        d="M540.23 138.75L538.89 138.91V137.74C539.12 137.64 540.23 137.56 540.23 137.56V138.75Z"
        fill="#CECECE"
      />
      <path
        d="M540.23 141.02L538.89 141.17V139.98C539.11 139.89 540.23 139.81 540.23 139.81V141.01V141.02Z"
        fill="#CECECE"
      />
      <path
        d="M540.23 143.29L538.89 143.44V142.23C539.1 142.14 540.23 142.07 540.23 142.07V143.29Z"
        fill="#CECECE"
      />
      <path
        d="M540.23 145.56L538.89 145.7V144.48C539.09 144.4 540.23 144.33 540.23 144.33V145.57V145.56Z"
        fill="#CECECE"
      />
      <path
        d="M540.23 147.83L538.89 147.96V146.72C539.07 146.64 540.23 146.58 540.23 146.58V147.84V147.83Z"
        fill="#CECECE"
      />
      <path
        d="M540.23 152.38L538.89 152.49V151.21C539.05 151.14 540.23 151.09 540.23 151.09V152.38Z"
        fill="#CECECE"
      />
      <path
        d="M540.23 154.65L538.89 154.75V153.45C539.04 153.39 540.23 153.34 540.23 153.34V154.65Z"
        fill="#CECECE"
      />
      <path
        d="M540.23 156.92L538.89 157.01V155.69C539.02 155.63 540.23 155.58 540.23 155.58V156.91V156.92Z"
        fill="#CECECE"
      />
      <path
        d="M540.22 159.19L538.88 159.28V157.94C539 157.89 540.22 157.84 540.22 157.84V159.18V159.19Z"
        fill="#CECECE"
      />
      <path
        d="M540.22 166.01L538.87 166.07V164.68C538.96 164.64 540.22 164.61 540.22 164.61V166.01Z"
        fill="#CECECE"
      />
      <path
        d="M540.22 168.28L538.87 168.33V166.92C538.94 166.89 540.22 166.86 540.22 166.86V168.27V168.28Z"
        fill="#CECECE"
      />
      <path
        d="M540.22 170.55L538.87 170.59V169.16C538.93 169.13 540.22 169.11 540.22 169.11V170.54V170.55Z"
        fill="#CECECE"
      />
      <path
        d="M538.37 102.01V102.87L537.04 103.29V102.53L538.37 102.01Z"
        fill="#CECECE"
      />
      <path
        d="M538.37 105.13L537.04 105.54V104.76L538.37 104.25V105.13Z"
        fill="#CECECE"
      />
      <path
        d="M538.37 107.38L537.05 107.79V106.98L538.37 106.49V107.38Z"
        fill="#CECECE"
      />
      <path
        d="M538.37 109.64L537.05 110.03V109.21L538.37 108.73V109.64Z"
        fill="#CECECE"
      />
      <path
        d="M538.37 111.9L537.05 112.28V111.43L538.37 110.97V111.9Z"
        fill="#CECECE"
      />
      <path
        d="M538.36 116.42L537.05 116.77V115.88L538.36 115.45V116.42Z"
        fill="#CECECE"
      />
      <path
        d="M538.36 118.68L537.05 119.02V118.1L538.36 117.69V118.68Z"
        fill="#CECECE"
      />
      <path
        d="M538.36 120.93L537.05 121.26V120.33L538.36 119.93V120.93Z"
        fill="#CECECE"
      />
      <path
        d="M538.36 123.19L537.05 123.51V122.55L538.36 122.17V123.19Z"
        fill="#CECECE"
      />
      <path
        d="M538.36 125.45L537.05 125.76V124.78L538.36 124.41V125.45Z"
        fill="#CECECE"
      />
      <path
        d="M538.36 127.71L537.05 128V127L538.36 126.65V127.71Z"
        fill="#CECECE"
      />
      <path
        d="M538.36 129.97L537.05 130.25V129.23L538.36 128.89V129.97Z"
        fill="#CECECE"
      />
      <path
        d="M538.35 132.23L537.05 132.49V131.45L538.35 131.12V132.23Z"
        fill="#CECECE"
      />
      <path
        d="M538.35 134.48L537.05 134.74V133.68L538.35 133.36V134.48Z"
        fill="#CECECE"
      />
      <path
        d="M538.35 136.74L537.05 136.99V135.9L538.35 135.6V136.74Z"
        fill="#CECECE"
      />
      <path
        d="M538.35 139L537.06 139.23V138.12L538.35 137.84V139Z"
        fill="#CECECE"
      />
      <path
        d="M538.35 141.26L537.06 141.48V140.35L538.35 140.08V141.26Z"
        fill="#CECECE"
      />
      <path
        d="M538.35 143.52L537.06 143.72V142.57L538.35 142.32V143.52Z"
        fill="#CECECE"
      />
      <path
        d="M538.34 145.78L537.06 145.97V144.8L538.34 144.56V145.78Z"
        fill="#CECECE"
      />
      <path
        d="M538.34 148.03L537.06 148.22V147.02L538.34 146.8V148.03Z"
        fill="#CECECE"
      />
      <path
        d="M538.34 150.29L537.06 150.46V149.25L538.34 149.04V150.29Z"
        fill="#CECECE"
      />
      <path
        d="M538.34 152.55L537.06 152.71V151.47L538.34 151.28V152.55Z"
        fill="#CECECE"
      />
      <path
        d="M538.34 154.81L537.06 154.96V153.7L538.34 153.52V154.81Z"
        fill="#CECECE"
      />
      <path
        d="M538.34 157.07L537.06 157.2V155.92L538.34 155.76V157.07Z"
        fill="#CECECE"
      />
      <path
        d="M538.34 159.33L537.06 159.45V158.15L538.34 158V159.33Z"
        fill="#CECECE"
      />
      <path
        d="M538.33 161.58L537.06 161.69V160.37L538.33 160.24V161.58Z"
        fill="#CECECE"
      />
      <path
        d="M538.33 166.1L537.06 166.19V164.82L538.33 164.71V166.1Z"
        fill="#CECECE"
      />
      <path
        d="M538.33 168.36L537.07 168.43V167.04L538.33 166.95V168.36Z"
        fill="#CECECE"
      />
      <path
        d="M538.33 172.88L537.07 172.92V171.49L538.33 171.43V172.88Z"
        fill="#CECECE"
      />
      <path
        d="M538.33 175.13L537.07 175.17V173.72L538.33 173.67V175.13Z"
        fill="#CECECE"
      />
      <path
        d="M538.32 177.39L537.07 177.42V175.94L538.32 175.91V177.39Z"
        fill="#CECECE"
      />
      <path
        d="M538.32 179.65L537.07 179.66V178.17L538.32 178.15V179.65Z"
        fill="#CECECE"
      />
      <path d="M538.32 180.39H537.07V181.91H538.32V180.39Z" fill="#CECECE" />
      <path
        d="M516.45 112.23L517.5 111.65V112.47L516.45 113.02V112.23Z"
        fill="#CECECE"
      />
      <path
        d="M517.5 114.5L516.45 115.03V114.22L517.5 113.66V114.5Z"
        fill="#CECECE"
      />
      <path
        d="M517.5 116.52L516.45 117.04V116.21L517.5 115.66V116.52Z"
        fill="#CECECE"
      />
      <path
        d="M517.49 118.54L516.45 119.04V118.2L517.49 117.67V118.54Z"
        fill="#CECECE"
      />
      <path
        d="M517.49 120.57L516.45 121.05V120.19L517.49 119.67V120.57Z"
        fill="#CECECE"
      />
      <path
        d="M517.49 122.59L516.45 123.06V122.18L517.49 121.68V122.59Z"
        fill="#CECECE"
      />
      <path
        d="M517.49 124.61L516.45 125.07V124.17L517.49 123.68V124.61Z"
        fill="#CECECE"
      />
      <path
        d="M517.49 126.64L516.45 127.07V126.16L517.49 125.69V126.64Z"
        fill="#CECECE"
      />
      <path
        d="M517.49 128.66L516.45 129.08V128.15L517.49 127.7V128.66Z"
        fill="#CECECE"
      />
      <path
        d="M517.49 130.68L516.45 131.09V130.14L517.49 129.7V130.68Z"
        fill="#CECECE"
      />
      <path
        d="M517.49 132.71L516.45 133.1V132.12L517.49 131.71V132.71Z"
        fill="#CECECE"
      />
      <path
        d="M517.49 134.73L516.45 135.1V134.11L517.49 133.71V134.73Z"
        fill="#CECECE"
      />
      <path
        d="M517.49 136.75L516.45 137.11V136.1L517.49 135.72V136.75Z"
        fill="#CECECE"
      />
      <path
        d="M517.49 138.78L516.45 139.12V138.09L517.49 137.72V138.78Z"
        fill="#CECECE"
      />
      <path
        d="M517.49 140.8L516.45 141.13V140.08L517.49 139.73V140.8Z"
        fill="#CECECE"
      />
      <path
        d="M517.48 144.85L516.45 145.14V144.06L517.48 143.74V144.85Z"
        fill="#CECECE"
      />
      <path
        d="M517.48 146.87L516.45 147.15V146.05L517.48 145.75V146.87Z"
        fill="#CECECE"
      />
      <path
        d="M517.48 150.92L516.45 151.17V150.03L517.48 149.76V150.92Z"
        fill="#CECECE"
      />
      <path
        d="M517.48 152.94L516.45 153.17V152.01L517.48 151.76V152.94Z"
        fill="#CECECE"
      />
      <path
        d="M517.48 159.01L516.45 159.2V157.98L517.48 157.78V159.01Z"
        fill="#CECECE"
      />
      <path
        d="M517.48 163.05L516.45 163.21V161.96L517.48 161.79V163.05Z"
        fill="#CECECE"
      />
      <path
        d="M517.48 165.08L516.45 165.22V163.95L517.48 163.8V165.08Z"
        fill="#CECECE"
      />
      <path
        d="M517.48 169.13L516.45 169.23V167.93L517.48 167.81V169.13Z"
        fill="#CECECE"
      />
      <path
        d="M517.48 171.15L516.45 171.24V169.92L517.48 169.82V171.15Z"
        fill="#CECECE"
      />
      <path
        d="M517.47 175.19L516.45 175.26V173.9L517.47 173.83V175.19Z"
        fill="#CECECE"
      />
      <path
        d="M517.47 177.22L516.45 177.26V175.88L517.47 175.83V177.22Z"
        fill="#CECECE"
      />
      <path
        d="M517.47 181.27L516.45 181.28V179.86L517.47 179.84V181.27Z"
        fill="#CECECE"
      />
      <path
        d="M518.02 111.41L519.07 110.83V111.65L518.02 112.2V111.41Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 113.7L518.03 114.23V113.43L519.07 112.86V113.7Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 115.75L518.03 116.26V115.44L519.07 114.89V115.75Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 117.79L518.03 118.29V117.45L519.07 116.92V117.79Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 119.84L518.03 120.32V119.46L519.07 118.95V119.84Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 121.89L518.03 122.36V121.48L519.07 120.98V121.89Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 123.93L518.03 124.39V123.49L519.07 123.01V123.93Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 125.98L518.03 126.42V125.5L519.07 125.03V125.98Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 128.03L518.03 128.45V127.51L519.07 127.06V128.03Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 130.07L518.03 130.48V129.53L519.07 129.09V130.07Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 132.12L518.03 132.51V131.54L519.07 131.12V132.12Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 134.17L518.03 134.54V133.55L519.07 133.15V134.17Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 136.21L518.03 136.57V135.56L519.07 135.18V136.21Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 138.26L518.03 138.6V137.58L519.07 137.21V138.26Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 140.31L518.03 140.64V139.59L519.07 139.24V140.31Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 146.45L518.03 146.73V145.63L519.07 145.33V146.45Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 148.49L518.04 148.76V147.64L519.07 147.36V148.49Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 152.59L518.04 152.82V151.66L519.07 151.41V152.59Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 154.63L518.04 154.85V153.68L519.07 153.44V154.63Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 156.68L518.04 156.88V155.69L519.07 155.47V156.68Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 158.73L518.04 158.92V157.7L519.07 157.5V158.73Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 162.82L518.04 162.98V161.73L519.07 161.56V162.82Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 168.96L518.04 169.07V167.76L519.07 167.65V168.96Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 175.1L518.04 175.16V173.8L519.07 173.73V175.1Z"
        fill="#CECECE"
      />
      <path
        d="M519.07 181.24L518.05 181.26V179.84L519.07 179.82V181.24Z"
        fill="#CECECE"
      />
      <path
        d="M519.6 110.61L520.64 110.02V110.85L519.6 111.39V110.61Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 112.92L519.6 113.45V112.64L520.64 112.08V112.92Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 114.99L519.6 115.5V114.68L520.64 114.13V114.99Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 117.06L519.6 117.56V116.71L520.64 116.18V117.06Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 119.13L519.6 119.61V118.75L520.64 118.23V119.13Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 121.2L519.6 121.66V120.79L520.64 120.29V121.2Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 123.27L519.6 123.72V122.82L520.64 122.34V123.27Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 125.34L519.6 125.77V124.86L520.64 124.39V125.34Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 127.41L519.6 127.83V126.89L520.64 126.44V127.41Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 129.48L519.6 129.88V128.93L520.64 128.49V129.48Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 131.54L519.6 131.94V130.96L520.64 130.55V131.54Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 135.68L519.6 136.04V135.03L520.64 134.65V135.68Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 139.82L519.6 140.15V139.11L520.64 138.76V139.82Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 141.89L519.61 142.21V141.14L520.64 140.81V141.89Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 146.03L519.61 146.31V145.21L520.64 144.91V146.03Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 148.1L519.61 148.37V147.25L520.64 146.96V148.1Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 152.24L519.61 152.48V151.32L520.64 151.07V152.24Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 154.31L519.61 154.53V153.35L520.64 153.12V154.31Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 156.38L519.61 156.58V155.39L520.64 155.17V156.38Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 158.45L519.61 158.64V157.42L520.64 157.23V158.45Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 160.52L519.61 160.69V159.46L520.64 159.28V160.52Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 162.59L519.61 162.75V161.5L520.64 161.33V162.59Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 166.73L519.61 166.86V165.57L520.64 165.43V166.73Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 170.87L519.61 170.96V169.64L520.64 169.54V170.87Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 172.94L519.61 173.02V171.67L520.64 171.59V172.94Z"
        fill="#CECECE"
      />
      <path
        d="M520.64 177.08L519.61 177.13V175.75L520.64 175.69V177.08Z"
        fill="#CECECE"
      />
      <path
        d="M521.21 109.82L522.25 109.24V110.06L521.21 110.61V109.82Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 112.15L521.21 112.68V111.88L522.25 111.31V112.15Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 116.34L521.21 116.84V116L522.25 115.46V116.34Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 118.43L521.21 118.91V118.05L522.25 117.54V118.43Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 120.52L521.21 120.99V120.11L522.25 119.61V120.52Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 122.61L521.21 123.07V122.17L522.25 121.69V122.61Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 126.8L521.21 127.22V126.29L522.25 125.84V126.8Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 128.89L521.21 129.3V128.34L522.25 127.91V128.89Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 130.98L521.21 131.37V130.4L522.25 129.98V130.98Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 133.08L521.22 133.45V132.46L522.25 132.06V133.08Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 135.17L521.22 135.53V134.52L522.25 134.13V135.17Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 137.26L521.22 137.6V136.58L522.25 136.21V137.26Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 139.35L521.22 139.68V138.63L522.25 138.28V139.35Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 141.44L521.22 141.76V140.69L522.25 140.36V141.44Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 145.63L521.22 145.91V144.81L522.25 144.51V145.63Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 147.72L521.22 147.99V146.87L522.25 146.58V147.72Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 149.81L521.22 150.06V148.92L522.25 148.66V149.81Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 151.91L521.22 152.14V150.98L522.25 150.73V151.91Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 154L521.22 154.22V153.04L522.25 152.81V154Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 156.09L521.22 156.29V155.1L522.25 154.88V156.09Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 160.27L521.23 160.45V159.21L522.25 159.03V160.27Z"
        fill="#CECECE"
      />
      <path
        d="M522.25 162.37L521.23 162.52V161.27L522.25 161.1V162.37Z"
        fill="#CECECE"
      />
      <path
        d="M522.26 166.55L521.23 166.68V165.39L522.26 165.25V166.55Z"
        fill="#CECECE"
      />
      <path
        d="M522.26 170.74L521.23 170.83V169.5L522.26 169.4V170.74Z"
        fill="#CECECE"
      />
      <path
        d="M522.26 172.83L521.23 172.9V171.56L522.26 171.48V172.83Z"
        fill="#CECECE"
      />
      <path
        d="M522.26 174.92L521.23 174.98V173.62L522.26 173.55V174.92Z"
        fill="#CECECE"
      />
      <path
        d="M522.24 178.2L521.22 178.25V176.87L522.24 176.82V178.2Z"
        fill="#CECECE"
      />
      <path
        d="M522.26 179.1L521.23 179.13V177.74L522.26 177.7V179.1Z"
        fill="#CECECE"
      />
      <path d="M522.26 181.85H521.24V183.29H522.26V181.85Z" fill="#CECECE" />
      <path
        d="M522.88 109.03L523.93 108.44V109.27L522.88 109.82V109.03Z"
        fill="#CECECE"
      />
      <path
        d="M523.93 111.38L522.88 111.92V111.11L523.93 110.54V111.38Z"
        fill="#CECECE"
      />
      <path
        d="M523.93 113.5L522.88 114.02V113.19L523.93 112.63V113.5Z"
        fill="#CECECE"
      />
      <path
        d="M523.93 115.61L522.88 116.11V115.27L523.93 114.73V115.61Z"
        fill="#CECECE"
      />
      <path
        d="M523.92 117.73L522.87 118.21V117.35L523.92 116.83V117.73Z"
        fill="#CECECE"
      />
      <path
        d="M523.92 119.84L522.87 120.31V119.43L523.92 118.93V119.84Z"
        fill="#CECECE"
      />
      <path
        d="M523.92 121.96L522.87 122.41V121.51L523.92 121.02V121.96Z"
        fill="#CECECE"
      />
      <path
        d="M523.92 124.07L522.87 124.51V123.59L523.92 123.12V124.07Z"
        fill="#CECECE"
      />
      <path
        d="M523.92 126.19L522.87 126.61V125.67L523.92 125.22V126.19Z"
        fill="#CECECE"
      />
      <path
        d="M523.92 128.3L522.87 128.71V127.75L523.92 127.32V128.3Z"
        fill="#CECECE"
      />
      <path
        d="M523.91 130.42L522.87 130.81V129.83L523.91 129.41V130.42Z"
        fill="#CECECE"
      />
      <path
        d="M523.91 132.53L522.87 132.91V131.91L523.91 131.51V132.53Z"
        fill="#CECECE"
      />
      <path
        d="M523.91 134.65L522.87 135.01V133.99L523.91 133.61V134.65Z"
        fill="#CECECE"
      />
      <path
        d="M523.91 136.76L522.87 137.11V136.08L523.91 135.71V136.76Z"
        fill="#CECECE"
      />
      <path
        d="M523.91 138.88L522.87 139.21V138.16L523.91 137.8V138.88Z"
        fill="#CECECE"
      />
      <path
        d="M523.91 140.99L522.87 141.3V140.24L523.91 139.9V140.99Z"
        fill="#CECECE"
      />
      <path
        d="M523.91 143.1L522.87 143.4V142.32L523.91 142V143.1Z"
        fill="#CECECE"
      />
      <path
        d="M523.9 145.22L522.87 145.5V144.4L523.9 144.1V145.22Z"
        fill="#CECECE"
      />
      <path
        d="M523.9 149.45L522.87 149.7V148.56L523.9 148.29V149.45Z"
        fill="#CECECE"
      />
      <path
        d="M523.9 151.56L522.87 151.8V150.64L523.9 150.39V151.56Z"
        fill="#CECECE"
      />
      <path
        d="M523.9 153.68L522.87 153.9V152.72L523.9 152.49V153.68Z"
        fill="#CECECE"
      />
      <path
        d="M523.9 155.79L522.86 156V154.8L523.9 154.58V155.79Z"
        fill="#CECECE"
      />
      <path
        d="M523.89 160.02L522.86 160.2V158.96L523.89 158.78V160.02Z"
        fill="#CECECE"
      />
      <path
        d="M523.89 164.25L522.86 164.4V163.13L523.89 162.97V164.25Z"
        fill="#CECECE"
      />
      <path
        d="M523.89 166.37L522.86 166.49V165.21L523.89 165.07V166.37Z"
        fill="#CECECE"
      />
      <path
        d="M523.89 168.48L522.86 168.59V167.29L523.89 167.17V168.48Z"
        fill="#CECECE"
      />
      <path
        d="M523.88 172.71L522.86 172.79V171.45L523.88 171.36V172.71Z"
        fill="#CECECE"
      />
      <path
        d="M523.88 176.94L522.86 176.99V175.61L523.88 175.56V176.94Z"
        fill="#CECECE"
      />
      <path
        d="M525.76 107.77V108.57L524.5 108.98V108.26L525.76 107.77Z"
        fill="#CECECE"
      />
      <path
        d="M525.76 110.71L524.51 111.1V110.36L525.76 109.88V110.71Z"
        fill="#CECECE"
      />
      <path
        d="M525.76 112.84L524.51 113.22V112.46L525.76 112V112.84Z"
        fill="#CECECE"
      />
      <path
        d="M525.76 114.98L524.51 115.35V114.56L525.76 114.12V114.98Z"
        fill="#CECECE"
      />
      <path
        d="M525.75 117.11L524.51 117.47V116.67L525.75 116.23V117.11Z"
        fill="#CECECE"
      />
      <path
        d="M525.75 121.38L524.51 121.71V120.87L525.75 120.47V121.38Z"
        fill="#CECECE"
      />
      <path
        d="M525.75 123.51L524.51 123.84V122.98L525.75 122.58V123.51Z"
        fill="#CECECE"
      />
      <path
        d="M525.75 125.65L524.51 125.96V125.08L525.75 124.7V125.65Z"
        fill="#CECECE"
      />
      <path
        d="M525.75 127.78L524.51 128.08V127.18L525.75 126.82V127.78Z"
        fill="#CECECE"
      />
      <path
        d="M525.75 129.92L524.51 130.21V129.28L525.75 128.93V129.92Z"
        fill="#CECECE"
      />
      <path
        d="M525.74 132.05L524.51 132.33V131.39L525.74 131.05V132.05Z"
        fill="#CECECE"
      />
      <path
        d="M525.74 134.19L524.51 134.45V133.49L525.74 133.17V134.19Z"
        fill="#CECECE"
      />
      <path
        d="M525.74 136.32L524.51 136.58V135.59L525.74 135.28V136.32Z"
        fill="#CECECE"
      />
      <path
        d="M525.74 138.46L524.51 138.7V137.69L525.74 137.4V138.46Z"
        fill="#CECECE"
      />
      <path
        d="M525.74 140.59L524.51 140.82V139.8L525.74 139.52V140.59Z"
        fill="#CECECE"
      />
      <path
        d="M525.74 142.73L524.52 142.95V141.9L525.74 141.63V142.73Z"
        fill="#CECECE"
      />
      <path
        d="M525.74 144.86L524.52 145.07V144L525.74 143.75V144.86Z"
        fill="#CECECE"
      />
      <path
        d="M525.74 147L524.52 147.19V146.1L525.74 145.87V147Z"
        fill="#CECECE"
      />
      <path
        d="M525.73 149.13L524.52 149.32V148.21L525.73 147.98V149.13Z"
        fill="#CECECE"
      />
      <path
        d="M525.73 151.27L524.52 151.44V150.31L525.73 150.1V151.27Z"
        fill="#CECECE"
      />
      <path
        d="M525.73 153.4L524.52 153.56V152.41L525.73 152.22V153.4Z"
        fill="#CECECE"
      />
      <path
        d="M525.73 155.54L524.52 155.69V154.52L525.73 154.33V155.54Z"
        fill="#CECECE"
      />
      <path
        d="M525.73 159.81L524.52 159.93V158.72L525.73 158.57V159.81Z"
        fill="#CECECE"
      />
      <path
        d="M525.73 161.94L524.52 162.06V160.82L525.73 160.68V161.94Z"
        fill="#CECECE"
      />
      <path
        d="M525.72 164.08L524.52 164.18V162.93L525.72 162.8V164.08Z"
        fill="#CECECE"
      />
      <path
        d="M525.72 168.35L524.52 168.43V167.13L525.72 167.03V168.35Z"
        fill="#CECECE"
      />
      <path
        d="M525.72 170.48L524.52 170.55V169.23L525.72 169.15V170.48Z"
        fill="#CECECE"
      />
      <path
        d="M525.72 174.75L524.53 174.79V173.44L525.72 173.38V174.75Z"
        fill="#CECECE"
      />
      <path
        d="M525.72 176.88L524.53 176.92V175.54L525.72 175.5V176.88Z"
        fill="#CECECE"
      />
      <path
        d="M525.71 179.02L524.53 179.04V177.65L525.71 177.62V179.02Z"
        fill="#CECECE"
      />
      <path
        d="M525.71 181.15L524.53 181.16V179.75L525.71 179.73V181.15Z"
        fill="#CECECE"
      />
      <path d="M525.71 181.85H524.53V183.29H525.71V181.85Z" fill="#CECECE" />
      <path
        d="M507.32 130.11L508.29 129.57V130.33L507.32 130.83V130.11Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 132.22L507.32 132.72V131.97L508.29 131.45V132.22Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 134.12L507.32 134.6V133.83L508.29 133.32V134.12Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 136.01L507.32 136.48V135.7L508.29 135.2V136.01Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 137.91L507.32 138.36V137.56L508.29 137.08V137.91Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 139.8L507.32 140.24V139.42L508.29 138.96V139.8Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 141.7L507.32 142.12V141.29L508.29 140.84V141.7Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 143.59L507.32 144V143.15L508.29 142.72V143.59Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 145.49L507.32 145.88V145.01L508.29 144.6V145.49Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 147.38L507.32 147.76V146.87L508.29 146.47V147.38Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 149.28L507.33 149.64V148.74L508.29 148.35V149.28Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 151.17L507.33 151.52V150.6L508.29 150.23V151.17Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 153.07L507.33 153.4V152.46L508.29 152.11V153.07Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 156.86L507.33 157.16V156.19L508.29 155.87V156.86Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 158.75L507.33 159.04V158.05L508.29 157.75V158.75Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 162.54L507.33 162.8V161.78L508.29 161.5V162.54Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 164.44L507.33 164.68V163.64L508.29 163.38V164.44Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 166.33L507.33 166.56V165.51L508.29 165.26V166.33Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 168.23L507.33 168.44V167.37L508.29 167.14V168.23Z"
        fill="#CECECE"
      />
      <path
        d="M508.29 172.01L507.33 172.2V171.1L508.29 170.9V172.01Z"
        fill="#CECECE"
      />
      <path
        d="M508.28 173.91L507.33 174.08V172.96L508.28 172.77V173.91Z"
        fill="#CECECE"
      />
      <path
        d="M508.28 177.7L507.33 177.84V176.69L508.28 176.53V177.7Z"
        fill="#CECECE"
      />
      <path
        d="M508.28 183.38L507.34 183.49V182.28L508.28 182.17V183.38Z"
        fill="#CECECE"
      />
      <path
        d="M508.28 189.07L507.34 189.13V187.87L508.28 187.8V189.07Z"
        fill="#CECECE"
      />
      <path
        d="M508.28 194.75L507.34 194.77V193.45L508.28 193.44V194.75Z"
        fill="#CECECE"
      />
      <path
        d="M508.78 129.36L509.74 128.82V129.58L508.78 130.09V129.36Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 131.5L508.78 131.99V131.24L509.74 130.72V131.5Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 133.41L508.78 133.89V133.13L509.74 132.62V133.41Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 135.33L508.78 135.79V135.01L509.74 134.52V135.33Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 137.25L508.78 137.7V136.9L509.74 136.42V137.25Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 139.16L508.78 139.6V138.78L509.74 138.32V139.16Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 141.08L508.78 141.5V140.67L509.74 140.22V141.08Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 143L508.78 143.4V142.55L509.74 142.12V143Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 144.91L508.78 145.3V144.44L509.74 144.02V144.91Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 146.83L508.78 147.2V146.32L509.74 145.92V146.83Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 148.74L508.78 149.11V148.21L509.74 147.82V148.74Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 152.58L508.78 152.91V151.97L509.74 151.62V152.58Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 156.41L508.78 156.71V155.74L509.74 155.42V156.41Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 158.32L508.78 158.61V157.63L509.74 157.32V158.32Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 162.16L508.78 162.42V161.4L509.74 161.12V162.16Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 164.07L508.78 164.32V163.28L509.74 163.02V164.07Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 167.91L508.78 168.12V167.05L509.74 166.82V167.91Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 171.74L508.79 171.93V170.82L509.74 170.62V171.74Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 173.65L508.79 173.83V172.7L509.74 172.52V173.65Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 175.57L508.79 175.73V174.59L509.74 174.42V175.57Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 177.49L508.79 177.63V176.47L509.74 176.32V177.49Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 181.32L508.79 181.43V180.24L509.74 180.12V181.32Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 185.15L508.79 185.24V184.01L509.74 183.92V185.15Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 187.07L508.79 187.14V185.89L509.74 185.82V187.07Z"
        fill="#CECECE"
      />
      <path
        d="M509.74 190.9L508.79 190.94V189.66L509.74 189.62V190.9Z"
        fill="#CECECE"
      />
      <path
        d="M510.26 128.63L511.23 128.09V128.85L510.26 129.36V128.63Z"
        fill="#CECECE"
      />
      <path
        d="M511.23 130.79L510.26 131.28V130.54L511.23 130.01V130.79Z"
        fill="#CECECE"
      />
      <path
        d="M511.23 134.67L510.27 135.13V134.35L511.23 133.85V134.67Z"
        fill="#CECECE"
      />
      <path
        d="M511.23 136.6L510.27 137.05V136.25L511.23 135.78V136.6Z"
        fill="#CECECE"
      />
      <path
        d="M511.23 138.54L510.27 138.97V138.16L511.23 137.7V138.54Z"
        fill="#CECECE"
      />
      <path
        d="M511.23 140.48L510.27 140.9V140.06L511.23 139.62V140.48Z"
        fill="#CECECE"
      />
      <path
        d="M511.23 144.35L510.27 144.74V143.87L511.23 143.46V144.35Z"
        fill="#CECECE"
      />
      <path
        d="M511.23 146.29L510.27 146.66V145.78L511.23 145.38V146.29Z"
        fill="#CECECE"
      />
      <path
        d="M511.23 148.22L510.27 148.59V147.69L511.23 147.3V148.22Z"
        fill="#CECECE"
      />
      <path
        d="M511.23 150.16L510.27 150.51V149.59L511.23 149.22V150.16Z"
        fill="#CECECE"
      />
      <path
        d="M511.23 152.1L510.27 152.43V151.5L511.23 151.14V152.1Z"
        fill="#CECECE"
      />
      <path
        d="M511.23 154.04L510.27 154.35V153.4L511.23 153.06V154.04Z"
        fill="#CECECE"
      />
      <path
        d="M511.23 155.97L510.27 156.28V155.31L511.23 154.98V155.97Z"
        fill="#CECECE"
      />
      <path
        d="M511.23 157.91L510.28 158.2V157.21L511.23 156.9V157.91Z"
        fill="#CECECE"
      />
      <path
        d="M511.24 161.78L510.28 162.04V161.02L511.24 160.74V161.78Z"
        fill="#CECECE"
      />
      <path
        d="M511.24 163.72L510.28 163.97V162.93L511.24 162.67V163.72Z"
        fill="#CECECE"
      />
      <path
        d="M511.24 165.66L510.28 165.89V164.83L511.24 164.59V165.66Z"
        fill="#CECECE"
      />
      <path
        d="M511.24 167.59L510.28 167.81V166.74L511.24 166.51V167.59Z"
        fill="#CECECE"
      />
      <path
        d="M511.24 169.53L510.28 169.73V168.64L511.24 168.43V169.53Z"
        fill="#CECECE"
      />
      <path
        d="M511.24 171.47L510.28 171.66V170.55L511.24 170.35V171.47Z"
        fill="#CECECE"
      />
      <path
        d="M511.24 175.34L510.28 175.5V174.36L511.24 174.19V175.34Z"
        fill="#CECECE"
      />
      <path
        d="M511.24 177.28L510.28 177.42V176.26L511.24 176.11V177.28Z"
        fill="#CECECE"
      />
      <path
        d="M511.24 181.15L510.29 181.27V180.08L511.24 179.95V181.15Z"
        fill="#CECECE"
      />
      <path
        d="M511.24 185.03L510.29 185.11V183.89L511.24 183.79V185.03Z"
        fill="#CECECE"
      />
      <path
        d="M511.24 186.96L510.29 187.04V185.79L511.24 185.71V186.96Z"
        fill="#CECECE"
      />
      <path
        d="M511.24 188.9L510.29 188.96V187.7L511.24 187.63V188.9Z"
        fill="#CECECE"
      />
      <path
        d="M511.22 191.94L510.27 191.98V190.71L511.22 190.66V191.94Z"
        fill="#CECECE"
      />
      <path
        d="M511.24 192.77L510.29 192.8V191.51L511.24 191.48V192.77Z"
        fill="#CECECE"
      />
      <path d="M511.23 195.32H510.29V196.65H511.23V195.32Z" fill="#CECECE" />
      <path
        d="M511.81 127.9L512.79 127.35V128.12L511.81 128.63V127.9Z"
        fill="#CECECE"
      />
      <path
        d="M512.79 130.08L511.81 130.57V129.82L512.79 129.29V130.08Z"
        fill="#CECECE"
      />
      <path
        d="M512.78 132.03L511.81 132.52V131.75L512.78 131.24V132.03Z"
        fill="#CECECE"
      />
      <path
        d="M512.78 133.99L511.81 134.46V133.67L512.78 133.18V133.99Z"
        fill="#CECECE"
      />
      <path
        d="M512.78 135.95L511.81 136.4V135.6L512.78 135.12V135.95Z"
        fill="#CECECE"
      />
      <path
        d="M512.78 137.91L511.81 138.35V137.53L512.78 137.06V137.91Z"
        fill="#CECECE"
      />
      <path
        d="M512.78 139.87L511.81 140.29V139.45L512.78 139V139.87Z"
        fill="#CECECE"
      />
      <path
        d="M512.78 141.82L511.81 142.23V141.38L512.78 140.95V141.82Z"
        fill="#CECECE"
      />
      <path
        d="M512.77 143.78L511.81 144.18V143.31L512.77 142.89V143.78Z"
        fill="#CECECE"
      />
      <path
        d="M512.77 145.74L511.81 146.12V145.23L512.77 144.83V145.74Z"
        fill="#CECECE"
      />
      <path
        d="M512.77 147.7L511.81 148.06V147.16L512.77 146.77V147.7Z"
        fill="#CECECE"
      />
      <path
        d="M512.77 149.66L511.81 150.01V149.09L512.77 148.71V149.66Z"
        fill="#CECECE"
      />
      <path
        d="M512.77 151.61L511.81 151.95V151.01L512.77 150.65V151.61Z"
        fill="#CECECE"
      />
      <path
        d="M512.77 153.57L511.8 153.89V152.94L512.77 152.6V153.57Z"
        fill="#CECECE"
      />
      <path
        d="M512.77 155.53L511.8 155.84V154.86L512.77 154.54V155.53Z"
        fill="#CECECE"
      />
      <path
        d="M512.77 157.49L511.8 157.78V156.79L512.77 156.48V157.49Z"
        fill="#CECECE"
      />
      <path
        d="M512.76 159.45L511.8 159.72V158.72L512.76 158.42V159.45Z"
        fill="#CECECE"
      />
      <path
        d="M512.76 161.4L511.8 161.67V160.64L512.76 160.36V161.4Z"
        fill="#CECECE"
      />
      <path
        d="M512.76 165.32L511.8 165.55V164.5L512.76 164.25V165.32Z"
        fill="#CECECE"
      />
      <path
        d="M512.76 167.28L511.8 167.5V166.42L512.76 166.19V167.28Z"
        fill="#CECECE"
      />
      <path
        d="M512.76 169.24L511.8 169.44V168.35L512.76 168.13V169.24Z"
        fill="#CECECE"
      />
      <path
        d="M512.76 171.19L511.8 171.38V170.28L512.76 170.07V171.19Z"
        fill="#CECECE"
      />
      <path
        d="M512.75 173.15L511.8 173.33V172.2L512.75 172.02V173.15Z"
        fill="#CECECE"
      />
      <path
        d="M512.75 175.11L511.8 175.27V174.13L512.75 173.96V175.11Z"
        fill="#CECECE"
      />
      <path
        d="M512.75 179.03L511.8 179.16V177.98L512.75 177.84V179.03Z"
        fill="#CECECE"
      />
      <path
        d="M512.75 180.98L511.8 181.1V179.91L512.75 179.78V180.98Z"
        fill="#CECECE"
      />
      <path
        d="M512.75 182.94L511.8 183.04V181.83L512.75 181.72V182.94Z"
        fill="#CECECE"
      />
      <path
        d="M512.74 186.86L511.8 186.93V185.69L512.74 185.61V186.86Z"
        fill="#CECECE"
      />
      <path
        d="M512.74 190.77L511.79 190.82V189.54L512.74 189.49V190.77Z"
        fill="#CECECE"
      />
      <path
        d="M514.48 126.73V127.47L513.32 127.85V127.18L514.48 126.73Z"
        fill="#CECECE"
      />
      <path
        d="M514.48 129.45L513.32 129.81V129.13L514.48 128.69V129.45Z"
        fill="#CECECE"
      />
      <path
        d="M514.48 131.43L513.32 131.78V131.08L514.48 130.65V131.43Z"
        fill="#CECECE"
      />
      <path
        d="M514.48 133.4L513.32 133.75V133.02L514.48 132.61V133.4Z"
        fill="#CECECE"
      />
      <path
        d="M514.48 135.38L513.32 135.71V134.97L514.48 134.57V135.38Z"
        fill="#CECECE"
      />
      <path
        d="M514.47 139.33L513.32 139.64V138.86L514.47 138.49V139.33Z"
        fill="#CECECE"
      />
      <path
        d="M514.47 141.31L513.32 141.61V140.81L514.47 140.45V141.31Z"
        fill="#CECECE"
      />
      <path
        d="M514.47 143.29L513.32 143.57V142.76L514.47 142.41V143.29Z"
        fill="#CECECE"
      />
      <path
        d="M514.47 145.26L513.32 145.54V144.7L514.47 144.37V145.26Z"
        fill="#CECECE"
      />
      <path
        d="M514.47 147.24L513.32 147.51V146.65L514.47 146.33V147.24Z"
        fill="#CECECE"
      />
      <path
        d="M514.47 149.22L513.33 149.47V148.6L514.47 148.29V149.22Z"
        fill="#CECECE"
      />
      <path
        d="M514.47 151.19L513.33 151.44V150.54L514.47 150.24V151.19Z"
        fill="#CECECE"
      />
      <path
        d="M514.46 153.17L513.33 153.4V152.49L514.46 152.21V153.17Z"
        fill="#CECECE"
      />
      <path
        d="M514.46 155.14L513.33 155.37V154.44L514.46 154.16V155.14Z"
        fill="#CECECE"
      />
      <path
        d="M514.46 157.12L513.33 157.33V156.38L514.46 156.12V157.12Z"
        fill="#CECECE"
      />
      <path
        d="M514.46 159.1L513.33 159.3V158.33L514.46 158.08V159.1Z"
        fill="#CECECE"
      />
      <path
        d="M514.46 161.07L513.33 161.27V160.28L514.46 160.04V161.07Z"
        fill="#CECECE"
      />
      <path
        d="M514.46 163.05L513.33 163.23V162.22L514.46 162V163.05Z"
        fill="#CECECE"
      />
      <path
        d="M514.46 165.03L513.33 165.2V164.17L514.46 163.96V165.03Z"
        fill="#CECECE"
      />
      <path
        d="M514.46 167L513.33 167.16V166.12L514.46 165.92V167Z"
        fill="#CECECE"
      />
      <path
        d="M514.45 168.98L513.33 169.13V168.06L514.45 167.88V168.98Z"
        fill="#CECECE"
      />
      <path
        d="M514.45 170.96L513.33 171.09V170.01L514.45 169.84V170.96Z"
        fill="#CECECE"
      />
      <path
        d="M514.45 172.93L513.33 173.06V171.96L514.45 171.8V172.93Z"
        fill="#CECECE"
      />
      <path
        d="M514.45 174.91L513.33 175.03V173.9L514.45 173.76V174.91Z"
        fill="#CECECE"
      />
      <path
        d="M514.45 176.88L513.33 176.99V175.85L514.45 175.72V176.88Z"
        fill="#CECECE"
      />
      <path
        d="M514.45 178.86L513.34 178.96V177.8L514.45 177.68V178.86Z"
        fill="#CECECE"
      />
      <path
        d="M514.44 182.81L513.34 182.89V181.69L514.44 181.6V182.81Z"
        fill="#CECECE"
      />
      <path
        d="M514.44 184.79L513.34 184.85V183.64L514.44 183.56V184.79Z"
        fill="#CECECE"
      />
      <path
        d="M514.44 188.74L513.34 188.78V187.53L514.44 187.48V188.74Z"
        fill="#CECECE"
      />
      <path
        d="M514.44 190.72L513.34 190.75V189.48L514.44 189.44V190.72Z"
        fill="#CECECE"
      />
      <path
        d="M514.44 192.69L513.34 192.72V191.42L514.44 191.4V192.69Z"
        fill="#CECECE"
      />
      <path
        d="M514.44 194.67L513.34 194.68V193.37L514.44 193.36V194.67Z"
        fill="#CECECE"
      />
      <path d="M514.44 195.32H513.34V196.65H514.44V195.32Z" fill="#CECECE" />
      <path
        d="M558.76 142.27V143.31L560.34 143.19V142.09L558.76 142.27Z"
        fill="#CECECE"
      />
      <path
        d="M558.76 144.12V145.16L560.34 145.04V143.95L558.76 144.12Z"
        fill="#CECECE"
      />
      <path
        d="M558.76 147.82V148.86L560.34 148.76V147.67L558.76 147.82Z"
        fill="#CECECE"
      />
      <path
        d="M558.76 149.67V150.71L560.34 150.62V149.53L558.76 149.67Z"
        fill="#CECECE"
      />
      <path
        d="M558.76 151.53V152.56L560.34 152.48V151.39L558.76 151.53Z"
        fill="#CECECE"
      />
      <path
        d="M558.76 153.38V154.41L560.34 154.33V153.26L558.76 153.38Z"
        fill="#CECECE"
      />
      <path
        d="M558.76 157.08V158.11L560.34 158.05V156.98L558.76 157.08Z"
        fill="#CECECE"
      />
      <path
        d="M558.76 158.93V159.96L560.34 159.91V158.84L558.76 158.93Z"
        fill="#CECECE"
      />
      <path
        d="M558.76 160.78V161.81L560.34 161.76V160.7L558.76 160.78Z"
        fill="#CECECE"
      />
      <path
        d="M558.76 164.48V165.51L560.34 165.48V164.43L558.76 164.48Z"
        fill="#CECECE"
      />
      <path
        d="M558.76 166.33V167.37L560.34 167.34V166.29L558.76 166.33Z"
        fill="#CECECE"
      />
      <path
        d="M558.76 170.03V171.07L560.34 171.05V170.01L558.76 170.03Z"
        fill="#CECECE"
      />
      <path d="M560.34 173.73H558.76V174.76H560.34V173.73Z" fill="#CECECE" />
      <path
        d="M560.95 142.02V143.12L562.45 143.05V141.93L560.95 142.02Z"
        fill="#CECECE"
      />
      <path
        d="M560.95 143.88V144.98L562.45 144.92V143.8L560.95 143.88Z"
        fill="#CECECE"
      />
      <path
        d="M560.95 145.75V146.85L562.45 146.78V145.67L560.95 145.75Z"
        fill="#CECECE"
      />
      <path
        d="M560.94 149.48V150.57L562.45 150.51V149.42L560.94 149.48Z"
        fill="#CECECE"
      />
      <path
        d="M560.94 151.35V152.43L562.45 152.38V151.29L560.94 151.35Z"
        fill="#CECECE"
      />
      <path
        d="M560.94 155.08V156.15L562.45 156.11V155.03L560.94 155.08Z"
        fill="#CECECE"
      />
      <path
        d="M560.93 156.94V158.01L562.45 157.98V156.9L560.93 156.94Z"
        fill="#CECECE"
      />
      <path
        d="M560.93 158.81V159.88L562.45 159.84V158.77L560.93 158.81Z"
        fill="#CECECE"
      />
      <path
        d="M560.93 160.67V161.74L562.45 161.71V160.64L560.93 160.67Z"
        fill="#CECECE"
      />
      <path
        d="M560.93 162.54V163.6L562.45 163.57V162.51L560.93 162.54Z"
        fill="#CECECE"
      />
      <path
        d="M560.93 164.41V165.46L562.45 165.44V164.38L560.93 164.41Z"
        fill="#CECECE"
      />
      <path
        d="M560.92 168.14V169.18L562.45 169.17V168.12L560.92 168.14Z"
        fill="#CECECE"
      />
      <path d="M560.92 170V171.04H562.45V169.99L560.92 170Z" fill="#CECECE" />
      <path d="M562.45 173.73H560.92V174.76H562.45V173.73Z" fill="#CECECE" />
      <path
        d="M563.1 141.88V142.98L564.65 142.94V141.83L563.1 141.88Z"
        fill="#CECECE"
      />
      <path
        d="M563.1 143.76V144.85L564.65 144.81V143.71L563.1 143.76Z"
        fill="#CECECE"
      />
      <path
        d="M563.1 145.63V146.72L564.65 146.69V145.58L563.1 145.63Z"
        fill="#CECECE"
      />
      <path
        d="M563.1 147.51V148.59L564.65 148.56V147.46L563.1 147.51Z"
        fill="#CECECE"
      />
      <path
        d="M563.1 149.38V150.46L564.65 150.43V149.34L563.1 149.38Z"
        fill="#CECECE"
      />
      <path
        d="M563.1 151.25V152.33L564.65 152.3V151.21L563.1 151.25Z"
        fill="#CECECE"
      />
      <path
        d="M563.1 153.13V154.2L564.66 154.17V153.09L563.1 153.13Z"
        fill="#CECECE"
      />
      <path
        d="M563.1 155V156.07L564.66 156.05V154.97L563.1 155Z"
        fill="#CECECE"
      />
      <path
        d="M563.1 158.75V159.81L564.66 159.79V158.72L563.1 158.75Z"
        fill="#CECECE"
      />
      <path
        d="M563.1 162.49V163.55L564.66 163.53V162.47L563.1 162.49Z"
        fill="#CECECE"
      />
      <path
        d="M563.1 166.24V167.29L564.66 167.28V166.23L563.1 166.24Z"
        fill="#CECECE"
      />
      <path
        d="M563.1 168.11V169.16L564.66 169.15V168.1L563.1 168.11Z"
        fill="#CECECE"
      />
      <path
        d="M563.1 169.99V171.03L564.66 171.02V169.98L563.1 169.99Z"
        fill="#CECECE"
      />
      <path d="M563.1 171.86V172.9H564.66V171.86H563.1Z" fill="#CECECE" />
      <path d="M566.75 141.81H565.38V142.93H566.75V141.81Z" fill="#CECECE" />
      <path d="M566.75 143.69H565.38V144.8H566.75V143.69Z" fill="#CECECE" />
      <path d="M566.75 145.57H565.38V146.68H566.75V145.57Z" fill="#CECECE" />
      <path d="M566.75 147.44H565.38V148.54H566.75V147.44Z" fill="#CECECE" />
      <path d="M566.75 149.32H565.38V150.42H566.75V149.32Z" fill="#CECECE" />
      <path d="M566.75 151.2H565.38V152.29H566.75V151.2Z" fill="#CECECE" />
      <path d="M566.75 153.08H565.38V154.17H566.75V153.08Z" fill="#CECECE" />
      <path d="M566.75 154.96H565.38V156.04H566.75V154.96Z" fill="#CECECE" />
      <path d="M566.75 156.83H565.38V157.91H566.75V156.83Z" fill="#CECECE" />
      <path d="M566.75 160.59H565.38V161.66H566.75V160.59Z" fill="#CECECE" />
      <path d="M566.75 162.47H565.38V163.53H566.75V162.47Z" fill="#CECECE" />
      <path d="M566.75 164.34H565.38V165.4H566.75V164.34Z" fill="#CECECE" />
      <path d="M566.75 166.22H565.38V167.27H566.75V166.22Z" fill="#CECECE" />
      <path d="M566.75 168.1H565.38V169.15H566.75V168.1Z" fill="#CECECE" />
      <path d="M566.75 169.98H565.38V171.02H566.75V169.98Z" fill="#CECECE" />
      <path d="M566.75 173.73H565.38V174.76H566.75V173.73Z" fill="#CECECE" />
      <path
        d="M558.76 176.8V177.83L560.34 177.81V176.77L558.76 176.8Z"
        fill="#CECECE"
      />
      <path d="M560.34 181.59H558.76V182.62H560.34V181.59Z" fill="#CECECE" />
      <path
        d="M560.92 176.77V177.81L562.45 177.8V176.75L560.92 176.77Z"
        fill="#CECECE"
      />
      <path d="M562.45 181.59H560.92V182.62H562.45V181.59Z" fill="#CECECE" />
      <path
        d="M563.1 176.75V177.79H564.66V176.74L563.1 176.75Z"
        fill="#CECECE"
      />
      <path d="M563.1 178.62V179.66H564.66V178.62H563.1Z" fill="#CECECE" />
      <path d="M566.75 176.74H565.38V177.78H566.75V176.74Z" fill="#CECECE" />
      <path d="M566.75 181.59H565.38V182.62H566.75V181.59Z" fill="#CECECE" />
      <path d="M566.75 179.91H565.38V180.94H566.75V179.91Z" fill="#CECECE" />
      <path
        d="M560.92 183.19V184.23L562.45 184.22V183.18L560.92 183.19Z"
        fill="#CECECE"
      />
      <path d="M562.45 186.92H560.92V187.95H562.45V186.92Z" fill="#CECECE" />
      <path
        d="M563.1 183.17V184.21H564.66V183.16L563.1 183.17Z"
        fill="#CECECE"
      />
      <path d="M563.1 185.04V186.08H564.66V185.04H563.1Z" fill="#CECECE" />
      <path d="M566.75 183.16H565.38V184.2H566.75V183.16Z" fill="#CECECE" />
      <path d="M566.75 186.92H565.38V187.95H566.75V186.92Z" fill="#CECECE" />
      <path
        d="M560.92 189.95V190.99L562.45 190.98V189.94L560.92 189.95Z"
        fill="#CECECE"
      />
      <path d="M564.65 193.41H563.12V194.44H564.65V193.41Z" fill="#CECECE" />
      <path d="M563.1 189.93V190.97H564.66V189.93H563.1Z" fill="#CECECE" />
      <path
        d="M563.1 191.81V192.84H564.66V191.8L563.1 191.81Z"
        fill="#CECECE"
      />
      <path d="M566.75 189.92H565.38V190.96H566.75V189.92Z" fill="#CECECE" />
      <path d="M566.75 194.77H565.38V195.8H566.75V194.77Z" fill="#CECECE" />
      <path d="M712.08 172.13H710.81V173.16H712.08V172.13Z" fill="#CECECE" />
      <path
        d="M710.81 170.42L712.08 170.44V171.48L711.45 171.47H710.81V170.42Z"
        fill="#CECECE"
      />
      <path
        d="M710.81 168.7L712.08 168.74V169.8L711.45 169.78L710.81 169.76V168.7Z"
        fill="#CECECE"
      />
      <path
        d="M710.81 166.99L712.08 167.04V168.12L711.45 168.09L710.81 168.06V166.99Z"
        fill="#CECECE"
      />
      <path
        d="M710.81 165.27L712.08 165.35V166.44L711.45 166.4L710.81 166.36V165.27Z"
        fill="#CECECE"
      />
      <path
        d="M710.81 163.56L712.08 163.65V164.76L711.45 164.71L710.81 164.66V163.56Z"
        fill="#CECECE"
      />
      <path
        d="M710.81 161.84L712.08 161.95V163.08L711.45 163.02L710.81 162.96V161.84Z"
        fill="#CECECE"
      />
      <path
        d="M710.81 158.41L712.08 158.56V159.71L711.45 159.64L710.81 159.56V158.41Z"
        fill="#CECECE"
      />
      <path
        d="M710.81 156.7L712.08 156.87V158.03L711.45 157.94L710.81 157.86V156.7Z"
        fill="#CECECE"
      />
      <path
        d="M710.81 154.98L712.08 155.17V156.35L711.45 156.25L710.81 156.16V154.98Z"
        fill="#CECECE"
      />
      <path
        d="M710.81 153.27L712.08 153.47V154.67L711.45 154.56L710.81 154.46V153.27Z"
        fill="#CECECE"
      />
      <path
        d="M710.81 151.55L712.08 151.78V152.99L711.45 152.87L710.81 152.75V151.55Z"
        fill="#CECECE"
      />
      <path
        d="M710.81 149.84V151.05L711.45 151.18L712.08 151.3V150.08L710.81 149.84Z"
        fill="#CECECE"
      />
      <path d="M714.16 172.13H712.89V173.16H714.16V172.13Z" fill="#CECECE" />
      <path
        d="M712.89 170.45L714.16 170.47V171.52L713.53 171.51L712.89 171.5V170.45Z"
        fill="#CECECE"
      />
      <path
        d="M712.89 167.08L714.16 167.14V168.22L713.53 168.19L712.89 168.16V167.08Z"
        fill="#CECECE"
      />
      <path
        d="M712.89 165.39L714.16 165.47V166.57L713.53 166.53L712.89 166.49V165.39Z"
        fill="#CECECE"
      />
      <path
        d="M712.89 163.71L714.16 163.8V164.92L713.53 164.87L712.89 164.82V163.71Z"
        fill="#CECECE"
      />
      <path
        d="M712.89 162.03L714.16 162.14V163.27L713.53 163.21L712.89 163.15V162.03Z"
        fill="#CECECE"
      />
      <path
        d="M712.89 160.34L714.16 160.47V161.62L713.53 161.55L712.89 161.48V160.34Z"
        fill="#CECECE"
      />
      <path
        d="M712.89 158.66L714.16 158.81V159.97L713.53 159.89L712.89 159.81V158.66Z"
        fill="#CECECE"
      />
      <path
        d="M712.89 155.29L714.16 155.47V156.66L713.53 156.57L712.89 156.47V155.29Z"
        fill="#CECECE"
      />
      <path
        d="M712.89 151.92L714.16 152.14V153.36L713.53 153.25L712.89 153.13V151.92Z"
        fill="#CECECE"
      />
      <path
        d="M712.89 150.23V151.46L713.53 151.59L714.16 151.71V150.48L712.89 150.23Z"
        fill="#CECECE"
      />
      <path
        d="M714.99 170.48L716.27 170.5V171.55L715.63 171.54L714.99 171.53V170.48Z"
        fill="#CECECE"
      />
      <path
        d="M714.99 168.83L716.27 168.86V169.93L715.63 169.91L714.99 169.89V168.83Z"
        fill="#CECECE"
      />
      <path
        d="M714.99 167.17L716.27 167.23V168.31L715.63 168.28L714.99 168.25V167.17Z"
        fill="#CECECE"
      />
      <path
        d="M714.99 163.86L716.27 163.96V165.08L715.63 165.03L714.99 164.98V163.86Z"
        fill="#CECECE"
      />
      <path
        d="M714.99 160.56L716.27 160.69V161.84L715.63 161.77L714.99 161.7V160.56Z"
        fill="#CECECE"
      />
      <path
        d="M714.99 158.9L716.27 159.05V160.22L715.63 160.14L714.99 160.07V158.9Z"
        fill="#CECECE"
      />
      <path
        d="M714.99 157.25L716.27 157.42V158.6L715.63 158.52L714.99 158.43V157.25Z"
        fill="#CECECE"
      />
      <path
        d="M714.99 155.59L716.27 155.78V156.98L715.63 156.89L714.99 156.79V155.59Z"
        fill="#CECECE"
      />
      <path
        d="M714.99 152.29L716.27 152.51V153.75L715.63 153.63L714.99 153.52V152.29Z"
        fill="#CECECE"
      />
      <path
        d="M714.99 150.63V151.88L715.63 152L716.27 152.13V150.88L714.99 150.63Z"
        fill="#CECECE"
      />
      <path
        d="M717.05 170.51L718.32 170.53V171.58L717.68 171.57L717.05 171.56V170.51Z"
        fill="#CECECE"
      />
      <path
        d="M717.05 168.89L718.32 168.92V169.99L717.68 169.97L717.05 169.95V168.89Z"
        fill="#CECECE"
      />
      <path
        d="M717.05 167.26L718.32 167.32V168.41L717.68 168.38L717.05 168.35V167.26Z"
        fill="#CECECE"
      />
      <path
        d="M717.05 164.01L718.32 164.11V165.23L717.68 165.18L717.05 165.13V164.01Z"
        fill="#CECECE"
      />
      <path
        d="M717.05 162.39L718.32 162.5V163.64L717.68 163.59L717.05 163.53V162.39Z"
        fill="#CECECE"
      />
      <path
        d="M717.05 160.77L718.32 160.9V162.06L717.68 161.99L717.05 161.92V160.77Z"
        fill="#CECECE"
      />
      <path
        d="M717.05 159.14L718.32 159.29V160.47L717.68 160.39L717.05 160.32V159.14Z"
        fill="#CECECE"
      />
      <path
        d="M717.05 155.9L718.32 156.08V157.3L717.68 157.2L717.05 157.1V155.9Z"
        fill="#CECECE"
      />
      <path
        d="M717.05 154.27L718.32 154.48V155.71L717.68 155.6L717.05 155.5V154.27Z"
        fill="#CECECE"
      />
      <path
        d="M717.05 151.03V152.28L717.68 152.41L718.32 152.53V151.27L717.05 151.03Z"
        fill="#CECECE"
      />
      <path d="M703.91 172.13H702.64V173.16H703.91V172.13Z" fill="#CECECE" />
      <path
        d="M702.64 168.93L703.92 168.89V169.95L703.28 169.97L702.64 169.99V168.93Z"
        fill="#CECECE"
      />
      <path
        d="M702.64 167.33L703.92 167.27V168.34L703.28 168.37L702.64 168.4V167.33Z"
        fill="#CECECE"
      />
      <path
        d="M702.64 165.73L703.92 165.65V166.73L703.28 166.77L702.64 166.81V165.73Z"
        fill="#CECECE"
      />
      <path
        d="M702.64 162.52L703.92 162.41V163.51L703.28 163.57L702.64 163.62V162.52Z"
        fill="#CECECE"
      />
      <path
        d="M702.64 160.92L703.92 160.78V161.9L703.28 161.97L702.64 162.03V160.92Z"
        fill="#CECECE"
      />
      <path
        d="M702.64 159.32L703.92 159.16V160.29L703.28 160.37L702.64 160.44V159.32Z"
        fill="#CECECE"
      />
      <path
        d="M702.64 156.11L703.92 155.92V157.07L703.28 157.17L702.64 157.26V156.11Z"
        fill="#CECECE"
      />
      <path
        d="M702.64 154.51L703.92 154.3V155.46L703.28 155.57L702.64 155.67V154.51Z"
        fill="#CECECE"
      />
      <path
        d="M702.64 152.91L703.92 152.68V153.85L703.28 153.97L702.64 154.08V152.91Z"
        fill="#CECECE"
      />
      <path d="M705.99 172.13H704.72V173.16H705.99V172.13Z" fill="#CECECE" />
      <path
        d="M704.72 170.5L706 170.48V171.53H705.36L704.72 171.54V170.5Z"
        fill="#CECECE"
      />
      <path
        d="M704.72 167.23L706 167.17V168.24L705.36 168.27L704.72 168.3V167.23Z"
        fill="#CECECE"
      />
      <path
        d="M704.72 163.97L706 163.87V164.96L705.36 165.01L704.72 165.06V163.97Z"
        fill="#CECECE"
      />
      <path
        d="M704.72 162.33L706 162.22V163.32L705.36 163.38L704.72 163.44V162.33Z"
        fill="#CECECE"
      />
      <path
        d="M704.72 160.7L706 160.56V161.68L705.36 161.75L704.72 161.81V160.7Z"
        fill="#CECECE"
      />
      <path
        d="M704.72 159.07L706 158.91V160.04L705.36 160.11L704.72 160.19V159.07Z"
        fill="#CECECE"
      />
      <path
        d="M704.72 157.43L706 157.26V158.4L705.36 158.48L704.72 158.57V157.43Z"
        fill="#CECECE"
      />
      <path
        d="M704.72 154.16L706 153.95V155.11L705.36 155.22L704.72 155.33V154.16Z"
        fill="#CECECE"
      />
      <path
        d="M704.72 152.53L706 152.3V153.47L705.36 153.59L704.72 153.7V152.53Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 170.47L708.1 170.45V171.49L707.46 171.5L706.83 171.51V170.47Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 168.8L708.1 168.76V169.82L707.46 169.84L706.83 169.86V168.8Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 167.14L708.1 167.08V168.15L707.46 168.18L706.83 168.2V167.14Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 165.47L708.1 165.39V166.47L707.46 166.51L706.83 166.55V165.47Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 163.81L708.1 163.71V164.8L707.46 164.85L706.83 164.9V163.81Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 158.81L708.1 158.65V159.78L707.46 159.86L706.83 159.94V158.81Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 157.14L708.1 156.97V158.11L707.46 158.2L706.83 158.28V157.14Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 155.48L708.1 155.28V156.44L707.46 156.53L706.83 156.63V155.48Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 152.15L708.1 151.92V153.09L707.46 153.21L706.83 153.32V152.15Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 150.48V151.67L707.46 151.54L708.1 151.42V150.23L706.83 150.48Z"
        fill="#CECECE"
      />
      <path d="M710.15 172.13H708.88V173.16H710.15V172.13Z" fill="#CECECE" />
      <path
        d="M708.88 170.44L710.15 170.42V171.46L709.52 171.47L708.88 171.48V170.44Z"
        fill="#CECECE"
      />
      <path d="M712.08 178.14H710.81V179.17H712.08V178.14Z" fill="#CECECE" />
      <path
        d="M710.81 174.71L712.08 174.75V175.81L711.45 175.79L710.81 175.77V174.71Z"
        fill="#CECECE"
      />
      <path d="M703.91 180.28H702.64V181.31H703.91V180.28Z" fill="#CECECE" />
      <path d="M703.91 183.93H702.64V184.96H703.91V183.93Z" fill="#CECECE" />
      <path d="M703.91 188.11H702.64V189.14H703.91V188.11Z" fill="#CECECE" />
      <path
        d="M702.64 174.94L703.92 174.9V175.96L703.28 175.97L702.64 175.99V174.94Z"
        fill="#CECECE"
      />
      <path d="M705.99 181.98H704.72V183.01H705.99V181.98Z" fill="#CECECE" />
      <path d="M705.99 183.93H704.72V184.96H705.99V183.93Z" fill="#CECECE" />
      <path d="M708.1 183.93H706.83V184.96H708.1V183.93Z" fill="#CECECE" />
      <path d="M714.16 183.85H712.89V184.88H714.16V183.85Z" fill="#CECECE" />
      <path d="M705.99 185.89H704.72V186.92H705.99V185.89Z" fill="#CECECE" />
      <path
        d="M704.72 176.51L706 176.49V177.53L705.36 177.54L704.72 177.55V176.51Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 176.48L708.1 176.46V177.5L707.46 177.51L706.83 177.52V176.48Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 187.84L708.1 187.83V188.87L707.46 188.88L706.83 188.89V187.84Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 174.81L708.1 174.77V175.83L707.46 175.85L706.83 175.87V174.81Z"
        fill="#CECECE"
      />
      <path d="M710.15 178.14H708.88V179.17H710.15V178.14Z" fill="#CECECE" />
      <path
        d="M708.88 176.44L710.15 176.43V177.47L709.52 177.48L708.88 177.49V176.44Z"
        fill="#CECECE"
      />
      <path d="M712.08 181.98H710.81V183.01H712.08V181.98Z" fill="#CECECE" />
      <path
        d="M710.81 180.26L712.08 180.28V181.33L711.45 181.32L710.81 181.31V180.26Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 180.31L708.1 180.29V181.34L707.46 181.35L706.83 181.36V180.31Z"
        fill="#CECECE"
      />
      <path d="M710.15 181.98H708.88V183.01H710.15V181.98Z" fill="#CECECE" />
      <path
        d="M708.88 180.28L710.15 180.26V181.31L709.52 181.32L708.88 181.33V180.28Z"
        fill="#CECECE"
      />
      <path d="M712.08 185.89H710.81V186.92H712.08V185.89Z" fill="#CECECE" />
      <path
        d="M708.88 183.93L710.15 183.91V184.96L709.52 184.97L708.88 184.98V183.93Z"
        fill="#CECECE"
      />
      <path d="M712.08 191.75H710.81V192.78H712.08V191.75Z" fill="#CECECE" />
      <path d="M703.91 191.75H702.64V192.78H703.91V191.75Z" fill="#CECECE" />
      <path d="M703.91 195.59H702.64V196.62H703.91V195.59Z" fill="#CECECE" />
      <path d="M705.99 191.75H704.72V192.78H705.99V191.75Z" fill="#CECECE" />
      <path
        d="M704.72 190.12L706 190.1V191.14L705.36 191.15L704.72 191.16V190.12Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 190.09L708.1 190.07V191.11L707.46 191.12L706.83 191.13V190.09Z"
        fill="#CECECE"
      />
      <path d="M710.15 191.75H708.88V192.78H710.15V191.75Z" fill="#CECECE" />
      <path
        d="M708.88 187.84L710.15 187.82V188.87L709.52 188.88L708.88 188.89V187.84Z"
        fill="#CECECE"
      />
      <path d="M712.08 195.59H710.81V196.62H712.08V195.59Z" fill="#CECECE" />
      <path
        d="M708.88 185.92L710.15 185.9V186.95L709.52 186.96L708.88 186.97V185.92Z"
        fill="#CECECE"
      />
      <path
        d="M710.81 189.74L712.08 189.76V190.81L711.45 190.8L710.81 190.79V189.74Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 193.92L708.1 193.91V194.95L707.46 194.96L706.83 194.97V193.92Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 195.71L708.1 195.69V196.74L707.46 196.75H706.83V195.71Z"
        fill="#CECECE"
      />
      <path d="M705.99 199.62H704.72V200.65H705.99V199.62Z" fill="#CECECE" />
      <path
        d="M704.72 197.98L706 197.96V199.01L705.36 199.02L704.72 199.03V197.98Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 197.95L708.1 197.93V198.98L707.46 198.99L706.83 199V197.95Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 201.79L708.1 201.77V202.82L707.46 202.83L706.83 202.84V201.79Z"
        fill="#CECECE"
      />
      <path d="M714.17 178.14H712.9V179.17H714.17V178.14Z" fill="#CECECE" />
      <path d="M714.17 180.28H712.9V181.31H714.17V180.28Z" fill="#CECECE" />
      <path
        d="M712.9 174.62L714.18 174.59V175.64L713.54 175.66L712.9 175.68V174.62Z"
        fill="#CECECE"
      />
      <path d="M716.25 178.14H714.98V179.17H716.25V178.14Z" fill="#CECECE" />
      <path d="M716.25 183.78H714.98V184.81H716.25V183.78Z" fill="#CECECE" />
      <path
        d="M714.98 176.2L716.26 176.18V177.22L715.62 177.23L714.98 177.24V176.2Z"
        fill="#CECECE"
      />
      <path
        d="M717.08 176.16L718.36 176.14V177.19L717.72 177.2L717.08 177.21V176.16Z"
        fill="#CECECE"
      />
      <path
        d="M717.08 183.69L718.36 183.67V184.71L717.72 184.72L717.08 184.73V183.69Z"
        fill="#CECECE"
      />
      <path
        d="M717.08 174.5L718.36 174.46V175.52L717.72 175.54L717.08 175.56V174.5Z"
        fill="#CECECE"
      />
      <path
        d="M717.08 180L718.36 179.98V181.03L717.72 181.04L717.08 181.05V180Z"
        fill="#CECECE"
      />
      <path d="M714.17 187.59H712.9V188.62H714.17V187.59Z" fill="#CECECE" />
      <path d="M714.17 191.75H712.9V192.78H714.17V191.75Z" fill="#CECECE" />
      <path d="M716.25 187.59H714.98V188.62H716.25V187.59Z" fill="#CECECE" />
      <path d="M716.25 193.38H714.98V194.41H716.25V193.38Z" fill="#CECECE" />
      <path d="M714.17 201.67H712.9V202.7H714.17V201.67Z" fill="#CECECE" />
      <path d="M703.91 199.5H702.64V200.53H703.91V199.5Z" fill="#CECECE" />
      <path
        d="M714.98 185.96L716.26 185.94V186.99L715.62 187L714.98 187.01V185.96Z"
        fill="#CECECE"
      />
      <path
        d="M717.08 197.87L718.36 197.85V198.9L717.72 198.91L717.08 198.92V197.87Z"
        fill="#CECECE"
      />
      <path
        d="M717.08 189.77L718.36 189.75V190.79L717.72 190.8L717.08 190.81V189.77Z"
        fill="#CECECE"
      />
      <path
        d="M717.08 195.54L718.36 195.52V196.57L717.72 196.58L717.08 196.59V195.54Z"
        fill="#CECECE"
      />
      <path d="M710.15 195.59H708.88V196.62H710.15V195.59Z" fill="#CECECE" />
      <path
        d="M708.88 193.89L710.15 193.87V194.92L709.52 194.93L708.88 194.94V193.89Z"
        fill="#CECECE"
      />
      <path d="M712.08 199.5H710.81V200.53H712.08V199.5Z" fill="#CECECE" />
      <path d="M714.17 199.5H712.9V200.53H714.17V199.5Z" fill="#CECECE" />
      <path
        d="M708.88 197.8L710.15 197.78V198.83L709.52 198.84L708.88 198.85V197.8Z"
        fill="#CECECE"
      />
      <path d="M703.91 203.37H702.64V204.4H703.91V203.37Z" fill="#CECECE" />
      <path d="M705.99 203.37H704.72V204.4H705.99V203.37Z" fill="#CECECE" />
      <path d="M705.99 209.39H704.72V210.42H705.99V209.39Z" fill="#CECECE" />
      <path
        d="M706.83 213.65L708.1 213.63V214.67L707.46 214.68L706.83 214.69V213.65Z"
        fill="#CECECE"
      />
      <path d="M710.15 203.37H708.88V204.4H710.15V203.37Z" fill="#CECECE" />
      <path
        d="M710.81 205.5L712.08 205.51V206.56L711.45 206.55L710.81 206.54V205.5Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 205.54L708.1 205.52V206.57L707.46 206.58L706.83 206.59V205.54Z"
        fill="#CECECE"
      />
      <path d="M716.25 205.54H714.98V206.57H716.25V205.54Z" fill="#CECECE" />
      <path d="M716.25 207.23H714.98V208.26H716.25V207.23Z" fill="#CECECE" />
      <path
        d="M717.08 209.49L718.36 209.47V210.52L717.72 210.53H717.08V209.49Z"
        fill="#CECECE"
      />
      <path
        d="M717.08 201.39L718.36 201.37V202.41L717.72 202.42L717.08 202.43V201.39Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 209.42L708.1 209.4V210.45L707.46 210.46L706.83 210.47V209.42Z"
        fill="#CECECE"
      />
      <path
        d="M708.88 209.39L710.15 209.37V210.42L709.52 210.43L708.88 210.44V209.39Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 211.66L708.1 211.64V212.69L707.46 212.7L706.83 212.71V211.66Z"
        fill="#CECECE"
      />
      <path d="M703.91 209.4H702.64V210.43H703.91V209.4Z" fill="#CECECE" />
      <path d="M714.17 209.4H712.9V210.43H714.17V209.4Z" fill="#CECECE" />
      <path d="M712.08 213.28H710.81V214.31H712.08V213.28Z" fill="#CECECE" />
      <path
        d="M704.72 211.64L706 211.62V212.67L705.36 212.68L704.72 212.69V211.64Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 211.61L708.1 211.59V212.64L707.46 212.65L706.83 212.66V211.61Z"
        fill="#CECECE"
      />
      <path d="M703.91 217.1H702.64V218.13H703.91V217.1Z" fill="#CECECE" />
      <path d="M705.99 217.1H704.72V218.13H705.99V217.1Z" fill="#CECECE" />
      <path d="M705.99 222.89H704.72V223.92H705.99V222.89Z" fill="#CECECE" />
      <path
        d="M704.72 215.47L706 215.45V216.49L705.36 216.5L704.72 216.51V215.47Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 226.81L708.1 226.79V227.84L707.46 227.85L706.83 227.86V226.81Z"
        fill="#CECECE"
      />
      <path
        d="M708.88 215.4L710.15 215.39V216.43L709.52 216.44L708.88 216.45V215.4Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 219.27L708.1 219.25V220.3L707.46 220.31L706.83 220.32V219.27Z"
        fill="#CECECE"
      />
      <path
        d="M706.83 224.83L708.1 224.81V225.85L707.46 225.86L706.83 225.87V224.83Z"
        fill="#CECECE"
      />
      <path d="M703.91 223.13H702.64V224.16H703.91V223.13Z" fill="#CECECE" />
      <path d="M699.74 173.09H698.47V174.12H699.74V173.09Z" fill="#CECECE" />
      <path
        d="M698.47 169.89L699.74 169.85V170.9L699.11 170.92L698.47 170.94V169.89Z"
        fill="#CECECE"
      />
      <path
        d="M698.47 168.28L699.74 168.23V169.29L699.11 169.32L698.47 169.35V168.28Z"
        fill="#CECECE"
      />
      <path
        d="M698.47 166.68L699.74 166.6V167.68L699.11 167.72L698.47 167.76V166.68Z"
        fill="#CECECE"
      />
      <path
        d="M698.47 163.48L699.74 163.36V164.47L699.11 164.52L698.47 164.58V163.48Z"
        fill="#CECECE"
      />
      <path
        d="M698.47 161.88L699.74 161.74V162.86L699.11 162.92L698.47 162.99V161.88Z"
        fill="#CECECE"
      />
      <path
        d="M698.47 160.28L699.74 160.12V161.25L699.11 161.32L698.47 161.4V160.28Z"
        fill="#CECECE"
      />
      <path
        d="M698.47 157.07L699.74 156.88V158.03L699.11 158.12L698.47 158.22V157.07Z"
        fill="#CECECE"
      />
      <path
        d="M698.47 155.47L699.74 155.26V156.42L699.11 156.52L698.47 156.63V155.47Z"
        fill="#CECECE"
      />
      <path
        d="M698.47 153.87L699.74 153.64V154.81L699.11 154.92L698.47 155.04V153.87Z"
        fill="#CECECE"
      />
      <path d="M701.82 173.09H700.55V174.12H701.82V173.09Z" fill="#CECECE" />
      <path
        d="M700.55 171.46L701.82 171.44V172.48L701.19 172.49L700.55 172.5V171.46Z"
        fill="#CECECE"
      />
      <path
        d="M700.55 168.19L701.82 168.13V169.2L701.19 169.23L700.55 169.26V168.19Z"
        fill="#CECECE"
      />
      <path
        d="M700.55 164.92L701.82 164.83V165.92L701.19 165.97L700.55 166.01V164.92Z"
        fill="#CECECE"
      />
      <path
        d="M700.55 163.29L701.82 163.17V164.28L701.19 164.33L700.55 164.39V163.29Z"
        fill="#CECECE"
      />
      <path
        d="M700.55 161.66L701.82 161.52V162.64L701.19 162.7L700.55 162.77V161.66Z"
        fill="#CECECE"
      />
      <path
        d="M700.55 160.02L701.82 159.87V160.99L701.19 161.07L700.55 161.15V160.02Z"
        fill="#CECECE"
      />
      <path
        d="M700.55 158.39L701.82 158.22V159.35L701.19 159.44L700.55 159.53V158.39Z"
        fill="#CECECE"
      />
      <path
        d="M700.55 155.12L701.82 154.91V156.07L701.19 156.18L700.55 156.28V155.12Z"
        fill="#CECECE"
      />
      <path
        d="M700.55 153.49L701.82 153.26V154.43L701.19 154.54L700.55 154.66V153.49Z"
        fill="#CECECE"
      />
      <path d="M699.74 179.1H698.47V180.13H699.74V179.1Z" fill="#CECECE" />
      <path d="M699.74 181.24H698.47V182.27H699.74V181.24Z" fill="#CECECE" />
      <path
        d="M698.47 175.89L699.74 175.86V176.91L699.11 176.93L698.47 176.95V175.89Z"
        fill="#CECECE"
      />
      <path d="M701.82 179.1H700.55V180.13H701.82V179.1Z" fill="#CECECE" />
      <path d="M701.82 182.94H700.55V183.97H701.82V182.94Z" fill="#CECECE" />
      <path d="M701.82 184.89H700.55V185.92H701.82V184.89Z" fill="#CECECE" />
      <path d="M701.82 186.84H700.55V187.87H701.82V186.84Z" fill="#CECECE" />
      <path
        d="M700.55 177.46L701.82 177.45V178.49L701.19 178.5L700.55 178.51V177.46Z"
        fill="#CECECE"
      />
      <path d="M701.82 192.71H700.55V193.74H701.82V192.71Z" fill="#CECECE" />
      <path
        d="M700.55 191.08L701.82 191.06V192.1L701.19 192.11L700.55 192.12V191.08Z"
        fill="#CECECE"
      />
      <path d="M701.82 200.57H700.55V201.6H701.82V200.57Z" fill="#CECECE" />
      <path
        d="M700.55 198.94L701.82 198.92V199.97L701.19 199.98L700.55 199.99V198.94Z"
        fill="#CECECE"
      />
      <path d="M701.82 204.33H700.55V205.36H701.82V204.33Z" fill="#CECECE" />
      <path d="M701.82 210.35H700.55V211.38H701.82V210.35Z" fill="#CECECE" />
      <path
        d="M700.55 202.7L701.82 202.68V203.72L701.19 203.73L700.55 203.74V202.7Z"
        fill="#CECECE"
      />
      <path d="M699.74 210.36H698.47V211.39H699.74V210.36Z" fill="#CECECE" />
      <path
        d="M700.55 212.6L701.82 212.58V213.63L701.19 213.64H700.55V212.6Z"
        fill="#CECECE"
      />
      <path d="M699.74 218.06H698.47V219.09H699.74V218.06Z" fill="#CECECE" />
      <path d="M701.82 218.06H700.55V219.09H701.82V218.06Z" fill="#CECECE" />
      <path d="M701.82 223.85H700.55V224.88H701.82V223.85Z" fill="#CECECE" />
      <path d="M699.74 224.09H698.47V225.12H699.74V224.09Z" fill="#CECECE" />
      <path
        d="M706.83 224.78L708.1 224.76V225.8L707.46 225.81L706.83 225.82V224.78Z"
        fill="#CECECE"
      />
      <path d="M712.08 221.02H710.81V222.05H712.08V221.02Z" fill="#CECECE" />
      <path
        d="M708.88 165.35L710.15 165.27V166.35L709.52 166.39L708.88 166.43V165.35Z"
        fill="#CECECE"
      />
      <path
        d="M708.88 161.95L710.15 161.84V162.94L709.52 163L708.88 163.06V161.95Z"
        fill="#CECECE"
      />
      <path
        d="M708.88 160.26L710.15 160.12V161.24L709.52 161.3L708.88 161.37V160.26Z"
        fill="#CECECE"
      />
      <path
        d="M708.88 158.56L710.15 158.4V159.53L709.52 159.61L708.88 159.69V158.56Z"
        fill="#CECECE"
      />
      <path
        d="M708.88 155.17L710.15 154.97V156.12L709.52 156.22L708.88 156.32V155.17Z"
        fill="#CECECE"
      />
      <path
        d="M708.88 153.47L710.15 153.26V154.42L709.52 154.53L708.88 154.63V153.47Z"
        fill="#CECECE"
      />
      <path
        d="M708.88 150.08V151.26L709.52 151.14L710.15 151.01V149.83L708.88 150.08Z"
        fill="#CECECE"
      />
      <path
        d="M597.67 133.38V133.57L592.99 134.41V134.25L597.67 133.38Z"
        fill="#CECECE"
      />
      <path
        d="M597.67 132.38V132.56L592.99 133.42V133.26L597.67 132.38Z"
        fill="#CECECE"
      />
      <path
        d="M594.76 133.9V134.08L590.09 134.9V134.75L594.76 133.9Z"
        fill="#CECECE"
      />
      <path
        d="M594.76 132.9V133.09L590.09 133.93V133.77L594.76 132.9Z"
        fill="#CECECE"
      />
      <path
        d="M603.32 136.06L597.68 132.56V132.19L603.32 135.76V136.06Z"
        fill="#CECECE"
      />
      <path
        d="M603.32 137.03L597.68 133.62V133.24L603.32 136.72V137.03Z"
        fill="#CECECE"
      />
      <path
        d="M615.27 147.5V148.13L616.16 147.97V147.31L615.27 147.5Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 150L615.27 150.16V149.5L616.16 149.32V150Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 152.04L615.27 152.19V151.51L616.16 151.34V152.04Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 154.07L615.27 154.21V153.52L616.16 153.35V154.07Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 156.1L615.27 156.24V155.53L616.16 155.37V156.1Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 158.14L615.27 158.26V157.53L616.16 157.38V158.14Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 160.17L615.27 160.29V159.54L616.16 159.4V160.17Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 162.2L615.27 162.32V161.55L616.16 161.42V162.2Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 164.24L615.26 164.34V163.55L616.16 163.43V164.24Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 166.27L615.26 166.37V165.56L616.16 165.45V166.27Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 168.3L615.26 168.39V167.57L616.16 167.46V168.3Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 170.34L615.26 170.42V169.58L616.16 169.48V170.34Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 172.37L615.26 172.45V171.58L616.16 171.49V172.37Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 174.4L615.26 174.47V173.59L616.16 173.51V174.4Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 176.44L615.26 176.5V175.6L616.16 175.52V176.44Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 178.47L615.26 178.52V177.61L616.16 177.54V178.47Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 180.5L615.26 180.55V179.61L616.16 179.56V180.5Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 182.53L615.26 182.58V181.62L616.16 181.57V182.53Z"
        fill="#CECECE"
      />
      <path
        d="M616.16 184.57L615.25 184.6V183.63L616.16 183.59V184.57Z"
        fill="#CECECE"
      />
      <path
        d="M616.17 186.6L615.25 186.63V185.64L616.17 185.6V186.6Z"
        fill="#CECECE"
      />
      <path
        d="M616.17 188.63L615.25 188.66V187.64L616.17 187.62V188.63Z"
        fill="#CECECE"
      />
      <path
        d="M616.17 190.67L615.25 190.68V189.65L616.17 189.63V190.67Z"
        fill="#CECECE"
      />
      <path d="M616.17 196.37H615.25V197.44H616.17V196.37Z" fill="#CECECE" />
      <path
        d="M616.16 147.31V147.97L617.21 148.67V148.03L616.16 147.31Z"
        fill="#CECECE"
      />
      <path
        d="M617.2 150.68L616.16 150V149.32L617.2 150.01V150.68Z"
        fill="#CECECE"
      />
      <path
        d="M617.2 152.68L616.16 152.04V151.34L617.2 152V152.68Z"
        fill="#CECECE"
      />
      <path
        d="M617.2 154.68L616.16 154.07V153.35L617.2 153.98V154.68Z"
        fill="#CECECE"
      />
      <path
        d="M617.2 156.68L616.16 156.1V155.37L617.2 155.96V156.68Z"
        fill="#CECECE"
      />
      <path
        d="M617.2 158.69L616.16 158.14V157.38L617.2 157.95V158.69Z"
        fill="#CECECE"
      />
      <path
        d="M617.2 160.69L616.16 160.17V159.4L617.2 159.93V160.69Z"
        fill="#CECECE"
      />
      <path
        d="M617.2 162.69L616.16 162.2V161.42L617.2 161.92V162.69Z"
        fill="#CECECE"
      />
      <path
        d="M617.19 164.7L616.16 164.24V163.43L617.19 163.9V164.7Z"
        fill="#CECECE"
      />
      <path
        d="M617.19 166.7L616.16 166.27V165.45L617.19 165.89V166.7Z"
        fill="#CECECE"
      />
      <path
        d="M617.19 170.7L616.16 170.34V169.48L617.19 169.85V170.7Z"
        fill="#CECECE"
      />
      <path
        d="M617.19 172.71L616.16 172.37V171.49L617.19 171.84V172.71Z"
        fill="#CECECE"
      />
      <path
        d="M617.19 174.71L616.16 174.4V173.51L617.19 173.82V174.71Z"
        fill="#CECECE"
      />
      <path
        d="M617.18 178.71L616.16 178.47V177.54L617.18 177.79V178.71Z"
        fill="#CECECE"
      />
      <path
        d="M617.18 180.72L616.16 180.5V179.56L617.18 179.77V180.72Z"
        fill="#CECECE"
      />
      <path
        d="M617.18 184.72L616.16 184.57V183.59L617.18 183.74V184.72Z"
        fill="#CECECE"
      />
      <path
        d="M617.18 188.73L616.17 188.63V187.62L617.18 187.71V188.73Z"
        fill="#CECECE"
      />
      <path
        d="M617.33 148.11V148.76L618.3 149.41V148.78L617.33 148.11Z"
        fill="#CECECE"
      />
      <path
        d="M618.31 151.38L617.33 150.75V150.09L618.31 150.73V151.38Z"
        fill="#CECECE"
      />
      <path
        d="M618.31 153.35L617.33 152.75V152.07L618.31 152.68V153.35Z"
        fill="#CECECE"
      />
      <path
        d="M618.31 155.32L617.33 154.75V154.05L618.31 154.64V155.32Z"
        fill="#CECECE"
      />
      <path
        d="M618.31 157.29L617.33 156.75V156.03L618.31 156.59V157.29Z"
        fill="#CECECE"
      />
      <path
        d="M618.31 159.26L617.33 158.75V158.01L618.31 158.54V159.26Z"
        fill="#CECECE"
      />
      <path
        d="M618.31 161.24L617.33 160.75V159.99L618.31 160.49V161.24Z"
        fill="#CECECE"
      />
      <path
        d="M618.31 163.21L617.33 162.75V161.97L618.31 162.44V163.21Z"
        fill="#CECECE"
      />
      <path
        d="M618.31 165.18L617.33 164.75V163.95L618.31 164.39V165.18Z"
        fill="#CECECE"
      />
      <path
        d="M618.31 167.15L617.33 166.75V165.94L618.31 166.34V167.15Z"
        fill="#CECECE"
      />
      <path
        d="M618.31 169.12L617.33 168.75V167.92L618.31 168.3V169.12Z"
        fill="#CECECE"
      />
      <path
        d="M618.31 171.09L617.33 170.74V169.9L618.31 170.25V171.09Z"
        fill="#CECECE"
      />
      <path
        d="M618.31 173.06L617.33 172.74V171.88L618.31 172.2V173.06Z"
        fill="#CECECE"
      />
      <path
        d="M618.31 175.03L617.33 174.74V173.86L618.31 174.15V175.03Z"
        fill="#CECECE"
      />
      <path
        d="M618.31 177L617.33 176.74V175.84L618.31 176.1V177Z"
        fill="#CECECE"
      />
      <path
        d="M618.31 178.97L617.34 178.74V177.82L618.31 178.05V178.97Z"
        fill="#CECECE"
      />
      <path
        d="M618.32 180.94L617.34 180.74V179.8L618.32 180V180.94Z"
        fill="#CECECE"
      />
      <path
        d="M618.32 182.91L617.34 182.74V181.78L618.32 181.96V182.91Z"
        fill="#CECECE"
      />
      <path
        d="M618.32 184.88L617.34 184.74V183.76L618.32 183.91V184.88Z"
        fill="#CECECE"
      />
      <path
        d="M618.32 186.85L617.34 186.74V185.74L618.32 185.86V186.85Z"
        fill="#CECECE"
      />
      <path
        d="M618.32 188.82L617.34 188.74V187.72L618.32 187.81V188.82Z"
        fill="#CECECE"
      />
      <path
        d="M618.32 190.79L617.34 190.74V189.7L618.32 189.76V190.79Z"
        fill="#CECECE"
      />
      <path
        d="M618.32 192.76L617.34 192.73V191.68L618.32 191.71V192.76Z"
        fill="#CECECE"
      />
      <path
        d="M619.67 149.72V150.32L620.29 150.74V150.14L619.67 149.72Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 152.65L619.66 152.26V151.63L620.29 152.04V152.65Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 154.57L619.66 154.19V153.54L620.29 153.93V154.57Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 156.48L619.66 156.12V155.45L620.29 155.82V156.48Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 158.39L619.66 158.05V157.36L620.29 157.71V158.39Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 160.3L619.66 159.98V159.27L620.29 159.61V160.3Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 164.13L619.66 163.84V163.09L620.29 163.39V164.13Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 166.04L619.65 165.77V165L620.29 165.28V166.04Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 167.96L619.65 167.7V166.91L620.29 167.17V167.96Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 169.87L619.65 169.63V168.82L620.29 169.07V169.87Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 171.78L619.65 171.56V170.74L620.29 170.96V171.78Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 173.69L619.65 173.49V172.65L620.29 172.85V173.69Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 177.52L619.64 177.36V176.47L620.29 176.64V177.52Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 179.43L619.64 179.29V178.38L620.29 178.53V179.43Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 183.26L619.64 183.15V182.2L620.29 182.31V183.26Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 185.17L619.64 185.08V184.11L620.29 184.2V185.17Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 187.08L619.64 187.01V186.02L620.29 186.1V187.08Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 190.91L619.63 190.87V189.84L620.29 189.88V190.91Z"
        fill="#CECECE"
      />
      <path
        d="M620.29 192.82L619.63 192.8V191.75L620.29 191.77V192.82Z"
        fill="#CECECE"
      />
      <path
        d="M620.41 150.23V150.82L620.98 151.2V150.62L620.41 150.23Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 153.1L620.41 152.73V152.12L620.98 152.49V153.1Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 154.99L620.4 154.64V154L620.98 154.36V154.99Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 156.88L620.4 156.55V155.89L620.98 156.24V156.88Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 158.78L620.4 158.46V157.78L620.98 158.11V158.78Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 160.67L620.4 160.37V159.67L620.98 159.98V160.67Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 162.56L620.4 162.28V161.56L620.98 161.85V162.56Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 164.45L620.4 164.19V163.45L620.98 163.72V164.45Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 166.35L620.4 166.1V165.34L620.98 165.59V166.35Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 168.24L620.4 168V167.22L620.98 167.46V168.24Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 170.13L620.4 169.91V169.11L620.98 169.34V170.13Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 172.02L620.4 171.82V171L620.98 171.21V172.02Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 173.92L620.4 173.73V172.89L620.98 173.08V173.92Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 175.81L620.4 175.64V174.78L620.98 174.95V175.81Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 179.59L620.4 179.46V178.56L620.98 178.69V179.59Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 181.49L620.4 181.37V180.44L620.98 180.56V181.49Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 183.38L620.4 183.28V182.33L620.98 182.44V183.38Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 187.16L620.4 187.1V186.11L620.98 186.18V187.16Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 189.06L620.4 189.01V188L620.98 188.05V189.06Z"
        fill="#CECECE"
      />
      <path
        d="M620.98 190.95L620.4 190.92V189.89L620.98 189.92V190.95Z"
        fill="#CECECE"
      />
      <path d="M620.98 196.37H620.39V197.44H620.98V196.37Z" fill="#CECECE" />
      <path
        d="M622.32 151.54V152.1L623.08 152.61V152.06L622.32 151.54Z"
        fill="#CECECE"
      />
      <path
        d="M623.08 154.45L622.32 153.96V153.37L623.08 153.87V154.45Z"
        fill="#CECECE"
      />
      <path
        d="M623.08 156.28L622.32 155.81V155.2L623.08 155.68V156.28Z"
        fill="#CECECE"
      />
      <path
        d="M623.08 159.94L622.32 159.52V158.87L623.08 159.3V159.94Z"
        fill="#CECECE"
      />
      <path
        d="M623.07 161.77L622.32 161.37V160.7L623.07 161.11V161.77Z"
        fill="#CECECE"
      />
      <path
        d="M623.07 163.6L622.32 163.22V162.53L623.07 162.92V163.6Z"
        fill="#CECECE"
      />
      <path
        d="M623.07 165.43L622.32 165.08V164.36L623.07 164.72V165.43Z"
        fill="#CECECE"
      />
      <path
        d="M623.07 167.26L622.32 166.93V166.19L623.07 166.53V167.26Z"
        fill="#CECECE"
      />
      <path
        d="M623.07 169.1L622.32 168.78V168.02L623.07 168.34V169.1Z"
        fill="#CECECE"
      />
      <path
        d="M623.07 170.93L622.32 170.64V169.85L623.07 170.15V170.93Z"
        fill="#CECECE"
      />
      <path
        d="M623.07 176.42L622.32 176.2V175.35L623.07 175.58V176.42Z"
        fill="#CECECE"
      />
      <path
        d="M623.07 178.25L622.33 178.05V177.18L623.07 177.39V178.25Z"
        fill="#CECECE"
      />
      <path
        d="M623.06 180.08L622.33 179.91V179.01L623.06 179.2V180.08Z"
        fill="#CECECE"
      />
      <path
        d="M623.06 181.91L622.33 181.76V180.84L623.06 181V181.91Z"
        fill="#CECECE"
      />
      <path
        d="M623.06 183.75L622.33 183.61V182.67L623.06 182.81V183.75Z"
        fill="#CECECE"
      />
      <path
        d="M623.06 187.41L622.33 187.32V186.34L623.06 186.43V187.41Z"
        fill="#CECECE"
      />
      <path
        d="M623.06 191.07L622.33 191.03V190L623.06 190.05V191.07Z"
        fill="#CECECE"
      />
      <path
        d="M623.06 192.9L622.33 192.88V191.83L623.06 191.86V192.9Z"
        fill="#CECECE"
      />
      <path d="M623.05 196.37H622.33V197.44H623.05V196.37Z" fill="#CECECE" />
      <path
        d="M623.2 152.15V152.69L623.82 153.11V152.57L623.2 152.15Z"
        fill="#CECECE"
      />
      <path
        d="M623.82 154.92L623.2 154.52V153.95L623.82 154.36V154.92Z"
        fill="#CECECE"
      />
      <path
        d="M623.81 156.73L623.2 156.35V155.76L623.81 156.15V156.73Z"
        fill="#CECECE"
      />
      <path
        d="M623.81 158.54L623.2 158.18V157.56L623.81 157.93V158.54Z"
        fill="#CECECE"
      />
      <path
        d="M623.81 160.35L623.2 160.01V159.37L623.81 159.72V160.35Z"
        fill="#CECECE"
      />
      <path
        d="M623.8 162.16L623.2 161.83V161.17L623.8 161.51V162.16Z"
        fill="#CECECE"
      />
      <path
        d="M623.8 163.97L623.2 163.66V162.98L623.8 163.29V163.97Z"
        fill="#CECECE"
      />
      <path
        d="M623.8 167.59L623.2 167.32V166.59L623.8 166.87V167.59Z"
        fill="#CECECE"
      />
      <path
        d="M623.79 169.4L623.2 169.14V168.39L623.79 168.65V169.4Z"
        fill="#CECECE"
      />
      <path
        d="M623.79 171.21L623.2 170.97V170.2L623.79 170.44V171.21Z"
        fill="#CECECE"
      />
      <path
        d="M623.79 173.02L623.2 172.8V172L623.79 172.23V173.02Z"
        fill="#CECECE"
      />
      <path
        d="M623.78 174.83L623.2 174.63V173.81L623.78 174.01V174.83Z"
        fill="#CECECE"
      />
      <path
        d="M623.78 176.64L623.2 176.46V175.61L623.78 175.8V176.64Z"
        fill="#CECECE"
      />
      <path
        d="M623.78 178.45L623.2 178.28V177.42L623.78 177.59V178.45Z"
        fill="#CECECE"
      />
      <path
        d="M623.77 180.26L623.2 180.11V179.22L623.77 179.37V180.26Z"
        fill="#CECECE"
      />
      <path
        d="M623.77 182.07L623.2 181.94V181.03L623.77 181.16V182.07Z"
        fill="#CECECE"
      />
      <path
        d="M623.77 183.88L623.21 183.77V182.83L623.77 182.95V183.88Z"
        fill="#CECECE"
      />
      <path
        d="M623.76 185.69L623.21 185.6V184.64L623.76 184.73V185.69Z"
        fill="#CECECE"
      />
      <path
        d="M623.76 187.5L623.21 187.42V186.44L623.76 186.52V187.5Z"
        fill="#CECECE"
      />
      <path
        d="M623.76 189.31L623.21 189.25V188.25L623.76 188.3V189.31Z"
        fill="#CECECE"
      />
      <path
        d="M623.75 192.92L623.21 192.91V191.86L623.75 191.88V192.92Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 147.81V148.41L614.79 148.22V147.6L613.79 147.81Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 150.42L614.79 150.24V149.6L613.79 149.81V150.42Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 152.43L614.79 152.27V151.61L613.79 151.8V152.43Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 154.45L614.79 154.29V153.61L613.79 153.8V154.45Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 156.46L614.79 156.31V155.61L613.79 155.79V156.46Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 158.48L614.78 158.33V157.61L613.79 157.78V158.48Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 160.49L614.78 160.36V159.62L613.79 159.78V160.49Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 162.51L614.78 162.38V161.62L613.79 161.77V162.51Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 164.52L614.78 164.4V163.62L613.79 163.76V164.52Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 166.53L614.78 166.42V165.63L613.79 165.76V166.53Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 168.55L614.78 168.44V167.63L613.79 167.75V168.55Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 170.56L614.78 170.47V169.63L613.79 169.74V170.56Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 172.58L614.78 172.49V171.63L613.79 171.74V172.58Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 174.59L614.78 174.51V173.64L613.79 173.73V174.59Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 176.61L614.78 176.53V175.64L613.79 175.72V176.61Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 180.63L614.78 180.58V179.65L613.79 179.71V180.63Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 182.65L614.78 182.6V181.65L613.79 181.7V182.65Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 184.66L614.77 184.62V183.65L613.79 183.7V184.66Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 188.69L614.77 188.67V187.66L613.79 187.68V188.69Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 190.71L614.77 190.69V189.66L613.79 189.68V190.71Z"
        fill="#CECECE"
      />
      <path
        d="M613.79 192.72L614.77 192.71V191.66L613.79 191.67V192.72Z"
        fill="#CECECE"
      />
      <path
        d="M612.43 148.11V148.66L613.33 148.49V147.91L612.43 148.11Z"
        fill="#CECECE"
      />
      <path
        d="M612.43 150.66L613.33 150.5V149.9L612.43 150.09V150.66Z"
        fill="#CECECE"
      />
      <path
        d="M612.43 152.66L613.33 152.51V151.89L612.43 152.07V152.66Z"
        fill="#CECECE"
      />
      <path
        d="M612.43 154.67L613.33 154.52V153.88L612.43 154.05V154.67Z"
        fill="#CECECE"
      />
      <path
        d="M612.43 156.67L613.33 156.53V155.87L612.43 156.03V156.67Z"
        fill="#CECECE"
      />
      <path
        d="M612.42 158.67L613.33 158.54V157.86L612.42 158.01V158.67Z"
        fill="#CECECE"
      />
      <path
        d="M612.42 160.68L613.33 160.55V159.85L612.42 159.99V160.68Z"
        fill="#CECECE"
      />
      <path
        d="M612.42 162.68L613.33 162.56V161.84L612.42 161.97V162.68Z"
        fill="#CECECE"
      />
      <path
        d="M612.42 164.68L613.33 164.58V163.83L612.42 163.95V164.68Z"
        fill="#CECECE"
      />
      <path
        d="M612.42 166.69L613.33 166.59V165.82L612.42 165.94V166.69Z"
        fill="#CECECE"
      />
      <path
        d="M612.42 168.69L613.33 168.6V167.81L612.42 167.92V168.69Z"
        fill="#CECECE"
      />
      <path
        d="M612.42 170.69L613.33 170.61V169.8L612.42 169.9V170.69Z"
        fill="#CECECE"
      />
      <path
        d="M612.42 172.7L613.33 172.62V171.78L612.42 171.88V172.7Z"
        fill="#CECECE"
      />
      <path
        d="M612.42 176.7L613.33 176.64V175.76L612.42 175.84V176.7Z"
        fill="#CECECE"
      />
      <path
        d="M612.42 178.71L613.33 178.65V177.75L612.42 177.82V178.71Z"
        fill="#CECECE"
      />
      <path
        d="M612.42 180.71L613.33 180.66V179.74L612.42 179.8V180.71Z"
        fill="#CECECE"
      />
      <path
        d="M612.42 186.72L613.33 186.69V185.71L612.42 185.74V186.72Z"
        fill="#CECECE"
      />
      <path
        d="M612.42 188.72L613.33 188.7V187.7L612.42 187.72V188.72Z"
        fill="#CECECE"
      />
      <path
        d="M612.42 192.73L613.33 192.72V191.68H612.42V192.73Z"
        fill="#CECECE"
      />
      <path
        d="M611.31 148.35V148.86L612.02 148.73V148.2L611.31 148.35Z"
        fill="#CECECE"
      />
      <path
        d="M611.31 150.86L612.02 150.73V150.17L611.31 150.32V150.86Z"
        fill="#CECECE"
      />
      <path
        d="M611.31 152.85L612.02 152.73V152.15L611.31 152.29V152.85Z"
        fill="#CECECE"
      />
      <path
        d="M611.31 154.84L612.02 154.73V154.13L611.31 154.26V154.84Z"
        fill="#CECECE"
      />
      <path
        d="M611.31 156.84L612.02 156.73V156.1L611.31 156.23V156.84Z"
        fill="#CECECE"
      />
      <path
        d="M611.31 158.83L612.02 158.73V158.08L611.31 158.2V158.83Z"
        fill="#CECECE"
      />
      <path
        d="M611.3 162.82L612.01 162.73V162.03L611.3 162.14V162.82Z"
        fill="#CECECE"
      />
      <path
        d="M611.3 164.82L612.01 164.73V164.01L611.3 164.11V164.82Z"
        fill="#CECECE"
      />
      <path
        d="M611.3 166.81L612.01 166.73V165.99L611.3 166.08V166.81Z"
        fill="#CECECE"
      />
      <path
        d="M611.3 170.8L612.01 170.73V169.94L611.3 170.02V170.8Z"
        fill="#CECECE"
      />
      <path
        d="M611.3 172.8L612.01 172.73V171.92L611.3 171.99V172.8Z"
        fill="#CECECE"
      />
      <path
        d="M611.3 174.79L612.01 174.73V173.9L611.3 173.96V174.79Z"
        fill="#CECECE"
      />
      <path
        d="M611.3 178.78L612.01 178.73V177.85L611.3 177.9V178.78Z"
        fill="#CECECE"
      />
      <path
        d="M611.3 180.77L612.01 180.73V179.83L611.3 179.87V180.77Z"
        fill="#CECECE"
      />
      <path
        d="M611.3 184.76L612.01 184.73V183.78L611.3 183.81V184.76Z"
        fill="#CECECE"
      />
      <path
        d="M611.3 186.76L612 186.73V185.76L611.3 185.78V186.76Z"
        fill="#CECECE"
      />
      <path
        d="M611.3 188.75L612 188.73V187.73L611.3 187.75V188.75Z"
        fill="#CECECE"
      />
      <path
        d="M610.05 148.62V149.09L610.9 148.94V148.44L610.05 148.62Z"
        fill="#CECECE"
      />
      <path
        d="M610.05 151.08L610.9 150.93V150.4L610.05 150.58V151.08Z"
        fill="#CECECE"
      />
      <path
        d="M610.05 153.06L610.9 152.92V152.37L610.05 152.54V153.06Z"
        fill="#CECECE"
      />
      <path
        d="M610.04 155.05L610.9 154.91V154.34L610.04 154.5V155.05Z"
        fill="#CECECE"
      />
      <path
        d="M610.04 157.03L610.9 156.9V156.3L610.04 156.45V157.03Z"
        fill="#CECECE"
      />
      <path
        d="M610.04 161L610.9 160.88V160.24L610.04 160.37V161Z"
        fill="#CECECE"
      />
      <path
        d="M610.04 162.98L610.9 162.87V162.2L610.04 162.33V162.98Z"
        fill="#CECECE"
      />
      <path
        d="M610.04 164.97L610.9 164.87V164.17L610.04 164.29V164.97Z"
        fill="#CECECE"
      />
      <path
        d="M610.03 168.94L610.9 168.85V168.1L610.03 168.2V168.94Z"
        fill="#CECECE"
      />
      <path
        d="M610.03 172.91L610.9 172.83V172.03L610.03 172.12V172.91Z"
        fill="#CECECE"
      />
      <path
        d="M610.03 174.89L610.9 174.82V174L610.03 174.08V174.89Z"
        fill="#CECECE"
      />
      <path
        d="M610.03 176.87L610.9 176.81V175.97L610.03 176.04V176.87Z"
        fill="#CECECE"
      />
      <path
        d="M610.03 178.86L610.9 178.8V177.93L610.03 178V178.86Z"
        fill="#CECECE"
      />
      <path
        d="M610.02 180.84L610.9 180.8V179.9L610.02 179.96V180.84Z"
        fill="#CECECE"
      />
      <path
        d="M610.02 182.83L610.9 182.79V181.87L610.02 181.91V182.83Z"
        fill="#CECECE"
      />
      <path
        d="M610.02 186.8L610.9 186.77V185.8L610.02 185.83V186.8Z"
        fill="#CECECE"
      />
      <path
        d="M610.02 190.77L610.9 190.75V189.73L610.02 189.75V190.77Z"
        fill="#CECECE"
      />
      <path
        d="M610.02 192.75L610.9 192.74V191.7L610.02 191.71V192.75Z"
        fill="#CECECE"
      />
      <path
        d="M618.49 194.73H619.47V149.54L618.49 148.86V194.73Z"
        fill="#CECECE"
      />
      <path
        d="M621.15 194.73H622.13V151.39L621.15 150.71V194.73Z"
        fill="#CECECE"
      />
      <path
        d="M624.01 194.73H624.29V152.89L624.01 152.7V194.73Z"
        fill="#CECECE"
      />
      <path
        d="M624.38 194.73H624.66V153.15L624.38 152.95V194.73Z"
        fill="#CECECE"
      />
      <path
        d="M596.61 134.83V135.65L597.75 135.44V134.58L596.61 134.83Z"
        fill="#CECECE"
      />
      <path
        d="M597.75 138.04L596.61 138.24V137.4L597.75 137.17V138.04Z"
        fill="#CECECE"
      />
      <path
        d="M597.75 140.65L596.61 140.84V139.98L597.75 139.75V140.65Z"
        fill="#CECECE"
      />
      <path
        d="M597.75 143.26L596.61 143.44V142.55L597.75 142.34V143.26Z"
        fill="#CECECE"
      />
      <path
        d="M597.75 145.87L596.61 146.04V145.13L597.75 144.93V145.87Z"
        fill="#CECECE"
      />
      <path
        d="M597.75 148.48L596.61 148.64V147.7L597.75 147.51V148.48Z"
        fill="#CECECE"
      />
      <path
        d="M597.75 151.08L596.61 151.24V150.28L597.75 150.1V151.08Z"
        fill="#CECECE"
      />
      <path
        d="M597.75 153.69L596.6 153.84V152.85L597.75 152.68V153.69Z"
        fill="#CECECE"
      />
      <path
        d="M597.75 156.3L596.6 156.44V155.43L597.75 155.27V156.3Z"
        fill="#CECECE"
      />
      <path
        d="M597.75 158.91L596.6 159.03V158L597.75 157.85V158.91Z"
        fill="#CECECE"
      />
      <path
        d="M597.75 161.51L596.6 161.63V160.57L597.75 160.44V161.51Z"
        fill="#CECECE"
      />
      <path
        d="M597.75 164.12L596.6 164.23V163.15L597.75 163.02V164.12Z"
        fill="#CECECE"
      />
      <path
        d="M597.75 166.73L596.6 166.83V165.72L597.75 165.61V166.73Z"
        fill="#CECECE"
      />
      <path
        d="M597.75 169.34L596.6 169.43V168.3L597.75 168.19V169.34Z"
        fill="#CECECE"
      />
      <path
        d="M597.75 171.95L596.59 172.03V170.87L597.75 170.78V171.95Z"
        fill="#CECECE"
      />
      <path
        d="M597.75 174.55L596.59 174.63V173.45L597.75 173.36V174.55Z"
        fill="#CECECE"
      />
      <path
        d="M597.76 177.16L596.59 177.22V176.02L597.76 175.95V177.16Z"
        fill="#CECECE"
      />
      <path
        d="M597.76 179.77L596.59 179.82V178.6L597.76 178.53V179.77Z"
        fill="#CECECE"
      />
      <path
        d="M597.76 182.38L596.59 182.42V181.17L597.76 181.12V182.38Z"
        fill="#CECECE"
      />
      <path
        d="M597.76 184.98L596.59 185.02V183.75L597.76 183.7V184.98Z"
        fill="#CECECE"
      />
      <path
        d="M597.76 187.59L596.59 187.62V186.32L597.76 186.29V187.59Z"
        fill="#CECECE"
      />
      <path
        d="M597.76 190.2L596.58 190.22V188.89L597.76 188.87V190.2Z"
        fill="#CECECE"
      />
      <path d="M597.76 194.04H596.58V195.41H597.76V194.04Z" fill="#CECECE" />
      <path
        d="M597.75 134.58V135.44L599.09 136.34V135.51L597.75 134.58Z"
        fill="#CECECE"
      />
      <path
        d="M599.09 138.91L597.75 138.04V137.17L599.09 138.06V138.91Z"
        fill="#CECECE"
      />
      <path
        d="M599.09 141.48L597.75 140.65V139.75L599.09 140.6V141.48Z"
        fill="#CECECE"
      />
      <path
        d="M599.09 144.05L597.75 143.26V142.34L599.09 143.14V144.05Z"
        fill="#CECECE"
      />
      <path
        d="M599.08 146.61L597.75 145.87V144.93L599.08 145.69V146.61Z"
        fill="#CECECE"
      />
      <path
        d="M599.08 149.18L597.75 148.48V147.51L599.08 148.23V149.18Z"
        fill="#CECECE"
      />
      <path
        d="M599.08 151.75L597.75 151.08V150.1L599.08 150.78V151.75Z"
        fill="#CECECE"
      />
      <path
        d="M599.08 154.32L597.75 153.69V152.68L599.08 153.32V154.32Z"
        fill="#CECECE"
      />
      <path
        d="M599.08 156.89L597.75 156.3V155.27L599.08 155.87V156.89Z"
        fill="#CECECE"
      />
      <path
        d="M599.07 159.46L597.75 158.91V157.85L599.07 158.41V159.46Z"
        fill="#CECECE"
      />
      <path
        d="M599.07 164.59L597.75 164.12V163.02L599.07 163.5V164.59Z"
        fill="#CECECE"
      />
      <path
        d="M599.07 167.16L597.75 166.73V165.61L599.07 166.05V167.16Z"
        fill="#CECECE"
      />
      <path
        d="M599.07 169.73L597.75 169.34V168.19L599.07 168.59V169.73Z"
        fill="#CECECE"
      />
      <path
        d="M599.06 174.87L597.75 174.55V173.36L599.06 173.68V174.87Z"
        fill="#CECECE"
      />
      <path
        d="M599.06 177.44L597.76 177.16V175.95L599.06 176.23V177.44Z"
        fill="#CECECE"
      />
      <path
        d="M599.06 182.57L597.76 182.38V181.12L599.06 181.32V182.57Z"
        fill="#CECECE"
      />
      <path
        d="M599.05 187.71L597.76 187.59V186.29L599.05 186.41V187.71Z"
        fill="#CECECE"
      />
      <path
        d="M599.24 135.62V136.44L600.5 137.29V136.48L599.24 135.62Z"
        fill="#CECECE"
      />
      <path
        d="M600.5 139.81L599.25 139.01V138.16L600.5 138.98V139.81Z"
        fill="#CECECE"
      />
      <path
        d="M600.5 142.34L599.25 141.57V140.7L600.5 141.48V142.34Z"
        fill="#CECECE"
      />
      <path
        d="M600.5 144.87L599.25 144.14V143.24L600.5 143.99V144.87Z"
        fill="#CECECE"
      />
      <path
        d="M600.5 147.4L599.25 146.7V145.78L600.5 146.49V147.4Z"
        fill="#CECECE"
      />
      <path
        d="M600.51 149.92L599.25 149.26V148.32L600.51 148.99V149.92Z"
        fill="#CECECE"
      />
      <path
        d="M600.51 152.45L599.25 151.83V150.86L600.51 151.5V152.45Z"
        fill="#CECECE"
      />
      <path
        d="M600.51 154.98L599.25 154.39V153.4L600.51 154V154.98Z"
        fill="#CECECE"
      />
      <path
        d="M600.51 157.5L599.25 156.96V155.94L600.51 156.5V157.5Z"
        fill="#CECECE"
      />
      <path
        d="M600.51 160.03L599.25 159.52V158.48L600.51 159V160.03Z"
        fill="#CECECE"
      />
      <path
        d="M600.51 162.56L599.25 162.08V161.02L600.51 161.51V162.56Z"
        fill="#CECECE"
      />
      <path
        d="M600.51 165.09L599.25 164.65V163.56L600.51 164.01V165.09Z"
        fill="#CECECE"
      />
      <path
        d="M600.51 167.61L599.26 167.21V166.1L600.51 166.51V167.61Z"
        fill="#CECECE"
      />
      <path
        d="M600.51 170.14L599.26 169.78V168.64L600.51 169.01V170.14Z"
        fill="#CECECE"
      />
      <path
        d="M600.51 172.67L599.26 172.34V171.18L600.51 171.52V172.67Z"
        fill="#CECECE"
      />
      <path
        d="M600.51 175.2L599.26 174.9V173.72L600.51 174.02V175.2Z"
        fill="#CECECE"
      />
      <path
        d="M600.51 177.72L599.26 177.47V176.26L600.51 176.52V177.72Z"
        fill="#CECECE"
      />
      <path
        d="M600.52 180.25L599.26 180.03V178.8L600.52 179.03V180.25Z"
        fill="#CECECE"
      />
      <path
        d="M600.52 182.78L599.26 182.59V181.34L600.52 181.53V182.78Z"
        fill="#CECECE"
      />
      <path
        d="M600.52 185.31L599.26 185.16V183.88L600.52 184.03V185.31Z"
        fill="#CECECE"
      />
      <path
        d="M600.52 187.83L599.26 187.72V186.42L600.52 186.54V187.83Z"
        fill="#CECECE"
      />
      <path
        d="M600.52 190.36L599.26 190.29V188.96L600.52 189.04V190.36Z"
        fill="#CECECE"
      />
      <path
        d="M600.52 192.89L599.26 192.85V191.5L600.52 191.54V192.89Z"
        fill="#CECECE"
      />
      <path
        d="M602.25 137.68V138.46L603.04 138.99V138.23L602.25 137.68Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 141.44L602.24 140.93V140.13L603.04 140.65V141.44Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 143.9L602.24 143.41V142.58L603.04 143.08V143.9Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 146.35L602.24 145.89V145.03L603.04 145.51V146.35Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 148.8L602.24 148.36V147.48L603.04 147.93V148.8Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 151.26L602.24 150.84V149.93L603.04 150.36V151.26Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 156.16L602.23 155.79V154.83L603.04 155.21V156.16Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 158.62L602.23 158.27V157.28L603.04 157.64V158.62Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 161.07L602.23 160.74V159.73L603.04 160.07V161.07Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 163.52L602.23 163.22V162.18L603.04 162.49V163.52Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 165.98L602.23 165.7V164.64L603.04 164.92V165.98Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 168.43L602.22 168.17V167.09L603.04 167.35V168.43Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 173.34L602.22 173.13V171.99L603.04 172.2V173.34Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 175.79L602.22 175.6V174.44L603.04 174.63V175.79Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 180.7L602.21 180.56V179.34L603.04 179.48V180.7Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 183.15L602.21 183.03V181.79L603.04 181.91V183.15Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 185.6L602.21 185.51V184.24L603.04 184.34V185.6Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 190.51L602.21 190.46V189.14L603.04 189.19V190.51Z"
        fill="#CECECE"
      />
      <path
        d="M603.04 192.96L602.2 192.94V191.59L603.04 191.62V192.96Z"
        fill="#CECECE"
      />
      <path
        d="M603.2 138.33V139.09L603.93 139.59V138.84L603.2 138.33Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 142.01L603.2 141.54V140.75L603.93 141.24V142.01Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 144.44L603.2 143.99V143.18L603.93 143.64V144.44Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 146.87L603.19 146.44V145.6L603.93 146.04V146.87Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 149.29L603.19 148.89V148.02L603.93 148.44V149.29Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 151.72L603.19 151.34V150.44L603.93 150.84V151.72Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 154.15L603.19 153.79V152.86L603.93 153.24V154.15Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 156.58L603.19 156.23V155.29L603.93 155.64V156.58Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 159L603.19 158.68V157.71L603.93 158.04V159Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 161.43L603.19 161.13V160.13L603.93 160.44V161.43Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 163.86L603.19 163.58V162.55L603.93 162.84V163.86Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 166.29L603.19 166.03V164.98L603.93 165.24V166.29Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 168.71L603.19 168.48V167.4L603.93 167.64V168.71Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 171.14L603.19 170.93V169.82L603.93 170.04V171.14Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 176L603.19 175.82V174.67L603.93 174.84V176Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 178.42L603.19 178.27V177.09L603.93 177.24V178.42Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 180.85L603.19 180.72V179.51L603.93 179.64V180.85Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 185.71L603.18 185.62V184.35L603.93 184.44V185.71Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 188.13L603.18 188.07V186.78L603.93 186.84V188.13Z"
        fill="#CECECE"
      />
      <path
        d="M603.93 190.56L603.18 190.52V189.2L603.93 189.24V190.56Z"
        fill="#CECECE"
      />
      <path d="M603.93 194.04H603.18V195.41H603.93V194.04Z" fill="#CECECE" />
      <path
        d="M605.65 140.01V140.74L606.63 141.39V140.69L605.65 140.01Z"
        fill="#CECECE"
      />
      <path
        d="M606.62 143.74L605.65 143.11V142.36L606.62 143.01V143.74Z"
        fill="#CECECE"
      />
      <path
        d="M606.62 146.09L605.65 145.49V144.71L606.62 145.33V146.09Z"
        fill="#CECECE"
      />
      <path
        d="M606.62 150.79L605.65 150.24V149.41L606.62 149.97V150.79Z"
        fill="#CECECE"
      />
      <path
        d="M606.62 153.14L605.65 152.62V151.76L606.62 152.29V153.14Z"
        fill="#CECECE"
      />
      <path
        d="M606.62 155.49L605.65 155V154.11L606.62 154.61V155.49Z"
        fill="#CECECE"
      />
      <path
        d="M606.62 157.83L605.65 157.38V156.46L606.62 156.93V157.83Z"
        fill="#CECECE"
      />
      <path
        d="M606.61 160.18L605.65 159.75V158.81L606.61 159.25V160.18Z"
        fill="#CECECE"
      />
      <path
        d="M606.61 162.53L605.65 162.13V161.16L606.61 161.57V162.53Z"
        fill="#CECECE"
      />
      <path
        d="M606.61 164.88L605.65 164.51V163.5L606.61 163.89V164.88Z"
        fill="#CECECE"
      />
      <path
        d="M606.61 171.93L605.66 171.64V170.55L606.61 170.85V171.93Z"
        fill="#CECECE"
      />
      <path
        d="M606.61 174.28L605.66 174.02V172.9L606.61 173.17V174.28Z"
        fill="#CECECE"
      />
      <path
        d="M606.61 176.63L605.66 176.4V175.25L606.61 175.49V176.63Z"
        fill="#CECECE"
      />
      <path
        d="M606.6 178.97L605.66 178.77V177.6L606.6 177.8V178.97Z"
        fill="#CECECE"
      />
      <path
        d="M606.6 181.32L605.66 181.15V179.95L606.6 180.12V181.32Z"
        fill="#CECECE"
      />
      <path
        d="M606.6 186.02L605.66 185.91V184.65L606.6 184.76V186.02Z"
        fill="#CECECE"
      />
      <path
        d="M606.6 190.72L605.66 190.66V189.35L606.6 189.4V190.72Z"
        fill="#CECECE"
      />
      <path
        d="M606.6 193.07L605.66 193.04V191.69L606.6 191.72V193.07Z"
        fill="#CECECE"
      />
      <path d="M606.6 194.04H605.67V195.41H606.6V194.04Z" fill="#CECECE" />
      <path
        d="M606.78 140.79V141.5L607.57 142.03V141.34L606.78 140.79Z"
        fill="#CECECE"
      />
      <path
        d="M607.57 144.35L606.78 143.84V143.11L607.57 143.63V144.35Z"
        fill="#CECECE"
      />
      <path
        d="M607.57 146.67L606.78 146.18V145.42L607.57 145.92V146.67Z"
        fill="#CECECE"
      />
      <path
        d="M607.56 148.99L606.78 148.53V147.74L607.56 148.21V148.99Z"
        fill="#CECECE"
      />
      <path
        d="M607.56 151.31L606.78 150.87V150.05L607.56 150.51V151.31Z"
        fill="#CECECE"
      />
      <path
        d="M607.55 153.64L606.78 153.22V152.37L607.55 152.8V153.64Z"
        fill="#CECECE"
      />
      <path
        d="M607.55 155.96L606.78 155.56V154.68L607.55 155.09V155.96Z"
        fill="#CECECE"
      />
      <path
        d="M607.54 160.6L606.78 160.25V159.31L607.54 159.67V160.6Z"
        fill="#CECECE"
      />
      <path
        d="M607.54 162.92L606.78 162.59V161.63L607.54 161.96V162.92Z"
        fill="#CECECE"
      />
      <path
        d="M607.53 165.24L606.78 164.94V163.95L607.53 164.25V165.24Z"
        fill="#CECECE"
      />
      <path
        d="M607.53 167.56L606.78 167.28V166.26L607.53 166.55V167.56Z"
        fill="#CECECE"
      />
      <path
        d="M607.53 169.88L606.78 169.63V168.58L607.53 168.84V169.88Z"
        fill="#CECECE"
      />
      <path
        d="M607.52 172.2L606.78 171.97V170.89L607.52 171.13V172.2Z"
        fill="#CECECE"
      />
      <path
        d="M607.52 174.53L606.79 174.32V173.21L607.52 173.42V174.53Z"
        fill="#CECECE"
      />
      <path
        d="M607.52 176.85L606.79 176.66V175.52L607.52 175.71V176.85Z"
        fill="#CECECE"
      />
      <path
        d="M607.51 179.17L606.79 179V177.84L607.51 178V179.17Z"
        fill="#CECECE"
      />
      <path
        d="M607.51 181.49L606.79 181.35V180.15L607.51 180.29V181.49Z"
        fill="#CECECE"
      />
      <path
        d="M607.5 183.81L606.79 183.69V182.47L607.5 182.59V183.81Z"
        fill="#CECECE"
      />
      <path
        d="M607.5 186.13L606.79 186.04V184.78L607.5 184.88V186.13Z"
        fill="#CECECE"
      />
      <path
        d="M607.49 188.45L606.79 188.38V187.1L607.49 187.17V188.45Z"
        fill="#CECECE"
      />
      <path
        d="M607.49 193.09L606.79 193.07V191.73L607.49 191.75V193.09Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 135.24V135.99L595.99 135.76V134.96L594.71 135.24Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 138.58L595.99 138.35V137.53L594.71 137.79V138.58Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 141.16L595.99 140.95V140.1L594.71 140.35V141.16Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 143.75L595.99 143.54V142.67L594.71 142.91V143.75Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 146.33L595.99 146.13V145.24L594.71 145.46V146.33Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 148.91L595.99 148.73V147.81L594.71 148.02V148.91Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 151.5L595.99 151.32V150.37L594.71 150.58V151.5Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 154.08L595.98 153.92V152.94L594.71 153.13V154.08Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 156.66L595.98 156.51V155.51L594.71 155.69V156.66Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 159.25L595.98 159.1V158.08L594.71 158.25V159.25Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 161.83L595.98 161.7V160.65L594.71 160.81V161.83Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 164.41L595.98 164.29V163.22L594.71 163.36V164.41Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 169.58L595.98 169.48V168.36L594.71 168.48V169.58Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 172.16L595.98 172.07V170.92L594.71 171.03V172.16Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 177.33L595.98 177.26V176.06L594.71 176.15V177.33Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 179.91L595.97 179.85V178.63L594.71 178.7V179.91Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 182.5L595.97 182.45V181.2L594.71 181.26V182.5Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 187.66L595.97 187.63V186.34L594.71 186.37V187.66Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 190.25L595.97 190.23V188.91L594.71 188.93V190.25Z"
        fill="#CECECE"
      />
      <path
        d="M594.71 192.83L595.97 192.82V191.48L594.71 191.49V192.83Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 135.61V136.32L594.12 136.1V135.37L592.96 135.61Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 138.89L594.12 138.68V137.92L592.96 138.15V138.89Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 144.02L594.12 143.84V143.02L592.96 143.24V144.02Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 146.59L594.12 146.42V145.57L592.96 145.78V146.59Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 149.16L594.12 149V148.12L592.96 148.32V149.16Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 151.73L594.12 151.58V150.67L592.96 150.86V151.73Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 154.3L594.12 154.16V153.22L592.96 153.4V154.3Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 159.44L594.12 159.31V158.33L592.96 158.48V159.44Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 162.01L594.12 161.89V160.88L592.96 161.02V162.01Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 164.58L594.12 164.47V163.43L592.96 163.56V164.58Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 169.69L594.12 169.59V168.52L592.96 168.64V169.69Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 172.29L594.12 172.21V171.08L592.96 171.18V172.29Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 174.86L594.12 174.78V173.63L592.96 173.72V174.86Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 177.43L594.12 177.36V176.18L592.96 176.26V177.43Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 185.14L594.12 185.1V183.84L592.96 183.88V185.14Z"
        fill="#CECECE"
      />
      <path
        d="M592.96 187.71L594.12 187.68V186.39L592.96 186.42V187.71Z"
        fill="#CECECE"
      />
      <path
        d="M592.95 192.85L594.12 192.84V191.49L592.95 191.5V192.85Z"
        fill="#CECECE"
      />
      <path
        d="M591.53 135.92V136.58L592.44 136.41V135.73L591.53 135.92Z"
        fill="#CECECE"
      />
      <path
        d="M591.53 139.14L592.44 138.98V138.26L591.53 138.45V139.14Z"
        fill="#CECECE"
      />
      <path
        d="M591.53 144.25L592.44 144.11V143.33L591.53 143.5V144.25Z"
        fill="#CECECE"
      />
      <path
        d="M591.53 146.81L592.44 146.67V145.87L591.53 146.03V146.81Z"
        fill="#CECECE"
      />
      <path
        d="M591.52 149.37L592.43 149.24V148.4L591.52 148.56V149.37Z"
        fill="#CECECE"
      />
      <path
        d="M591.52 154.49L592.43 154.37V153.47L591.52 153.61V154.49Z"
        fill="#CECECE"
      />
      <path
        d="M591.52 159.6L592.43 159.5V158.55L591.52 158.67V159.6Z"
        fill="#CECECE"
      />
      <path
        d="M591.52 164.72L592.43 164.63V163.62L591.52 163.72V164.72Z"
        fill="#CECECE"
      />
      <path
        d="M591.52 169.83L592.43 169.76V168.69L591.52 168.77V169.83Z"
        fill="#CECECE"
      />
      <path
        d="M591.52 174.95L592.42 174.89V173.76L591.52 173.83V174.95Z"
        fill="#CECECE"
      />
      <path
        d="M591.52 177.51L592.42 177.46V176.3L591.52 176.35V177.51Z"
        fill="#CECECE"
      />
      <path
        d="M591.51 182.62L592.42 182.59V181.37L591.51 181.41V182.62Z"
        fill="#CECECE"
      />
      <path
        d="M591.51 185.18L592.42 185.15V183.9L591.51 183.94V185.18Z"
        fill="#CECECE"
      />
      <path
        d="M591.51 187.74L592.42 187.72V186.44L591.51 186.46V187.74Z"
        fill="#CECECE"
      />
      <path
        d="M589.91 136.27V136.88L591.01 136.67V136.03L589.91 136.27Z"
        fill="#CECECE"
      />
      <path
        d="M589.91 139.42L591.01 139.23V138.56L589.91 138.78V139.42Z"
        fill="#CECECE"
      />
      <path
        d="M589.91 141.97L591.01 141.78V141.08L589.91 141.29V141.97Z"
        fill="#CECECE"
      />
      <path
        d="M589.91 144.51L591.01 144.34V143.6L589.91 143.81V144.51Z"
        fill="#CECECE"
      />
      <path
        d="M589.9 147.06L591.01 146.89V146.12L589.9 146.32V147.06Z"
        fill="#CECECE"
      />
      <path
        d="M589.9 152.15L591.01 152V151.17L589.9 151.34V152.15Z"
        fill="#CECECE"
      />
      <path
        d="M589.9 154.69L591.01 154.55V153.69L589.9 153.85V154.69Z"
        fill="#CECECE"
      />
      <path
        d="M589.9 157.24L591.01 157.11V156.21L589.9 156.37V157.24Z"
        fill="#CECECE"
      />
      <path
        d="M589.89 162.33L591.01 162.21V161.26L589.89 161.39V162.33Z"
        fill="#CECECE"
      />
      <path
        d="M589.89 169.96L591.01 169.88V168.82L589.89 168.92V169.96Z"
        fill="#CECECE"
      />
      <path
        d="M589.89 172.51L591.01 172.43V171.34L589.89 171.44V172.51Z"
        fill="#CECECE"
      />
      <path
        d="M589.88 175.05L591.01 174.98V173.87L589.88 173.95V175.05Z"
        fill="#CECECE"
      />
      <path
        d="M589.88 177.6L591.01 177.54V176.39L589.88 176.46V177.6Z"
        fill="#CECECE"
      />
      <path
        d="M589.88 180.14L591.01 180.09V178.91L589.88 178.97V180.14Z"
        fill="#CECECE"
      />
      <path
        d="M589.88 185.23L591.01 185.2V183.95L589.88 184V185.23Z"
        fill="#CECECE"
      />
      <path
        d="M589.87 190.32L591.01 190.31V189L589.87 189.02V190.32Z"
        fill="#CECECE"
      />
      <path
        d="M589.87 192.87L591.01 192.86V191.52L589.87 191.53V192.87Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 136.58V137.27L589.45 137.07V136.34L588.31 136.58Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 139.8L589.45 139.6V138.85L588.31 139.08V139.8Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 142.33L589.45 142.14V141.36L588.31 141.58V142.33Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 144.85L589.45 144.67V143.86L588.31 144.08V144.85Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 147.38L589.45 147.21V146.37L588.31 146.57V147.38Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 152.43L589.45 152.28V151.39L588.31 151.57V152.43Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 154.96L589.45 154.81V153.9L588.31 154.07V154.96Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 157.48L589.45 157.35V156.4L588.31 156.56V157.48Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 160.01L589.45 159.88V158.91L588.31 159.06V160.01Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 162.53L589.45 162.42V161.42L588.31 161.56V162.53Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 165.06L589.45 164.95V163.93L588.31 164.06V165.06Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 172.64L589.45 172.56V171.45L588.31 171.55V172.64Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 175.16L589.45 175.09V173.96L588.31 174.04V175.16Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 177.69L589.45 177.63V176.47L588.31 176.54V177.69Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 185.27L589.45 185.23V183.99L588.31 184.03V185.27Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 187.79L589.45 187.77V186.5L588.31 186.53V187.79Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 192.85L589.45 192.84V191.52L588.31 191.53V192.85Z"
        fill="#CECECE"
      />
      <path
        d="M586.9 136.89V137.53L587.8 137.37V136.69L586.9 136.89Z"
        fill="#CECECE"
      />
      <path
        d="M586.9 140.05L587.8 139.89V139.19L586.9 139.37V140.05Z"
        fill="#CECECE"
      />
      <path
        d="M586.9 142.56L587.8 142.41V141.68L586.9 141.86V142.56Z"
        fill="#CECECE"
      />
      <path
        d="M586.9 145.08L587.8 144.93V144.17L586.9 144.34V145.08Z"
        fill="#CECECE"
      />
      <path
        d="M586.9 147.59L587.8 147.46V146.66L586.9 146.82V147.59Z"
        fill="#CECECE"
      />
      <path
        d="M586.9 150.11L587.79 149.98V149.16L586.9 149.31V150.11Z"
        fill="#CECECE"
      />
      <path
        d="M586.9 155.14L587.79 155.02V154.14L586.9 154.28V155.14Z"
        fill="#CECECE"
      />
      <path
        d="M586.9 157.65L587.79 157.54V156.63L586.9 156.76V157.65Z"
        fill="#CECECE"
      />
      <path
        d="M586.9 160.17L587.79 160.07V159.13L586.9 159.25V160.17Z"
        fill="#CECECE"
      />
      <path
        d="M586.89 165.19L587.79 165.11V164.11L586.89 164.21V165.19Z"
        fill="#CECECE"
      />
      <path
        d="M586.89 175.25L587.78 175.2V174.21L586.89 174.27V175.25Z"
        fill="#CECECE"
      />
      <path
        d="M586.89 177.77L587.78 177.72V176.58L586.89 176.63V177.77Z"
        fill="#CECECE"
      />
      <path
        d="M586.89 182.8L587.78 182.76V181.56L586.89 181.6V182.8Z"
        fill="#CECECE"
      />
      <path
        d="M586.89 185.31L587.78 185.28V184.05L586.89 184.09V185.31Z"
        fill="#CECECE"
      />
      <path
        d="M586.89 187.83L587.78 187.81V186.55L586.89 186.57V187.83Z"
        fill="#CECECE"
      />
      <path
        d="M585.31 137.23V137.83L586.39 137.63V137L585.31 137.23Z"
        fill="#CECECE"
      />
      <path
        d="M585.31 140.33L586.39 140.14V139.48L585.31 139.7V140.33Z"
        fill="#CECECE"
      />
      <path
        d="M585.31 142.83L586.39 142.65V141.96L585.31 142.17V142.83Z"
        fill="#CECECE"
      />
      <path
        d="M585.31 145.33L586.39 145.16V144.44L585.31 144.64V145.33Z"
        fill="#CECECE"
      />
      <path
        d="M585.31 147.83L586.39 147.67V146.91L585.31 147.11V147.83Z"
        fill="#CECECE"
      />
      <path
        d="M585.3 152.84L586.39 152.69V151.87L585.3 152.04V152.84Z"
        fill="#CECECE"
      />
      <path
        d="M585.3 155.34L586.39 155.2V154.35L585.3 154.51V155.34Z"
        fill="#CECECE"
      />
      <path
        d="M585.3 157.84L586.39 157.71V156.83L585.3 156.98V157.84Z"
        fill="#CECECE"
      />
      <path
        d="M585.3 162.85L586.39 162.73V161.79L585.3 161.92V162.85Z"
        fill="#CECECE"
      />
      <path
        d="M585.29 170.35L586.39 170.27V169.23L585.29 169.33V170.35Z"
        fill="#CECECE"
      />
      <path
        d="M585.29 172.85L586.39 172.78V171.71L585.29 171.8V172.85Z"
        fill="#CECECE"
      />
      <path
        d="M585.29 175.43L586.39 175.35V174.29L585.29 174.38V175.43Z"
        fill="#CECECE"
      />
      <path
        d="M585.28 190.37L586.39 190.35V189.06L585.28 189.08V190.37Z"
        fill="#CECECE"
      />
      <path
        d="M585.27 192.87L586.39 192.86V191.54L585.27 191.55V192.87Z"
        fill="#CECECE"
      />
      <path
        d="M583.28 173.18L584.4 173.1V172.01L583.28 172.11V173.18Z"
        fill="#CECECE"
      />
      <path
        d="M583.28 175.72L584.4 175.65V174.53L583.28 174.62V175.72Z"
        fill="#CECECE"
      />
      <path
        d="M583.27 178.27L584.4 178.21V177.06L583.27 177.13V178.27Z"
        fill="#CECECE"
      />
      <path
        d="M583.27 180.81L584.4 180.76V179.58L583.27 179.64V180.81Z"
        fill="#CECECE"
      />
      <path
        d="M581.7 173.31L582.84 173.22V172.12L581.7 172.22V173.31Z"
        fill="#CECECE"
      />
      <path
        d="M581.7 175.83L582.84 175.76V174.63L581.7 174.71V175.83Z"
        fill="#CECECE"
      />
      <path
        d="M578.47 185.94L579.61 185.9V184.66L578.47 184.7V185.94Z"
        fill="#CECECE"
      />
      <path
        d="M580.28 175.92L581.18 175.87V174.75L580.28 174.82V175.92Z"
        fill="#CECECE"
      />
      <path
        d="M577.06 183.47L577.95 183.43V182.23L577.06 182.27V183.47Z"
        fill="#CECECE"
      />
      <path
        d="M577.05 188.5L577.95 188.47V187.21L577.05 187.24V188.5Z"
        fill="#CECECE"
      />
      <path
        d="M578.68 176.02L579.78 175.95V174.86L578.68 174.94V176.02Z"
        fill="#CECECE"
      />
      <path
        d="M578.68 181.03L579.78 180.98V179.82L578.68 179.88V181.03Z"
        fill="#CECECE"
      />
      <path
        d="M575.44 191.04L576.56 191.02V189.73L575.44 189.75V191.04Z"
        fill="#CECECE"
      />
      <path
        d="M575.44 193.54L576.56 193.53V192.21L575.44 192.22V193.54Z"
        fill="#CECECE"
      />
      <path
        d="M577.31 176.24L578.2 176.18V175.07L577.31 175.13V176.24Z"
        fill="#CECECE"
      />
      <path
        d="M574.08 183.78L574.97 183.74V182.54L574.08 182.58V183.78Z"
        fill="#CECECE"
      />
      <path
        d="M574.08 186.3L574.97 186.27V185.04L574.08 185.07V186.3Z"
        fill="#CECECE"
      />
      <path
        d="M574.08 188.81L574.97 188.79V187.53L574.08 187.55V188.81Z"
        fill="#CECECE"
      />
      <path
        d="M574.08 193.66L574.97 193.64V192.38L574.08 192.4V193.66Z"
        fill="#CECECE"
      />
      <path
        d="M575.71 173.84L576.81 173.76V172.69L575.71 172.78V173.84Z"
        fill="#CECECE"
      />
      <path
        d="M575.7 176.34L576.81 176.27V175.17L575.7 175.25V176.34Z"
        fill="#CECECE"
      />
      <path
        d="M575.7 178.84L576.81 178.78V177.65L575.7 177.72V178.84Z"
        fill="#CECECE"
      />
      <path
        d="M575.7 181.34L576.81 181.29V180.13L575.7 180.19V181.34Z"
        fill="#CECECE"
      />
      <path
        d="M572.47 186.35L573.58 186.31V185.09L572.47 185.13V186.35Z"
        fill="#CECECE"
      />
      <path
        d="M572.46 193.85L573.58 193.84V192.53L572.46 192.54V193.85Z"
        fill="#CECECE"
      />
      <path
        d="M573.7 174.16L574.82 174.08V172.99L573.7 173.09V174.16Z"
        fill="#CECECE"
      />
      <path
        d="M573.69 176.7L574.82 176.63V175.52L573.69 175.6V176.7Z"
        fill="#CECECE"
      />
      <path
        d="M573.69 179.25L574.82 179.19V178.04L573.69 178.11V179.25Z"
        fill="#CECECE"
      />
      <path
        d="M573.69 181.79L574.82 181.74V180.56L573.69 180.62V181.79Z"
        fill="#CECECE"
      />
      <path
        d="M572.12 174.29L573.26 174.21V173.1L572.12 173.2V174.29Z"
        fill="#CECECE"
      />
      <path
        d="M572.12 176.81L573.26 176.74V175.61L572.12 175.69V176.81Z"
        fill="#CECECE"
      />
      <path
        d="M572.12 179.34L573.26 179.28V178.12L572.12 178.19V179.34Z"
        fill="#CECECE"
      />
      <path
        d="M589.88 197.25L591.01 197.2V196.02L589.88 196.08V197.25Z"
        fill="#CECECE"
      />
      <path
        d="M594.82 202.07L595.95 202.03V200.79L594.82 200.83V202.07Z"
        fill="#CECECE"
      />
      <path
        d="M593.25 202.1L594.39 202.07V200.83L593.25 200.87V202.1Z"
        fill="#CECECE"
      />
      <path
        d="M593.25 204.63L594.39 204.6V203.33L593.25 203.37V204.63Z"
        fill="#CECECE"
      />
      <path
        d="M591.85 211.39L592.99 211.38V210.06L591.85 210.07V211.39Z"
        fill="#CECECE"
      />
      <path
        d="M588.31 199.9L589.2 199.87V198.67L588.31 198.71V199.9Z"
        fill="#CECECE"
      />
      <path
        d="M591.83 202.15L592.72 202.12V200.89L591.83 200.92V202.15Z"
        fill="#CECECE"
      />
      <path
        d="M591.83 204.66L592.72 204.64V203.38L591.83 203.41V204.66Z"
        fill="#CECECE"
      />
      <path
        d="M597.17 208.66L598.37 208.63V207.31L597.17 207.35V208.66Z"
        fill="#CECECE"
      />
      <path
        d="M595.52 208.7L596.72 208.66V207.35L595.52 207.4V208.7Z"
        fill="#CECECE"
      />
      <path
        d="M595.52 211.37L596.72 211.34V210L595.52 210.03V211.37Z"
        fill="#CECECE"
      />
      <path
        d="M594.02 208.75L594.96 208.72V207.42L594.02 207.45V208.75Z"
        fill="#CECECE"
      />
      <path
        d="M594.02 211.4L594.96 211.38V210.05L594.02 210.08V211.4Z"
        fill="#CECECE"
      />
      <path
        d="M578.48 193.38L579.61 193.31V192.17L578.48 192.24V193.38Z"
        fill="#CECECE"
      />
      <path
        d="M578.48 195.92L579.61 195.87V194.69L578.48 194.75V195.92Z"
        fill="#CECECE"
      />
      <path
        d="M577.05 202.89L577.95 202.87V201.61L577.05 201.64V202.89Z"
        fill="#CECECE"
      />
      <path
        d="M575.45 198.13L576.56 198.08V196.92L575.45 196.98V198.13Z"
        fill="#CECECE"
      />
      <path
        d="M572.47 205.43L573.59 205.42V204.13L572.47 204.15V205.43Z"
        fill="#CECECE"
      />
      <path
        d="M572.47 207.93H573.59V206.61L572.47 206.62V207.93Z"
        fill="#CECECE"
      />
      <path
        d="M574.08 195.86L574.98 195.81V194.66L574.08 194.72V195.86Z"
        fill="#CECECE"
      />
      <path
        d="M574.08 200.69L574.97 200.66V199.43L574.08 199.47V200.69Z"
        fill="#CECECE"
      />
      <path
        d="M574.08 203.21L574.97 203.18V201.92L574.08 201.95V203.21Z"
        fill="#CECECE"
      />
      <path
        d="M572.47 200.74L573.58 200.71V199.48L572.47 199.52V200.74Z"
        fill="#CECECE"
      />
      <path
        d="M575.44 210.07L576.56 210.05V208.77L575.44 208.79V210.07Z"
        fill="#CECECE"
      />
      <path
        d="M575.44 212.57L576.56 212.56V211.25L575.44 211.26V212.57Z"
        fill="#CECECE"
      />
      <path
        d="M574.08 207.84L574.97 207.82V206.56L574.08 206.59V207.84Z"
        fill="#CECECE"
      />
      <path
        d="M572.46 212.89L573.58 212.88V211.56L572.46 211.57V212.89Z"
        fill="#CECECE"
      />
      <path
        d="M574.08 214.89L574.98 214.84V213.7L574.08 213.76V214.89Z"
        fill="#CECECE"
      />
      <path
        d="M572.47 219.78L573.58 219.74V218.52L572.47 218.56V219.78Z"
        fill="#CECECE"
      />
      <path
        d="M600.74 195.41H602V137.45L600.74 136.58V195.41Z"
        fill="#CECECE"
      />
      <path
        d="M604.15 195.41H605.41V139.82L604.15 138.95V195.41Z"
        fill="#CECECE"
      />
      <path
        d="M607.82 195.41H608.18V141.75L607.82 141.5V195.41Z"
        fill="#CECECE"
      />
      <path
        d="M608.29 195.41H608.65V142.08L608.29 141.83V195.41Z"
        fill="#CECECE"
      />
      <path
        d="M756.57 167.03V167.55L757.29 167.42V166.88L756.57 167.03Z"
        fill="#CECECE"
      />
      <path
        d="M757.29 169.09L756.57 169.21V168.68L757.29 168.53V169.09Z"
        fill="#CECECE"
      />
      <path
        d="M757.29 170.75L756.57 170.87V170.32L757.29 170.18V170.75Z"
        fill="#CECECE"
      />
      <path
        d="M757.29 172.42L756.57 172.53V171.97L757.29 171.83V172.42Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 174.08L756.57 174.19V173.61L757.3 173.48V174.08Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 175.75L756.57 175.85V175.25L757.3 175.13V175.75Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 177.41L756.56 177.51V176.9L757.3 176.78V177.41Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 179.08L756.56 179.17V178.54L757.3 178.44V179.08Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 180.75L756.56 180.83V180.19L757.3 180.09V180.75Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 182.41L756.56 182.49V181.83L757.3 181.74V182.41Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 184.08L756.56 184.15V183.48L757.3 183.39V184.08Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 185.74L756.56 185.81V185.12L757.3 185.04V185.74Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 187.41L756.56 187.47V186.77L757.3 186.69V187.41Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 189.08L756.56 189.13V188.41L757.3 188.34V189.08Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 190.74L756.56 190.79V190.06L757.3 189.99V190.74Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 192.41L756.56 192.45V191.7L757.3 191.65V192.41Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 194.07L756.56 194.11V193.34L757.3 193.3V194.07Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 195.74L756.55 195.77V194.99L757.3 194.95V195.74Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 197.4L756.55 197.43V196.63L757.3 196.6V197.4Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 199.07L756.55 199.09V198.28L757.3 198.25V199.07Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 200.74L756.55 200.75V199.92L757.3 199.9V200.74Z"
        fill="#CECECE"
      />
      <path
        d="M757.3 202.4L756.55 202.41V201.57L757.3 201.56V202.4Z"
        fill="#CECECE"
      />
      <path d="M757.3 204.86H756.55V205.74H757.3V204.86Z" fill="#CECECE" />
      <path
        d="M757.29 166.88V167.42L758.15 168V167.47L757.29 166.88Z"
        fill="#CECECE"
      />
      <path
        d="M758.15 169.64L757.29 169.09V168.53L758.15 169.09V169.64Z"
        fill="#CECECE"
      />
      <path
        d="M758.15 171.28L757.29 170.75V170.18L758.15 170.72V171.28Z"
        fill="#CECECE"
      />
      <path
        d="M758.15 172.92L757.29 172.42V171.83L758.15 172.34V172.92Z"
        fill="#CECECE"
      />
      <path
        d="M758.15 174.56L757.3 174.08V173.48L758.15 173.97V174.56Z"
        fill="#CECECE"
      />
      <path
        d="M758.15 176.2L757.3 175.75V175.13L758.15 175.6V176.2Z"
        fill="#CECECE"
      />
      <path
        d="M758.15 177.84L757.3 177.41V176.78L758.15 177.22V177.84Z"
        fill="#CECECE"
      />
      <path
        d="M758.14 179.48L757.3 179.08V178.44L758.14 178.85V179.48Z"
        fill="#CECECE"
      />
      <path
        d="M758.14 181.12L757.3 180.75V180.09L758.14 180.47V181.12Z"
        fill="#CECECE"
      />
      <path
        d="M758.14 182.76L757.3 182.41V181.74L758.14 182.1V182.76Z"
        fill="#CECECE"
      />
      <path
        d="M758.14 186.05L757.3 185.74V185.04L758.14 185.35V186.05Z"
        fill="#CECECE"
      />
      <path
        d="M758.14 187.69L757.3 187.41V186.69L758.14 186.98V187.69Z"
        fill="#CECECE"
      />
      <path
        d="M758.14 189.33L757.3 189.08V188.34L758.14 188.6V189.33Z"
        fill="#CECECE"
      />
      <path
        d="M758.14 192.61L757.3 192.41V191.65L758.14 191.85V192.61Z"
        fill="#CECECE"
      />
      <path
        d="M758.13 194.25L757.3 194.07V193.3L758.13 193.48V194.25Z"
        fill="#CECECE"
      />
      <path
        d="M758.13 197.53L757.3 197.4V196.6L758.13 196.73V197.53Z"
        fill="#CECECE"
      />
      <path
        d="M758.13 200.81L757.3 200.74V199.9L758.13 199.98V200.81Z"
        fill="#CECECE"
      />
      <path
        d="M758.25 167.53V168.06L759.05 168.6V168.09L758.25 167.53Z"
        fill="#CECECE"
      />
      <path
        d="M759.05 170.22L758.25 169.7V169.16L759.05 169.68V170.22Z"
        fill="#CECECE"
      />
      <path
        d="M759.05 171.83L758.25 171.34V170.78L759.05 171.28V171.83Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 173.44L758.25 172.98V172.4L759.06 172.88V173.44Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 175.06L758.25 174.61V174.03L759.06 174.48V175.06Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 176.67L758.25 176.25V175.65L759.06 176.08V176.67Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 178.29L758.25 177.89V177.27L759.06 177.68V178.29Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 179.9L758.26 179.53V178.89L759.06 179.28V179.9Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 181.52L758.26 181.17V180.52L759.06 180.88V181.52Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 183.13L758.26 182.8V182.14L759.06 182.47V183.13Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 184.75L758.26 184.44V183.76L759.06 184.07V184.75Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 186.36L758.26 186.08V185.38L759.06 185.67V186.36Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 187.97L758.26 187.72V187.01L759.06 187.27V187.97Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 189.59L758.26 189.36V188.63L759.06 188.87V189.59Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 191.2L758.26 190.99V190.25L759.06 190.47V191.2Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 192.82L758.26 192.63V191.88L759.06 192.07V192.82Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 194.43L758.26 194.27V193.5L759.06 193.67V194.43Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 196.05L758.26 195.91V195.12L759.06 195.26V196.05Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 197.66L758.26 197.54V196.74L759.06 196.86V197.66Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 199.28L758.26 199.18V198.37L759.06 198.46V199.28Z"
        fill="#CECECE"
      />
      <path
        d="M759.06 200.89L758.26 200.82V199.99L759.06 200.06V200.89Z"
        fill="#CECECE"
      />
      <path
        d="M759.07 202.5L758.26 202.46V201.61L759.07 201.66V202.5Z"
        fill="#CECECE"
      />
      <path
        d="M759.07 204.12L758.26 204.1V203.23L759.07 203.26V204.12Z"
        fill="#CECECE"
      />
      <path
        d="M760.17 168.85V169.35L760.68 169.69V169.2L760.17 168.85Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 171.26L760.17 170.93V170.42L760.68 170.75V171.26Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 172.82L760.17 172.51V171.98L760.68 172.3V172.82Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 174.39L760.17 174.09V173.55L760.68 173.85V174.39Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 175.96L760.16 175.68V175.11L760.68 175.4V175.96Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 177.53L760.16 177.26V176.68L760.68 176.95V177.53Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 180.66L760.16 180.42V179.81L760.68 180.05V180.66Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 182.23L760.16 182V181.38L760.68 181.6V182.23Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 183.79L760.16 183.59V182.94L760.68 183.15V183.79Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 185.36L760.16 185.17V184.51L760.68 184.7V185.36Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 186.93L760.15 186.75V186.07L760.68 186.25V186.93Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 188.5L760.15 188.33V187.64L760.68 187.8V188.5Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 191.63L760.15 191.5V190.77L760.68 190.9V191.63Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 193.2L760.15 193.08V192.33L760.68 192.46V193.2Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 196.33L760.15 196.24V195.46L760.68 195.56V196.33Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 197.9L760.15 197.82V197.03L760.68 197.11V197.9Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 199.47L760.15 199.41V198.6L760.68 198.66V199.47Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 202.6L760.14 202.57V201.73L760.68 201.76V202.6Z"
        fill="#CECECE"
      />
      <path
        d="M760.68 204.17L760.14 204.15V203.29L760.68 203.31V204.17Z"
        fill="#CECECE"
      />
      <path
        d="M760.78 169.27V169.76L761.24 170.07V169.59L760.78 169.27Z"
        fill="#CECECE"
      />
      <path
        d="M761.24 171.62L760.78 171.32V170.82L761.24 171.12V171.62Z"
        fill="#CECECE"
      />
      <path
        d="M761.24 173.17L760.77 172.88V172.36L761.24 172.66V173.17Z"
        fill="#CECECE"
      />
      <path
        d="M761.24 174.72L760.77 174.45V173.91L761.24 174.19V174.72Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 176.27L760.77 176.01V175.46L761.25 175.72V176.27Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 177.82L760.77 177.58V177.01L761.25 177.26V177.82Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 179.37L760.77 179.14V178.55L761.25 178.79V179.37Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 180.92L760.77 180.71V180.1L761.25 180.32V180.92Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 182.47L760.77 182.27V181.65L761.25 181.86V182.47Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 184.03L760.77 183.83V183.19L761.25 183.39V184.03Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 185.58L760.77 185.4V184.74L761.25 184.92V185.58Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 187.13L760.77 186.96V186.29L761.25 186.46V187.13Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 188.68L760.77 188.53V187.84L761.25 187.99V188.68Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 190.23L760.77 190.09V189.38L761.25 189.52V190.23Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 193.33L760.77 193.22V192.48L761.25 192.59V193.33Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 194.88L760.77 194.78V194.03L761.25 194.12V194.88Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 196.43L760.77 196.35V195.57L761.25 195.66V196.43Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 199.53L760.77 199.48V198.67L761.25 198.72V199.53Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 201.08L760.77 201.04V200.22L761.25 200.26V201.08Z"
        fill="#CECECE"
      />
      <path
        d="M761.25 202.63L760.77 202.61V201.76L761.25 201.79V202.63Z"
        fill="#CECECE"
      />
      <path d="M761.25 204.86H760.77V205.74H761.25V204.86Z" fill="#CECECE" />
      <path
        d="M762.34 170.34V170.8L762.97 171.22V170.77L762.34 170.34Z"
        fill="#CECECE"
      />
      <path
        d="M762.97 172.73L762.34 172.32V171.84L762.97 172.26V172.73Z"
        fill="#CECECE"
      />
      <path
        d="M762.96 174.23L762.34 173.84V173.34L762.96 173.74V174.23Z"
        fill="#CECECE"
      />
      <path
        d="M762.96 177.23L762.34 176.88V176.35L762.96 176.7V177.23Z"
        fill="#CECECE"
      />
      <path
        d="M762.96 178.73L762.34 178.4V177.85L762.96 178.18V178.73Z"
        fill="#CECECE"
      />
      <path
        d="M762.96 180.23L762.34 179.92V179.35L762.96 179.67V180.23Z"
        fill="#CECECE"
      />
      <path
        d="M762.96 181.73L762.34 181.43V180.85L762.96 181.15V181.73Z"
        fill="#CECECE"
      />
      <path
        d="M762.96 183.23L762.34 182.95V182.35L762.96 182.63V183.23Z"
        fill="#CECECE"
      />
      <path
        d="M762.96 184.73L762.34 184.47V183.85L762.96 184.11V184.73Z"
        fill="#CECECE"
      />
      <path
        d="M762.96 186.23L762.35 185.99V185.35L762.96 185.59V186.23Z"
        fill="#CECECE"
      />
      <path
        d="M762.95 190.73L762.35 190.55V189.85L762.95 190.04V190.73Z"
        fill="#CECECE"
      />
      <path
        d="M762.95 192.23L762.35 192.07V191.35L762.95 191.52V192.23Z"
        fill="#CECECE"
      />
      <path
        d="M762.95 193.73L762.35 193.58V192.85L762.95 193V193.73Z"
        fill="#CECECE"
      />
      <path
        d="M762.95 195.23L762.35 195.1V194.35L762.95 194.48V195.23Z"
        fill="#CECECE"
      />
      <path
        d="M762.95 196.73L762.35 196.62V195.85L762.95 195.97V196.73Z"
        fill="#CECECE"
      />
      <path
        d="M762.95 199.73L762.35 199.66V198.85L762.95 198.93V199.73Z"
        fill="#CECECE"
      />
      <path
        d="M762.95 202.73L762.35 202.7V201.86L762.95 201.89V202.73Z"
        fill="#CECECE"
      />
      <path
        d="M762.95 204.23L762.35 204.21V203.36L762.95 203.38V204.23Z"
        fill="#CECECE"
      />
      <path d="M762.94 204.86H762.35V205.74H762.94V204.86Z" fill="#CECECE" />
      <path
        d="M763.06 170.84V171.29L763.57 171.63V171.19L763.06 170.84Z"
        fill="#CECECE"
      />
      <path
        d="M763.57 173.11L763.06 172.79V172.32L763.57 172.65V173.11Z"
        fill="#CECECE"
      />
      <path
        d="M763.57 174.6L763.06 174.28V173.8L763.57 174.12V174.6Z"
        fill="#CECECE"
      />
      <path
        d="M763.56 176.08L763.07 175.78V175.28L763.56 175.58V176.08Z"
        fill="#CECECE"
      />
      <path
        d="M763.56 177.56L763.07 177.28V176.76L763.56 177.05V177.56Z"
        fill="#CECECE"
      />
      <path
        d="M763.56 179.04L763.07 178.78V178.24L763.56 178.51V179.04Z"
        fill="#CECECE"
      />
      <path
        d="M763.56 180.53L763.07 180.28V179.72L763.56 179.97V180.53Z"
        fill="#CECECE"
      />
      <path
        d="M763.55 183.49L763.07 183.27V182.67L763.55 182.9V183.49Z"
        fill="#CECECE"
      />
      <path
        d="M763.55 184.98L763.07 184.77V184.15L763.55 184.36V184.98Z"
        fill="#CECECE"
      />
      <path
        d="M763.55 186.46L763.07 186.27V185.63L763.55 185.83V186.46Z"
        fill="#CECECE"
      />
      <path
        d="M763.54 187.94L763.07 187.76V187.11L763.54 187.29V187.94Z"
        fill="#CECECE"
      />
      <path
        d="M763.54 189.42L763.07 189.26V188.59L763.54 188.76V189.42Z"
        fill="#CECECE"
      />
      <path
        d="M763.54 190.91L763.07 190.76V190.07L763.54 190.22V190.91Z"
        fill="#CECECE"
      />
      <path
        d="M763.54 192.39L763.07 192.26V191.55L763.54 191.68V192.39Z"
        fill="#CECECE"
      />
      <path
        d="M763.53 193.87L763.07 193.75V193.03L763.53 193.15V193.87Z"
        fill="#CECECE"
      />
      <path
        d="M763.53 195.35L763.07 195.25V194.5L763.53 194.61V195.35Z"
        fill="#CECECE"
      />
      <path
        d="M763.53 196.84L763.07 196.75V195.98L763.53 196.07V196.84Z"
        fill="#CECECE"
      />
      <path
        d="M763.53 198.32L763.07 198.25V197.46L763.53 197.54V198.32Z"
        fill="#CECECE"
      />
      <path
        d="M763.52 199.8L763.07 199.74V198.94L763.52 199V199.8Z"
        fill="#CECECE"
      />
      <path
        d="M763.52 201.29L763.07 201.24V200.42L763.52 200.47V201.29Z"
        fill="#CECECE"
      />
      <path
        d="M763.52 204.25L763.07 204.24V203.38L763.52 203.39V204.25Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 167.29V167.78L756.17 167.63V167.12L755.36 167.29Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 169.43L756.17 169.28V168.76L755.36 168.93V169.43Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 171.08L756.17 170.94V170.4L755.36 170.56V171.08Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 172.73L756.17 172.6V172.04L755.36 172.19V172.73Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 174.38L756.17 174.25V173.68L755.36 173.83V174.38Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 176.03L756.17 175.91V175.32L755.36 175.46V176.03Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 177.68L756.17 177.57V176.96L755.36 177.09V177.68Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 179.33L756.17 179.22V178.6L755.36 178.73V179.33Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 180.98L756.17 180.88V180.24L755.36 180.36V180.98Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 182.63L756.17 182.54V181.88L755.36 181.99V182.63Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 184.28L756.17 184.19V183.53L755.36 183.62V184.28Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 185.93L756.17 185.85V185.17L755.36 185.26V185.93Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 187.58L756.17 187.51V186.81L755.36 186.89V187.58Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 189.23L756.16 189.17V188.45L755.36 188.52V189.23Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 190.88L756.16 190.82V190.09L755.36 190.16V190.88Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 194.18L756.16 194.14V193.37L755.36 193.42V194.18Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 195.83L756.16 195.79V195.01L755.36 195.06V195.83Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 197.48L756.16 197.45V196.65L755.36 196.69V197.48Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 200.78L756.16 200.76V199.93L755.36 199.96V200.78Z"
        fill="#CECECE"
      />
      <path
        d="M755.36 202.43L756.16 202.42V201.58L755.36 201.59V202.43Z"
        fill="#CECECE"
      />
      <path d="M755.36 204.08H756.16V203.22H755.36V204.08Z" fill="#CECECE" />
      <path
        d="M754.24 167.53V167.98L754.97 167.85V167.37L754.24 167.53Z"
        fill="#CECECE"
      />
      <path
        d="M754.24 169.62L754.97 169.49V169L754.24 169.16V169.62Z"
        fill="#CECECE"
      />
      <path
        d="M754.24 171.26L754.97 171.14V170.63L754.24 170.78V171.26Z"
        fill="#CECECE"
      />
      <path
        d="M754.24 172.91L754.97 172.79V172.26L754.24 172.4V172.91Z"
        fill="#CECECE"
      />
      <path
        d="M754.24 174.55L754.97 174.44V173.89L754.24 174.02V174.55Z"
        fill="#CECECE"
      />
      <path
        d="M754.24 176.19L754.97 176.08V175.52L754.24 175.65V176.19Z"
        fill="#CECECE"
      />
      <path
        d="M754.24 177.83L754.97 177.73V177.15L754.24 177.27V177.83Z"
        fill="#CECECE"
      />
      <path
        d="M754.24 179.47L754.97 179.38V178.78L754.24 178.89V179.47Z"
        fill="#CECECE"
      />
      <path
        d="M754.24 181.11L754.97 181.02V180.41L754.24 180.52V181.11Z"
        fill="#CECECE"
      />
      <path
        d="M754.24 182.75L754.97 182.67V182.04L754.24 182.14V182.75Z"
        fill="#CECECE"
      />
      <path
        d="M754.24 184.4L754.97 184.32V183.67L754.24 183.76V184.4Z"
        fill="#CECECE"
      />
      <path
        d="M754.24 186.04L754.97 185.97V185.3L754.24 185.38V186.04Z"
        fill="#CECECE"
      />
      <path
        d="M754.23 187.68L754.97 187.61V186.93L754.23 187.01V187.68Z"
        fill="#CECECE"
      />
      <path
        d="M754.23 190.96L754.97 190.91V190.19L754.23 190.25V190.96Z"
        fill="#CECECE"
      />
      <path
        d="M754.23 192.6L754.97 192.56V191.82L754.23 191.87V192.6Z"
        fill="#CECECE"
      />
      <path
        d="M754.23 194.24L754.97 194.2V193.45L754.23 193.5V194.24Z"
        fill="#CECECE"
      />
      <path
        d="M754.23 199.17L754.97 199.14V198.34L754.23 198.37V199.17Z"
        fill="#CECECE"
      />
      <path
        d="M754.23 200.81L754.97 200.79V199.97L754.23 199.99V200.81Z"
        fill="#CECECE"
      />
      <path d="M754.23 204.09H754.97V203.23H754.23V204.09Z" fill="#CECECE" />
      <path
        d="M754.97 205.77L754.23 205.75V204.94L754.97 204.97V205.77Z"
        fill="#CECECE"
      />
      <path
        d="M753.97 205.77L753.23 205.75V204.94L753.97 204.97V205.77Z"
        fill="#CECECE"
      />
      <path
        d="M754.97 207.23L754.23 207.21V206.39L754.97 206.41V207.23Z"
        fill="#CECECE"
      />
      <path
        d="M754.97 210.27L754.23 210.26V209.4L754.97 209.41V210.27Z"
        fill="#CECECE"
      />
      <path
        d="M753.32 167.73V168.15L753.9 168.04V167.61L753.32 167.73Z"
        fill="#CECECE"
      />
      <path
        d="M753.32 169.78L753.9 169.68V169.22L753.32 169.34V169.78Z"
        fill="#CECECE"
      />
      <path
        d="M753.32 171.42L753.9 171.32V170.84L753.32 170.96V171.42Z"
        fill="#CECECE"
      />
      <path
        d="M753.32 173.05L753.9 172.96V172.46L753.32 172.57V173.05Z"
        fill="#CECECE"
      />
      <path
        d="M753.32 174.69L753.9 174.6V174.08L753.32 174.19V174.69Z"
        fill="#CECECE"
      />
      <path
        d="M753.32 176.32L753.9 176.24V175.7L753.32 175.8V176.32Z"
        fill="#CECECE"
      />
      <path
        d="M753.32 179.59L753.9 179.51V178.94L753.32 179.03V179.59Z"
        fill="#CECECE"
      />
      <path
        d="M753.32 181.22L753.9 181.15V180.56L753.32 180.64V181.22Z"
        fill="#CECECE"
      />
      <path
        d="M753.32 182.86L753.9 182.79V182.18L753.32 182.26V182.86Z"
        fill="#CECECE"
      />
      <path
        d="M753.32 186.12L753.9 186.07V185.42L753.32 185.49V186.12Z"
        fill="#CECECE"
      />
      <path
        d="M753.32 187.76L753.9 187.71V187.04L753.32 187.1V187.76Z"
        fill="#CECECE"
      />
      <path
        d="M753.32 189.39L753.9 189.35V188.66L753.32 188.72V189.39Z"
        fill="#CECECE"
      />
      <path
        d="M753.31 192.66L753.89 192.62V191.9L753.31 191.94V192.66Z"
        fill="#CECECE"
      />
      <path
        d="M753.31 194.29L753.89 194.26V193.52L753.31 193.56V194.29Z"
        fill="#CECECE"
      />
      <path
        d="M753.31 197.56L753.89 197.54V196.76L753.31 196.79V197.56Z"
        fill="#CECECE"
      />
      <path
        d="M753.31 199.2L753.89 199.18V198.38L753.31 198.4V199.2Z"
        fill="#CECECE"
      />
      <path
        d="M753.31 200.83L753.89 200.82V200L753.31 200.01V200.83Z"
        fill="#CECECE"
      />
      <path
        d="M752.29 167.95V168.34L752.99 168.21V167.8L752.29 167.95Z"
        fill="#CECECE"
      />
      <path
        d="M752.29 169.97L752.99 169.84V169.41L752.29 169.56V169.97Z"
        fill="#CECECE"
      />
      <path
        d="M752.29 171.59L752.99 171.47V171.02L752.29 171.16V171.59Z"
        fill="#CECECE"
      />
      <path
        d="M752.29 173.22L752.99 173.1V172.64L752.29 172.77V173.22Z"
        fill="#CECECE"
      />
      <path
        d="M752.28 174.84L752.99 174.74V174.25L752.28 174.37V174.84Z"
        fill="#CECECE"
      />
      <path
        d="M752.28 178.09L752.99 178V177.47L752.28 177.58V178.09Z"
        fill="#CECECE"
      />
      <path
        d="M752.28 179.72L752.99 179.63V179.08L752.28 179.18V179.72Z"
        fill="#CECECE"
      />
      <path
        d="M752.28 181.35L752.99 181.26V180.69L752.28 180.79V181.35Z"
        fill="#CECECE"
      />
      <path
        d="M752.28 184.6L752.99 184.53V183.91L752.28 184V184.6Z"
        fill="#CECECE"
      />
      <path
        d="M752.27 187.85L752.99 187.79V187.13L752.27 187.21V187.85Z"
        fill="#CECECE"
      />
      <path
        d="M752.27 189.48L752.99 189.42V188.75L752.27 188.81V189.48Z"
        fill="#CECECE"
      />
      <path
        d="M752.27 191.1L752.99 191.05V190.36L752.27 190.42V191.1Z"
        fill="#CECECE"
      />
      <path
        d="M752.27 192.73L752.99 192.68V191.97L752.27 192.02V192.73Z"
        fill="#CECECE"
      />
      <path
        d="M752.27 194.35L752.99 194.31V193.58L752.27 193.63V194.35Z"
        fill="#CECECE"
      />
      <path
        d="M752.27 195.98L752.99 195.94V195.19L752.27 195.23V195.98Z"
        fill="#CECECE"
      />
      <path
        d="M752.27 199.23L752.99 199.21V198.41L752.27 198.44V199.23Z"
        fill="#CECECE"
      />
      <path
        d="M752.26 202.48L752.99 202.47V201.63L752.26 201.65V202.48Z"
        fill="#CECECE"
      />
      <path
        d="M752.26 204.11L752.99 204.1V203.25H752.26V204.11Z"
        fill="#CECECE"
      />
      <path
        d="M759.21 205.73H760.01V168.71L759.21 168.15V205.73Z"
        fill="#CECECE"
      />
      <path
        d="M761.38 205.73H762.19V170.22L761.38 169.66V205.73Z"
        fill="#CECECE"
      />
      <path
        d="M763.73 205.73H763.96V171.45L763.73 171.29V205.73Z"
        fill="#CECECE"
      />
      <path
        d="M764.03 205.73H764.26V171.66L764.03 171.5V205.73Z"
        fill="#CECECE"
      />
      <path
        d="M741.41 159.31V159.98L742.34 159.8V159.11L741.41 159.31Z"
        fill="#CECECE"
      />
      <path
        d="M742.34 161.94L741.41 162.1V161.42L742.34 161.22V161.94Z"
        fill="#CECECE"
      />
      <path
        d="M742.34 164.08L741.41 164.23V163.52L742.34 163.34V164.08Z"
        fill="#CECECE"
      />
      <path
        d="M742.34 166.21L741.41 166.36V165.63L742.34 165.46V166.21Z"
        fill="#CECECE"
      />
      <path
        d="M742.34 168.35L741.41 168.49V167.74L742.34 167.58V168.35Z"
        fill="#CECECE"
      />
      <path
        d="M742.34 170.49L741.41 170.62V169.85L742.34 169.7V170.49Z"
        fill="#CECECE"
      />
      <path
        d="M742.34 172.62L741.41 172.75V171.96L742.34 171.81V172.62Z"
        fill="#CECECE"
      />
      <path
        d="M742.35 174.76L741.41 174.88V174.07L742.35 173.93V174.76Z"
        fill="#CECECE"
      />
      <path
        d="M742.35 176.9L741.41 177.01V176.18L742.35 176.05V176.9Z"
        fill="#CECECE"
      />
      <path
        d="M742.35 179.03L741.4 179.14V178.29L742.35 178.17V179.03Z"
        fill="#CECECE"
      />
      <path
        d="M742.35 181.17L741.4 181.27V180.4L742.35 180.29V181.17Z"
        fill="#CECECE"
      />
      <path
        d="M742.35 183.31L741.4 183.4V182.51L742.35 182.4V183.31Z"
        fill="#CECECE"
      />
      <path
        d="M742.35 185.44L741.4 185.52V184.62L742.35 184.52V185.44Z"
        fill="#CECECE"
      />
      <path
        d="M742.35 187.58L741.4 187.65V186.73L742.35 186.64V187.58Z"
        fill="#CECECE"
      />
      <path
        d="M742.35 189.72L741.4 189.78V188.84L742.35 188.76V189.72Z"
        fill="#CECECE"
      />
      <path
        d="M742.35 191.85L741.4 191.91V190.95L742.35 190.88V191.85Z"
        fill="#CECECE"
      />
      <path
        d="M742.35 193.99L741.4 194.04V193.06L742.35 192.99V193.99Z"
        fill="#CECECE"
      />
      <path
        d="M742.35 196.13L741.39 196.17V195.16L742.35 195.11V196.13Z"
        fill="#CECECE"
      />
      <path
        d="M742.35 198.26L741.39 198.3V197.27L742.35 197.23V198.26Z"
        fill="#CECECE"
      />
      <path
        d="M742.35 200.4L741.39 200.43V199.38L742.35 199.35V200.4Z"
        fill="#CECECE"
      />
      <path
        d="M742.35 202.53L741.39 202.56V201.49L742.35 201.47V202.53Z"
        fill="#CECECE"
      />
      <path
        d="M742.35 204.67L741.39 204.69V203.6L742.35 203.58V204.67Z"
        fill="#CECECE"
      />
      <path d="M742.36 207.82H741.39V208.94H742.36V207.82Z" fill="#CECECE" />
      <path
        d="M742.34 159.11V159.8L743.44 160.54V159.86L742.34 159.11Z"
        fill="#CECECE"
      />
      <path
        d="M743.44 162.65L742.34 161.94V161.22L743.44 161.95V162.65Z"
        fill="#CECECE"
      />
      <path
        d="M743.44 164.75L742.34 164.08V163.34L743.44 164.03V164.75Z"
        fill="#CECECE"
      />
      <path
        d="M743.44 166.86L742.34 166.21V165.46L743.44 166.12V166.86Z"
        fill="#CECECE"
      />
      <path
        d="M743.44 168.96L742.34 168.35V167.58L743.44 168.2V168.96Z"
        fill="#CECECE"
      />
      <path
        d="M743.44 171.07L742.34 170.49V169.7L743.44 170.29V171.07Z"
        fill="#CECECE"
      />
      <path
        d="M743.44 173.17L742.34 172.62V171.81L743.44 172.38V173.17Z"
        fill="#CECECE"
      />
      <path
        d="M743.43 175.27L742.35 174.76V173.93L743.43 174.46V175.27Z"
        fill="#CECECE"
      />
      <path
        d="M743.43 177.38L742.35 176.9V176.05L743.43 176.55V177.38Z"
        fill="#CECECE"
      />
      <path
        d="M743.43 179.48L742.35 179.03V178.17L743.43 178.63V179.48Z"
        fill="#CECECE"
      />
      <path
        d="M743.43 183.69L742.35 183.31V182.4L743.43 182.8V183.69Z"
        fill="#CECECE"
      />
      <path
        d="M743.43 185.8L742.35 185.44V184.52L743.43 184.89V185.8Z"
        fill="#CECECE"
      />
      <path
        d="M743.42 187.9L742.35 187.58V186.64L743.42 186.97V187.9Z"
        fill="#CECECE"
      />
      <path
        d="M743.42 192.11L742.35 191.85V190.88L743.42 191.14V192.11Z"
        fill="#CECECE"
      />
      <path
        d="M743.42 194.21L742.35 193.99V192.99L743.42 193.23V194.21Z"
        fill="#CECECE"
      />
      <path
        d="M743.42 198.42L742.35 198.26V197.23L743.42 197.4V198.42Z"
        fill="#CECECE"
      />
      <path
        d="M743.41 202.63L742.35 202.53V201.47L743.41 201.57V202.63Z"
        fill="#CECECE"
      />
      <path
        d="M743.57 159.95V160.63L744.6 161.32V160.66L743.57 159.95Z"
        fill="#CECECE"
      />
      <path
        d="M744.6 163.39L743.57 162.73V162.03L744.6 162.71V163.39Z"
        fill="#CECECE"
      />
      <path
        d="M744.6 165.46L743.57 164.83V164.11L744.6 164.76V165.46Z"
        fill="#CECECE"
      />
      <path
        d="M744.6 167.53L743.57 166.93V166.19L744.6 166.81V167.53Z"
        fill="#CECECE"
      />
      <path
        d="M744.6 169.6L743.57 169.03V168.28L744.6 168.86V169.6Z"
        fill="#CECECE"
      />
      <path
        d="M744.6 171.67L743.57 171.13V170.36L744.6 170.91V171.67Z"
        fill="#CECECE"
      />
      <path
        d="M744.6 173.74L743.57 173.23V172.44L744.6 172.96V173.74Z"
        fill="#CECECE"
      />
      <path
        d="M744.6 175.81L743.58 175.33V174.52L744.6 175.01V175.81Z"
        fill="#CECECE"
      />
      <path
        d="M744.6 177.88L743.58 177.43V176.6L744.6 177.06V177.88Z"
        fill="#CECECE"
      />
      <path
        d="M744.61 179.96L743.58 179.54V178.68L744.61 179.11V179.96Z"
        fill="#CECECE"
      />
      <path
        d="M744.61 182.03L743.58 181.64V180.76L744.61 181.16V182.03Z"
        fill="#CECECE"
      />
      <path
        d="M744.61 184.1L743.58 183.74V182.84L744.61 183.21V184.1Z"
        fill="#CECECE"
      />
      <path
        d="M744.61 186.17L743.58 185.84V184.93L744.61 185.26V186.17Z"
        fill="#CECECE"
      />
      <path
        d="M744.61 188.24L743.58 187.94V187.01L744.61 187.31V188.24Z"
        fill="#CECECE"
      />
      <path
        d="M744.61 190.31L743.58 190.04V189.09L744.61 189.37V190.31Z"
        fill="#CECECE"
      />
      <path
        d="M744.61 192.38L743.58 192.14V191.17L744.61 191.42V192.38Z"
        fill="#CECECE"
      />
      <path
        d="M744.61 194.45L743.58 194.24V193.25L744.61 193.47V194.45Z"
        fill="#CECECE"
      />
      <path
        d="M744.61 196.52L743.58 196.34V195.33L744.61 195.52V196.52Z"
        fill="#CECECE"
      />
      <path
        d="M744.61 198.59L743.58 198.44V197.41L744.61 197.57V198.59Z"
        fill="#CECECE"
      />
      <path
        d="M744.61 200.66L743.58 200.54V199.5L744.61 199.62V200.66Z"
        fill="#CECECE"
      />
      <path
        d="M744.61 202.73L743.59 202.64V201.58L744.61 201.67V202.73Z"
        fill="#CECECE"
      />
      <path
        d="M744.61 204.8L743.59 204.74V203.66L744.61 203.72V204.8Z"
        fill="#CECECE"
      />
      <path
        d="M744.61 206.87L743.59 206.84V205.74L744.61 205.77V206.87Z"
        fill="#CECECE"
      />
      <path
        d="M746.03 161.64V162.28L746.68 162.72V162.09L746.03 161.64Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 164.73L746.03 164.31V163.65L746.68 164.08V164.73Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 166.74L746.03 166.34V165.66L746.68 166.07V166.74Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 168.75L746.02 168.37V167.66L746.68 168.05V168.75Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 170.76L746.02 170.39V169.67L746.68 170.04V170.76Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 172.77L746.02 172.42V171.68L746.68 172.03V172.77Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 176.79L746.02 176.48V175.7L746.68 176.01V176.79Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 178.8L746.02 178.51V177.7L746.68 178V178.8Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 180.81L746.01 180.54V179.71L746.68 179.98V180.81Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 182.82L746.01 182.57V181.72L746.68 181.97V182.82Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 184.83L746.01 184.6V183.73L746.68 183.96V184.83Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 186.84L746.01 186.63V185.73L746.68 185.95V186.84Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 190.86L746.01 190.68V189.75L746.68 189.93V190.86Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 192.86L746.01 192.71V191.76L746.68 191.91V192.86Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 196.88L746 196.77V195.77L746.68 195.89V196.88Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 198.9L746 198.8V197.78L746.68 197.88V198.9Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 200.91L746 200.83V199.79L746.68 199.87V200.91Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 204.92L746 204.89V203.81L746.68 203.84V204.92Z"
        fill="#CECECE"
      />
      <path
        d="M746.68 206.93L745.99 206.92V205.81L746.68 205.83V206.93Z"
        fill="#CECECE"
      />
      <path
        d="M746.81 162.18V162.8L747.41 163.2V162.59L746.81 162.18Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 165.19L746.81 164.81V164.16L747.41 164.56V165.19Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 167.18L746.81 166.81V166.14L747.41 166.52V167.18Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 169.17L746.81 168.82V168.13L747.41 168.49V169.17Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 171.16L746.81 170.83V170.11L747.41 170.46V171.16Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 173.15L746.81 172.83V172.1L747.41 172.42V173.15Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 175.14L746.8 174.84V174.08L747.41 174.39V175.14Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 177.12L746.8 176.84V176.07L747.41 176.36V177.12Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 179.11L746.8 178.85V178.05L747.41 178.32V179.11Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 181.1L746.8 180.86V180.04L747.41 180.29V181.1Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 183.09L746.8 182.86V182.02L747.41 182.26V183.09Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 185.08L746.8 184.87V184.01L747.41 184.22V185.08Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 187.07L746.8 186.88V185.99L747.41 186.19V187.07Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 189.06L746.8 188.88V187.98L747.41 188.15V189.06Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 193.03L746.8 192.89V191.94L747.41 192.09V193.03Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 195.02L746.8 194.9V193.93L747.41 194.05V195.02Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 197.01L746.8 196.91V195.91L747.41 196.02V197.01Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 200.99L746.8 200.92V199.88L747.41 199.95V200.99Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 202.98L746.8 202.93V201.87L747.41 201.92V202.98Z"
        fill="#CECECE"
      />
      <path
        d="M747.41 204.97L746.8 204.93V203.85L747.41 203.89V204.97Z"
        fill="#CECECE"
      />
      <path d="M747.42 207.82H746.8V208.94H747.42V207.82Z" fill="#CECECE" />
      <path
        d="M748.81 163.55V164.15L749.62 164.68V164.11L748.81 163.55Z"
        fill="#CECECE"
      />
      <path
        d="M749.62 166.61L748.82 166.09V165.48L749.62 166.01V166.61Z"
        fill="#CECECE"
      />
      <path
        d="M749.61 168.53L748.82 168.04V167.4L749.61 167.91V168.53Z"
        fill="#CECECE"
      />
      <path
        d="M749.61 172.38L748.82 171.94V171.25L749.61 171.71V172.38Z"
        fill="#CECECE"
      />
      <path
        d="M749.61 174.31L748.82 173.89V173.18L749.61 173.61V174.31Z"
        fill="#CECECE"
      />
      <path
        d="M749.61 176.23L748.82 175.83V175.1L749.61 175.51V176.23Z"
        fill="#CECECE"
      />
      <path
        d="M749.61 178.16L748.82 177.78V177.03L749.61 177.41V178.16Z"
        fill="#CECECE"
      />
      <path
        d="M749.61 180.08L748.82 179.73V178.95L749.61 179.31V180.08Z"
        fill="#CECECE"
      />
      <path
        d="M749.61 182L748.82 181.68V180.88L749.61 181.21V182Z"
        fill="#CECECE"
      />
      <path
        d="M749.61 183.93L748.82 183.62V182.8L749.61 183.11V183.93Z"
        fill="#CECECE"
      />
      <path
        d="M749.6 189.7L748.82 189.47V188.58L749.6 188.81V189.7Z"
        fill="#CECECE"
      />
      <path
        d="M749.6 191.63L748.82 191.41V190.5L749.6 190.72V191.63Z"
        fill="#CECECE"
      />
      <path
        d="M749.6 193.55L748.82 193.36V192.42L749.6 192.62V193.55Z"
        fill="#CECECE"
      />
      <path
        d="M749.6 195.47L748.83 195.31V194.35L749.6 194.52V195.47Z"
        fill="#CECECE"
      />
      <path
        d="M749.6 197.4L748.83 197.26V196.27L749.6 196.42V197.4Z"
        fill="#CECECE"
      />
      <path
        d="M749.6 201.25L748.83 201.15V200.12L749.6 200.22V201.25Z"
        fill="#CECECE"
      />
      <path
        d="M749.59 205.1L748.83 205.05V203.97L749.59 204.02V205.1Z"
        fill="#CECECE"
      />
      <path
        d="M749.59 207.02L748.83 207V205.9L749.59 205.92V207.02Z"
        fill="#CECECE"
      />
      <path d="M749.59 207.82H748.83V208.94H749.59V207.82Z" fill="#CECECE" />
      <path
        d="M749.74 164.19V164.77L750.39 165.21V164.64L749.74 164.19Z"
        fill="#CECECE"
      />
      <path
        d="M750.39 167.11L749.74 166.69V166.09L750.39 166.52V167.11Z"
        fill="#CECECE"
      />
      <path
        d="M750.39 169.01L749.74 168.61V167.99L750.39 168.4V169.01Z"
        fill="#CECECE"
      />
      <path
        d="M750.38 170.91L749.74 170.53V169.88L750.38 170.27V170.91Z"
        fill="#CECECE"
      />
      <path
        d="M750.38 172.81L749.74 172.45V171.78L750.38 172.15V172.81Z"
        fill="#CECECE"
      />
      <path
        d="M750.38 174.71L749.74 174.37V173.68L750.38 174.03V174.71Z"
        fill="#CECECE"
      />
      <path
        d="M750.38 176.62L749.75 176.29V175.57L750.38 175.91V176.62Z"
        fill="#CECECE"
      />
      <path
        d="M750.37 180.42L749.75 180.13V179.37L750.37 179.66V180.42Z"
        fill="#CECECE"
      />
      <path
        d="M750.37 182.32L749.75 182.05V181.26L750.37 181.54V182.32Z"
        fill="#CECECE"
      />
      <path
        d="M750.36 184.22L749.75 183.98V183.16L750.36 183.41V184.22Z"
        fill="#CECECE"
      />
      <path
        d="M750.36 186.12L749.75 185.9V185.06L750.36 185.29V186.12Z"
        fill="#CECECE"
      />
      <path
        d="M750.36 188.03L749.75 187.82V186.95L750.36 187.17V188.03Z"
        fill="#CECECE"
      />
      <path
        d="M750.35 189.93L749.75 189.74V188.85L750.35 189.05V189.93Z"
        fill="#CECECE"
      />
      <path
        d="M750.35 191.83L749.75 191.66V190.75L750.35 190.92V191.83Z"
        fill="#CECECE"
      />
      <path
        d="M750.35 193.73L749.75 193.58V192.65L750.35 192.8V193.73Z"
        fill="#CECECE"
      />
      <path
        d="M750.34 195.63L749.75 195.5V194.54L750.34 194.68V195.63Z"
        fill="#CECECE"
      />
      <path
        d="M750.34 197.53L749.75 197.42V196.44L750.34 196.56V197.53Z"
        fill="#CECECE"
      />
      <path
        d="M750.34 199.44L749.75 199.34V198.34L750.34 198.43V199.44Z"
        fill="#CECECE"
      />
      <path
        d="M750.33 201.34L749.75 201.26V200.23L750.33 200.31V201.34Z"
        fill="#CECECE"
      />
      <path
        d="M750.33 203.24L749.75 203.18V202.13L750.33 202.19V203.24Z"
        fill="#CECECE"
      />
      <path
        d="M750.32 207.04L749.75 207.02V205.92L750.32 205.94V207.04Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 159.64V160.26L740.9 160.07V159.42L739.86 159.64Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 162.38L740.9 162.19V161.52L739.86 161.74V162.38Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 164.49L740.9 164.32V163.62L739.86 163.83V164.49Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 166.61L740.9 166.44V165.73L739.86 165.93V166.61Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 168.73L740.9 168.57V167.83L739.86 168.02V168.73Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 170.84L740.9 170.69V169.94L739.86 170.12V170.84Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 172.96L740.9 172.82V172.04L739.86 172.21V172.96Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 175.08L740.9 174.94V174.15L739.86 174.3V175.08Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 177.19L740.9 177.07V176.25L739.86 176.4V177.19Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 179.31L740.9 179.19V178.36L739.86 178.49V179.31Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 181.43L740.9 181.32V180.46L739.86 180.59V181.43Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 183.54L740.9 183.44V182.57L739.86 182.68V183.54Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 185.66L740.89 185.57V184.67L739.86 184.78V185.66Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 187.78L740.89 187.69V186.78L739.86 186.87V187.78Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 189.89L740.89 189.82V188.88L739.86 188.97V189.89Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 194.13L740.89 194.07V193.09L739.86 193.16V194.13Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 196.24L740.89 196.19V195.19L739.86 195.25V196.24Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 198.36L740.89 198.32V197.3L739.86 197.35V198.36Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 202.59L740.89 202.57V201.51L739.86 201.54V202.59Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 204.71L740.89 204.69V203.61L739.86 203.63V204.71Z"
        fill="#CECECE"
      />
      <path
        d="M739.86 206.83L740.89 206.82V205.72L739.86 205.73V206.83Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 159.95V160.52L739.37 160.35V159.75L738.42 159.95Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 162.63L739.37 162.46V161.84L738.42 162.03V162.63Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 164.74L739.37 164.58V163.93L738.42 164.11V164.74Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 166.84L739.37 166.69V166.02L738.42 166.19V166.84Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 168.95L739.37 168.8V168.11L738.42 168.28V168.95Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 171.05L739.37 170.91V170.2L738.42 170.36V171.05Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 173.16L739.37 173.03V172.29L738.42 172.44V173.16Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 175.26L739.37 175.14V174.38L738.42 174.52V175.26Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 177.37L739.37 177.25V176.47L738.42 176.6V177.37Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 179.47L739.37 179.37V178.56L738.42 178.68V179.47Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 181.58L739.37 181.48V180.65L738.42 180.76V181.58Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 183.68L739.37 183.59V182.74L738.42 182.84V183.68Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 185.79L739.37 185.7V184.83L738.42 184.93V185.79Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 190L739.37 189.93V189.01L738.42 189.09V190Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 192.1L739.37 192.04V191.1L738.42 191.17V192.1Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 194.21L739.37 194.16V193.19L738.42 193.25V194.21Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 200.52L739.37 200.49V199.46L738.42 199.5V200.52Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 202.63L739.37 202.61V201.55L738.42 201.58V202.63Z"
        fill="#CECECE"
      />
      <path
        d="M738.42 206.84L739.37 206.83V205.73L738.42 205.74V206.84Z"
        fill="#CECECE"
      />
      <path
        d="M737.25 160.2V160.74L738 160.6V160.04L737.25 160.2Z"
        fill="#CECECE"
      />
      <path
        d="M737.25 162.84L737.99 162.71V162.12L737.25 162.27V162.84Z"
        fill="#CECECE"
      />
      <path
        d="M737.25 164.93L737.99 164.81V164.2L737.25 164.34V164.93Z"
        fill="#CECECE"
      />
      <path
        d="M737.25 167.03L737.99 166.91V166.27L737.25 166.41V167.03Z"
        fill="#CECECE"
      />
      <path
        d="M737.25 169.12L737.99 169.01V168.35L737.25 168.48V169.12Z"
        fill="#CECECE"
      />
      <path
        d="M737.24 171.22L737.99 171.11V170.43L737.24 170.55V171.22Z"
        fill="#CECECE"
      />
      <path
        d="M737.24 175.41L737.99 175.32V174.58L737.24 174.69V175.41Z"
        fill="#CECECE"
      />
      <path
        d="M737.24 177.51L737.99 177.42V176.66L737.24 176.77V177.51Z"
        fill="#CECECE"
      />
      <path
        d="M737.24 179.6L737.99 179.52V178.74L737.24 178.84V179.6Z"
        fill="#CECECE"
      />
      <path
        d="M737.24 183.79L737.99 183.72V182.89L737.24 182.98V183.79Z"
        fill="#CECECE"
      />
      <path
        d="M737.24 185.89L737.98 185.83V184.97L737.24 185.05V185.89Z"
        fill="#CECECE"
      />
      <path
        d="M737.24 187.99L737.98 187.93V187.05L737.24 187.12V187.99Z"
        fill="#CECECE"
      />
      <path
        d="M737.24 192.18L737.98 192.13V191.2L737.24 191.26V192.18Z"
        fill="#CECECE"
      />
      <path
        d="M737.24 194.27L737.98 194.23V193.28L737.24 193.33V194.27Z"
        fill="#CECECE"
      />
      <path
        d="M737.24 198.46L737.98 198.44V197.43L737.24 197.47V198.46Z"
        fill="#CECECE"
      />
      <path
        d="M737.23 200.56L737.98 200.54V199.51L737.23 199.54V200.56Z"
        fill="#CECECE"
      />
      <path
        d="M737.23 202.66L737.98 202.64V201.59L737.23 201.61V202.66Z"
        fill="#CECECE"
      />
      <path
        d="M735.92 160.49V160.98L736.82 160.82V160.29L735.92 160.49Z"
        fill="#CECECE"
      />
      <path
        d="M735.92 163.07L736.82 162.91V162.36L735.92 162.55V163.07Z"
        fill="#CECECE"
      />
      <path
        d="M735.92 165.15L736.82 165V164.43L735.92 164.6V165.15Z"
        fill="#CECECE"
      />
      <path
        d="M735.92 167.24L736.82 167.1V166.49L735.92 166.66V167.24Z"
        fill="#CECECE"
      />
      <path
        d="M735.92 169.32L736.82 169.19V168.56L735.92 168.72V169.32Z"
        fill="#CECECE"
      />
      <path
        d="M735.91 173.5L736.82 173.37V172.69L735.91 172.84V173.5Z"
        fill="#CECECE"
      />
      <path
        d="M735.91 175.58L736.82 175.47V174.76L735.91 174.89V175.58Z"
        fill="#CECECE"
      />
      <path
        d="M735.91 177.67L736.82 177.56V176.83L735.91 176.95V177.67Z"
        fill="#CECECE"
      />
      <path
        d="M735.91 181.84L736.82 181.74V180.96L735.91 181.07V181.84Z"
        fill="#CECECE"
      />
      <path
        d="M735.9 186.01L736.82 185.93V185.09L735.9 185.18V186.01Z"
        fill="#CECECE"
      />
      <path
        d="M735.9 188.09L736.82 188.02V187.16L735.9 187.24V188.09Z"
        fill="#CECECE"
      />
      <path
        d="M735.9 190.18L736.82 190.11V189.22L735.9 189.3V190.18Z"
        fill="#CECECE"
      />
      <path
        d="M735.9 192.26L736.82 192.21V191.29L735.9 191.36V192.26Z"
        fill="#CECECE"
      />
      <path
        d="M735.9 194.35L736.82 194.3V193.36L735.9 193.41V194.35Z"
        fill="#CECECE"
      />
      <path
        d="M735.9 196.43L736.82 196.39V195.42L735.9 195.47V196.43Z"
        fill="#CECECE"
      />
      <path
        d="M735.89 200.6L736.82 200.57V199.56L735.89 199.59V200.6Z"
        fill="#CECECE"
      />
      <path
        d="M735.89 204.77L736.82 204.76V203.69L735.89 203.7V204.77Z"
        fill="#CECECE"
      />
      <path
        d="M735.89 206.86L736.82 206.85V205.75L735.89 205.76V206.86Z"
        fill="#CECECE"
      />
      <path
        d="M744.79 208.94H745.83V161.45L744.79 160.74V208.94Z"
        fill="#CECECE"
      />
      <path
        d="M747.59 208.94H748.62V163.4L747.59 162.68V208.94Z"
        fill="#CECECE"
      />
      <path
        d="M750.59 208.94H750.89V164.98L750.59 164.77V208.94Z"
        fill="#CECECE"
      />
      <path
        d="M750.98 208.94H751.28V165.25L750.98 165.04V208.94Z"
        fill="#CECECE"
      />
      <path
        d="M731.65 161.45V161.95L729.52 162.4V161.91L731.65 161.45Z"
        fill="#CECECE"
      />
      <path
        d="M729.52 164.01L731.65 163.58V163.06L729.52 163.5V164.01Z"
        fill="#CECECE"
      />
      <path
        d="M729.52 165.62L731.65 165.21V164.67L729.52 165.09V165.62Z"
        fill="#CECECE"
      />
      <path
        d="M729.53 168.84L731.65 168.47V167.89L729.53 168.28V168.84Z"
        fill="#CECECE"
      />
      <path
        d="M729.53 170.45L731.64 170.1V169.5L729.53 169.87V170.45Z"
        fill="#CECECE"
      />
      <path
        d="M729.53 172.06L731.64 171.73V171.11L729.53 171.46V172.06Z"
        fill="#CECECE"
      />
      <path
        d="M729.54 173.67L731.64 173.36V172.73L729.54 173.05V173.67Z"
        fill="#CECECE"
      />
      <path
        d="M729.54 175.28L731.64 174.99V174.34L729.54 174.64V175.28Z"
        fill="#CECECE"
      />
      <path
        d="M729.54 176.89L731.64 176.62V175.95L729.54 176.23V176.89Z"
        fill="#CECECE"
      />
      <path
        d="M729.55 178.5L731.63 178.25V177.56L729.55 177.82V178.5Z"
        fill="#CECECE"
      />
      <path
        d="M729.55 183.33L731.63 183.14V182.39L729.55 182.59V183.33Z"
        fill="#CECECE"
      />
      <path
        d="M729.56 184.94L731.63 184.77V184L729.56 184.18V184.94Z"
        fill="#CECECE"
      />
      <path
        d="M729.56 186.55L731.63 186.4V185.61L729.56 185.77V186.55Z"
        fill="#CECECE"
      />
      <path
        d="M729.56 188.16L731.62 188.03V187.22L729.56 187.36V188.16Z"
        fill="#CECECE"
      />
      <path
        d="M729.57 189.77L731.62 189.65V188.83L729.57 188.95V189.77Z"
        fill="#CECECE"
      />
      <path
        d="M729.57 192.99L731.62 192.92V192.05L729.57 192.13V192.99Z"
        fill="#CECECE"
      />
      <path
        d="M729.58 196.21L731.62 196.17V195.27L729.58 195.31V196.21Z"
        fill="#CECECE"
      />
      <path
        d="M729.58 197.82L731.61 197.8V196.88L729.58 196.9V197.82Z"
        fill="#CECECE"
      />
      <path d="M731.61 198.49H729.58V199.43H731.61V198.49Z" fill="#CECECE" />
      <path
        d="M729.18 161.98V162.47L727.45 162.83V162.36L729.18 161.98Z"
        fill="#CECECE"
      />
      <path
        d="M727.45 164.42L729.18 164.07V163.57L727.45 163.93V164.42Z"
        fill="#CECECE"
      />
      <path
        d="M727.46 166.02L729.18 165.68V165.16L727.46 165.5V166.02Z"
        fill="#CECECE"
      />
      <path
        d="M727.47 167.61L729.18 167.29V166.75L727.47 167.07V167.61Z"
        fill="#CECECE"
      />
      <path
        d="M727.48 169.2L729.18 168.9V168.33L727.48 168.64V169.2Z"
        fill="#CECECE"
      />
      <path
        d="M727.49 170.79L729.18 170.5V169.92L727.49 170.22V170.79Z"
        fill="#CECECE"
      />
      <path
        d="M727.5 172.38L729.18 172.11V171.51L727.5 171.79V172.38Z"
        fill="#CECECE"
      />
      <path
        d="M727.51 175.56L729.17 175.33V174.68L727.51 174.93V175.56Z"
        fill="#CECECE"
      />
      <path
        d="M727.52 177.16L729.17 176.93V176.27L727.52 176.5V177.16Z"
        fill="#CECECE"
      />
      <path
        d="M727.53 178.75L729.17 178.54V177.86L727.53 178.07V178.75Z"
        fill="#CECECE"
      />
      <path
        d="M727.54 180.34L729.17 180.15V179.45L727.54 179.64V180.34Z"
        fill="#CECECE"
      />
      <path
        d="M727.55 181.93L729.17 181.75V181.03L727.55 181.21V181.93Z"
        fill="#CECECE"
      />
      <path
        d="M727.56 183.52L729.17 183.36V182.62L727.56 182.78V183.52Z"
        fill="#CECECE"
      />
      <path
        d="M727.57 185.11L729.17 184.97V184.21L727.57 184.36V185.11Z"
        fill="#CECECE"
      />
      <path
        d="M727.57 186.7L729.17 186.58V185.8L727.57 185.93V186.7Z"
        fill="#CECECE"
      />
      <path
        d="M727.58 188.3L729.17 188.18V187.38L727.58 187.5V188.3Z"
        fill="#CECECE"
      />
      <path
        d="M727.59 189.89L729.16 189.79V188.97L727.59 189.07V189.89Z"
        fill="#CECECE"
      />
      <path
        d="M727.6 191.48L729.16 191.4V190.56L727.6 190.64V191.48Z"
        fill="#CECECE"
      />
      <path
        d="M727.61 193.07L729.16 193.01V192.15L727.61 192.21V193.07Z"
        fill="#CECECE"
      />
      <path
        d="M727.62 194.66L729.16 194.61V193.73L727.62 193.78V194.66Z"
        fill="#CECECE"
      />
      <path
        d="M727.64 197.84L729.16 197.83V196.91L727.64 196.92V197.84Z"
        fill="#CECECE"
      />
      <path
        d="M734.92 199.43H732.18V161.32L734.92 160.72V199.43Z"
        fill="#CECECE"
      />
      <path
        d="M726.92 199.43H726.13V162.64L726.92 162.47V199.43Z"
        fill="#CECECE"
      />
      <path
        d="M725.89 199.43H725.1V162.87L725.89 162.69V199.43Z"
        fill="#CECECE"
      />
      <path d="M527.4 119.09H526.65V156.42H527.4V119.09Z" fill="#CECECE" />
      <path d="M527.4 177.96H526.65V207.9H527.4V177.96Z" fill="#CECECE" />
      <path
        opacity="0.7"
        d="M678.79 160.25H678.08V161.58H678.79V160.25Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M680.17 160.25H679.46V161.58H680.17V160.25Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M678.79 162.2H678.08V163.53H678.79V162.2Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M678.79 164.15H678.08V165.48H678.79V164.15Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M678.79 166.1H678.08V167.43H678.79V166.1Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M678.79 168.05H678.08V169.38H678.79V168.05Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M678.79 170H678.08V171.33H678.79V170Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M678.79 171.96H678.08V173.29H678.79V171.96Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M678.79 173.91H678.08V175.24H678.79V173.91Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M677.41 160.25H676.7V161.58H677.41V160.25Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M677.41 162.2H676.7V163.53H677.41V162.2Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M677.41 168.05H676.7V169.38H677.41V168.05Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M677.41 170H676.7V171.33H677.41V170Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M677.41 171.96H676.7V173.29H677.41V171.96Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M677.41 175.86H676.7V177.19H677.41V175.86Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M676.03 160.25H675.32V161.58H676.03V160.25Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M676.03 162.2H675.32V163.53H676.03V162.2Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M676.03 164.15H675.32V165.48H676.03V164.15Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M676.03 166.1H675.32V167.43H676.03V166.1Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M676.03 170H675.32V171.33H676.03V170Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M676.03 171.96H675.32V173.29H676.03V171.96Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M676.03 173.91H675.32V175.24H676.03V173.91Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M676.03 175.86H675.32V177.19H676.03V175.86Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M674.64 160.25H673.93V161.58H674.64V160.25Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M674.64 162.2H673.93V163.53H674.64V162.2Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M674.64 164.15H673.93V165.48H674.64V164.15Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M674.64 166.1H673.93V167.43H674.64V166.1Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M674.64 168.05H673.93V169.38H674.64V168.05Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M674.64 170H673.93V171.33H674.64V170Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M674.64 173.91H673.93V175.24H674.64V173.91Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M674.64 175.86H673.93V177.19H674.64V175.86Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M669.11 160.25H668.4V161.58H669.11V160.25Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M669.11 162.2H668.4V163.53H669.11V162.2Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M669.11 166.1H668.4V167.43H669.11V166.1Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M669.11 168.05H668.4V169.38H669.11V168.05Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M669.11 170H668.4V171.33H669.11V170Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M669.11 171.96H668.4V173.29H669.11V171.96Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M669.11 177.81H668.4V179.14H669.11V177.81Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M667.73 160.25H667.02V161.58H667.73V160.25Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M667.73 162.2H667.02V163.53H667.73V162.2Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M667.73 164.15H667.02V165.48H667.73V164.15Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M667.73 168.05H667.02V169.38H667.73V168.05Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M667.73 173.91H667.02V175.24H667.73V173.91Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M667.73 177.81H667.02V179.14H667.73V177.81Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M666.17 160.25H665.46V161.58H666.17V160.25Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M666.17 162.2H665.46V163.53H666.17V162.2Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M666.17 164.15H665.46V165.48H666.17V164.15Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M666.17 166.1H665.46V167.43H666.17V166.1Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M666.17 168.05H665.46V169.38H666.17V168.05Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M666.17 170H665.46V171.33H666.17V170Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M666.17 173.91H665.46V175.24H666.17V173.91Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M666.17 175.86H665.46V177.19H666.17V175.86Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M666.17 177.81H665.46V179.14H666.17V177.81Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M664.78 160.25H664.07V161.58H664.78V160.25Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M664.78 164.15H664.07V165.48H664.78V164.15Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M664.78 168.05H664.07V169.38H664.78V168.05Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M664.78 170H664.07V171.33H664.78V170Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M664.78 171.96H664.07V173.29H664.78V171.96Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M663.4 160.25H662.69V161.58H663.4V160.25Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M663.4 162.2H662.69V163.53H663.4V162.2Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M663.4 164.15H662.69V165.48H663.4V164.15Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M663.4 166.1H662.69V167.43H663.4V166.1Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M663.4 168.05H662.69V169.38H663.4V168.05Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M663.4 171.96H662.69V173.29H663.4V171.96Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M663.4 173.91H662.69V175.24H663.4V173.91Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M663.4 175.86H662.69V177.19H663.4V175.86Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M663.4 177.81H662.69V179.14H663.4V177.81Z"
        fill="#CECECE"
      />
      <g opacity="0.7">
        <path
          opacity="0.7"
          d="M680.17 177.81H679.46V179.14H680.17V177.81Z"
          fill="#CECECE"
        />
        <path
          opacity="0.7"
          d="M680.17 162.23H679.46V163.56H680.17V162.23Z"
          fill="#CECECE"
        />
        <path
          opacity="0.7"
          d="M680.17 166.13H679.46V167.46H680.17V166.13Z"
          fill="#CECECE"
        />
        <path
          opacity="0.7"
          d="M680.17 168.05H679.46V169.38H680.17V168.05Z"
          fill="#CECECE"
        />
        <path
          opacity="0.7"
          d="M680.17 170.01H679.46V171.34H680.17V170.01Z"
          fill="#CECECE"
        />
        <path
          opacity="0.7"
          d="M680.17 171.96H679.46V173.29H680.17V171.96Z"
          fill="#CECECE"
        />
        <path
          opacity="0.7"
          d="M680.17 173.91H679.46V175.24H680.17V173.91Z"
          fill="#CECECE"
        />
        <path
          opacity="0.7"
          d="M680.17 175.86H679.46V177.19H680.17V175.86Z"
          fill="#CECECE"
        />
        <path
          opacity="0.7"
          d="M678.79 177.81H678.08V179.14H678.79V177.81Z"
          fill="#CECECE"
        />
        <path
          opacity="0.7"
          d="M677.41 177.81H676.7V179.14H677.41V177.81Z"
          fill="#CECECE"
        />
        <path
          opacity="0.7"
          d="M676.03 177.81H675.32V179.14H676.03V177.81Z"
          fill="#CECECE"
        />
        <path
          opacity="0.7"
          d="M673.44 177.81H672.73V179.14H673.44V177.81Z"
          fill="#CECECE"
        />
      </g>
      <path
        opacity="0.7"
        d="M662.02 160.25H661.31V161.58H662.02V160.25Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M662.02 162.2H661.31V163.53H662.02V162.2Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M662.02 164.15H661.31V165.48H662.02V164.15Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M662.02 166.1H661.31V167.43H662.02V166.1Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M662.02 168.05H661.31V169.38H662.02V168.05Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M662.02 170H661.31V171.33H662.02V170Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M662.02 171.96H661.31V173.29H662.02V171.96Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M662.02 173.91H661.31V175.24H662.02V173.91Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M662.02 175.86H661.31V177.19H662.02V175.86Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M662.02 177.81H661.31V179.14H662.02V177.81Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M660.64 160.25H659.93V161.58H660.64V160.25Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M660.64 166.1H659.93V167.43H660.64V166.1Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M660.64 168.05H659.93V169.38H660.64V168.05Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M660.64 170H659.93V171.33H660.64V170Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M660.64 171.96H659.93V173.29H660.64V171.96Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M660.64 177.81H659.93V179.14H660.64V177.81Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M633.79 181.47H633.28V182.43H633.79V181.47Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M633.79 182.88H633.28V183.84H633.79V182.88Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M633.79 184.29H633.28V185.25H633.79V184.29Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M633.79 187.11H633.28V188.07H633.79V187.11Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M633.79 191.35H633.28V192.31H633.79V191.35Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M633.79 194.17H633.28V195.13H633.79V194.17Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M632.66 181.47H632.15V182.43H632.66V181.47Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M632.66 182.88H632.15V183.84H632.66V182.88Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M632.66 184.29H632.15V185.25H632.66V184.29Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M632.66 185.7H632.15V186.66H632.66V185.7Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M632.66 187.11H632.15V188.07H632.66V187.11Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M632.66 188.53H632.15V189.49H632.66V188.53Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M632.66 191.35H632.15V192.31H632.66V191.35Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M632.66 192.76H632.15V193.72H632.66V192.76Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M632.66 194.17H632.15V195.13H632.66V194.17Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M631.66 181.47H631.15V182.43H631.66V181.47Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M631.66 184.29H631.15V185.25H631.66V184.29Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M631.66 187.11H631.15V188.07H631.66V187.11Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M631.66 188.53H631.15V189.49H631.66V188.53Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M631.66 189.94H631.15V190.9H631.66V189.94Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M630.66 181.47H630.15V182.43H630.66V181.47Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M630.66 182.88H630.15V183.84H630.66V182.88Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M630.66 184.29H630.15V185.25H630.66V184.29Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M630.66 185.7H630.15V186.66H630.66V185.7Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M630.66 187.11H630.15V188.07H630.66V187.11Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M630.66 189.94H630.15V190.9H630.66V189.94Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M630.66 191.35H630.15V192.31H630.66V191.35Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M630.66 192.76H630.15V193.72H630.66V192.76Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M630.66 194.17H630.15V195.13H630.66V194.17Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M629.66 181.47H629.15V182.43H629.66V181.47Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M629.66 182.88H629.15V183.84H629.66V182.88Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M629.66 184.29H629.15V185.25H629.66V184.29Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M629.66 185.7H629.15V186.66H629.66V185.7Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M629.66 187.11H629.15V188.07H629.66V187.11Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M629.66 188.53H629.15V189.49H629.66V188.53Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M629.66 189.94H629.15V190.9H629.66V189.94Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M629.66 191.35H629.15V192.31H629.66V191.35Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M629.66 192.76H629.15V193.72H629.66V192.76Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M629.66 194.17H629.15V195.13H629.66V194.17Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M628.66 181.47H628.15V182.43H628.66V181.47Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M628.66 185.7H628.15V186.66H628.66V185.7Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M628.66 187.11H628.15V188.07H628.66V187.11Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M628.66 188.53H628.15V189.49H628.66V188.53Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M628.66 189.94H628.15V190.9H628.66V189.94Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M628.66 194.17H628.15V195.13H628.66V194.17Z"
        fill="#CECECE"
      />
      <path d="M696.63 149.58H695.92V150.91H696.63V149.58Z" fill="#CECECE" />
      <path d="M696.63 151.7H695.92V153.03H696.63V151.7Z" fill="#CECECE" />
      <path d="M696.63 153.65H695.92V154.98H696.63V153.65Z" fill="#CECECE" />
      <path d="M696.63 155.6H695.92V156.93H696.63V155.6Z" fill="#CECECE" />
      <path d="M696.63 157.55H695.92V158.88H696.63V157.55Z" fill="#CECECE" />
      <path d="M696.63 159.5H695.92V160.83H696.63V159.5Z" fill="#CECECE" />
      <path d="M696.63 161.45H695.92V162.78H696.63V161.45Z" fill="#CECECE" />
      <path d="M696.63 165.36H695.92V166.69H696.63V165.36Z" fill="#CECECE" />
      <path d="M696.63 167.31H695.92V168.64H696.63V167.31Z" fill="#CECECE" />
      <path d="M696.63 171.21H695.92V172.54H696.63V171.21Z" fill="#CECECE" />
      <path d="M696.63 173.16H695.92V174.49H696.63V173.16Z" fill="#CECECE" />
      <path d="M696.63 175.11H695.92V176.44H696.63V175.11Z" fill="#CECECE" />
      <path d="M696.63 177.06H695.92V178.39H696.63V177.06Z" fill="#CECECE" />
      <path d="M696.63 179.02H695.92V180.35H696.63V179.02Z" fill="#CECECE" />
      <path d="M696.63 180.97H695.92V182.3H696.63V180.97Z" fill="#CECECE" />
      <path d="M696.63 182.92H695.92V184.25H696.63V182.92Z" fill="#CECECE" />
      <path d="M696.63 184.87H695.92V186.2H696.63V184.87Z" fill="#CECECE" />
      <path d="M696.63 220.14H695.92V221.47H696.63V220.14Z" fill="#CECECE" />
      <path d="M696.63 222.09H695.92V223.42H696.63V222.09Z" fill="#CECECE" />
      <path d="M696.63 224.04H695.92V225.37H696.63V224.04Z" fill="#CECECE" />
      <path d="M696.63 225.99H695.92V227.32H696.63V225.99Z" fill="#CECECE" />
      <path d="M696.63 227.95H695.92V229.28H696.63V227.95Z" fill="#CECECE" />
      <path d="M696.63 229.9H695.92V231.23H696.63V229.9Z" fill="#CECECE" />
      <path d="M696.63 231.85H695.92V233.18H696.63V231.85Z" fill="#CECECE" />
      <path d="M696.63 233.8H695.92V235.13H696.63V233.8Z" fill="#CECECE" />
      <path d="M696.63 188.77H695.92V190.1H696.63V188.77Z" fill="#CECECE" />
      <path d="M696.63 192.68H695.92V194.01H696.63V192.68Z" fill="#CECECE" />
      <path d="M695.25 149.58H694.54V150.91H695.25V149.58Z" fill="#CECECE" />
      <path d="M695.25 151.7H694.54V153.03H695.25V151.7Z" fill="#CECECE" />
      <path d="M695.25 153.65H694.54V154.98H695.25V153.65Z" fill="#CECECE" />
      <path d="M695.25 155.6H694.54V156.93H695.25V155.6Z" fill="#CECECE" />
      <path d="M695.25 157.55H694.54V158.88H695.25V157.55Z" fill="#CECECE" />
      <path d="M695.25 159.5H694.54V160.83H695.25V159.5Z" fill="#CECECE" />
      <path d="M695.25 161.45H694.54V162.78H695.25V161.45Z" fill="#CECECE" />
      <path d="M695.25 163.4H694.54V164.73H695.25V163.4Z" fill="#CECECE" />
      <path d="M695.25 165.36H694.54V166.69H695.25V165.36Z" fill="#CECECE" />
      <path d="M695.25 167.31H694.54V168.64H695.25V167.31Z" fill="#CECECE" />
      <path d="M695.25 169.26H694.54V170.59H695.25V169.26Z" fill="#CECECE" />
      <path d="M695.25 171.21H694.54V172.54H695.25V171.21Z" fill="#CECECE" />
      <path d="M695.25 173.16H694.54V174.49H695.25V173.16Z" fill="#CECECE" />
      <path d="M695.25 179.02H694.54V180.35H695.25V179.02Z" fill="#CECECE" />
      <path d="M695.25 180.97H694.54V182.3H695.25V180.97Z" fill="#CECECE" />
      <path d="M695.25 182.92H694.54V184.25H695.25V182.92Z" fill="#CECECE" />
      <path d="M695.25 186.82H694.54V188.15H695.25V186.82Z" fill="#CECECE" />
      <path d="M695.25 188.77H694.54V190.1H695.25V188.77Z" fill="#CECECE" />
      <path d="M695.25 190.72H694.54V192.05H695.25V190.72Z" fill="#CECECE" />
      <path d="M695.25 192.68H694.54V194.01H695.25V192.68Z" fill="#CECECE" />
      <path d="M693.87 149.58H693.16V150.91H693.87V149.58Z" fill="#CECECE" />
      <path d="M693.87 151.7H693.16V153.03H693.87V151.7Z" fill="#CECECE" />
      <path d="M693.87 153.65H693.16V154.98H693.87V153.65Z" fill="#CECECE" />
      <path d="M693.87 155.6H693.16V156.93H693.87V155.6Z" fill="#CECECE" />
      <path d="M693.87 159.5H693.16V160.83H693.87V159.5Z" fill="#CECECE" />
      <path d="M693.87 161.45H693.16V162.78H693.87V161.45Z" fill="#CECECE" />
      <path d="M693.87 163.4H693.16V164.73H693.87V163.4Z" fill="#CECECE" />
      <path d="M693.87 165.36H693.16V166.69H693.87V165.36Z" fill="#CECECE" />
      <path d="M693.87 167.31H693.16V168.64H693.87V167.31Z" fill="#CECECE" />
      <path d="M693.87 169.26H693.16V170.59H693.87V169.26Z" fill="#CECECE" />
      <path d="M693.87 171.21H693.16V172.54H693.87V171.21Z" fill="#CECECE" />
      <path d="M693.87 173.16H693.16V174.49H693.87V173.16Z" fill="#CECECE" />
      <path d="M693.87 175.11H693.16V176.44H693.87V175.11Z" fill="#CECECE" />
      <path d="M693.87 177.06H693.16V178.39H693.87V177.06Z" fill="#CECECE" />
      <path d="M693.87 180.97H693.16V182.3H693.87V180.97Z" fill="#CECECE" />
      <path d="M693.87 182.92H693.16V184.25H693.87V182.92Z" fill="#CECECE" />
      <path d="M693.87 184.87H693.16V186.2H693.87V184.87Z" fill="#CECECE" />
      <path d="M693.87 186.82H693.16V188.15H693.87V186.82Z" fill="#CECECE" />
      <path d="M693.87 188.77H693.16V190.1H693.87V188.77Z" fill="#CECECE" />
      <path d="M692.49 149.58H691.78V150.91H692.49V149.58Z" fill="#CECECE" />
      <path d="M692.49 151.7H691.78V153.03H692.49V151.7Z" fill="#CECECE" />
      <path d="M692.49 153.65H691.78V154.98H692.49V153.65Z" fill="#CECECE" />
      <path d="M692.49 155.6H691.78V156.93H692.49V155.6Z" fill="#CECECE" />
      <path d="M692.49 157.55H691.78V158.88H692.49V157.55Z" fill="#CECECE" />
      <path d="M692.49 159.5H691.78V160.83H692.49V159.5Z" fill="#CECECE" />
      <path d="M692.49 161.45H691.78V162.78H692.49V161.45Z" fill="#CECECE" />
      <path d="M692.49 163.4H691.78V164.73H692.49V163.4Z" fill="#CECECE" />
      <path d="M692.49 165.36H691.78V166.69H692.49V165.36Z" fill="#CECECE" />
      <path d="M692.49 171.21H691.78V172.54H692.49V171.21Z" fill="#CECECE" />
      <path d="M692.49 173.16H691.78V174.49H692.49V173.16Z" fill="#CECECE" />
      <path d="M692.49 175.11H691.78V176.44H692.49V175.11Z" fill="#CECECE" />
      <path d="M692.49 177.06H691.78V178.39H692.49V177.06Z" fill="#CECECE" />
      <path d="M692.49 179.02H691.78V180.35H692.49V179.02Z" fill="#CECECE" />
      <path d="M692.49 180.97H691.78V182.3H692.49V180.97Z" fill="#CECECE" />
      <path d="M692.49 184.87H691.78V186.2H692.49V184.87Z" fill="#CECECE" />
      <path d="M692.49 186.82H691.78V188.15H692.49V186.82Z" fill="#CECECE" />
      <path d="M692.49 188.77H691.78V190.1H692.49V188.77Z" fill="#CECECE" />
      <path d="M692.49 190.72H691.78V192.05H692.49V190.72Z" fill="#CECECE" />
      <path d="M692.49 192.68H691.78V194.01H692.49V192.68Z" fill="#CECECE" />
      <path d="M691.1 149.58H690.39V150.91H691.1V149.58Z" fill="#CECECE" />
      <path d="M691.1 151.7H690.39V153.03H691.1V151.7Z" fill="#CECECE" />
      <path d="M691.1 155.6H690.39V156.93H691.1V155.6Z" fill="#CECECE" />
      <path d="M691.1 157.55H690.39V158.88H691.1V157.55Z" fill="#CECECE" />
      <path d="M691.1 159.5H690.39V160.83H691.1V159.5Z" fill="#CECECE" />
      <path d="M691.1 161.45H690.39V162.78H691.1V161.45Z" fill="#CECECE" />
      <path d="M691.1 163.4H690.39V164.73H691.1V163.4Z" fill="#CECECE" />
      <path d="M691.1 167.31H690.39V168.64H691.1V167.31Z" fill="#CECECE" />
      <path d="M691.1 169.26H690.39V170.59H691.1V169.26Z" fill="#CECECE" />
      <path d="M691.1 171.21H690.39V172.54H691.1V171.21Z" fill="#CECECE" />
      <path d="M691.1 175.11H690.39V176.44H691.1V175.11Z" fill="#CECECE" />
      <path d="M691.1 179.02H690.39V180.35H691.1V179.02Z" fill="#CECECE" />
      <path d="M691.1 180.97H690.39V182.3H691.1V180.97Z" fill="#CECECE" />
      <path d="M691.1 182.92H690.39V184.25H691.1V182.92Z" fill="#CECECE" />
      <path d="M691.1 194.63H690.39V195.96H691.1V194.63Z" fill="#CECECE" />
      <path d="M689.72 149.58H689.01V150.91H689.72V149.58Z" fill="#CECECE" />
      <path d="M689.72 151.7H689.01V153.03H689.72V151.7Z" fill="#CECECE" />
      <path d="M689.72 153.65H689.01V154.98H689.72V153.65Z" fill="#CECECE" />
      <path d="M689.72 155.6H689.01V156.93H689.72V155.6Z" fill="#CECECE" />
      <path d="M689.72 157.55H689.01V158.88H689.72V157.55Z" fill="#CECECE" />
      <path d="M689.72 159.5H689.01V160.83H689.72V159.5Z" fill="#CECECE" />
      <path d="M689.72 163.4H689.01V164.73H689.72V163.4Z" fill="#CECECE" />
      <path d="M689.72 165.36H689.01V166.69H689.72V165.36Z" fill="#CECECE" />
      <path d="M689.72 167.31H689.01V168.64H689.72V167.31Z" fill="#CECECE" />
      <path d="M689.72 171.21H689.01V172.54H689.72V171.21Z" fill="#CECECE" />
      <path d="M689.72 173.16H689.01V174.49H689.72V173.16Z" fill="#CECECE" />
      <path d="M689.72 175.11H689.01V176.44H689.72V175.11Z" fill="#CECECE" />
      <path d="M689.72 177.06H689.01V178.39H689.72V177.06Z" fill="#CECECE" />
      <path d="M689.72 179.02H689.01V180.35H689.72V179.02Z" fill="#CECECE" />
      <path d="M689.72 182.92H689.01V184.25H689.72V182.92Z" fill="#CECECE" />
      <path d="M689.72 184.87H689.01V186.2H689.72V184.87Z" fill="#CECECE" />
      <path d="M689.72 186.82H689.01V188.15H689.72V186.82Z" fill="#CECECE" />
      <path d="M689.72 188.77H689.01V190.1H689.72V188.77Z" fill="#CECECE" />
      <path d="M689.72 190.72H689.01V192.05H689.72V190.72Z" fill="#CECECE" />
      <path d="M689.72 192.68H689.01V194.01H689.72V192.68Z" fill="#CECECE" />
      <path d="M688.34 149.58H687.63V150.91H688.34V149.58Z" fill="#CECECE" />
      <path d="M688.34 151.7H687.63V153.03H688.34V151.7Z" fill="#CECECE" />
      <path d="M688.34 153.65H687.63V154.98H688.34V153.65Z" fill="#CECECE" />
      <path d="M688.34 155.6H687.63V156.93H688.34V155.6Z" fill="#CECECE" />
      <path d="M688.34 157.55H687.63V158.88H688.34V157.55Z" fill="#CECECE" />
      <path d="M688.34 159.5H687.63V160.83H688.34V159.5Z" fill="#CECECE" />
      <path d="M688.34 161.45H687.63V162.78H688.34V161.45Z" fill="#CECECE" />
      <path d="M688.34 163.4H687.63V164.73H688.34V163.4Z" fill="#CECECE" />
      <path d="M688.34 167.31H687.63V168.64H688.34V167.31Z" fill="#CECECE" />
      <path d="M688.34 169.26H687.63V170.59H688.34V169.26Z" fill="#CECECE" />
      <path d="M688.34 171.21H687.63V172.54H688.34V171.21Z" fill="#CECECE" />
      <path d="M688.34 173.16H687.63V174.49H688.34V173.16Z" fill="#CECECE" />
      <path d="M688.34 175.11H687.63V176.44H688.34V175.11Z" fill="#CECECE" />
      <path d="M688.34 177.06H687.63V178.39H688.34V177.06Z" fill="#CECECE" />
      <path d="M688.34 179.02H687.63V180.35H688.34V179.02Z" fill="#CECECE" />
      <path d="M688.34 180.97H687.63V182.3H688.34V180.97Z" fill="#CECECE" />
      <path d="M688.34 182.92H687.63V184.25H688.34V182.92Z" fill="#CECECE" />
      <path d="M688.34 184.87H687.63V186.2H688.34V184.87Z" fill="#CECECE" />
      <path d="M688.34 186.82H687.63V188.15H688.34V186.82Z" fill="#CECECE" />
      <path d="M688.34 188.77H687.63V190.1H688.34V188.77Z" fill="#CECECE" />
      <path d="M686.96 149.58H686.25V150.91H686.96V149.58Z" fill="#CECECE" />
      <path d="M686.96 151.7H686.25V153.03H686.96V151.7Z" fill="#CECECE" />
      <path d="M686.96 153.65H686.25V154.98H686.96V153.65Z" fill="#CECECE" />
      <path d="M686.96 155.6H686.25V156.93H686.96V155.6Z" fill="#CECECE" />
      <path d="M686.96 159.5H686.25V160.83H686.96V159.5Z" fill="#CECECE" />
      <path d="M686.96 163.4H686.25V164.73H686.96V163.4Z" fill="#CECECE" />
      <path d="M686.96 165.36H686.25V166.69H686.96V165.36Z" fill="#CECECE" />
      <path d="M686.96 167.31H686.25V168.64H686.96V167.31Z" fill="#CECECE" />
      <path d="M686.96 169.26H686.25V170.59H686.96V169.26Z" fill="#CECECE" />
      <path d="M686.96 171.21H686.25V172.54H686.96V171.21Z" fill="#CECECE" />
      <path d="M686.96 177.06H686.25V178.39H686.96V177.06Z" fill="#CECECE" />
      <path d="M685.58 149.58H684.87V150.91H685.58V149.58Z" fill="#CECECE" />
      <path d="M685.58 151.7H684.87V153.03H685.58V151.7Z" fill="#CECECE" />
      <path d="M685.58 153.65H684.87V154.98H685.58V153.65Z" fill="#CECECE" />
      <path d="M685.58 155.6H684.87V156.93H685.58V155.6Z" fill="#CECECE" />
      <path d="M685.58 157.55H684.87V158.88H685.58V157.55Z" fill="#CECECE" />
      <path d="M685.58 159.5H684.87V160.83H685.58V159.5Z" fill="#CECECE" />
      <path d="M685.58 161.45H684.87V162.78H685.58V161.45Z" fill="#CECECE" />
      <path d="M685.58 163.4H684.87V164.73H685.58V163.4Z" fill="#CECECE" />
      <path d="M685.58 165.36H684.87V166.69H685.58V165.36Z" fill="#CECECE" />
      <path d="M685.58 171.21H684.87V172.54H685.58V171.21Z" fill="#CECECE" />
      <path d="M685.58 173.16H684.87V174.49H685.58V173.16Z" fill="#CECECE" />
      <path d="M685.58 175.11H684.87V176.44H685.58V175.11Z" fill="#CECECE" />
      <path d="M686.97 179.02H686.23V180.41H686.97V179.02Z" fill="#CECECE" />
      <path d="M686.97 185.16H686.23V186.55H686.97V185.16Z" fill="#CECECE" />
      <path d="M686.97 189.25H686.23V190.64H686.97V189.25Z" fill="#CECECE" />
      <path d="M686.97 195.39H686.23V196.78H686.97V195.39Z" fill="#CECECE" />
      <path d="M696.63 145.17H695.86V148.95H696.63V145.17Z" fill="#CECECE" />
      <path d="M686.96 145.17H686.25V148.95H686.96V145.17Z" fill="#CECECE" />
      <path d="M688.34 145.17H687.63V148.95H688.34V145.17Z" fill="#CECECE" />
      <path d="M689.72 145.17H689.01V148.95H689.72V145.17Z" fill="#CECECE" />
      <path d="M691.1 145.17H690.39V148.95H691.1V145.17Z" fill="#CECECE" />
      <path d="M692.49 145.17H691.78V148.95H692.49V145.17Z" fill="#CECECE" />
      <path d="M693.87 145.17H693.16V148.95H693.87V145.17Z" fill="#CECECE" />
      <path d="M695.25 145.17H694.54V148.95H695.25V145.17Z" fill="#CECECE" />
      <path d="M685.61 145.17H684.87V148.95H685.61V145.17Z" fill="#CECECE" />
      <path d="M684.32 149.58H683.61V150.91H684.32V149.58Z" fill="#CECECE" />
      <path d="M684.32 151.7H683.61V153.03H684.32V151.7Z" fill="#CECECE" />
      <path d="M684.32 153.65H683.61V154.98H684.32V153.65Z" fill="#CECECE" />
      <path d="M684.32 155.6H683.61V156.93H684.32V155.6Z" fill="#CECECE" />
      <path d="M684.32 157.55H683.61V158.88H684.32V157.55Z" fill="#CECECE" />
      <path d="M684.32 159.5H683.61V160.83H684.32V159.5Z" fill="#CECECE" />
      <path d="M684.32 161.45H683.61V162.78H684.32V161.45Z" fill="#CECECE" />
      <path d="M684.32 163.4H683.61V164.73H684.32V163.4Z" fill="#CECECE" />
      <path d="M684.32 167.31H683.61V168.64H684.32V167.31Z" fill="#CECECE" />
      <path d="M684.32 169.26H683.61V170.59H684.32V169.26Z" fill="#CECECE" />
      <path d="M684.32 171.21H683.61V172.54H684.32V171.21Z" fill="#CECECE" />
      <path d="M684.32 173.16H683.61V174.49H684.32V173.16Z" fill="#CECECE" />
      <path d="M684.32 175.11H683.61V176.44H684.32V175.11Z" fill="#CECECE" />
      <path d="M684.32 177.06H683.61V178.39H684.32V177.06Z" fill="#CECECE" />
      <path d="M695.25 194.7H694.54V196.03H695.25V194.7Z" fill="#CECECE" />
      <path d="M695.25 198.6H694.54V199.93H695.25V198.6Z" fill="#CECECE" />
      <path d="M695.25 204.45H694.54V205.78H695.25V204.45Z" fill="#CECECE" />
      <path d="M695.25 206.4H694.54V207.73H695.25V206.4Z" fill="#CECECE" />
      <path d="M695.25 208.36H694.54V209.69H695.25V208.36Z" fill="#CECECE" />
      <path d="M693.87 192.74H693.16V194.07H693.87V192.74Z" fill="#CECECE" />
      <path d="M693.87 196.65H693.16V197.98H693.87V196.65Z" fill="#CECECE" />
      <path d="M693.87 198.6H693.16V199.93H693.87V198.6Z" fill="#CECECE" />
      <path d="M693.87 200.55H693.16V201.88H693.87V200.55Z" fill="#CECECE" />
      <path d="M693.87 202.5H693.16V203.83H693.87V202.5Z" fill="#CECECE" />
      <path d="M692.49 194.7H691.78V196.03H692.49V194.7Z" fill="#CECECE" />
      <path d="M692.49 200.55H691.78V201.88H692.49V200.55Z" fill="#CECECE" />
      <path d="M692.49 202.5H691.78V203.83H692.49V202.5Z" fill="#CECECE" />
      <path d="M692.49 206.4H691.78V207.73H692.49V206.4Z" fill="#CECECE" />
      <path d="M692.49 208.36H691.78V209.69H692.49V208.36Z" fill="#CECECE" />
      <path d="M691.1 196.65H690.39V197.98H691.1V196.65Z" fill="#CECECE" />
      <path d="M691.1 198.6H690.39V199.93H691.1V198.6Z" fill="#CECECE" />
      <path d="M689.72 192.74H689.01V194.07H689.72V192.74Z" fill="#CECECE" />
      <path d="M689.72 198.6H689.01V199.93H689.72V198.6Z" fill="#CECECE" />
      <path d="M689.72 200.55H689.01V201.88H689.72V200.55Z" fill="#CECECE" />
      <path d="M689.72 202.5H689.01V203.83H689.72V202.5Z" fill="#CECECE" />
      <path d="M689.72 204.45H689.01V205.78H689.72V204.45Z" fill="#CECECE" />
      <path d="M689.72 206.4H689.01V207.73H689.72V206.4Z" fill="#CECECE" />
      <path d="M689.72 208.36H689.01V209.69H689.72V208.36Z" fill="#CECECE" />
      <path d="M688.34 192.74H687.63V194.07H688.34V192.74Z" fill="#CECECE" />
      <path d="M688.34 194.7H687.63V196.03H688.34V194.7Z" fill="#CECECE" />
      <path d="M688.34 196.65H687.63V197.98H688.34V196.65Z" fill="#CECECE" />
      <path d="M688.34 200.55H687.63V201.88H688.34V200.55Z" fill="#CECECE" />
      <path d="M688.34 204.45H687.63V205.78H688.34V204.45Z" fill="#CECECE" />
      <path d="M695.25 210.35H694.54V211.68H695.25V210.35Z" fill="#CECECE" />
      <path d="M696.63 200.8H695.92V202.13H696.63V200.8Z" fill="#CECECE" />
      <path d="M696.63 202.75H695.92V204.08H696.63V202.75Z" fill="#CECECE" />
      <path d="M696.63 212.61H695.92V213.94H696.63V212.61Z" fill="#CECECE" />
      <path d="M696.63 206.69H695.92V208.02H696.63V206.69Z" fill="#CECECE" />
      <path d="M692.49 210.35H691.78V211.68H692.49V210.35Z" fill="#CECECE" />
      <path d="M689.72 210.35H689.01V211.68H689.72V210.35Z" fill="#CECECE" />
      <path d="M695.25 212.37H694.54V213.7H695.25V212.37Z" fill="#CECECE" />
      <path d="M695.25 216.27H694.54V217.6H695.25V216.27Z" fill="#CECECE" />
      <path d="M695.25 222.12H694.54V223.45H695.25V222.12Z" fill="#CECECE" />
      <path d="M695.25 224.08H694.54V225.41H695.25V224.08Z" fill="#CECECE" />
      <path d="M695.25 226.03H694.54V227.36H695.25V226.03Z" fill="#CECECE" />
      <path d="M695.25 233.8H694.54V235.13H695.25V233.8Z" fill="#CECECE" />
      <path d="M695.25 235.75H694.54V237.08H695.25V235.75Z" fill="#CECECE" />
      <path d="M695.25 237.7H694.54V239.03H695.25V237.7Z" fill="#CECECE" />
      <path d="M695.25 239.65H694.54V240.98H695.25V239.65Z" fill="#CECECE" />
      <path d="M695.25 241.6H694.54V242.93H695.25V241.6Z" fill="#CECECE" />
      <path d="M695.25 243.56H694.54V244.89H695.25V243.56Z" fill="#CECECE" />
      <path d="M695.25 245.51H694.54V246.84H695.25V245.51Z" fill="#CECECE" />
      <path d="M693.87 233.83H693.16V235.16H693.87V233.83Z" fill="#CECECE" />
      <path d="M693.87 235.78H693.16V237.11H693.87V235.78Z" fill="#CECECE" />
      <path d="M693.87 237.74H693.16V239.07H693.87V237.74Z" fill="#CECECE" />
      <path d="M689.72 227.94H689.01V229.27H689.72V227.94Z" fill="#CECECE" />
      <path d="M689.72 231.85H689.01V233.18H689.72V231.85Z" fill="#CECECE" />
      <path d="M689.72 235.75H689.01V237.08H689.72V235.75Z" fill="#CECECE" />
      <path d="M688.34 227.98H687.63V229.31H688.34V227.98Z" fill="#CECECE" />
      <path d="M693.87 210.41H693.16V211.74H693.87V210.41Z" fill="#CECECE" />
      <path d="M693.87 214.32H693.16V215.65H693.87V214.32Z" fill="#CECECE" />
      <path d="M693.87 216.27H693.16V217.6H693.87V216.27Z" fill="#CECECE" />
      <path d="M693.87 218.22H693.16V219.55H693.87V218.22Z" fill="#CECECE" />
      <path d="M693.87 220.17H693.16V221.5H693.87V220.17Z" fill="#CECECE" />
      <path d="M692.49 212.37H691.78V213.7H692.49V212.37Z" fill="#CECECE" />
      <path d="M692.49 218.22H691.78V219.55H692.49V218.22Z" fill="#CECECE" />
      <path d="M692.49 220.17H691.78V221.5H692.49V220.17Z" fill="#CECECE" />
      <path d="M692.49 224.08H691.78V225.41H692.49V224.08Z" fill="#CECECE" />
      <path d="M692.49 226.03H691.78V227.36H692.49V226.03Z" fill="#CECECE" />
      <path d="M691.1 214.32H690.39V215.65H691.1V214.32Z" fill="#CECECE" />
      <path d="M691.1 216.27H690.39V217.6H691.1V216.27Z" fill="#CECECE" />
      <path d="M691.1 224.08H690.39V225.41H691.1V224.08Z" fill="#CECECE" />
      <path d="M691.1 227.98H690.39V229.31H691.1V227.98Z" fill="#CECECE" />
      <path d="M689.72 216.27H689.01V217.6H689.72V216.27Z" fill="#CECECE" />
      <path d="M689.72 218.22H689.01V219.55H689.72V218.22Z" fill="#CECECE" />
      <path d="M689.72 220.17H689.01V221.5H689.72V220.17Z" fill="#CECECE" />
      <path d="M689.72 222.12H689.01V223.45H689.72V222.12Z" fill="#CECECE" />
      <path d="M689.72 224.08H689.01V225.41H689.72V224.08Z" fill="#CECECE" />
      <path d="M689.72 226.03H689.01V227.36H689.72V226.03Z" fill="#CECECE" />
      <path d="M688.34 210.41H687.63V211.74H688.34V210.41Z" fill="#CECECE" />
      <path d="M688.34 212.37H687.63V213.7H688.34V212.37Z" fill="#CECECE" />
      <path d="M688.34 214.32H687.63V215.65H688.34V214.32Z" fill="#CECECE" />
      <path d="M688.34 218.22H687.63V219.55H688.34V218.22Z" fill="#CECECE" />
      <path d="M688.34 222.12H687.63V223.45H688.34V222.12Z" fill="#CECECE" />
      <path d="M686.97 195.46H686.23V196.85H686.97V195.46Z" fill="#CECECE" />
      <path d="M682.94 149.58H682.23V150.91H682.94V149.58Z" fill="#CECECE" />
      <path d="M682.94 151.7H682.23V153.03H682.94V151.7Z" fill="#CECECE" />
      <path d="M682.94 153.65H682.23V154.98H682.94V153.65Z" fill="#CECECE" />
      <path d="M682.94 155.6H682.23V156.93H682.94V155.6Z" fill="#CECECE" />
      <path d="M682.94 159.5H682.23V160.83H682.94V159.5Z" fill="#CECECE" />
      <path d="M682.94 163.4H682.23V164.73H682.94V163.4Z" fill="#CECECE" />
      <path d="M682.94 165.36H682.23V166.69H682.94V165.36Z" fill="#CECECE" />
      <path d="M682.94 167.31H682.23V168.64H682.94V167.31Z" fill="#CECECE" />
      <path d="M682.94 169.26H682.23V170.59H682.94V169.26Z" fill="#CECECE" />
      <path d="M682.94 171.21H682.23V172.54H682.94V171.21Z" fill="#CECECE" />
      <path d="M682.94 177.06H682.23V178.39H682.94V177.06Z" fill="#CECECE" />
      <path d="M681.56 149.58H680.85V150.91H681.56V149.58Z" fill="#CECECE" />
      <path d="M681.56 151.7H680.85V153.03H681.56V151.7Z" fill="#CECECE" />
      <path d="M681.56 153.65H680.85V154.98H681.56V153.65Z" fill="#CECECE" />
      <path d="M681.56 155.6H680.85V156.93H681.56V155.6Z" fill="#CECECE" />
      <path d="M681.56 157.55H680.85V158.88H681.56V157.55Z" fill="#CECECE" />
      <path d="M681.56 159.5H680.85V160.83H681.56V159.5Z" fill="#CECECE" />
      <path d="M681.56 161.45H680.85V162.78H681.56V161.45Z" fill="#CECECE" />
      <path d="M681.56 163.4H680.85V164.73H681.56V163.4Z" fill="#CECECE" />
      <path d="M681.56 165.36H680.85V166.69H681.56V165.36Z" fill="#CECECE" />
      <path d="M681.56 171.21H680.85V172.54H681.56V171.21Z" fill="#CECECE" />
      <path d="M681.56 173.16H680.85V174.49H681.56V173.16Z" fill="#CECECE" />
      <path d="M681.56 175.11H680.85V176.44H681.56V175.11Z" fill="#CECECE" />
      <path d="M502.29 174.29H500.65V175.66H502.29V174.29Z" fill="#CECECE" />
      <path d="M502.29 176.48H500.65V177.85H502.29V176.48Z" fill="#CECECE" />
      <path d="M502.29 178.5H500.65V179.87H502.29V178.5Z" fill="#CECECE" />
      <path d="M502.29 180.52H500.65V181.89H502.29V180.52Z" fill="#CECECE" />
      <path d="M502.29 182.54H500.65V183.91H502.29V182.54Z" fill="#CECECE" />
      <path d="M502.29 184.55H500.65V185.92H502.29V184.55Z" fill="#CECECE" />
      <path d="M502.29 186.57H500.65V187.94H502.29V186.57Z" fill="#CECECE" />
      <path d="M502.29 190.61H500.65V191.98H502.29V190.61Z" fill="#CECECE" />
      <path d="M502.29 192.63H500.65V194H502.29V192.63Z" fill="#CECECE" />
      <path d="M502.29 196.67H500.65V198.04H502.29V196.67Z" fill="#CECECE" />
      <path d="M502.29 198.69H500.65V200.06H502.29V198.69Z" fill="#CECECE" />
      <path d="M502.29 200.71H500.65V202.08H502.29V200.71Z" fill="#CECECE" />
      <path d="M502.29 202.72H500.65V204.09H502.29V202.72Z" fill="#CECECE" />
      <path d="M502.29 204.74H500.65V206.11H502.29V204.74Z" fill="#CECECE" />
      <path d="M502.29 206.76H500.65V208.13H502.29V206.76Z" fill="#CECECE" />
      <path d="M502.29 208.78H500.65V210.15H502.29V208.78Z" fill="#CECECE" />
      <path d="M502.29 210.8H500.65V212.17H502.29V210.8Z" fill="#CECECE" />
      <path d="M502.29 214.84H500.65V216.21H502.29V214.84Z" fill="#CECECE" />
      <path d="M502.29 218.88H500.65V220.25H502.29V218.88Z" fill="#CECECE" />
      <path d="M499.08 174.29H497.44V175.66H499.08V174.29Z" fill="#CECECE" />
      <path d="M499.08 176.48H497.44V177.85H499.08V176.48Z" fill="#CECECE" />
      <path d="M499.08 178.5H497.44V179.87H499.08V178.5Z" fill="#CECECE" />
      <path d="M499.08 180.52H497.44V181.89H499.08V180.52Z" fill="#CECECE" />
      <path d="M499.08 182.54H497.44V183.91H499.08V182.54Z" fill="#CECECE" />
      <path d="M499.08 184.55H497.44V185.92H499.08V184.55Z" fill="#CECECE" />
      <path d="M499.08 186.57H497.44V187.94H499.08V186.57Z" fill="#CECECE" />
      <path d="M499.08 188.59H497.44V189.96H499.08V188.59Z" fill="#CECECE" />
      <path d="M499.08 190.61H497.44V191.98H499.08V190.61Z" fill="#CECECE" />
      <path d="M499.08 192.63H497.44V194H499.08V192.63Z" fill="#CECECE" />
      <path d="M499.08 194.65H497.44V196.02H499.08V194.65Z" fill="#CECECE" />
      <path d="M499.08 196.67H497.44V198.04H499.08V196.67Z" fill="#CECECE" />
      <path d="M499.08 198.69H497.44V200.06H499.08V198.69Z" fill="#CECECE" />
      <path d="M499.08 204.74H497.44V206.11H499.08V204.74Z" fill="#CECECE" />
      <path d="M499.08 206.76H497.44V208.13H499.08V206.76Z" fill="#CECECE" />
      <path d="M499.08 208.78H497.44V210.15H499.08V208.78Z" fill="#CECECE" />
      <path d="M499.08 212.82H497.44V214.19H499.08V212.82Z" fill="#CECECE" />
      <path d="M499.08 214.84H497.44V216.21H499.08V214.84Z" fill="#CECECE" />
      <path d="M499.08 216.86H497.44V218.23H499.08V216.86Z" fill="#CECECE" />
      <path d="M499.08 218.88H497.44V220.25H499.08V218.88Z" fill="#CECECE" />
      <path d="M495.87 174.29H494.23V175.66H495.87V174.29Z" fill="#CECECE" />
      <path d="M495.87 176.48H494.23V177.85H495.87V176.48Z" fill="#CECECE" />
      <path d="M495.87 178.5H494.23V179.87H495.87V178.5Z" fill="#CECECE" />
      <path d="M495.87 180.52H494.23V181.89H495.87V180.52Z" fill="#CECECE" />
      <path d="M495.87 184.55H494.23V185.92H495.87V184.55Z" fill="#CECECE" />
      <path d="M495.87 186.57H494.23V187.94H495.87V186.57Z" fill="#CECECE" />
      <path d="M495.87 188.59H494.23V189.96H495.87V188.59Z" fill="#CECECE" />
      <path d="M495.87 190.61H494.23V191.98H495.87V190.61Z" fill="#CECECE" />
      <path d="M495.87 192.63H494.23V194H495.87V192.63Z" fill="#CECECE" />
      <path d="M495.87 194.65H494.23V196.02H495.87V194.65Z" fill="#CECECE" />
      <path d="M495.87 196.67H494.23V198.04H495.87V196.67Z" fill="#CECECE" />
      <path d="M495.87 198.69H494.23V200.06H495.87V198.69Z" fill="#CECECE" />
      <path d="M495.87 200.71H494.23V202.08H495.87V200.71Z" fill="#CECECE" />
      <path d="M495.87 202.72H494.23V204.09H495.87V202.72Z" fill="#CECECE" />
      <path d="M495.87 206.76H494.23V208.13H495.87V206.76Z" fill="#CECECE" />
      <path d="M495.87 208.78H494.23V210.15H495.87V208.78Z" fill="#CECECE" />
      <path d="M495.87 210.8H494.23V212.17H495.87V210.8Z" fill="#CECECE" />
      <path d="M495.87 212.82H494.23V214.19H495.87V212.82Z" fill="#CECECE" />
      <path d="M495.87 214.84H494.23V216.21H495.87V214.84Z" fill="#CECECE" />
      <path d="M492.67 174.29H491.02V175.66H492.67V174.29Z" fill="#CECECE" />
      <path d="M492.67 176.48H491.02V177.85H492.67V176.48Z" fill="#CECECE" />
      <path d="M492.67 178.5H491.02V179.87H492.67V178.5Z" fill="#CECECE" />
      <path d="M492.67 180.52H491.02V181.89H492.67V180.52Z" fill="#CECECE" />
      <path d="M492.67 182.54H491.02V183.91H492.67V182.54Z" fill="#CECECE" />
      <path d="M492.67 184.55H491.02V185.92H492.67V184.55Z" fill="#CECECE" />
      <path d="M492.67 186.57H491.02V187.94H492.67V186.57Z" fill="#CECECE" />
      <path d="M492.67 188.59H491.02V189.96H492.67V188.59Z" fill="#CECECE" />
      <path d="M492.67 190.61H491.02V191.98H492.67V190.61Z" fill="#CECECE" />
      <path d="M492.67 196.67H491.02V198.04H492.67V196.67Z" fill="#CECECE" />
      <path d="M492.67 198.69H491.02V200.06H492.67V198.69Z" fill="#CECECE" />
      <path d="M492.67 200.71H491.02V202.08H492.67V200.71Z" fill="#CECECE" />
      <path d="M492.67 202.72H491.02V204.09H492.67V202.72Z" fill="#CECECE" />
      <path d="M492.67 204.74H491.02V206.11H492.67V204.74Z" fill="#CECECE" />
      <path d="M492.67 206.76H491.02V208.13H492.67V206.76Z" fill="#CECECE" />
      <path d="M492.67 210.8H491.02V212.17H492.67V210.8Z" fill="#CECECE" />
      <path d="M492.67 212.82H491.02V214.19H492.67V212.82Z" fill="#CECECE" />
      <path d="M492.67 214.84H491.02V216.21H492.67V214.84Z" fill="#CECECE" />
      <path d="M492.67 216.86H491.02V218.23H492.67V216.86Z" fill="#CECECE" />
      <path d="M492.67 218.88H491.02V220.25H492.67V218.88Z" fill="#CECECE" />
      <path d="M489.46 174.29H487.81V175.66H489.46V174.29Z" fill="#CECECE" />
      <path d="M489.46 176.48H487.81V177.85H489.46V176.48Z" fill="#CECECE" />
      <path d="M489.46 180.52H487.81V181.89H489.46V180.52Z" fill="#CECECE" />
      <path d="M489.46 182.54H487.81V183.91H489.46V182.54Z" fill="#CECECE" />
      <path d="M489.46 184.55H487.81V185.92H489.46V184.55Z" fill="#CECECE" />
      <path d="M489.46 186.57H487.81V187.94H489.46V186.57Z" fill="#CECECE" />
      <path d="M489.46 188.59H487.81V189.96H489.46V188.59Z" fill="#CECECE" />
      <path d="M489.46 192.63H487.81V194H489.46V192.63Z" fill="#CECECE" />
      <path d="M489.46 194.65H487.81V196.02H489.46V194.65Z" fill="#CECECE" />
      <path d="M489.46 196.67H487.81V198.04H489.46V196.67Z" fill="#CECECE" />
      <path d="M489.46 200.71H487.81V202.08H489.46V200.71Z" fill="#CECECE" />
      <path d="M489.46 204.74H487.81V206.11H489.46V204.74Z" fill="#CECECE" />
      <path d="M489.46 206.76H487.81V208.13H489.46V206.76Z" fill="#CECECE" />
      <path d="M489.46 208.78H487.81V210.15H489.46V208.78Z" fill="#CECECE" />
      <path d="M489.46 216.86H487.81V218.23H489.46V216.86Z" fill="#CECECE" />
      <path d="M489.46 220.89H487.81V222.26H489.46V220.89Z" fill="#CECECE" />
      <path d="M486.25 174.29H484.6V175.66H486.25V174.29Z" fill="#CECECE" />
      <path d="M486.25 176.48H484.6V177.85H486.25V176.48Z" fill="#CECECE" />
      <path d="M486.25 178.5H484.6V179.87H486.25V178.5Z" fill="#CECECE" />
      <path d="M486.25 180.52H484.6V181.89H486.25V180.52Z" fill="#CECECE" />
      <path d="M486.25 182.54H484.6V183.91H486.25V182.54Z" fill="#CECECE" />
      <path d="M486.25 184.55H484.6V185.92H486.25V184.55Z" fill="#CECECE" />
      <path d="M486.25 188.59H484.6V189.96H486.25V188.59Z" fill="#CECECE" />
      <path d="M486.25 190.61H484.6V191.98H486.25V190.61Z" fill="#CECECE" />
      <path d="M486.25 192.63H484.6V194H486.25V192.63Z" fill="#CECECE" />
      <path d="M486.25 196.67H484.6V198.04H486.25V196.67Z" fill="#CECECE" />
      <path d="M486.25 198.69H484.6V200.06H486.25V198.69Z" fill="#CECECE" />
      <path d="M486.25 200.71H484.6V202.08H486.25V200.71Z" fill="#CECECE" />
      <path d="M486.25 202.72H484.6V204.09H486.25V202.72Z" fill="#CECECE" />
      <path d="M486.25 204.74H484.6V206.11H486.25V204.74Z" fill="#CECECE" />
      <path d="M486.25 208.78H484.6V210.15H486.25V208.78Z" fill="#CECECE" />
      <path d="M486.25 210.8H484.6V212.17H486.25V210.8Z" fill="#CECECE" />
      <path d="M486.25 212.82H484.6V214.19H486.25V212.82Z" fill="#CECECE" />
      <path d="M486.25 214.84H484.6V216.21H486.25V214.84Z" fill="#CECECE" />
      <path d="M486.25 216.86H484.6V218.23H486.25V216.86Z" fill="#CECECE" />
      <path d="M486.25 218.88H484.6V220.25H486.25V218.88Z" fill="#CECECE" />
      <path d="M483.03 174.29H481.39V175.66H483.03V174.29Z" fill="#CECECE" />
      <path d="M483.03 176.48H481.39V177.85H483.03V176.48Z" fill="#CECECE" />
      <path d="M483.03 178.5H481.39V179.87H483.03V178.5Z" fill="#CECECE" />
      <path d="M483.03 180.52H481.39V181.89H483.03V180.52Z" fill="#CECECE" />
      <path d="M483.03 182.54H481.39V183.91H483.03V182.54Z" fill="#CECECE" />
      <path d="M483.03 184.55H481.39V185.92H483.03V184.55Z" fill="#CECECE" />
      <path d="M483.03 186.57H481.39V187.94H483.03V186.57Z" fill="#CECECE" />
      <path d="M483.03 188.59H481.39V189.96H483.03V188.59Z" fill="#CECECE" />
      <path d="M483.03 192.63H481.39V194H483.03V192.63Z" fill="#CECECE" />
      <path d="M483.03 194.65H481.39V196.02H483.03V194.65Z" fill="#CECECE" />
      <path d="M483.03 196.67H481.39V198.04H483.03V196.67Z" fill="#CECECE" />
      <path d="M483.03 198.69H481.39V200.06H483.03V198.69Z" fill="#CECECE" />
      <path d="M483.03 200.71H481.39V202.08H483.03V200.71Z" fill="#CECECE" />
      <path d="M483.03 202.72H481.39V204.09H483.03V202.72Z" fill="#CECECE" />
      <path d="M483.03 204.74H481.39V206.11H483.03V204.74Z" fill="#CECECE" />
      <path d="M483.03 206.76H481.39V208.13H483.03V206.76Z" fill="#CECECE" />
      <path d="M483.03 208.78H481.39V210.15H483.03V208.78Z" fill="#CECECE" />
      <path d="M483.03 210.8H481.39V212.17H483.03V210.8Z" fill="#CECECE" />
      <path d="M483.03 212.82H481.39V214.19H483.03V212.82Z" fill="#CECECE" />
      <path d="M483.03 214.84H481.39V216.21H483.03V214.84Z" fill="#CECECE" />
      <path d="M479.83 174.29H478.18V175.66H479.83V174.29Z" fill="#CECECE" />
      <path d="M479.83 176.48H478.18V177.85H479.83V176.48Z" fill="#CECECE" />
      <path d="M479.83 178.5H478.18V179.87H479.83V178.5Z" fill="#CECECE" />
      <path d="M479.83 180.52H478.18V181.89H479.83V180.52Z" fill="#CECECE" />
      <path d="M479.83 184.55H478.18V185.92H479.83V184.55Z" fill="#CECECE" />
      <path d="M479.83 188.59H478.18V189.96H479.83V188.59Z" fill="#CECECE" />
      <path d="M479.83 190.61H478.18V191.98H479.83V190.61Z" fill="#CECECE" />
      <path d="M479.83 192.63H478.18V194H479.83V192.63Z" fill="#CECECE" />
      <path d="M479.83 194.65H478.18V196.02H479.83V194.65Z" fill="#CECECE" />
      <path d="M479.83 196.67H478.18V198.04H479.83V196.67Z" fill="#CECECE" />
      <path d="M479.83 202.72H478.18V204.09H479.83V202.72Z" fill="#CECECE" />
      <path d="M479.83 204.74H478.18V206.11H479.83V204.74Z" fill="#CECECE" />
      <path d="M479.83 206.76H478.18V208.13H479.83V206.76Z" fill="#CECECE" />
      <path d="M479.83 208.78H478.18V210.15H479.83V208.78Z" fill="#CECECE" />
      <path d="M479.83 214.84H478.18V216.21H479.83V214.84Z" fill="#CECECE" />
      <path d="M479.83 216.86H478.18V218.23H479.83V216.86Z" fill="#CECECE" />
      <path d="M499.08 220.97H497.44V222.34H499.08V220.97Z" fill="#CECECE" />
      <path d="M499.08 225H497.44V226.37H499.08V225Z" fill="#CECECE" />
      <path d="M495.87 218.95H494.23V220.32H495.87V218.95Z" fill="#CECECE" />
      <path d="M495.87 222.98H494.23V224.35H495.87V222.98Z" fill="#CECECE" />
      <path d="M495.87 225H494.23V226.37H495.87V225Z" fill="#CECECE" />
      <path d="M495.87 227.02H494.23V228.39H495.87V227.02Z" fill="#CECECE" />
      <path d="M495.87 229.04H494.23V230.41H495.87V229.04Z" fill="#CECECE" />
      <path d="M492.67 220.97H491.02V222.34H492.67V220.97Z" fill="#CECECE" />
      <path d="M492.67 227.02H491.02V228.39H492.67V227.02Z" fill="#CECECE" />
      <path d="M492.67 229.04H491.02V230.41H492.67V229.04Z" fill="#CECECE" />
      <path d="M489.46 222.98H487.81V224.35H489.46V222.98Z" fill="#CECECE" />
      <path d="M489.46 225H487.81V226.37H489.46V225Z" fill="#CECECE" />
      <path d="M486.25 218.95H484.6V220.32H486.25V218.95Z" fill="#CECECE" />
      <path d="M486.25 225H484.6V226.37H486.25V225Z" fill="#CECECE" />
      <path d="M486.25 227.02H484.6V228.39H486.25V227.02Z" fill="#CECECE" />
      <path d="M483.03 218.95H481.39V220.32H483.03V218.95Z" fill="#CECECE" />
      <path d="M483.03 220.97H481.39V222.34H483.03V220.97Z" fill="#CECECE" />
      <path d="M483.03 227.02H481.39V228.39H483.03V227.02Z" fill="#CECECE" />
      <path d="M502.29 227.27H500.65V228.64H502.29V227.27Z" fill="#CECECE" />
      <path d="M502.29 229.29H500.65V230.66H502.29V229.29Z" fill="#CECECE" />
      <path d="M658.8 182.66H657.08V184.1H658.8V182.66Z" fill="#CECECE" />
      <path d="M658.8 184.78H657.08V186.22H658.8V184.78Z" fill="#CECECE" />
      <path d="M658.8 189.01H657.08V190.45H658.8V189.01Z" fill="#CECECE" />
      <path d="M658.8 191.13H657.08V192.57H658.8V191.13Z" fill="#CECECE" />
      <path d="M658.8 193.25H657.08V194.69H658.8V193.25Z" fill="#CECECE" />
      <path d="M658.8 195.36H657.08V196.8H658.8V195.36Z" fill="#CECECE" />
      <path d="M658.8 197.48H657.08V198.92H658.8V197.48Z" fill="#CECECE" />
      <path d="M658.8 199.6H657.08V201.04H658.8V199.6Z" fill="#CECECE" />
      <path d="M658.8 201.72H657.08V203.16H658.8V201.72Z" fill="#CECECE" />
      <path d="M658.8 203.83H657.08V205.27H658.8V203.83Z" fill="#CECECE" />
      <path d="M658.8 208.07H657.08V209.51H658.8V208.07Z" fill="#CECECE" />
      <path d="M658.8 212.31H657.08V213.75H658.8V212.31Z" fill="#CECECE" />
      <path d="M661.6 182.66H659.88V184.1H661.6V182.66Z" fill="#CECECE" />
      <path d="M661.6 184.78H659.88V186.22H661.6V184.78Z" fill="#CECECE" />
      <path d="M661.6 186.89H659.88V188.33H661.6V186.89Z" fill="#CECECE" />
      <path d="M661.6 189.01H659.88V190.45H661.6V189.01Z" fill="#CECECE" />
      <path d="M661.6 191.13H659.88V192.57H661.6V191.13Z" fill="#CECECE" />
      <path d="M661.6 197.48H659.88V198.92H661.6V197.48Z" fill="#CECECE" />
      <path d="M661.6 199.6H659.88V201.04H661.6V199.6Z" fill="#CECECE" />
      <path d="M661.6 201.72H659.88V203.16H661.6V201.72Z" fill="#CECECE" />
      <path d="M661.6 205.95H659.88V207.39H661.6V205.95Z" fill="#CECECE" />
      <path d="M661.6 208.07H659.88V209.51H661.6V208.07Z" fill="#CECECE" />
      <path d="M661.6 210.19H659.88V211.63H661.6V210.19Z" fill="#CECECE" />
      <path d="M661.6 212.31H659.88V213.75H661.6V212.31Z" fill="#CECECE" />
      <path d="M664.4 182.66H662.68V184.1H664.4V182.66Z" fill="#CECECE" />
      <path d="M664.4 184.78H662.68V186.22H664.4V184.78Z" fill="#CECECE" />
      <path d="M667.12 184.78H665.4V186.22H667.12V184.78Z" fill="#CECECE" />
      <path d="M664.4 186.89H662.68V188.33H664.4V186.89Z" fill="#CECECE" />
      <path d="M664.4 189.01H662.68V190.45H664.4V189.01Z" fill="#CECECE" />
      <path d="M664.4 191.13H662.68V192.57H664.4V191.13Z" fill="#CECECE" />
      <path d="M664.4 195.36H662.68V196.8H664.4V195.36Z" fill="#CECECE" />
      <path d="M664.4 199.6H662.68V201.04H664.4V199.6Z" fill="#CECECE" />
      <path d="M664.4 201.72H662.68V203.16H664.4V201.72Z" fill="#CECECE" />
      <path d="M664.4 203.83H662.68V205.27H664.4V203.83Z" fill="#CECECE" />
      <path d="M664.4 205.95H662.68V207.39H664.4V205.95Z" fill="#CECECE" />
      <path d="M664.4 208.07H662.68V209.51H664.4V208.07Z" fill="#CECECE" />
      <path d="M667.21 182.66H665.48V184.1H667.21V182.66Z" fill="#CECECE" />
      <path d="M667.21 189.01H665.48V190.45H667.21V189.01Z" fill="#CECECE" />
      <path d="M667.21 191.13H665.48V192.57H667.21V191.13Z" fill="#CECECE" />
      <path d="M667.21 193.25H665.48V194.69H667.21V193.25Z" fill="#CECECE" />
      <path d="M667.21 195.36H665.48V196.8H667.21V195.36Z" fill="#CECECE" />
      <path d="M667.21 197.48H665.48V198.92H667.21V197.48Z" fill="#CECECE" />
      <path d="M667.21 199.6H665.48V201.04H667.21V199.6Z" fill="#CECECE" />
      <path d="M667.21 203.83H665.48V205.27H667.21V203.83Z" fill="#CECECE" />
      <path d="M667.21 205.95H665.48V207.39H667.21V205.95Z" fill="#CECECE" />
      <path d="M667.21 208.07H665.48V209.51H667.21V208.07Z" fill="#CECECE" />
      <path d="M667.21 210.19H665.48V211.63H667.21V210.19Z" fill="#CECECE" />
      <path d="M667.21 212.31H665.48V213.75H667.21V212.31Z" fill="#CECECE" />
      <path d="M670.01 184.78H668.28V186.22H670.01V184.78Z" fill="#CECECE" />
      <path d="M670.01 186.89H668.28V188.33H670.01V186.89Z" fill="#CECECE" />
      <path d="M670.01 189.01H668.28V190.45H670.01V189.01Z" fill="#CECECE" />
      <path d="M670.01 193.25H668.28V194.69H670.01V193.25Z" fill="#CECECE" />
      <path d="M670.01 197.48H668.28V198.92H670.01V197.48Z" fill="#CECECE" />
      <path d="M670.01 199.6H668.28V201.04H670.01V199.6Z" fill="#CECECE" />
      <path d="M670.01 201.72H668.28V203.16H670.01V201.72Z" fill="#CECECE" />
      <path d="M670.01 210.19H668.28V211.63H670.01V210.19Z" fill="#CECECE" />
      <path d="M670.01 214.42H668.28V215.86H670.01V214.42Z" fill="#CECECE" />
      <path d="M675.59 184.78H673.87V186.22H675.59V184.78Z" fill="#CECECE" />
      <path d="M675.59 186.89H673.87V188.33H675.59V186.89Z" fill="#CECECE" />
      <path d="M675.59 189.01H673.87V190.45H675.59V189.01Z" fill="#CECECE" />
      <path d="M675.59 191.13H673.87V192.57H675.59V191.13Z" fill="#CECECE" />
      <path d="M675.59 193.25H673.87V194.69H675.59V193.25Z" fill="#CECECE" />
      <path d="M675.59 195.36H673.87V196.8H675.59V195.36Z" fill="#CECECE" />
      <path d="M675.59 197.48H673.87V198.92H675.59V197.48Z" fill="#CECECE" />
      <path d="M675.59 199.6H673.87V201.04H675.59V199.6Z" fill="#CECECE" />
      <path d="M675.59 201.72H673.87V203.16H675.59V201.72Z" fill="#CECECE" />
      <path d="M675.59 203.83H673.87V205.27H675.59V203.83Z" fill="#CECECE" />
      <path d="M675.59 205.95H673.87V207.39H675.59V205.95Z" fill="#CECECE" />
      <path d="M675.59 208.07H673.87V209.51H675.59V208.07Z" fill="#CECECE" />
      <path d="M678.4 182.66H676.67V184.1H678.4V182.66Z" fill="#CECECE" />
      <path d="M678.4 184.78H676.67V186.22H678.4V184.78Z" fill="#CECECE" />
      <path d="M678.4 186.89H676.67V188.33H678.4V186.89Z" fill="#CECECE" />
      <path d="M680.82 186.89H679.09V188.33H680.82V186.89Z" fill="#CECECE" />
      <path d="M678.4 189.01H676.67V190.45H678.4V189.01Z" fill="#CECECE" />
      <path d="M678.4 195.36H676.67V196.8H678.4V195.36Z" fill="#CECECE" />
      <path d="M678.4 197.48H676.67V198.92H678.4V197.48Z" fill="#CECECE" />
      <path d="M678.4 199.6H676.67V201.04H678.4V199.6Z" fill="#CECECE" />
      <path d="M678.4 201.72H676.67V203.16H678.4V201.72Z" fill="#CECECE" />
      <path d="M678.4 208.07H676.67V209.51H678.4V208.07Z" fill="#CECECE" />
      <path d="M678.4 210.19H676.67V211.63H678.4V210.19Z" fill="#CECECE" />
      <path d="M678.4 212.31H676.67V213.75H678.4V212.31Z" fill="#CECECE" />
      <path d="M661.6 214.5H659.88V215.94H661.6V214.5Z" fill="#CECECE" />
      <path d="M661.6 218.73H659.88V220.17H661.6V218.73Z" fill="#CECECE" />
      <path d="M664.4 212.38H662.68V213.82H664.4V212.38Z" fill="#CECECE" />
      <path d="M664.4 216.62H662.68V218.06H664.4V216.62Z" fill="#CECECE" />
      <path d="M664.4 218.73H662.68V220.17H664.4V218.73Z" fill="#CECECE" />
      <path d="M664.4 220.85H662.68V222.29H664.4V220.85Z" fill="#CECECE" />
      <path d="M664.4 222.97H662.68V224.41H664.4V222.97Z" fill="#CECECE" />
      <path d="M667.21 214.5H665.48V215.94H667.21V214.5Z" fill="#CECECE" />
      <path d="M667.21 220.85H665.48V222.29H667.21V220.85Z" fill="#CECECE" />
      <path d="M667.21 222.97H665.48V224.41H667.21V222.97Z" fill="#CECECE" />
      <path d="M670.01 216.62H668.28V218.06H670.01V216.62Z" fill="#CECECE" />
      <path d="M670.01 218.73H668.28V220.17H670.01V218.73Z" fill="#CECECE" />
      <path d="M672.8 218.73H671.07V220.17H672.8V218.73Z" fill="#CECECE" />
      <path d="M672.8 220.85H671.07V222.29H672.8V220.85Z" fill="#CECECE" />
      <path d="M672.8 222.97H671.07V224.41H672.8V222.97Z" fill="#CECECE" />
      <path d="M675.59 212.38H673.87V213.82H675.59V212.38Z" fill="#CECECE" />
      <path d="M675.59 214.5H673.87V215.94H675.59V214.5Z" fill="#CECECE" />
      <path d="M675.59 216.62H673.87V218.06H675.59V216.62Z" fill="#CECECE" />
      <path d="M675.59 220.85H673.87V222.29H675.59V220.85Z" fill="#CECECE" />
      <path d="M658.8 221.12H657.08V222.56H658.8V221.12Z" fill="#CECECE" />
      <path d="M658.8 223.23H657.08V224.67H658.8V223.23Z" fill="#CECECE" />
      <path d="M678.4 212.38H676.67V213.82H678.4V212.38Z" fill="#CECECE" />
      <path d="M678.4 218.73H676.67V220.17H678.4V218.73Z" fill="#CECECE" />
      <path d="M680.82 182.66H679.09V184.1H680.82V182.66Z" fill="#CECECE" />
      <path d="M680.82 184.78H679.09V186.22H680.82V184.78Z" fill="#CECECE" />
      <path d="M680.82 189.01H679.09V190.45H680.82V189.01Z" fill="#CECECE" />
      <path d="M680.82 191.13H679.09V192.57H680.82V191.13Z" fill="#CECECE" />
      <path d="M680.82 193.25H679.09V194.69H680.82V193.25Z" fill="#CECECE" />
      <path d="M680.82 195.36H679.09V196.8H680.82V195.36Z" fill="#CECECE" />
      <path d="M680.82 197.48H679.09V198.92H680.82V197.48Z" fill="#CECECE" />
      <path d="M680.82 201.72H679.09V203.16H680.82V201.72Z" fill="#CECECE" />
      <path d="M680.82 203.83H679.09V205.27H680.82V203.83Z" fill="#CECECE" />
      <path d="M680.82 205.95H679.09V207.39H680.82V205.95Z" fill="#CECECE" />
      <path d="M680.82 208.07H679.09V209.51H680.82V208.07Z" fill="#CECECE" />
      <path d="M680.82 210.19H679.09V211.63H680.82V210.19Z" fill="#CECECE" />
      <path d="M680.82 212.31H679.09V213.75H680.82V212.31Z" fill="#CECECE" />
      <path d="M683.62 180.54H659.88V181.98H683.62V180.54Z" fill="#CECECE" />
      <path d="M683.62 182.66H681.89V188.34H683.62V182.66Z" fill="#CECECE" />
      <path d="M683.62 189.01H681.89V190.45H683.62V189.01Z" fill="#CECECE" />
      <path d="M683.62 191.13H681.89V192.57H683.62V191.13Z" fill="#CECECE" />
      <path d="M683.62 193.25H681.89V194.69H683.62V193.25Z" fill="#CECECE" />
      <path d="M683.62 195.36H681.89V196.8H683.62V195.36Z" fill="#CECECE" />
      <path d="M683.62 197.48H681.89V198.92H683.62V197.48Z" fill="#CECECE" />
      <path d="M683.62 199.6H681.89V201.04H683.62V199.6Z" fill="#CECECE" />
      <path d="M683.62 201.72H681.89V203.16H683.62V201.72Z" fill="#CECECE" />
      <path d="M683.62 203.83H681.89V205.27H683.62V203.83Z" fill="#CECECE" />
      <path d="M683.62 205.95H681.89V207.39H683.62V205.95Z" fill="#CECECE" />
      <path d="M683.62 208.07H681.89V209.51H683.62V208.07Z" fill="#CECECE" />
      <path d="M686.42 180.54H684.69V181.98H686.42V180.54Z" fill="#CECECE" />
      <path d="M686.42 199.6H684.69V201.04H686.42V199.6Z" fill="#CECECE" />
      <path d="M686.42 201.72H684.69V203.16H686.42V201.72Z" fill="#CECECE" />
      <path d="M686.42 208.07H684.69V209.51H686.42V208.07Z" fill="#CECECE" />
      <path d="M680.82 212.38H679.09V213.82H680.82V212.38Z" fill="#CECECE" />
      <path d="M680.82 218.73H679.09V220.17H680.82V218.73Z" fill="#CECECE" />
      <path d="M680.82 220.85H679.09V222.29H680.82V220.85Z" fill="#CECECE" />
      <path d="M680.82 222.97H679.09V224.41H680.82V222.97Z" fill="#CECECE" />
      <path d="M683.62 212.38H681.89V213.82H683.62V212.38Z" fill="#CECECE" />
      <path d="M683.62 214.5H681.89V215.94H683.62V214.5Z" fill="#CECECE" />
      <path d="M683.62 216.62H681.89V218.06H683.62V216.62Z" fill="#CECECE" />
      <path d="M683.62 220.85H681.89V222.29H683.62V220.85Z" fill="#CECECE" />
      <path d="M675.59 225.04H673.87V226.48H675.59V225.04Z" fill="#CECECE" />
      <path d="M675.59 227.16H673.87V228.6H675.59V227.16Z" fill="#CECECE" />
      <path d="M672.8 227.16H671.07V228.6H672.8V227.16Z" fill="#CECECE" />
      <path d="M675.59 229.27H673.87V230.71H675.59V229.27Z" fill="#CECECE" />
      <path d="M678.4 229.27H676.67V230.71H678.4V229.27Z" fill="#CECECE" />
      <path d="M678.4 233.51H676.67V234.95H678.4V233.51Z" fill="#CECECE" />
      <path d="M675.59 235.7H673.87V237.14H675.59V235.7Z" fill="#CECECE" />
      <path d="M678.4 233.58H676.67V235.02H678.4V233.58Z" fill="#CECECE" />
      <path d="M678.4 237.66H676.67V239.1H678.4V237.66Z" fill="#CECECE" />
      <path d="M680.82 227.16H679.09V228.6H680.82V227.16Z" fill="#CECECE" />
      <path d="M680.82 231.39H679.09V232.83H680.82V231.39Z" fill="#CECECE" />
      <path d="M680.82 233.51H679.09V234.95H680.82V233.51Z" fill="#CECECE" />
      <path d="M683.62 225.04H681.89V226.48H683.62V225.04Z" fill="#CECECE" />
      <path d="M683.62 229.27H681.89V230.71H683.62V229.27Z" fill="#CECECE" />
      <path d="M686.42 229.27H684.69V230.71H686.42V229.27Z" fill="#CECECE" />
      <path d="M686.42 233.51H684.69V234.95H686.42V233.51Z" fill="#CECECE" />
      <path d="M680.82 233.58H679.09V235.02H680.82V233.58Z" fill="#CECECE" />
      <path d="M680.82 239.78H679.09V241.22H680.82V239.78Z" fill="#CECECE" />
      <path d="M683.62 233.58H681.89V235.02H683.62V233.58Z" fill="#CECECE" />
      <path d="M683.62 235.7H681.89V237.14H683.62V235.7Z" fill="#CECECE" />
      <path d="M683.62 242.05H681.89V243.49H683.62V242.05Z" fill="#CECECE" />
      <path d="M683.62 244.3H681.89V245.74H683.62V244.3Z" fill="#CECECE" />
      <path d="M683.62 237.9H681.89V239.34H683.62V237.9Z" fill="#CECECE" />
      <path d="M686.42 233.58H684.69V235.02H686.42V233.58Z" fill="#CECECE" />
      <path d="M682.94 145.17H682.23V148.95H682.94V145.17Z" fill="#CECECE" />
      <path d="M684.32 145.17H683.61V148.95H684.32V145.17Z" fill="#CECECE" />
      <path d="M681.59 145.17H680.85V148.95H681.59V145.17Z" fill="#CECECE" />
      <path d="M650.2 198.79H648.55V200.13H650.2V198.79Z" fill="#CECECE" />
      <path
        d="M648.55 196.58L650.2 196.6V197.96L649.38 197.94L648.55 197.93V196.58Z"
        fill="#CECECE"
      />
      <path
        d="M648.55 194.36L650.2 194.41V195.78L649.38 195.76L648.55 195.73V194.36Z"
        fill="#CECECE"
      />
      <path
        d="M648.55 192.15L650.2 192.22V193.61L649.38 193.57L648.55 193.54V192.15Z"
        fill="#CECECE"
      />
      <path
        d="M648.55 189.93L650.2 190.03V191.44L649.38 191.39L648.55 191.34V189.93Z"
        fill="#CECECE"
      />
      <path
        d="M648.55 187.72L650.2 187.84V189.27L649.38 189.21L648.55 189.14V187.72Z"
        fill="#CECECE"
      />
      <path
        d="M648.55 185.5L650.2 185.65V187.1L649.38 187.02L648.55 186.95V185.5Z"
        fill="#CECECE"
      />
      <path
        d="M648.55 181.07L650.2 181.27V182.75L649.38 182.65L648.55 182.55V181.07Z"
        fill="#CECECE"
      />
      <path
        d="M648.55 178.86L650.2 179.08V180.58L649.38 180.47L648.55 180.36V178.86Z"
        fill="#CECECE"
      />
      <path
        d="M648.55 176.64L650.2 176.89V178.41L649.38 178.29L648.55 178.16V176.64Z"
        fill="#CECECE"
      />
      <path
        d="M648.55 174.43L650.2 174.7V176.24L649.38 176.1L648.55 175.96V174.43Z"
        fill="#CECECE"
      />
      <path
        d="M648.55 172.22L650.2 172.5V174.07L649.38 173.92L648.55 173.77V172.22Z"
        fill="#CECECE"
      />
      <path
        d="M648.55 170V171.57L649.38 171.73L650.2 171.9V170.31L648.55 170Z"
        fill="#CECECE"
      />
      <path
        d="M651.24 196.62L652.89 196.64V198L652.06 197.98L651.24 197.97V196.62Z"
        fill="#CECECE"
      />
      <path
        d="M651.24 192.27L652.89 192.34V193.73L652.06 193.7L651.24 193.66V192.27Z"
        fill="#CECECE"
      />
      <path
        d="M651.24 190.09L652.88 190.19V191.6L652.06 191.55L651.24 191.5V190.09Z"
        fill="#CECECE"
      />
      <path
        d="M651.24 187.91L652.88 188.04V189.47L652.06 189.41L651.24 189.35V187.91Z"
        fill="#CECECE"
      />
      <path
        d="M651.24 185.74L652.88 185.88V187.34L652.06 187.27L651.24 187.19V185.74Z"
        fill="#CECECE"
      />
      <path
        d="M651.24 183.56L652.88 183.73V185.21L652.06 185.12L651.24 185.04V183.56Z"
        fill="#CECECE"
      />
      <path
        d="M651.24 181.39L652.88 181.58V183.08L652.06 182.98L651.24 182.88V181.39Z"
        fill="#CECECE"
      />
      <path
        d="M651.24 177.04L652.88 177.28V178.82L652.06 178.69L651.24 178.57V177.04Z"
        fill="#CECECE"
      />
      <path
        d="M651.24 172.69L652.88 172.98V174.56L652.06 174.41L651.24 174.26V172.69Z"
        fill="#CECECE"
      />
      <path
        d="M651.24 170.51V172.1L652.06 172.26L652.88 172.43V170.83L651.24 170.51Z"
        fill="#CECECE"
      />
      <path d="M655.61 198.79H653.96V200.13H655.61V198.79Z" fill="#CECECE" />
      <path
        d="M653.96 196.66L655.6 196.68V198.04L654.78 198.02L653.96 198.01V196.66Z"
        fill="#CECECE"
      />
      <path
        d="M653.96 194.52L655.6 194.57V195.95L654.78 195.92L653.96 195.9V194.52Z"
        fill="#CECECE"
      />
      <path
        d="M653.96 192.38L655.6 192.46V193.86L654.78 193.82L653.96 193.78V192.38Z"
        fill="#CECECE"
      />
      <path
        d="M653.96 188.11L655.6 188.23V189.68L654.78 189.62L653.96 189.55V188.11Z"
        fill="#CECECE"
      />
      <path
        d="M653.96 183.84L655.6 184.01V185.5L654.78 185.41L653.96 185.32V183.84Z"
        fill="#CECECE"
      />
      <path
        d="M653.96 181.71L655.6 181.9V183.41L654.78 183.31L653.96 183.21V181.71Z"
        fill="#CECECE"
      />
      <path
        d="M653.96 179.57L655.6 179.79V181.32L654.78 181.21L653.96 181.1V179.57Z"
        fill="#CECECE"
      />
      <path
        d="M653.96 177.44L655.6 177.68V179.23L654.78 179.11L653.96 178.98V177.44Z"
        fill="#CECECE"
      />
      <path
        d="M653.96 173.16L655.6 173.45V175.05L654.78 174.9L653.96 174.75V173.16Z"
        fill="#CECECE"
      />
      <path
        d="M653.96 171.03V172.64L654.78 172.8L655.6 172.96V171.34L653.96 171.03Z"
        fill="#CECECE"
      />
      <path d="M477.45 201.93H475.87V203.21H477.45V201.93Z" fill="#CECECE" />
      <path
        d="M477.45 199.8L475.87 199.82V201.13L476.66 201.11L477.45 201.1V199.8Z"
        fill="#CECECE"
      />
      <path
        d="M477.45 197.68L475.87 197.72V199.04L476.66 199.02L477.45 198.99V197.68Z"
        fill="#CECECE"
      />
      <path
        d="M477.45 195.55L475.87 195.62V196.96L476.66 196.92L477.45 196.88V195.55Z"
        fill="#CECECE"
      />
      <path
        d="M477.45 193.42L475.87 193.52V194.87L476.66 194.82L477.45 194.77V193.42Z"
        fill="#CECECE"
      />
      <path
        d="M477.45 191.3L475.87 191.41V192.79L476.66 192.73L477.45 192.67V191.3Z"
        fill="#CECECE"
      />
      <path
        d="M477.45 189.17L475.87 189.31V190.7L476.66 190.63L477.45 190.56V189.17Z"
        fill="#CECECE"
      />
      <path
        d="M477.45 184.92L475.87 185.1V186.53L476.66 186.43L477.45 186.34V184.92Z"
        fill="#CECECE"
      />
      <path
        d="M477.45 182.79L475.87 183V184.45L476.66 184.34L477.45 184.23V182.79Z"
        fill="#CECECE"
      />
      <path
        d="M477.45 180.66L475.87 180.9V182.36L476.66 182.24L477.45 182.12V180.66Z"
        fill="#CECECE"
      />
      <path
        d="M477.45 178.54L475.87 178.79V180.28L476.66 180.14L477.45 180.01V178.54Z"
        fill="#CECECE"
      />
      <path
        d="M477.45 176.41L475.87 176.69V178.19L476.66 178.05L477.45 177.9V176.41Z"
        fill="#CECECE"
      />
      <path
        d="M477.45 174.29V175.79L476.66 175.95L475.87 176.11V174.59L477.45 174.29Z"
        fill="#CECECE"
      />
      <path
        d="M474.87 199.84L473.29 199.86V201.16L474.08 201.15L474.87 201.14V199.84Z"
        fill="#CECECE"
      />
      <path
        d="M474.87 195.66L473.29 195.73V197.07L474.08 197.04L474.87 197V195.66Z"
        fill="#CECECE"
      />
      <path
        d="M474.87 193.57L473.3 193.67V195.03L474.08 194.98L474.87 194.93V193.57Z"
        fill="#CECECE"
      />
      <path
        d="M474.87 191.49L473.3 191.6V192.98L474.08 192.92L474.87 192.86V191.49Z"
        fill="#CECECE"
      />
      <path
        d="M474.87 189.4L473.3 189.54V190.94L474.08 190.86L474.87 190.79V189.4Z"
        fill="#CECECE"
      />
      <path
        d="M474.88 187.31L473.3 187.47V188.89L474.08 188.81L474.88 188.72V187.31Z"
        fill="#CECECE"
      />
      <path
        d="M474.88 185.22L473.3 185.4V186.84L474.08 186.75L474.88 186.65V185.22Z"
        fill="#CECECE"
      />
      <path
        d="M474.88 181.04L473.3 181.27V182.75L474.08 182.63L474.88 182.51V181.04Z"
        fill="#CECECE"
      />
      <path
        d="M474.88 176.87L473.3 177.14V178.66L474.08 178.52L474.88 178.37V176.87Z"
        fill="#CECECE"
      />
      <path
        d="M474.88 174.78V176.3L474.08 176.46L473.3 176.61V175.08L474.88 174.78Z"
        fill="#CECECE"
      />
      <path d="M472.27 201.93H470.69V203.21H472.27V201.93Z" fill="#CECECE" />
      <path
        d="M472.27 199.88L470.69 199.9V201.2L471.48 201.19L472.27 201.18V199.88Z"
        fill="#CECECE"
      />
      <path
        d="M472.27 197.83L470.69 197.87V199.2L471.48 199.17L472.27 199.15V197.83Z"
        fill="#CECECE"
      />
      <path
        d="M472.27 195.78L470.69 195.85V197.19L471.48 197.15L472.27 197.12V195.78Z"
        fill="#CECECE"
      />
      <path
        d="M472.27 191.68L470.69 191.79V193.18L471.48 193.12L472.27 193.06V191.68Z"
        fill="#CECECE"
      />
      <path
        d="M472.27 187.58L470.69 187.74V189.17L471.48 189.08L472.27 189V187.58Z"
        fill="#CECECE"
      />
      <path
        d="M472.27 185.53L470.69 185.71V187.16L471.48 187.06L472.27 186.97V185.53Z"
        fill="#CECECE"
      />
      <path
        d="M472.27 183.48L470.69 183.68V185.15L471.48 185.05L472.27 184.94V183.48Z"
        fill="#CECECE"
      />
      <path
        d="M472.27 181.42L470.69 181.66V183.15L471.48 183.03L472.27 182.91V181.42Z"
        fill="#CECECE"
      />
      <path
        d="M472.27 177.32L470.69 177.6V179.14L471.48 178.99L472.27 178.85V177.32Z"
        fill="#CECECE"
      />
      <path
        d="M472.27 175.27V176.82L471.48 176.97L470.69 177.13V175.58L472.27 175.27Z"
        fill="#CECECE"
      />
      <path
        d="M469.72 197.9L468.14 197.95V199.28L468.93 199.25L469.72 199.23V197.9Z"
        fill="#CECECE"
      />
      <path
        d="M469.72 195.89L468.14 195.96V197.31L468.93 197.27L469.72 197.24V195.89Z"
        fill="#CECECE"
      />
      <path
        d="M469.72 191.86L468.14 191.98V193.37L468.93 193.31L469.72 193.25V191.86Z"
        fill="#CECECE"
      />
      <path
        d="M469.72 189.85L468.14 189.99V191.4L468.93 191.33L469.72 191.26V189.85Z"
        fill="#CECECE"
      />
      <path
        d="M469.72 187.84L468.14 188V189.44L468.93 189.35L469.72 189.27V187.84Z"
        fill="#CECECE"
      />
      <path
        d="M469.72 185.82L468.14 186.01V187.47L468.93 187.37L469.72 187.28V185.82Z"
        fill="#CECECE"
      />
      <path
        d="M469.72 181.8L468.14 182.03V183.53L468.93 183.41L469.72 183.29V181.8Z"
        fill="#CECECE"
      />
      <path
        d="M469.72 179.78L468.14 180.04V181.57L468.93 181.43L469.72 181.3V179.78Z"
        fill="#CECECE"
      />
      <path
        d="M469.72 175.76V177.32L468.93 177.47L468.14 177.63V176.06L469.72 175.76Z"
        fill="#CECECE"
      />
      <path d="M477.45 209.38H475.87V210.66H477.45V209.38Z" fill="#CECECE" />
      <path
        d="M477.45 205.12L475.87 205.17V206.49L476.66 206.47L477.45 206.44V205.12Z"
        fill="#CECECE"
      />
      <path d="M472.27 209.38H470.69V210.66H472.27V209.38Z" fill="#CECECE" />
      <path
        d="M472.27 207.33L470.69 207.35V208.65L471.48 208.64L472.27 208.63V207.33Z"
        fill="#CECECE"
      />
      <path
        d="M469.72 205.35L468.14 205.4V206.72L468.93 206.7L469.72 206.68V205.35Z"
        fill="#CECECE"
      />
      <path
        d="M453.76 153.03L453.06 152.53V153.23L453.76 153.69V153.03Z"
        fill="#CECECE"
      />
      <path
        d="M453.06 154.93L453.76 155.38V154.7L453.06 154.22V154.93Z"
        fill="#CECECE"
      />
      <path
        d="M453.06 156.64L453.76 157.07V156.38L453.06 155.91V156.64Z"
        fill="#CECECE"
      />
      <path
        d="M453.06 158.34L453.76 158.76V158.05L453.06 157.6V158.34Z"
        fill="#CECECE"
      />
      <path
        d="M453.06 160.05L453.76 160.45V159.73L453.06 159.29V160.05Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 161.75L453.76 162.15V161.4L453.07 160.98V161.75Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 163.45L453.76 163.84V163.08L453.07 162.67V163.45Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 165.16L453.76 165.53V164.76L453.07 164.36V165.16Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 166.86L453.76 167.22V166.43L453.07 166.05V166.86Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 168.57L453.76 168.91V168.11L453.07 167.74V168.57Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 170.27L453.76 170.6V169.78L453.07 169.43V170.27Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 171.98L453.76 172.29V171.46L453.07 171.12V171.98Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 173.68L453.76 173.98V173.13L453.07 172.81V173.68Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 175.39L453.76 175.68V174.81L453.07 174.5V175.39Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 177.09L453.76 177.37V176.49L453.07 176.19V177.09Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 178.8L453.76 179.06V178.16L453.07 177.88V178.8Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 180.5L453.76 180.75V179.84L453.07 179.57V180.5Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 182.2L453.76 182.44V181.51L453.07 181.26V182.2Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 185.61L453.76 185.82V184.86L453.07 184.64V185.61Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 187.32L453.76 187.52V186.54L453.07 186.33V187.32Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 192.43L453.76 192.59V191.57L453.07 191.4V192.43Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 195.84L453.76 195.97V194.92L453.07 194.78V195.84Z"
        fill="#CECECE"
      />
      <path
        d="M453.07 197.55L453.76 197.66V196.59L453.07 196.47V197.55Z"
        fill="#CECECE"
      />
      <path
        d="M453.08 200.95L453.76 201.05V199.95L453.08 199.85V200.95Z"
        fill="#CECECE"
      />
      <path
        d="M453.08 202.66L453.76 202.74V201.62L453.08 201.54V202.66Z"
        fill="#CECECE"
      />
      <path
        d="M453.08 206.07L453.76 206.12V204.97L453.08 204.92V206.07Z"
        fill="#CECECE"
      />
      <path
        d="M453.08 207.77L453.76 207.81V206.65L453.08 206.61V207.77Z"
        fill="#CECECE"
      />
      <path
        d="M453.08 211.18L453.76 211.2V210L453.08 209.99V211.18Z"
        fill="#CECECE"
      />
      <path
        d="M452.71 152.33L452.02 151.84V152.54L452.71 153V152.33Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 154.26L452.71 154.71V154.03L452.02 153.55V154.26Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 155.99L452.71 156.42V155.73L452.02 155.26V155.99Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 157.71L452.71 158.13V157.42L452.02 156.97V157.71Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 159.43L452.71 159.84V159.12L452.02 158.68V159.43Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 161.16L452.71 161.55V160.81L452.02 160.39V161.16Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 162.88L452.71 163.26V162.51L452.02 162.1V162.88Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 164.61L452.71 164.98V164.2L452.02 163.81V164.61Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 166.33L452.71 166.69V165.9L452.02 165.52V166.33Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 168.06L452.71 168.4V167.59L452.02 167.23V168.06Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 169.78L452.71 170.11V169.29L452.02 168.94V169.78Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 171.5L452.71 171.82V170.98L452.02 170.65V171.5Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 173.23L452.71 173.53V172.68L452.02 172.36V173.23Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 174.95L452.71 175.24V174.38L452.02 174.07V174.95Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 176.68L452.71 176.95V176.07L452.02 175.78V176.68Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 178.4L452.71 178.66V177.77L452.02 177.49V178.4Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 180.13L452.71 180.38V179.46L452.02 179.2V180.13Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 181.85L452.71 182.09V181.16L452.02 180.91V181.85Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 183.57L452.71 183.8V182.85L452.02 182.61V183.57Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 185.3L452.7 185.51V184.55L452.02 184.32V185.3Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 187.02L452.7 187.22V186.24L452.02 186.03V187.02Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 190.47L452.7 190.64V189.63L452.02 189.45V190.47Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 192.2L452.7 192.35V191.33L452.02 191.16V192.2Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 195.64L452.7 195.78V194.72L452.02 194.58V195.64Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 200.82L452.7 200.91V199.81L452.02 199.71V200.82Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 205.99L452.7 206.04V204.89L452.02 204.84V205.99Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 211.16L452.7 211.18V209.98L452.02 209.97V211.16Z"
        fill="#CECECE"
      />
      <path
        d="M452.02 214.85L452.7 214.87V213.67L452.02 213.66V214.85Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 216.58L451.66 216.6V215.4L450.98 215.39V216.58Z"
        fill="#CECECE"
      />
      <path
        d="M451.67 151.66L450.98 151.16V151.86L451.67 152.32V151.66Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 153.6L451.67 154.05V153.37L450.98 152.89V153.6Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 155.35L451.67 155.78V155.09L450.98 154.62V155.35Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 157.09L451.67 157.51V156.8L450.98 156.35V157.09Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 158.83L451.67 159.24V158.51L450.98 158.08V158.83Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 160.58L451.67 160.97V160.23L450.98 159.81V160.58Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 162.32L451.67 162.7V161.94L450.98 161.54V162.32Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 164.06L451.67 164.43V163.66L450.98 163.27V164.06Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 165.81L451.67 166.16V165.37L450.98 165V165.81Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 167.55L451.67 167.89V167.09L450.98 166.72V167.55Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 169.29L451.67 169.62V168.8L450.98 168.45V169.29Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 172.78L451.67 173.08V172.23L450.98 171.91V172.78Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 176.27L451.67 176.55V175.66L450.98 175.37V176.27Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 178.01L451.66 178.28V177.38L450.98 177.1V178.01Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 179.76L451.66 180.01V179.09L450.98 178.83V179.76Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 181.5L451.66 181.74V180.81L450.98 180.56V181.5Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 183.24L451.66 183.47V182.52L450.98 182.28V183.24Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 186.73L451.66 186.93V185.95L450.98 185.74V186.73Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 190.22L451.66 190.39V189.38L450.98 189.2V190.22Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 191.96L451.66 192.12V191.1L450.98 190.93V191.96Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 193.71L451.66 193.85V192.81L450.98 192.66V193.71Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 195.45L451.66 195.58V194.53L450.98 194.39V195.45Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 198.94L451.66 199.04V197.96L450.98 197.85V198.94Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 202.42L451.66 202.5V201.39L450.98 201.3V202.42Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 204.17L451.66 204.23V203.1L450.98 203.03V204.17Z"
        fill="#CECECE"
      />
      <path
        d="M450.98 207.66L451.66 207.69V206.53L450.98 206.49V207.66Z"
        fill="#CECECE"
      />
      <path
        d="M450.6 150.99L449.91 150.5V151.2L450.6 151.66V150.99Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 152.96L450.6 153.41V152.73L449.91 152.25V152.96Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 156.48L450.6 156.9V156.19L449.91 155.75V156.48Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 158.25L450.6 158.65V157.93L449.91 157.49V158.25Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 160.01L450.6 160.4V159.66L449.91 159.24V160.01Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 161.77L450.6 162.15V161.4L449.91 160.99V161.77Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 165.3L450.6 165.65V164.86L449.91 164.48V165.3Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 167.06L450.6 167.4V166.6L449.91 166.23V167.06Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 168.82L450.6 169.15V168.33L449.91 167.98V168.82Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 170.58L450.6 170.9V170.07L449.91 169.73V170.58Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 172.35L450.6 172.65V171.8L449.91 171.48V172.35Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 174.11L450.6 174.4V173.53L449.91 173.22V174.11Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 175.87L450.6 176.15V175.27L449.91 174.97V175.87Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 177.63L450.6 177.9V177L449.91 176.72V177.63Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 181.16L450.59 181.4V180.47L449.91 180.21V181.16Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 182.92L450.59 183.15V182.2L449.91 181.96V182.92Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 184.68L450.59 184.9V183.94L449.91 183.71V184.68Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 186.45L450.59 186.64V185.67L449.91 185.46V186.45Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 189.97L450.59 190.14V189.14L449.91 188.95V189.97Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 193.5L450.59 193.64V192.6L449.91 192.45V193.5Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 195.26L450.59 195.39V194.34L449.91 194.2V195.26Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 198.79L450.59 198.89V197.81L449.91 197.69V198.79Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 202.31L450.59 202.39V201.27L449.91 201.19V202.31Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 204.07L450.59 204.14V203.01L449.91 202.94V204.07Z"
        fill="#CECECE"
      />
      <path
        d="M449.92 208.6L450.6 208.64V207.48L449.92 207.44V208.6Z"
        fill="#CECECE"
      />
      <path
        d="M449.91 209.36L450.58 209.39V208.21L449.91 208.18V209.36Z"
        fill="#CECECE"
      />
      <path d="M450.59 211.68H449.91V212.89H450.59V211.68Z" fill="#CECECE" />
      <path
        d="M449.5 150.32L448.8 149.83V150.53L449.5 150.99V150.32Z"
        fill="#CECECE"
      />
      <path
        d="M448.8 152.31L449.5 152.76V152.08L448.8 151.6V152.31Z"
        fill="#CECECE"
      />
      <path
        d="M448.8 154.09L449.5 154.53V153.83L448.8 153.36V154.09Z"
        fill="#CECECE"
      />
      <path
        d="M448.8 155.87L449.5 156.3V155.58L448.8 155.13V155.87Z"
        fill="#CECECE"
      />
      <path
        d="M448.8 157.65L449.5 158.06V157.33L448.8 156.9V157.65Z"
        fill="#CECECE"
      />
      <path
        d="M448.8 159.43L449.5 159.83V159.09L448.8 158.66V159.43Z"
        fill="#CECECE"
      />
      <path
        d="M448.8 161.22L449.5 161.6V160.84L448.8 160.43V161.22Z"
        fill="#CECECE"
      />
      <path
        d="M448.8 163L449.5 163.37V162.59L448.8 162.2V163Z"
        fill="#CECECE"
      />
      <path
        d="M448.81 164.78L449.5 165.14V164.35L448.81 163.96V164.78Z"
        fill="#CECECE"
      />
      <path
        d="M448.81 166.56L449.5 166.91V166.1L448.81 165.73V166.56Z"
        fill="#CECECE"
      />
      <path
        d="M448.81 168.34L449.5 168.67V167.85L448.81 167.5V168.34Z"
        fill="#CECECE"
      />
      <path
        d="M448.81 170.13L449.5 170.44V169.61L448.81 169.27V170.13Z"
        fill="#CECECE"
      />
      <path
        d="M448.81 171.91L449.5 172.21V171.36L448.81 171.03V171.91Z"
        fill="#CECECE"
      />
      <path
        d="M448.81 173.69L449.5 173.98V173.11L448.81 172.8V173.69Z"
        fill="#CECECE"
      />
      <path
        d="M448.81 175.47L449.5 175.75V174.86L448.81 174.57V175.47Z"
        fill="#CECECE"
      />
      <path
        d="M448.81 177.25L449.5 177.52V176.62L448.81 176.33V177.25Z"
        fill="#CECECE"
      />
      <path
        d="M448.81 179.03L449.5 179.29V178.37L448.81 178.1V179.03Z"
        fill="#CECECE"
      />
      <path
        d="M448.81 180.82L449.5 181.05V180.12L448.81 179.87V180.82Z"
        fill="#CECECE"
      />
      <path
        d="M448.82 184.38L449.5 184.59V183.63L448.82 183.4V184.38Z"
        fill="#CECECE"
      />
      <path
        d="M448.82 186.16L449.5 186.36V185.38L448.82 185.17V186.16Z"
        fill="#CECECE"
      />
      <path
        d="M448.82 189.72L449.5 189.9V188.89L448.82 188.7V189.72Z"
        fill="#CECECE"
      />
      <path
        d="M448.82 191.51L449.5 191.66V190.64L448.82 190.47V191.51Z"
        fill="#CECECE"
      />
      <path
        d="M448.82 193.29L449.5 193.43V192.39L448.82 192.24V193.29Z"
        fill="#CECECE"
      />
      <path
        d="M448.82 196.85L449.51 196.97V195.9L448.82 195.77V196.85Z"
        fill="#CECECE"
      />
      <path
        d="M448.82 198.63L449.51 198.74V197.65L448.82 197.54V198.63Z"
        fill="#CECECE"
      />
      <path
        d="M448.83 200.41L449.51 200.51V199.41L448.83 199.31V200.41Z"
        fill="#CECECE"
      />
      <path
        d="M448.83 203.98L449.51 204.04V202.91L448.83 202.84V203.98Z"
        fill="#CECECE"
      />
      <path
        d="M448.83 207.54L449.51 207.58V206.42L448.83 206.37V207.54Z"
        fill="#CECECE"
      />
      <path
        d="M440.77 149.88L439.84 150.36V149.46L440.77 149V149.88Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 152.14L440.77 151.68V150.79L439.84 151.24V152.14Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 153.93L440.77 153.48V152.58L439.84 153.01V153.93Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 155.72L440.77 155.28V154.38L439.84 154.79V155.72Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 157.5L440.78 157.08V156.17L439.84 156.57V157.5Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 159.29L440.78 158.88V157.96L439.84 158.35V159.29Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 161.08L440.78 160.68V159.75L439.84 160.12V161.08Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 162.86L440.78 162.48V161.54L439.84 161.9V162.86Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 164.65L440.78 164.28V163.33L439.84 163.68V164.65Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 166.44L440.78 166.09V165.12L439.84 165.46V166.44Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 168.22L440.78 167.88V166.91L439.84 167.24V168.22Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 170.01L440.78 169.68V168.7L439.84 169.01V170.01Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 171.8L440.78 171.48V170.49L439.84 170.79V171.8Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 173.58L440.78 173.29V172.28L439.84 172.57V173.58Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 175.37L440.78 175.09V174.07L439.84 174.35V175.37Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 178.94L440.78 178.69V177.65L439.84 177.9V178.94Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 180.73L440.78 180.49V179.44L439.84 179.68V180.73Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 182.52L440.78 182.29V181.24L439.84 181.46V182.52Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 184.3L440.78 184.09V183.03L439.84 183.23V184.3Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 186.09L440.79 185.89V184.82L439.84 185.01V186.09Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 187.87L440.79 187.69V186.61L439.84 186.79V187.87Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 189.66L440.79 189.49V188.4L439.84 188.57V189.66Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 193.23L440.79 193.09V191.98L439.84 192.12V193.23Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 195.02L440.79 194.89V193.77L439.84 193.9V195.02Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 196.81L440.79 196.69V195.56L439.84 195.68V196.81Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 198.59L440.79 198.49V197.35L439.84 197.45V198.59Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 200.38L440.79 200.29V199.14L439.84 199.23V200.38Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 205.74L440.79 205.69V204.51L439.84 204.57V205.74Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 207.53L440.79 207.49V206.3L439.84 206.34V207.53Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 211.1L440.79 211.09V209.89L439.84 209.9V211.1Z"
        fill="#CECECE"
      />
      <path
        d="M439.39 150.58L438.62 151.09V150.28L439.39 149.72V150.58Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 152.86L439.39 152.36V151.49L438.61 152.03V152.86Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 154.62L439.39 154.14V153.26L438.61 153.78V154.62Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 156.39L439.4 155.92V155.03L438.61 155.54V156.39Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 158.16L439.4 157.7V156.8L438.61 157.29V158.16Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 159.92L439.4 159.48V158.57L438.61 159.05V159.92Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 161.69L439.4 161.26V160.34L438.61 160.8V161.69Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 163.45L439.4 163.04V162.11L438.61 162.56V163.45Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 165.22L439.4 164.82V163.88L438.61 164.31V165.22Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 166.98L439.4 166.6V165.65L438.61 166.06V166.98Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 168.75L439.4 168.38V167.42L438.61 167.82V168.75Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 174.05L439.41 173.72V172.73L438.61 173.08V174.05Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 175.81L439.41 175.5V174.5L438.61 174.84V175.81Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 177.58L439.41 177.28V176.27L438.61 176.59V177.58Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 179.34L439.41 179.06V178.04L438.61 178.34V179.34Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 181.11L439.41 180.84V179.81L438.61 180.1V181.11Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 182.87L439.41 182.62V181.58L438.61 181.85V182.87Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 184.64L439.41 184.4V183.35L438.61 183.61V184.64Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 188.17L439.42 187.96V186.89L438.61 187.12V188.17Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 191.7L439.42 191.52V190.43L438.61 190.62V191.7Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 195.23L439.42 195.08V193.97L438.61 194.13V195.23Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 198.76L439.42 198.65V197.51L438.61 197.64V198.76Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 200.53L439.42 200.43V199.28L438.61 199.4V200.53Z"
        fill="#CECECE"
      />
      <path
        d="M438.6 204.56L439.41 204.49V203.33L438.6 203.41V204.56Z"
        fill="#CECECE"
      />
      <path
        d="M438.61 205.82L439.43 205.77V204.6L438.61 204.66V205.82Z"
        fill="#CECECE"
      />
      <path
        d="M438.24 151.33L437.6 151.84V151.09L438.24 150.56V151.33Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 153.59L438.24 153.09V152.31L437.6 152.82V153.59Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 155.33L438.24 154.85V154.05L437.6 154.56V155.33Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 157.07L438.24 156.61V155.8L437.6 156.29V157.07Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 160.56L438.24 160.12V159.29L437.6 159.75V160.56Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 162.31L438.24 161.88V161.04L437.6 161.48V162.31Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 164.05L438.24 163.64V162.78L437.6 163.21V164.05Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 165.8L438.24 165.4V164.53L437.6 164.94V165.8Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 167.54L438.24 167.16V166.28L437.6 166.67V167.54Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 169.28L438.24 168.92V168.02L437.6 168.4V169.28Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 171.03L438.24 170.68V169.77L437.6 170.13V171.03Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 172.77L438.24 172.44V171.51L437.6 171.86V172.77Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 176.26L438.24 175.95V175.01L437.6 175.33V176.26Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 181.49L438.24 181.23V180.24L437.6 180.52V181.49Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 183.24L438.24 182.99V181.99L437.6 182.25V183.24Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 188.47L438.24 188.26V187.23L437.6 187.44V188.47Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 190.21L438.24 190.02V188.98L437.6 189.17V190.21Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 191.96L438.24 191.78V190.72L437.6 190.91V191.96Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 197.19L438.24 197.06V195.96L437.6 196.1V197.19Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 198.93L438.24 198.82V197.71L437.6 197.83V198.93Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 205.91L438.24 205.85V204.69L437.6 204.75V205.91Z"
        fill="#CECECE"
      />
      <path
        d="M437.6 211.14L438.24 211.13V209.93L437.6 209.95V211.14Z"
        fill="#CECECE"
      />
      <path
        d="M437.29 152.04L436.76 152.46V151.77L437.29 151.32V152.04Z"
        fill="#CECECE"
      />
      <path
        d="M436.76 154.19L437.29 153.78V153.05L436.76 153.48V154.19Z"
        fill="#CECECE"
      />
      <path
        d="M436.76 155.92L437.29 155.51V154.77L436.76 155.19V155.92Z"
        fill="#CECECE"
      />
      <path
        d="M436.76 157.64L437.29 157.25V156.5L436.76 156.9V157.64Z"
        fill="#CECECE"
      />
      <path
        d="M436.76 159.37L437.29 158.99V158.22L436.76 158.61V159.37Z"
        fill="#CECECE"
      />
      <path
        d="M436.76 161.09L437.29 160.73V159.95L436.76 160.32V161.09Z"
        fill="#CECECE"
      />
      <path
        d="M436.76 162.82L437.29 162.47V161.67L436.76 162.04V162.82Z"
        fill="#CECECE"
      />
      <path
        d="M436.76 164.55L437.29 164.21V163.39L436.76 163.75V164.55Z"
        fill="#CECECE"
      />
      <path
        d="M436.76 166.27L437.29 165.95V165.12L436.76 165.46V166.27Z"
        fill="#CECECE"
      />
      <path
        d="M436.76 168L437.29 167.68V166.84L436.76 167.17V168Z"
        fill="#CECECE"
      />
      <path
        d="M436.77 171.45L437.3 171.16V170.29L436.77 170.59V171.45Z"
        fill="#CECECE"
      />
      <path
        d="M436.77 173.18L437.3 172.9V172.02L436.77 172.31V173.18Z"
        fill="#CECECE"
      />
      <path
        d="M436.77 174.91L437.3 174.64V173.74L436.77 174.02V174.91Z"
        fill="#CECECE"
      />
      <path
        d="M436.77 176.63L437.3 176.38V175.46L436.77 175.73V176.63Z"
        fill="#CECECE"
      />
      <path
        d="M436.77 178.36L437.3 178.12V177.19L436.77 177.44V178.36Z"
        fill="#CECECE"
      />
      <path
        d="M436.77 180.08L437.3 179.85V178.91L436.77 179.15V180.08Z"
        fill="#CECECE"
      />
      <path
        d="M436.77 181.81L437.3 181.59V180.64L436.77 180.87V181.81Z"
        fill="#CECECE"
      />
      <path
        d="M436.77 183.54L437.3 183.33V182.36L436.77 182.58V183.54Z"
        fill="#CECECE"
      />
      <path
        d="M436.77 185.26L437.3 185.07V184.09L436.77 184.29V185.26Z"
        fill="#CECECE"
      />
      <path
        d="M436.77 188.72L437.3 188.55V187.54L436.77 187.71V188.72Z"
        fill="#CECECE"
      />
      <path
        d="M436.77 195.62L437.31 195.5V194.43L436.77 194.56V195.62Z"
        fill="#CECECE"
      />
      <path
        d="M436.77 197.35L437.31 197.24V196.16L436.77 196.27V197.35Z"
        fill="#CECECE"
      />
      <path
        d="M436.77 202.53L437.31 202.46V201.33L436.77 201.41V202.53Z"
        fill="#CECECE"
      />
      <path
        d="M436.77 204.25L437.31 204.19V203.05L436.77 203.12V204.25Z"
        fill="#CECECE"
      />
      <path
        d="M436.77 207.71L437.31 207.67V206.5L436.77 206.54V207.71Z"
        fill="#CECECE"
      />
      <path d="M437.32 211.68H436.78V212.89H437.32V211.68Z" fill="#CECECE" />
      <path
        d="M436.43 152.11L436.07 152.5V152.95L436.43 152.64V152.11Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 154.66L436.43 154.36V153.81L436.07 154.2V154.66Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 156.38L436.43 156.08V155.51L436.07 155.89V156.38Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 158.09L436.43 157.8V157.21L436.07 157.58V158.09Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 159.8L436.43 159.52V158.91L436.07 159.27V159.8Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 161.51L436.43 161.24V160.62L436.07 160.96V161.51Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 163.23L436.43 162.97V162.32L436.07 162.65V163.23Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 164.94L436.44 164.69V164.02L436.07 164.34V164.94Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 166.65L436.44 166.41V165.72L436.07 166.03V166.65Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 168.36L436.44 168.13V167.42L436.07 167.72V168.36Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 170.08L436.44 169.85V169.13L436.07 169.41V170.08Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 171.79L436.44 171.57V170.83L436.07 171.1V171.79Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 173.5L436.44 173.29V172.53L436.07 172.79V173.5Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 175.21L436.44 175.02V174.23L436.07 174.48V175.21Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 176.93L436.44 176.74V175.93L436.07 176.17V176.93Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 178.64L436.44 178.46V177.64L436.07 177.86V178.64Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 180.35L436.44 180.18V179.34L436.07 179.55V180.35Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 182.06L436.44 181.9V181.04L436.07 181.24V182.06Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 185.49L436.45 185.34V184.44L436.07 184.63V185.49Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 188.91L436.45 188.79V187.85L436.07 188.01V188.91Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 190.62L436.45 190.51V189.55L436.07 189.7V190.62Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 192.34L436.45 192.23V191.25L436.07 191.39V192.34Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 195.76L436.45 195.67V194.66L436.07 194.77V195.76Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 197.47L436.45 197.39V196.36L436.07 196.46V197.47Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 200.9L436.46 200.84V199.76L436.07 199.84V200.9Z"
        fill="#CECECE"
      />
      <path
        d="M436.07 204.32L436.46 204.28V203.17L436.07 203.22V204.32Z"
        fill="#CECECE"
      />
      <path
        d="M444.99 148.53V149.35L445.98 149.49V148.71C445.98 148.71 445.23 148.56 444.99 148.52V148.53Z"
        fill="#CECECE"
      />
      <path
        d="M444.99 151.17L445.98 151.31V150.52C445.98 150.52 445.23 150.38 444.99 150.34V151.17Z"
        fill="#CECECE"
      />
      <path
        d="M445 152.98L445.98 153.11V152.31C445.98 152.31 445.22 152.17 445 152.13V152.98Z"
        fill="#CECECE"
      />
      <path
        d="M445 154.8L445.98 154.93V154.11C445.98 154.11 445.22 153.98 445 153.94V154.8Z"
        fill="#CECECE"
      />
      <path
        d="M445 156.61L445.98 156.73V155.9C445.98 155.9 445.21 155.77 445 155.74V156.61Z"
        fill="#CECECE"
      />
      <path
        d="M445 158.43L445.98 158.55V157.71C445.98 157.71 445.21 157.58 445 157.55V158.43Z"
        fill="#CECECE"
      />
      <path
        d="M445 160.24L445.98 160.36V159.51C445.98 159.51 445.2 159.39 445 159.36V160.25V160.24Z"
        fill="#CECECE"
      />
      <path
        d="M445 162.06L445.97 162.17V161.3C445.97 161.3 445.19 161.18 445 161.15V162.05V162.06Z"
        fill="#CECECE"
      />
      <path
        d="M445 163.87L445.97 163.98V163.1C445.97 163.1 445.18 162.99 445 162.96V163.87Z"
        fill="#CECECE"
      />
      <path
        d="M445 165.69L445.97 165.8V164.91C445.97 164.91 445.18 164.8 445 164.77V165.69Z"
        fill="#CECECE"
      />
      <path
        d="M445 167.51L445.97 167.61V166.71C445.97 166.71 445.17 166.61 445 166.58V167.51Z"
        fill="#CECECE"
      />
      <path
        d="M445 169.32L445.97 169.42V168.51C445.97 168.51 445.17 168.41 445 168.38V169.33V169.32Z"
        fill="#CECECE"
      />
      <path
        d="M445 171.14L445.97 171.23V170.3C445.97 170.3 445.16 170.2 445 170.18V171.14Z"
        fill="#CECECE"
      />
      <path
        d="M445 172.95L445.96 173.04V172.1C445.96 172.1 445.15 172.01 445 171.98V172.95Z"
        fill="#CECECE"
      />
      <path
        d="M445.01 174.77L445.97 174.85V173.9C445.97 173.9 445.15 173.81 445.01 173.79V174.77Z"
        fill="#CECECE"
      />
      <path
        d="M445.01 176.58L445.97 176.66V175.7C445.97 175.7 445.15 175.62 445.01 175.59V176.58Z"
        fill="#CECECE"
      />
      <path
        d="M445.01 178.4L445.97 178.48V177.5C445.97 177.5 445.14 177.42 445.01 177.4V178.4Z"
        fill="#CECECE"
      />
      <path
        d="M445.01 180.21L445.97 180.28V179.29C445.97 179.29 445.14 179.21 445.01 179.19V180.2V180.21Z"
        fill="#CECECE"
      />
      <path
        d="M445.01 182.03L445.96 182.1V181.1C445.96 181.1 445.12 181.03 445.01 181.01V182.03Z"
        fill="#CECECE"
      />
      <path
        d="M445.01 183.84L445.96 183.9V182.89C445.96 182.89 445.12 182.82 445.01 182.8V183.83V183.84Z"
        fill="#CECECE"
      />
      <path
        d="M445.01 185.66L445.96 185.72V184.69C445.96 184.69 445.11 184.63 445.01 184.61V185.66Z"
        fill="#CECECE"
      />
      <path
        d="M445.01 187.47L445.96 187.53V186.49C445.96 186.49 445.11 186.43 445.01 186.42V187.48V187.47Z"
        fill="#CECECE"
      />
      <path
        d="M445.01 189.29L445.96 189.34V188.29C445.96 188.29 445.1 188.24 445.01 188.22V189.29Z"
        fill="#CECECE"
      />
      <path
        d="M445.01 192.92L445.95 192.96V191.89C445.95 191.89 445.08 191.84 445.01 191.83V192.92Z"
        fill="#CECECE"
      />
      <path
        d="M445.02 194.73L445.96 194.77V193.68C445.96 193.68 445.09 193.64 445.02 193.63V194.73Z"
        fill="#CECECE"
      />
      <path
        d="M445.02 196.55L445.96 196.59V195.49C445.96 195.49 445.08 195.45 445.02 195.44V196.55Z"
        fill="#CECECE"
      />
      <path
        d="M445.02 198.36L445.96 198.39V197.28C445.96 197.28 445.08 197.25 445.02 197.24V198.36Z"
        fill="#CECECE"
      />
      <path
        d="M445.02 200.18L445.95 200.21V199.09C445.95 199.09 445.06 199.06 445.02 199.05V200.18Z"
        fill="#CECECE"
      />
      <path
        d="M445.02 203.81L445.95 203.83V202.68C445.95 202.68 445.05 202.66 445.02 202.65V203.8V203.81Z"
        fill="#CECECE"
      />
      <path
        d="M445.02 207.44H445.95V206.28C445.95 206.28 445.04 206.27 445.02 206.26V207.44Z"
        fill="#CECECE"
      />
      <path
        d="M445.02 211.07H445.94V209.88H445.02V211.08V211.07Z"
        fill="#CECECE"
      />
      <path
        d="M444.4 148.51C444.4 148.51 443.53 148.42 443.12 148.51V149.38H444.4V148.51Z"
        fill="#CECECE"
      />
      <path
        d="M443.12 151.2H444.4V150.32C444.4 150.32 443.52 150.23 443.12 150.32V151.2Z"
        fill="#CECECE"
      />
      <path
        d="M443.12 153.01H444.4V152.12C444.4 152.12 443.51 152.03 443.12 152.12V153.01Z"
        fill="#CECECE"
      />
      <path
        d="M443.13 154.83H444.4V153.93C444.4 153.93 443.5 153.85 443.13 153.93V154.83Z"
        fill="#CECECE"
      />
      <path
        d="M443.13 156.64H444.4V155.73C444.4 155.73 443.49 155.65 443.13 155.73V156.64Z"
        fill="#CECECE"
      />
      <path
        d="M443.13 158.45H444.4V157.53C444.4 157.53 443.48 157.45 443.13 157.53V158.45Z"
        fill="#CECECE"
      />
      <path
        d="M443.13 162.08H444.4V161.14C444.4 161.14 443.46 161.07 443.13 161.14V162.08Z"
        fill="#CECECE"
      />
      <path
        d="M443.13 163.9H444.39V162.95C444.39 162.95 443.44 162.88 443.13 162.95V163.9Z"
        fill="#CECECE"
      />
      <path
        d="M443.13 165.71H444.39V164.75C444.39 164.75 443.43 164.68 443.13 164.75V165.71Z"
        fill="#CECECE"
      />
      <path
        d="M443.14 167.53H444.4V166.56C444.4 166.56 443.43 166.5 443.14 166.56V167.53Z"
        fill="#CECECE"
      />
      <path
        d="M443.14 169.34H444.4V168.36C444.4 168.36 443.43 168.3 443.14 168.36V169.34Z"
        fill="#CECECE"
      />
      <path
        d="M443.14 171.16H444.39V170.17C444.39 170.17 443.41 170.11 443.14 170.17V171.16Z"
        fill="#CECECE"
      />
      <path
        d="M443.14 174.78H444.39V173.77C444.39 173.77 443.39 173.72 443.14 173.77V174.78Z"
        fill="#CECECE"
      />
      <path
        d="M443.14 176.6H444.39V175.58C444.39 175.58 443.38 175.53 443.14 175.58V176.6Z"
        fill="#CECECE"
      />
      <path
        d="M443.14 178.41H444.39V177.38C444.39 177.38 443.37 177.33 443.14 177.38V178.41Z"
        fill="#CECECE"
      />
      <path
        d="M443.14 180.23H444.38V179.19C444.38 179.19 443.35 179.14 443.14 179.19V180.23Z"
        fill="#CECECE"
      />
      <path
        d="M443.15 182.04H444.39V180.99C444.39 180.99 443.35 180.95 443.15 180.99V182.04Z"
        fill="#CECECE"
      />
      <path
        d="M443.15 183.86H444.39V182.8C444.39 182.8 443.34 182.76 443.15 182.8V183.86Z"
        fill="#CECECE"
      />
      <path
        d="M443.15 185.67H444.39V184.6C444.39 184.6 443.33 184.56 443.15 184.6V185.67Z"
        fill="#CECECE"
      />
      <path
        d="M443.15 187.49H444.39V186.41C444.39 186.41 443.32 186.37 443.15 186.41V187.49Z"
        fill="#CECECE"
      />
      <path
        d="M443.15 189.3H444.38V188.22C444.38 188.22 443.3 188.19 443.15 188.22V189.3Z"
        fill="#CECECE"
      />
      <path
        d="M443.15 191.11H444.38V190.02C444.38 190.02 443.29 189.99 443.15 190.02V191.11Z"
        fill="#CECECE"
      />
      <path
        d="M443.15 192.93H444.38V191.83C444.38 191.83 443.28 191.8 443.15 191.83V192.93Z"
        fill="#CECECE"
      />
      <path
        d="M443.15 194.74H444.38V193.63C444.38 193.63 443.27 193.6 443.15 193.63V194.74Z"
        fill="#CECECE"
      />
      <path
        d="M443.16 198.37H444.38V197.24C444.38 197.24 443.25 197.22 443.16 197.24V198.37Z"
        fill="#CECECE"
      />
      <path
        d="M443.16 200.19H444.38V199.05C444.38 199.05 443.24 199.03 443.16 199.05V200.19Z"
        fill="#CECECE"
      />
      <path
        d="M443.16 203.81H444.38V202.65C444.38 202.65 443.22 202.64 443.16 202.65V203.81Z"
        fill="#CECECE"
      />
      <path
        d="M443.16 207.44H444.37V206.26C444.37 206.26 443.19 206.26 443.16 206.26V207.44Z"
        fill="#CECECE"
      />
      <path
        d="M443.17 211.07H444.38V209.87C444.38 209.87 443.18 209.87 443.17 209.87V211.07Z"
        fill="#CECECE"
      />
      <path d="M444.38 211.68H443.17V212.89H444.38V211.68Z" fill="#CECECE" />
      <path
        d="M442.54 148.56C442.54 148.56 441.73 148.68 441.4 148.85V149.68C441.4 149.68 442.37 149.41 442.54 149.38V148.56Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 151.49C441.4 151.49 442.38 151.23 442.54 151.2V150.37C442.54 150.37 441.72 150.48 441.4 150.65V151.49Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 153.29C441.4 153.29 442.38 153.03 442.54 153.01V152.16C442.54 152.16 441.71 152.27 441.4 152.43V153.28V153.29Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 155.1C441.4 155.1 442.39 154.85 442.54 154.83V153.97C442.54 153.97 441.7 154.08 441.4 154.23V155.1Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 156.9C441.4 156.9 442.39 156.66 442.54 156.64V155.77C442.54 155.77 441.69 155.87 441.4 156.03V156.91V156.9Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 158.71C441.4 158.71 442.4 158.48 442.54 158.45V157.57C442.54 157.57 441.68 157.67 441.4 157.82V158.71Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 160.52C441.4 160.52 442.4 160.29 442.54 160.27V159.38C442.54 159.38 441.67 159.48 441.4 159.62V160.52Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 162.32C441.4 162.32 442.41 162.1 442.54 162.08V161.18C442.54 161.18 441.66 161.27 441.4 161.41V162.32Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 164.13C441.4 164.13 442.41 163.92 442.54 163.9V162.99C442.54 162.99 441.65 163.08 441.4 163.21V164.13Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 165.93C441.4 165.93 442.42 165.73 442.54 165.71V164.79C442.54 164.79 441.64 164.88 441.4 165V165.93Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 167.74C441.4 167.74 442.42 167.55 442.54 167.53V166.6C442.54 166.6 441.64 166.68 441.4 166.81V167.75V167.74Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 171.35C441.4 171.35 442.43 171.17 442.54 171.15V170.19C442.54 170.19 441.62 170.27 441.4 170.38V171.34V171.35Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 173.16C441.4 173.16 442.43 172.99 442.54 172.97V172C442.54 172 441.61 172.07 441.4 172.18V173.15V173.16Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 174.96C441.4 174.96 442.44 174.8 442.54 174.78V173.8C442.54 173.8 441.6 173.87 441.4 173.97V174.95V174.96Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 176.77C441.4 176.77 442.44 176.61 442.54 176.6V175.61C442.54 175.61 441.59 175.68 441.4 175.78V176.77Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 178.57C441.4 178.57 442.45 178.42 442.54 178.41V177.41C442.54 177.41 441.58 177.47 441.4 177.57V178.58V178.57Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 180.38C441.4 180.38 442.45 180.24 442.54 180.23V179.22C442.54 179.22 441.57 179.28 441.4 179.37V180.39V180.38Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 183.99C441.4 183.99 442.46 183.87 442.54 183.85V182.82C442.54 182.82 441.55 182.87 441.4 182.95V183.99Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 185.8C441.4 185.8 442.47 185.68 442.54 185.67V184.63C442.54 184.63 441.54 184.68 441.4 184.75V185.8Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 189.41C441.4 189.41 442.48 189.31 442.54 189.3V188.23C442.54 188.23 441.52 188.27 441.4 188.34V189.41Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 191.22C441.4 191.22 442.48 191.13 442.54 191.12V190.04C442.54 190.04 441.52 190.08 441.4 190.14V191.22Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 193.02C441.4 193.02 442.49 192.93 442.54 192.93V191.84C442.54 191.84 441.51 191.88 441.4 191.93V193.02Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 194.83C441.4 194.83 442.49 194.75 442.54 194.74V193.64C442.54 193.64 441.5 193.67 441.4 193.72V194.82V194.83Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 196.63C441.4 196.63 442.49 196.56 442.54 196.55V195.44C442.54 195.44 441.49 195.47 441.4 195.51V196.62V196.63Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 198.44C441.4 198.44 442.5 198.38 442.54 198.37V197.25C442.54 197.25 441.48 197.28 441.4 197.32V198.44Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 203.86C441.4 203.86 442.51 203.82 442.54 203.82V202.67C442.54 202.67 441.45 202.69 441.4 202.71V203.87V203.86Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 205.66C441.4 205.66 442.52 205.63 442.54 205.63V204.46C442.54 204.46 441.44 204.47 441.4 204.49V205.66Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 216.34L440.79 216.28V215.11L439.84 215.16V216.34Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 218.12L440.79 218.08V216.9L439.84 216.94V218.12Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 216.26C441.4 216.26 442.52 216.23 442.54 216.23V215.06C442.54 215.06 441.44 215.07 441.4 215.09V216.26Z"
        fill="#CECECE"
      />
      <path
        d="M446.41 149.57V148.85C446.41 148.85 446.97 148.97 447.24 149.12V149.81L446.41 149.57Z"
        fill="#CECECE"
      />
      <path
        d="M446.41 151.38L447.24 151.61V150.9C446.98 150.76 446.41 150.64 446.41 150.64V151.38Z"
        fill="#CECECE"
      />
      <path
        d="M446.41 153.19L447.24 153.42V152.7C446.99 152.56 446.41 152.45 446.41 152.45V153.2V153.19Z"
        fill="#CECECE"
      />
      <path
        d="M446.41 155L447.24 155.22V154.48C446.99 154.35 446.41 154.24 446.41 154.24V155Z"
        fill="#CECECE"
      />
      <path
        d="M446.41 156.8L447.24 157.01V156.26C447 156.13 446.41 156.02 446.41 156.02V156.8Z"
        fill="#CECECE"
      />
      <path
        d="M446.41 158.61L447.24 158.82V158.05C447.01 157.92 446.41 157.82 446.41 157.82V158.61Z"
        fill="#CECECE"
      />
      <path
        d="M446.41 160.42L447.24 160.62V159.84C447.02 159.72 446.41 159.62 446.41 159.62V160.42Z"
        fill="#CECECE"
      />
      <path
        d="M446.41 162.23L447.25 162.42V161.62C447.03 161.5 446.41 161.41 446.41 161.41V162.23Z"
        fill="#CECECE"
      />
      <path
        d="M446.41 164.04L447.25 164.22V163.41C447.04 163.3 446.41 163.2 446.41 163.2V164.03V164.04Z"
        fill="#CECECE"
      />
      <path
        d="M446.42 165.85L447.26 166.03V165.2C447.06 165.09 446.42 165 446.42 165V165.85Z"
        fill="#CECECE"
      />
      <path
        d="M446.42 169.47L447.26 169.63V168.77C447.08 168.67 446.42 168.59 446.42 168.59V169.47Z"
        fill="#CECECE"
      />
      <path
        d="M446.42 171.28L447.26 171.44V170.57C447.08 170.47 446.42 170.4 446.42 170.4V171.29V171.28Z"
        fill="#CECECE"
      />
      <path
        d="M446.42 173.09L447.26 173.24V172.35C447.09 172.26 446.42 172.18 446.42 172.18V173.08V173.09Z"
        fill="#CECECE"
      />
      <path
        d="M446.42 174.9L447.26 175.04V174.14C447.1 174.05 446.42 173.98 446.42 173.98V174.9Z"
        fill="#CECECE"
      />
      <path
        d="M446.42 178.51L447.26 178.64V177.71C447.11 177.63 446.42 177.56 446.42 177.56V178.51Z"
        fill="#CECECE"
      />
      <path
        d="M446.42 180.32L447.26 180.44V179.49C447.12 179.41 446.42 179.35 446.42 179.35V180.31V180.32Z"
        fill="#CECECE"
      />
      <path
        d="M446.42 182.13L447.26 182.25V181.29C447.13 181.22 446.42 181.16 446.42 181.16V182.13Z"
        fill="#CECECE"
      />
      <path
        d="M446.42 183.94L447.26 184.05V183.08C447.14 183.01 446.42 182.96 446.42 182.96V183.95V183.94Z"
        fill="#CECECE"
      />
      <path
        d="M446.42 185.75L447.26 185.85V184.86C447.14 184.8 446.42 184.75 446.42 184.75V185.75Z"
        fill="#CECECE"
      />
      <path
        d="M446.42 189.37L447.26 189.46V188.44C447.16 188.39 446.42 188.34 446.42 188.34V189.37Z"
        fill="#CECECE"
      />
      <path
        d="M446.42 191.18L447.26 191.26V190.23C447.17 190.18 446.42 190.14 446.42 190.14V191.18Z"
        fill="#CECECE"
      />
      <path
        d="M446.42 192.99L447.26 193.07V192.02C447.18 191.97 446.42 191.94 446.42 191.94V193V192.99Z"
        fill="#CECECE"
      />
      <path
        d="M446.42 194.8L447.26 194.87V193.81C447.18 193.77 446.42 193.73 446.42 193.73V194.8Z"
        fill="#CECECE"
      />
      <path
        d="M446.43 200.22L447.27 200.27V199.16C447.22 199.13 446.43 199.11 446.43 199.11V200.22Z"
        fill="#CECECE"
      />
      <path
        d="M446.43 202.03L447.27 202.07V200.95L446.43 200.9V202.03Z"
        fill="#CECECE"
      />
      <path
        d="M446.43 203.84L447.27 203.87V202.73L446.43 202.69V203.83V203.84Z"
        fill="#CECECE"
      />
      <path
        d="M447.58 149.26V149.94L448.42 150.28V149.67L447.58 149.26Z"
        fill="#CECECE"
      />
      <path
        d="M447.59 151.74L448.42 152.07V151.45L447.59 151.04V151.74Z"
        fill="#CECECE"
      />
      <path
        d="M447.59 153.54L448.42 153.86V153.22L447.59 152.83V153.54Z"
        fill="#CECECE"
      />
      <path
        d="M447.59 155.34L448.42 155.65V154.99L447.59 154.61V155.34Z"
        fill="#CECECE"
      />
      <path
        d="M447.59 157.13L448.42 157.44V156.76L447.59 156.39V157.13Z"
        fill="#CECECE"
      />
      <path
        d="M447.59 160.73L448.41 161.01V160.3L447.59 159.96V160.73Z"
        fill="#CECECE"
      />
      <path
        d="M447.59 162.53L448.41 162.8V162.07L447.59 161.74V162.53Z"
        fill="#CECECE"
      />
      <path
        d="M447.59 164.33L448.41 164.59V163.85L447.59 163.53V164.33Z"
        fill="#CECECE"
      />
      <path
        d="M447.59 166.13L448.41 166.38V165.62L447.59 165.31V166.13Z"
        fill="#CECECE"
      />
      <path
        d="M447.59 167.93L448.41 168.17V167.39L447.59 167.09V167.93Z"
        fill="#CECECE"
      />
      <path
        d="M447.59 169.72L448.41 169.96V169.16L447.59 168.88V169.72Z"
        fill="#CECECE"
      />
      <path
        d="M447.6 171.52L448.41 171.75V170.93L447.6 170.66V171.52Z"
        fill="#CECECE"
      />
      <path
        d="M447.6 173.32L448.41 173.53V172.7L447.6 172.44V173.32Z"
        fill="#CECECE"
      />
      <path
        d="M447.6 175.12L448.41 175.32V174.47L447.6 174.23V175.12Z"
        fill="#CECECE"
      />
      <path
        d="M447.6 176.92L448.41 177.11V176.25L447.6 176.01V176.92Z"
        fill="#CECECE"
      />
      <path
        d="M447.6 178.72L448.41 178.9V178.02L447.6 177.79V178.72Z"
        fill="#CECECE"
      />
      <path
        d="M447.6 180.51L448.41 180.69V179.79L447.6 179.58V180.51Z"
        fill="#CECECE"
      />
      <path
        d="M447.6 182.31L448.41 182.48V181.56L447.6 181.36V182.31Z"
        fill="#CECECE"
      />
      <path
        d="M447.6 184.11L448.41 184.27V183.33L447.6 183.14V184.11Z"
        fill="#CECECE"
      />
      <path
        d="M447.6 185.91L448.41 186.06V185.1L447.6 184.93V185.91Z"
        fill="#CECECE"
      />
      <path
        d="M447.6 187.71L448.41 187.84V186.88L447.6 186.71V187.71Z"
        fill="#CECECE"
      />
      <path
        d="M447.6 189.51L448.41 189.63V188.65L447.6 188.49V189.51Z"
        fill="#CECECE"
      />
      <path
        d="M447.61 191.3L448.41 191.42V190.42L447.61 190.28V191.3Z"
        fill="#CECECE"
      />
      <path
        d="M447.61 193.1L448.41 193.21V192.19L447.61 192.06V193.1Z"
        fill="#CECECE"
      />
      <path
        d="M447.61 194.9L448.41 195V193.96L447.61 193.84V194.9Z"
        fill="#CECECE"
      />
      <path
        d="M447.61 196.7L448.4 196.79V195.73L447.61 195.63V196.7Z"
        fill="#CECECE"
      />
      <path
        d="M447.61 200.3L448.4 200.37V199.28L447.61 199.19V200.3Z"
        fill="#CECECE"
      />
      <path
        d="M447.61 202.1L448.4 202.15V201.05L447.61 200.98V202.1Z"
        fill="#CECECE"
      />
      <path
        d="M447.61 205.69L448.4 205.73V204.59L447.61 204.54V205.69Z"
        fill="#CECECE"
      />
      <path
        d="M447.61 207.49L448.4 207.52V206.36L447.61 206.33V207.49Z"
        fill="#CECECE"
      />
      <path
        d="M458.17 179.17L458.8 179.43V178.54L458.17 178.26V179.17Z"
        fill="#CECECE"
      />
      <path
        d="M458.17 180.87L458.8 181.12V180.21L458.17 179.94V180.87Z"
        fill="#CECECE"
      />
      <path
        d="M458.17 182.58L458.8 182.82V181.89L458.17 181.63V182.58Z"
        fill="#CECECE"
      />
      <path
        d="M457.21 178.78L457.84 179.04V178.14L457.21 177.86V178.78Z"
        fill="#CECECE"
      />
      <path
        d="M457.21 180.5L457.83 180.75V179.84L457.21 179.57V180.5Z"
        fill="#CECECE"
      />
      <path
        d="M457.21 182.22L457.83 182.46V181.53L457.21 181.28V182.22Z"
        fill="#CECECE"
      />
      <path
        d="M457.21 185.67L457.83 185.88V184.92L457.21 184.7V185.67Z"
        fill="#CECECE"
      />
      <path
        d="M457.21 187.4L457.83 187.59V186.62L457.21 186.41V187.4Z"
        fill="#CECECE"
      />
      <path
        d="M457.21 189.12L457.83 189.31V188.31L457.21 188.12V189.12Z"
        fill="#CECECE"
      />
      <path
        d="M457.21 190.85L457.83 191.02V190.01L457.21 189.83V190.85Z"
        fill="#CECECE"
      />
      <path
        d="M457.21 192.57L457.83 192.73V191.7L457.21 191.54V192.57Z"
        fill="#CECECE"
      />
      <path
        d="M457.21 196.02L457.83 196.15V195.1L457.21 194.96V196.02Z"
        fill="#CECECE"
      />
      <path
        d="M456.25 178.39L456.88 178.65V177.75L456.25 177.47V178.39Z"
        fill="#CECECE"
      />
      <path
        d="M456.25 180.13L456.88 180.38V179.47L456.25 179.2V180.13Z"
        fill="#CECECE"
      />
      <path
        d="M456.26 181.87L456.88 182.11V181.18L456.26 180.93V181.87Z"
        fill="#CECECE"
      />
      <path
        d="M456.26 187.11L456.88 187.3V186.33L456.26 186.12V187.11Z"
        fill="#CECECE"
      />
      <path
        d="M456.26 188.85L456.88 189.03V188.04L456.26 187.85V188.85Z"
        fill="#CECECE"
      />
      <path
        d="M456.26 190.59L456.88 190.76V189.76L456.26 189.57V190.59Z"
        fill="#CECECE"
      />
      <path
        d="M456.26 192.34L456.88 192.49V191.47L456.26 191.3V192.34Z"
        fill="#CECECE"
      />
      <path
        d="M456.26 195.82L456.88 195.96V194.9L456.26 194.76V195.82Z"
        fill="#CECECE"
      />
      <path
        d="M456.26 202.8L456.88 202.88V201.76L456.26 201.68V202.8Z"
        fill="#CECECE"
      />
      <path
        d="M456.26 204.54L456.88 204.61V203.48L456.26 203.41V204.54Z"
        fill="#CECECE"
      />
      <path
        d="M456.26 208.03L456.88 208.07V206.91L456.26 206.86V208.03Z"
        fill="#CECECE"
      />
      <path
        d="M455.28 178.01L455.9 178.27V177.37L455.28 177.09V178.01Z"
        fill="#CECECE"
      />
      <path
        d="M455.28 181.53L455.9 181.77V180.84L455.28 180.59V181.53Z"
        fill="#CECECE"
      />
      <path
        d="M455.28 185.06L455.9 185.27V184.31L455.28 184.09V185.06Z"
        fill="#CECECE"
      />
      <path
        d="M455.28 186.82L455.9 187.02V186.04L455.28 185.83V186.82Z"
        fill="#CECECE"
      />
      <path
        d="M455.28 188.58L455.9 188.77V187.78L455.28 187.58V188.58Z"
        fill="#CECECE"
      />
      <path
        d="M455.28 190.35L455.9 190.52V189.51L455.28 189.33V190.35Z"
        fill="#CECECE"
      />
      <path
        d="M455.28 195.63L455.9 195.77V194.71L455.28 194.57V195.63Z"
        fill="#CECECE"
      />
      <path
        d="M455.27 202.69L455.9 202.76V201.65L455.27 201.56V202.69Z"
        fill="#CECECE"
      />
      <path
        d="M455.27 204.45L455.9 204.51V203.38L455.27 203.31V204.45Z"
        fill="#CECECE"
      />
      <path
        d="M455.27 206.21L455.9 206.26V205.12L455.27 205.06V206.21Z"
        fill="#CECECE"
      />
      <path
        d="M455.28 208.98L455.91 209.02V207.85L455.28 207.81V208.98Z"
        fill="#CECECE"
      />
      <path
        d="M454.27 177.63L454.9 177.89V176.99L454.27 176.71V177.63Z"
        fill="#CECECE"
      />
      <path
        d="M454.27 179.41L454.9 179.66V178.74L454.27 178.48V179.41Z"
        fill="#CECECE"
      />
      <path
        d="M454.28 181.19L454.9 181.43V180.5L454.28 180.24V181.19Z"
        fill="#CECECE"
      />
      <path
        d="M454.28 184.75L454.91 184.97V184L454.28 183.78V184.75Z"
        fill="#CECECE"
      />
      <path
        d="M454.28 186.54L454.91 186.73V185.76L454.28 185.54V186.54Z"
        fill="#CECECE"
      />
      <path
        d="M454.28 188.32L454.91 188.5V187.51L454.28 187.31V188.32Z"
        fill="#CECECE"
      />
      <path
        d="M454.28 190.1L454.91 190.27V189.26L454.28 189.08V190.1Z"
        fill="#CECECE"
      />
      <path
        d="M454.28 191.88L454.91 192.04V191.02L454.28 190.85V191.88Z"
        fill="#CECECE"
      />
      <path
        d="M454.28 193.66L454.91 193.81V192.77L454.28 192.61V193.66Z"
        fill="#CECECE"
      />
      <path
        d="M454.28 197.23L454.91 197.34V196.27L454.28 196.15V197.23Z"
        fill="#CECECE"
      />
      <path
        d="M454.29 200.79L454.91 200.88V199.78L454.29 199.68V200.79Z"
        fill="#CECECE"
      />
      <path
        d="M454.29 204.35L454.91 204.42V203.29L454.29 203.22V204.35Z"
        fill="#CECECE"
      />
      <path
        d="M454.29 207.92L454.91 207.95V206.79L454.29 206.75V207.92Z"
        fill="#CECECE"
      />
      <path
        d="M447.61 209.29L448.4 209.31V208.13L447.61 208.11V209.29Z"
        fill="#CECECE"
      />
      <path d="M448.4 211.68H447.62V212.89H448.4V211.68Z" fill="#CECECE" />
      <path
        d="M448.83 214.82L449.51 214.86V213.7L448.83 213.66V214.82Z"
        fill="#CECECE"
      />
      <path
        d="M445.02 214.72H445.95V213.56C445.95 213.56 445.04 213.55 445.02 213.54V214.72Z"
        fill="#CECECE"
      />
      <path
        d="M445.02 218.35H445.94V217.16H445.02V218.36V218.35Z"
        fill="#CECECE"
      />
      <path
        d="M443.16 214.73H444.37V213.55C444.37 213.55 443.19 213.55 443.16 213.55V214.73Z"
        fill="#CECECE"
      />
      <path
        d="M443.17 218.36H444.38V217.16C444.38 217.16 443.18 217.16 443.17 217.16V218.36Z"
        fill="#CECECE"
      />
      <path d="M444.38 218.96H443.17V220.17H444.38V218.96Z" fill="#CECECE" />
      <path
        d="M447.61 216.57L448.4 216.59V215.42L447.61 215.39V216.57Z"
        fill="#CECECE"
      />
      <path
        d="M447.62 218.37L448.4 218.38V217.19L447.62 217.18V218.37Z"
        fill="#CECECE"
      />
      <path d="M448.4 218.96H447.62V220.17H448.4V218.96Z" fill="#CECECE" />
      <path
        d="M439.84 221.96L440.79 221.95V220.75L439.84 220.76V221.96Z"
        fill="#CECECE"
      />
      <path
        d="M445.02 221.93H445.94V220.74H445.02V221.94V221.93Z"
        fill="#CECECE"
      />
      <path
        d="M443.17 221.93H444.38V220.73C444.38 220.73 443.18 220.73 443.17 220.73V221.93Z"
        fill="#CECECE"
      />
      <path d="M444.38 222.54H443.17V223.75H444.38V222.54Z" fill="#CECECE" />
      <path
        d="M439.84 227.2L440.79 227.15V225.97L439.84 226.03V227.2Z"
        fill="#CECECE"
      />
      <path
        d="M439.84 228.99L440.79 228.95V227.76L439.84 227.8V228.99Z"
        fill="#CECECE"
      />
      <path
        d="M441.4 227.12C441.4 227.12 442.52 227.09 442.54 227.09V225.92C442.54 225.92 441.44 225.93 441.4 225.95V227.12Z"
        fill="#CECECE"
      />
      <path
        d="M447.61 220.15L448.4 220.17V219L447.61 218.97V220.15Z"
        fill="#CECECE"
      />
      <path d="M448.4 222.54H447.62V223.75H448.4V222.54Z" fill="#CECECE" />
      <path d="M442.54 222.54H441.4V223.75H442.54V222.54Z" fill="#CECECE" />
      <path d="M442.54 231.54H441.4V232.75H442.54V231.54Z" fill="#CECECE" />
      <path d="M442.54 207.81H441.4V209.02H442.54V207.81Z" fill="#CECECE" />
      <path
        d="M445.02 225.59H445.95V224.43C445.95 224.43 445.04 224.42 445.02 224.41V225.59Z"
        fill="#CECECE"
      />
      <path
        d="M445.02 229.22H445.94V228.03H445.02V229.23V229.22Z"
        fill="#CECECE"
      />
      <path
        d="M443.16 225.59H444.37V224.41C444.37 224.41 443.19 224.41 443.16 224.41V225.59Z"
        fill="#CECECE"
      />
      <path
        d="M443.17 229.22H444.38V228.02C444.38 228.02 443.18 228.02 443.17 228.02V229.22Z"
        fill="#CECECE"
      />
      <path d="M444.38 229.82H443.17V231.03H444.38V229.82Z" fill="#CECECE" />
      <path
        d="M443.17 234.37H444.38V233.17C444.38 233.17 443.18 233.17 443.17 233.17V234.37Z"
        fill="#CECECE"
      />
      <path d="M444.38 236.81H443.17V238.02H444.38V236.81Z" fill="#CECECE" />
      <path
        d="M447.61 227.44L448.4 227.45V226.28L447.61 226.26V227.44Z"
        fill="#CECECE"
      />
      <path
        d="M447.62 229.23L448.4 229.24V228.05L447.62 228.04V229.23Z"
        fill="#CECECE"
      />
      <path d="M448.4 229.82H447.62V231.03H448.4V229.82Z" fill="#CECECE" />
      <path
        d="M459.95 166.17V166.91C459.95 166.91 456.95 167.11 455.37 168.4V167.97C455.37 167.97 456.85 166.61 459.95 166.17Z"
        fill="#CECECE"
      />
      <path
        d="M459.95 168.52C459.95 168.52 456.88 168.71 455.37 169.95V169.5C455.37 169.5 456.99 168.2 459.95 167.78V168.52Z"
        fill="#CECECE"
      />
      <path
        d="M459.95 170.13C459.95 170.13 456.81 170.31 455.37 171.49V171.03C455.37 171.03 457.12 169.79 459.95 169.39V170.13Z"
        fill="#CECECE"
      />
      <path
        d="M459.95 171.74C459.95 171.74 456.74 171.91 455.37 173.04V172.57C455.37 172.57 457.26 171.38 459.95 171.01V171.75V171.74Z"
        fill="#CECECE"
      />
      <path
        d="M459.95 173.35C459.95 173.35 456.67 173.51 455.37 174.58V174.09C455.37 174.09 457.39 172.96 459.95 172.61V173.35Z"
        fill="#CECECE"
      />
      <path
        d="M459.95 174.72C459.95 174.72 456.74 174.89 455.37 176.02V175.55C455.37 175.55 457.26 174.36 459.95 173.99V174.73V174.72Z"
        fill="#CECECE"
      />
      <path
        d="M459.95 176.33C459.95 176.33 458.47 176.4 457.11 176.77C456.84 176.69 456.67 176.62 456.43 176.57C457.27 176.22 458.53 175.78 459.96 175.58V176.32L459.95 176.33Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 166.39V167.29L466.24 167.14V166.17L467.59 166.39Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 167.98V168.88L466.24 168.74V167.78L467.59 167.98Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 169.58V170.48L466.24 170.34V169.38L467.59 169.58Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 171.17V172.07L466.24 171.94V170.98L467.59 171.17Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 172.77V173.66L466.24 173.54V172.59L467.59 172.77Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 175.95V176.85L466.24 176.74V175.79L467.59 175.95Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 177.55V178.44L466.24 178.34V177.4L467.59 177.55Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 180.74V181.63L466.24 181.54V180.6L467.59 180.74Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 182.33V183.22L466.24 183.14V182.21L467.59 182.33Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 183.92V184.82L466.24 184.74V183.81L467.59 183.92Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 185.52V186.41L466.24 186.34V185.41L467.59 185.52Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 188.7V189.6L466.24 189.54V188.62L467.59 188.7Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 190.3V191.19L466.24 191.14V190.22L467.59 190.3Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 191.89V192.78L466.24 192.74V191.83L467.59 191.89Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 195.08V195.97L466.24 195.94V195.03L467.59 195.08Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 196.67V197.56L466.24 197.54V196.64L467.59 196.67Z"
        fill="#CECECE"
      />
      <path
        d="M467.59 199.86V200.75L466.24 200.74V199.84L467.59 199.86Z"
        fill="#CECECE"
      />
      <path d="M467.6 203.05H466.24V203.94H467.6V203.05Z" fill="#CECECE" />
      <path
        d="M465.7 166.1V167.07L464.42 166.99V166L465.7 166.1Z"
        fill="#CECECE"
      />
      <path
        d="M465.71 167.7V168.67L464.42 168.59V167.61L465.71 167.7Z"
        fill="#CECECE"
      />
      <path
        d="M465.71 169.31V170.28L464.42 170.2V169.22L465.71 169.31Z"
        fill="#CECECE"
      />
      <path
        d="M465.71 170.92V171.88L464.42 171.81V170.83L465.71 170.92Z"
        fill="#CECECE"
      />
      <path
        d="M465.71 172.52V173.48L464.42 173.41V172.44L465.71 172.52Z"
        fill="#CECECE"
      />
      <path
        d="M465.71 174.13V175.08L464.42 175.02V174.05L465.71 174.13Z"
        fill="#CECECE"
      />
      <path
        d="M465.71 175.74V176.69L464.42 176.63V175.66L465.71 175.74Z"
        fill="#CECECE"
      />
      <path
        d="M465.71 177.34V178.29L464.42 178.23V177.27L465.71 177.34Z"
        fill="#CECECE"
      />
      <path
        d="M465.72 178.95V179.89L464.42 179.84V178.88L465.72 178.95Z"
        fill="#CECECE"
      />
      <path
        d="M465.72 182.16V183.1L464.42 183.05V182.11L465.72 182.16Z"
        fill="#CECECE"
      />
      <path
        d="M465.72 183.77V184.7L464.42 184.66V183.72L465.72 183.77Z"
        fill="#CECECE"
      />
      <path
        d="M465.72 186.98V187.91L464.42 187.87V186.94L465.72 186.98Z"
        fill="#CECECE"
      />
      <path
        d="M465.73 188.59V189.51L464.42 189.48V188.55L465.73 188.59Z"
        fill="#CECECE"
      />
      <path
        d="M465.73 190.2V191.11L464.42 191.08V190.16L465.73 190.2Z"
        fill="#CECECE"
      />
      <path
        d="M465.73 191.8V192.72L464.42 192.69V191.77L465.73 191.8Z"
        fill="#CECECE"
      />
      <path
        d="M465.73 193.41V194.32L464.42 194.3V193.38L465.73 193.41Z"
        fill="#CECECE"
      />
      <path
        d="M465.73 195.02V195.92L464.42 195.91V194.99L465.73 195.02Z"
        fill="#CECECE"
      />
      <path
        d="M465.74 198.23V199.13L464.42 199.12V198.22L465.74 198.23Z"
        fill="#CECECE"
      />
      <path
        d="M465.74 199.84V200.73H464.42V199.83L465.74 199.84Z"
        fill="#CECECE"
      />
      <path d="M465.74 203.05H464.42V203.94H465.74V203.05Z" fill="#CECECE" />
      <path
        d="M463.86 165.94V166.9L462.53 166.86V165.88L463.86 165.94Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 167.55V168.51L462.53 168.47V167.49L463.86 167.55Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 169.17V170.12L462.53 170.08V169.11L463.86 169.17Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 170.78V171.73L462.53 171.7V170.73L463.86 170.78Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 172.39V173.34L462.53 173.31V172.34L463.86 172.39Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 174.01V174.95L462.53 174.92V173.96L463.86 174.01Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 175.62V176.56L462.52 176.53V175.57L463.86 175.62Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 177.23V178.17L462.52 178.14V177.19L463.86 177.23Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 178.85V179.79L462.52 179.76V178.81L463.86 178.85Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 180.46V181.4L462.52 181.37V180.42L463.86 180.46Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 182.07V183.01L462.52 182.98V182.04L463.86 182.07Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 183.69V184.62L462.52 184.59V183.65L463.86 183.69Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 185.3V186.23L462.52 186.2V185.27L463.86 185.3Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 186.92V187.84L462.52 187.82V186.89L463.86 186.92Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 190.14V191.06L462.52 191.04V190.12L463.86 190.14Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 193.37V194.28L462.52 194.27V193.35L463.86 193.37Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 196.6V197.5L462.52 197.49V196.58L463.86 196.6Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 198.21V199.11L462.52 199.1V198.2L463.86 198.21Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 199.82V200.72L462.52 200.71V199.82H463.86Z"
        fill="#CECECE"
      />
      <path
        d="M463.86 201.44V202.33H462.51V201.43L463.86 201.44Z"
        fill="#CECECE"
      />
      <path d="M461.9 165.85H460.72V166.84H461.9V165.85Z" fill="#CECECE" />
      <path d="M461.9 167.47H460.72V168.46H461.9V167.47Z" fill="#CECECE" />
      <path d="M461.9 169.09H460.72V170.07H461.9V169.09Z" fill="#CECECE" />
      <path d="M461.9 170.71H460.72V171.69H461.9V170.71Z" fill="#CECECE" />
      <path d="M461.9 172.32H460.72V173.29H461.9V172.32Z" fill="#CECECE" />
      <path d="M461.9 173.94H460.72V174.91H461.9V173.94Z" fill="#CECECE" />
      <path d="M461.9 175.56H460.72V176.52H461.9V175.56Z" fill="#CECECE" />
      <path d="M461.9 177.17H460.72V178.13H461.9V177.17Z" fill="#CECECE" />
      <path d="M461.9 178.79H460.72V179.75H461.9V178.79Z" fill="#CECECE" />
      <path d="M461.9 180.41H460.72V181.36H461.9V180.41Z" fill="#CECECE" />
      <path d="M461.9 182.03H460.72V182.98H461.9V182.03Z" fill="#CECECE" />
      <path d="M461.9 183.64H460.72V184.58H461.9V183.64Z" fill="#CECECE" />
      <path d="M461.9 185.26H460.72V186.2H461.9V185.26Z" fill="#CECECE" />
      <path d="M461.9 186.88H460.72V187.81H461.9V186.88Z" fill="#CECECE" />
      <path d="M461.9 188.49H460.72V189.42H461.9V188.49Z" fill="#CECECE" />
      <path d="M461.9 191.73H460.72V192.65H461.9V191.73Z" fill="#CECECE" />
      <path d="M461.9 193.35H460.72V194.27H461.9V193.35Z" fill="#CECECE" />
      <path d="M461.9 194.96H460.72V195.87H461.9V194.96Z" fill="#CECECE" />
      <path d="M461.9 196.58H460.72V197.49H461.9V196.58Z" fill="#CECECE" />
      <path d="M461.9 198.2H460.72V199.1H461.9V198.2Z" fill="#CECECE" />
      <path d="M461.9 199.81H460.72V200.71H461.9V199.81Z" fill="#CECECE" />
      <path d="M461.9 203.05H460.72V203.94H461.9V203.05Z" fill="#CECECE" />
      <path
        d="M467.59 205.69V206.57L466.24 206.56V205.67L467.59 205.69Z"
        fill="#CECECE"
      />
      <path d="M467.6 209.82H466.24V210.71H467.6V209.82Z" fill="#CECECE" />
      <path
        d="M465.74 205.66V206.56L464.42 206.55V205.65L465.74 205.66Z"
        fill="#CECECE"
      />
      <path d="M465.74 209.82H464.42V210.71H465.74V209.82Z" fill="#CECECE" />
      <path
        d="M463.86 205.65V206.54H462.52V205.64L463.86 205.65Z"
        fill="#CECECE"
      />
      <path d="M463.86 207.26V208.15H462.51V207.26H463.86Z" fill="#CECECE" />
      <path d="M461.9 205.64H460.72V206.54H461.9V205.64Z" fill="#CECECE" />
      <path d="M461.9 209.82H460.72V210.71H461.9V209.82Z" fill="#CECECE" />
      <path d="M461.9 211.49H460.72V212.38H461.9V211.49Z" fill="#CECECE" />
      <path d="M461.9 213.95H460.72V214.84H461.9V213.95Z" fill="#CECECE" />
      <path
        d="M467.59 215.71V216.6L466.24 216.58V215.69L467.59 215.71Z"
        fill="#CECECE"
      />
      <path d="M467.6 219.29H466.24V220.18H467.6V219.29Z" fill="#CECECE" />
      <path
        d="M465.74 215.68V216.58L464.42 216.57V215.67L465.74 215.68Z"
        fill="#CECECE"
      />
      <path
        d="M465.74 212.83V213.72H464.42V212.82L465.74 212.83Z"
        fill="#CECECE"
      />
      <path d="M465.74 219.29H464.42V220.18H465.74V219.29Z" fill="#CECECE" />
      <path
        d="M463.86 215.67V216.56H462.52V215.66L463.86 215.67Z"
        fill="#CECECE"
      />
      <path d="M463.86 217.28V218.17H462.51V217.28H463.86Z" fill="#CECECE" />
      <path d="M461.9 215.66H460.72V216.56H461.9V215.66Z" fill="#CECECE" />
      <path d="M461.9 219.29H460.72V220.18H461.9V219.29Z" fill="#CECECE" />
      <path d="M461.9 220.96H460.72V221.85H461.9V220.96Z" fill="#CECECE" />
      <path d="M461.9 223.43H460.72V224.32H461.9V223.43Z" fill="#CECECE" />
      <path
        d="M467.59 220.99V221.88H466.27V220.98L467.59 220.99Z"
        fill="#CECECE"
      />
      <path d="M467.59 224.6H466.27V225.49H467.59V224.6Z" fill="#CECECE" />
      <path
        d="M465.71 220.97V221.87L464.37 221.86V220.97H465.71Z"
        fill="#CECECE"
      />
      <path
        d="M465.71 222.59V223.48H464.36V222.58L465.71 222.59Z"
        fill="#CECECE"
      />
      <path d="M463.75 220.97H462.57V221.87H463.75V220.97Z" fill="#CECECE" />
      <path d="M463.75 224.6H462.57V225.49H463.75V224.6Z" fill="#CECECE" />
      <path d="M463.75 226.27H462.57V227.16H463.75V226.27Z" fill="#CECECE" />
      <path d="M463.75 228.73H462.57V229.62H463.75V228.73Z" fill="#CECECE" />
      <path d="M548.24 173.59H546.43V175.07H548.24V173.59Z" fill="#CECECE" />
      <path d="M540.23 173.59H538.88V175.07H540.23V173.59Z" fill="#CECECE" />
      <path d="M540.23 180.41H538.88V181.89H540.23V180.41Z" fill="#CECECE" />
      <path d="M532.95 180.39H531.87V181.85H532.95V180.39Z" fill="#CECECE" />
      <path d="M540.23 184.94H538.88V186.42H540.23V184.94Z" fill="#CECECE" />
      <path d="M540.23 189.39H538.88V190.87H540.23V189.39Z" fill="#CECECE" />
      <path d="M540.23 196.19H538.88V197.67H540.23V196.19Z" fill="#CECECE" />
      <path d="M540.23 175.92H538.88V177.4H540.23V175.92Z" fill="#CECECE" />
      <path d="M548.24 175.78H546.43V177.26H548.24V175.78Z" fill="#CECECE" />
      <path d="M548.24 178.14H546.43V179.62H548.24V178.14Z" fill="#CECECE" />
      <path d="M548.24 182.56H546.43V184.04H548.24V182.56Z" fill="#CECECE" />
      <path d="M548.24 187.02H546.43V188.5H548.24V187.02Z" fill="#CECECE" />
      <path d="M548.24 191.69H546.43V193.17H548.24V191.69Z" fill="#CECECE" />
      <path
        d="M529.71 205.12L528.63 205.17V203.72L529.71 203.67V205.12Z"
        fill="#CECECE"
      />
      <path
        d="M529.7 209.37L528.63 209.38V207.9L529.7 207.88V209.37Z"
        fill="#CECECE"
      />
      <path
        d="M533.02 204.97L531.95 205.02V203.57L533.02 203.52V204.97Z"
        fill="#CECECE"
      />
      <path d="M534.72 209.98H533.65V211.49H534.72V209.98Z" fill="#CECECE" />
      <path
        d="M550.66 204.67L549.15 204.62V203.15L550.66 203.2V204.67Z"
        fill="#CECECE"
      />
      <path
        d="M545.19 204.67L543.68 204.62V203.15L545.19 203.2V204.67Z"
        fill="#CECECE"
      />
      <path
        d="M550.66 207L549.15 206.98V205.48L550.66 205.5V207Z"
        fill="#CECECE"
      />
      <path
        d="M554.21 207.27L553.2 207.26V205.76L554.21 205.78V207.27Z"
        fill="#CECECE"
      />
      <path
        d="M555.51 204.9L554.66 204.85V203.4L555.51 203.44V204.9Z"
        fill="#CECECE"
      />
      <path
        d="M542.46 204.71L540.99 204.73V203.27C540.99 203.27 542.42 203.25 542.46 203.25V204.72V204.71Z"
        fill="#CECECE"
      />
      <path
        d="M542.45 209.23H540.99V207.74C540.99 207.74 542.44 207.74 542.45 207.74V209.23Z"
        fill="#CECECE"
      />
      <path d="M545.39 209.98H543.48V211.49H545.39V209.98Z" fill="#CECECE" />
      <path
        d="M538.35 204.77L537.11 204.81V203.36L538.35 203.32V204.77Z"
        fill="#CECECE"
      />
      <path
        d="M529.7 214.06L528.63 214.08V212.59L529.7 212.57V214.06Z"
        fill="#CECECE"
      />
      <path
        d="M550.66 213.8L549.15 213.78V212.28L550.66 212.3V213.8Z"
        fill="#CECECE"
      />
      <path
        d="M554.21 214.07L553.2 214.05V212.56L554.21 212.58V214.07Z"
        fill="#CECECE"
      />
      <path
        d="M542.45 216.03H540.99V214.54C540.99 214.54 542.44 214.54 542.45 214.54V216.03Z"
        fill="#CECECE"
      />
      <path d="M545.39 216.78H543.48V218.29H545.39V216.78Z" fill="#CECECE" />
      <path
        d="M531.29 207.03L530.21 207.05V205.55L531.29 205.53V207.03Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 211.51L530.21 211.52V210.02L531.29 210V211.51Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 218.28L530.21 218.3V216.8L531.29 216.78V218.28Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 220.54L530.21 220.55V219.05L531.29 219.04V220.54Z"
        fill="#CECECE"
      />
      <path d="M534.67 201H533.59V202.52H534.67V201Z" fill="#CECECE" />
      <path d="M536.43 201H535.35V202.52H536.43V201Z" fill="#CECECE" />
      <path d="M534.72 205.23H533.65V206.74H534.72V205.23Z" fill="#CECECE" />
      <path d="M536.43 207.8H535.35V209.32H536.43V207.8Z" fill="#CECECE" />
      <path d="M555.62 201H554.76V202.52H555.62V201Z" fill="#CECECE" />
      <path
        d="M556.74 201.07L556.13 201.01V199.62L556.74 199.69V201.07Z"
        fill="#CECECE"
      />
      <path
        d="M556.74 207.45L556.13 207.4V206L556.74 206.07V207.45Z"
        fill="#CECECE"
      />
      <path
        d="M542.46 197.68H540.99V196.18C540.99 196.18 542.45 196.18 542.46 196.18V197.69V197.68Z"
        fill="#CECECE"
      />
      <path
        d="M565.28 198.23V199.26L566.85 199.25V198.21L565.28 198.23Z"
        fill="#CECECE"
      />
      <path
        d="M565.28 196.42V197.45L566.85 197.44V196.39L565.28 196.42Z"
        fill="#CECECE"
      />
      <path d="M566.88 203.66H565.3V204.69H566.88V203.66Z" fill="#CECECE" />
      <path
        d="M560.92 196.4V197.44L562.45 197.43V196.39L560.92 196.4Z"
        fill="#CECECE"
      />
      <path
        d="M563.1 196.39V197.43L564.66 197.42V196.38L563.1 196.39Z"
        fill="#CECECE"
      />
      <path d="M563.1 201.94V202.98H564.66V201.94H563.1Z" fill="#CECECE" />
      <path d="M566.75 200.06H565.38V201.1H566.75V200.06Z" fill="#CECECE" />
      <path d="M562.45 206.44H560.92V207.47H562.45V206.44Z" fill="#CECECE" />
      <path d="M566.75 206.44H565.38V207.47H566.75V206.44Z" fill="#CECECE" />
      <path d="M564.65 212.94H563.12V213.97H564.65V212.94Z" fill="#CECECE" />
      <path
        d="M563.1 209.46V210.5L564.66 210.49V209.45L563.1 209.46Z"
        fill="#CECECE"
      />
      <path d="M566.75 209.45H565.38V210.49H566.75V209.45Z" fill="#CECECE" />
      <path d="M566.75 211.31H565.38V212.35H566.75V211.31Z" fill="#CECECE" />
      <path d="M566.75 214.3H565.38V215.33H566.75V214.3Z" fill="#CECECE" />
      <path
        d="M565.28 217.75V218.78L566.85 218.77V217.73L565.28 217.75Z"
        fill="#CECECE"
      />
      <path d="M566.85 225.94H565.32V226.97H566.85V225.94Z" fill="#CECECE" />
      <path
        d="M563.1 215.91V216.95H564.66V215.9L563.1 215.91Z"
        fill="#CECECE"
      />
      <path
        d="M563.1 221.47V222.5H564.66V221.46L563.1 221.47Z"
        fill="#CECECE"
      />
      <path d="M566.75 219.58H565.38V220.62H566.75V219.58Z" fill="#CECECE" />
      <path d="M566.75 224.43H565.38V225.46H566.75V224.43Z" fill="#CECECE" />
      <path d="M540.23 201.02H538.88V202.5H540.23V201.02Z" fill="#CECECE" />
      <path d="M532.95 201H531.87V202.46H532.95V201Z" fill="#CECECE" />
      <path d="M540.23 205.55H538.88V207.03H540.23V205.55Z" fill="#CECECE" />
      <path d="M540.23 198.73H538.88V200.21H540.23V198.73Z" fill="#CECECE" />
      <path d="M538.41 198.73H537.06V200.21H538.41V198.73Z" fill="#CECECE" />
      <path
        d="M529.7 209.37L528.63 209.38V207.9L529.7 207.88V209.37Z"
        fill="#CECECE"
      />
      <path
        d="M531.38 209.34L530.31 209.36V207.87L531.38 207.85V209.34Z"
        fill="#CECECE"
      />
      <path d="M534.72 209.98H533.65V211.49H534.72V209.98Z" fill="#CECECE" />
      <path d="M534.72 212.24H533.65V213.75H534.72V212.24Z" fill="#CECECE" />
      <path
        d="M542.45 209.23H540.99V207.74C540.99 207.74 542.44 207.74 542.45 207.74V209.23Z"
        fill="#CECECE"
      />
      <path
        d="M538.35 209.25L537.11 209.26V207.78L538.35 207.76V209.25Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 211.48L530.21 211.5V210L531.29 209.98V211.48Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 213.74L530.21 213.76V212.25L531.29 212.24V213.74Z"
        fill="#CECECE"
      />
      <path d="M540.23 210H538.88V211.48H540.23V210Z" fill="#CECECE" />
      <path
        d="M529.71 218.93L528.63 218.98V217.53L529.71 217.48V218.93Z"
        fill="#CECECE"
      />
      <path
        d="M529.7 223.18L528.63 223.19V221.7L529.7 221.69V223.18Z"
        fill="#CECECE"
      />
      <path
        d="M533.02 218.78L531.95 218.83V217.38L533.02 217.33V218.78Z"
        fill="#CECECE"
      />
      <path d="M534.72 223.79H533.65V225.3H534.72V223.79Z" fill="#CECECE" />
      <path
        d="M542.46 218.52L540.99 218.54V217.08C540.99 217.08 542.42 217.06 542.46 217.06V218.53V218.52Z"
        fill="#CECECE"
      />
      <path
        d="M542.45 223.04H540.99V221.55C540.99 221.55 542.44 221.55 542.45 221.55V223.04Z"
        fill="#CECECE"
      />
      <path
        d="M538.35 218.58L537.11 218.61V217.17L538.35 217.13V218.58Z"
        fill="#CECECE"
      />
      <path
        d="M529.7 227.87L528.63 227.89V226.4L529.7 226.38V227.87Z"
        fill="#CECECE"
      />
      <path
        d="M542.45 229.84H540.99V228.35C540.99 228.35 542.44 228.35 542.45 228.35V229.84Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 220.84L530.21 220.86V219.35L531.29 219.34V220.84Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 225.32L530.21 225.33V223.83L531.29 223.81V225.32Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 232.09L530.21 232.1V230.6L531.29 230.59V232.09Z"
        fill="#CECECE"
      />
      <path
        d="M531.29 234.35L530.21 234.36V232.86L531.29 232.85V234.35Z"
        fill="#CECECE"
      />
      <path d="M534.67 214.81H533.59V216.33H534.67V214.81Z" fill="#CECECE" />
      <path d="M536.46 223.85H535.39V225.36H536.46V223.85Z" fill="#CECECE" />
      <path d="M536.46 223.85H535.39V225.36H536.46V223.85Z" fill="#CECECE" />
      <path d="M536.46 219.49H535.39V221H536.46V219.49Z" fill="#CECECE" />
      <path d="M536.46 226.11H535.39V227.62H536.46V226.11Z" fill="#CECECE" />
      <path d="M538.23 226.11H537.16V227.62H538.23V226.11Z" fill="#CECECE" />
      <path d="M536.4 228.67H535.32V230.19H536.4V228.67Z" fill="#CECECE" />
      <path
        d="M542.46 211.49H540.99V209.99C540.99 209.99 542.45 209.99 542.46 209.99V211.5V211.49Z"
        fill="#CECECE"
      />
      <path d="M540.23 214.83H538.88V216.31H540.23V214.83Z" fill="#CECECE" />
      <path d="M532.95 214.81H531.87V216.27H532.95V214.81Z" fill="#CECECE" />
      <path d="M540.23 219.35H538.88V220.83H540.23V219.35Z" fill="#CECECE" />
      <path d="M540.23 212.54H538.88V214.02H540.23V212.54Z" fill="#CECECE" />
      <path d="M538.41 212.54H537.06V214.02H538.41V212.54Z" fill="#CECECE" />
      <path d="M548.24 198.58H546.43V200.06H548.24V198.58Z" fill="#CECECE" />
      <path d="M548.24 193.82H546.43V195.3H548.24V193.82Z" fill="#CECECE" />
      <path d="M548.24 207.63H546.43V209.11H548.24V207.63Z" fill="#CECECE" />
      <path d="M548.24 220.94H546.43V222.42H548.24V220.94Z" fill="#CECECE" />
      <path d="M747.41 209.8H746.8V210.88H747.41V209.8Z" fill="#CECECE" />
      <path d="M749.52 209.8H748.83V210.88H749.52V209.8Z" fill="#CECECE" />
      <path d="M744.62 209.8H743.59V210.88H744.62V209.8Z" fill="#CECECE" />
      <path d="M742.35 209.8H741.39V210.88H742.35V209.8Z" fill="#CECECE" />
      <path d="M739.37 209.8H738.42V210.88H739.37V209.8Z" fill="#CECECE" />
      <path d="M750.32 209.8H749.75V210.88H750.32V209.8Z" fill="#CECECE" />
      <path d="M740.89 207.82H739.86V208.94H740.89V207.82Z" fill="#CECECE" />
      <path d="M737.98 207.82H737.24V208.94H737.98V207.82Z" fill="#CECECE" />
      <path d="M736.82 209.8H735.89V210.88H736.82V209.8Z" fill="#CECECE" />
      <path d="M743.42 207.82H742.58V208.94H743.42V207.82Z" fill="#CECECE" />
      <path d="M743.42 209.8H742.58V210.88H743.42V209.8Z" fill="#CECECE" />
      <path d="M746.68 209.8H745.99V210.88H746.68V209.8Z" fill="#CECECE" />
      <path d="M747.41 211.68H746.8V212.76H747.41V211.68Z" fill="#CECECE" />
      <path d="M749.52 211.68H748.83V212.76H749.52V211.68Z" fill="#CECECE" />
      <path d="M744.62 211.68H743.59V212.76H744.62V211.68Z" fill="#CECECE" />
      <path d="M742.35 211.68H741.39V212.76H742.35V211.68Z" fill="#CECECE" />
      <path d="M737.98 211.68H737.24V212.76H737.98V211.68Z" fill="#CECECE" />
      <path d="M740.89 211.68H739.86V212.76H740.89V211.68Z" fill="#CECECE" />
      <path d="M747.41 213.52H746.8V214.6H747.41V213.52Z" fill="#CECECE" />
      <path d="M749.52 213.52H748.83V214.6H749.52V213.52Z" fill="#CECECE" />
      <path d="M744.62 213.52H743.59V214.6H744.62V213.52Z" fill="#CECECE" />
      <path d="M742.35 213.52H741.39V214.6H742.35V213.52Z" fill="#CECECE" />
      <path d="M739.37 213.52H738.42V214.6H739.37V213.52Z" fill="#CECECE" />
      <path d="M750.32 213.52H749.75V214.6H750.32V213.52Z" fill="#CECECE" />
      <path d="M743.42 213.52H742.58V214.6H743.42V213.52Z" fill="#CECECE" />
      <path d="M746.68 213.52H745.99V214.6H746.68V213.52Z" fill="#CECECE" />
      <path d="M747.41 215.4H746.8V216.48H747.41V215.4Z" fill="#CECECE" />
      <path d="M749.52 215.4H748.83V216.48H749.52V215.4Z" fill="#CECECE" />
      <path d="M744.62 215.4H743.59V216.48H744.62V215.4Z" fill="#CECECE" />
      <path d="M742.35 215.4H741.39V216.48H742.35V215.4Z" fill="#CECECE" />
      <path d="M750.32 215.4H749.75V216.48H750.32V215.4Z" fill="#CECECE" />
      <path d="M740.89 215.4H739.86V216.48H740.89V215.4Z" fill="#CECECE" />
      <path d="M747.41 217.17H746.8V218.25H747.41V217.17Z" fill="#CECECE" />
      <path d="M744.62 217.17H743.59V218.25H744.62V217.17Z" fill="#CECECE" />
      <path d="M742.35 217.17H741.39V218.25H742.35V217.17Z" fill="#CECECE" />
      <path d="M739.37 217.17H738.42V218.25H739.37V217.17Z" fill="#CECECE" />
      <path d="M750.32 217.17H749.75V218.25H750.32V217.17Z" fill="#CECECE" />
      <path d="M743.42 217.17H742.58V218.25H743.42V217.17Z" fill="#CECECE" />
      <path d="M747.41 219.06H746.8V220.14H747.41V219.06Z" fill="#CECECE" />
      <path d="M749.52 219.06H748.83V220.14H749.52V219.06Z" fill="#CECECE" />
      <path d="M742.35 219.06H741.39V220.14H742.35V219.06Z" fill="#CECECE" />
      <path d="M750.32 219.06H749.75V220.14H750.32V219.06Z" fill="#CECECE" />
      <path d="M743.42 219.06H742.58V220.14H743.42V219.06Z" fill="#CECECE" />
      <path d="M746.68 219.06H745.99V220.14H746.68V219.06Z" fill="#CECECE" />
      <path d="M747.41 220.89H746.8V221.97H747.41V220.89Z" fill="#CECECE" />
      <path d="M749.52 220.89H748.83V221.97H749.52V220.89Z" fill="#CECECE" />
      <path d="M744.62 220.89H743.59V221.97H744.62V220.89Z" fill="#CECECE" />
      <path d="M739.37 220.89H738.42V221.97H739.37V220.89Z" fill="#CECECE" />
      <path d="M740.89 220.89H739.86V221.97H740.89V220.89Z" fill="#CECECE" />
      <path d="M743.42 220.89H742.58V221.97H743.42V220.89Z" fill="#CECECE" />
      <path d="M746.68 220.89H745.99V221.97H746.68V220.89Z" fill="#CECECE" />
      <path d="M747.41 222.78H746.8V223.86H747.41V222.78Z" fill="#CECECE" />
      <path d="M749.52 222.78H748.83V223.86H749.52V222.78Z" fill="#CECECE" />
      <path d="M744.62 222.78H743.59V223.86H744.62V222.78Z" fill="#CECECE" />
      <path d="M747.41 224.72H746.8V225.8H747.41V224.72Z" fill="#CECECE" />
      <path d="M743.42 224.72H742.58V225.8H743.42V224.72Z" fill="#CECECE" />
      <path d="M746.68 224.72H745.99V225.8H746.68V224.72Z" fill="#CECECE" />
      <path d="M747.41 226.56H746.8V227.64H747.41V226.56Z" fill="#CECECE" />
      <path d="M749.52 226.56H748.83V227.64H749.52V226.56Z" fill="#CECECE" />
      <path d="M744.62 226.56H743.59V227.64H744.62V226.56Z" fill="#CECECE" />
      <path d="M746.68 226.56H745.99V227.64H746.68V226.56Z" fill="#CECECE" />
      <path d="M747.41 228.44H746.8V229.52H747.41V228.44Z" fill="#CECECE" />
      <path d="M744.62 228.44H743.59V229.52H744.62V228.44Z" fill="#CECECE" />
      <path d="M742.35 222.78H741.39V223.86H742.35V222.78Z" fill="#CECECE" />
      <path d="M603.95 212.3H603.22V213.59H603.95V212.3Z" fill="#CECECE" />
      <path d="M600.61 212.3H599.38V213.59H600.61V212.3Z" fill="#CECECE" />
      <path d="M598.45 212.3H597.3V213.59H598.45V212.3Z" fill="#CECECE" />
      <path d="M594.34 212.3H593.2V213.59H594.34V212.3Z" fill="#CECECE" />
      <path d="M603.95 214.55H603.22V215.84H603.95V214.55Z" fill="#CECECE" />
      <path d="M606.48 214.55H605.65V215.84H606.48V214.55Z" fill="#CECECE" />
      <path d="M606.48 210.01H605.65V211.3H606.48V210.01Z" fill="#CECECE" />
      <path d="M598.45 214.55H597.3V215.84H598.45V214.55Z" fill="#CECECE" />
      <path d="M603.08 210.01H602.26V211.3H603.08V210.01Z" fill="#CECECE" />
      <path d="M606.48 216.75H605.65V218.04H606.48V216.75Z" fill="#CECECE" />
      <path d="M600.61 216.75H599.38V218.04H600.61V216.75Z" fill="#CECECE" />
      <path d="M594.88 216.75H593.74V218.04H594.88V216.75Z" fill="#CECECE" />
      <path d="M596.69 216.75H595.46V218.04H596.69V216.75Z" fill="#CECECE" />
      <path d="M603.08 216.75H602.26V218.04H603.08V216.75Z" fill="#CECECE" />
      <path d="M603.95 219H603.22V220.29H603.95V219Z" fill="#CECECE" />
      <path d="M600.61 219H599.38V220.29H600.61V219Z" fill="#CECECE" />
      <path d="M603.95 221.32H603.22V222.61H603.95V221.32Z" fill="#CECECE" />
      <path d="M603.08 221.32H602.26V222.61H603.08V221.32Z" fill="#CECECE" />
      <path d="M603.95 223.52H603.22V224.81H603.95V223.52Z" fill="#CECECE" />
      <path d="M606.48 223.52H605.65V224.81H606.48V223.52Z" fill="#CECECE" />
      <path d="M600.61 223.52H599.38V224.81H600.61V223.52Z" fill="#CECECE" />
      <path d="M603.95 225.77H603.22V227.06H603.95V225.77Z" fill="#CECECE" />
      <path d="M600.61 225.77H599.38V227.06H600.61V225.77Z" fill="#CECECE" />
      <path d="M598.45 219H597.3V220.29H598.45V219Z" fill="#CECECE" />
      <path d="M750.32 222.78H749.75V223.86H750.32V222.78Z" fill="#CECECE" />
      <path d="M745.82 207.45H744.79V234.57H745.82V207.45Z" fill="#CECECE" />
      <path d="M750.89 207.04H750.59V218.25H750.89V207.04Z" fill="#CECECE" />
      <path d="M757.3 207.94H756.58V208.78H757.3V207.94Z" fill="#CECECE" />
      <path
        d="M758.99 207.23L758.22 207.21V206.39L758.99 206.41V207.23Z"
        fill="#CECECE"
      />
      <path
        d="M760.79 207.28L760.28 207.27V206.44L760.79 206.46V207.28Z"
        fill="#CECECE"
      />
      <path d="M761.34 207.94H760.88V208.78H761.34V207.94Z" fill="#CECECE" />
      <path
        d="M762.96 207.34L762.4 207.33V206.51L762.96 206.52V207.34Z"
        fill="#CECECE"
      />
      <path d="M762.97 207.94H762.4V208.78H762.97V207.94Z" fill="#CECECE" />
      <path
        d="M763.51 207.36L763.08 207.34V206.53L763.51 206.54V207.36Z"
        fill="#CECECE"
      />
      <path
        d="M755.44 207.2L756.21 207.19V206.37L755.44 206.38V207.2Z"
        fill="#CECECE"
      />
      <path d="M761.34 209.41H760.88V210.21H761.34V209.41Z" fill="#CECECE" />
      <path d="M762.9 209.41H762.39V210.21H762.9V209.41Z" fill="#CECECE" />
      <path d="M758.99 209.41H758.22V210.21H758.99V209.41Z" fill="#CECECE" />
      <path d="M757.31 209.41H756.59V210.21H757.31V209.41Z" fill="#CECECE" />
      <path d="M763.51 209.41H763.08V210.21H763.51V209.41Z" fill="#CECECE" />
      <path d="M756.21 207.94H755.44V208.78H756.21V207.94Z" fill="#CECECE" />
      <path d="M758.09 207.94H757.47V208.78H758.09V207.94Z" fill="#CECECE" />
      <path d="M758.09 209.41H757.47V210.21H758.09V209.41Z" fill="#CECECE" />
      <path d="M760.79 209.41H760.28V210.21H760.79V209.41Z" fill="#CECECE" />
      <path d="M761.34 210.82H760.88V211.62H761.34V210.82Z" fill="#CECECE" />
      <path d="M762.9 210.82H762.39V211.62H762.9V210.82Z" fill="#CECECE" />
      <path d="M758.99 210.82H758.22V211.62H758.99V210.82Z" fill="#CECECE" />
      <path d="M757.31 210.82H756.59V211.62H757.31V210.82Z" fill="#CECECE" />
      <path d="M756.21 210.82H755.44V211.62H756.21V210.82Z" fill="#CECECE" />
      <path d="M761.34 212.18H760.88V212.98H761.34V212.18Z" fill="#CECECE" />
      <path d="M762.9 212.18H762.39V212.98H762.9V212.18Z" fill="#CECECE" />
      <path d="M758.99 212.18H758.22V212.98H758.99V212.18Z" fill="#CECECE" />
      <path d="M757.31 212.18H756.59V212.98H757.31V212.18Z" fill="#CECECE" />
      <path d="M763.51 212.18H763.08V212.98H763.51V212.18Z" fill="#CECECE" />
      <path d="M758.09 212.18H757.47V212.98H758.09V212.18Z" fill="#CECECE" />
      <path d="M760.79 212.18H760.28V212.98H760.79V212.18Z" fill="#CECECE" />
      <path d="M761.34 213.59H760.88V214.39H761.34V213.59Z" fill="#CECECE" />
      <path d="M762.9 213.59H762.39V214.39H762.9V213.59Z" fill="#CECECE" />
      <path d="M758.99 213.59H758.22V214.39H758.99V213.59Z" fill="#CECECE" />
      <path d="M757.31 213.59H756.59V214.39H757.31V213.59Z" fill="#CECECE" />
      <path d="M763.51 213.59H763.08V214.39H763.51V213.59Z" fill="#CECECE" />
      <path d="M756.21 213.59H755.44V214.39H756.21V213.59Z" fill="#CECECE" />
      <path d="M754.99 212.36H754.22V213.16H754.99V212.36Z" fill="#CECECE" />
      <path d="M761.34 214.9H760.88V215.7H761.34V214.9Z" fill="#CECECE" />
      <path d="M758.99 214.9H758.22V215.7H758.99V214.9Z" fill="#CECECE" />
      <path d="M757.31 214.9H756.59V215.7H757.31V214.9Z" fill="#CECECE" />
      <path d="M763.51 214.9H763.08V215.7H763.51V214.9Z" fill="#CECECE" />
      <path d="M758.09 214.9H757.47V215.7H758.09V214.9Z" fill="#CECECE" />
      <path d="M761.34 216.3H760.88V217.1H761.34V216.3Z" fill="#CECECE" />
      <path d="M762.9 216.3H762.39V217.1H762.9V216.3Z" fill="#CECECE" />
      <path d="M757.31 216.3H756.59V217.1H757.31V216.3Z" fill="#CECECE" />
      <path d="M763.51 216.3H763.08V217.1H763.51V216.3Z" fill="#CECECE" />
      <path d="M758.09 216.3H757.47V217.1H758.09V216.3Z" fill="#CECECE" />
      <path d="M760.79 216.3H760.28V217.1H760.79V216.3Z" fill="#CECECE" />
      <path d="M761.34 217.67H760.88V218.47H761.34V217.67Z" fill="#CECECE" />
      <path d="M762.9 217.67H762.39V218.47H762.9V217.67Z" fill="#CECECE" />
      <path d="M758.99 217.67H758.22V218.47H758.99V217.67Z" fill="#CECECE" />
      <path d="M756.21 217.67H755.44V218.47H756.21V217.67Z" fill="#CECECE" />
      <path d="M758.09 217.67H757.47V218.47H758.09V217.67Z" fill="#CECECE" />
      <path d="M760.79 217.67H760.28V218.47H760.79V217.67Z" fill="#CECECE" />
      <path d="M761.34 219.07H760.88V219.87H761.34V219.07Z" fill="#CECECE" />
      <path d="M762.9 219.07H762.39V219.87H762.9V219.07Z" fill="#CECECE" />
      <path d="M758.99 219.07H758.22V219.87H758.99V219.07Z" fill="#CECECE" />
      <path d="M761.34 220.52H760.88V221.32H761.34V220.52Z" fill="#CECECE" />
      <path d="M758.09 220.52H757.47V221.32H758.09V220.52Z" fill="#CECECE" />
      <path d="M760.79 220.52H760.28V221.32H760.79V220.52Z" fill="#CECECE" />
      <path d="M761.34 221.89H760.88V222.69H761.34V221.89Z" fill="#CECECE" />
      <path d="M762.9 221.89H762.39V222.69H762.9V221.89Z" fill="#CECECE" />
      <path d="M758.99 221.89H758.22V222.69H758.99V221.89Z" fill="#CECECE" />
      <path d="M760.79 221.89H760.28V222.69H760.79V221.89Z" fill="#CECECE" />
      <path d="M761.34 223.29H760.88V224.09H761.34V223.29Z" fill="#CECECE" />
      <path d="M758.99 223.29H758.22V224.09H758.99V223.29Z" fill="#CECECE" />
      <path d="M757.31 219.07H756.59V219.87H757.31V219.07Z" fill="#CECECE" />
      <path d="M763.51 219.07H763.08V219.87H763.51V219.07Z" fill="#CECECE" />
      <path d="M731.61 200.29H729.57V201.17H731.61V200.29Z" fill="#CECECE" />
      <path d="M729.16 200.29H727.64V201.17H729.16V200.29Z" fill="#CECECE" />
      <path d="M729.16 202.05H727.64V202.93H729.16V202.05Z" fill="#CECECE" />
      <path d="M731.61 203.69H729.57V204.71H731.61V203.69Z" fill="#CECECE" />
      <path d="M729.16 203.69H727.64V204.71H729.16V203.69Z" fill="#CECECE" />
      <path d="M731.61 205.72H729.57V206.74H731.61V205.72Z" fill="#CECECE" />
      <path d="M729.16 207.82H727.64V208.84H729.16V207.82Z" fill="#CECECE" />
      <path d="M731.61 209.83H729.57V210.85H731.61V209.83Z" fill="#CECECE" />
      <path d="M729.16 209.83H727.64V210.85H729.16V209.83Z" fill="#CECECE" />
      <path d="M729.16 211.71H727.64V212.73H729.16V211.71Z" fill="#CECECE" />
      <path d="M731.61 213.55H729.57V214.57H731.61V213.55Z" fill="#CECECE" />
      <path d="M729.16 215.43H727.64V216.45H729.16V215.43Z" fill="#CECECE" />
      <path d="M731.61 217.27H729.57V218.29H731.61V217.27Z" fill="#CECECE" />
      <path d="M729.16 217.27H727.64V218.29H729.16V217.27Z" fill="#CECECE" />
      <path d="M731.61 219.8H729.57V220.82H731.61V219.8Z" fill="#CECECE" />
      <path d="M729.16 221.4H727.64V222.42H729.16V221.4Z" fill="#CECECE" />
      <path d="M729.16 223.41H727.64V224.43H729.16V223.41Z" fill="#CECECE" />
      <path d="M729.16 225.29H727.64V226.31H729.16V225.29Z" fill="#CECECE" />
      <path d="M729.16 229.01H727.64V230.03H729.16V229.01Z" fill="#CECECE" />
      <path d="M726.92 199.78H726.13V212.76H726.92V199.78Z" fill="#CECECE" />
      <path d="M725.89 204.54H725.1V215.21H725.89V204.54Z" fill="#CECECE" />
      <path d="M603.89 196.6H603.23V198.06H603.89V196.6Z" fill="#CECECE" />
      <path d="M606.6 196.6H605.67V198.06H606.6V196.6Z" fill="#CECECE" />
      <path d="M607.49 196.6H606.79V198.06H607.49V196.6Z" fill="#CECECE" />
      <path d="M600.51 196.6H599.26V198.06H600.51V196.6Z" fill="#CECECE" />
      <path d="M599.05 196.6H597.91V198.06H599.05V196.6Z" fill="#CECECE" />
      <path d="M603.05 199.18H602.21V200.64H603.05V199.18Z" fill="#CECECE" />
      <path d="M603.89 199.18H603.23V200.64H603.89V199.18Z" fill="#CECECE" />
      <path d="M606.6 199.18H605.67V200.64H606.6V199.18Z" fill="#CECECE" />
      <path d="M600.51 199.18H599.26V200.64H600.51V199.18Z" fill="#CECECE" />
      <path d="M603.89 201.83H603.23V203.29H603.89V201.83Z" fill="#CECECE" />
      <path d="M606.6 201.83H605.67V203.29H606.6V201.83Z" fill="#CECECE" />
      <path d="M607.49 201.83H606.79V203.29H607.49V201.83Z" fill="#CECECE" />
      <path d="M599.05 201.83H597.91V203.29H599.05V201.83Z" fill="#CECECE" />
      <path d="M603.05 204.25H602.21V205.71H603.05V204.25Z" fill="#CECECE" />
      <path d="M606.6 204.25H605.67V205.71H606.6V204.25Z" fill="#CECECE" />
      <path d="M600.51 204.25H599.26V205.71H600.51V204.25Z" fill="#CECECE" />
      <path d="M603.89 206.9H603.23V208.36H603.89V206.9Z" fill="#CECECE" />
      <path d="M607.49 206.9H606.79V208.36H607.49V206.9Z" fill="#CECECE" />
      <path d="M602 194.04H600.74V209.08H602V194.04Z" fill="#CECECE" />
      <path d="M605.41 194.55H604.15V203.29H605.41V194.55Z" fill="#CECECE" />
      <path d="M608.18 194.34H607.82V205.71H608.18V194.34Z" fill="#CECECE" />
      <path d="M568.13 145.6H567.33V169.42H568.13V145.6Z" fill="#CECECE" />
      <path d="M569.22 141.97H568.59V165.79H569.22V141.97Z" fill="#CECECE" />
      <path d="M760.01 204.86H759.21V227.34H760.01V204.86Z" fill="#CECECE" />
      <path d="M762.18 221.52H761.38V230.06H762.18V221.52Z" fill="#CECECE" />
      <path d="M763.96 205.33H763.73V215.3H763.96V205.33Z" fill="#CECECE" />
      <path d="M678.4 182.56H659.88V183.38H678.4V182.56Z" fill="#CECECE" />
      <path d="M686.97 180.16H686.23V204.56H686.97V180.16Z" fill="#CECECE" />
      <path d="M611.49 198.54H609.77V199.98H611.49V198.54Z" fill="#CECECE" />
      <path d="M611.49 200.66H609.77V202.1H611.49V200.66Z" fill="#CECECE" />
      <path d="M611.49 202.77H609.77V204.21H611.49V202.77Z" fill="#CECECE" />
      <path d="M611.49 204.89H609.77V206.33H611.49V204.89Z" fill="#CECECE" />
      <path d="M611.49 207.01H609.77V208.45H611.49V207.01Z" fill="#CECECE" />
      <path d="M611.49 213.36H609.77V214.8H611.49V213.36Z" fill="#CECECE" />
      <path d="M611.49 215.48H609.77V216.92H611.49V215.48Z" fill="#CECECE" />
      <path d="M611.49 217.6H609.77V219.04H611.49V217.6Z" fill="#CECECE" />
      <path d="M611.49 221.83H609.77V223.27H611.49V221.83Z" fill="#CECECE" />
      <path d="M611.49 223.95H609.77V225.39H611.49V223.95Z" fill="#CECECE" />
      <path d="M611.49 226.07H609.77V227.51H611.49V226.07Z" fill="#CECECE" />
      <path d="M611.49 228.19H609.77V229.63H611.49V228.19Z" fill="#CECECE" />
      <path d="M614.29 198.54H612.57V199.98H614.29V198.54Z" fill="#CECECE" />
      <path d="M614.29 200.66H612.57V202.1H614.29V200.66Z" fill="#CECECE" />
      <path d="M617.01 200.66H615.29V202.1H617.01V200.66Z" fill="#CECECE" />
      <path d="M614.29 202.77H612.57V204.21H614.29V202.77Z" fill="#CECECE" />
      <path d="M614.29 204.89H612.57V206.33H614.29V204.89Z" fill="#CECECE" />
      <path d="M614.29 207.01H612.57V208.45H614.29V207.01Z" fill="#CECECE" />
      <path d="M614.29 211.24H612.57V212.68H614.29V211.24Z" fill="#CECECE" />
      <path d="M614.29 215.48H612.57V216.92H614.29V215.48Z" fill="#CECECE" />
      <path d="M614.29 217.6H612.57V219.04H614.29V217.6Z" fill="#CECECE" />
      <path d="M614.29 219.72H612.57V221.16H614.29V219.72Z" fill="#CECECE" />
      <path d="M614.29 221.83H612.57V223.27H614.29V221.83Z" fill="#CECECE" />
      <path d="M614.29 223.95H612.57V225.39H614.29V223.95Z" fill="#CECECE" />
      <path d="M617.09 198.54H615.36V199.98H617.09V198.54Z" fill="#CECECE" />
      <path d="M617.09 204.89H615.36V206.33H617.09V204.89Z" fill="#CECECE" />
      <path d="M617.09 207.01H615.36V208.45H617.09V207.01Z" fill="#CECECE" />
      <path d="M617.09 209.13H615.36V210.57H617.09V209.13Z" fill="#CECECE" />
      <path d="M617.09 211.24H615.36V212.68H617.09V211.24Z" fill="#CECECE" />
      <path d="M617.09 213.36H615.36V214.8H617.09V213.36Z" fill="#CECECE" />
      <path d="M617.09 215.48H615.36V216.92H617.09V215.48Z" fill="#CECECE" />
      <path d="M617.09 219.72H615.36V221.16H617.09V219.72Z" fill="#CECECE" />
      <path d="M617.09 221.83H615.36V223.27H617.09V221.83Z" fill="#CECECE" />
      <path d="M617.09 223.95H615.36V225.39H617.09V223.95Z" fill="#CECECE" />
      <path d="M617.09 226.07H615.36V227.51H617.09V226.07Z" fill="#CECECE" />
      <path d="M617.09 228.19H615.36V229.63H617.09V228.19Z" fill="#CECECE" />
      <path d="M619.9 200.66H618.17V202.1H619.9V200.66Z" fill="#CECECE" />
      <path d="M619.9 202.77H618.17V204.21H619.9V202.77Z" fill="#CECECE" />
      <path d="M622.69 202.77H620.96V204.21H622.69V202.77Z" fill="#CECECE" />
      <path d="M619.9 204.89H618.17V206.33H619.9V204.89Z" fill="#CECECE" />
      <path d="M619.9 209.13H618.17V210.57H619.9V209.13Z" fill="#CECECE" />
      <path d="M619.9 213.36H618.17V214.8H619.9V213.36Z" fill="#CECECE" />
      <path d="M619.9 215.48H618.17V216.92H619.9V215.48Z" fill="#CECECE" />
      <path d="M619.9 217.6H618.17V219.04H619.9V217.6Z" fill="#CECECE" />
      <path d="M619.9 226.07H618.17V227.51H619.9V226.07Z" fill="#CECECE" />
      <path d="M619.9 230.3H618.17V231.74H619.9V230.3Z" fill="#CECECE" />
      <path d="M622.69 198.54H620.96V199.98H622.69V198.54Z" fill="#CECECE" />
      <path d="M622.69 200.66H620.96V202.1H622.69V200.66Z" fill="#CECECE" />
      <path d="M622.69 204.89H620.96V206.33H622.69V204.89Z" fill="#CECECE" />
      <path d="M622.69 207.01H620.96V208.45H622.69V207.01Z" fill="#CECECE" />
      <path d="M622.69 209.13H620.96V210.57H622.69V209.13Z" fill="#CECECE" />
      <path d="M622.69 211.24H620.96V212.68H622.69V211.24Z" fill="#CECECE" />
      <path d="M622.69 213.36H620.96V214.8H622.69V213.36Z" fill="#CECECE" />
      <path d="M622.69 217.6H620.96V219.04H622.69V217.6Z" fill="#CECECE" />
      <path d="M622.69 219.72H620.96V221.16H622.69V219.72Z" fill="#CECECE" />
      <path d="M622.69 221.83H620.96V223.27H622.69V221.83Z" fill="#CECECE" />
      <path d="M622.69 223.95H620.96V225.39H622.69V223.95Z" fill="#CECECE" />
      <path d="M622.69 226.07H620.96V227.51H622.69V226.07Z" fill="#CECECE" />
      <path d="M622.69 228.19H620.96V229.63H622.69V228.19Z" fill="#CECECE" />
      <path d="M625.48 200.66H623.76V202.1H625.48V200.66Z" fill="#CECECE" />
      <path d="M625.48 202.77H623.76V204.21H625.48V202.77Z" fill="#CECECE" />
      <path d="M625.48 204.89H623.76V206.33H625.48V204.89Z" fill="#CECECE" />
      <path d="M625.48 207.01H623.76V208.45H625.48V207.01Z" fill="#CECECE" />
      <path d="M625.48 209.13H623.76V210.57H625.48V209.13Z" fill="#CECECE" />
      <path d="M625.48 211.24H623.76V212.68H625.48V211.24Z" fill="#CECECE" />
      <path d="M625.48 213.36H623.76V214.8H625.48V213.36Z" fill="#CECECE" />
      <path d="M625.48 215.48H623.76V216.92H625.48V215.48Z" fill="#CECECE" />
      <path d="M625.48 217.6H623.76V219.04H625.48V217.6Z" fill="#CECECE" />
      <path d="M625.48 219.72H623.76V221.16H625.48V219.72Z" fill="#CECECE" />
      <path d="M625.48 221.83H623.76V223.27H625.48V221.83Z" fill="#CECECE" />
      <path d="M625.48 223.95H623.76V225.39H625.48V223.95Z" fill="#CECECE" />
      <path d="M628.29 198.54H626.56V199.98H628.29V198.54Z" fill="#CECECE" />
      <path d="M628.29 200.66H626.56V202.1H628.29V200.66Z" fill="#CECECE" />
      <path d="M628.29 202.77H626.56V204.21H628.29V202.77Z" fill="#CECECE" />
      <path d="M630.71 202.77H628.98V204.21H630.71V202.77Z" fill="#CECECE" />
      <path d="M628.29 204.89H626.56V206.33H628.29V204.89Z" fill="#CECECE" />
      <path d="M628.29 211.24H626.56V212.68H628.29V211.24Z" fill="#CECECE" />
      <path d="M628.29 213.36H626.56V214.8H628.29V213.36Z" fill="#CECECE" />
      <path d="M628.29 215.48H626.56V216.92H628.29V215.48Z" fill="#CECECE" />
      <path d="M628.29 217.6H626.56V219.04H628.29V217.6Z" fill="#CECECE" />
      <path d="M628.29 223.95H626.56V225.39H628.29V223.95Z" fill="#CECECE" />
      <path d="M628.29 226.07H626.56V227.51H628.29V226.07Z" fill="#CECECE" />
      <path d="M628.29 228.19H626.56V229.63H628.29V228.19Z" fill="#CECECE" />
      <path d="M611.49 230.38H609.77V231.82H611.49V230.38Z" fill="#CECECE" />
      <path d="M611.49 234.61H609.77V236.05H611.49V234.61Z" fill="#CECECE" />
      <path d="M614.29 228.26H612.57V229.7H614.29V228.26Z" fill="#CECECE" />
      <path d="M614.29 232.5H612.57V233.94H614.29V232.5Z" fill="#CECECE" />
      <path d="M614.29 234.61H612.57V236.05H614.29V234.61Z" fill="#CECECE" />
      <path d="M614.29 236.73H612.57V238.17H614.29V236.73Z" fill="#CECECE" />
      <path d="M614.29 238.85H612.57V240.29H614.29V238.85Z" fill="#CECECE" />
      <path d="M617.09 230.38H615.36V231.82H617.09V230.38Z" fill="#CECECE" />
      <path d="M617.09 236.73H615.36V238.17H617.09V236.73Z" fill="#CECECE" />
      <path d="M617.09 238.85H615.36V240.29H617.09V238.85Z" fill="#CECECE" />
      <path d="M619.9 232.5H618.17V233.94H619.9V232.5Z" fill="#CECECE" />
      <path d="M619.9 234.61H618.17V236.05H619.9V234.61Z" fill="#CECECE" />
      <path d="M622.69 228.26H620.96V229.7H622.69V228.26Z" fill="#CECECE" />
      <path d="M622.69 234.61H620.96V236.05H622.69V234.61Z" fill="#CECECE" />
      <path d="M622.69 236.73H620.96V238.17H622.69V236.73Z" fill="#CECECE" />
      <path d="M622.69 238.85H620.96V240.29H622.69V238.85Z" fill="#CECECE" />
      <path d="M625.48 228.26H623.76V229.7H625.48V228.26Z" fill="#CECECE" />
      <path d="M625.48 230.38H623.76V231.82H625.48V230.38Z" fill="#CECECE" />
      <path d="M625.48 232.5H623.76V233.94H625.48V232.5Z" fill="#CECECE" />
      <path d="M625.48 236.73H623.76V238.17H625.48V236.73Z" fill="#CECECE" />
      <path d="M628.29 228.26H626.56V229.7H628.29V228.26Z" fill="#CECECE" />
      <path d="M628.29 234.61H626.56V236.05H628.29V234.61Z" fill="#CECECE" />
      <path d="M630.71 198.54H628.98V199.98H630.71V198.54Z" fill="#CECECE" />
      <path d="M630.71 200.66H628.98V202.1H630.71V200.66Z" fill="#CECECE" />
      <path d="M630.71 204.89H628.98V206.33H630.71V204.89Z" fill="#CECECE" />
      <path d="M630.71 207.01H628.98V208.45H630.71V207.01Z" fill="#CECECE" />
      <path d="M630.71 209.13H628.98V210.57H630.71V209.13Z" fill="#CECECE" />
      <path d="M630.71 211.24H628.98V212.68H630.71V211.24Z" fill="#CECECE" />
      <path d="M630.71 213.36H628.98V214.8H630.71V213.36Z" fill="#CECECE" />
      <path d="M630.71 217.6H628.98V219.04H630.71V217.6Z" fill="#CECECE" />
      <path d="M630.71 219.72H628.98V221.16H630.71V219.72Z" fill="#CECECE" />
      <path d="M630.71 221.83H628.98V223.27H630.71V221.83Z" fill="#CECECE" />
      <path d="M630.71 223.95H628.98V225.39H630.71V223.95Z" fill="#CECECE" />
      <path d="M630.71 226.07H628.98V227.51H630.71V226.07Z" fill="#CECECE" />
      <path d="M630.71 228.19H628.98V229.63H630.71V228.19Z" fill="#CECECE" />
      <path d="M633.51 196.42H609.77V197.86H633.51V196.42Z" fill="#CECECE" />
      <path d="M633.51 200.66H631.78V202.1H633.51V200.66Z" fill="#CECECE" />
      <path d="M633.51 202.77H631.78V204.21H633.51V202.77Z" fill="#CECECE" />
      <path d="M633.51 204.89H631.78V206.33H633.51V204.89Z" fill="#CECECE" />
      <path d="M633.51 207.01H631.78V208.45H633.51V207.01Z" fill="#CECECE" />
      <path d="M633.51 209.13H631.78V210.57H633.51V209.13Z" fill="#CECECE" />
      <path d="M633.51 211.24H631.78V212.68H633.51V211.24Z" fill="#CECECE" />
      <path d="M633.51 213.36H631.78V214.8H633.51V213.36Z" fill="#CECECE" />
      <path d="M633.51 215.48H631.78V216.92H633.51V215.48Z" fill="#CECECE" />
      <path d="M633.51 217.6H631.78V219.04H633.51V217.6Z" fill="#CECECE" />
      <path d="M633.51 219.72H631.78V221.16H633.51V219.72Z" fill="#CECECE" />
      <path d="M633.51 221.83H631.78V223.27H633.51V221.83Z" fill="#CECECE" />
      <path d="M633.51 223.95H631.78V225.39H633.51V223.95Z" fill="#CECECE" />
      <path d="M630.71 228.26H628.98V229.7H630.71V228.26Z" fill="#CECECE" />
      <path d="M630.71 234.61H628.98V236.05H630.71V234.61Z" fill="#CECECE" />
      <path d="M630.71 236.73H628.98V238.17H630.71V236.73Z" fill="#CECECE" />
      <path d="M630.71 238.85H628.98V240.29H630.71V238.85Z" fill="#CECECE" />
      <path d="M633.51 228.26H631.78V229.7H633.51V228.26Z" fill="#CECECE" />
      <path d="M633.51 230.38H631.78V231.82H633.51V230.38Z" fill="#CECECE" />
      <path d="M633.51 232.5H631.78V233.94H633.51V232.5Z" fill="#CECECE" />
      <path d="M633.51 236.73H631.78V238.17H633.51V236.73Z" fill="#CECECE" />
      <path d="M625.48 240.92H623.76V242.36H625.48V240.92Z" fill="#CECECE" />
      <path d="M625.48 243.04H623.76V244.48H625.48V243.04Z" fill="#CECECE" />
      <path d="M622.69 243.04H620.96V244.48H622.69V243.04Z" fill="#CECECE" />
      <path d="M625.48 245.16H623.76V246.6H625.48V245.16Z" fill="#CECECE" />
      <path d="M628.29 245.16H626.56V246.6H628.29V245.16Z" fill="#CECECE" />
      <path d="M628.29 249.39H626.56V250.83H628.29V249.39Z" fill="#CECECE" />
      <path d="M625.48 251.58H623.76V253.02H625.48V251.58Z" fill="#CECECE" />
      <path d="M628.29 249.46H626.56V250.9H628.29V249.46Z" fill="#CECECE" />
      <path d="M628.29 253.54H626.56V254.98H628.29V253.54Z" fill="#CECECE" />
      <path d="M630.71 243.04H628.98V244.48H630.71V243.04Z" fill="#CECECE" />
      <path d="M630.71 247.27H628.98V248.71H630.71V247.27Z" fill="#CECECE" />
      <path d="M630.71 249.39H628.98V250.83H630.71V249.39Z" fill="#CECECE" />
      <path d="M633.51 240.92H631.78V242.36H633.51V240.92Z" fill="#CECECE" />
      <path d="M633.51 245.16H631.78V246.6H633.51V245.16Z" fill="#CECECE" />
      <path d="M630.71 249.46H628.98V250.9H630.71V249.46Z" fill="#CECECE" />
      <path d="M630.71 255.66H628.98V257.1H630.71V255.66Z" fill="#CECECE" />
      <path d="M633.51 249.46H631.78V250.9H633.51V249.46Z" fill="#CECECE" />
      <path d="M633.51 251.58H631.78V253.02H633.51V251.58Z" fill="#CECECE" />
      <path d="M633.51 257.94H631.78V259.38H633.51V257.94Z" fill="#CECECE" />
      <path d="M633.51 260.18H631.78V261.62H633.51V260.18Z" fill="#CECECE" />
      <path d="M633.51 253.78H631.78V255.22H633.51V253.78Z" fill="#CECECE" />
      <path d="M628.29 198.44H609.77V199.26H628.29V198.44Z" fill="#CECECE" />
      <path
        d="M577.43 162.01L578.46 162.37V161.36L577.43 160.98V162.01Z"
        fill="#CECECE"
      />
      <path
        d="M577.43 166.15L578.46 166.48V165.43L577.43 165.08V166.15Z"
        fill="#CECECE"
      />
      <path
        d="M575.82 146.85L576.86 147.32V146.44L575.82 145.94V146.85Z"
        fill="#CECECE"
      />
      <path
        d="M575.82 148.94L576.86 149.39V148.5L575.82 148.01V148.94Z"
        fill="#CECECE"
      />
      <path
        d="M575.82 153.13L576.86 153.55V152.61L575.82 152.16V153.13Z"
        fill="#CECECE"
      />
      <path
        d="M575.82 155.22L576.85 155.62V154.67L575.82 154.24V155.22Z"
        fill="#CECECE"
      />
      <path
        d="M575.82 157.31L576.85 157.7V156.73L575.82 156.31V157.31Z"
        fill="#CECECE"
      />
      <path
        d="M575.82 159.4L576.85 159.78V158.79L575.82 158.39V159.4Z"
        fill="#CECECE"
      />
      <path
        d="M575.82 161.49L576.85 161.85V160.84L575.82 160.46V161.49Z"
        fill="#CECECE"
      />
      <path
        d="M575.82 163.59L576.85 163.93V162.9L575.82 162.54V163.59Z"
        fill="#CECECE"
      />
      <path
        d="M575.81 165.68L576.85 166.01V164.96L575.81 164.61V165.68Z"
        fill="#CECECE"
      />
      <path
        d="M574.15 146.17L575.19 146.64V145.76L574.15 145.25V146.17Z"
        fill="#CECECE"
      />
      <path
        d="M574.15 148.28L575.19 148.74V147.84L574.15 147.35V148.28Z"
        fill="#CECECE"
      />
      <path
        d="M574.15 150.4L575.2 150.84V149.92L574.15 149.45V150.4Z"
        fill="#CECECE"
      />
      <path
        d="M574.15 152.51L575.2 152.94V152L574.15 151.55V152.51Z"
        fill="#CECECE"
      />
      <path
        d="M574.15 154.63L575.2 155.04V154.08L574.15 153.64V154.63Z"
        fill="#CECECE"
      />
      <path
        d="M574.15 156.74L575.2 157.14V156.16L574.15 155.74V156.74Z"
        fill="#CECECE"
      />
      <path
        d="M574.15 158.86L575.2 159.23V158.24L574.15 157.84V158.86Z"
        fill="#CECECE"
      />
      <path
        d="M574.16 160.97L575.2 161.33V160.32L574.16 159.93V160.97Z"
        fill="#CECECE"
      />
      <path
        d="M574.16 163.09L575.2 163.43V162.4L574.16 162.03V163.09Z"
        fill="#CECECE"
      />
      <path
        d="M574.16 165.2L575.2 165.53V164.48L574.16 164.13V165.2Z"
        fill="#CECECE"
      />
      <path
        d="M574.16 167.32L575.2 167.63V166.56L574.16 166.23V167.32Z"
        fill="#CECECE"
      />
      <path
        d="M572.32 147.71L573.56 148.04V147.2L572.32 146.79V147.71Z"
        fill="#CECECE"
      />
      <path
        d="M572.32 149.84L573.56 150.16V149.3L572.32 148.91V149.84Z"
        fill="#CECECE"
      />
      <path
        d="M572.32 151.98L573.56 152.29V151.4L572.32 151.03V151.98Z"
        fill="#CECECE"
      />
      <path
        d="M572.32 154.11L573.56 154.41V153.51L572.32 153.14V154.11Z"
        fill="#CECECE"
      />
      <path
        d="M572.32 156.25L573.56 156.53V155.61L572.32 155.26V156.25Z"
        fill="#CECECE"
      />
      <path
        d="M572.32 158.38L573.56 158.66V157.71L572.32 157.38V158.38Z"
        fill="#CECECE"
      />
      <path
        d="M572.32 160.51L573.56 160.78V159.81L572.32 159.49V160.51Z"
        fill="#CECECE"
      />
      <path
        d="M572.33 162.65L573.56 162.9V161.92L572.33 161.61V162.65Z"
        fill="#CECECE"
      />
      <path
        d="M572.33 164.78L573.55 165.03V164.02L572.33 163.73V164.78Z"
        fill="#CECECE"
      />
      <path
        d="M572.33 166.92L573.55 167.15V166.12L572.33 165.84V166.92Z"
        fill="#CECECE"
      />
      <path d="M502.29 233.31H500.65V234.68H502.29V233.31Z" fill="#CECECE" />
      <path d="M499.08 231.29H497.44V232.66H499.08V231.29Z" fill="#CECECE" />
      <path d="M499.08 233.31H497.44V234.68H499.08V233.31Z" fill="#CECECE" />
      <path d="M492.67 231.29H491.02V232.66H492.67V231.29Z" fill="#CECECE" />
      <path d="M492.67 233.31H491.02V234.68H492.67V233.31Z" fill="#CECECE" />
      <path d="M489.46 231.29H487.81V232.66H489.46V231.29Z" fill="#CECECE" />
      <path d="M489.46 235.33H487.81V236.7H489.46V235.33Z" fill="#CECECE" />
      <path d="M486.25 231.29H484.6V232.66H486.25V231.29Z" fill="#CECECE" />
      <path d="M499.08 235.4H497.44V236.77H499.08V235.4Z" fill="#CECECE" />
      <path d="M499.08 239.43H497.44V240.8H499.08V239.43Z" fill="#CECECE" />
      <path d="M495.87 237.41H494.23V238.78H495.87V237.41Z" fill="#CECECE" />
      <path d="M495.87 239.43H494.23V240.8H495.87V239.43Z" fill="#CECECE" />
      <path d="M492.67 243.47H491.02V244.84H492.67V243.47Z" fill="#CECECE" />
      <path d="M489.46 237.41H487.81V238.78H489.46V237.41Z" fill="#CECECE" />
      <path d="M486.25 239.43H484.6V240.8H486.25V239.43Z" fill="#CECECE" />
      <path d="M502.29 241.71H500.65V243.08H502.29V241.71Z" fill="#CECECE" />
      <path d="M502.29 243.73H500.65V245.1H502.29V243.73Z" fill="#CECECE" />
      <g opacity="0.4">
        <path
          opacity="0.4"
          d="M638.6 164.91L634.87 165.19V164.58L638.6 164.3V164.91Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.6 166.23L634.87 166.49V165.88L638.6 165.6V166.23Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.6 167.55L634.88 167.8V167.17L638.6 166.9V167.55Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.6 168.86L634.88 169.1V168.47L638.6 168.21V168.86Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.6 170.18L634.88 170.41V169.76L638.6 169.51V170.18Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.59 171.49L634.88 171.71V171.05L638.59 170.82V171.49Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.59 172.81L634.88 173.02V172.35L638.59 172.12V172.81Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.59 174.12L634.89 174.32V173.64L638.59 173.42V174.12Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.59 175.44L634.89 175.63V174.93L638.59 174.73V175.44Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.59 176.75L634.89 176.93V176.23L638.59 176.03V176.75Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.59 178.07L634.89 178.24V177.52L638.59 177.34V178.07Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.59 179.38L634.89 179.55V178.81L638.59 178.64V179.38Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.59 182.02L634.9 182.16V181.4L638.59 181.25V182.02Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.59 183.33L634.9 183.46V182.69L638.59 182.55V183.33Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.59 184.65L634.9 184.77V183.99L638.59 183.86V184.65Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.59 187.28L634.91 187.38V186.57L638.59 186.47V187.28Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.59 191.22L634.92 191.29V190.45L638.59 190.38V191.22Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.59 195.17L634.92 195.21V194.33L638.59 194.29V195.17Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.58 199.9L634.93 199.91V199L638.58 198.99V199.9Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.58 196.5L634.93 196.51V195.6L638.58 195.59V196.5Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.12 164.4L646.85 164.67V164.07L643.12 163.78V164.4Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.12 165.71L646.85 165.97V165.36L643.12 165.08V165.71Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.12 167.03L646.84 167.28V166.65L643.12 166.39V167.03Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.12 168.34L646.84 168.58V167.95L643.12 167.69V168.34Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.12 169.66L646.84 169.89V169.24L643.12 168.99V169.66Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.13 170.97L646.84 171.19V170.53L643.13 170.3V170.97Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.13 172.29L646.84 172.5V171.83L643.13 171.6V172.29Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.13 173.6L646.84 173.81V173.12L643.13 172.91V173.6Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.13 174.92L646.83 175.11V174.41L643.13 174.21V174.92Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.13 176.24L646.83 176.42V175.71L643.13 175.52V176.24Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.13 177.55L646.83 177.72V177L643.13 176.82V177.55Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.13 178.87L646.83 179.03V178.29L643.13 178.12V178.87Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.13 180.18L646.83 180.33V179.59L643.13 179.43V180.18Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.13 181.5L646.82 181.64V180.88L643.13 180.73V181.5Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.13 182.81L646.82 182.94V182.18L643.13 182.04V182.81Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.13 184.13L646.82 184.25V183.47L643.13 183.34V184.13Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.13 186.76L646.81 186.86V186.06L643.13 185.95V186.76Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.13 190.71L646.81 190.78V189.94L643.13 189.86V190.71Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.13 194.65L646.8 194.69V193.82L643.13 193.77V194.65Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M643.14 198.6L646.79 198.61V197.7L643.14 197.69V198.6Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.85 164.52L639.12 164.79V164.19L642.85 163.9V164.52Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.85 165.85L639.12 166.11V165.49L642.85 165.22V165.85Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.85 167.18L639.13 167.43V166.8L642.85 166.53V167.18Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.85 169.84L639.13 170.07V169.42L642.85 169.17V169.84Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.85 172.5L639.13 172.71V172.03L642.85 171.81V172.5Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.85 173.83L639.14 174.03V173.34L642.85 173.13V173.83Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.85 175.16L639.14 175.35V174.65L642.85 174.45V175.16Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.84 176.49L639.14 176.67V175.96L642.84 175.77V176.49Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.84 177.82L639.14 177.99V177.27L642.84 177.09V177.82Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.84 180.48L639.14 180.63V179.88L642.84 179.72V180.48Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.84 181.81L639.14 181.95V181.19L642.84 181.04V181.81Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.84 183.14L639.15 183.27V182.5L642.84 182.36V183.14Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.84 184.47L639.15 184.59V183.81L642.84 183.68V184.47Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.84 185.8L639.15 185.91V185.12L642.84 185V185.8Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.84 187.13L639.15 187.23V186.43L642.84 186.32V187.13Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.83 189.79L639.16 189.87V189.04L642.83 188.96V189.79Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.83 192.45L639.16 192.51V191.66L642.83 191.59V192.45Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.83 193.78L639.16 193.83V192.97L642.83 192.91V193.78Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.83 196.44L639.16 196.47V195.58L642.83 195.55V196.44Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M646.82 199.3H643.14V200.14H646.82V199.3Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M642.84 200.63H639.16V201.47H642.84V200.63Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.6 202.02H634.92V202.86H638.6V202.02Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.6 200.55H634.92V201.39H638.6V200.55Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.6 204.82H634.92V205.66H638.6V204.82Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.6 207.07H634.92V207.91H638.6V207.07Z"
          fill="#CECECE"
        />
        <path
          opacity="0.4"
          d="M638.6 211.14H634.92V211.98H638.6V211.14Z"
          fill="#CECECE"
        />
      </g>
      <path
        d="M714.82 196.42L711.1 196.69V196.09L714.82 195.8V196.42Z"
        fill="#CECECE"
      />
      <path
        d="M714.82 197.73L711.1 197.99V197.38L714.82 197.1V197.73Z"
        fill="#CECECE"
      />
      <path
        d="M714.82 199.05L711.1 199.3V198.67L714.82 198.41V199.05Z"
        fill="#CECECE"
      />
      <path
        d="M714.82 200.36L711.1 200.6V199.97L714.82 199.71V200.36Z"
        fill="#CECECE"
      />
      <path
        d="M714.82 201.68L711.1 201.91V201.26L714.82 201.01V201.68Z"
        fill="#CECECE"
      />
      <path
        d="M714.82 202.99L711.11 203.21V202.55L714.82 202.32V202.99Z"
        fill="#CECECE"
      />
      <path
        d="M714.82 204.31L711.11 204.52V203.85L714.82 203.62V204.31Z"
        fill="#CECECE"
      />
      <path
        d="M714.82 205.62L711.11 205.83V205.14L714.82 204.93V205.62Z"
        fill="#CECECE"
      />
      <path
        d="M714.82 206.94L711.11 207.13V206.43L714.82 206.23V206.94Z"
        fill="#CECECE"
      />
      <path
        d="M714.82 208.26L711.11 208.44V207.73L714.82 207.53V208.26Z"
        fill="#CECECE"
      />
      <path
        d="M714.82 209.57L711.12 209.74V209.02L714.82 208.84V209.57Z"
        fill="#CECECE"
      />
      <path
        d="M714.82 210.89L711.12 211.05V210.31L714.82 210.14V210.89Z"
        fill="#CECECE"
      />
      <path
        d="M714.82 213.52L711.12 213.66V212.9L714.82 212.75V213.52Z"
        fill="#CECECE"
      />
      <path
        d="M714.82 214.83L711.13 214.96V214.19L714.82 214.06V214.83Z"
        fill="#CECECE"
      />
      <path
        d="M714.81 216.15L711.13 216.27V215.49L714.81 215.36V216.15Z"
        fill="#CECECE"
      />
      <path
        d="M714.81 218.78L711.13 218.88V218.08L714.81 217.97V218.78Z"
        fill="#CECECE"
      />
      <path
        d="M714.81 222.73L711.14 222.8V221.96L714.81 221.88V222.73Z"
        fill="#CECECE"
      />
      <path
        d="M714.81 226.67L711.15 226.71V225.84L714.81 225.79V226.67Z"
        fill="#CECECE"
      />
      <path
        d="M714.81 231.4L711.15 231.41V230.5L714.81 230.49V231.4Z"
        fill="#CECECE"
      />
      <path
        d="M714.81 228L711.15 228.01V227.1L714.81 227.09V228Z"
        fill="#CECECE"
      />
      <path
        d="M719.35 195.9L723.07 196.17V195.57L719.35 195.28V195.9Z"
        fill="#CECECE"
      />
      <path
        d="M719.35 197.21L723.07 197.47V196.86L719.35 196.58V197.21Z"
        fill="#CECECE"
      />
      <path
        d="M719.35 198.53L723.07 198.78V198.16L719.35 197.89V198.53Z"
        fill="#CECECE"
      />
      <path
        d="M719.35 199.84L723.07 200.09V199.45L719.35 199.19V199.84Z"
        fill="#CECECE"
      />
      <path
        d="M719.35 201.16L723.07 201.39V200.74L719.35 200.5V201.16Z"
        fill="#CECECE"
      />
      <path
        d="M719.35 202.48L723.06 202.7V202.04L719.35 201.8V202.48Z"
        fill="#CECECE"
      />
      <path
        d="M719.35 203.79L723.06 204V203.33L719.35 203.1V203.79Z"
        fill="#CECECE"
      />
      <path
        d="M719.35 205.11L723.06 205.31V204.62L719.35 204.41V205.11Z"
        fill="#CECECE"
      />
      <path
        d="M719.35 206.42L723.06 206.61V205.92L719.35 205.71V206.42Z"
        fill="#CECECE"
      />
      <path
        d="M719.35 207.74L723.06 207.92V207.21L719.35 207.02V207.74Z"
        fill="#CECECE"
      />
      <path
        d="M719.35 209.05L723.05 209.22V208.5L719.35 208.32V209.05Z"
        fill="#CECECE"
      />
      <path
        d="M719.35 210.37L723.05 210.53V209.8L719.35 209.62V210.37Z"
        fill="#CECECE"
      />
      <path
        d="M719.35 211.68L723.05 211.83V211.09L719.35 210.93V211.68Z"
        fill="#CECECE"
      />
      <path
        d="M719.35 213L723.05 213.14V212.38L719.35 212.23V213Z"
        fill="#CECECE"
      />
      <path
        d="M719.35 214.31L723.04 214.45V213.68L719.35 213.54V214.31Z"
        fill="#CECECE"
      />
      <path
        d="M719.36 215.63L723.04 215.75V214.97L719.36 214.84V215.63Z"
        fill="#CECECE"
      />
      <path
        d="M719.36 218.26L723.04 218.36V217.56L719.36 217.45V218.26Z"
        fill="#CECECE"
      />
      <path
        d="M719.36 222.21L723.03 222.28V221.44L719.36 221.36V222.21Z"
        fill="#CECECE"
      />
      <path
        d="M719.36 226.15L723.02 226.19V225.32L719.36 225.28V226.15Z"
        fill="#CECECE"
      />
      <path
        d="M719.36 230.1L723.02 230.11V229.2L719.36 229.19V230.1Z"
        fill="#CECECE"
      />
      <path
        d="M719.08 196.02L715.35 196.29V195.69L719.08 195.4V196.02Z"
        fill="#CECECE"
      />
      <path
        d="M719.08 197.35L715.35 197.61V196.99L719.08 196.72V197.35Z"
        fill="#CECECE"
      />
      <path
        d="M719.07 198.68L715.35 198.93V198.3L719.07 198.04V198.68Z"
        fill="#CECECE"
      />
      <path
        d="M719.07 201.34L715.36 201.57V200.92L719.07 200.67V201.34Z"
        fill="#CECECE"
      />
      <path
        d="M719.07 204L715.36 204.21V203.54L719.07 203.31V204Z"
        fill="#CECECE"
      />
      <path
        d="M719.07 205.33L715.36 205.53V204.84L719.07 204.63V205.33Z"
        fill="#CECECE"
      />
      <path
        d="M719.07 206.66L715.36 206.85V206.15L719.07 205.95V206.66Z"
        fill="#CECECE"
      />
      <path
        d="M719.07 207.99L715.36 208.17V207.46L719.07 207.27V207.99Z"
        fill="#CECECE"
      />
      <path
        d="M719.06 209.32L715.36 209.49V208.77L719.06 208.59V209.32Z"
        fill="#CECECE"
      />
      <path
        d="M719.06 211.98L715.37 212.13V211.39L719.06 211.23V211.98Z"
        fill="#CECECE"
      />
      <path
        d="M719.06 213.31L715.37 213.45V212.69L719.06 212.54V213.31Z"
        fill="#CECECE"
      />
      <path
        d="M719.06 214.64L715.37 214.77V214L719.06 213.86V214.64Z"
        fill="#CECECE"
      />
      <path
        d="M719.06 215.97L715.37 216.09V215.31L719.06 215.18V215.97Z"
        fill="#CECECE"
      />
      <path
        d="M719.06 217.3L715.37 217.41V216.62L719.06 216.5V217.3Z"
        fill="#CECECE"
      />
      <path
        d="M719.06 218.63L715.38 218.73V217.93L719.06 217.82V218.63Z"
        fill="#CECECE"
      />
      <path
        d="M719.06 221.29L715.38 221.37V220.54L719.06 220.46V221.29Z"
        fill="#CECECE"
      />
      <path
        d="M719.06 223.95L715.38 224.01V223.16L719.06 223.1V223.95Z"
        fill="#CECECE"
      />
      <path
        d="M719.05 225.28L715.38 225.33V224.47L719.05 224.42V225.28Z"
        fill="#CECECE"
      />
      <path
        d="M719.05 227.94L715.39 227.97V227.09L719.05 227.05V227.94Z"
        fill="#CECECE"
      />
      <path d="M723.04 230.8H719.36V231.64H723.04V230.8Z" fill="#CECECE" />
      <path d="M719.06 232.13H715.38V232.97H719.06V232.13Z" fill="#CECECE" />
      <path d="M714.82 233.52H711.14V234.36H714.82V233.52Z" fill="#CECECE" />
      <path d="M714.82 232.05H711.14V232.89H714.82V232.05Z" fill="#CECECE" />
      <path d="M714.82 236.32H711.14V237.16H714.82V236.32Z" fill="#CECECE" />
      <path d="M714.82 238.57H711.14V239.41H714.82V238.57Z" fill="#CECECE" />
      <path d="M714.82 242.64H711.14V243.48H714.82V242.64Z" fill="#CECECE" />
      <path d="M449.51 217.18H448.83V218.39H449.51V217.18Z" fill="#CECECE" />
      <path d="M450.6 218.97H449.92V220.18H450.6V218.97Z" fill="#CECECE" />
      <path d="M449.51 222.54H448.83V223.75H449.51V222.54Z" fill="#CECECE" />
      <path d="M602 207.86H600.74V224.81H602V207.86Z" fill="#CECECE" />
      <path
        d="M595.98 165.79L571.27 168.2V169.24L595.98 166.88V165.79Z"
        fill="#CECECE"
      />
      <path
        d="M571.27 170.74V171.77L584.09 170.45V169.42L571.27 170.74Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M673.44 160.25H672.72V177.19H673.44V160.25Z"
        fill="#CECECE"
      />
      <path
        opacity="0.7"
        d="M670.5 160.25H669.78V177.19H670.5V160.25Z"
        fill="#CECECE"
      />
      <path
        d="M704.86 179.3L708.59 179.57V178.97L704.86 178.68V179.3Z"
        fill="#CECECE"
      />
      <path
        d="M704.86 180.62L708.59 180.88V180.26L704.86 179.99V180.62Z"
        fill="#CECECE"
      />
      <path
        d="M704.86 181.93L708.58 182.18V181.56L704.86 181.29V181.93Z"
        fill="#CECECE"
      />
      <path
        d="M704.86 183.25L708.58 183.49V182.85L704.86 182.59V183.25Z"
        fill="#CECECE"
      />
      <path
        d="M704.86 184.56L708.58 184.79V184.14L704.86 183.9V184.56Z"
        fill="#CECECE"
      />
      <path
        d="M704.86 185.88L708.57 186.1V185.44L704.86 185.2V185.88Z"
        fill="#CECECE"
      />
      <path
        d="M704.86 187.19L708.57 187.4V186.73L704.86 186.51V187.19Z"
        fill="#CECECE"
      />
      <path
        d="M704.86 188.51L708.57 188.71V188.02L704.86 187.81V188.51Z"
        fill="#CECECE"
      />
      <path
        d="M704.86 189.82L708.57 190.01V189.32L704.86 189.11V189.82Z"
        fill="#CECECE"
      />
      <path
        d="M704.86 191.14L708.57 191.32V190.61L704.86 190.42V191.14Z"
        fill="#CECECE"
      />
      <path
        d="M704.86 192.45L708.57 192.63V191.91L704.86 191.72V192.45Z"
        fill="#CECECE"
      />
      <path
        d="M704.86 193.77L708.56 193.93V193.2L704.86 193.03V193.77Z"
        fill="#CECECE"
      />
      <path
        d="M704.86 195.09L708.56 195.24V194.49L704.86 194.33V195.09Z"
        fill="#CECECE"
      />
      <path
        d="M704.86 196.4L708.56 196.54V195.79L704.86 195.64V196.4Z"
        fill="#CECECE"
      />
      <path
        d="M704.86 197.72L708.56 197.85V197.08L704.86 196.94V197.72Z"
        fill="#CECECE"
      />
      <path
        d="M704.87 199.03L708.55 199.15V198.37L704.87 198.24V199.03Z"
        fill="#CECECE"
      />
      <path
        d="M704.87 201.66L708.55 201.76V200.96L704.87 200.85V201.66Z"
        fill="#CECECE"
      />
      <path
        d="M704.87 205.61L708.54 205.68V204.84L704.87 204.76V205.61Z"
        fill="#CECECE"
      />
      <path
        d="M704.87 209.56L708.53 209.6V208.72L704.87 208.68V209.56Z"
        fill="#CECECE"
      />
      <path
        d="M704.87 213.5L708.53 213.51V212.6L704.87 212.59V213.5Z"
        fill="#CECECE"
      />
      <path
        d="M704.59 179.42L700.86 179.69V179.09L704.59 178.8V179.42Z"
        fill="#CECECE"
      />
      <path
        d="M704.59 180.75L700.86 181.01V180.4L704.59 180.12V180.75Z"
        fill="#CECECE"
      />
      <path
        d="M704.58 182.08L700.86 182.33V181.71L704.58 181.44V182.08Z"
        fill="#CECECE"
      />
      <path
        d="M704.58 184.74L700.87 184.97V184.32L704.58 184.08V184.74Z"
        fill="#CECECE"
      />
      <path
        d="M704.58 187.4L700.87 187.61V186.94L704.58 186.71V187.4Z"
        fill="#CECECE"
      />
      <path
        d="M704.58 188.73L700.87 188.93V188.25L704.58 188.03V188.73Z"
        fill="#CECECE"
      />
      <path
        d="M704.58 190.06L700.87 190.25V189.55L704.58 189.35V190.06Z"
        fill="#CECECE"
      />
      <path
        d="M704.58 191.39L700.87 191.57V190.86L704.58 190.67V191.39Z"
        fill="#CECECE"
      />
      <path
        d="M704.58 192.72L700.87 192.89V192.17L704.58 191.99V192.72Z"
        fill="#CECECE"
      />
      <path
        d="M704.58 195.38L700.88 195.53V194.79L704.58 194.63V195.38Z"
        fill="#CECECE"
      />
      <path
        d="M704.57 196.71L700.88 196.85V196.1L704.57 195.95V196.71Z"
        fill="#CECECE"
      />
      <path
        d="M704.57 198.04L700.88 198.17V197.4L704.57 197.27V198.04Z"
        fill="#CECECE"
      />
      <path
        d="M704.57 199.37L700.88 199.49V198.71L704.57 198.58V199.37Z"
        fill="#CECECE"
      />
      <path
        d="M704.57 200.7L700.89 200.81V200.02L704.57 199.9V200.7Z"
        fill="#CECECE"
      />
      <path
        d="M704.57 202.03L700.89 202.13V201.33L704.57 201.22V202.03Z"
        fill="#CECECE"
      />
      <path
        d="M704.57 204.69L700.89 204.77V203.95L704.57 203.86V204.69Z"
        fill="#CECECE"
      />
      <path
        d="M704.57 207.35L700.9 207.41V206.56L704.57 206.5V207.35Z"
        fill="#CECECE"
      />
      <path
        d="M704.57 208.68L700.9 208.73V207.87L704.57 207.82V208.68Z"
        fill="#CECECE"
      />
      <path
        d="M704.57 211.34L700.9 211.37V210.49L704.57 210.45V211.34Z"
        fill="#CECECE"
      />
      <path d="M708.55 214.2H704.87V215.04H708.55V214.2Z" fill="#CECECE" />
      <path d="M704.58 215.53H700.9V216.37H704.58V215.53Z" fill="#CECECE" />
      <path d="M704.58 218.25H700.9V219.09H704.58V218.25Z" fill="#CECECE" />
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M769.87 189.36L771.82 189.63V189.03L769.87 188.74V189.36Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.87 190.68L771.82 190.94V190.32L769.87 190.05V190.68Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.87 191.99L771.82 192.24V191.62L769.87 191.35V191.99Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.87 193.31L771.81 193.55V192.91L769.87 192.65V193.31Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.87 194.62L771.81 194.85V194.2L769.87 193.96V194.62Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.87 195.94L771.81 196.16V195.5L769.87 195.26V195.94Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.87 197.25L771.81 197.46V196.79L769.87 196.57V197.25Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.87 198.57L771.81 198.77V198.08L769.87 197.87V198.57Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.87 199.88L771.81 200.07V199.38L769.87 199.17V199.88Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.87 201.2L771.81 201.38V200.67L769.87 200.48V201.2Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.87 202.51L771.81 202.68V201.96L769.87 201.78V202.51Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.87 203.83L771.81 203.99V203.26L769.87 203.09V203.83Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.87 205.15L771.81 205.3V204.55L769.87 204.39V205.15Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.87 206.46L771.8 206.6V205.85L769.87 205.7V206.46Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.87 207.78L771.8 207.91V207.14L769.87 207V207.78Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.88 209.09L771.8 209.21V208.43L769.88 208.3V209.09Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.88 211.72L771.8 211.82V211.02L769.88 210.91V211.72Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.88 215.67L771.8 215.74V214.9L769.88 214.82V215.67Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.88 219.62L771.79 219.66V218.78L769.88 218.74V219.62Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.88 223.56L771.79 223.57V222.66L769.88 222.65V223.56Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.34 189.48L765.93 189.75V189.15L769.34 188.86V189.48Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.34 190.81L765.93 191.07V190.46L769.34 190.18V190.81Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.34 192.14L765.94 192.39V191.76L769.34 191.5V192.14Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.33 194.8L765.94 195.03V194.38L769.33 194.14V194.8Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.33 197.46L765.94 197.67V197L769.33 196.77V197.46Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.33 198.79L765.95 198.99V198.31L769.33 198.09V198.79Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.33 200.12L765.95 200.31V199.61L769.33 199.41V200.12Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.33 201.45L765.95 201.63V200.92L769.33 200.73V201.45Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.33 202.78L765.95 202.95V202.23L769.33 202.05V202.78Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.33 205.44L765.95 205.59V204.85L769.33 204.69V205.44Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.33 206.77L765.95 206.91V206.16L769.33 206.01V206.77Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.33 208.1L765.96 208.23V207.46L769.33 207.33V208.1Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.32 209.43L765.96 209.55V208.77L769.32 208.64V209.43Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.32 210.76L765.96 210.87V210.08L769.32 209.96V210.76Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.32 212.09L765.96 212.19V211.39L769.32 211.28V212.09Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.32 214.75L765.97 214.83V214.01L769.32 213.92V214.75Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.32 217.41L765.97 217.47V216.62L769.32 216.56V217.41Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.32 218.74L765.97 218.79V217.93L769.32 217.88V218.74Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.32 221.4L765.97 221.43V220.55L769.32 220.51V221.4Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M771.8 224.26H769.88V225.1H771.8V224.26Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.33 225.59H765.97V226.43H769.33V225.59Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M769.33 228.31H765.97V229.15H769.33V228.31Z"
          fill="#CECECE"
        />
      </g>
      <g opacity="0.5">
        <path
          opacity="0.5"
          d="M772.45 189.8L774.4 190.08V189.48L772.45 189.19V189.8Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 191.12L774.4 191.38V190.77L772.45 190.49V191.12Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 192.44L774.39 192.69V192.06L772.45 191.79V192.44Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 193.75L774.39 193.99V193.36L772.45 193.1V193.75Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 195.07L774.39 195.3V194.65L772.45 194.4V195.07Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 196.38L774.39 196.6V195.94L772.45 195.71V196.38Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 197.7L774.39 197.91V197.24L772.45 197.01V197.7Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 199.01L774.39 199.21V198.53L772.45 198.31V199.01Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 200.33L774.39 200.52V199.82L772.45 199.62V200.33Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 201.64L774.39 201.82V201.12L772.45 200.92V201.64Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 202.96L774.39 203.13V202.41L772.45 202.23V202.96Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 204.28L774.38 204.44V203.7L772.45 203.53V204.28Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 205.59L774.38 205.74V205L772.45 204.84V205.59Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 206.91L774.38 207.05V206.29L772.45 206.14V206.91Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 208.22L774.38 208.35V207.58L772.45 207.44V208.22Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 209.54L774.38 209.66V208.88L772.45 208.75V209.54Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 212.17L774.38 212.27V211.46L772.45 211.36V212.17Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 216.11L774.37 216.18V215.34L772.45 215.27V216.11Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.45 220.06L774.37 220.1V219.22L772.45 219.18V220.06Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M772.46 224.01L774.37 224.02V223.1L772.46 223.09V224.01Z"
          fill="#CECECE"
        />
        <path
          opacity="0.5"
          d="M774.38 224.71H772.46V225.55H774.38V224.71Z"
          fill="#CECECE"
        />
      </g>
      <path d="M648.88 206.42H646.81V208.15H648.88V206.42Z" fill="#CECECE" />
      <path d="M648.88 208.96H646.81V210.69H648.88V208.96Z" fill="#CECECE" />
      <path d="M648.88 211.51H646.81V213.24H648.88V211.51Z" fill="#CECECE" />
      <path d="M652.24 206.42H650.17V208.15H652.24V206.42Z" fill="#CECECE" />
      <path d="M655.6 206.42H653.53V208.15H655.6V206.42Z" fill="#CECECE" />
      <path d="M655.6 208.96H653.53V210.69H655.6V208.96Z" fill="#CECECE" />
      <path d="M655.6 211.51H653.53V213.24H655.6V211.51Z" fill="#CECECE" />
      <path d="M648.88 214.14H646.81V215.87H648.88V214.14Z" fill="#CECECE" />
      <path d="M648.88 219.22H646.81V220.95H648.88V219.22Z" fill="#CECECE" />
      <path d="M652.24 211.59H650.17V213.32H652.24V211.59Z" fill="#CECECE" />
      <path d="M652.24 216.68H650.17V218.41H652.24V216.68Z" fill="#CECECE" />
      <path d="M652.24 219.22H650.17V220.95H652.24V219.22Z" fill="#CECECE" />
      <path d="M652.24 221.77H650.17V223.5H652.24V221.77Z" fill="#CECECE" />
      <path d="M652.24 224.31H650.17V226.04H652.24V224.31Z" fill="#CECECE" />
      <path d="M642.33 206.42H640.26V208.15H642.33V206.42Z" fill="#CECECE" />
      <path d="M642.33 208.96H640.26V210.69H642.33V208.96Z" fill="#CECECE" />
      <path d="M642.33 211.51H640.26V213.24H642.33V211.51Z" fill="#CECECE" />
      <path d="M645.69 206.42H643.62V208.15H645.69V206.42Z" fill="#CECECE" />
      <path d="M642.33 214.14H640.26V215.87H642.33V214.14Z" fill="#CECECE" />
      <path d="M642.33 219.22H640.26V220.95H642.33V219.22Z" fill="#CECECE" />
      <path d="M645.69 211.59H643.62V213.32H645.69V211.59Z" fill="#CECECE" />
      <path d="M645.69 216.68H643.62V218.41H645.69V216.68Z" fill="#CECECE" />
      <path d="M645.69 219.22H643.62V220.95H645.69V219.22Z" fill="#CECECE" />
      <path d="M645.69 221.77H643.62V223.5H645.69V221.77Z" fill="#CECECE" />
      <path d="M645.69 224.31H643.62V226.04H645.69V224.31Z" fill="#CECECE" />
      <path d="M655.6 214.14H653.53V215.87H655.6V214.14Z" fill="#CECECE" />
      <path d="M655.6 221.77H653.53V223.5H655.6V221.77Z" fill="#CECECE" />
      <path d="M655.6 224.31H653.53V226.04H655.6V224.31Z" fill="#CECECE" />
      <path d="M655.6 204.01H640.26V205H655.6V204.01Z" fill="#CECECE" />
      <path d="M655.6 201.35H643.71V202.9H655.6V201.35Z" fill="#CECECE" />
      <path d="M639.1 214.14H637.03V215.87H639.1V214.14Z" fill="#CECECE" />
      <path d="M639.1 219.32H637.03V221.05H639.1V219.32Z" fill="#CECECE" />
      <path d="M639.1 224.4H637.03V226.13H639.1V224.4Z" fill="#CECECE" />
      <path d="M642.33 229.42H640.26V231.15H642.33V229.42Z" fill="#CECECE" />
      <path d="M642.33 237.14H640.26V238.87H642.33V237.14Z" fill="#CECECE" />
      <path d="M645.69 229.51H643.62V231.24H645.69V229.51Z" fill="#CECECE" />
      <path d="M645.69 234.59H643.62V236.32H645.69V234.59Z" fill="#CECECE" />
      <path d="M639.1 242.32H637.03V244.05H639.1V242.32Z" fill="#CECECE" />
      <path d="M639.1 226.95H637.03V228.68H639.1V226.95Z" fill="#CECECE" />
      <path d="M639.1 229.49H637.03V231.22H639.1V229.49Z" fill="#CECECE" />
      <path d="M639.1 234.59H637.03V236.32H639.1V234.59Z" fill="#CECECE" />
      <path d="M635.98 214.14H634.94V215.87H635.98V214.14Z" fill="#CECECE" />
      <path d="M635.98 219.32H634.94V221.05H635.98V219.32Z" fill="#CECECE" />
      <path d="M635.98 224.4H634.94V226.13H635.98V224.4Z" fill="#CECECE" />
      <path d="M635.98 226.95H634.94V228.68H635.98V226.95Z" fill="#CECECE" />
      <path d="M635.98 229.49H634.94V231.22H635.98V229.49Z" fill="#CECECE" />
      <path d="M635.98 232.03H634.94V233.76H635.98V232.03Z" fill="#CECECE" />
      <path
        d="M695.15 179.3L698.88 179.57V178.97L695.15 178.68V179.3Z"
        fill="#CECECE"
      />
      <path
        d="M695.15 180.62L698.88 180.88V180.26L695.15 179.99V180.62Z"
        fill="#CECECE"
      />
      <path
        d="M695.15 181.93L698.87 182.18V181.56L695.15 181.29V181.93Z"
        fill="#CECECE"
      />
      <path
        d="M695.15 183.25L698.87 183.49V182.85L695.15 182.59V183.25Z"
        fill="#CECECE"
      />
      <path
        d="M695.15 184.56L698.87 184.79V184.14L695.15 183.9V184.56Z"
        fill="#CECECE"
      />
      <path
        d="M695.15 185.88L698.86 186.1V185.44L695.15 185.2V185.88Z"
        fill="#CECECE"
      />
      <path
        d="M695.15 187.19L698.86 187.4V186.73L695.15 186.51V187.19Z"
        fill="#CECECE"
      />
      <path
        d="M695.15 188.51L698.86 188.71V188.02L695.15 187.81V188.51Z"
        fill="#CECECE"
      />
      <path
        d="M695.15 189.82L698.86 190.01V189.32L695.15 189.11V189.82Z"
        fill="#CECECE"
      />
      <path
        d="M695.15 191.14L698.86 191.32V190.61L695.15 190.42V191.14Z"
        fill="#CECECE"
      />
      <path
        d="M695.15 192.45L698.86 192.63V191.91L695.15 191.72V192.45Z"
        fill="#CECECE"
      />
      <path
        d="M695.16 193.77L698.85 193.93V193.2L695.16 193.03V193.77Z"
        fill="#CECECE"
      />
      <path
        d="M695.16 195.09L698.85 195.24V194.49L695.16 194.33V195.09Z"
        fill="#CECECE"
      />
      <path
        d="M695.16 196.4L698.85 196.54V195.79L695.16 195.64V196.4Z"
        fill="#CECECE"
      />
      <path
        d="M695.16 197.72L698.85 197.85V197.08L695.16 196.94V197.72Z"
        fill="#CECECE"
      />
      <path
        d="M695.16 199.03L698.84 199.15V198.37L695.16 198.24V199.03Z"
        fill="#CECECE"
      />
      <path
        d="M695.16 201.66L698.84 201.76V200.96L695.16 200.85V201.66Z"
        fill="#CECECE"
      />
      <path
        d="M695.16 205.61L698.83 205.68V204.84L695.16 204.76V205.61Z"
        fill="#CECECE"
      />
      <path
        d="M695.16 209.56L698.83 209.6V208.72L695.16 208.68V209.56Z"
        fill="#CECECE"
      />
      <path
        d="M695.16 213.5L698.82 213.51V212.6L695.16 212.59V213.5Z"
        fill="#CECECE"
      />
      <path
        d="M694.88 179.42L691.15 179.69V179.09L694.88 178.8V179.42Z"
        fill="#CECECE"
      />
      <path
        d="M694.88 180.75L691.15 181.01V180.4L694.88 180.12V180.75Z"
        fill="#CECECE"
      />
      <path
        d="M694.88 182.08L691.15 182.33V181.71L694.88 181.44V182.08Z"
        fill="#CECECE"
      />
      <path
        d="M694.87 184.74L691.16 184.97V184.32L694.87 184.08V184.74Z"
        fill="#CECECE"
      />
      <path
        d="M694.87 187.4L691.16 187.61V186.94L694.87 186.71V187.4Z"
        fill="#CECECE"
      />
      <path
        d="M694.87 188.73L691.16 188.93V188.25L694.87 188.03V188.73Z"
        fill="#CECECE"
      />
      <path
        d="M694.87 190.06L691.16 190.25V189.55L694.87 189.35V190.06Z"
        fill="#CECECE"
      />
      <path
        d="M694.87 191.39L691.17 191.57V190.86L694.87 190.67V191.39Z"
        fill="#CECECE"
      />
      <path
        d="M694.87 192.72L691.17 192.89V192.17L694.87 191.99V192.72Z"
        fill="#CECECE"
      />
      <path
        d="M694.87 195.38L691.17 195.53V194.79L694.87 194.63V195.38Z"
        fill="#CECECE"
      />
      <path
        d="M694.87 196.71L691.17 196.85V196.1L694.87 195.95V196.71Z"
        fill="#CECECE"
      />
      <path
        d="M694.87 198.04L691.17 198.17V197.4L694.87 197.27V198.04Z"
        fill="#CECECE"
      />
      <path
        d="M694.86 199.37L691.17 199.49V198.71L694.86 198.58V199.37Z"
        fill="#CECECE"
      />
      <path
        d="M694.86 200.7L691.18 200.81V200.02L694.86 199.9V200.7Z"
        fill="#CECECE"
      />
      <path
        d="M694.86 202.03L691.18 202.13V201.33L694.86 201.22V202.03Z"
        fill="#CECECE"
      />
      <path
        d="M694.86 204.69L691.18 204.77V203.95L694.86 203.86V204.69Z"
        fill="#CECECE"
      />
      <path
        d="M694.86 207.35L691.19 207.41V206.56L694.86 206.5V207.35Z"
        fill="#CECECE"
      />
      <path
        d="M694.86 208.68L691.19 208.73V207.87L694.86 207.82V208.68Z"
        fill="#CECECE"
      />
      <path
        d="M694.86 211.34L691.19 211.37V210.49L694.86 210.45V211.34Z"
        fill="#CECECE"
      />
      <path d="M698.84 214.2H695.16V215.04H698.84V214.2Z" fill="#CECECE" />
      <path d="M694.87 215.53H691.19V216.37H694.87V215.53Z" fill="#CECECE" />
      <path d="M694.87 218.25H691.19V219.09H694.87V218.25Z" fill="#CECECE" />
      <path
        d="M695.16 223.42L698.83 223.46V222.58L695.16 222.54V223.42Z"
        fill="#CECECE"
      />
      <path
        d="M695.16 227.37H698.82V226.46L695.16 226.45V227.37Z"
        fill="#CECECE"
      />
      <path
        d="M694.86 221.22L691.19 221.28V220.43L694.86 220.36V221.22Z"
        fill="#CECECE"
      />
      <path
        d="M694.86 222.55L691.19 222.6V221.73L694.86 221.68V222.55Z"
        fill="#CECECE"
      />
      <path
        d="M694.86 225.21L691.19 225.24V224.35L694.86 224.32V225.21Z"
        fill="#CECECE"
      />
      <path d="M698.84 228.07H695.16V228.91H698.84V228.07Z" fill="#CECECE" />
      <path d="M694.87 229.39H691.19V230.23H694.87V229.39Z" fill="#CECECE" />
      <path d="M694.87 232.11H691.19V232.95H694.87V232.11Z" fill="#CECECE" />
      <path
        d="M690.9 220.93L694.56 220.97V220.09L690.9 220.05V220.93Z"
        fill="#CECECE"
      />
      <path
        d="M690.9 224.87L694.55 224.88V223.97L690.9 223.96V224.87Z"
        fill="#CECECE"
      />
      <path
        d="M690.59 218.73L686.92 218.79V217.93L690.59 217.87V218.73Z"
        fill="#CECECE"
      />
      <path
        d="M690.59 220.06L686.92 220.11V219.24L690.59 219.19V220.06Z"
        fill="#CECECE"
      />
      <path
        d="M690.59 222.72L686.93 222.75V221.86L690.59 221.83V222.72Z"
        fill="#CECECE"
      />
      <path d="M694.58 225.57H690.9V226.41H694.58V225.57Z" fill="#CECECE" />
      <path d="M690.6 226.9H686.92V227.74H690.6V226.9Z" fill="#CECECE" />
      <path d="M690.6 229.62H686.92V230.46H690.6V229.62Z" fill="#CECECE" />
      <path
        d="M686.61 179.68L690.34 179.95V179.35L686.61 179.06V179.68Z"
        fill="#CECECE"
      />
      <path
        d="M686.61 181L690.34 181.26V180.64L686.61 180.36V181Z"
        fill="#CECECE"
      />
      <path
        d="M686.61 182.31L690.33 182.56V181.94L686.61 181.67V182.31Z"
        fill="#CECECE"
      />
      <path
        d="M686.61 183.63L690.33 183.87V183.23L686.61 182.97V183.63Z"
        fill="#CECECE"
      />
      <path
        d="M686.61 184.94L690.33 185.17V184.52L686.61 184.28V184.94Z"
        fill="#CECECE"
      />
      <path
        d="M686.62 186.26L690.33 186.48V185.82L686.62 185.58V186.26Z"
        fill="#CECECE"
      />
      <path
        d="M686.62 187.57L690.33 187.78V187.11L686.62 186.89V187.57Z"
        fill="#CECECE"
      />
      <path
        d="M686.62 188.89L690.32 189.09V188.4L686.62 188.19V188.89Z"
        fill="#CECECE"
      />
      <path
        d="M686.62 190.2L690.32 190.39V189.7L686.62 189.49V190.2Z"
        fill="#CECECE"
      />
      <path
        d="M686.62 191.52L690.32 191.7V190.99L686.62 190.8V191.52Z"
        fill="#CECECE"
      />
      <path
        d="M686.62 192.83L690.32 193V192.28L686.62 192.1V192.83Z"
        fill="#CECECE"
      />
      <path
        d="M686.62 194.15L690.32 194.31V193.58L686.62 193.41V194.15Z"
        fill="#CECECE"
      />
      <path
        d="M686.62 195.46L690.31 195.62V194.87L686.62 194.71V195.46Z"
        fill="#CECECE"
      />
      <path
        d="M686.62 196.78L690.31 196.92V196.16L686.62 196.01V196.78Z"
        fill="#CECECE"
      />
      <path
        d="M686.62 198.1L690.31 198.23V197.46L686.62 197.32V198.1Z"
        fill="#CECECE"
      />
      <path
        d="M686.62 199.41L690.31 199.53V198.75L686.62 198.62V199.41Z"
        fill="#CECECE"
      />
      <path
        d="M686.62 202.04L690.3 202.14V201.34L686.62 201.23V202.04Z"
        fill="#CECECE"
      />
      <path
        d="M686.62 205.99L690.29 206.06V205.22L686.62 205.14V205.99Z"
        fill="#CECECE"
      />
      <path
        d="M686.62 209.93L690.29 209.98V209.1L686.62 209.06V209.93Z"
        fill="#CECECE"
      />
      <path
        d="M686.62 213.88L690.28 213.89V212.98L686.62 212.97V213.88Z"
        fill="#CECECE"
      />
      <path d="M690.3 214.58H686.62V215.42H690.3V214.58Z" fill="#CECECE" />
      <path d="M685.55 182.5H684.7V198.92H685.55V182.5Z" fill="#CECECE" />
      <path d="M686.97 208.07H686.23V232.33H686.97V208.07Z" fill="#CECECE" />
      <path d="M685.55 210.27H684.7V226.69H685.55V210.27Z" fill="#CECECE" />
      <path d="M710.15 196.17H708.88V213.43H710.15V196.17Z" fill="#CECECE" />
      <path d="M672.8 183.08H671.07V213.75H672.8V183.08Z" fill="#CECECE" />
      <path
        d="M570.28 144.24V183.98L571.42 183.94V144.41L570.28 144.24Z"
        fill="#CECECE"
      />
      <path d="M505.84 174.16H503.49V211.93H505.84V174.16Z" fill="#CECECE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M410.84 50.4199L416.46 318.04L431.41 317.66L426.08 54.2199L410.84 50.4199Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M410.84 50.4199L426.08 54.2199L426.18 59.2199L412.99 66.7499L416.46 318.04L410.84 50.4199Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M354.2 46.6899L359.82 314.31L374.76 313.93L369.43 50.4899L354.2 46.6899Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M354.2 46.6899L369.43 50.4899L369.53 55.4899L361.89 61.5199L366.82 316.03L361.89 313.92L354.2 46.6899Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M343.92 46.6899L349.54 314.31L364.48 313.93L359.15 50.4899L343.92 46.6899Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M343.92 46.6899L359.15 50.4899L359.25 55.4899L351.61 61.5199L356.54 316.03L351.61 313.92L343.92 46.6899Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M333.63 46.6899L339.25 314.31L354.2 313.93L348.87 50.4899L333.63 46.6899Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M333.63 46.6899L348.87 50.4899L348.97 55.4899L337.09 61.5199L346.26 316.03L341.33 313.92L333.63 46.6899Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M320.84 46.6899L326.46 314.31L341.41 313.93L336.08 50.4899L320.84 46.6899Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M320.84 46.6899L336.08 50.4899L336.18 55.4899L328.54 61.5199L333.47 316.03L328.54 313.92L320.84 46.6899Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M394.11 50.4199L399.73 318.04L414.67 317.66L409.34 54.2199L394.11 50.4199Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M394.11 50.4199L409.34 54.2199L409.44 59.2199L396.26 66.7499L401.09 317.65H400.43L394.11 50.4199Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M373.22 50.4199L378.84 318.04L393.79 317.66L388.46 54.2199L373.22 50.4199Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M373.22 50.4199L388.46 54.2199L388.56 59.2199L375.37 66.7499L382.58 317.65L378.84 318.04L373.22 50.4199Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M310.56 46.6899L316.18 314.31L331.12 313.93L325.79 50.4899L310.56 46.6899Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M310.56 46.6899L325.79 50.4899L325.9 55.4899L318.26 61.5199L323.19 316.03L318.26 313.92L310.56 46.6899Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M300.28 46.6899L305.9 314.31L320.84 313.93L315.51 50.4899L300.28 46.6899Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M300.28 46.6899L315.51 50.4899L315.61 55.4899L303.73 61.5199L312.9 316.03L307.97 313.92L300.28 46.6899Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M763 51.5898L757.38 318.04L742.43 317.66L747.76 55.3698L763 51.5898Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M763 51.5898L747.76 55.3698L747.66 60.3498L760.85 67.8498L757.38 318.04L763 51.5898Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M829.92 47.8799L824.3 314.33L809.36 313.95L814.69 51.6599L829.92 47.8799Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M829.92 47.8799L814.69 51.6599L814.59 56.6299L822.23 62.6399L817.3 316.03L822.23 313.94L829.92 47.8799Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M840.21 47.8799L834.59 314.33L819.64 313.95L824.97 51.6599L840.21 47.8799Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M840.21 47.8799L824.97 51.6599L824.87 56.6299L832.51 62.6399L827.58 316.03L832.51 313.94L840.21 47.8799Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M850.49 47.8799L844.87 314.33L829.92 313.95L835.25 51.6599L850.49 47.8799Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M850.49 47.8799L835.25 51.6599L835.15 56.6299L847.03 62.6399L837.86 316.03L842.79 313.94L850.49 47.8799Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M863.28 47.8799L857.66 314.33L842.72 313.95L848.04 51.6599L863.28 47.8799Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M863.28 47.8799L848.04 51.6599L847.94 56.6299L855.58 62.6399L850.65 316.03L855.58 313.94L863.28 47.8799Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M790.01 51.5898L784.39 318.04L769.45 317.66L774.78 55.3698L790.01 51.5898Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M790.01 51.5898L774.78 55.3698L774.68 60.3498L787.86 67.8498L783.03 317.65H783.69L790.01 51.5898Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M810.9 51.5898L805.28 318.04L790.33 317.66L795.66 55.3698L810.9 51.5898Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M810.9 51.5898L795.66 55.3698L795.56 60.3498L808.75 67.8498L801.54 317.65L805.28 318.04L810.9 51.5898Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M873.56 47.8799L867.94 314.33L853 313.95L858.33 51.6599L873.56 47.8799Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M873.56 47.8799L858.33 51.6599L858.23 56.6299L865.87 62.6399L860.94 316.03L865.87 313.94L873.56 47.8799Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M883.84 47.8799L878.22 314.33L863.28 313.95L868.61 51.6599L883.84 47.8799Z"
        fill="#C1C1C1"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M883.84 47.8799L868.61 51.6599L868.51 56.6299L880.39 62.6399L871.22 316.03L876.15 313.94L883.84 47.8799Z"
          fill="#C1C1C1"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1038.06 14.6901L1034.45 338.13L1010.18 338.5L1016.95 11.3301L1038.06 14.6901Z"
        fill="#EAEAEA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1016.95 11.3301C965.8 21.6401 927.89 31.2701 878.73 38.7601L874 314.59C874 314.59 963.23 325.95 1010.18 338.49L1016.95 11.3301Z"
        fill="#EAEAEA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1034.58 326.36L1034.54 330.29L1034.45 338.12L1010.18 338.49C946.84 323.57 870.92 314.2 870.92 314.2V307.99L874.13 306.84C922.79 310.76 1011.2 326.02 1011.2 326.02L1034.58 326.36Z"
        fill="#F4F4F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1038.06 14.7001L1037.96 24.7001L1037.9 30.1801L1016.95 26.9201C1016.95 26.9201 936.2 45.5001 878.53 49.7701L875.38 47.7801L874.53 38.1901C874.68 38.1701 874.84 38.1501 874.99 38.1201C875.13 38.1101 875.28 38.0901 875.43 38.0601C875.52 38.0501 875.62 38.0401 875.71 38.0201C877.79 37.7001 882.54 36.9901 889.12 35.9901C889.27 35.9701 889.44 35.9401 889.59 35.9101C919.94 31.2601 987.98 18.0901 1016.94 11.3601L1038.05 14.7201L1038.06 14.7001Z"
        fill="#F4F4F4"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1038.06 14.7001V24.7001H1037.96L1016.95 23.9901C938.11 38.4801 875.38 47.7701 875.38 47.7701L874.53 38.1801C874.68 38.1601 874.84 38.1401 874.99 38.1101C875.13 38.1001 875.28 38.0801 875.43 38.0501C875.52 38.0401 875.62 38.0301 875.71 38.0101C880.08 37.4001 884.57 36.7201 889.12 35.9801C889.27 35.9601 889.44 35.9301 889.59 35.9001C919.94 31.2501 987.98 18.0801 1016.94 11.3501L1038.05 14.7101L1038.06 14.7001Z"
          fill="#F4F4F4"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1034.56 328.86L1034.46 338.13L1010.19 338.5C946.85 323.58 870.93 314.21 870.93 314.21V308C931.61 316.81 1010.87 328.7 1010.87 328.7L1034.57 328.87L1034.56 328.86Z"
          fill="#F4F4F4"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M152.96 14.6901L156.5 336.63L180.4 338.18L173.74 11.3301L152.96 14.6901Z"
        fill="#EAEAEA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M173.74 11.3301C224.08 21.6301 261.38 31.2501 309.77 38.7301L314.43 314.29C314.43 314.29 226.62 325.63 180.41 338.17L173.75 11.3201L173.74 11.3301Z"
        fill="#EAEAEA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.38 326.06L156.42 329.99L156.49 336.64L180.39 338.18C242.73 323.28 317.44 313.91 317.44 313.91V307.71L314.28 306.56C266.39 310.48 179.38 325.73 179.38 325.73L156.37 326.06H156.38Z"
        fill="#F4F4F4"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.87">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M152.96 14.7001L153.06 24.6901L153.12 30.1601L173.74 26.9001C173.74 26.9001 253.21 45.4601 309.97 49.7201L313.07 47.7301L313.9 38.1501C313.75 38.1301 313.6 38.1101 313.44 38.0801C313.3 38.0701 313.16 38.0501 313 38.0201C312.91 38.0101 312.82 38.0001 312.73 37.9801C310.68 37.6701 306.01 36.9501 299.53 35.9501C299.38 35.9301 299.22 35.9001 299.06 35.8701C269.2 31.2201 202.23 18.0701 173.74 11.3401L152.96 14.7001Z"
          fill="#F4F4F4"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.87">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M152.96 14.7001V24.6901H153.06L173.74 23.9801C189.01 26.8301 203.67 29.4801 217.37 31.8901C273.24 41.7501 313.07 47.7301 313.07 47.7301L313.9 38.1501C313.75 38.1301 313.6 38.1101 313.44 38.0801C313.3 38.0701 313.16 38.0501 313 38.0201C312.91 38.0101 312.82 38.0001 312.73 37.9801C308.43 37.3701 304.01 36.6901 299.53 35.9501C299.38 35.9301 299.22 35.9001 299.06 35.8701C269.2 31.2201 202.23 18.0701 173.74 11.3401L152.96 14.7001Z"
          fill="#F4F4F4"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M156.41 329.24L156.49 336.63L180.39 338.17C242.73 323.27 317.44 313.9 317.44 313.9V307.7C257.72 316.5 179.72 328.38 179.72 328.38L156.4 329.24H156.41Z"
          fill="#F4F4F4"
        />
      </g>
      <path
        style={{ mixBlendMode: 'screen' }}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M310.64 90.4299L177.59 200.28L179.23 282.77L312.14 178.98L310.64 90.4299Z"
        fill="url(#paint7_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M312.14 184.75L179.57 297.33L180.15 325.58L213.2 320.27L314.42 267.61L312.14 184.75Z"
        fill="url(#paint8_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M310.56 85.6699L177.59 186.6L176.77 168.33L309.61 59.3799L310.56 85.6699Z"
        fill="url(#paint9_linear_2072_10275)"
      />
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          d="M1031.16 342.55L1003.49 340.68L1003.41 330.93L1001.73 328.09L1004.96 177.26L871.28 75.8399L871.91 52.2199L868.81 50.2299L868.52 46.9199C795.22 55.6699 705.14 61.8799 595.5 61.8799C479.05 61.8799 382.95 54.6599 307.02 44.9199L306.56 50.2299L303.46 52.2199L303.7 67.4699L170.26 170.83L173.63 328.09L171.95 330.93L171.87 340.68L136.47 343.08L136.36 342.74L81.1799 357.95C81.1799 357.95 278.04 392.8 592.03 392.8C822.44 392.8 960.7 377.49 1029.66 366.67C1030.12 358.63 1030.65 350.59 1031.15 342.55H1031.16Z"
          fill="#EFEFEF"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M220.06 214.95L204 239.83L192.29 239.91L186.53 324.34L192.29 326.47L191.91 335.74L218.05 340.44L241.15 339.28L234.96 298.41L236.41 276.69L228.33 268.98L229.34 226.6L220.06 214.95Z"
          fill="#F4F4F4"
        />
      </g>
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M217.2 338.49L216.04 367.97H254.7L253.57 338.49H217.2Z"
        fill="url(#paint10_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1007.97 338.18V368.55L870.92 345.37V313.9C870.92 313.9 927.17 319.58 1007.97 338.17V338.18Z"
        fill="url(#paint11_linear_2072_10275)"
      />
      <path
        d="M301.29 188.28L166.12 195.49L165.21 84.1599L300.37 92.9999L301.29 188.28Z"
        fill="white"
        stroke="#9B9B9B"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <g clipPath="url(#clip0_2072_10275)">
        <path
          opacity="0.21"
          d="M194.546 182.27C194.564 182.727 239.997 181.605 247.268 181.321C254.538 181.037 278.5 179.448 278.482 178.991C278.464 178.534 252.928 178.879 245.658 179.163C238.387 179.447 194.528 181.81 194.546 182.27Z"
          fill="#15738C"
        />
        <path
          d="M269.346 174.916L270.08 174.887L270.013 173.165L269.279 173.194L269.346 174.916Z"
          fill="#8B8E93"
        />
        <path
          d="M269.286 173.385L270.021 173.357L270.013 173.165L269.279 173.194L269.286 173.385Z"
          fill="#777A7F"
        />
        <path
          d="M266.108 177.537L266.694 177.514L266.663 176.724L266.078 176.747L266.108 177.537Z"
          fill="#595E65"
        />
        <path
          d="M272.952 177.299L273.537 177.277L273.503 176.386L272.917 176.409L272.952 177.299Z"
          fill="#595E65"
        />
        <path
          d="M270.122 175.792L270.182 176.371L273.235 176.922L273.508 176.377L270.122 175.792Z"
          fill="#595E65"
        />
        <path
          d="M269.41 175.873L269.401 176.455L266.404 177.257L266.086 176.741L269.41 175.873Z"
          fill="#595E65"
        />
        <path
          d="M269.208 177.047L270.332 177.003L270.249 174.877L269.125 174.921L269.208 177.047Z"
          fill="#535C69"
        />
        <path
          d="M269.449 177.832L270.133 177.805L270.097 176.891L269.413 176.918L269.449 177.832Z"
          fill="#595E65"
        />
        <path
          d="M270.265 173.191L269.056 173.238C268.849 173.246 268.677 173.084 268.669 172.875L268.661 172.683L270.616 172.607L270.623 172.799C270.631 173.008 270.472 173.183 270.265 173.191Z"
          fill="#535C69"
        />
        <path
          d="M270.312 173.189L269.971 173.202C269.778 173.21 269.615 173.057 269.607 172.862L269.599 172.647L270.613 172.607L270.622 172.849C270.629 173.029 270.489 173.182 270.312 173.189Z"
          fill="#608599"
        />
        <path
          opacity="0.59"
          d="M270.622 172.76C270.622 172.76 270.622 172.772 270.622 172.778L268.671 172.854C268.67 172.837 268.666 172.822 268.666 172.804L268.661 172.686L270.616 172.61L270.622 172.76Z"
          fill="#26374C"
        />
        <path
          d="M272.329 172.546L266.698 172.766C266.346 172.78 266.052 172.502 266.038 172.148C266.035 172.077 266.091 172.016 266.161 172.013L273.009 171.746C273.079 171.743 273.14 171.8 273.142 171.87C273.156 172.227 272.681 172.532 272.329 172.546Z"
          fill="#535C69"
        />
        <path
          d="M270.357 171.959L270.353 171.85L273.137 171.741L273.141 171.85C273.156 172.216 272.856 172.525 272.471 172.54L271.079 172.595C270.694 172.61 270.371 172.324 270.357 171.959Z"
          fill="#608599"
        />
        <path
          d="M269.82 178.535C270.084 178.525 270.29 178.3 270.279 178.033C270.269 177.766 270.046 177.558 269.783 177.568C269.519 177.578 269.313 177.803 269.324 178.07C269.334 178.337 269.556 178.545 269.82 178.535Z"
          fill="#25262A"
        />
        <path
          d="M269.507 178.063C269.514 178.228 269.65 178.356 269.813 178.349C269.976 178.343 270.102 178.205 270.096 178.04C270.089 177.875 269.953 177.748 269.79 177.754C269.627 177.76 269.501 177.898 269.507 178.063Z"
          fill="#535C69"
        />
        <path
          d="M266.381 178.236C266.645 178.225 266.85 178 266.84 177.733C266.829 177.466 266.607 177.258 266.343 177.268C266.079 177.279 265.874 177.504 265.884 177.771C265.895 178.038 266.117 178.246 266.381 178.236Z"
          fill="#25262A"
        />
        <path
          d="M266.373 178.05C266.536 178.043 266.662 177.905 266.656 177.74C266.65 177.576 266.513 177.448 266.35 177.454C266.188 177.46 266.061 177.599 266.068 177.763C266.074 177.928 266.211 178.056 266.373 178.05Z"
          fill="#535C69"
        />
        <path
          d="M273.272 178.016C273.535 178.006 273.741 177.781 273.73 177.514C273.72 177.247 273.498 177.039 273.234 177.049C272.97 177.06 272.765 177.284 272.775 177.551C272.785 177.818 273.008 178.027 273.272 178.016Z"
          fill="#25262A"
        />
        <path
          d="M272.961 177.544C272.968 177.709 273.104 177.837 273.267 177.83C273.43 177.824 273.556 177.686 273.55 177.521C273.543 177.356 273.407 177.228 273.244 177.235C273.081 177.241 272.955 177.379 272.961 177.544Z"
          fill="#535C69"
        />
        <path
          d="M265.255 172.123L273.366 171.773C274.269 171.735 274.971 170.96 274.929 170.047L274.663 163.894C274.651 163.591 274.397 163.356 274.097 163.37L269.813 163.573C269.155 163.599 270.632 167.043 270.66 167.709L269.353 170.899L265.202 171.062C264.928 171.072 264.716 171.308 264.726 171.585L264.729 171.638C264.739 171.918 264.975 172.134 265.249 172.123L265.255 172.123Z"
          fill="#D8AAAA"
        />
        <path
          d="M268.648 170.93L272.906 170.746C273.401 170.727 273.784 170.301 273.762 169.8L273.544 164.839C273.492 163.94 273.681 163.413 273.992 163.377L269.282 163.576C268.546 163.611 268.361 164.321 268.397 165.182L268.645 170.93L268.648 170.93Z"
          fill="#B78B8B"
        />
        <path
          d="M264.747 171.44C264.8 171.231 264.984 171.073 265.208 171.064L269.909 170.881C269.225 170.908 269.124 171.907 269.967 171.921L265.258 172.123C265.031 172.131 264.833 171.986 264.763 171.779L264.75 171.44L264.747 171.44Z"
          fill="#BA8F93"
        />
        <path
          d="M269.147 171.162L268.593 169.662C268.7 170.538 268.294 170.903 267.582 170.972L269.151 171.265L269.147 171.164L269.147 171.162Z"
          fill="#BA8F93"
        />
        <path
          d="M267.241 170.825L265.765 169.947L264.178 170.171C264.178 170.171 263.574 170.381 263.516 170.995C263.458 171.608 267.685 177.641 267.685 177.641L268.141 177.526L265.691 171.919C265.691 171.919 266.492 171.909 266.488 171.871C266.486 171.832 267.241 170.825 267.241 170.825Z"
          fill="#FFE6DB"
        />
        <path
          d="M267.913 177.127C267.913 177.127 267.44 177.73 267.48 177.773C267.523 177.816 267.241 178.237 267.241 178.237L266.97 178.372L266.501 178.632L266.548 178.793C266.548 178.793 267.518 178.894 267.618 178.323C267.618 178.323 267.907 177.795 267.943 177.835C267.98 177.875 268.133 178.433 268.133 178.433L268.372 178.347L268.199 177.588L268.216 177.42C268.216 177.42 268.016 177.079 267.913 177.124L267.913 177.127Z"
          fill="#30385C"
        />
        <path
          d="M267.832 170.796L266.381 170.018L264.781 170.074C264.781 170.074 264.165 170.349 264.107 170.966C264.049 171.579 268.216 177.423 268.216 177.423L268.442 177.449L268.556 177.096L266.279 171.891C266.279 171.891 267.081 171.88 267.076 171.842C267.075 171.803 267.829 170.797 267.829 170.797L267.832 170.796Z"
          fill="#FFEADE"
        />
        <path
          d="M269.323 166.397L266.693 167.861L266.078 168.252L265.819 169.227L266.04 169.216L266.288 169.224L266.688 168.86L267.16 168.832L269.799 167.312L269.323 166.397Z"
          fill="#575E6A"
        />
        <path
          d="M268.111 176.759C268.111 176.759 268.208 177.523 268.267 177.524C268.325 177.522 268.429 178.022 268.429 178.022L268.335 178.312L268.192 178.835L268.338 178.912C268.338 178.912 269.087 178.283 268.753 177.809C268.753 177.809 268.582 177.231 268.634 177.232C268.687 177.233 269.191 177.514 269.191 177.514L269.296 177.28L268.638 176.874L268.528 176.743C268.528 176.743 268.148 176.648 268.108 176.753L268.111 176.759Z"
          fill="#30385C"
        />
        <path
          d="M269.543 162.243L271.129 162.376L273.383 165.347L273.305 165.964L269.425 168.487L269.014 167.756L272.111 165.417C272.101 165.371 271.139 164.206 271.139 164.206L270.997 164.829C270.997 164.829 271.426 168.35 272.156 168.956C273.115 169.754 271.903 171.517 271.946 171.495C271.986 171.476 271.407 171.735 271.415 171.705C271.422 171.675 266.543 172.075 266.543 172.075L266.033 169.789L269.052 169.11L268.295 166.674C268.295 166.674 266.795 166.582 267.245 165.253C267.579 164.26 267.219 163.692 267.219 163.692L267.705 163.212L269.545 162.24L269.543 162.243Z"
          fill="#4C688E"
        />
        <path
          d="M269.384 167.358L269.074 167.574L269.634 168.479C269.634 168.479 269.893 168.442 269.842 168.344C269.792 168.245 269.386 167.358 269.386 167.358L269.384 167.358Z"
          fill="white"
        />
        <path
          d="M266.711 167.79L266.401 168.006L266.962 168.911C266.962 168.911 267.22 168.874 267.169 168.776C267.119 168.68 266.714 167.79 266.714 167.79L266.711 167.79Z"
          fill="white"
        />
        <path
          d="M268.65 162.78C268.649 162.75 269.246 162.491 269.246 162.491C269.246 162.491 269.134 163.502 268.471 164.765C268.292 165.109 268.394 166.375 268.394 166.375C268.394 166.375 267.362 166.025 267.674 164.368L268.026 163.155L268.647 162.78L268.65 162.78Z"
          fill="white"
        />
        <path
          d="M266.459 159.791C266.459 159.791 264.953 160.216 265.967 161.373C266.981 162.529 267.78 163.277 267.78 163.277L268.109 163.102L266.457 159.792L266.459 159.791Z"
          fill="#514740"
        />
        <path
          d="M267.052 162.196L268.18 163.22L267.868 164.567L267.94 165.282L267.992 164.583L268.463 163.348L268.697 162.766L267.242 160.868L267.052 162.196Z"
          fill="#FFE5D9"
        />
        <path
          d="M266.945 162.888C267.108 163.023 267.344 163.02 267.502 162.881C268.114 162.352 269.531 160.98 268.53 160.36C267.274 159.585 266.029 160.57 266.029 160.57C266.029 160.57 265.956 162.061 266.945 162.888Z"
          fill="#FFE4D7"
        />
        <path
          d="M266.931 159.082C266.931 159.082 265.158 160.017 266.573 160.694L267.219 160.869C267.219 160.869 268.827 163.107 268.833 163.059C268.84 163.012 270.629 161.226 269.914 160.548C269.199 159.87 268.498 158.796 266.931 159.082Z"
          fill="#514740"
        />
        <path
          d="M269.195 167.749L268.931 167.945L268.241 168.061L267.982 169.036L268.203 169.025L268.451 169.033L268.851 168.669L269.003 168.456L269.505 168.23L269.195 167.749Z"
          fill="#FFE5D9"
        />
        <path
          d="M270.015 163.509L269.287 163.537L269.294 163.723L270.022 163.695L270.015 163.509Z"
          fill="white"
        />
        <path
          d="M256.792 175.27L257.497 175.243L257.433 173.583L256.728 173.61L256.792 175.27Z"
          fill="#8B8E93"
        />
        <path
          d="M256.735 173.796L257.44 173.769L257.433 173.583L256.728 173.61L256.735 173.796Z"
          fill="#777A7F"
        />
        <path
          d="M253.673 177.796L254.239 177.774L254.209 177.013L253.644 177.035L253.673 177.796Z"
          fill="#595E65"
        />
        <path
          d="M260.263 177.568L260.828 177.546L260.795 176.688L260.23 176.71L260.263 177.568Z"
          fill="#595E65"
        />
        <path
          d="M257.537 176.115L257.594 176.671L260.535 177.2L260.798 176.679L257.537 176.115Z"
          fill="#595E65"
        />
        <path
          d="M256.852 176.189L256.842 176.751L253.955 177.525L253.649 177.026L256.852 176.189Z"
          fill="#595E65"
        />
        <path
          d="M256.657 177.322L257.74 177.28L257.66 175.23L256.577 175.273L256.657 177.322Z"
          fill="#535C69"
        />
        <path
          d="M256.891 178.078L257.549 178.052L257.514 177.17L256.856 177.196L256.891 178.078Z"
          fill="#595E65"
        />
        <path
          d="M257.492 173.616L256.691 173.647C256.391 173.659 256.14 173.424 256.128 173.12L258.01 173.046C258.021 173.35 257.789 173.604 257.489 173.616L257.492 173.616Z"
          fill="#535C69"
        />
        <path
          d="M257.562 173.613C257.282 173.624 257.046 173.403 257.035 173.12L257.034 173.084L258.01 173.046L258.012 173.117C258.023 173.38 257.821 173.6 257.562 173.61L257.562 173.613Z"
          fill="#608599"
        />
        <path
          opacity="0.59"
          d="M258.018 173.194C258.018 173.194 258.019 173.205 258.019 173.211L256.14 173.285C256.14 173.27 256.139 173.252 256.138 173.238L256.134 173.123L258.016 173.049L258.021 173.194L258.018 173.194Z"
          fill="#26374C"
        />
        <path
          d="M259.661 172.988L254.238 173.2C253.9 173.213 253.615 172.947 253.602 172.605C253.599 172.537 253.652 172.479 253.719 172.476L260.317 172.218C260.384 172.216 260.441 172.269 260.444 172.337C260.457 172.679 259.999 172.975 259.661 172.988Z"
          fill="#535C69"
        />
        <path
          d="M257.763 172.421L257.759 172.315L260.439 172.21L260.443 172.316C260.457 172.67 260.168 172.968 259.798 172.982L258.458 173.035C258.089 173.049 257.777 172.775 257.763 172.421Z"
          fill="#608599"
        />
        <path
          d="M257.244 178.758C257.498 178.748 257.696 178.531 257.686 178.274C257.676 178.017 257.462 177.816 257.207 177.826C256.953 177.836 256.755 178.053 256.765 178.31C256.775 178.567 256.99 178.768 257.244 178.758Z"
          fill="#25262A"
        />
        <path
          d="M257.237 178.578C257.393 178.572 257.514 178.439 257.508 178.281C257.502 178.123 257.37 178 257.214 178.006C257.058 178.012 256.937 178.145 256.943 178.303C256.949 178.461 257.081 178.584 257.237 178.578Z"
          fill="#535C69"
        />
        <path
          d="M253.936 178.468C254.19 178.458 254.388 178.241 254.378 177.984C254.368 177.727 254.154 177.526 253.9 177.536C253.645 177.546 253.447 177.763 253.458 178.02C253.468 178.277 253.682 178.478 253.936 178.468Z"
          fill="#25262A"
        />
        <path
          d="M253.929 178.288C254.085 178.282 254.206 178.149 254.2 177.991C254.194 177.833 254.063 177.71 253.907 177.716C253.751 177.722 253.629 177.855 253.635 178.013C253.641 178.171 253.773 178.294 253.929 178.288Z"
          fill="#535C69"
        />
        <path
          d="M260.57 178.256C260.824 178.246 261.022 178.029 261.012 177.772C261.002 177.515 260.788 177.314 260.534 177.324C260.28 177.334 260.082 177.551 260.092 177.808C260.102 178.065 260.316 178.266 260.57 178.256Z"
          fill="#25262A"
        />
        <path
          d="M260.563 178.076C260.719 178.07 260.841 177.937 260.835 177.779C260.829 177.621 260.697 177.498 260.541 177.504C260.385 177.51 260.263 177.643 260.27 177.801C260.276 177.959 260.407 178.082 260.563 178.076Z"
          fill="#535C69"
        />
        <path
          d="M252.851 172.581L260.665 172.243C261.536 172.206 262.21 171.462 262.173 170.581L261.918 164.655C261.906 164.363 261.661 164.137 261.373 164.151L257.25 164.344C256.615 164.369 258.036 167.686 258.065 168.329L256.805 171.402L252.805 171.558C252.54 171.568 252.336 171.798 252.35 172.063L252.352 172.116C252.362 172.384 252.589 172.594 252.854 172.583L252.851 172.581Z"
          fill="#D8AAAA"
        />
        <path
          d="M256.117 171.428L260.218 171.25C260.696 171.232 261.065 170.822 261.043 170.338L260.833 165.56C260.781 164.694 260.966 164.184 261.265 164.152L256.727 164.344C256.017 164.378 255.839 165.061 255.875 165.892L256.114 171.428L256.117 171.428Z"
          fill="#B78B8B"
        />
        <path
          d="M252.359 171.921C252.409 171.721 252.587 171.566 252.803 171.558L257.332 171.381C256.671 171.407 256.577 172.367 257.389 172.383L252.854 172.578C252.636 172.586 252.444 172.446 252.377 172.245L252.365 171.917L252.359 171.921Z"
          fill="#BA8F93"
        />
        <path
          d="M256.599 171.655L256.064 170.211C256.167 171.054 255.775 171.406 255.092 171.471L256.603 171.755L256.599 171.658L256.599 171.655Z"
          fill="#BA8F93"
        />
        <path
          d="M265.603 178.794L266.451 178.761L266.101 169.801L265.253 169.834L265.603 178.794Z"
          fill="#608599"
        />
        <path
          d="M272.448 178.527L273.296 178.494L272.946 169.533L272.098 169.567L272.448 178.527Z"
          fill="#608599"
        />
        <path
          d="M250.911 179.368L251.578 179.342L251.228 170.382L250.561 170.408L250.911 179.368Z"
          fill="#3F637F"
        />
        <path
          d="M256.398 179.13L254.859 179.161L254.944 178.514L255.316 177.732L256.175 177.985L256.398 179.13Z"
          fill="#535C69"
        />
        <path
          d="M252.73 179.12L251.514 179.342L250.718 179.361L250.428 178.738L251.767 178.21L252.727 178.149L252.73 179.12Z"
          fill="#535C69"
        />
        <path
          d="M255.671 169.553L256.616 170.148L259.013 169.381L258.979 170.242L258.634 171.33L257.627 171.476L253.415 172.372L253.005 178.223L251.569 178.206L251.766 171.161L255.671 169.553Z"
          fill="#535C69"
        />
        <path
          d="M256.036 171.446C256.053 171.584 256.458 178.127 256.458 178.127C256.458 178.127 254.966 178.109 254.945 178.003C254.923 177.898 254.325 171.992 254.325 171.992L256.036 171.446Z"
          fill="#535C69"
        />
        <path
          d="M244.353 170.775L274.02 169.616L273.988 168.802L244.321 169.961L244.353 170.775Z"
          fill="#608599"
        />
        <path
          d="M258.957 169.059L259.157 170.073L255.09 170.231L255.136 169.232L254.672 166.01L254.894 164.02L255.184 163.903L257.692 163.565L258.911 163.863L258.873 166.918L258.957 169.059Z"
          fill="#535C69"
        />
        <path
          d="M257.692 163.566L258.035 164.364L257.517 164.458L257.884 165.126L256.249 168.001L256.127 167.415L255.142 165.133L255.415 164.656L255.107 164.473L255.53 163.706L256.943 163.288L257.692 163.566Z"
          fill="#4A607C"
        />
        <path
          d="M257.274 163.782L256.333 165.517L255.604 164.559L255.682 162.909L257.142 162.716L257.274 163.782Z"
          fill="#F5D7C6"
        />
        <path
          d="M255.64 163.778L255.721 164.112L256.081 164.44L256.755 164.004L257.236 163.477L257.484 163.695L257.011 164.575L256.25 166.985L255.648 164.723L255.54 164.335L255.536 163.948L255.64 163.778Z"
          fill="white"
        />
        <path
          d="M256.457 164.659L256.366 164.878L255.958 164.879L255.862 164.676L256.081 164.44L256.457 164.659Z"
          fill="#BA8F93"
        />
        <path
          d="M255.884 165.617L256.256 167.132L256.64 165.777L256.419 164.973L255.932 164.978L255.884 165.617Z"
          fill="#BA8F93"
        />
        <path
          d="M251.875 169.108L252.178 169.548L252.726 170.043L253.352 170.175L253.639 169.972L253.606 169.885L253.29 169.924L253.089 169.934L253.457 169.716L253.103 169.095L252.434 168.915L251.875 169.108Z"
          fill="#F8E2D2"
        />
        <path
          d="M254.971 159.493C254.971 159.493 256.027 159.405 256.43 159.413C257.384 159.429 257.863 159.584 257.937 160.73C257.951 160.945 257.84 161.321 257.84 161.54C257.84 161.54 258.05 161.381 258.136 161.578C258.2 161.724 257.898 162.426 257.686 162.384L257.454 163.017L256.544 163.755L255.983 163.73L255.42 163.202L255.096 162.244C254.96 162.337 254.89 161.826 254.86 161.571C254.843 161.427 254.923 161.471 254.923 161.471C254.923 161.471 254.828 160.683 254.886 160.374C254.942 160.079 254.971 159.496 254.971 159.496L254.971 159.493Z"
          fill="#F8E2D2"
        />
        <path
          d="M255.166 160.451L254.939 160.986L255.077 162.044L254.98 161.888L254.857 160.986L254.855 160.248L255.166 160.451Z"
          fill="#A8938B"
        />
        <path
          d="M254.702 160.732L255.565 161.1L257.265 160.939L257.628 161.114L257.819 161.148L257.884 161.234L257.996 161.132C257.996 161.132 257.988 160.557 258.008 160.532C258.027 160.505 257.775 159.723 257.775 159.723L257.375 159.571L257.09 159.287L256.121 159.274L255.234 159.427L254.719 159.536L254.617 160.145L254.705 160.735L254.702 160.732Z"
          fill="#77675F"
        />
        <path
          d="M257.628 161.111L258.008 160.529L257.996 161.129L257.906 161.508L257.813 161.597L257.737 161.957L257.466 162.113L257.661 161.426L257.628 161.111Z"
          fill="#A8938B"
        />
        <path
          d="M256.787 169.451L256.395 169.498L255.712 169.939L255.106 170.045L254.857 169.798L254.907 169.722L255.192 169.699L254.838 169.311L255.208 168.765L256.104 168.695L256.613 168.805L256.787 169.451Z"
          fill="#F8E2D2"
        />
        <path
          d="M256.579 168.623L256.375 168.702L256.723 169.447L256.927 169.368L256.579 168.623Z"
          fill="white"
        />
        <path
          d="M252.634 169.625L252.794 169.763L253.365 169.168L253.196 168.944L252.634 169.625Z"
          fill="white"
        />
        <path
          d="M258.013 165.062C258.863 163.52 258.883 163.678 259.142 164.321L260.614 167.801L260.459 168.997L256.97 169.576L256.465 168.542L259.104 167.91L258.22 165.969C258.247 165.992 257.991 165.098 258.013 165.062Z"
          fill="#535C69"
        />
        <path
          d="M255.344 165.895L255.335 165.671L254.894 164.02L252.492 166.592L252.361 166.966L252.653 169.895L253.359 169.156L253.532 167.221L255.154 165.826L255.344 165.895Z"
          fill="#535C69"
        />
        <path
          d="M247.315 169.162C247.315 169.162 247.435 169.104 247.33 169.099C247.222 169.095 246.96 169.102 246.955 169.205C246.949 169.285 247.026 169.693 247.49 169.613C247.954 169.533 247.531 169.543 247.531 169.543C247.531 169.543 247.149 169.546 247.069 169.298C246.983 169.03 247.835 169.496 247.835 169.496L247.318 169.165L247.315 169.162Z"
          fill="#B9D2D8"
        />
        <path
          opacity="0.95"
          d="M248.164 169.102C248.164 169.102 248.185 168.821 247.958 168.596C247.74 168.383 247.851 167.738 247.851 167.738C247.851 167.738 248.05 168.04 248.065 168.128C248.094 168.272 247.993 168.382 248.175 168.7C248.278 168.882 248.222 169.088 248.222 169.088C248.222 169.088 248.279 168.968 248.298 168.866C248.32 168.756 248.313 168.509 248.231 168.258C248.115 167.902 247.87 167.764 247.712 167.147C247.564 166.577 247.752 166.245 247.911 166.124C248.29 165.834 247.931 164.484 247.931 164.484C247.931 164.484 248.338 165.191 248.436 165.518C248.533 165.839 248.746 166.451 248.28 166.977C248.017 167.274 248.207 167.574 248.383 168.131C248.557 168.688 248.287 169.106 248.287 169.106C248.25 169.122 248.215 169.138 248.164 169.105L248.164 169.102Z"
          fill="#EEFEFF"
        />
        <path
          d="M246.955 169.203C246.973 169.06 247.107 169.067 247.238 169.07C247.323 169.073 247.331 169.12 247.363 169.136L247.3 169.16C247.3 169.16 246.963 169.117 246.972 169.279C246.973 169.29 246.973 169.299 246.973 169.308C246.96 169.261 246.955 169.22 246.958 169.202L246.955 169.203Z"
          fill="white"
        />
        <path
          d="M247.247 169.067C247.243 168.961 247.638 168.857 248.131 168.838C248.623 168.819 249.025 168.888 249.03 168.998C249.03 169.009 249.025 169.018 249.019 169.03C248.972 169.162 248.764 169.737 248.765 169.758C248.767 169.814 248.48 169.872 248.128 169.886C247.775 169.9 247.541 169.862 247.538 169.806L247.25 169.076L247.267 169.069L247.25 169.07L247.247 169.067Z"
          fill="#CADEE3"
        />
        <path
          d="M247.518 168.915C247.592 169.169 247.74 169.745 247.778 169.879C247.628 169.867 247.54 169.838 247.538 169.806L247.25 169.076C247.25 169.076 247.2 168.995 247.518 168.915Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M247.198 165.871L247.098 166.008L253.764 169.592L253.844 169.471L252.369 165.84L247.198 165.871Z"
          fill="#49768E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M247.098 166.008L248.334 166.279L252.272 165.977L252.369 165.84L247.198 165.871L247.098 166.008Z"
          fill="#87A8B2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M253.764 169.592L256.156 169.496L256.15 169.351L253.709 169.444L253.764 169.592Z"
          fill="#49768E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M254.008 169.547L254.24 169.535L254.238 169.467L254.005 169.477L254.008 169.547Z"
          fill="#535C69"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M254.313 169.535L254.543 169.523L254.541 169.459L254.311 169.468L254.313 169.535Z"
          fill="#535C69"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M247.098 166.008L248.786 169.775L253.764 169.592L252.272 165.977L247.098 166.008Z"
          fill="#718E99"
        />
        <path
          d="M244.353 170.775L266.4 169.913L266.368 169.1L244.321 169.961L244.353 170.775Z"
          fill="#516F87"
        />
        <path
          d="M263.045 165.659C263.045 165.659 266.513 165.574 266.53 165.556C266.547 165.537 267.644 169.053 267.644 169.053L264.178 169.197L263.045 165.659Z"
          fill="#87ADB7"
        />
        <path
          d="M270.521 168.556L265.789 168.698L265.802 169.119L270.533 168.978L270.521 168.556Z"
          fill="#87ADB7"
        />
        <path
          d="M265.411 167.306C265.473 167.537 265.434 167.745 265.33 167.773C265.223 167.801 265.089 167.638 265.027 167.407C264.966 167.176 265.004 166.968 265.108 166.94C265.215 166.912 265.35 167.075 265.411 167.306Z"
          fill="#EAFCFF"
        />
        <path
          d="M261.241 168.68L257.387 168.83C257.186 168.838 257.094 168.718 257.088 168.57C257.082 168.42 257.168 168.296 257.366 168.288L261.219 168.137L261.228 168.199L261.094 168.204L261.07 168.344L260.946 168.316L261.104 168.614L261.232 168.609L261.235 168.683L261.241 168.68Z"
          fill="#AFC9D9"
        />
        <path
          d="M261.113 168.614L259.222 168.688C259.126 168.691 259.044 168.603 259.039 168.488C259.035 168.376 259.11 168.279 259.206 168.284L261.097 168.21L261.113 168.614Z"
          fill="white"
        />
        <path
          d="M258.955 168.492C258.961 168.642 259.044 168.763 259.14 168.759L257.337 168.829C257.171 168.818 257.09 168.706 257.085 168.571C257.079 168.423 257.162 168.299 257.357 168.288L259.119 168.219C259.023 168.214 258.949 168.341 258.955 168.492Z"
          fill="#97B2C2"
        />
        <path
          d="M256.655 168.085C256.66 168.212 256.766 168.314 256.894 168.309L260.369 168.173L260.334 167.274L256.859 167.41C256.734 167.415 256.633 167.522 256.638 167.652L256.655 168.088L256.655 168.085Z"
          fill="#B7D1DD"
        />
        <path
          d="M256.933 168.187L258.748 168.116C258.843 168.112 258.916 168.031 258.913 167.935L258.9 167.605C258.896 167.509 258.816 167.434 258.721 167.437L256.906 167.508C256.812 167.512 256.738 167.593 256.741 167.689L256.754 168.019C256.758 168.115 256.838 168.19 256.933 168.187Z"
          fill="#7DA1B2"
        />
        <path
          d="M260.37 168.052L257.084 168.181C256.988 168.184 256.904 168.108 256.9 168.008L256.889 167.722C256.884 167.604 256.976 167.503 257.093 167.498L260.341 167.371L260.367 168.049L260.37 168.052Z"
          fill="white"
        />
        <path
          d="M258.992 168.106L257.067 168.181C256.98 168.185 256.907 168.117 256.903 168.028L256.889 167.651C256.886 167.571 256.947 167.507 257.023 167.504L258.963 167.428L258.989 168.106L258.992 168.106Z"
          fill="#EEFEFF"
        />
        <path
          d="M259.036 167.425L260.443 167.37L260.439 167.267L259.032 167.322L259.036 167.425Z"
          fill="#D6EFF7"
        />
        <path
          d="M259.067 168.219L260.474 168.164L260.469 168.049L259.062 168.104L259.067 168.219Z"
          fill="#D6EFF7"
        />
        <path
          d="M256.673 169.517L260.643 169.362C260.713 169.359 260.766 169.301 260.763 169.23L260.747 168.811C260.744 168.747 260.69 168.696 260.626 168.698L256.647 168.854L256.673 169.517Z"
          fill="#839AA8"
        />
        <path
          d="M260.552 169.286L258.945 169.348L258.925 168.847L260.556 168.783C260.603 168.782 260.639 168.819 260.641 168.863L260.653 169.169C260.655 169.228 260.608 169.28 260.549 169.283L260.552 169.286Z"
          fill="#394852"
        />
        <path
          d="M260.383 169.292L258.901 169.35L258.881 168.849L260.364 168.791C260.443 168.788 260.509 168.85 260.512 168.93L260.52 169.139C260.524 169.219 260.462 169.286 260.383 169.289L260.383 169.292Z"
          fill="white"
        />
        <path
          d="M256.643 169.438L258.945 169.348L258.925 168.847L256.624 168.937L256.643 169.438Z"
          fill="#EEFEFF"
        />
        <path
          d="M256.496 168.939L258.768 168.85L258.764 168.768L256.492 168.857L256.496 168.939Z"
          fill="#5A6D78"
        />
        <path
          d="M256.518 169.52L258.79 169.431L258.787 169.352L256.515 169.44L256.518 169.52Z"
          fill="#5A6D78"
        />
        <path
          d="M219.909 175.025L219.204 175.053L219.269 176.713L219.973 176.685L219.909 175.025Z"
          fill="#8B8E93"
        />
        <path
          d="M219.909 175.025L219.204 175.053L219.211 175.238L219.916 175.211L219.909 175.025Z"
          fill="#777A7F"
        />
        <path
          d="M223.25 178.199L222.685 178.221L222.715 178.982L223.28 178.96L223.25 178.199Z"
          fill="#595E65"
        />
        <path
          d="M216.662 178.389L216.097 178.411L216.13 179.269L216.695 179.247L216.662 178.389Z"
          fill="#595E65"
        />
        <path
          d="M219.297 177.586L219.284 178.144L216.393 178.901L216.091 178.402L219.297 177.586Z"
          fill="#595E65"
        />
        <path
          d="M219.986 177.606L220.04 178.165L222.979 178.712L223.244 178.19L219.986 177.606Z"
          fill="#595E65"
        />
        <path
          d="M220.189 176.674L219.105 176.716L219.185 178.765L220.269 178.723L220.189 176.674Z"
          fill="#535C69"
        />
        <path
          d="M220.063 178.61L219.405 178.636L219.439 179.517L220.098 179.492L220.063 178.61Z"
          fill="#595E65"
        />
        <path
          d="M219.147 175.09L219.948 175.059C220.248 175.047 220.48 174.793 220.468 174.489L218.587 174.563C218.598 174.867 218.85 175.102 219.15 175.09L219.147 175.09Z"
          fill="#535C69"
        />
        <path
          d="M219.077 175.093C219.357 175.082 219.575 174.843 219.564 174.56L219.562 174.525L218.587 174.563L218.589 174.634C218.6 174.896 218.818 175.1 219.077 175.09L219.077 175.093Z"
          fill="#608599"
        />
        <path
          opacity="0.59"
          d="M218.589 174.711C218.589 174.711 218.59 174.722 218.59 174.728L220.469 174.655C220.468 174.64 220.468 174.622 220.467 174.608L220.462 174.493L218.581 174.566L218.586 174.711L218.589 174.711Z"
          fill="#26374C"
        />
        <path
          d="M216.935 174.634L222.359 174.422C222.697 174.408 222.96 174.121 222.946 173.779C222.944 173.711 222.886 173.657 222.819 173.66L216.222 173.917C216.155 173.92 216.101 173.978 216.104 174.046C216.118 174.388 216.597 174.647 216.935 174.634Z"
          fill="#535C69"
        />
        <path
          d="M218.783 173.921L218.779 173.814L216.099 173.919L216.103 174.025C216.117 174.379 216.428 174.653 216.798 174.639L218.138 174.587C218.508 174.572 218.797 174.274 218.783 173.921Z"
          fill="#608599"
        />
        <path
          d="M219.796 180.197C220.05 180.187 220.248 179.971 220.238 179.713C220.228 179.456 220.013 179.256 219.759 179.265C219.505 179.275 219.307 179.492 219.317 179.749C219.327 180.007 219.541 180.207 219.796 180.197Z"
          fill="#25262A"
        />
        <path
          d="M219.789 180.017C219.945 180.011 220.066 179.878 220.06 179.72C220.054 179.562 219.922 179.439 219.766 179.445C219.61 179.451 219.489 179.584 219.495 179.742C219.501 179.9 219.633 180.023 219.789 180.017Z"
          fill="#535C69"
        />
        <path
          d="M223.074 179.65C223.328 179.64 223.526 179.423 223.516 179.166C223.506 178.909 223.291 178.708 223.037 178.718C222.783 178.728 222.585 178.945 222.595 179.202C222.605 179.459 222.819 179.66 223.074 179.65Z"
          fill="#25262A"
        />
        <path
          d="M223.067 179.47C223.223 179.464 223.344 179.331 223.338 179.173C223.332 179.015 223.2 178.892 223.044 178.898C222.888 178.904 222.767 179.037 222.773 179.195C222.779 179.353 222.911 179.476 223.067 179.47Z"
          fill="#535C69"
        />
        <path
          d="M216.44 179.956C216.694 179.946 216.892 179.73 216.882 179.472C216.872 179.215 216.658 179.015 216.404 179.024C216.15 179.034 215.952 179.251 215.962 179.508C215.972 179.766 216.186 179.966 216.44 179.956Z"
          fill="#25262A"
        />
        <path
          d="M216.433 179.776C216.589 179.77 216.711 179.637 216.704 179.479C216.698 179.321 216.567 179.198 216.411 179.204C216.255 179.21 216.133 179.343 216.139 179.501C216.146 179.659 216.277 179.782 216.433 179.776Z"
          fill="#535C69"
        />
        <path
          d="M223.696 173.696L215.879 173.969C215.008 174 214.278 173.311 214.247 172.429L214.039 166.502C214.027 166.21 214.254 165.965 214.542 165.957L218.668 165.828C219.303 165.803 218.144 169.221 218.167 169.864L219.662 172.829L223.662 172.673C223.927 172.662 224.148 172.875 224.155 173.141L224.158 173.194C224.168 173.462 223.958 173.689 223.693 173.699L223.696 173.696Z"
          fill="#D8AAAA"
        />
        <path
          d="M220.347 172.802L216.245 172.945C215.767 172.964 215.367 172.584 215.351 172.1L215.188 167.32C215.171 166.452 214.948 165.959 214.647 165.95L219.186 165.787C219.894 165.766 220.127 166.433 220.157 167.264L220.35 172.802L220.347 172.802Z"
          fill="#B78B8B"
        />
        <path
          d="M224.132 173C224.066 172.805 223.877 172.664 223.662 172.673L219.132 172.85C219.793 172.824 219.962 173.774 219.154 173.853L223.69 173.693C223.908 173.685 224.089 173.53 224.139 173.324L224.127 172.997L224.132 173Z"
          fill="#BA8F93"
        />
        <path
          d="M219.885 173.065L220.305 171.584C220.268 172.433 220.686 172.754 221.372 172.765L219.888 173.166L219.885 173.068L219.885 173.065Z"
          fill="#BA8F93"
        />
        <path
          d="M220.668 180.503L222.205 180.413L222.072 179.774L221.64 179.024L220.801 179.343L220.668 180.503Z"
          fill="#535C69"
        />
        <path
          d="M224.324 180.206L225.554 180.332L226.349 180.289L226.589 179.645L225.213 179.224L224.251 179.238L224.324 180.206Z"
          fill="#535C69"
        />
        <path
          d="M220.646 170.901L219.75 171.565L217.3 170.987L217.404 171.842L217.83 172.901L218.845 172.967L223.115 173.533L223.983 179.334L225.411 179.204L224.664 172.196L220.646 170.901Z"
          fill="#535C69"
        />
        <path
          d="M220.429 172.814C220.423 172.953 220.53 179.507 220.53 179.507C220.53 179.507 222.016 179.372 222.029 179.265C222.042 179.159 222.178 173.224 222.178 173.224L220.429 172.814Z"
          fill="#535C69"
        />
        <path
          d="M204.445 165.335L204.625 165.703C204.899 165.994 205.764 166.084 205.874 165.711L205.957 165.43L205.905 164.094L204.342 163.677L204.521 164.447L204.445 165.335Z"
          fill="#F5D7C6"
        />
        <path
          d="M204.41 161.761L204.645 161.43C204.645 161.43 204.957 161.279 205.227 161.242C205.459 161.209 206.123 160.941 206.123 160.941L206.252 161.258L206.495 161.361L206.629 161.518C206.733 161.924 206.609 162.124 206.603 162.189C206.546 162.806 206.308 163.975 206.333 163.998L205.82 164.618L205.358 164.6L204.916 164.337L204.609 164.154C204.609 164.154 204.496 163.966 204.208 163.594C204.11 163.341 204.106 163.447 204.004 163.091C204.015 162.91 203.937 162.19 204.009 162.087C204.036 162.044 204.413 161.767 204.413 161.767L204.41 161.761Z"
          fill="#F8E2D2"
        />
        <path
          d="M206.67 162.186L206.929 161.71L206.85 161.255L206.579 161.186L206.264 160.906L205.074 161.053L204.568 161.235L204.422 161.548L203.872 161.944L203.841 162.947L204.256 164.002L204.496 164.335L204.494 163.981L204.226 163.392L204.205 163.092L204.437 163.121L204.664 163.561L204.599 163.02L204.559 162.423L204.879 162.191L205.661 162.185L206.67 162.186Z"
          fill="#535C69"
        />
        <path
          d="M207.049 175.537L206.388 175.562L206.448 177.119L207.11 177.093L207.049 175.537Z"
          fill="#8B8E93"
        />
        <path
          d="M207.049 175.537L206.388 175.562L206.394 175.736L207.056 175.711L207.049 175.537Z"
          fill="#777A7F"
        />
        <path
          d="M210.182 178.512L209.651 178.532L209.679 179.246L210.209 179.225L210.182 178.512Z"
          fill="#595E65"
        />
        <path
          d="M204.004 178.691L203.474 178.712L203.505 179.517L204.035 179.496L204.004 178.691Z"
          fill="#595E65"
        />
        <path
          d="M206.475 177.936L206.463 178.462L203.751 179.17L203.468 178.7L206.475 177.936Z"
          fill="#595E65"
        />
        <path
          d="M207.12 177.958L207.17 178.482L209.926 178.994L210.175 178.503L207.12 177.958Z"
          fill="#595E65"
        />
        <path
          d="M207.308 177.083L206.294 177.122L206.369 179.042L207.383 179.002L207.308 177.083Z"
          fill="#535C69"
        />
        <path
          d="M207.192 178.897L206.574 178.921L206.607 179.747L207.224 179.723L207.192 178.897Z"
          fill="#595E65"
        />
        <path
          d="M205.807 175.107L207.572 175.038L207.591 175.527C207.591 175.527 207.58 175.551 207.569 175.552L205.853 175.619C205.853 175.619 205.829 175.608 205.829 175.596L205.81 175.107L205.807 175.107Z"
          fill="#535C69"
        />
        <path
          d="M205.807 175.107L206.721 175.071L206.741 175.56C206.741 175.56 206.73 175.584 206.718 175.585L205.847 175.619C205.847 175.619 205.827 175.611 205.826 175.599L205.807 175.107Z"
          fill="#608599"
        />
        <path
          opacity="0.59"
          d="M205.812 175.242C205.812 175.242 205.813 175.254 205.813 175.257L207.575 175.188C207.574 175.174 207.574 175.159 207.573 175.144L207.569 175.038L205.804 175.107L205.809 175.243L205.812 175.242Z"
          fill="#26374C"
        />
        <path
          d="M204.26 175.167L209.343 174.969C209.66 174.956 209.907 174.687 209.894 174.365C209.892 174.3 209.837 174.249 209.773 174.252L203.589 174.493C203.525 174.496 203.475 174.551 203.477 174.616C203.49 174.937 203.94 175.18 204.257 175.167L204.26 175.167Z"
          fill="#535C69"
        />
        <path
          d="M205.993 174.5L205.989 174.4L203.475 174.498L203.479 174.598C203.492 174.929 203.785 175.186 204.132 175.172L205.39 175.123C205.737 175.11 206.009 174.83 205.996 174.5L205.993 174.5Z"
          fill="#608599"
        />
        <path
          d="M206.941 180.383C207.179 180.374 207.364 180.171 207.355 179.93C207.345 179.689 207.145 179.501 206.907 179.511C206.668 179.52 206.483 179.723 206.493 179.964C206.502 180.205 206.703 180.393 206.941 180.383Z"
          fill="#25262A"
        />
        <path
          d="M207.189 179.937C207.194 180.084 207.08 180.21 206.934 180.215C206.788 180.221 206.664 180.105 206.659 179.958C206.653 179.81 206.767 179.685 206.913 179.679C207.059 179.673 207.183 179.789 207.189 179.937Z"
          fill="#535C69"
        />
        <path
          d="M210.013 179.871C210.251 179.861 210.436 179.659 210.427 179.418C210.418 179.177 210.217 178.989 209.979 178.998C209.741 179.007 209.555 179.21 209.565 179.451C209.574 179.692 209.775 179.88 210.013 179.871Z"
          fill="#25262A"
        />
        <path
          d="M210.261 179.424C210.267 179.572 210.152 179.697 210.006 179.703C209.861 179.708 209.737 179.592 209.731 179.445C209.725 179.297 209.84 179.172 209.985 179.166C210.131 179.16 210.255 179.277 210.261 179.424Z"
          fill="#535C69"
        />
        <path
          d="M203.796 180.161C204.034 180.152 204.219 179.949 204.21 179.708C204.201 179.467 204 179.279 203.762 179.288C203.524 179.297 203.338 179.5 203.348 179.741C203.357 179.982 203.558 180.17 203.796 180.161Z"
          fill="#25262A"
        />
        <path
          d="M204.044 179.714C204.05 179.862 203.935 179.987 203.789 179.993C203.644 179.998 203.52 179.882 203.514 179.735C203.508 179.587 203.623 179.462 203.768 179.456C203.914 179.451 204.038 179.567 204.044 179.714Z"
          fill="#535C69"
        />
        <path
          d="M210.597 174.291L203.27 174.547C202.455 174.576 201.77 173.93 201.741 173.104L201.547 167.548C201.536 167.274 201.749 167.044 202.02 167.037L205.889 166.918C206.484 166.895 205.398 170.1 205.419 170.701L206.82 173.481L210.569 173.335C210.816 173.325 211.025 173.524 211.032 173.775L211.034 173.822C211.044 174.075 210.848 174.287 210.597 174.294L210.597 174.291Z"
          fill="#D8AAAA"
        />
        <path
          d="M207.46 173.453L203.615 173.586C203.169 173.603 202.794 173.246 202.776 172.795L202.621 168.315C202.604 167.504 202.396 167.04 202.116 167.03L206.369 166.879C207.034 166.859 207.251 167.482 207.278 168.263L207.46 173.453Z"
          fill="#B78B8B"
        />
        <path
          d="M211.006 173.64C210.944 173.456 210.77 173.327 210.566 173.332L206.322 173.498C206.942 173.474 207.099 174.365 206.344 174.439L210.597 174.291C210.804 174.283 210.97 174.137 211.018 173.946L211.006 173.64Z"
          fill="#BA8F93"
        />
        <path
          d="M207.027 173.701L207.419 172.312C207.386 173.108 207.777 173.409 208.419 173.419L207.028 173.795L207.024 173.704L207.027 173.701Z"
          fill="#BA8F93"
        />
        <path
          d="M206.681 179.626L206.68 180.069L206.429 180.268C206.429 180.268 206.505 179.901 206.681 179.626Z"
          fill="#B4B4B4"
        />
        <path
          d="M206.678 179.72C206.678 179.72 206.426 180.126 206.388 180.437C206.388 180.437 206.341 180.87 205.978 181.059C205.978 181.059 205.225 181.274 204.925 180.917L204.926 180.719C204.926 180.719 205.318 180.964 205.989 180.816C205.989 180.816 206.323 180.703 206.4 180.139L206.7 179.593L206.681 179.723L206.678 179.72Z"
          fill="#CBCCCC"
        />
        <path
          d="M205.471 179.567C205.471 179.567 205.732 179.379 206.01 179.566C206.01 179.566 206.196 179.766 206.346 179.568C206.346 179.568 206.475 179.22 206.635 179.202C206.635 179.202 206.747 179.372 206.7 179.59C206.7 179.59 206.476 179.997 206.402 180.192C206.402 180.192 206.341 180.714 205.963 180.814C205.963 180.814 205.328 181.078 204.929 180.719C204.929 180.719 204.909 180.191 205.304 179.993C205.304 179.993 205.442 179.881 205.471 179.57L205.471 179.567Z"
          fill="#31455E"
        />
        <path
          d="M204.538 173.683L207.529 173.566L207.453 171.629L203.735 171.795L203.789 172.9C203.807 173.348 204.141 173.698 204.538 173.683Z"
          fill="#2E425B"
        />
        <path
          d="M210.577 169.508C210.577 169.508 210.937 169.485 211.027 169.39C211.027 169.39 211.537 169.225 211.754 169.261C211.754 169.261 212.628 169.377 212.734 169.323C212.734 169.323 212.74 169.621 212.206 169.618C212.206 169.618 212.634 169.761 212.657 169.822C212.657 169.822 212.659 170.026 212.441 170.034C212.441 170.034 212.337 170.207 212.22 170.194C212.22 170.194 212.142 170.386 211.953 170.31C211.953 170.31 211.923 170.453 211.755 170.392C211.755 170.392 210.889 170.03 210.669 170.092L210.577 169.508Z"
          fill="#F8DAC9"
        />
        <path
          d="M210.843 169.456C210.843 169.456 209.225 168.802 208.649 168.638L207.74 165.594L207.495 169.197L208.29 169.824C208.29 169.824 209.884 170.01 210.693 170.164C210.693 170.164 210.756 169.911 210.846 169.459L210.843 169.456Z"
          fill="#B7CAD8"
        />
        <path
          d="M207.417 171.81C207.417 171.81 207.643 169.023 207.651 168.178C207.651 168.178 207.721 165.872 207.74 165.6C207.74 165.6 206.67 165.083 206.123 164.833L205.67 166.008L204.148 164.91C204.148 164.91 203.043 165.606 202.695 165.947L203.89 172.046L207.42 171.813L207.417 171.81Z"
          fill="#97B1C1"
        />
        <path
          d="M205.8 165.867L205.762 165.869L206.129 171.753L206.167 171.751L205.8 165.867Z"
          fill="#A1BAC9"
        />
        <path
          d="M206.472 166.603L205.667 166.008L205.145 166.752C205.145 166.752 204.144 165.265 203.909 165.07L204.459 164.641C204.459 164.641 205.11 165.628 205.62 165.768C205.62 165.768 205.925 165.673 205.964 164.582L206.45 164.985C206.45 164.985 206.53 166.361 206.472 166.606L206.472 166.603Z"
          fill="white"
        />
        <path
          d="M205.689 166.418C205.691 166.456 205.721 166.485 205.759 166.483C205.797 166.482 205.825 166.451 205.823 166.413C205.822 166.374 205.791 166.346 205.753 166.347C205.716 166.349 205.688 166.38 205.689 166.418Z"
          fill="white"
        />
        <path
          d="M205.795 167.418C205.832 167.416 205.861 167.385 205.86 167.347C205.858 167.31 205.827 167.281 205.79 167.282C205.753 167.283 205.724 167.315 205.726 167.352C205.727 167.39 205.758 167.419 205.795 167.418Z"
          fill="white"
        />
        <path
          d="M205.832 168.37C205.869 168.369 205.898 168.337 205.897 168.3C205.895 168.262 205.864 168.233 205.827 168.234C205.79 168.236 205.761 168.267 205.763 168.305C205.764 168.342 205.795 168.372 205.832 168.37Z"
          fill="white"
        />
        <path
          d="M211.255 179.926L211.44 179.818L211.411 179.734L211.223 179.768L211.255 179.926Z"
          fill="#B3B3B3"
        />
        <path
          d="M210.009 180.072L210.855 180.068L210.828 179.907L209.986 179.919L210.009 180.072Z"
          fill="#B3B3B3"
        />
        <path
          d="M209.968 179.754L209.986 179.916C209.986 179.916 210.211 180.014 210.828 179.907C210.828 179.907 211.438 179.983 211.564 180.076C211.564 180.076 212.305 180.289 213.092 179.966L213.068 179.81C213.068 179.81 212.808 179.965 211.944 180.005L210.942 179.752C210.942 179.752 210.754 179.724 210.513 179.748C210.513 179.748 210.072 179.803 209.968 179.754Z"
          fill="#CECECD"
        />
        <path
          d="M210.084 178.84C210.084 178.84 209.91 179.19 209.935 179.431L209.968 179.754C209.968 179.754 210.213 179.848 210.696 179.744C210.696 179.744 211.115 179.778 211.346 179.857C211.346 179.857 211.665 180.054 212.151 180.012C212.151 180.012 212.545 180.005 213.073 179.855C213.073 179.855 213.125 179.492 212.817 179.425C212.817 179.425 212.64 179.319 212.292 179.445L211.579 178.891C211.579 178.891 211.166 178.913 210.953 179.205L210.683 179.248C210.683 179.248 210.283 179.166 210.084 178.84Z"
          fill="#31455E"
        />
        <path
          d="M209.946 179.055L209.627 174.092C209.604 173.798 209.353 173.574 209.061 173.586L206.143 173.7L206.074 171.931L210.675 171.887C210.675 171.887 210.903 171.893 210.96 172.313L211.744 178.929C211.744 178.929 210.746 179.582 209.946 179.052L209.946 179.055Z"
          fill="#425975"
        />
        <path
          d="M205.42 179.613C205.42 179.613 206.052 179.969 206.73 179.695L206.415 172.307C206.415 172.307 206.125 171.084 204.88 171.632C204.88 171.632 204.286 171.564 203.944 172.445L205.423 179.613L205.42 179.613Z"
          fill="#575E6A"
        />
        <path
          d="M208.963 170.324L208.623 170.048C208.623 170.048 207.997 170.01 207.784 170.154C207.784 170.154 207.027 170.503 206.933 170.63C206.933 170.63 206.832 171.101 206.992 171.157C206.992 171.157 207.785 171.073 207.876 171.164C207.876 171.164 208.163 171.433 208.391 171.436C208.391 171.436 208.535 171.395 208.405 171.267L208.103 170.998C208.103 170.998 208.147 170.94 208.237 170.993C208.237 170.993 208.61 171.28 208.668 171.289C208.668 171.289 208.774 171.3 208.83 171.238C208.83 171.238 208.825 171.118 208.78 171.075L208.301 170.704C208.301 170.704 208.872 171.051 208.969 171.062C208.969 171.062 209.117 170.964 208.993 170.857L208.526 170.548C208.526 170.548 208.187 170.407 208.106 170.419C208.106 170.419 208.422 170.289 208.507 170.306C208.507 170.306 208.734 170.501 208.841 170.485C208.841 170.485 209.033 170.457 208.957 170.321L208.963 170.324Z"
          fill="#F8DAC9"
        />
        <path
          d="M202.681 165.954C202.681 165.954 202.187 166.301 202.574 167.541C202.574 167.541 203.209 170.433 203.764 170.843L207.071 171.162C207.071 171.162 206.808 170.795 207.01 170.515L204.678 169.729C204.678 169.729 204.37 166.939 202.681 165.954Z"
          fill="#C7DAEB"
        />
        <path
          d="M211.114 171.926L210.267 171.959L210.617 180.919L211.465 180.886L211.114 171.926Z"
          fill="#608599"
        />
        <path
          d="M204.272 172.193L203.425 172.226L203.775 181.186L204.622 181.153L204.272 172.193Z"
          fill="#608599"
        />
        <path
          d="M225.807 171.352L225.14 171.378L225.49 180.338L226.157 180.312L225.807 171.352Z"
          fill="#3F637F"
        />
        <path
          d="M231.993 170.419L202.326 171.578L202.358 172.392L232.025 171.233L231.993 170.419Z"
          fill="#608599"
        />
        <path
          d="M217.315 170.251L217.195 171.278L221.261 171.119L221.138 170.126L221.35 166.881L220.972 164.914L220.674 164.817L218.148 164.676L216.955 165.071L217.232 168.111L217.315 170.251Z"
          fill="#535C69"
        />
        <path
          d="M218.148 164.676L217.868 165.502L218.392 165.555L218.078 166.247L219.935 168.985L220.008 168.392L220.812 166.04L220.503 165.585L220.795 165.382L220.314 164.647L218.873 164.344L218.148 164.676Z"
          fill="#4A607C"
        />
        <path
          d="M219.957 165.875L218.901 165.512L218.51 165.214L218.579 165.037L218.851 164.371L218.879 163.54L220.693 163.821L220.305 164.421L220.362 165.278L220.482 165.663L219.957 165.875Z"
          fill="#A58C83"
        />
        <path
          d="M220.808 164.359L219.237 164.099C218.976 163.705 218.799 163.363 218.686 163.069C218.778 161.084 219.522 161.256 219.522 161.256C219.522 161.256 221.064 160.915 221.105 161.956C221.12 162.357 221.128 162.566 221.069 162.831L220.808 164.359Z"
          fill="#BFA69B"
        />
        <path
          d="M221.095 162.092L220.608 161.928L220.313 161.919L220.02 162.117L220.122 162.866L219.775 162.947C219.775 162.947 219.732 162.284 219.375 162.644C219.229 162.791 219.274 162.967 219.358 163.099L219.149 163.27L218.838 163.979L218.293 163.105L218.47 162.26L218.812 161.361L219.277 161.088L221.051 161.261L221.27 161.796L221.098 162.098L221.095 162.092Z"
          fill="#535C69"
        />
        <path
          d="M220.325 164.712L220.156 165.067L219.822 165.426L219.119 165.04L218.797 164.497L218.51 165.202L218.479 166.057L219.852 167.976L220.64 166.043L220.502 165.585L220.353 165.275L220.421 164.909L220.325 164.712Z"
          fill="white"
        />
        <path
          d="M219.464 165.673L219.572 165.884L219.979 165.851L220.058 165.641L219.822 165.426L219.464 165.673Z"
          fill="#BA8F93"
        />
        <path
          d="M220.11 166.584L219.858 168.12L219.369 166.802L219.526 165.98L220.015 165.947L220.11 166.584Z"
          fill="#BA8F93"
        />
        <path
          d="M224.379 169.751L224.111 170.21L223.604 170.75L222.99 170.927L222.688 170.747L222.714 170.657L223.032 170.672L223.233 170.67L222.85 170.481L223.154 169.834L223.81 169.599L224.379 169.751Z"
          fill="#F8E2D2"
        />
        <path
          d="M219.512 170.475L219.907 170.493L220.619 170.878L221.231 170.934L221.46 170.671L221.404 170.596L221.118 170.596L221.441 170.182L221.03 169.669L220.131 169.666L219.632 169.815L219.512 170.475Z"
          fill="#BFA69B"
        />
        <path
          d="M219.651 169.634L219.861 169.694L219.573 170.464L219.363 170.404L219.651 169.634Z"
          fill="white"
        />
        <path
          d="M223.663 170.325L223.515 170.476L222.898 169.924L223.049 169.688L223.663 170.325Z"
          fill="white"
        />
        <path
          d="M217.945 166.196C216.977 164.725 216.969 164.885 216.761 165.545L215.565 169.13L215.812 170.31L219.337 170.615L219.759 169.545L217.079 169.121L217.808 167.117C217.783 167.141 217.969 166.231 217.945 166.196Z"
          fill="#535C69"
        />
        <path
          d="M220.67 166.816L220.662 166.595L220.972 164.914L223.568 167.29L223.728 167.65L223.665 170.594L222.906 169.912L222.58 167.996L220.857 166.735L220.67 166.816Z"
          fill="#535C69"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M228.805 166.566L228.915 166.694L222.552 170.788L222.46 170.673L223.648 166.939L228.805 166.566Z"
          fill="#49768E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M228.915 166.694L227.705 167.061L223.755 167.067L223.648 166.939L228.805 166.566L228.915 166.694Z"
          fill="#87A8B2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M222.552 170.788L220.161 170.878L220.155 170.734L222.593 170.635L222.552 170.788Z"
          fill="#49768E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M222.303 170.762L222.07 170.768L222.068 170.7L222.301 170.691L222.303 170.762Z"
          fill="#535C69"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M221.998 170.774L221.767 170.78L221.765 170.715L221.998 170.706L221.998 170.774Z"
          fill="#535C69"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M228.915 166.695L227.527 170.582L222.552 170.788L223.755 167.067L228.915 166.695Z"
          fill="#718E99"
        />
        <path
          d="M231.993 170.419L209.946 171.28L209.977 172.094L232.025 171.233L231.993 170.419Z"
          fill="#516F87"
        />
        <path
          d="M215.025 170.462L218.878 170.311C219.079 170.304 219.162 170.176 219.156 170.029C219.15 169.879 219.055 169.761 218.857 169.769L215.004 169.919L215 169.982L215.134 169.976L215.169 170.114L215.29 170.077L215.156 170.386L215.028 170.391L215.031 170.465L215.025 170.462Z"
          fill="#AFC9D9"
        />
        <path
          d="M215.147 170.386L217.038 170.312C217.134 170.309 217.209 170.214 217.204 170.099C217.2 169.987 217.118 169.896 217.022 169.908L215.131 169.982L215.147 170.386Z"
          fill="white"
        />
        <path
          d="M217.289 170.096C217.295 170.246 217.221 170.373 217.125 170.377L218.928 170.306C219.093 170.282 219.164 170.164 219.159 170.029C219.153 169.881 219.061 169.764 218.866 169.769L217.104 169.837C217.199 169.825 217.283 169.946 217.289 170.096Z"
          fill="#97B2C2"
        />
        <path
          d="M219.553 169.511C219.558 169.638 219.46 169.748 219.332 169.753L215.857 169.889L215.822 168.99L219.297 168.854C219.422 168.849 219.531 168.948 219.536 169.078L219.553 169.514L219.553 169.511Z"
          fill="#B7D1DD"
        />
        <path
          d="M219.254 168.956L217.44 169.027C217.345 169.031 217.271 169.112 217.275 169.208L217.287 169.538C217.291 169.634 217.371 169.709 217.466 169.705L219.281 169.634C219.376 169.63 219.45 169.55 219.446 169.454L219.433 169.123C219.429 169.027 219.349 168.952 219.254 168.956Z"
          fill="#7DA1B2"
        />
        <path
          d="M215.814 169.09L219.062 168.964C219.179 168.959 219.278 169.053 219.283 169.17L219.294 169.456C219.298 169.554 219.223 169.639 219.124 169.643L215.838 169.772L215.811 169.094L215.814 169.09Z"
          fill="white"
        />
        <path
          d="M217.195 169.037L219.135 168.961C219.214 168.958 219.277 169.02 219.28 169.097L219.295 169.474C219.298 169.563 219.231 169.636 219.144 169.64L217.219 169.715L217.192 169.037L217.195 169.037Z"
          fill="#EEFEFF"
        />
        <path
          d="M217.118 168.936L215.711 168.991L215.715 169.094L217.122 169.039L217.118 168.936Z"
          fill="#D6EFF7"
        />
        <path
          d="M217.149 169.717L215.742 169.772L215.746 169.887L217.153 169.832L217.149 169.717Z"
          fill="#D6EFF7"
        />
        <path
          d="M219.644 170.94L215.674 171.095C215.604 171.098 215.546 171.044 215.544 170.973L215.527 170.554C215.525 170.49 215.575 170.434 215.639 170.432L219.618 170.277L219.644 170.94Z"
          fill="#839AA8"
        />
        <path
          d="M215.712 170.509L217.343 170.445L217.363 170.946L215.755 171.009C215.697 171.011 215.645 170.963 215.643 170.904L215.631 170.598C215.629 170.551 215.666 170.514 215.709 170.512L215.712 170.509Z"
          fill="#394852"
        />
        <path
          d="M215.907 170.501L217.39 170.443L217.41 170.945L215.927 171.002C215.848 171.006 215.782 170.943 215.779 170.864L215.77 170.654C215.767 170.575 215.829 170.507 215.907 170.504L215.907 170.501Z"
          fill="white"
        />
        <path
          d="M219.645 170.355L217.343 170.445L217.363 170.946L219.664 170.856L219.645 170.355Z"
          fill="#EEFEFF"
        />
        <path
          d="M219.772 170.27L217.5 170.359L217.504 170.442L219.776 170.353L219.772 170.27Z"
          fill="#5A6D78"
        />
        <path
          d="M219.795 170.851L217.523 170.94L217.526 171.02L219.798 170.931L219.795 170.851Z"
          fill="#5A6D78"
        />
        <path
          d="M207.776 171.368L213.951 171.127L213.936 170.747L207.761 170.988L207.776 171.368Z"
          fill="#718E99"
        />
        <path
          d="M207.169 171.371L208.99 171.3L208.975 170.92L207.154 170.991L207.169 171.371Z"
          fill="#49768E"
        />
        <path
          d="M208.696 170.361L216.159 170.069L215.954 164.836L208.492 165.127L208.696 170.361Z"
          fill="#C4E2E1"
        />
        <path
          d="M208.895 170.362L216.357 170.07L216.152 164.828L208.69 165.119L208.895 170.362Z"
          fill="#718E99"
        />
        <path
          d="M212.563 168.237C212.841 168.226 213.056 167.936 213.043 167.589C213.029 167.243 212.792 166.97 212.514 166.981C212.236 166.992 212.021 167.282 212.035 167.629C212.048 167.976 212.285 168.248 212.563 168.237Z"
          fill="white"
        />
        <path
          d="M211.968 171.071L213.541 171.01L213.446 168.572L211.873 168.633L211.968 171.071Z"
          fill="#49768E"
        />
        <path
          d="M211.17 171.244L214.149 171.128L214.138 170.842L211.158 170.958L211.17 171.244Z"
          fill="#49768E"
        />
      </g>
      <path
        d="M241.437 143.122L239.058 141.215L235.761 138.701C235.761 138.701 233.628 137.155 233.477 139.347C233.338 141.354 236.55 142.397 236.522 142.358L235.315 142.296L232.377 140.902L231.532 143.188L232.436 144.851L231.168 145.459L231.645 147.165L231.072 147.736L231.656 149.432L231.206 150.34C231.206 150.34 232.726 151.899 233.204 152.153C233.682 152.406 242.235 152.526 242.235 152.526L242.271 150.005L243.514 146.337L242.094 145.403L241.437 143.12V143.122Z"
        fill="#F8CDAE"
      />
      <path
        d="M235.241 142.288C235.241 142.288 237.629 143.708 237.456 144.019C237.283 144.331 237.456 145.542 236.799 145.819C236.143 146.096 234.55 145.646 234.55 145.646C234.55 145.646 236.624 146.344 236.765 146.753C236.946 147.288 236.413 148.24 236.247 148.173L234.377 147.967C234.377 147.967 236.072 148.417 236.143 148.589C236.211 148.762 236.349 149.905 236.247 150.044C235.769 150.681 233.893 149.939 233.997 150.009C234.102 150.078 235.209 150.875 235.209 150.875L235.174 151.982C235.174 151.982 233.236 152.293 233.443 152.225C233.65 152.157 237.735 152.538 237.701 152.436C237.667 152.334 236.94 149.941 236.94 149.768C236.94 149.596 239.377 148.628 239.122 148.523C237.079 147.691 237.494 143.99 237.494 143.99L236.526 142.365C236.526 142.365 235.36 142.247 235.245 142.292L235.241 142.288Z"
        fill="#EEB18D"
      />
      <path
        d="M237.074 144.158L236.831 145.508C236.831 145.508 235.725 145.576 235.343 145.058C234.961 144.54 235.586 143.776 235.586 143.776C235.586 143.776 236.625 143.708 237.074 144.158Z"
        fill="#FFDAC5"
      />
      <path
        d="M236.313 146.997L236.174 147.897C236.174 147.897 235.343 147.758 235.136 147.203C234.929 146.649 235.586 146.581 235.586 146.581L236.313 146.997Z"
        fill="#FFDAC5"
      />
      <path
        d="M235.863 148.969C235.897 149.176 235.759 150.007 235.759 150.007C235.759 150.007 234.997 150.041 234.788 149.419C234.582 148.796 235.411 148.692 235.411 148.692L235.861 148.969H235.863Z"
        fill="#FFDAC5"
      />
      <path
        d="M234.895 150.941C234.861 151.114 234.584 151.807 234.584 151.807C234.584 151.807 233.718 151.98 233.545 151.289C233.373 150.596 234.895 150.944 234.895 150.944V150.941Z"
        fill="#FCD3BB"
      />
      <path
        d="M234.793 157.29C234.786 157.39 234.226 157.494 234.211 157.599C234.144 158.064 234.078 158.512 233.761 158.857C232.43 160.305 230.342 159.185 230.342 157.603C230.342 157.194 230.47 156.812 230.688 156.499C230.854 156.26 230.811 155.931 230.613 155.718C230.575 155.678 230.536 155.637 230.498 155.594C230.133 155.204 229.483 155.236 229.193 155.684C228.715 156.426 228.498 157.354 228.673 158.335C228.952 159.9 230.274 161.124 231.852 161.301C234.072 161.55 235.88 159.806 235.88 157.646C235.88 157.136 235.831 156.669 235.644 156.23L234.795 157.277C234.795 157.277 234.791 157.283 234.791 157.288L234.793 157.29Z"
        fill="#264153"
      />
      <path
        d="M235.882 157.761L234.215 158.371V130.875H235.882V157.761Z"
        fill="#264153"
      />
      <path
        d="M244.813 145.668L242.491 145.337L241.793 152.763L245.527 153.362L244.813 145.668Z"
        fill="#FDFBFC"
      />
      <path
        d="M245.144 146.604L247.11 153.91L243.514 153.042L244.03 145.559L245.171 145.721C245.203 145.86 245.105 146.346 245.144 146.606V146.604Z"
        fill="#E2DCDF"
      />
      <path
        d="M300 153.09L244 155L245.032 144.048L300 141V153.09Z"
        fill="#27AE60"
      />
      <path
        d="M233.588 152.219C234.021 152.166 235.17 151.98 235.17 151.98L235.204 150.873C235.204 150.873 234.098 150.078 233.993 150.008C233.889 149.939 235.765 150.679 236.243 150.042C236.347 149.903 236.209 148.76 236.138 148.587C236.07 148.415 234.373 147.965 234.373 147.965L236.243 148.172C236.409 148.238 236.944 147.289 236.761 146.751C236.62 146.34 234.545 145.645 234.545 145.645C234.545 145.645 236.138 146.095 236.795 145.817C237.452 145.54 237.279 144.329 237.452 144.018C237.625 143.706 235.236 142.286 235.236 142.286C235.243 142.284 235.253 142.28 235.268 142.275L232.372 140.902L231.528 143.188L232.432 144.851L231.163 145.459L231.641 147.165L231.067 147.737L231.652 149.432L231.202 150.34C231.202 150.34 232.722 151.899 233.2 152.153C233.243 152.176 233.33 152.198 233.451 152.217C233.477 152.212 233.522 152.212 233.584 152.217L233.588 152.219Z"
        fill="#F8CDAE"
      />
      <path
        d="M233.441 152.223C233.405 152.236 233.434 152.236 233.507 152.227C233.49 152.225 233.473 152.221 233.456 152.219C233.449 152.219 233.443 152.219 233.439 152.221L233.441 152.223Z"
        fill="#EEB18D"
      />
      <path
        d="M233.458 152.219C233.475 152.221 233.492 152.225 233.509 152.227C233.532 152.225 233.56 152.221 233.59 152.219C233.528 152.217 233.483 152.219 233.458 152.219Z"
        fill="#EEB18D"
      />
      <path
        d="M237.074 144.158L236.831 145.508C236.831 145.508 235.725 145.576 235.343 145.058C234.961 144.54 235.586 143.776 235.586 143.776C235.586 143.776 236.625 143.708 237.074 144.158Z"
        fill="#FFE4D7"
      />
      <path
        d="M236.313 146.997L236.174 147.897C236.174 147.897 235.343 147.758 235.136 147.203C234.929 146.649 235.586 146.581 235.586 146.581L236.313 146.997Z"
        fill="#FFE4D7"
      />
      <path
        d="M235.863 148.969C235.897 149.176 235.759 150.007 235.759 150.007C235.759 150.007 234.997 150.041 234.788 149.419C234.582 148.796 235.411 148.692 235.411 148.692L235.861 148.969H235.863Z"
        fill="#FFE4D7"
      />
      <path
        d="M234.895 150.941C234.861 151.114 234.584 151.807 234.584 151.807C234.584 151.807 233.718 151.98 233.545 151.289C233.373 150.596 234.895 150.943 234.895 150.943V150.941Z"
        fill="#FFE4D7"
      />
      <path
        d="M236.797 145.819C236.868 145.789 236.927 145.749 236.978 145.702C235.179 145.487 232.496 143.93 231.618 143.35L232.436 144.853L232.43 144.857L234.72 145.766L235.061 145.834C234.763 145.721 234.548 145.649 234.548 145.649C234.548 145.649 236.14 146.099 236.797 145.821V145.819Z"
        fill="#EEB18D"
      />
      <path
        d="M234.375 147.964L236.049 148.15C234.667 147.653 231.598 145.787 231.189 145.536L231.643 147.163L234.443 148.001C234.443 148.001 234.498 148.009 234.592 148.024C234.458 147.988 234.373 147.964 234.373 147.964H234.375Z"
        fill="#EEB18D"
      />
      <path
        d="M234.136 150.108C234.063 150.056 234.012 150.02 233.993 150.007C233.923 149.96 234.75 150.28 235.445 150.302C233.102 149.474 231.784 148.566 231.189 148.08L231.639 149.387L234.006 150.056L234.136 150.108Z"
        fill="#EEB18D"
      />
      <path
        d="M231.268 150.406C231.558 150.7 232.784 151.931 233.204 152.155C233.247 152.178 233.334 152.199 233.456 152.219C233.481 152.214 233.526 152.214 233.588 152.219C233.925 152.178 234.697 152.057 235.021 152.005C233.432 151.698 231.816 150.745 231.268 150.406Z"
        fill="#EEB18D"
      />
      <path
        d="M235.927 134.996H234.105V139.323H235.927V134.996Z"
        fill="#330F00"
      />
      <path
        d="M235.164 113.633C234.936 113.633 234.749 113.381 234.749 113.075V107.499C234.749 107.193 234.936 107 235.164 107C235.391 107 235.578 107.193 235.578 107.499V113.075C235.578 113.381 235.391 113.633 235.164 113.633Z"
        fill="#533526"
      />
      <path
        d="M235.234 110.701H235.031C234.556 110.701 234.171 111.086 234.171 111.561V116.531C234.171 117.006 234.556 117.391 235.031 117.391H235.234C235.709 117.391 236.094 117.006 236.094 116.531V111.561C236.094 111.086 235.709 110.701 235.234 110.701Z"
        fill="#533526"
      />
      <path
        d="M269.67 137.878C266.379 123.067 252.235 111.932 235.284 111.932C218.334 111.932 204.466 122.852 201 137.447C203.491 136.356 206.447 135.979 209.512 136.535C212.832 137.137 215.728 138.734 217.852 140.9C222.995 138.897 228.881 137.759 235.133 137.759C241.386 137.759 247.282 138.899 252.429 140.906C254.537 138.824 257.37 137.294 260.604 136.706C263.901 136.108 267.068 136.589 269.67 137.876V137.878Z"
        fill="#00A317"
      />
      <path
        d="M234.376 111.946C225.605 113.49 217.679 126.059 217.852 140.902C222.609 139.044 229.425 137.761 235.144 137.761C240.862 137.761 247.53 138.901 252.431 140.908C252.676 139.138 252.225 137.416 252.082 135.179C251.088 121.503 244.386 113.961 236.442 111.934C235.25 111.809 236.517 111.934 235.291 111.934C234.986 111.934 234.682 111.94 234.378 111.948L234.376 111.946Z"
        fill="#3ED153"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M844.99 284.68C844.99 284.68 832.02 267.02 797.65 265.57C797.65 265.57 783.2 293.15 790.52 323.99L783.21 323.3C783.21 323.3 786.06 285.99 795.6 262.3C795.6 262.3 820.51 264.48 848.87 276.43C848.87 276.43 848.87 284.2 844.99 284.68Z"
        fill="url(#paint12_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M847.98 279.93C847.98 281.58 847.11 282.91 846.04 282.91C844.97 282.91 844.1 281.57 844.1 279.93C844.1 278.29 844.97 276.95 846.04 276.95C847.11 276.95 847.98 278.29 847.98 279.93Z"
        fill="url(#paint13_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M788.64 320.33C788.64 321.98 787.77 323.31 786.7 323.31C785.63 323.31 784.76 321.97 784.76 320.33C784.76 318.69 785.63 317.35 786.7 317.35C787.77 317.35 788.64 318.69 788.64 320.33Z"
        fill="url(#paint14_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M795.59 262.31H790.27C790.27 262.31 779.86 294.84 780.96 323.31H783.2C783.2 323.31 787.12 285.7 795.59 262.31Z"
        fill="url(#paint15_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M797.21 266.74C797.21 266.74 826.13 266.61 844.99 284.69C844.99 284.69 833.69 267.35 797.73 265.1L797.21 266.75V266.74Z"
        fill="#5A3361"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M832.07 353.52L810.11 366.95C810.11 366.95 808.49 370.27 808.12 373.97H810.09C810.09 373.97 811.35 370.97 812.04 370.07C813.57 368.1 833.37 363.08 833.37 363.08L835.83 353.51H832.07V353.52Z"
        fill="#180B1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M831.19 353.52L809.23 366.95C809.23 366.95 807.61 370.27 807.24 373.97H809.21C809.21 373.97 810.47 370.97 811.16 370.07C812.69 368.1 832.49 363.08 832.49 363.08L832.82 361.36L831.19 353.5V353.52Z"
        fill="url(#paint16_radial_2072_10275)"
      />
      <path
        d="M813.773 377.896C814.394 374.069 811.795 370.463 807.968 369.841C804.141 369.22 800.535 371.819 799.914 375.646C799.293 379.473 801.892 383.079 805.719 383.7C809.546 384.321 813.152 381.722 813.773 377.896Z"
        fill="url(#paint17_radial_2072_10275)"
      />
      <path
        d="M804.38 382.2C806.622 382.2 808.44 379.76 808.44 376.75C808.44 373.74 806.622 371.3 804.38 371.3C802.138 371.3 800.32 373.74 800.32 376.75C800.32 379.76 802.138 382.2 804.38 382.2Z"
        fill="url(#paint18_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M863.29 186.82C863.29 186.82 842.45 262.14 826.68 321.38L887.4 315.52C887.4 315.52 912.39 253.24 918.74 181.84C918.74 181.84 896.14 177.26 863.29 186.83V186.82Z"
        fill="url(#paint19_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M758.95 323.65C758.95 323.65 825.17 330.85 891.38 325.86C891.38 325.86 853.17 321.42 822 322.24L758.94 323.65H758.95Z"
        fill="url(#paint20_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M822 318.2C822 318.2 862.75 316.8 887.39 315.52C887.39 315.52 906.49 253.6 918.82 180.98H922.67C922.67 180.98 911.16 265.27 891.37 325.87C891.37 325.87 872.51 327.9 821.99 322.25V318.21L822 318.2Z"
        fill="url(#paint21_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M822 318.2H758.95V323.65L822 322.24V318.2Z"
        fill="url(#paint22_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M922.68 180.97C922.68 180.97 902.2 175.47 860.46 185.7C860.46 185.7 886.13 177.69 918.74 181.83L922.68 180.97Z"
        fill="url(#paint23_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M758.95 318.2C758.95 318.2 757.99 309.81 761.24 306.98C761.24 306.98 826.68 302.25 883.17 311.74L887.06 315.58L822.89 318.17L758.95 318.2Z"
        fill="url(#paint24_radial_2072_10275)"
      />
      <g style={{ mixBlendMode: 'screen' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M822 318.2L824.8 310.34L761.24 306.98C761.24 306.98 757.82 309.63 758.95 318.2H822.01H822Z"
          fill="#41243F"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M761.24 306.97L818.94 310.49C818.94 310.49 857.92 309.1 883.17 311.73C883.17 311.73 832.98 302.12 761.24 306.97Z"
        fill="#714A6A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M883.17 311.74C883.17 311.74 902.88 252.5 907.73 228.53C907.73 228.53 898.67 192.94 913.3 180.98L918.75 181.84C918.75 181.84 902.13 274.71 887.07 315.58L883.18 311.74H883.17Z"
        fill="#180B1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M913.29 180.97C913.29 180.97 886.71 177.35 860.46 185.7C860.46 185.7 847.52 205.38 851.56 228.6L830.6 306.3C830.6 306.3 864.99 308.22 883.17 311.72C883.17 311.72 903.96 250.06 907.73 228.51C907.73 228.51 902.17 201.54 913.3 180.96L913.29 180.97Z"
        fill="url(#paint25_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M817.39 327.09H854.26C854.26 327.09 845.44 332.68 834.8 332.68C824.16 332.68 817.39 327.09 817.39 327.09Z"
        fill="#180B1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M830.65 332.39L831.7 350.7H838.49L839.17 332.35L830.65 332.39Z"
        fill="url(#paint26_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M829.85 343.51H839.97L838.96 362.68H831.05L829.85 343.51Z"
        fill="url(#paint27_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M830.65 353.09L781.29 366.52C781.29 366.52 777.65 369.84 776.81 373.54H781.23C781.23 373.54 784.06 370.54 785.62 369.64C789.05 367.67 833.56 362.65 833.56 362.65L834.29 360.93L830.64 353.07L830.65 353.09Z"
        fill="url(#paint28_radial_2072_10275)"
      />
      <path
        d="M781.25 382.69C785.127 382.69 788.27 379.547 788.27 375.67C788.27 371.793 785.127 368.65 781.25 368.65C777.373 368.65 774.23 371.793 774.23 375.67C774.23 379.547 777.373 382.69 781.25 382.69Z"
        fill="url(#paint29_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M787.35 376.32C787.35 379.33 785.53 381.77 783.29 381.77C781.05 381.77 779.23 379.33 779.23 376.32C779.23 373.31 781.05 370.87 783.29 370.87C785.53 370.87 787.35 373.31 787.35 376.32Z"
        fill="url(#paint30_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M839.48 353.09L888.84 366.52C888.84 366.52 892.48 369.84 893.32 373.54H888.9C888.9 373.54 886.07 370.54 884.51 369.64C881.08 367.67 836.57 362.65 836.57 362.65L835.84 360.93L839.49 353.07L839.48 353.09Z"
        fill="url(#paint31_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M839.08 353.09L861.04 366.52C861.04 366.52 862.66 369.84 863.03 373.54H861.06C861.06 373.54 859.8 370.54 859.11 369.64C857.58 367.67 837.78 362.65 837.78 362.65L835.32 353.08H839.08V353.09Z"
        fill="#714A6A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M835.32 353.09L857.28 366.52C857.28 366.52 858.9 369.84 859.27 373.54H857.3C857.3 373.54 856.04 370.54 855.35 369.64C853.82 367.67 834.02 362.65 834.02 362.65L833.69 360.93L835.32 353.07V353.09Z"
        fill="url(#paint32_radial_2072_10275)"
      />
      <path
        d="M888.89 382.69C892.767 382.69 895.91 379.547 895.91 375.67C895.91 371.793 892.767 368.65 888.89 368.65C885.013 368.65 881.87 371.793 881.87 375.67C881.87 379.547 885.013 382.69 888.89 382.69Z"
        fill="url(#paint33_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M882.78 376.32C882.78 379.33 884.6 381.77 886.84 381.77C889.08 381.77 890.9 379.33 890.9 376.32C890.9 373.31 889.08 370.87 886.84 370.87C884.6 370.87 882.78 373.31 882.78 376.32Z"
        fill="url(#paint34_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M861.04 366.53H857.28C857.28 366.53 858.93 369.95 859.27 373.55H863.03C863.03 373.55 862.58 369.01 861.04 366.53Z"
        fill="#482F54"
      />
      <path
        d="M859.7 383.34C863.577 383.34 866.72 380.197 866.72 376.32C866.72 372.443 863.577 369.3 859.7 369.3C855.823 369.3 852.68 372.443 852.68 376.32C852.68 380.197 855.823 383.34 859.7 383.34Z"
        fill="url(#paint35_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M853.6 376.97C853.6 379.98 855.42 382.42 857.66 382.42C859.9 382.42 861.72 379.98 861.72 376.97C861.72 373.96 859.9 371.52 857.66 371.52C855.42 371.52 853.6 373.96 853.6 376.97Z"
        fill="url(#paint36_radial_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M859.11 193.02C859.11 193.02 864.5 185.79 877.25 184.43C894.42 182.6 908.15 187.86 908.15 187.86C908.15 187.86 909.5 183.12 913.29 180.97C913.29 180.97 885.31 179.49 861.6 185.7C861.6 185.7 858.37 188.02 859.1 193.01L859.11 193.02Z"
        fill="url(#paint37_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M853.17 228.53L906.76 227.21C906.76 227.21 897.07 228.47 885.33 229.88C871.89 231.49 853.17 228.53 853.17 228.53Z"
        fill="#26132A"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M861.45 230.36C860.03 230.66 864.81 233.73 873.95 234.46C883.09 235.19 889.95 230.21 889.35 230.36C888.75 230.52 884.59 231.72 875.3 231.48C865.99 231.24 861.66 230.32 861.45 230.36Z"
        fill="url(#paint38_radial_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M857.5 230.36C853.18 229.67 850.4 241.73 850.73 242.94C851.05 244.15 852.67 238.19 854.84 237.13C859.11 235.04 859.53 230.69 857.5 230.37V230.36Z"
        fill="url(#paint39_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.55"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M854.14 212.21C854.14 212.21 852.74 200.76 857.42 195.44C859.97 198.75 854.92 203.83 854.14 212.21Z"
        fill="url(#paint40_linear_2072_10275)"
      />
      <path
        d="M856.26 218.67C856.26 218.67 850.06 210.5 845.06 206.5C840.54 202.88 832.62 202.94 833.06 202.5C833.06 202.5 846.06 185.5 859.41 187.34L860.84 177.29C860.84 177.29 834.6 181.94 816.05 200.5C811.05 205.5 850.51 235.95 850.51 235.95L856.25 218.67H856.26Z"
        fill="#9B9B9B"
      />
      <path
        d="M873.68 214.74C873.68 214.74 897.68 218.18 892.73 232.69C888.96 237.12 888.3 239.16 887.89 241.55C887.48 243.94 878.67 295.39 855.64 303.36L836.02 277.89C836.02 277.89 821.82 271.68 840.32 233.12C842.11 229.38 843.55 224.59 849.07 218.94C854.23 213.66 860.66 209.91 873.68 214.73V214.74Z"
        fill="#00A504"
      />
      <path
        d="M883.06 242.5C907.74 242.2 927.06 220.27 927.06 220.27C931.56 215.77 913.68 195.15 905.33 188.56L899.43 198.23C905.51 204.39 911.05 210.5 913.05 216.5C914.35 220.41 909.05 216.5 903.05 219.5C898.58 221.74 894.31 224.81 889.25 220.41C887.05 218.5 883.62 219.12 881.09 220.5C869.2 227.05 876.39 242.63 883.05 242.5H883.06Z"
        fill="#9B9B9B"
      />
      <path
        d="M899.95 185.75C899.95 185.75 896.06 180.6 889.3 176.76C882.53 172.92 879.55 171.99 878.71 173.42C877.87 174.85 886.36 176.59 885.2 178.44C884.51 179.53 876.92 173.48 875.66 175.3C874.12 177.51 884.56 180.17 883.7 181.79C882.87 183.36 875.03 176.62 874.07 178.4C872.59 181.17 883.46 183.6 882.04 185.24C881.29 186.1 874.29 180.55 873.56 181.91C872.57 183.74 877.17 186.25 883.7 189.2C885.68 190.1 885.55 190.79 884.88 191.18C883.08 192.23 880.5 193.93 880.94 195.36C881.61 197.55 888.4 191.35 895.05 193.06C901.71 194.77 901.73 187.26 899.96 185.76L899.95 185.75Z"
        fill="#FCBA7E"
      />
      <path
        d="M894.19 193.83C896.27 195.29 898.39 197 899.82 198.45L905.6 188.98C902.44 186.47 899.78 184.68 899.78 184.68L894.18 193.84L894.19 193.83Z"
        fill="#DBF5FF"
      />
      <path
        d="M879.86 188.18C880.28 187.67 880.89 187.29 881.6 187.2C882.31 187.11 883.09 187.39 883.63 187.93C884.18 188.47 884.49 189.2 884.62 189.93C884.75 190.67 884.69 191.42 884.5 192.12C884.13 193.52 883.12 194.82 881.68 195.27C881.32 195.37 880.94 195.42 880.57 195.37C880.2 195.31 879.84 195.19 879.54 194.99C878.93 194.58 878.56 193.92 878.46 193.27C878.82 193.82 879.29 194.26 879.82 194.43C880.35 194.61 880.89 194.56 881.36 194.33C882.32 193.88 883.01 192.86 883.33 191.78C883.65 190.7 883.57 189.46 882.94 188.6C882.62 188.19 882.16 187.88 881.6 187.81C881.04 187.73 880.43 187.89 879.86 188.19V188.18Z"
        fill="#D49C6A"
      />
      <path
        d="M860.76 178.68C860.68 179.24 860.57 179.8 860.4 180.35C860.36 180.49 860.31 180.62 860.26 180.77C860.2 180.92 860.13 181.04 860.07 181.17C859.94 181.43 859.78 181.68 859.59 181.93C859.4 182.17 859.18 182.4 858.92 182.59C858.78 182.68 858.66 182.76 858.51 182.84C858.35 182.92 858.19 182.97 858.03 183.02C857.87 183.06 857.71 183.09 857.55 183.1C857.39 183.11 857.22 183.1 857.1 183.1C856.83 183.1 856.62 183.11 856.47 183.16H856.43C856.31 183.2 856.2 183.25 856.1 183.3C855.99 183.36 855.9 183.43 855.83 183.51C855.76 183.59 855.71 183.67 855.69 183.73C855.68 183.76 855.67 183.81 855.66 183.84C855.66 183.87 855.66 183.91 855.66 183.95C855.68 184.03 855.71 184.13 855.77 184.24C855.83 184.35 855.91 184.45 856 184.55C856.05 184.6 856.09 184.65 856.15 184.7C856.21 184.75 856.28 184.81 856.34 184.86C856.46 184.96 856.59 185.07 856.72 185.17C856.99 185.37 857.26 185.57 857.54 185.76L857.75 185.9L857.96 186.03C858.1 186.12 858.24 186.2 858.39 186.28C858.54 186.36 858.68 186.43 858.82 186.49C858.97 186.54 859.12 186.59 859.27 186.61C859.31 186.61 859.35 186.61 859.39 186.61C859.43 186.61 859.46 186.61 859.5 186.61C859.57 186.61 859.64 186.58 859.72 186.55C859.86 186.49 860 186.37 860.1 186.23C860.06 186.41 859.97 186.58 859.84 186.73C859.77 186.8 859.69 186.86 859.59 186.91C859.54 186.93 859.49 186.95 859.44 186.97C859.39 186.98 859.35 187 859.3 187.01C858.92 187.09 858.52 187.02 858.17 186.93C857.99 186.88 857.82 186.83 857.64 186.76C857.55 186.73 857.47 186.69 857.38 186.66L857.14 186.55C856.82 186.4 856.5 186.24 856.18 186.05C856.02 185.96 855.87 185.86 855.71 185.75C855.63 185.69 855.56 185.64 855.49 185.59C855.41 185.53 855.33 185.46 855.25 185.39C855.09 185.24 854.95 185.08 854.82 184.88C854.7 184.68 854.59 184.46 854.54 184.19C854.52 184.05 854.5 183.91 854.52 183.77C854.53 183.62 854.56 183.5 854.6 183.36C854.69 183.09 854.84 182.87 855.01 182.7C855.35 182.35 855.77 182.15 856.21 182.06H856.17C856.35 182.02 856.53 182 856.7 181.99C856.87 181.99 857.02 181.99 857.16 182.01C857.31 182.02 857.41 182.03 857.52 182.03C857.63 182.03 857.74 182.03 857.84 182.01C857.94 181.99 858.04 181.97 858.14 181.94C858.23 181.91 858.35 181.85 858.45 181.8C858.65 181.69 858.84 181.55 859.02 181.38C859.2 181.21 859.37 181.02 859.54 180.81C859.62 180.71 859.71 180.6 859.77 180.5C859.84 180.4 859.91 180.28 859.98 180.16C860.25 179.69 860.51 179.19 860.78 178.7L860.76 178.68Z"
        fill="#D49C6A"
      />
      <path
        d="M855.09 183.68C854.97 184.2 855.32 184.77 855.83 185.16C856.33 185.57 856.96 185.95 857.55 186.28C857.85 186.44 858.16 186.58 858.46 186.68C858.78 186.79 859.1 186.84 859.4 186.8C859.7 186.76 859.95 186.55 860.09 186.24C860.25 185.94 860.29 185.58 860.34 185.22L860.77 178.68C860.77 178.68 860.31 180.09 859.97 180.71C859.6 181.34 859.14 181.97 858.43 182.33C858.08 182.51 857.66 182.58 857.25 182.56C856.92 182.55 856.62 182.53 856.32 182.62C855.73 182.74 855.2 183.17 855.1 183.69L855.09 183.68Z"
        fill="#FCBA7E"
      />
      <path
        d="M860.2 188.35C859.09 187.55 857.81 186.91 856.46 186.93C855.11 186.96 853.71 187.83 853.39 189.18C855.81 190.99 859.85 192.5 864.21 192.5C863.36 190.61 861.8 189.49 860.2 188.34V188.35Z"
        fill="#534741"
      />
      <path
        d="M865.83 182.79C865.36 184.16 864.36 185.04 863.59 184.76C862.82 184.48 862.56 183.15 863.03 181.78C863.5 180.41 864.5 179.53 865.27 179.81C866.04 180.09 866.3 181.42 865.83 182.79Z"
        fill="#333333"
      />
      <path
        d="M865.14 181.18C865.08 181.57 864.73 181.83 864.35 181.77C863.97 181.71 863.72 181.35 863.77 180.96C863.83 180.57 864.18 180.31 864.56 180.37C864.94 180.43 865.19 180.79 865.14 181.18Z"
        fill="#E6E6E6"
      />
      <path
        d="M864 178.18C865.03 176.76 866.99 176.48 868.37 177.55C869.75 178.62 870.04 180.63 869.01 182.05L864 178.18Z"
        fill="#D49C6A"
      />
      <path
        d="M859.27 179.22C858.87 180.41 858.04 181.18 857.41 180.96C856.79 180.73 856.6 179.59 857.01 178.4C857.41 177.21 858.24 176.44 858.87 176.66C859.5 176.88 859.68 178.03 859.27 179.22Z"
        fill="#333333"
      />
      <path
        d="M858.73 177.84C858.68 178.17 858.38 178.41 858.08 178.36C857.78 178.31 857.57 178.01 857.63 177.67C857.68 177.34 857.98 177.1 858.28 177.15C858.58 177.2 858.79 177.5 858.73 177.84Z"
        fill="#E6E6E6"
      />
      <path
        d="M857.83 175.32C858.82 174.1 860.23 173.65 860.99 174.3C861.75 174.95 861.57 176.47 860.58 177.69L857.83 175.32Z"
        fill="#D49C6A"
      />
      <path
        d="M883.86 192.17C883.2 194.16 881.46 195.35 879.97 194.83C878.48 194.31 877.81 192.27 878.46 190.28C879.12 188.29 880.86 187.1 882.35 187.62C883.84 188.14 884.51 190.18 883.86 192.17Z"
        fill="#FCBA7E"
      />
      <path
        d="M853.93 191.1C854.16 191.32 854.27 191.33 854.34 191.44C854.4 191.54 854.44 191.66 854.49 191.76C854.59 191.98 854.7 192.2 854.82 192.42C855.06 192.87 855.38 193.28 855.77 193.51C856.55 193.98 857.39 194.18 858.22 194.26C859.05 194.33 859.87 194.39 860.69 194.26L861.9 194.09C862.1 194.07 862.3 194.05 862.5 194.05C862.7 194.07 862.9 193.91 863.07 194.53C863.44 194.55 863.75 194.25 863.76 193.87C863.78 193.49 863.49 193.17 863.12 193.16C862.9 193.75 862.71 193.57 862.52 193.56C862.33 193.54 862.13 193.49 861.94 193.45C861.55 193.36 861.18 193.2 860.81 193.06C860.07 192.76 859.33 192.57 858.63 192.31C857.94 192.03 857.24 191.83 856.59 191.62C856.27 191.51 855.89 191.54 855.51 191.49C855.32 191.47 855.14 191.42 854.98 191.33C854.91 191.28 854.83 191.23 854.79 191.16C854.76 191.11 854.79 190.93 854.97 190.95C854.93 190.65 854.66 190.44 854.37 190.48C854.08 190.52 853.87 190.8 853.91 191.1H853.93Z"
        fill="#BD6855"
      />
      <path
        d="M866.24 221.25C866.38 223.06 866.36 224.41 866.36 224.41C870.09 218.95 880.1 216.18 880.1 216.18L876.91 210.53C872.18 214.08 864.71 214.08 864.71 214.08C865.67 215.98 866.07 218.97 866.24 221.25Z"
        fill="#DBF5FF"
      />
      <path
        d="M852.86 220.56C853.32 220.01 853.77 219.51 854.23 219.05C859.48 213.76 864.71 214.08 864.71 214.08C861.56 211.56 861.56 207.13 861.56 207.13C861.27 208.54 856.25 212.94 856.25 212.94C855.79 214.31 854.93 216.21 854.21 217.77C853.51 219.26 852.94 220.43 852.87 220.56H852.86Z"
        fill="#DBF5FF"
      />
      <path
        d="M758.31 267.67C759.07 275.05 763.04 274.81 763.04 274.81C763.04 274.81 766.5 273.44 766.21 266.68C765.88 258.9 761.1 258.41 761.1 258.41C759.59 258.96 757.54 260.29 758.3 267.67H758.31Z"
        fill="#00253D"
      />
      <path
        d="M767.03 260.84C767.03 260.84 760.92 263.24 758.16 261.99L759.92 273.14C759.92 273.14 764.55 271.48 768.74 271.37L767.02 260.84H767.03Z"
        fill="#C7B299"
      />
      <path
        d="M763.05 274.81C787.37 270.38 796.41 281.02 809.54 291.21C810.16 291.69 810.77 292.14 811.38 292.56C817.01 293.44 823.15 295.2 829.15 298.73H829.23C832.62 298.85 834.72 298.3 834.72 298.3C834.72 298.3 847.63 300.52 825.68 277.02C803.73 253.53 761.11 258.4 761.11 258.4C761.11 258.4 764.93 258.94 765.56 265.76C765.59 266.09 765.61 266.42 765.63 266.78C765.91 273.54 763.05 274.8 763.05 274.8V274.81Z"
        fill="#00375C"
      />
      <path
        d="M868.39 295L864.64 298.74C864.64 298.74 856.61 278.5 829.2 264.17C829.2 264.17 854.56 268.81 868.56 293.77C868.78 294.17 868.71 294.68 868.39 295.01V295Z"
        fill="#333333"
      />
      <path
        d="M845.27 269.41L843.69 273.33L835.51 267.86L836.44 265.87C836.44 265.87 842.18 267.86 845.26 269.42L845.27 269.41Z"
        fill="#808080"
      />
      <path
        d="M754.66 252.76L755.31 264.39C758.93 264.68 762.35 265.07 765.57 265.54C779.41 267.57 789.07 270.5 799.07 275.5C812.72 282.33 819.8 291.84 829.22 298.5C829.32 298.58 829.44 298.65 829.54 298.73C829.56 298.73 829.58 298.76 829.61 298.77C830.16 299.1 830.71 299.44 831.25 299.82C834.75 299.96 840.44 301.92 849.78 306.16C858.61 306.05 863.64 300.78 864.97 299.15C865.21 298.86 865.3 298.47 865.19 298.1C864.49 295.52 861.14 284.86 851.92 277.69C839.05 268.5 821.05 260.28 807.03 258.51C773.24 254.25 754.64 252.76 754.64 252.76H754.66Z"
        fill="#00406B"
      />
      <path
        d="M739.52 230.9L739.16 230.95L740.96 246.18C741.26 248.75 742.11 251.23 743.38 253.46C743.82 254.22 744.28 255.06 744.75 256.03C745.96 258.54 747.15 261.91 747.74 267.21C751.22 266.75 752.91 265.77 754.81 264.85C755.93 264.31 756.12 262.76 755.17 261.95C752.1 259.34 749.87 258.82 754.3 248.77C754.72 247.83 754.77 246.77 753.92 246.21C751.08 244.35 744.15 239.79 742.55 232.77C742.27 231.53 740.76 230.75 739.53 230.91L739.52 230.9Z"
        fill="#42210B"
      />
      <path
        d="M744.05 256.65C742.55 257.3 741.09 257.56 741.09 257.56L742.22 267.12C743.68 267.37 745.54 267.37 746.99 267.27C746.62 264.62 745.82 260.72 744.05 256.65Z"
        fill="#42210B"
      />
      <path
        d="M739.46 230.33L737.9 230.53L739.8 246.57C740.1 249.07 740.95 251.46 742.18 253.64C742.75 254.66 743.25 255.68 743.69 256.69C745.46 260.75 746.27 264.66 746.63 267.31C747.13 267.27 747.62 267.22 748.11 267.16C747.52 261.86 746.33 258.49 745.12 255.98C744.66 255.01 744.19 254.17 743.75 253.41C742.48 251.17 741.63 248.7 741.33 246.13L739.46 230.33Z"
        fill="#603813"
      />
      <path
        d="M749.38 243.11C749.38 243.11 754.5 243.87 756.66 253.41C757.55 256.04 758.8 258.08 759.46 259.05C759.74 259.46 759.89 259.95 759.89 260.45C759.89 262.16 760.07 266.55 761.37 272.44C761.59 273.41 761.21 274.43 760.43 275.03C759.12 276.03 757.12 277.42 755.89 277.62C753.93 277.93 749.39 243.11 749.39 243.11H749.38Z"
        fill="#42210B"
      />
      <path
        d="M754.46 277.09L755.24 268.05L757.25 267.67C756.45 263.38 755.39 258.25 755.17 253.16C754.66 241.01 749.6 242.06 749.6 242.06C749.51 242.06 749.42 242.06 749.33 242.08C742.65 244.34 748.87 271 754.45 277.09H754.46Z"
        fill="#603813"
      />
      <path
        d="M749.19 268.29C750.75 272.8 752.63 276.48 754.39 277.87L754.46 277.09L755.24 268.05L757.25 267.67C757.2 267.37 757.14 267.08 757.08 266.78L749.19 268.28V268.29Z"
        fill="#4D260D"
      />
      <path
        d="M749.19 268.29L757.08 266.79C756.31 262.69 755.37 257.91 755.17 253.17C754.66 241.02 749.6 242.07 749.6 242.07C749.51 242.07 749.42 242.07 749.33 242.09C743.6 242.48 745.5 257.68 749.18 268.3L749.19 268.29Z"
        fill="#5C2D10"
      />
      <path
        d="M755.17 253.17C755.38 258.26 756.45 263.38 757.25 267.68C758.29 273.27 758.89 277.46 756.56 278.33C756.63 278.33 756.7 278.33 756.77 278.32C756.79 278.32 756.81 278.32 756.82 278.32C761.78 277.51 756.44 265.19 755.92 253.03C755.41 240.88 750.35 241.93 750.35 241.93C749.98 241.93 749.65 241.97 749.34 242.09C749.42 242.07 749.52 242.07 749.61 242.07C749.61 242.07 754.67 241.02 755.18 253.17H755.17Z"
        fill="#603813"
      />
      <path
        d="M754.3 278.96L756.29 278.42C756.46 278.41 756.62 278.37 756.77 278.31C756.7 278.32 756.63 278.33 756.56 278.32C758.89 277.44 758.29 273.26 757.25 267.67L755.24 268.05L754.46 277.09L754.39 277.87L754.3 278.96Z"
        fill="#42210B"
      />
      <path
        d="M753.97 279.01C753.85 279.01 753.72 279.02 753.6 279.03C752.44 279.08 751.34 278.52 750.69 277.54C749.74 276.13 748.7 274.18 748.41 269.37L755.25 268.05C755.25 268.05 756.8 274.39 755.64 277.72C755.39 278.45 754.73 278.96 753.98 279L753.97 279.01Z"
        fill="#5C2D10"
      />
      <path
        d="M880.35 208.72L880.37 208.67L880.35 208.72Z"
        fill="url(#paint41_linear_2072_10275)"
      />
      <path
        d="M848.86 181.74C846.56 181.86 846.85 183.47 847.47 186.31C847.47 193.63 849.1 195.31 849.93 194.97C851.46 194.36 851.64 181.59 848.86 181.74Z"
        fill="#F0B299"
      />
      <path
        d="M849.3 192.22C849.3 192.22 848.43 190.73 849.19 188.26C850.97 182.43 847.44 181.35 847.58 185.59C847.58 185.59 848.4 183.76 848.76 184.42C849.2 185.23 847.98 185.41 848.06 188.6C848.1 190.26 849.3 192.23 849.3 192.23V192.22Z"
        fill="url(#paint42_linear_2072_10275)"
      />
      <path
        d="M891.07 187.32C893.29 187.93 892.68 189.45 891.48 192.09C889.97 199.24 888.02 200.53 887.28 200.02C885.92 199.09 888.38 186.58 891.07 187.32Z"
        fill="#F0B299"
      />
      <path
        d="M888.46 197.47C888.46 197.47 889.62 196.21 889.39 193.63C888.86 187.55 892.53 187.26 891.51 191.36C891.51 191.36 891.09 189.39 890.6 189.96C890 190.65 891.16 191.09 890.42 194.2C890.03 195.81 888.45 197.47 888.45 197.47H888.46Z"
        fill="url(#paint43_linear_2072_10275)"
      />
      <path
        d="M889.35 186.74C892.28 169.91 887.46 166.95 886.23 165.03C883.73 161.12 879.26 158.97 871.25 158.09C871.25 158.09 860.8 157.07 857.43 162.49C853.83 168.28 852.2 176.7 851.38 184.68C850.39 194.37 850.04 196.93 850.6 199.06C850.86 200.05 851.17 201.4 852.82 203.13C855.46 205.89 858.76 210.87 860.89 213.14C861.75 214.05 867.99 216.6 873.54 213.79C876.45 212.32 879.53 210.37 883.22 207.51C884.85 206.25 886.1 204.01 886.25 202.83C886.43 201.48 887.96 194.82 888.05 193.8C888.51 188.32 888.52 191.42 889.33 186.74H889.35Z"
        fill="#F7C3A9"
      />
      <path
        d="M875.45 180.76C874.98 182.37 872.25 188.24 873.13 188.94C878.62 193.29 886.06 189.59 886.06 189.59C887.05 178.72 875.45 180.76 875.45 180.76Z"
        fill="url(#paint44_linear_2072_10275)"
      />
      <path
        d="M853.83 185.54C853.83 185.54 859.59 190.67 866.21 187.52C867.22 187.04 866.1 181.41 866.07 179.73C866.07 179.73 855.13 174.81 853.83 185.54Z"
        fill="url(#paint45_linear_2072_10275)"
      />
      <path
        d="M879.1 201.64C882.36 202.3 886.11 202.32 887.72 195.51C888.64 191.63 888.47 189.57 886.89 189.04C883.53 187.92 878.38 188.79 876.17 189.61C871.51 191.33 873.33 200.46 879.1 201.64Z"
        fill="url(#paint46_radial_2072_10275)"
      />
      <path
        d="M862.49 187.45C859.21 185.71 855.95 184.17 852.45 184.71C851.19 184.91 850.79 187.72 850.64 190.38C850.57 191.66 850.21 193.62 850.38 194.45C851.24 198.53 857.07 199.48 860.25 198.8C865.67 197.64 867.02 189.85 862.49 187.45Z"
        fill="url(#paint47_radial_2072_10275)"
      />
      <path
        d="M886.24 190.88C885.69 190.46 885.19 190.89 883.9 191.14C882.64 191.38 879.25 191.57 880.69 192.63C882.28 193.8 884.85 192.83 885.17 192.63C885.49 192.43 886.92 191.4 886.24 190.88Z"
        fill="url(#paint48_linear_2072_10275)"
      />
      <path
        d="M876.33 203.65C876.19 203.74 876.06 203.83 875.93 203.91C875.93 203.91 876.1 203.82 876.33 203.65Z"
        fill="url(#paint49_linear_2072_10275)"
      />
      <path
        d="M875.67 197.24C879.1 200.91 877.24 202.96 876.33 203.65C877.98 202.59 880.16 201.46 880.1 200.89C879.89 198.82 875.66 197.25 875.66 197.25L875.67 197.24Z"
        fill="url(#paint50_linear_2072_10275)"
      />
      <path
        d="M876.25 201.23C876.25 201.23 878.29 201.03 878.48 200.91C878.67 200.79 878.9 200.3 878.9 200.3L877.59 200.52L876.25 201.23Z"
        fill="#E19F8C"
      />
      <path
        d="M857.43 198.16C857.43 198.79 858.95 200.53 859.92 201.87C859.92 201.87 857.35 198.19 861.93 195.79C861.93 195.79 857.41 196.05 857.43 198.16Z"
        fill="url(#paint51_linear_2072_10275)"
      />
      <path
        d="M858.54 197.71C858.54 197.71 858.63 198.24 858.79 198.41C858.95 198.58 860.86 199.3 860.86 199.3L859.75 198.26L858.55 197.71H858.54Z"
        fill="#E19F8C"
      />
      <path
        d="M863.55 207.24C868.86 207.35 872.3 208.48 872.3 208.48C868.67 205.45 863.55 207.24 863.55 207.24Z"
        fill="url(#paint52_linear_2072_10275)"
      />
      <path
        d="M858.97 198.02C859.06 198.15 859.12 198.31 859.25 198.39C861.61 199.85 861.5 200.93 862.5 201.66C866.04 204.25 870.56 204.34 873.78 203.07C875.63 202.34 876 201.24 878.17 200.71C878.46 200.64 878.54 200.43 878.54 200.43C867.16 201.69 858.97 198.03 858.97 198.03V198.02Z"
        fill="#962865"
      />
      <path
        d="M868.13 204.65C866.64 204.45 865.22 203.96 865.18 204.26C865.14 204.56 866.34 205.38 867.83 205.58C869.32 205.78 870.87 205.32 870.91 205.03C870.95 204.74 869.62 204.86 868.13 204.66V204.65Z"
        fill="#FDC9B3"
      />
      <path
        d="M872.82 202.23C871.78 202.3 869.83 202.43 868.08 202.2C866.16 201.94 864.25 201.33 863.22 200.99C862.77 200.84 862.46 201.64 862.46 201.64C863.72 202.86 865.35 203.48 868.04 203.86C871.63 204.37 873.83 203.06 873.83 203.06C873.83 203.06 873.43 202.2 872.82 202.24V202.23Z"
        fill="url(#paint53_linear_2072_10275)"
      />
      <path
        d="M862.59 204.3C867.71 209.69 873.86 205.48 873.86 205.48C867.64 207.83 862.59 204.3 862.59 204.3Z"
        fill="url(#paint54_linear_2072_10275)"
      />
      <path
        d="M861.39 198.88C861.39 198.88 861.3 199.84 862.2 200.39C862.72 200.71 863.84 201.83 868.71 202.33C873.58 202.83 874.69 201.77 874.94 201.59C875.4 201.26 875.68 200.63 875.68 200.63C875.68 200.63 868.18 201.1 861.39 198.87V198.88Z"
        fill="url(#paint55_linear_2072_10275)"
      />
      <path
        d="M861.39 198.79C861.39 198.79 861.36 199.23 861.49 199.51C861.59 199.74 865.39 200.83 868.31 201.24C871.23 201.65 875.15 201.4 875.31 201.24C875.56 201 875.73 200.55 875.73 200.55C875.73 200.55 872.29 201.23 861.39 198.79Z"
        fill="#F3EBED"
      />
      <path
        d="M858.41 197.64C858.41 197.64 859.06 198.15 858.97 198.02C858.97 198.02 867.16 201.68 878.54 200.42L879.18 200.2C873.06 200.41 858.41 197.64 858.41 197.64Z"
        fill="url(#paint56_linear_2072_10275)"
      />
      <path
        d="M854.88 187.41C853.68 186.9 853.27 186.37 852.65 186.66C851.88 187.02 853.05 188.33 853.32 188.59C853.59 188.86 855.89 190.35 857.7 189.54C859.33 188.81 856.07 187.9 854.88 187.4V187.41Z"
        fill="url(#paint57_linear_2072_10275)"
      />
      <path
        d="M879.31 185.62C877.55 185.48 875.14 185.59 874.06 188.4C873.61 189.57 877.2 190.6 879.38 190.72C882.29 190.88 884.08 188.73 883.97 188.41C883.17 186.14 880.32 185.7 879.31 185.62Z"
        fill="url(#paint58_linear_2072_10275)"
      />
      <path
        d="M877.21 185.87C876.06 185.86 875.66 186.25 875.38 186.53C874.74 187.18 874.37 188.25 874.37 188.25C874.32 188.48 874.85 189.08 875.38 189.26C876.61 189.69 877.5 190.24 880.55 190.06C881.5 190.01 882.86 189.13 883.18 188.76C883.48 188.41 883.56 188.07 883.56 188.07C882.23 186.31 881.92 185.92 877.21 185.86V185.87Z"
        fill="url(#paint59_linear_2072_10275)"
      />
      <path
        d="M881.04 186.17C879.66 186.14 876.63 185.36 874.74 187.45C875.97 187.07 878.86 187.05 883.21 188.75C883.41 188.51 883.53 188.23 883.57 188.09C883.57 188.09 882.8 186.22 881.05 186.18L881.04 186.17Z"
        fill="#DDDDDD"
      />
      <path
        d="M878.94 185.87C877.16 185.54 875.94 186.59 875.83 188.15C875.78 188.74 876.02 189.44 876.08 189.51C876.32 189.63 877.28 189.95 878.35 190.05C879.14 190.17 880.28 190.1 880.56 190.05C880.85 190.01 881.11 189.29 881.15 188.97C881.45 186.83 880.44 186.14 878.94 185.86V185.87Z"
        fill="url(#paint60_linear_2072_10275)"
      />
      <path
        d="M879.08 185.69C876.78 185.28 876.04 187.24 876.04 187.24C879.02 187.19 881.19 188.04 881.19 188.04C881.19 187.4 880.83 186 879.08 185.69Z"
        fill="url(#paint61_linear_2072_10275)"
      />
      <path
        d="M878.83 186.3C877.94 186.16 877.1 186.77 876.97 187.65C876.84 188.54 877.46 189.36 878.35 189.5C879.25 189.63 880.08 189.03 880.21 188.14C880.34 187.25 879.72 186.43 878.82 186.29L878.83 186.3Z"
        fill="url(#paint62_radial_2072_10275)"
      />
      <path
        d="M881.82 186.18C880.58 185.45 877.42 185.3 876.66 185.57C875.37 186.01 874.74 187.45 874.74 187.45C874.74 187.45 876.15 186.11 879.63 186.69C882.38 187.15 883.57 188.08 883.57 188.08C883.57 188.08 883.32 187.07 881.83 186.19L881.82 186.18Z"
        fill="url(#paint63_linear_2072_10275)"
      />
      <path
        d="M879.94 188.14C879.55 188.14 879.23 188.46 879.22 188.86C879.22 189.26 879.52 189.59 879.91 189.59C880.3 189.59 880.63 189.27 880.63 188.87C880.64 188.47 880.33 188.14 879.94 188.14Z"
        fill="white"
      />
      <path
        d="M878.51 187.27C878.2 187.27 877.95 187.52 877.94 187.84C877.94 188.16 878.18 188.42 878.49 188.42C878.8 188.42 879.05 188.17 879.06 187.85C879.06 187.53 878.82 187.27 878.51 187.27Z"
        fill="white"
      />
      <path
        d="M860.97 183.25C859.98 183.06 857.11 182.73 855.74 184.72C855.55 185 856.71 187.54 859.56 188.15C861.7 188.61 865.43 188.56 865.3 187.31C864.99 184.32 862.7 183.58 860.96 183.25H860.97Z"
        fill="url(#paint64_linear_2072_10275)"
      />
      <path
        d="M862.93 184.04C858.37 182.86 857.97 183.15 856.22 184.5C856.22 184.5 856.21 184.85 856.41 185.27C856.62 185.7 857.7 186.91 858.6 187.21C861.5 188.18 862.5 187.88 863.8 187.79C864.36 187.75 865.02 187.31 865.04 187.08C865.04 187.08 864.96 185.95 864.51 185.16C864.32 184.82 864.03 184.33 862.92 184.04H862.93Z"
        fill="url(#paint65_linear_2072_10275)"
      />
      <path
        d="M859.16 183.32C857.46 182.9 856.23 184.5 856.23 184.5C856.21 184.68 856.27 185 856.4 185.24C861.04 184.75 863.82 185.52 864.91 186.21C863.63 183.7 860.5 183.65 859.16 183.32Z"
        fill="#DDDDDD"
      />
      <path
        d="M861.26 183.59C859.74 183.46 858.58 183.87 858.32 186.01C858.28 186.33 858.47 187.12 858.61 187.21C858.85 187.37 859.95 187.69 860.74 187.78C861.8 187.97 862.81 187.9 863.07 187.85C863.14 187.79 863.55 187.19 863.66 186.6C863.96 185.06 863.06 183.73 861.25 183.58L861.26 183.59Z"
        fill="url(#paint66_linear_2072_10275)"
      />
      <path
        d="M861.17 183.38C859.39 183.22 858.69 184.48 858.51 185.09C858.51 185.09 860.83 184.84 863.69 185.67C863.69 185.67 863.5 183.58 861.17 183.38Z"
        fill="url(#paint67_linear_2072_10275)"
      />
      <path
        d="M861.25 184.04C860.35 183.93 859.53 184.57 859.43 185.46C859.32 186.35 859.97 187.15 860.87 187.26C861.77 187.36 862.59 186.73 862.69 185.84C862.79 184.95 862.15 184.15 861.25 184.04Z"
        fill="url(#paint68_radial_2072_10275)"
      />
      <path
        d="M863.55 183.9C862.88 183.45 859.79 182.75 858.41 183.14C856.74 183.6 856.23 184.51 856.23 184.51C856.23 184.51 857.62 183.92 860.4 184.2C863.9 184.55 864.91 186.22 864.91 186.22C864.91 186.22 864.68 184.67 863.55 183.9Z"
        fill="url(#paint69_linear_2072_10275)"
      />
      <path
        d="M862.28 185.86C861.89 185.86 861.57 186.18 861.56 186.58C861.56 186.98 861.86 187.31 862.25 187.31C862.64 187.31 862.97 186.99 862.97 186.59C862.98 186.19 862.67 185.86 862.28 185.86Z"
        fill="white"
      />
      <path
        d="M860.84 185C860.53 185 860.28 185.25 860.27 185.57C860.27 185.89 860.51 186.15 860.82 186.15C861.13 186.15 861.38 185.9 861.39 185.58C861.39 185.26 861.15 185 860.84 185Z"
        fill="white"
      />
      <path
        d="M875.41 180.24C875.16 181.2 874.97 182.12 875.57 182.2C877.75 182.48 885.68 183.26 885.68 183.26C885.68 183.26 883.78 181.57 882.95 181.12C881.88 180.54 878.2 180.14 875.42 180.24H875.41Z"
        fill="url(#paint70_linear_2072_10275)"
      />
      <path
        d="M858.79 177.97C857.87 178.19 855.59 179.32 855.59 179.32C855.59 179.32 863.44 180.65 865.62 180.95C866.22 181.03 866.27 180.09 866.29 179.1C863.63 178.28 859.98 177.69 858.79 177.97Z"
        fill="url(#paint71_linear_2072_10275)"
      />
      <path
        d="M850.89 186.78C850.53 190.52 849.95 196.49 850.21 198.32C850.28 198.8 850.52 200.87 852.04 202.74C854.56 205.86 858.02 209.57 858.02 209.57C857.57 208.66 853.52 202.43 852.84 201.02C850.24 195.65 850.9 186.78 850.9 186.78H850.89Z"
        fill="url(#paint72_linear_2072_10275)"
      />
      <path
        d="M875.8 212.57C877.15 211.77 880.46 209.68 883.32 207.58C884.68 206.58 885.72 204.63 886.24 203.33C886.76 202.02 888.07 193.8 888.07 193.8C887.25 197.14 885.83 202.31 883.62 205.3C881.42 208.29 876.62 211.73 875.79 212.57H875.8Z"
        fill="url(#paint73_linear_2072_10275)"
      />
      <path
        d="M871.44 189.05C872.13 185.34 870.89 184.62 869.92 184.53C868.97 184.44 868.28 185.66 868.09 188.54C867.9 191.41 867.2 192.42 867.15 193.77C867.13 194.38 867.36 194.82 868.89 195.03C870.58 195.27 871.21 194.95 871.36 194.39C871.76 192.87 870.95 191.72 871.44 189.05Z"
        fill="url(#paint74_linear_2072_10275)"
      />
      <path
        d="M864.29 194.88C864.29 194.88 868.11 198.52 869.06 198.47C870.01 198.41 873.77 196.15 873.77 196.15C873.77 196.15 869.86 196.11 868.98 195.99C868.1 195.87 864.29 194.88 864.29 194.88Z"
        fill="url(#paint75_linear_2072_10275)"
      />
      <path
        d="M870.66 196.34C873.02 196.08 873.87 196.53 873.87 196.53C872.7 195.19 870.66 196.34 870.66 196.34Z"
        fill="#E19F8C"
      />
      <path
        d="M864.25 195.08C864.25 195.08 865.46 195.05 867.17 195.89C867.17 195.89 865.6 194.33 864.25 195.08Z"
        fill="#E19F8C"
      />
      <path
        d="M872.93 192.79C872.79 193.72 872.93 194.38 872.57 194.87C871.78 195.97 870.07 196.22 868.99 195.99C868.14 195.98 866.25 195.3 865.61 193.95C865.35 193.4 865.61 192.97 865.6 191.96C865.6 191.96 862.98 194.38 864.26 195.09C864.26 195.09 864.7 194.85 865.77 195.09C866.85 195.34 866.46 196.5 868.96 196.86C871.14 197.17 870.58 196.03 872 196.02C873.41 196.01 873.55 196.39 873.84 196.57C874.53 196.66 874.34 194.29 872.93 192.79Z"
        fill="url(#paint76_linear_2072_10275)"
      />
      <path
        d="M866.92 193.61C866.74 194.21 867.51 194.98 869.05 195.19C870.73 195.43 871.2 194.81 871.14 194.23C870.75 190.8 867.59 191.38 866.93 193.6L866.92 193.61Z"
        fill="url(#paint77_linear_2072_10275)"
      />
      <path
        d="M886.78 167.93C880.17 161.77 859.95 164.26 857.94 164.04C855.94 163.82 850.96 188.82 850.96 188.82C850.96 188.82 853.17 184 854.29 181.03C855.42 178.06 856.68 170.82 859.6 168.61C868.03 162.21 880.84 167.13 883.63 170.52C886.62 174.16 886.17 182.24 886.61 184.21C887.05 186.18 888.13 193.13 888.13 193.13C888.13 193.13 893.39 174.09 886.78 167.94V167.93Z"
        fill="url(#paint78_linear_2072_10275)"
      />
      <path
        d="M889.68 163.14C889.68 163.14 891.01 163.68 893.76 165.48C893.76 165.48 889.65 156.4 878.35 154.26C872.44 153.14 863.7 152.93 860.21 157.85C860.21 157.85 856.27 153.91 851.81 161.62C851.81 161.62 853.38 160 855.97 160.4C855.97 160.4 851.52 160.74 849.4 168.51C848.57 171.56 848.6 176.5 848.64 181.76C848.64 181.76 851.4 182.01 850.82 189C850.82 189 853.16 179.93 854.75 175.29C854.75 175.29 855.11 178.04 854.6 179.79C855.22 179.01 858.02 177.01 859.71 164.22C859.71 164.22 860.8 176.54 875.7 175.37C875.7 175.37 873.05 174.48 872.55 172.41C876.31 176.31 881.75 178.87 887.15 180.57L886.19 174.71C886.19 174.71 888.96 181.99 888.39 188.03C888.24 189.65 888.09 193.78 888.09 193.78C888.09 193.78 889.03 187.12 891.53 187.46C891.53 187.46 893.12 180.4 892.71 176.74C892.71 176.74 893.55 177.86 893.66 179.63C893.66 179.63 896.49 170.57 889.69 163.12L889.68 163.14Z"
        fill="url(#paint79_linear_2072_10275)"
      />
      <path
        d="M888.07 193.79C888.07 193.79 891.97 183.21 886.56 173.77C886.56 173.77 888.91 182.25 888.07 193.79Z"
        fill="#1E1412"
      />
      <path
        d="M861.16 170.11C860.48 168.36 859.74 165.8 859.63 162.32C859.36 164.07 858.87 166.41 859.2 168.15C859.51 169.75 859.94 171.51 860.85 172.88C862.38 175.17 865.22 176.06 867.79 176.46C866.4 175.76 864.99 175.04 863.77 174.05C862.6 173.09 861.7 171.52 861.15 170.12L861.16 170.11Z"
        fill="#1E1412"
      />
      <path
        d="M866.36 172.56C865.07 171.65 863.68 170.67 862.65 169.47C861.68 168.34 859.95 165.19 859.52 163.14C859.54 165.66 859.57 167.21 860.51 168.91C861.34 170.4 862.41 171.55 863.76 172.57C865.12 173.59 866.49 174.5 868.13 174.98C870.55 175.7 873.28 175.98 875.8 175.7C874.03 175.44 872.28 175.03 870.57 174.49C869.09 174.02 867.64 173.47 866.36 172.56Z"
        fill="#1E1412"
      />
      <path
        d="M880.51 177.78C879.03 176.96 877.74 176.09 876.58 175.31C874.28 173.76 872.61 172.49 871.36 171.47C870.12 170.46 869.29 169.73 868.74 169.27C868.2 168.81 867.93 168.64 867.93 168.64C869.18 171.18 871.16 173.27 873.19 174.84C874.21 175.63 875.25 176.32 876.26 176.91C877.27 177.5 878.25 178.02 879.2 178.43C881.08 179.26 882.77 179.6 883.92 179.63C884.5 179.65 884.94 179.62 885.24 179.58L885.7 179.51C883.7 179.33 881.99 178.57 880.51 177.76V177.78Z"
        fill="#1E1412"
      />
      <path
        d="M885.13 178.46C884.39 177.86 883.68 177.22 882.95 176.61C882.37 176.13 881.73 175.56 881.01 175.3C882.54 179.09 886.82 182.95 891.11 181.09C888.86 181.02 886.85 179.85 885.13 178.47V178.46Z"
        fill="#1E1412"
      />
      <path
        d="M851.62 182.18C851.11 184.35 850.77 186.76 850.82 189.23C850.82 189.23 854.08 180.12 854.87 174.23C854.99 173.33 854.65 171.25 854.2 170.45C853.14 174.29 852.33 178.25 851.63 182.19L851.62 182.18Z"
        fill="#1E1412"
      />
      <path
        d="M886.19 174.64C886.91 176.94 887.11 177.32 887.36 178.51C887.6 179.68 887.74 180.86 887.91 182.04C888.21 184.05 888.65 186.06 890 187.62C889.17 185.13 889.63 182.44 889.17 179.89C888.85 178.07 887.39 176.03 886.18 174.65L886.19 174.64Z"
        fill="#1E1412"
      />
      <path
        d="M859.42 163.47C859.08 166.9 858.83 169.47 857.31 173.38C856.29 176.02 854.68 179.09 852.96 181.32C854.28 180.35 855.42 179.13 856.34 177.77C857.93 175.41 859.28 172.46 859.52 169.62C859.62 168.43 859.45 166.26 859.41 163.47H859.42Z"
        fill="#1E1412"
      />
      <path
        d="M889.96 163.23C892.21 164.5 893.76 165.48 893.76 165.48C893.76 165.48 889.99 156.33 877.82 153.74C864.21 150.84 860.2 157.85 860.2 157.85C852.92 155.07 847.86 163.94 847.47 172.8C851.57 162.33 860.34 160.33 860.34 160.33C859.93 166.29 872.1 168.11 872.1 168.11C870.41 165.37 871.27 162.66 871.27 162.66C873.23 168.09 886.84 170.82 886.84 170.82C884.47 166.47 882.81 164.08 882.81 164.08C889.99 167.4 893.64 179.63 893.64 179.63C896.48 167.87 889.95 163.22 889.95 163.22L889.96 163.23Z"
        fill="url(#paint80_linear_2072_10275)"
      />
      <path
        d="M873.65 153.11C870.73 152.66 867.42 152.76 864.64 153.89C867.64 151.37 871.7 151.38 875.39 151.34C872.4 150.52 869.14 150.03 866.15 151.18C864.84 151.69 863.69 152.52 862.75 153.58C861.84 154.61 860.92 155.93 860.57 157.29C858.89 155.31 855.58 155.17 853.52 156.56C851.57 157.88 849.37 161.3 849.17 162.82C850.94 159.84 852.38 158.85 854.33 158.18C856.59 157.41 858.68 157.59 860.49 158.57C860.49 158.65 861.16 158.54 861.16 158.54C861.16 158.54 861.61 157.53 861.87 157.27C862.55 156.6 863.27 155.94 864.13 155.52C865.01 155.09 865.99 154.92 866.95 154.77C868 154.6 869.07 154.5 870.14 154.48C874.07 154.4 878.01 155.26 881.57 156.93C883.16 157.68 884.61 158.62 886.05 159.63C885 158.52 883.88 157.58 882.75 156.78C880.07 154.87 876.89 153.62 873.65 153.13V153.11Z"
        fill="url(#paint81_linear_2072_10275)"
      />
      <path
        d="M867.44 209.13C866.3 208.98 863.34 209.37 863.36 209.8C863.44 211.1 866.06 211.66 867.2 211.81C868.34 211.96 870.69 211.98 870.88 210.9C870.96 210.48 868.57 209.27 867.43 209.12L867.44 209.13Z"
        fill="url(#paint82_linear_2072_10275)"
      />
      <path
        d="M867.73 207.87C864.8 207.48 862.3 208.16 862.14 208.9C861.84 210.32 864.11 210.99 866.32 211.54C868.52 212.09 872.09 211.31 872.23 210.25C872.37 209.19 871.72 208.4 867.73 207.87Z"
        fill="url(#paint83_linear_2072_10275)"
      />
      <path
        d="M862.18 213.49C860.92 212.97 858.02 209.57 858.02 209.57C858.02 209.57 860.33 213.84 861.93 214.39C863.53 214.94 868.37 215.8 870.42 215.52C872.46 215.24 876.36 212.22 876.36 212.22C876.36 212.22 872.72 214.06 870.71 214.62C868.7 215.18 863.45 214 862.19 213.48L862.18 213.49Z"
        fill="url(#paint84_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M902.54 279.87C902.54 279.87 889.57 262.21 855.2 260.76C855.2 260.76 840.75 288.34 848.07 319.18L840.76 318.49C840.76 318.49 843.61 281.18 853.15 257.49C853.15 257.49 878.06 259.67 906.42 271.62C906.42 271.62 906.42 279.39 902.54 279.87Z"
        fill="url(#paint85_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M905.53 275.12C905.53 276.77 904.66 278.1 903.59 278.1C902.52 278.1 901.65 276.76 901.65 275.12C901.65 273.48 902.52 272.14 903.59 272.14C904.66 272.14 905.53 273.48 905.53 275.12Z"
        fill="url(#paint86_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M846.19 315.51C846.19 317.16 845.32 318.49 844.25 318.49C843.18 318.49 842.31 317.15 842.31 315.51C842.31 313.87 843.18 312.53 844.25 312.53C845.32 312.53 846.19 313.87 846.19 315.51Z"
        fill="url(#paint87_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M853.14 257.5H847.82C847.82 257.5 837.41 290.03 838.51 318.5H840.75C840.75 318.5 844.67 280.89 853.14 257.5Z"
        fill="url(#paint88_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M854.76 261.93C854.76 261.93 883.68 261.8 902.54 279.88C902.54 279.88 891.24 262.54 855.28 260.29L854.76 261.94V261.93Z"
        fill="#5A3361"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M395.93 311.05C395.93 311.05 402.05 283.86 402.49 266.2H395.93C395.93 266.2 395.78 296.34 392.29 311.05H395.93Z"
        fill="url(#paint89_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M387.01 270.8L395.93 266.19C395.93 266.19 396.36 295.18 392.29 311.04H391.47C391.47 311.04 395.74 288.14 394.43 269.18L386.83 274.11L387 270.79L387.01 270.8Z"
        fill="url(#paint90_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M388.1 273.31L394.59 272.12L394.44 269.19L388.1 273.31Z"
        fill="#5A3361"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M323.22 310.39C323.22 310.39 317.2 283.85 316.75 266.19H323.31C323.31 266.19 323.46 296.33 326.95 311.04L323.22 310.39Z"
        fill="url(#paint91_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M332.24 270.8L323.32 266.19C323.32 266.19 322.89 295.18 326.96 311.04H327.78C327.78 311.04 323.51 288.14 324.82 269.18L332.42 274.11L332.25 270.79L332.24 270.8Z"
        fill="url(#paint92_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M331.14 273.31L324.65 272.12L324.8 269.19L331.14 273.31Z"
        fill="#5A3361"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M388.46 199.36C388.46 199.36 390.49 260.88 386.92 298.4L332.38 299.71C332.38 299.71 325.55 230.34 325.06 199.62L388.46 199.36Z"
        fill="url(#paint93_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M385.54 299.39C385.54 299.39 389.97 236.24 388.46 199.36C388.46 199.36 359.03 187.89 325.06 199.62C325.06 199.62 328.49 264.4 334.44 301.41L385.54 299.39Z"
        fill="url(#paint94_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M362.19 331.75L378.48 341.46C378.48 341.46 379.68 343.86 379.96 346.54H378.5C378.5 346.54 377.57 344.37 377.05 343.72C375.92 342.3 361.23 338.67 361.23 338.67L359.4 331.75H362.19Z"
        fill="#180B1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M362.84 331.75L379.13 341.46C379.13 341.46 380.33 343.86 380.61 346.54H379.15C379.15 346.54 378.22 344.37 377.7 343.72C376.57 342.3 361.88 338.67 361.88 338.67L361.64 337.43L362.85 331.75H362.84Z"
        fill="url(#paint95_radial_2072_10275)"
      />
      <path
        d="M380.92 353.62C383.797 353.62 386.13 351.346 386.13 348.54C386.13 345.734 383.797 343.46 380.92 343.46C378.043 343.46 375.71 345.734 375.71 348.54C375.71 351.346 378.043 353.62 380.92 353.62Z"
        fill="url(#paint96_radial_2072_10275)"
      />
      <path
        d="M382.72 352.48C384.382 352.48 385.73 350.716 385.73 348.54C385.73 346.364 384.382 344.6 382.72 344.6C381.058 344.6 379.71 346.364 379.71 348.54C379.71 350.716 381.058 352.48 382.72 352.48Z"
        fill="url(#paint97_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M399.04 311.25C399.04 311.25 369.61 316.7 320.71 310.23C320.71 310.23 329.16 309.64 352.28 310.23L399.04 311.25Z"
        fill="url(#paint98_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M320.71 307.31H399.04V311.25L320.71 310.23V307.31Z"
        fill="url(#paint99_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M399.04 307.31C399.04 307.31 399.75 301.24 397.34 299.2C397.34 299.2 362.6 294.89 320.71 301.76V307.32L351.62 307.3L399.04 307.32V307.31Z"
        fill="url(#paint100_radial_2072_10275)"
      />
      <g style={{ mixBlendMode: 'screen' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M320.71 307.31V301.75C350.02 300.26 367.68 299.17 397.34 299.19C397.34 299.19 399.87 301.1 399.04 307.3H320.71V307.31Z"
          fill="#41243F"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M397.34 299.2L359.03 299.93C359.03 299.93 339.44 299.86 320.72 301.75C320.72 301.75 347.91 294.75 397.35 299.19L397.34 299.2Z"
        fill="#714A6A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M373.07 312.65H345.73C345.73 312.65 351.51 316.69 359.4 316.69C367.29 316.69 373.07 312.65 373.07 312.65Z"
        fill="#180B1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M363.23 316.48L362.46 329.71H357.42L356.92 316.45L363.23 316.48Z"
        fill="url(#paint101_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M363.83 324.51H356.32L357.07 338.37H362.94L363.83 324.51Z"
        fill="url(#paint102_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M363.23 331.44L399.83 341.15C399.83 341.15 402.53 343.55 403.15 346.23H399.87C399.87 346.23 397.77 344.06 396.61 343.41C394.07 341.99 361.06 338.36 361.06 338.36L360.52 337.12L363.23 331.44Z"
        fill="url(#paint103_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M394.67 347.76C394.67 350.56 397 352.84 399.88 352.84C402.76 352.84 405.09 350.57 405.09 347.76C405.09 344.95 402.76 342.68 399.88 342.68C397 342.68 394.67 344.95 394.67 347.76Z"
        fill="url(#paint104_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M395.35 348.23C395.35 350.41 396.7 352.17 398.36 352.17C400.02 352.17 401.37 350.4 401.37 348.23C401.37 346.06 400.02 344.29 398.36 344.29C396.7 344.29 395.35 346.06 395.35 348.23Z"
        fill="url(#paint105_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M356.69 331.44L320.09 341.15C320.09 341.15 317.39 343.55 316.77 346.23H320.05C320.05 346.23 322.15 344.06 323.31 343.41C325.85 341.99 358.86 338.36 358.86 338.36L359.4 337.12L356.69 331.44Z"
        fill="url(#paint106_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M356.99 331.44L340.7 341.15C340.7 341.15 339.5 343.55 339.22 346.23H340.68C340.68 346.23 341.61 344.06 342.13 343.41C343.26 341.99 357.95 338.36 357.95 338.36L359.78 331.44H356.99Z"
        fill="#714A6A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M359.78 331.44L343.49 341.15C343.49 341.15 342.29 343.55 342.01 346.23H343.47C343.47 346.23 344.4 344.06 344.92 343.41C346.05 341.99 360.74 338.36 360.74 338.36L360.98 337.12L359.77 331.44H359.78Z"
        fill="url(#paint107_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M325.25 347.76C325.25 350.56 322.92 352.84 320.04 352.84C317.16 352.84 314.83 350.57 314.83 347.76C314.83 344.95 317.16 342.68 320.04 342.68C322.92 342.68 325.25 344.95 325.25 347.76Z"
        fill="url(#paint108_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M324.58 348.23C324.58 350.41 323.23 352.17 321.57 352.17C319.91 352.17 318.56 350.4 318.56 348.23C318.56 346.06 319.91 344.29 321.57 344.29C323.23 344.29 324.58 346.06 324.58 348.23Z"
        fill="url(#paint109_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M340.7 341.15H343.49C343.49 341.15 342.27 343.62 342.01 346.23H339.22C339.22 346.23 339.55 342.95 340.7 341.15Z"
        fill="#482F54"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M346.9 348.23C346.9 351.03 344.57 353.31 341.69 353.31C338.81 353.31 336.48 351.04 336.48 348.23C336.48 345.42 338.81 343.15 341.69 343.15C344.57 343.15 346.9 345.42 346.9 348.23Z"
        fill="url(#paint110_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M346.22 348.7C346.22 350.88 344.87 352.64 343.21 352.64C341.55 352.64 340.2 350.87 340.2 348.7C340.2 346.53 341.55 344.76 343.21 344.76C344.87 344.76 346.22 346.53 346.22 348.7Z"
        fill="url(#paint111_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M332.37 226.89H383.32C383.32 226.89 371.76 229.62 357.85 229.62C343.94 229.62 332.38 226.89 332.38 226.89H332.37Z"
        fill="#26132A"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M385.73 199.37L381.84 202.1C381.84 202.1 358.04 196.06 331.14 202.1L326.95 199.61C326.95 199.61 353 190.22 385.73 199.37Z"
        fill="url(#paint112_radial_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.55"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M383.32 205.38C385.86 206.04 386.26 214.94 384.2 215.95C382.14 216.96 382.65 212.93 380.97 210.67C379.29 208.41 379.48 204.38 383.32 205.39V205.38Z"
        fill="url(#paint113_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M379.42 229.62C376.71 229.15 368.83 230.76 357.04 230.94C345.25 231.13 334.31 228.96 334.31 228.96C334.31 228.96 349.99 234.05 358.6 233.49C367.21 232.92 379.41 229.62 379.41 229.62H379.42Z"
        fill="url(#paint114_radial_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.55"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M384.01 227.81C384.01 227.81 386.37 230.73 384.01 234.7C384.01 234.7 381.15 230.82 384.01 227.81Z"
        fill="url(#paint115_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.55"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M332.86 268.24C332.86 268.24 332.48 252.44 330.35 248.97C330.35 248.97 330.72 261.48 332.86 268.24Z"
        fill="url(#paint116_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M547.29 307.2C547.29 307.2 553.41 280.01 553.85 262.35H547.29C547.29 262.35 547.14 292.49 543.65 307.2H547.29Z"
        fill="url(#paint117_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M538.36 266.95L547.28 262.34C547.28 262.34 547.71 291.33 543.64 307.19H542.82C542.82 307.19 547.09 284.29 545.78 265.33L538.18 270.26L538.35 266.94L538.36 266.95Z"
        fill="url(#paint118_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M539.46 269.46L545.95 268.27L545.8 265.34L539.46 269.46Z"
        fill="#5A3361"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M474.57 306.54C474.57 306.54 468.55 280 468.1 262.34H474.66C474.66 262.34 474.81 292.48 478.3 307.19L474.57 306.54Z"
        fill="url(#paint119_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M483.59 266.95L474.67 262.34C474.67 262.34 474.24 291.33 478.31 307.19H479.13C479.13 307.19 474.86 284.29 476.17 265.33L483.77 270.26L483.6 266.94L483.59 266.95Z"
        fill="url(#paint120_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M482.5 269.46L476.01 268.27L476.16 265.34L482.5 269.46Z"
        fill="#5A3361"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M539.81 195.51C539.81 195.51 541.84 257.03 538.27 294.55L483.73 295.86C483.73 295.86 476.9 226.49 476.41 195.77L539.81 195.51Z"
        fill="url(#paint121_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M536.9 295.54C536.9 295.54 541.33 232.39 539.82 195.51C539.82 195.51 510.39 184.04 476.42 195.77C476.42 195.77 479.85 260.55 485.8 297.56L536.9 295.54Z"
        fill="url(#paint122_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M513.54 327.9L529.83 337.61C529.83 337.61 531.03 340.01 531.31 342.69H529.85C529.85 342.69 528.92 340.52 528.4 339.87C527.27 338.45 512.58 334.82 512.58 334.82L510.75 327.9H513.54Z"
        fill="#180B1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M514.19 327.9L530.48 337.61C530.48 337.61 531.68 340.01 531.96 342.69H530.5C530.5 342.69 529.57 340.52 529.05 339.87C527.92 338.45 513.23 334.82 513.23 334.82L512.99 333.58L514.2 327.9H514.19Z"
        fill="url(#paint123_radial_2072_10275)"
      />
      <path
        d="M532.28 349.77C535.157 349.77 537.49 347.495 537.49 344.69C537.49 341.884 535.157 339.61 532.28 339.61C529.402 339.61 527.07 341.884 527.07 344.69C527.07 347.495 529.402 349.77 532.28 349.77Z"
        fill="url(#paint124_radial_2072_10275)"
      />
      <path
        d="M534.08 348.63C535.742 348.63 537.09 346.866 537.09 344.69C537.09 342.514 535.742 340.75 534.08 340.75C532.417 340.75 531.07 342.514 531.07 344.69C531.07 346.866 532.417 348.63 534.08 348.63Z"
        fill="url(#paint125_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M550.4 307.41C550.4 307.41 520.97 312.86 472.07 306.39C472.07 306.39 480.52 305.8 503.64 306.39L550.4 307.41Z"
        fill="url(#paint126_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M472.07 303.46H550.4V307.41L472.07 306.38V303.46Z"
        fill="url(#paint127_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M550.4 303.46C550.4 303.46 551.11 297.39 548.7 295.35C548.7 295.35 513.96 291.04 472.07 297.91V303.47L502.98 303.45L550.4 303.47V303.46Z"
        fill="url(#paint128_radial_2072_10275)"
      />
      <g style={{ mixBlendMode: 'screen' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M472.07 303.46V297.9C501.38 296.41 519.04 295.32 548.7 295.34C548.7 295.34 551.23 297.25 550.4 303.45H472.07V303.46Z"
          fill="#41243F"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M548.7 295.35L510.39 296.08C510.39 296.08 490.8 296.01 472.08 297.9C472.08 297.9 499.27 290.9 548.71 295.34L548.7 295.35Z"
        fill="#714A6A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M524.43 308.8H497.09C497.09 308.8 502.87 312.84 510.76 312.84C518.65 312.84 524.43 308.8 524.43 308.8Z"
        fill="#180B1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M514.59 312.63L513.81 325.86H508.78L508.28 312.6L514.59 312.63Z"
        fill="url(#paint129_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M515.19 320.66H507.68L508.43 334.52H514.3L515.19 320.66Z"
        fill="url(#paint130_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M514.59 327.59L551.19 337.3C551.19 337.3 553.89 339.7 554.51 342.38H551.23C551.23 342.38 549.13 340.21 547.97 339.56C545.43 338.14 512.42 334.51 512.42 334.51L511.88 333.27L514.59 327.59Z"
        fill="url(#paint131_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M546.02 343.91C546.02 346.71 548.35 348.99 551.23 348.99C554.11 348.99 556.44 346.72 556.44 343.91C556.44 341.1 554.11 338.83 551.23 338.83C548.35 338.83 546.02 341.1 546.02 343.91Z"
        fill="url(#paint132_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M546.7 344.38C546.7 346.56 548.05 348.32 549.71 348.32C551.37 348.32 552.72 346.55 552.72 344.38C552.72 342.21 551.37 340.44 549.71 340.44C548.05 340.44 546.7 342.21 546.7 344.38Z"
        fill="url(#paint133_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M508.04 327.59L471.44 337.3C471.44 337.3 468.74 339.7 468.12 342.38H471.4C471.4 342.38 473.5 340.21 474.66 339.56C477.2 338.14 510.21 334.51 510.21 334.51L510.75 333.27L508.04 327.59Z"
        fill="url(#paint134_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M508.34 327.59L492.05 337.3C492.05 337.3 490.85 339.7 490.57 342.38H492.03C492.03 342.38 492.96 340.21 493.48 339.56C494.61 338.14 509.3 334.51 509.3 334.51L511.13 327.59H508.34Z"
        fill="#714A6A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M511.13 327.59L494.84 337.3C494.84 337.3 493.64 339.7 493.36 342.38H494.82C494.82 342.38 495.75 340.21 496.27 339.56C497.4 338.14 512.09 334.51 512.09 334.51L512.33 333.27L511.12 327.59H511.13Z"
        fill="url(#paint135_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M476.61 343.91C476.61 346.71 474.28 348.99 471.4 348.99C468.52 348.99 466.19 346.72 466.19 343.91C466.19 341.1 468.52 338.83 471.4 338.83C474.28 338.83 476.61 341.1 476.61 343.91Z"
        fill="url(#paint136_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M475.93 344.38C475.93 346.56 474.58 348.32 472.92 348.32C471.26 348.32 469.91 346.55 469.91 344.38C469.91 342.21 471.26 340.44 472.92 340.44C474.58 340.44 475.93 342.21 475.93 344.38Z"
        fill="url(#paint137_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M492.06 337.3H494.85C494.85 337.3 493.63 339.77 493.37 342.38H490.58C490.58 342.38 490.91 339.1 492.06 337.3Z"
        fill="#482F54"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M498.26 344.38C498.26 347.18 495.93 349.46 493.05 349.46C490.17 349.46 487.84 347.19 487.84 344.38C487.84 341.57 490.17 339.3 493.05 339.3C495.93 339.3 498.26 341.57 498.26 344.38Z"
        fill="url(#paint138_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M497.58 344.85C497.58 347.03 496.23 348.79 494.57 348.79C492.91 348.79 491.56 347.02 491.56 344.85C491.56 342.68 492.91 340.91 494.57 340.91C496.23 340.91 497.58 342.68 497.58 344.85Z"
        fill="url(#paint139_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M483.73 223.04H534.68C534.68 223.04 523.12 225.77 509.21 225.77C495.3 225.77 483.74 223.04 483.74 223.04H483.73Z"
        fill="#26132A"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M537.09 195.52L533.2 198.25C533.2 198.25 509.4 192.21 482.5 198.25L478.31 195.76C478.31 195.76 504.36 186.37 537.09 195.52Z"
        fill="url(#paint140_radial_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.55"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M534.68 201.53C537.22 202.19 537.62 211.09 535.56 212.1C533.5 213.11 534.01 209.08 532.33 206.82C530.65 204.56 530.84 200.53 534.68 201.54V201.53Z"
        fill="url(#paint141_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M530.78 225.77C528.07 225.3 520.19 226.91 508.4 227.09C496.61 227.28 485.67 225.11 485.67 225.11C485.67 225.11 501.35 230.2 509.96 229.64C518.57 229.07 530.77 225.77 530.77 225.77H530.78Z"
        fill="url(#paint142_radial_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.55"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M535.37 223.96C535.37 223.96 537.73 226.88 535.37 230.85C535.37 230.85 532.51 226.97 535.37 223.96Z"
        fill="url(#paint143_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.55"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M484.22 264.39C484.22 264.39 483.84 248.59 481.71 245.12C481.71 245.12 482.08 257.63 484.22 264.39Z"
        fill="url(#paint144_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M696.61 308.7C696.61 308.7 702.73 281.51 703.17 263.85H696.61C696.61 263.85 696.46 293.99 692.97 308.7H696.61Z"
        fill="url(#paint145_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M687.69 268.46L696.61 263.85C696.61 263.85 697.04 292.84 692.97 308.7H692.15C692.15 308.7 696.42 285.8 695.11 266.84L687.51 271.77L687.68 268.45L687.69 268.46Z"
        fill="url(#paint146_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M688.78 270.96L695.27 269.78L695.12 266.85L688.78 270.96Z"
        fill="#5A3361"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M623.9 308.05C623.9 308.05 617.88 281.51 617.43 263.85H623.99C623.99 263.85 624.14 293.99 627.63 308.7L623.9 308.05Z"
        fill="url(#paint147_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M632.92 268.46L624 263.85C624 263.85 623.57 292.84 627.64 308.7H628.46C628.46 308.7 624.19 285.8 625.5 266.84L633.1 271.77L632.93 268.45L632.92 268.46Z"
        fill="url(#paint148_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M631.82 270.96L625.33 269.78L625.48 266.85L631.82 270.96Z"
        fill="#5A3361"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M689.14 197.02C689.14 197.02 691.17 258.54 687.6 296.06L633.06 297.37C633.06 297.37 626.23 228 625.74 197.28L689.14 197.02Z"
        fill="url(#paint149_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M686.22 297.05C686.22 297.05 690.65 233.9 689.14 197.02C689.14 197.02 659.71 185.55 625.74 197.28C625.74 197.28 629.17 262.06 635.12 299.07L686.22 297.05Z"
        fill="url(#paint150_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M662.87 329.41L679.16 339.12C679.16 339.12 680.36 341.52 680.64 344.2H679.18C679.18 344.2 678.25 342.03 677.73 341.38C676.6 339.96 661.91 336.33 661.91 336.33L660.08 329.41H662.87Z"
        fill="#180B1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M663.52 329.41L679.81 339.12C679.81 339.12 681.01 341.52 681.29 344.2H679.83C679.83 344.2 678.9 342.03 678.38 341.38C677.25 339.96 662.56 336.33 662.56 336.33L662.32 335.09L663.53 329.41H663.52Z"
        fill="url(#paint151_radial_2072_10275)"
      />
      <path
        d="M681.6 351.28C684.477 351.28 686.81 349.005 686.81 346.2C686.81 343.394 684.477 341.12 681.6 341.12C678.723 341.12 676.39 343.394 676.39 346.2C676.39 349.005 678.723 351.28 681.6 351.28Z"
        fill="url(#paint152_radial_2072_10275)"
      />
      <path
        d="M683.4 350.14C685.062 350.14 686.41 348.376 686.41 346.2C686.41 344.024 685.062 342.26 683.4 342.26C681.738 342.26 680.39 344.024 680.39 346.2C680.39 348.376 681.738 350.14 683.4 350.14Z"
        fill="url(#paint153_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M699.72 308.91C699.72 308.91 670.29 314.36 621.39 307.89C621.39 307.89 629.84 307.3 652.96 307.89L699.72 308.91Z"
        fill="url(#paint154_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M621.39 304.97H699.72V308.91L621.39 307.89V304.97Z"
        fill="url(#paint155_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M699.72 304.97C699.72 304.97 700.43 298.9 698.02 296.86C698.02 296.86 663.28 292.55 621.39 299.42V304.98L652.3 304.96L699.72 304.98V304.97Z"
        fill="url(#paint156_radial_2072_10275)"
      />
      <g style={{ mixBlendMode: 'screen' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M621.39 304.97V299.41C650.7 297.92 668.36 296.83 698.02 296.85C698.02 296.85 700.55 298.76 699.72 304.96H621.39V304.97Z"
          fill="#41243F"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M698.02 296.85L659.71 297.58C659.71 297.58 640.12 297.51 621.4 299.4C621.4 299.4 648.59 292.4 698.03 296.84L698.02 296.85Z"
        fill="#714A6A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M673.75 310.3H646.41C646.41 310.3 652.19 314.34 660.08 314.34C667.97 314.34 673.75 310.3 673.75 310.3Z"
        fill="#180B1C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M663.91 314.13L663.14 327.36H658.1L657.6 314.1L663.91 314.13Z"
        fill="url(#paint157_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M664.51 322.17H657L657.75 336.02H663.62L664.51 322.17Z"
        fill="url(#paint158_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M663.91 329.1L700.51 338.81C700.51 338.81 703.21 341.21 703.83 343.89H700.55C700.55 343.89 698.45 341.72 697.29 341.07C694.75 339.65 661.74 336.02 661.74 336.02L661.2 334.78L663.91 329.1Z"
        fill="url(#paint159_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M695.35 345.41C695.35 348.21 697.68 350.49 700.56 350.49C703.44 350.49 705.77 348.22 705.77 345.41C705.77 342.6 703.44 340.33 700.56 340.33C697.68 340.33 695.35 342.6 695.35 345.41Z"
        fill="url(#paint160_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M696.03 345.89C696.03 348.07 697.38 349.83 699.04 349.83C700.7 349.83 702.05 348.06 702.05 345.89C702.05 343.72 700.7 341.95 699.04 341.95C697.38 341.95 696.03 343.72 696.03 345.89Z"
        fill="url(#paint161_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M657.37 329.1L620.77 338.81C620.77 338.81 618.07 341.21 617.45 343.89H620.73C620.73 343.89 622.83 341.72 623.99 341.07C626.53 339.65 659.54 336.02 659.54 336.02L660.08 334.78L657.37 329.1Z"
        fill="url(#paint162_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M657.67 329.1L641.38 338.81C641.38 338.81 640.18 341.21 639.9 343.89H641.36C641.36 343.89 642.29 341.72 642.81 341.07C643.94 339.65 658.63 336.02 658.63 336.02L660.46 329.1H657.67Z"
        fill="#714A6A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M660.46 329.1L644.17 338.81C644.17 338.81 642.97 341.21 642.69 343.89H644.15C644.15 343.89 645.08 341.72 645.6 341.07C646.73 339.65 661.42 336.02 661.42 336.02L661.66 334.78L660.45 329.1H660.46Z"
        fill="url(#paint163_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M625.93 345.41C625.93 348.21 623.6 350.49 620.72 350.49C617.84 350.49 615.51 348.22 615.51 345.41C615.51 342.6 617.84 340.33 620.72 340.33C623.6 340.33 625.93 342.6 625.93 345.41Z"
        fill="url(#paint164_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M625.26 345.89C625.26 348.07 623.91 349.83 622.25 349.83C620.59 349.83 619.24 348.06 619.24 345.89C619.24 343.72 620.59 341.95 622.25 341.95C623.91 341.95 625.26 343.72 625.26 345.89Z"
        fill="url(#paint165_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M641.38 338.81H644.17C644.17 338.81 642.95 341.28 642.69 343.89H639.9C639.9 343.89 640.23 340.61 641.38 338.81Z"
        fill="#482F54"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M647.58 345.89C647.58 348.69 645.25 350.97 642.37 350.97C639.49 350.97 637.16 348.7 637.16 345.89C637.16 343.08 639.49 340.81 642.37 340.81C645.25 340.81 647.58 343.08 647.58 345.89Z"
        fill="url(#paint166_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M646.9 346.36C646.9 348.54 645.55 350.3 643.89 350.3C642.23 350.3 640.88 348.53 640.88 346.36C640.88 344.19 642.23 342.42 643.89 342.42C645.55 342.42 646.9 344.19 646.9 346.36Z"
        fill="url(#paint167_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M633.05 224.54H684C684 224.54 672.44 227.27 658.53 227.27C644.62 227.27 633.06 224.54 633.06 224.54H633.05Z"
        fill="#26132A"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M686.41 197.03L682.52 199.76C682.52 199.76 658.72 193.72 631.82 199.76L627.63 197.27C627.63 197.27 653.68 187.88 686.41 197.03Z"
        fill="url(#paint168_radial_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.55"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M684 203.03C686.54 203.69 686.94 212.59 684.88 213.6C682.82 214.61 683.33 210.58 681.65 208.32C679.97 206.06 680.16 202.03 684 203.04V203.03Z"
        fill="url(#paint169_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M680.1 227.28C677.39 226.81 669.51 228.42 657.72 228.6C645.93 228.79 634.99 226.62 634.99 226.62C634.99 226.62 650.67 231.71 659.28 231.15C667.89 230.58 680.09 227.28 680.09 227.28H680.1Z"
        fill="url(#paint170_radial_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.55"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M684.69 225.46C684.69 225.46 687.05 228.38 684.69 232.35C684.69 232.35 681.83 228.47 684.69 225.46Z"
        fill="url(#paint171_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.55"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M633.54 265.89C633.54 265.89 633.16 250.09 631.03 246.62C631.03 246.62 631.4 259.13 633.54 265.89Z"
        fill="url(#paint172_linear_2072_10275)"
      />
      <path
        d="M462.24 213.01C456.92 216.89 451.65 220.94 451.65 220.94C452.04 222.06 452.43 223.16 452.82 224.23L441.3 247.36C441.3 247.36 447.49 246.28 449.78 245.21C454.21 243.14 476.11 231.53 476.11 231.53L478.23 230.64C478.23 230.64 478.64 223.49 479.2 221.77C479.76 220.04 481.14 203.83 481.14 203.83C471.23 205.99 467.3 209.31 462.24 213V213.01Z"
        fill="#F1F0F4"
      />
      <path
        d="M503.15 349.78C505.02 335.9 506.56 324.28 506.56 324.28C506.56 324.31 507.23 324.33 507.23 324.36C507.3 318.53 507.62 312.69 508.38 306.96C509 300.72 506.38 295.08 506.1 288.91C498.59 288.4 491.35 288.75 490.59 291.88C487.31 305.37 483.17 340.08 483.17 341.54C483.17 342.06 483.03 347.38 482.78 354.3C489.59 352.87 496.37 351.36 503.15 349.8V349.78Z"
        fill="url(#paint173_linear_2072_10275)"
      />
      <path
        d="M488.14 353.14C489.99 343.47 491.7 334.81 491.7 334.12C491.7 332.66 497.88 298.82 501.16 285.33C502.79 278.63 476.93 290.49 476.93 290.49L476.83 355.53C480.6 354.77 484.37 353.97 488.14 353.15V353.14Z"
        fill="url(#paint174_linear_2072_10275)"
      />
      <path
        d="M508.18 324.36C508.18 324.36 507.03 322.54 507.03 322.52C507.03 322.52 508.72 333.81 510.86 347.99C510.96 347.97 511.06 347.94 511.16 347.92C518.15 346.28 525 345.67 531.71 346.05C531.63 343.49 531.59 341.81 531.59 341.53C531.59 340.07 527.45 305.36 524.17 291.87C523.41 288.74 516.17 288.39 508.66 288.9C508.38 295.07 505.76 300.72 506.38 306.95C507.14 312.68 508.12 318.53 508.19 324.35L508.18 324.36Z"
        fill="url(#paint175_linear_2072_10275)"
      />
      <path
        d="M523.06 334.12C523.06 334.63 524 339.55 525.24 346C529.52 345.84 533.74 346.07 537.91 346.69L537.83 290.49C537.83 290.49 511.97 278.63 513.6 285.33C516.88 298.82 523.06 332.67 523.06 334.12Z"
        fill="url(#paint176_linear_2072_10275)"
      />
      <path
        d="M564.6 230.62C564.6 230.62 546.8 208.98 539.81 206.13C539.81 206.13 535.75 220.36 535.36 222.13C534.97 223.9 535.08 233.56 535.08 233.56L549.34 247.51C549.34 247.51 558.31 238.78 564.6 230.61V230.62Z"
        fill="#F1F0F4"
      />
      <path
        d="M494.97 195.03C494.97 195.03 496.51 192.12 505.76 191.8C511 191.62 517.95 192.88 519.58 195.03C519.58 195.03 520.85 204.24 507.66 204.23C492.99 204.23 494.97 195.03 494.97 195.03Z"
        fill="#B5B4B8"
      />
      <path
        d="M492.1 200.59C492.1 200.59 495.62 199.03 497.42 197.74L497.91 188.78L517.32 189.61C517.32 189.61 517.86 196.98 518.02 197.74C518.18 198.49 523.47 200.59 523.47 200.59C523.47 200.59 518.31 210.25 507.31 210.77C498.79 211.17 491.83 203.6 492.1 200.59Z"
        fill="url(#paint177_linear_2072_10275)"
      />
      <path
        d="M539.04 229.37C539.84 224.3 539.81 206.14 539.81 206.14C534.31 203.62 520.1 199.11 520.1 199.11C520.1 199.11 518.24 206.22 510.48 207.5C508.14 206.79 503.53 206.27 503.02 206.27C499.94 205.36 494.09 199.54 494.09 199.54C479.92 203.93 475.54 206.14 475.54 206.14C475.97 207 474.74 222.1 475.95 229.37C475.95 229.37 477.69 234.4 477.68 234.89C477.39 254.25 477.18 280.4 477.18 309.19C477.18 310.33 503.95 310.36 509.07 309.96C514.09 309.57 538.64 309.85 538.67 308.2C539.07 282.82 537.86 259.56 537.59 234.89C537.57 233.42 539.04 229.37 539.04 229.37Z"
        fill="#F1F0F4"
      />
      <path
        d="M485.32 217.98C492.58 213.71 496.78 215.04 508.1 215.36C519.42 215.68 526.69 213.44 530.75 217.5C534.81 221.56 533.22 238.38 510.45 239.93C483.69 241.75 478.05 222.26 485.32 217.99V217.98Z"
        fill="url(#paint178_linear_2072_10275)"
      />
      <path
        d="M535.09 226.83C534.75 228.47 535.08 233.57 534.54 238.79C534.23 241.76 538.18 263.56 538.18 263.56C538.18 263.56 538.18 256.41 537.75 236.18C537.75 236.18 535.29 225.82 535.09 226.82V226.83Z"
        fill="url(#paint179_linear_2072_10275)"
      />
      <path
        d="M480.29 226.89C480.63 228.53 480.3 233.63 480.84 238.85C481.15 241.82 477.36 263.01 477.36 263.01C477.36 263.01 477.47 251.03 477.63 235.8C477.63 235.8 480.08 225.89 480.29 226.89Z"
        fill="url(#paint180_linear_2072_10275)"
      />
      <path
        d="M508.38 210.21C508.41 211.06 507.79 211.77 506.98 211.8C506.17 211.83 505.49 211.17 505.46 210.32C505.43 209.47 506.05 208.76 506.86 208.73C507.67 208.7 508.35 209.36 508.38 210.21Z"
        fill="url(#paint181_linear_2072_10275)"
      />
      <path
        d="M453.51 219.45L464.82 211.12C464.82 211.12 457.38 225.23 455.32 231.26C453.91 235.4 451.48 243.25 444.78 246.23L453.5 219.45H453.51Z"
        fill="url(#paint182_linear_2072_10275)"
      />
      <path
        d="M436.73 246.67C437.07 247.21 437.48 247.14 438.19 247.23C438.9 247.32 443.6 248.03 447.05 245.1C450.51 242.17 451.66 236.13 452.01 231.44C452.36 226.75 455.56 217 455.91 215.94C456.26 214.88 458.3 210.53 458.39 210.27C458.48 210 447.49 209.29 447.49 209.29C447.49 209.29 446.06 215.1 445.06 216.85C443.86 218.95 442.65 220 437.82 229.15C437.21 230.31 434.76 243.57 436.71 246.67H436.73Z"
        fill="#F7D4AB"
      />
      <path
        d="M440.85 217.59C440.85 217.59 440.65 217.05 443.53 216.66C445.82 216.35 453.52 216.5 455.77 218.47C455.77 218.47 448.21 224.36 443.27 221.47C441 220.15 440.85 217.59 440.85 217.59Z"
        fill="url(#paint183_linear_2072_10275)"
      />
      <path
        d="M459.24 208.26C459.33 207.98 447.75 207.23 447.75 207.23C447.75 207.23 446.56 212.21 445.76 214.65C445.33 215.98 444.84 217.22 444.02 218.49C447.61 220.27 450.92 221.17 454.8 219.84C455.61 217.05 456.46 214.72 456.62 214.23C456.99 213.11 459.14 208.53 459.23 208.25L459.24 208.26Z"
        fill="#F7D4AB"
      />
      <path
        d="M464.08 192.07C464.08 192.07 462.92 182.54 462.84 182.15C461.96 177.71 461.82 171.38 460.17 171.38C458.52 171.38 458.57 173.85 458.98 177.18C459.39 180.51 459.26 187.92 459.26 187.92L447.86 193.77C447.86 193.77 447.1 194.54 447.07 195.07C447.04 195.6 448.24 199.86 448.08 200.47C447.92 201.08 447.84 204.69 447.96 205.64C448.08 206.59 446.71 211.03 446.71 211.03L455.18 213.92L464.07 192.07H464.08Z"
        fill="#F7D4AB"
      />
      <path
        d="M460.36 171.41C460.36 171.41 461.1 171.47 461.67 173.27C462.22 175 463.95 191.14 463.95 191.14C463.95 191.14 461.53 176.59 461.34 175.02C461.04 172.57 460.36 171.42 460.36 171.42V171.41Z"
        fill="url(#paint184_linear_2072_10275)"
      />
      <path
        d="M457.62 188.76L464.04 191.72L463.82 189.91L458.38 187.5L457.62 188.76Z"
        fill="url(#paint185_linear_2072_10275)"
      />
      <path
        d="M454.48 206.83C454.48 206.83 459.71 200.7 461.58 199.36C463.45 198.01 460.52 192.63 460.52 192.63L457.09 190.25L450.94 200.64C450.94 200.64 453.64 204.44 454.48 206.84V206.83Z"
        fill="url(#paint186_linear_2072_10275)"
      />
      <path
        d="M455.84 216.6C455.84 216.6 459.06 209.3 459.15 209.17C459.24 209.04 465.25 200.35 465.17 200.03C465.09 199.71 465.03 191.84 464.45 191.54C463.87 191.24 459.19 188.91 458.87 189.11C458.55 189.31 458.18 190.79 458.18 191.38C458.18 191.97 460.96 194.46 460.96 194.46C460.96 194.46 460.36 196.81 460.39 197.75C460.39 197.75 456.32 200.6 454.62 201.96C452.93 203.32 453.76 208.73 453.76 208.73L452.1 215.12L455.82 216.59L455.84 216.6Z"
        fill="#F7D4AB"
      />
      <path
        d="M448.09 192.72C448.09 192.72 447.22 194.25 447.08 195.07C446.94 195.89 447.53 199.83 447.61 200.59C447.69 201.35 447.91 205.25 447.78 205.84C447.64 206.44 446.55 211.99 446.55 211.99C446.55 211.99 449.63 207.46 449.72 207.33C449.81 207.2 448.12 203 448.79 201.62C449.46 200.24 450.55 199.08 450.55 199.08L448.1 192.71L448.09 192.72Z"
        fill="url(#paint187_linear_2072_10275)"
      />
      <path
        d="M459.56 171.53C459.56 171.53 458.69 171.92 458.64 173.27C458.62 173.79 458.86 176.66 458.98 178.58C459.24 182.82 459.27 187.5 459.27 187.5C459.27 187.5 460.06 182.83 459.36 177.8C458.99 175.13 458.91 173.88 459.01 172.99C459.13 171.88 459.55 171.54 459.55 171.54L459.56 171.53Z"
        fill="url(#paint188_linear_2072_10275)"
      />
      <path
        d="M458.29 190.57C458.29 190.57 458.01 192.07 458.36 192.73C458.71 193.39 460.39 194.9 460.39 194.9V197.76L460.96 199.74C460.96 199.74 461.08 195.79 462 194.33C462 194.33 459.12 193.34 458.29 190.57Z"
        fill="url(#paint189_linear_2072_10275)"
      />
      <path
        d="M461.75 190.23C461.75 190.23 464.43 191.31 464.73 191.72C465.13 192.27 465.23 199.83 465.27 200.1C465.3 200.37 460.43 207.3 460.43 207.3C460.43 207.3 463.79 200.67 463.81 200C463.83 199.33 463.65 192.26 463.41 191.9C463.18 191.53 461.75 190.22 461.75 190.22V190.23Z"
        fill="url(#paint190_linear_2072_10275)"
      />
      <path
        d="M448.37 193.89C448.37 193.89 449.53 200.18 450.36 201.51C450.72 202.09 451.34 202.4 452.21 202.22L448.38 193.9L448.37 193.89Z"
        fill="url(#paint191_linear_2072_10275)"
      />
      <path
        d="M448.18 193.13C448.3 193.83 450.35 200.45 450.45 200.93C450.71 202.23 453.82 202.1 453.38 200.34C452.65 197.46 451.07 191.32 451.07 191.32C451.07 191.32 449.64 191.14 448.71 191.93C448.39 192.21 448.1 192.72 448.1 192.72C448.1 192.72 448.15 192.93 448.19 193.13H448.18Z"
        fill="#F7D4AB"
      />
      <path
        d="M451.58 198.74C451.21 198.8 450.74 199.07 450.74 199.41C450.74 200.02 450.82 201.01 451.16 201.32C451.48 201.6 452.47 201.53 452.72 200.95C452.82 200.72 452.79 199.41 452.35 199.02C452.17 198.86 451.82 198.7 451.57 198.74H451.58Z"
        fill="#FFDEBD"
      />
      <path
        d="M451.06 191.32C450.74 191.22 450 191.36 450 191.36C450 191.36 451.25 199.48 451.94 200.22C452.63 200.96 453.37 201 453.37 201C453.37 201 453.49 200.71 453.49 200.38C453.07 198.26 451.44 191.43 451.07 191.32H451.06Z"
        fill="url(#paint192_linear_2072_10275)"
      />
      <path
        d="M451.26 188.34C451.48 187.88 453.75 186.76 454.35 188.14C454.96 189.53 455.14 198.9 455.1 199.55C455.03 200.69 452.9 201.37 452.18 200.14C451.12 198.33 450.8 189.29 451.25 188.34H451.26Z"
        fill="#F7D4AB"
      />
      <path
        d="M461.25 190C461.59 190.15 460.89 191.59 460.04 191.39C459.63 191.29 457.39 189.87 457.59 189.52C457.78 189.18 457.75 188.72 458.58 188.85C459.42 188.98 460.91 189.85 461.25 190Z"
        fill="#FFDEBD"
      />
      <path
        d="M453.34 187.48C453.34 187.48 454.09 187.47 454.47 188.07C454.87 188.69 455.07 197.49 455.07 197.49C455.07 197.49 454.35 197.03 453.88 196.15C453.42 195.27 453.33 187.49 453.33 187.49L453.34 187.48Z"
        fill="url(#paint193_linear_2072_10275)"
      />
      <path
        d="M459.27 187.92C459.27 187.92 458.18 191.83 458.14 192.19C458.1 192.55 457.62 195.7 457.14 196.3C456.66 196.9 455.13 197.34 454.41 196.33C453.69 195.32 454.3 190.1 454.3 190.1C454.3 190.1 454.28 185.06 455.18 184.13C455.73 183.56 458.26 183.58 458.58 184.92C458.91 186.25 459.28 187.92 459.28 187.92H459.27Z"
        fill="#F7D4AB"
      />
      <path
        d="M458.77 185.72C458.77 185.72 458.52 184.03 458.14 183.9C457.32 183.6 455.41 183.7 455.11 184.11C454.61 184.8 454.56 186.02 454.56 186.02C454.56 186.02 455.08 184.39 455.62 184.35C456.16 184.31 457.38 184.14 457.94 184.34C458.19 184.43 458.77 185.73 458.77 185.73V185.72Z"
        fill="url(#paint194_linear_2072_10275)"
      />
      <path
        d="M456.03 193.53C455.55 193.47 454.86 193.48 454.74 193.91C454.53 194.69 454.32 195.66 454.65 196.17C454.96 196.65 456.62 197.04 456.85 196.25C456.94 195.94 457.32 194.66 456.9 194.02C456.72 193.75 456.35 193.57 456.03 193.53Z"
        fill="#FFDEBD"
      />
      <path
        d="M453.5 197.32C453.02 197.3 452.33 197.35 452.25 197.79C452.1 198.58 451.96 199.56 452.33 200.04C452.67 200.49 454.35 200.75 454.52 199.96C454.59 199.64 454.87 198.35 454.4 197.74C454.2 197.48 453.82 197.33 453.5 197.32Z"
        fill="#FFDEBD"
      />
      <path
        d="M460.9 201.89C461.18 203.1 459.75 208.62 455.78 208.48C451.81 208.34 455.41 203 456.7 202.19C457.99 201.38 460.34 199.46 460.9 201.9V201.89Z"
        fill="url(#paint195_linear_2072_10275)"
      />
      <path
        d="M460.43 207.31C460.43 207.31 457.39 210.84 456.37 211.05C455.35 211.26 455.94 216.38 455.94 216.38C455.94 216.38 457.43 212.95 457.95 211.85C458.45 210.8 460.43 207.31 460.43 207.31Z"
        fill="url(#paint196_linear_2072_10275)"
      />
      <path
        d="M458.16 192.08L459.27 187.92L458.84 186.02L458.16 192.08Z"
        fill="url(#paint197_linear_2072_10275)"
      />
      <path
        d="M443.04 219.99L444.03 218.5C444.03 218.5 446.03 218.97 449.1 218.71C450.72 218.57 454.4 217.84 455.69 217L454.41 221.2L443.04 220V219.99Z"
        fill="url(#paint198_linear_2072_10275)"
      />
      <path
        d="M440.85 217.59C440.85 217.59 440.64 219.35 446.34 219.6C452.55 219.87 454.3 219.08 455.77 218.46C455.77 218.46 452.37 235.81 451.95 237.92C451.53 240.03 448.94 249.3 436.8 247.14C436.8 247.14 435.11 238.65 436.8 232.26C438.49 225.87 439.93 219.74 440.85 217.58V217.59Z"
        fill="#F1F0F4"
      />
      <path
        d="M440.85 217.59C440.85 217.59 438.63 224.78 436.41 230.17C435.35 232.76 434.35 242.25 435.16 245.48C435.5 246.84 436.8 247.15 436.8 247.15C436.8 247.15 435.95 244.17 438.3 231.26C438.81 228.44 440.85 217.59 440.85 217.59Z"
        fill="url(#paint199_linear_2072_10275)"
      />
      <path
        d="M438.79 240.93C440.35 244.29 442.95 241.43 444.07 239.67C445.19 237.91 451.96 219.49 451.96 219.49C451.96 219.49 444.09 220.25 441.46 218.5C441.46 218.5 436.94 236.94 438.79 240.93Z"
        fill="url(#paint200_linear_2072_10275)"
      />
      <path
        d="M507.78 209.99C507.81 210.84 507.19 211.55 506.38 211.58C505.57 211.61 504.89 210.95 504.86 210.1C504.83 209.25 505.45 208.54 506.26 208.51C507.07 208.48 507.75 209.14 507.78 209.99Z"
        fill="url(#paint201_linear_2072_10275)"
      />
      <path
        d="M495.8 198.01C495.8 198.01 503.3 199.76 503.93 200.46C504.56 201.16 504.79 206.19 504.79 206.19L509.68 206.27C509.68 206.27 509.91 202.09 511.48 201.15C511.84 200.93 516.64 198.8 518.35 197.29C518.35 197.29 510.83 204.69 510.48 207.5C507.98 206.53 503.02 206.27 503.02 206.27L495.81 198.01H495.8Z"
        fill="url(#paint202_linear_2072_10275)"
      />
      <path
        d="M480.34 238.02C479.37 228.73 478.32 222.94 478.32 222.94C478.32 222.94 467.4 232.73 456.23 239.48C447.74 244.61 438.83 247.22 436.05 246.82C436.05 246.82 438.23 247.91 442.79 247.91C443.81 247.91 447.12 247.3 450.02 245.99C451.14 245.48 476.01 231.83 476.13 231.83C476.9 231.83 478.07 255.11 478.07 255.11C478.07 255.11 480.57 240.28 480.34 238.01V238.02Z"
        fill="url(#paint203_linear_2072_10275)"
      />
      <path
        d="M503.02 206.27C504.5 206.27 508.49 206.13 510.29 207.32C512.09 208.52 504.98 232.03 504.98 232.03C504.98 232.03 510.17 208.79 509.58 207.8C509.04 206.88 503.69 206.49 503.03 206.27H503.02Z"
        fill="url(#paint204_linear_2072_10275)"
      />
      <path
        d="M485.95 217.98L477.51 253.45L477.55 243.63L485.95 217.98Z"
        fill="url(#paint205_linear_2072_10275)"
      />
      <path
        d="M505.09 206.59C505.09 206.59 509.25 206.84 509.57 207.8C509.85 208.64 509.48 213.7 506.85 223.34C506.85 223.34 509.34 209.61 508.13 208.44C506.92 207.27 505.08 206.58 505.08 206.58L505.09 206.59Z"
        fill="url(#paint206_linear_2072_10275)"
      />
      <path
        d="M476.1 355.67C487.83 353.31 499.5 350.66 511.15 347.92C521.95 345.38 532.41 345.3 542.53 347.54L538.06 250.5L529.36 221.46H485.07L477.43 250.65L471.21 357.11C472.8 356.56 474.42 356.07 476.1 355.67Z"
        fill="#333333"
      />
      <path
        d="M528.51 217.98L538.13 254.04L537.92 244.43L528.51 217.98Z"
        fill="url(#paint207_linear_2072_10275)"
      />
      <path
        d="M518.21 228.24C527.2 229.31 528.34 238.18 528.16 241.17C527.98 244.16 518.36 253.65 506.58 252.79C494.8 251.93 487.72 246.99 486.31 241.61C485.19 237.34 486.29 230.07 496.17 228.71C499.2 228.29 514.11 227.75 518.22 228.23L518.21 228.24Z"
        fill="url(#paint208_linear_2072_10275)"
      />
      <path
        d="M529.84 223.05L538.36 250.51L540.81 310.19L529.84 223.05Z"
        fill="url(#paint209_linear_2072_10275)"
      />
      <path
        d="M484.68 222.95L477.43 250.65L474.19 306.14L484.68 222.95Z"
        fill="url(#paint210_linear_2072_10275)"
      />
      <path
        d="M510.48 207.5C510.48 207.5 510.78 201.93 512.43 201.37C512.66 201.29 519.39 197.89 519.59 195.02L521.35 200.77C521.35 200.77 519.09 206.77 510.48 207.49V207.5Z"
        fill="#F1F0F5"
      />
      <path
        d="M510.48 207.5C510.48 207.5 516.8 207.66 520.72 201.96C520.72 201.96 516.64 206.39 510.48 207.5Z"
        fill="url(#paint211_linear_2072_10275)"
      />
      <path
        d="M503.14 207.18C503.14 207.18 502.84 201.61 501.19 201.05C500.96 200.97 494.48 199 494.97 195.03L493 202.04C493 202.04 494.88 207.24 503.14 207.18Z"
        fill="#F1F0F5"
      />
      <path
        d="M503.14 207.18C503.14 207.18 495.69 208.17 494.48 202.14C494.48 202.14 496.47 206.74 503.14 207.18Z"
        fill="url(#paint212_linear_2072_10275)"
      />
      <path
        d="M529.37 221.46C529.37 221.46 524.23 197.99 520.17 196.91L520.62 198.37C520.62 198.37 523.33 203.13 526.43 221.46H529.38H529.37Z"
        fill="url(#paint213_linear_2072_10275)"
      />
      <path
        d="M510.48 207.5C510.48 207.5 510.65 201.86 512.1 201.31C513.27 200.86 516.64 199.03 518.94 196.58C518.94 196.58 516.97 199.99 514.08 201.51C512.16 202.52 510.58 206.71 510.49 207.5H510.48Z"
        fill="url(#paint214_linear_2072_10275)"
      />
      <path
        d="M495.66 197.57C495.66 197.57 496.48 198.8 499.11 199.94C501.17 200.83 502.28 200.32 502.87 203.74C503.27 206.07 503.02 207.18 503.02 207.18C503.02 207.18 502.34 203.65 501.18 201.97C500.41 200.85 496.09 199.77 495.66 197.57Z"
        fill="url(#paint215_linear_2072_10275)"
      />
      <path
        d="M547.48 268.51C547.48 268.51 545.01 271.92 543.94 272.53C542.87 273.14 536.33 274.53 535.53 274.7C534.74 274.87 530.51 275.98 528.94 276.94C527.38 277.9 524.58 279.96 523.72 280.98C523.24 281.55 522.96 282.14 523.61 282.73C524.26 283.32 525.32 282.99 526.34 282.11C526.96 281.57 529.66 280.35 530.96 279.84C532.25 279.33 534.3 279.29 534.72 279.46C535.62 279.84 532.15 282.43 530.95 283.81C529.78 285.17 527.68 287.19 527.08 287.84C526.48 288.49 525.09 290.09 526.18 291.04C527.27 291.99 529.51 289.34 531 288.27C532.64 287.1 536.47 282.88 537.8 282.41C538.83 282.04 535.42 285.52 534.51 286.38C533.6 287.24 529.7 290.9 529.7 290.9C529.7 290.9 528.44 292.23 529.35 293.11C530.62 294.34 532.35 292.22 533.64 291.13C534.53 290.37 538.21 287.33 538.55 287.05C538.89 286.77 540.42 285.28 540.79 285.43C541.71 285.82 537.93 289.45 537.59 289.85C536.58 291 535.77 291.98 535.65 292.53C535.43 293.59 536.24 293.79 537.05 293.39C537.86 292.99 539.36 291.87 539.63 291.51C539.9 291.14 545.01 286.07 546.3 284.69C547.59 283.31 551.4 280.57 552.15 277.38C552.5 275.89 553.92 274.96 553.58 274.62L547.48 268.51Z"
        fill="#F7D4AB"
      />
      <path
        d="M529.54 291.5C529.83 291.1 532.37 289.01 532.76 288.67C533.74 287.82 536.27 287.99 534.12 290.22C531.53 292.9 530.4 293.4 530.09 293.33C529.78 293.26 528.75 292.63 529.55 291.51L529.54 291.5Z"
        fill="url(#paint216_linear_2072_10275)"
      />
      <path
        d="M531.59 291.33C531.39 290.87 530.81 290.75 530.31 291.12C530.09 291.28 529.33 291.89 529.28 292.27C529.21 292.78 529.76 293.16 529.85 293.17C530 293.18 530.38 293.45 530.84 292.93C531.29 292.41 531.81 291.84 531.59 291.33Z"
        fill="#FFDEBD"
      />
      <path
        d="M551.25 275.78C552.48 276.45 546.94 284.54 545.64 284.27C544.7 284.07 537.03 274.73 538.05 274.47C540.04 273.96 545 272.57 545 272.57C544.82 274.62 550.31 275.28 551.25 275.79V275.78Z"
        fill="url(#paint217_linear_2072_10275)"
      />
      <path
        d="M543.64 272.65C540.8 273.75 535.46 274.56 533.27 275.3C533.27 275.3 540.88 275.1 544 274.05C545.94 273.4 550.41 264.08 549.88 263.74C546.95 268.51 543.64 272.65 543.64 272.65Z"
        fill="url(#paint218_linear_2072_10275)"
      />
      <path
        d="M523.61 282.74C523.61 282.74 524.88 283.42 527.56 281.05C530.08 278.82 531.47 278.03 532.4 277.93C533.34 277.83 536.87 277.48 537.28 277.72C537.7 277.96 530.5 284.84 529.68 285.19C531.9 282.38 535.36 279.96 534.68 279.51C534.35 279.29 532.14 279.34 530.95 279.84C529.76 280.34 525.68 282.8 525.07 282.96C524.47 283.12 524.02 283.17 523.6 282.73L523.61 282.74Z"
        fill="url(#paint219_linear_2072_10275)"
      />
      <path
        d="M528.28 290.54C528.28 290.54 533.46 285.79 533.8 285.43C534.71 284.44 538.11 280.99 539.2 280.61C540.55 280.14 538.2 282.98 536.76 284.56C535.51 285.93 532.89 287.91 532.89 287.91C532.89 287.91 537.13 283.59 537.55 283.1C538.46 282.03 537.55 282.46 536.89 283.1C536.28 283.69 530.64 289.16 528.28 290.54Z"
        fill="url(#paint220_linear_2072_10275)"
      />
      <path
        d="M534.74 290.21C534.74 290.21 540.16 284.64 541.43 283.92C542.47 283.33 542.6 284.49 541.26 286.09C539.91 287.7 537.59 289.85 537.59 289.85C537.59 289.85 541.2 286.17 540.91 285.55C540.69 285.08 537.5 288.1 534.74 290.21Z"
        fill="url(#paint221_linear_2072_10275)"
      />
      <path
        d="M526.35 289.14C526.64 288.75 529.53 286.14 529.92 285.82C530.91 285 532.99 285.37 530.82 287.53C528.21 290.12 526.94 291.07 526.63 291.01C526.32 290.94 525.55 290.23 526.35 289.14Z"
        fill="url(#paint222_linear_2072_10275)"
      />
      <path
        d="M528.35 289.09C528.15 288.63 527.57 288.51 527.07 288.88C526.85 289.04 526.09 289.65 526.04 290.03C525.97 290.54 526.52 290.92 526.61 290.93C526.76 290.94 527.14 291.21 527.6 290.69C528.05 290.17 528.57 289.6 528.35 289.09Z"
        fill="#FFDEBD"
      />
      <path
        d="M527.67 278.04C527.95 277.89 528.95 277.33 529.43 277.88C530.16 278.72 526.73 281.16 526.07 281.77C525.12 282.65 522.68 282.68 524 281.05C525.32 279.42 527.38 278.19 527.66 278.04H527.67Z"
        fill="url(#paint223_linear_2072_10275)"
      />
      <path
        d="M525.7 280.63C525.41 280.38 524.91 280.24 524.44 280.63C523.97 281.03 523.41 281.47 523.37 281.91C523.34 282.32 523.81 282.86 524.46 282.73C524.72 282.68 525.94 281.87 525.99 281.32C526.01 281.09 525.89 280.79 525.7 280.62V280.63Z"
        fill="#FFDEBD"
      />
      <path
        d="M538.49 290.21C538.84 290.55 539.02 291.49 536.55 293.39C536.11 293.73 535.42 292.78 536.17 291.8C536.36 291.55 537.78 289.52 538.49 290.21Z"
        fill="url(#paint224_linear_2072_10275)"
      />
      <path
        d="M537.07 291.56C536.75 291.47 536.26 291.91 535.86 292.48C535.47 293.05 535.86 293.48 536.27 293.46C536.62 293.45 537.42 292.37 537.41 292.13C537.41 291.89 537.41 291.65 537.06 291.56H537.07Z"
        fill="#FFDEBD"
      />
      <path
        d="M559.47 270.52C559.47 270.52 551.55 275.5 551.24 275.78C550.93 276.06 549.89 279.57 546.91 282.87C543.93 286.17 537.04 293.39 537.04 293.39C537.04 293.39 538.75 292.69 541.11 290.03C543.71 287.1 549.72 281.85 550.74 280.4C552.19 278.33 552 277.62 554.08 275.63C556.17 273.63 557.58 272.53 559.47 270.52Z"
        fill="url(#paint225_linear_2072_10275)"
      />
      <path
        d="M544.69 271.3L552.23 277.9C552.23 277.9 552.7 277.18 552.73 277.14C552.76 277.09 553.88 275.8 553.88 275.8L545.42 270.27L544.69 271.3Z"
        fill="url(#paint226_linear_2072_10275)"
      />
      <path
        d="M564.6 230.62C564.6 230.62 572.88 240.08 574.64 246.95C576.41 253.82 556.99 279.69 556.99 279.69L544.69 270.2C544.69 270.2 552.67 252.46 552.88 251.7C553.09 250.94 549.34 247.51 549.34 247.51L564.6 230.61V230.62Z"
        fill="#F1F0F4"
      />
      <path
        d="M561.42 245.64C560.43 244.73 553.89 245.37 535.09 226.82L537.75 236.18C537.75 236.18 543.99 242 552.88 251.71C552.88 251.71 549.83 258.72 544.69 270.21C545.26 270.69 545.67 270.97 546.32 271.47C548.01 269.1 550.31 265.52 551.87 262.37C560.09 245.74 561.82 246.02 561.42 245.65V245.64Z"
        fill="url(#paint227_linear_2072_10275)"
      />
      <path
        d="M572.81 249.65C572.81 253.33 570.92 255.58 564.09 264.32C556.72 273.76 548.87 275.19 548.65 271.46C548.44 267.69 572.8 238.63 572.8 249.65H572.81Z"
        fill="url(#paint228_linear_2072_10275)"
      />
      <path
        d="M542.28 207.58C540.33 206.54 537.58 218.03 540.17 223.22C542.76 228.41 552.04 233.58 555.03 236.02C567.1 245.87 566.86 238.39 566.57 237.6C561.46 223.46 545.18 209.14 542.27 207.59L542.28 207.58Z"
        fill="url(#paint229_linear_2072_10275)"
      />
      <path
        d="M466.69 209.74C466.69 209.74 474.8 203.77 492.09 200.16C492.09 200.16 482.86 206.31 478.03 208.16C473.2 210.01 466.69 209.74 466.69 209.74Z"
        fill="url(#paint230_linear_2072_10275)"
      />
      <path
        d="M488.4 174.09C486.48 174.44 486.9 175.76 487.74 178.05C488.56 184.15 490.13 185.36 490.79 184.99C492.01 184.31 490.73 173.66 488.4 174.09Z"
        fill="#F0C499"
      />
      <path
        d="M489.96 182.77C489.96 182.77 489.06 181.63 489.42 179.49C490.27 174.44 487.17 173.93 487.76 177.44C487.76 177.44 488.24 175.82 488.62 176.33C489.08 176.96 488.07 177.24 488.5 179.89C488.72 181.27 489.96 182.77 489.96 182.77Z"
        fill="url(#paint231_linear_2072_10275)"
      />
      <path
        d="M524.63 174.05C526.57 174.32 526.22 175.64 525.51 177.97C525.04 184.09 523.55 185.38 522.86 185.04C521.61 184.42 522.28 173.72 524.62 174.04L524.63 174.05Z"
        fill="#F0C499"
      />
      <path
        d="M523.57 182.78C523.57 182.78 524.4 181.6 523.92 179.48C522.78 174.47 525.85 173.83 525.46 177.36C525.46 177.36 524.88 175.77 524.54 176.3C524.11 176.95 525.14 177.18 524.87 179.85C524.73 181.24 523.58 182.79 523.58 182.79L523.57 182.78Z"
        fill="url(#paint232_linear_2072_10275)"
      />
      <path
        d="M523.11 173.75C523.68 159.41 519.29 157.48 518.03 156.01C515.48 153.04 511.47 151.74 504.62 151.9C504.62 151.9 495.69 152.21 493.46 157.1C491.07 162.33 490.65 169.51 490.86 176.25C491.11 184.43 491.11 186.6 491.83 188.31C492.16 189.1 495.4 192.69 496.78 194.18C499.09 196.68 499.83 196.68 501.88 198.33C502.71 199 507.97 201.84 512.33 198.88C514.62 197.33 514.79 197.33 518.03 193.49C519.15 192.16 522.32 188.48 522.32 187.48C522.32 186.33 523 181.98 522.96 181.13C522.73 176.51 522.95 177.73 523.1 173.74L523.11 173.75Z"
        fill="#F7D4AB"
      />
      <path
        d="M510.36 170.37C510.14 171.76 508.86 176.9 509.68 177.38C514.8 180.39 520.39 176.58 520.39 176.58C521.81 168.19 510.36 170.37 510.36 170.37Z"
        fill="url(#paint233_linear_2072_10275)"
      />
      <path
        d="M516.14 187.3C518.96 187.49 522.38 187.13 522.97 181.28C523.31 177.95 522.68 176.21 521.29 175.95C518.33 175.4 514.09 176.69 512.32 177.62C508.59 179.57 511.15 186.97 516.15 187.31L516.14 187.3Z"
        fill="url(#paint234_radial_2072_10275)"
      />
      <path
        d="M492.61 176.33C492.61 176.33 498.46 180.34 503.69 176.98C504.49 176.46 502.91 171.9 502.69 170.51C502.69 170.51 492.49 167.25 492.61 176.33Z"
        fill="url(#paint235_linear_2072_10275)"
      />
      <path
        d="M500.54 177.33C499.73 177.03 493.6 175.63 491.77 176.17C490.73 176.47 490.38 178.84 490.56 181.07C490.64 182.14 490.88 183.84 491.12 184.51C492.3 187.81 497.33 187.95 499.93 187.03C504.37 185.46 504.63 178.82 500.54 177.33Z"
        fill="url(#paint236_radial_2072_10275)"
      />
      <path
        d="M520.96 177.55C520.45 177.26 520.07 177.68 519.02 178.03C517.98 178.37 515.15 178.91 516.48 179.63C517.95 180.43 520.01 179.33 520.26 179.13C520.51 178.92 521.59 177.91 520.96 177.55Z"
        fill="url(#paint237_linear_2072_10275)"
      />
      <path
        d="M494.12 178.14C493.05 177.85 492.65 177.45 492.15 177.76C491.54 178.15 492.67 179.1 492.93 179.3C493.19 179.49 495.3 180.48 496.73 179.61C498.02 178.82 495.17 178.43 494.11 178.14H494.12Z"
        fill="url(#paint238_linear_2072_10275)"
      />
      <path
        d="M514.83 172.85C515.92 172.81 517.28 173.17 517.69 173.5C518.49 174.15 519.09 175.74 519.08 176.2C519.07 176.66 517.34 177.79 515.5 177.93C513.73 178.07 510.68 177.84 510.21 176.91C510.05 176.59 510.45 174.95 510.51 174.64C510.67 173.77 511.8 172.97 514.84 172.85H514.83Z"
        fill="url(#paint239_linear_2072_10275)"
      />
      <path
        d="M513.03 173.92C517.44 173.56 516.7 174.23 518.21 176.13C518.21 176.13 517.6 177 516.47 177.27C514.44 177.75 513.49 177.66 511.41 177.2C510.87 177.08 510.85 176.81 510.85 176.81C510.85 176.81 510.64 174.12 513.03 173.93V173.92Z"
        fill="url(#paint240_linear_2072_10275)"
      />
      <path
        d="M516.05 174.13C517.47 173.98 518.2 176.13 518.2 176.13C518.11 176.26 518.07 176.31 517.88 176.49C516.51 175.78 513.84 175.74 513.62 175.77C511.85 176.05 510.84 176.48 510.84 176.48C510.93 174.81 511.42 174.51 511.42 174.51C511.42 174.51 514.63 174.27 516.05 174.12V174.13Z"
        fill="#DDDDDD"
      />
      <path
        d="M514.29 174.28C515.58 174.36 516.73 175.09 516.55 176.41C516.51 176.69 516.45 177 516.13 177.36C515.85 177.44 514.93 177.67 514.28 177.65C513.65 177.63 512.47 177.47 512.25 177.4C512.19 177.34 511.89 176.76 511.87 176.25C511.81 174.89 513.01 174.21 514.3 174.29L514.29 174.28Z"
        fill="url(#paint241_linear_2072_10275)"
      />
      <path
        d="M514.81 173.85C516.61 174.19 516.56 176.02 516.56 176.02C513.97 175.35 511.86 176.17 511.86 176.17C511.76 174.64 513.24 173.55 514.81 173.85Z"
        fill="url(#paint242_linear_2072_10275)"
      />
      <path
        d="M514.43 174.44C515.22 174.46 515.84 175.11 515.82 175.89C515.8 176.67 515.14 177.28 514.35 177.26C513.56 177.24 512.94 176.58 512.96 175.81C512.98 175.03 513.64 174.42 514.43 174.44Z"
        fill="url(#paint243_radial_2072_10275)"
      />
      <path
        d="M515.78 175.88C516.1 175.92 516.34 176.23 516.3 176.56C516.26 176.9 515.97 177.14 515.64 177.09C515.31 177.05 515.08 176.74 515.12 176.41C515.16 176.07 515.45 175.83 515.78 175.88Z"
        fill="white"
      />
      <path
        d="M514.44 175.37C514.7 175.4 514.88 175.64 514.85 175.91C514.82 176.17 514.59 176.36 514.33 176.33C514.07 176.3 513.89 176.06 513.92 175.79C513.95 175.52 514.18 175.33 514.44 175.37Z"
        fill="white"
      />
      <path
        d="M516.92 173.79C518.07 174.21 518.21 176.13 518.21 176.13C518.21 176.13 517.75 175.06 516.67 174.89C514.54 174.56 512.82 174.83 512.11 175.06C511.26 175.33 510.92 175.74 510.92 175.74C510.92 175.74 511 174.85 511.33 174.49C512.38 173.32 515.51 173.27 516.91 173.79H516.92Z"
        fill="url(#paint244_linear_2072_10275)"
      />
      <path
        d="M498.6 172.85C497.51 172.81 496.15 173.17 495.74 173.5C494.94 174.15 494.34 175.74 494.35 176.2C494.36 176.66 496.09 177.79 497.93 177.93C499.7 178.07 502.75 177.84 503.22 176.91C503.38 176.59 502.98 174.95 502.92 174.64C502.76 173.77 501.63 172.97 498.59 172.85H498.6Z"
        fill="url(#paint245_linear_2072_10275)"
      />
      <path
        d="M500.4 173.92C495.99 173.56 496.73 174.23 495.22 176.13C495.22 176.13 495.83 177 496.96 177.27C498.99 177.75 499.94 177.66 502.02 177.2C502.56 177.08 502.58 176.81 502.58 176.81C502.58 176.81 502.79 174.12 500.4 173.93V173.92Z"
        fill="url(#paint246_linear_2072_10275)"
      />
      <path
        d="M497.37 174.13C495.95 173.98 495.22 176.13 495.22 176.13C495.31 176.26 495.35 176.31 495.54 176.49C496.91 175.78 499.58 175.74 499.8 175.77C501.57 176.05 502.58 176.48 502.58 176.48C502.49 174.81 502 174.51 502 174.51C502 174.51 498.79 174.27 497.37 174.12V174.13Z"
        fill="#DDDDDD"
      />
      <path
        d="M499.14 174.28C497.85 174.36 496.7 175.09 496.88 176.41C496.92 176.69 496.98 177 497.3 177.36C497.58 177.44 498.5 177.67 499.15 177.65C499.78 177.63 500.96 177.47 501.18 177.4C501.24 177.34 501.54 176.76 501.56 176.25C501.62 174.89 500.42 174.21 499.13 174.29L499.14 174.28Z"
        fill="url(#paint247_linear_2072_10275)"
      />
      <path
        d="M498.62 173.85C496.82 174.19 496.87 176.02 496.87 176.02C499.46 175.35 501.57 176.17 501.57 176.17C501.67 174.64 500.19 173.55 498.62 173.85Z"
        fill="url(#paint248_linear_2072_10275)"
      />
      <path
        d="M499 174.44C498.21 174.46 497.59 175.11 497.61 175.89C497.63 176.67 498.29 177.28 499.08 177.26C499.87 177.24 500.49 176.58 500.47 175.81C500.45 175.03 499.79 174.42 499 174.44Z"
        fill="url(#paint249_radial_2072_10275)"
      />
      <path
        d="M500.28 175.88C499.96 175.92 499.72 176.23 499.76 176.56C499.8 176.9 500.09 177.14 500.42 177.09C500.75 177.05 500.98 176.74 500.94 176.41C500.9 176.07 500.61 175.83 500.28 175.88Z"
        fill="white"
      />
      <path
        d="M498.99 175.37C498.73 175.4 498.55 175.64 498.58 175.91C498.61 176.17 498.84 176.36 499.1 176.33C499.36 176.3 499.54 176.06 499.51 175.79C499.48 175.52 499.25 175.33 498.99 175.37Z"
        fill="white"
      />
      <path
        d="M496.51 173.79C495.36 174.21 495.22 176.13 495.22 176.13C495.22 176.13 495.68 175.06 496.76 174.89C498.89 174.56 500.61 174.83 501.32 175.06C502.17 175.33 502.51 175.74 502.51 175.74C502.51 175.74 502.43 174.85 502.1 174.49C501.05 173.32 497.92 173.27 496.52 173.79H496.51Z"
        fill="url(#paint250_linear_2072_10275)"
      />
      <path
        d="M490.36 179.98C490.48 183.13 490.99 186.25 491.41 187.75C491.52 188.14 492.09 189.71 493.45 191.23C496.04 194.11 498.59 196 499.26 196.45C496.98 194.04 494.66 190.8 493.92 189.71C491.12 185.52 490.36 179.99 490.36 179.99V179.98Z"
        fill="url(#paint251_linear_2072_10275)"
      />
      <path
        d="M514.6 197.26C515.65 196.44 518.21 193.85 520.38 191.78C521.41 190.8 522.07 189.06 522.37 187.91C522.66 186.77 523.06 180.15 523.06 180.15C522.75 183.02 521.9 187.1 520.38 189.84C518.86 192.58 515.2 196.46 514.6 197.26Z"
        fill="url(#paint252_linear_2072_10275)"
      />
      <path
        d="M518.82 158.37C512.55 153.98 495.78 158.3 494.06 158.34C492.34 158.38 490.6 180.11 490.6 180.11C490.6 180.11 492.4 176.68 493.01 174.08C493.62 171.48 495.97 169.79 499.02 169.3C507.92 167.87 512.05 167.89 515.62 168.88C518.59 169.7 519.9 170.36 520.5 171.95C521.09 173.54 522.79 179.21 522.79 179.21C522.79 179.21 525.08 162.77 518.82 158.38V158.37Z"
        fill="url(#paint253_linear_2072_10275)"
      />
      <path
        d="M520.83 155.48C520.83 155.48 522.02 151.96 519.34 149.59C519.34 149.59 520.24 150.48 519.34 151.97C519.34 151.97 516.46 145.83 507.7 145.51L509.42 147.47C509.42 147.47 501.35 144.36 494.27 148.7C494.27 148.7 495.6 149.33 496.36 150.19C491.99 149.89 489.71 152.48 488.58 155.22C488.58 155.22 491.28 153.69 493.68 155.5C493.68 155.5 488.84 154.54 487.11 159.59C487.11 159.59 489.98 156.7 491.89 159.59C491.89 159.59 488.61 159.18 487.02 164.83C488.36 162.74 490.84 162.29 490.84 162.29C490.84 162.29 489.47 166.73 488.84 174.16C488.84 174.16 490.38 174.69 490.57 178.97C490.57 178.97 492.19 162.36 495.24 160.34C502.97 155.22 515.05 157.71 516.82 158.98C522.42 163 523.07 179.05 523.07 179.05C523.07 179.05 523.03 173.9 524.84 174.09C524.84 174.09 524.65 158.59 520.84 155.49L520.83 155.48Z"
        fill="url(#paint254_linear_2072_10275)"
      />
      <path
        d="M500.12 151.11C500.07 151.1 500.04 151.09 500.04 151.09C500.07 151.09 500.09 151.1 500.12 151.11Z"
        fill="url(#paint255_linear_2072_10275)"
      />
      <path
        d="M512.21 151.09C512.21 151.09 516.07 154.8 516.15 157.74C514.23 156.51 508.94 156.39 507.89 156.4C506.86 155.01 504.62 151.89 500.12 151.1C500.63 151.22 502.57 151.77 505.18 156.26C503.39 156.11 500.06 157.29 499.35 157.44C498.85 157.08 496.7 155.96 495.22 155.96C495.22 155.96 497.51 157.02 497.72 157.97C497.72 157.97 495.3 158.97 494.06 161.06C490.51 167.06 490.51 180.44 490.51 180.44C490.51 180.44 491.76 175.67 492.41 172.25C493.16 168.28 493.41 163.55 494.8 161.67C498.35 156.88 511.38 155.98 516.79 159.6C519.78 161.6 520.27 166.76 521.14 171.25C521.88 175.1 523.04 180.52 523.04 180.52C523.04 180.52 523.2 165.3 519.58 159.99C519.58 159.99 517.34 153.56 512.2 151.1L512.21 151.09Z"
        fill="url(#paint256_linear_2072_10275)"
      />
      <path
        d="M524.32 147.73C524.32 147.73 534.35 141.65 531.83 138.7C529.31 135.75 520.09 137.04 518.25 137.23C516.41 137.42 509.73 132.99 506.44 134.47C503.15 135.94 496.39 140.62 493.6 140.95C490.8 141.29 486.47 146.96 481.82 147.71C477.17 148.47 475.65 157.17 478.05 158.35C480.45 159.52 470.99 167.4 481.37 173.19C484.45 174.91 489.2 170.2 489.2 170.2L489.27 158.55C489.27 158.55 502.76 148.35 524.33 147.73H524.32Z"
        fill="#CCCCD0"
      />
      <path
        d="M488.88 173.18C488.88 173.18 491.37 170.65 496.53 168.9C502.46 166.89 514.84 165.4 524.66 170.3C525.02 162.28 524.32 147.73 524.32 147.73C524.32 147.73 505.93 146.79 489.47 157.43C488.42 171.35 488.88 173.18 488.88 173.18Z"
        fill="#CCCCD0"
      />
      <path
        d="M492.65 169.93C492.65 169.93 497.27 167.11 505.55 166.31C514.01 165.49 521.64 168 521.64 168C521.64 168 522.16 152.16 520.91 151.06C519.66 149.96 502.38 154.5 494.04 159.45C492.25 160.51 492.65 169.94 492.65 169.94V169.93Z"
        fill="url(#paint257_linear_2072_10275)"
      />
      <path
        d="M521.28 147.89C521.28 147.89 522.55 142.45 520.94 143.92C519.33 145.39 515.62 149.42 514.95 148.45C514.28 147.48 514 142.75 513.07 144.29C512.14 145.83 511.17 147.48 510.21 147.73C509.25 147.98 497.9 145.64 499.55 146.63C501.2 147.61 502.31 148.84 498.56 149.82C494.81 150.8 483.88 153.03 485.78 153.97C487.68 154.91 486.39 158 484.86 160.33C483.33 162.66 487.56 165.54 486.95 166.22C486.34 166.9 480.24 171.25 481.97 171.83C483.71 172.4 488.78 170.36 488.78 170.36C488.78 170.36 489.94 157.07 491.02 155.63C492.1 154.19 521.27 147.9 521.27 147.9L521.28 147.89Z"
        fill="url(#paint258_linear_2072_10275)"
      />
      <path
        d="M524.32 147.73C524.32 147.73 491.12 148.75 489.26 158.55C488.83 160.79 488.78 170.36 488.78 170.36C488.78 170.36 490.52 159.23 491.02 158.35C494.45 152.32 524.32 147.74 524.32 147.74V147.73Z"
        fill="url(#paint259_linear_2072_10275)"
      />
      <path
        d="M528.33 144.89C528.33 144.89 534.62 140.42 531.52 138.24C527.64 135.52 518.84 137.14 517.79 137.03C515.8 136.82 510.81 133.55 507.59 134.1C504.37 134.65 496.56 139.86 495.58 140.23C494.6 140.6 492.77 140.78 491.86 141.34C490.96 141.9 484.64 146.62 484.1 146.85C483.56 147.08 479.26 146.63 477.17 150.44C475.08 154.25 476.8 156.75 477.17 157.8C477.54 158.85 473.79 166.78 475.08 169.17C476.37 171.57 481.35 173.18 481.35 173.18C481.35 173.18 476.68 169.48 477.17 168.13C477.66 166.78 480.18 160.29 481.96 159.45C483.74 158.61 483.5 154.55 483.99 153.02C484.48 151.48 491.39 149.52 492.94 148.97C494.49 148.42 500.08 140.74 501.4 140.62C502.72 140.5 507.46 142.09 510.31 142.22C513.16 142.34 518.37 140.07 519.4 140.62C523.77 142.95 531.65 139.64 528.31 144.91L528.33 144.89Z"
        fill="url(#paint260_linear_2072_10275)"
      />
      <path
        d="M524.6 155.32C525.03 166.16 524.66 170.3 524.66 170.3C524.66 170.3 523.64 169.82 523.42 169.73C523.42 169.73 524.48 156.65 524.6 155.32Z"
        fill="url(#paint261_linear_2072_10275)"
      />
      <path
        d="M507.73 193.53C506.14 193.53 502.16 194.63 502.28 195.21C502.63 196.99 506.32 197.29 507.9 197.28C509.49 197.28 512.7 196.86 512.77 195.34C512.8 194.74 509.32 193.51 507.73 193.52V193.53Z"
        fill="url(#paint262_linear_2072_10275)"
      />
      <path
        d="M512.62 184.13C515.73 186.67 514.47 188.5 513.82 189.14C515.02 188.13 516.63 186.99 516.52 186.55C516.13 184.93 512.61 184.13 512.61 184.13H512.62Z"
        fill="url(#paint263_linear_2072_10275)"
      />
      <path
        d="M513.82 189.14C513.72 189.23 513.62 189.31 513.53 189.39C513.53 189.39 513.66 189.3 513.82 189.14Z"
        fill="url(#paint264_linear_2072_10275)"
      />
      <path
        d="M513.5 187.23C513.5 187.23 515.09 186.85 515.23 186.74C515.37 186.63 515.5 186.21 515.5 186.21L514.49 186.52L513.5 187.22V187.23Z"
        fill="url(#paint265_linear_2072_10275)"
      />
      <path
        d="M498.24 186.8C498.31 187.3 499.7 188.52 500.61 189.48C500.61 189.48 498.18 186.83 501.56 184.45C501.56 184.45 498 185.13 498.24 186.81V186.8Z"
        fill="url(#paint266_linear_2072_10275)"
      />
      <path
        d="M499.07 186.32C499.07 186.32 499.2 186.73 499.34 186.85C499.48 186.97 501.07 187.34 501.07 187.34L500.08 186.64L499.07 186.33V186.32Z"
        fill="url(#paint267_linear_2072_10275)"
      />
      <path
        d="M504.06 193.35C508.28 192.88 511.14 193.4 511.14 193.4C507.94 191.38 504.06 193.35 504.06 193.35Z"
        fill="url(#paint268_linear_2072_10275)"
      />
      <path
        d="M507.42 190.81C506.22 190.81 505.04 190.57 505.04 190.81C505.04 191.05 506.08 191.58 507.28 191.58C508.48 191.58 509.67 191.05 509.67 190.81C509.67 190.57 508.63 190.81 507.42 190.81Z"
        fill="#FDD8B3"
      />
      <path
        d="M510.89 188.39C510.07 188.56 508.54 188.87 507.13 188.87C505.58 188.87 504 188.58 503.14 188.42C502.76 188.35 502.6 189.01 502.6 189.01C503.73 189.85 505.09 190.16 507.27 190.18C510.17 190.2 511.78 188.93 511.78 188.93C511.78 188.93 511.37 188.29 510.89 188.39Z"
        fill="url(#paint269_linear_2072_10275)"
      />
      <path
        d="M502.99 191.11C507.62 194.84 512.06 190.85 512.06 190.85C507.38 193.37 502.99 191.11 502.99 191.11Z"
        fill="url(#paint270_linear_2072_10275)"
      />
      <path
        d="M501.46 186.95C501.46 186.95 501.49 187.72 502.26 188.06C502.71 188.26 503.72 189.03 507.63 188.91C511.54 188.79 512.32 187.83 512.5 187.66C512.83 187.35 512.98 186.82 512.98 186.82C512.98 186.82 507.08 187.99 501.46 186.94V186.95Z"
        fill="url(#paint271_linear_2072_10275)"
      />
      <path
        d="M501.45 186.87C501.45 186.87 501.48 187.22 501.6 187.43C501.71 187.6 504.83 188.07 507.2 188.08C509.56 188.09 512.64 187.48 512.75 187.34C512.92 187.12 513.01 186.74 513.01 186.74C513.01 186.74 510.35 187.64 501.44 186.87H501.45Z"
        fill="#F3ECEB"
      />
      <path
        d="M498.97 186.27C498.97 186.27 499.34 186.48 499.45 186.51C499.45 186.51 506.34 188.55 515.23 186.34L515.71 186.09C510.88 186.91 498.96 186.26 498.96 186.26L498.97 186.27Z"
        fill="url(#paint272_linear_2072_10275)"
      />
      <path
        d="M508.74 176.67C508.93 172.95 507.64 172.42 506.69 172.45C505.76 172.48 505.25 173.77 505.44 176.61C505.63 179.43 505.08 180.52 505.21 181.84C505.27 182.44 505.54 182.84 507.05 182.85C508.71 182.86 509.28 182.47 509.35 181.9C509.54 180.36 508.61 179.35 508.74 176.67Z"
        fill="url(#paint273_linear_2072_10275)"
      />
      <path
        d="M508.92 183.9C511.16 183.34 512.04 183.67 512.04 183.67C510.74 182.51 508.92 183.9 508.92 183.9Z"
        fill="url(#paint274_linear_2072_10275)"
      />
      <path
        d="M502.58 183.51C502.58 183.51 503.74 183.32 505.5 183.92C505.5 183.92 503.78 182.6 502.58 183.51Z"
        fill="url(#paint275_linear_2072_10275)"
      />
      <path
        d="M510.65 180.13C510.64 181.06 510.85 181.68 510.57 182.21C509.95 183.39 508.34 183.86 507.26 183.77C506.44 183.87 504.53 183.46 503.73 182.22C503.41 181.72 503.61 181.26 503.46 180.27C503.46 180.27 501.24 182.98 502.57 183.5C502.57 183.5 502.96 183.2 504.03 183.3C505.1 183.4 504.88 184.59 507.34 184.61C509.48 184.63 508.8 183.59 510.16 183.39C511.52 183.19 511.7 183.55 512.01 183.69C512.69 183.69 512.2 181.4 510.64 180.12L510.65 180.13Z"
        fill="url(#paint276_linear_2072_10275)"
      />
      <path
        d="M504.97 181.72C504.88 182.33 505.72 182.98 507.23 182.99C508.89 183 509.26 182.34 509.12 181.78C508.3 178.48 505.32 179.46 504.98 181.72H504.97Z"
        fill="url(#paint277_linear_2072_10275)"
      />
      <path
        d="M516.45 169.6C515.8 169.52 513.67 169.02 510.63 169.67C509.85 169.84 509.71 171.56 510.55 171.53C512.12 171.48 514.35 171.21 515.85 171.18C518.04 171.14 519.17 171.64 519.17 171.64C519.17 171.64 517.88 169.77 516.44 169.59L516.45 169.6Z"
        fill="url(#paint278_linear_2072_10275)"
      />
      <path
        d="M502.47 169.48C499.43 168.83 497.31 169.33 496.65 169.41C495.22 169.59 493.92 171.46 493.92 171.46C493.92 171.46 495.06 170.95 497.24 171C498.74 171.03 500.96 171.3 502.54 171.35C503.38 171.38 503.24 169.66 502.46 169.49L502.47 169.48Z"
        fill="url(#paint279_linear_2072_10275)"
      />
      <path
        d="M501.08 197.71C501.08 197.71 504.79 200.53 508.02 200.2C511.26 199.87 512.77 198.8 514.59 197.25C514.59 197.25 512.01 201.14 508.1 201.1C504.19 201.06 502.33 198.95 501.07 197.71H501.08Z"
        fill="url(#paint280_linear_2072_10275)"
      />
      <path
        d="M485.07 221.46C485.07 221.46 490.34 198.11 494.41 197.03L493.97 198.59C493.97 198.59 491.11 203.13 488.02 221.47H485.07V221.46Z"
        fill="url(#paint281_linear_2072_10275)"
      />
      <path
        d="M696.37 233.42C691.18 210.08 690.39 210.8 690.39 210.8C685.62 208.07 681.54 226.52 682.29 235.37C682.49 237.67 684.07 251.98 684.22 253.34C690.46 255.25 695.6 257.9 701.95 259.85C701.62 257.34 700.36 251.39 696.36 233.42H696.37Z"
        fill="url(#paint282_radial_2072_10275)"
      />
      <path
        d="M681.54 235.93C681.54 235.93 681.97 228.05 682.79 225.77C682.79 225.77 682.03 245.76 695.29 256.92C695.29 256.92 689.26 253.25 684.24 253.44C684.24 253.44 681.21 238.18 681.54 235.93Z"
        fill="url(#paint283_radial_2072_10275)"
      />
      <path
        d="M691.34 212.99C693.09 216.04 697.67 232.46 696.55 238.84C693.75 254.71 685.54 202.86 691.34 212.99Z"
        fill="url(#paint284_radial_2072_10275)"
      />
      <path
        d="M684.58 218.56C685.55 214.54 686.79 210.31 688.19 208.6C691.4 210.29 693.2 214.13 693.91 217.52C694.7 221.27 695.28 224.44 695.94 228.43C694.45 230.12 682.61 232.12 682.61 232.12C683.37 226.57 683.88 221.47 684.58 218.57V218.56Z"
        fill="#908989"
      />
      <path
        d="M627.06 209.29C625.32 210.05 623.73 210.96 622.52 212.1C617.5 216.79 610.13 227.83 608.13 230.51C606.12 233.19 594.4 242.9 595.74 251.6C597.08 260.3 623.74 285.57 623.74 285.57L627.08 276.91C627.08 276.91 624.42 275.12 618.51 265.66C616.49 262.42 610.14 249.26 610.14 249.26C621.52 242.9 626.88 232.86 626.88 232.86C626.88 232.86 628.21 217.63 627.07 209.3L627.06 209.29Z"
        fill="url(#paint285_radial_2072_10275)"
      />
      <path
        d="M601.71 248.55C601.45 247.32 616.4 243.3 623.05 230.22L626.22 233.94C626.22 233.94 621.65 242.73 610.13 249.25C610.13 249.25 615.92 261.33 621.42 270.11C620.92 270.44 620.36 270.93 619.86 271.16C618.28 268.94 616.63 266.32 615 263.48C610.7 255.97 601.97 249.77 601.71 248.54V248.55Z"
        fill="url(#paint286_radial_2072_10275)"
      />
      <path
        d="M610.85 226.68C610.85 226.68 608.44 230.2 607.74 230.96C607.05 231.72 599.8 238.91 598.08 242.54C596.36 246.17 604.57 240.79 606.4 238.9C608.22 237.01 615.39 230.16 615.39 230.16L610.84 226.68H610.85Z"
        fill="url(#paint287_radial_2072_10275)"
      />
      <path
        d="M595.63 250.79C595.63 254.23 597.4 256.33 603.77 264.49C610.66 273.31 619.66 280.31 619.86 276.83C620.06 273.31 595.63 240.5 595.63 250.79Z"
        fill="url(#paint288_radial_2072_10275)"
      />
      <path
        d="M640.42 203.56C640.42 203.56 645.9 201.96 646.97 200.49C646.97 200.49 660.83 205.12 666.71 199.77L672.49 202.49C672.49 202.49 667.28 213.05 658.19 212.91C649.1 212.78 640.42 203.56 640.42 203.56Z"
        fill="url(#paint289_linear_2072_10275)"
      />
      <path
        d="M683.08 229.76H686.59C687.34 224.99 688.59 208.84 688.59 208.84C686.26 207.14 670.48 201.36 670.48 201.36C670.48 201.36 668.32 211.1 657.26 211.71C646.21 212.32 644.35 201.86 644.35 201.86C624.92 209.66 624.87 209.73 624.87 209.73C625.27 210.54 626.13 222.91 627.26 229.75H630.52C631.08 233.05 631.48 235.68 631.55 236.13C633.42 248.04 635.78 273.39 635.28 299.36C637.06 300.49 646.66 302.09 658.69 301.15C671.92 300.12 677.77 297.34 680.44 295.63C679.28 276.73 680.01 258.47 682.14 235.06C682.26 233.69 682.62 231.82 683.09 229.74L683.08 229.76Z"
        fill="#908989"
      />
      <path
        d="M654.75 207.59L657.93 211.41L660.79 206.95L656.97 208.86L654.75 207.59Z"
        fill="url(#paint290_radial_2072_10275)"
      />
      <path
        d="M695.42 225.31L696.01 228.55C696.01 228.55 693.01 230.67 682.62 232.1L682.92 228.9C682.92 228.9 692.95 227.37 695.42 225.31Z"
        fill="url(#paint291_linear_2072_10275)"
      />
      <path
        d="M667.55 199.96C667.24 199.73 666.94 197.76 666.73 195.88C666.59 193.41 666.42 190.68 666.37 190.24C666.37 190.24 659.26 195.37 646.82 191.04C646.82 191.04 646.82 195.14 646.88 198.56C646.83 199.34 646.79 199.7 646.72 200.13C646.59 201.07 642.96 202.48 642.96 202.48C642.96 202.48 644.43 212.1 656.59 212.9C668.75 213.7 672.42 202.19 672.42 202.19C672.42 202.19 668.09 200.34 667.55 199.94V199.96ZM657.2 210.72C648.22 211.02 645.91 203.71 645.91 203.71C645.91 203.71 646.98 202.91 647.51 202.64C647.88 202.46 648.1 201.79 648.24 201.08C651.29 203.9 654.84 205.58 656.87 205.4C659.11 205.2 662.57 203.58 665.13 201.66L668.22 204.05C665.61 209.46 659.2 210.66 657.2 210.73V210.72Z"
        fill="url(#paint292_radial_2072_10275)"
      />
      <path
        d="M644.35 201.87C644.35 201.87 646.63 211.91 657.33 211.45C668.15 210.98 670.48 201.36 670.48 201.36L673.22 202.38C673.22 202.38 669.16 215.85 656.06 215.05C642.97 214.25 641.3 203.09 641.3 203.09L644.35 201.86V201.87Z"
        fill="url(#paint293_linear_2072_10275)"
      />
      <path
        d="M636.07 219.06C642.9 215.04 646.85 216.29 657.49 216.59C668.13 216.89 674.97 214.78 678.78 218.6C682.6 222.42 681.1 238.24 659.7 239.69C634.54 241.4 629.24 223.07 636.07 219.06Z"
        fill="url(#paint294_linear_2072_10275)"
      />
      <path
        d="M683.07 230.79C683.17 228.56 683.6 225.28 683.27 224.37C682.94 223.47 683 226.38 681.97 230.71C681.39 233.13 680.58 236.28 679.45 240.21C678.67 242.91 682.62 260.63 682.62 260.63C682.62 260.63 682.46 257 682.33 252.26C682.27 250.07 682.65 239.98 683.08 230.78L683.07 230.79Z"
        fill="url(#paint295_linear_2072_10275)"
      />
      <path
        d="M610.96 225.7C610.96 225.7 617.68 216.25 619.88 213.81C622.06 211.38 623.89 210.2 624.87 209.75C625.85 209.3 632 231.66 632 231.66L624.46 237.53L610.96 225.7Z"
        fill="#908989"
      />
      <path
        d="M624.46 237.52L622.68 236.04C622.68 236.04 629.11 231.14 630.81 230.73C632.1 230.42 635.21 249.3 632.42 268.94C632.42 268.94 632.86 253.82 627.52 235.43C626.5 236.19 624.46 237.52 624.46 237.52Z"
        fill="#908989"
      />
      <path
        d="M630.82 250.11C630.82 250.11 631.25 253.25 631.25 253.74C631.25 253.74 635.21 243.26 635.31 242.42C635.41 241.59 637.89 224.22 637.89 224.22L632.77 206.52L631.09 207.2C631.09 207.2 634.93 223.8 634.87 224.21C634.81 224.62 630.82 250.11 630.82 250.11Z"
        fill="url(#paint296_linear_2072_10275)"
      />
      <path
        d="M681.6 205.63L683.75 206.52L678.25 224.42L682.55 243.09L682.4 254.82L675.83 225.61L681.6 205.63Z"
        fill="url(#paint297_linear_2072_10275)"
      />
      <path
        d="M636.32 343.66C642.32 343.54 648.33 343.43 654.33 343.31C654.09 336.34 653.92 331.32 653.92 331.32C653.92 331.32 659.99 319.04 659.75 313.26C659.5 303.9 661.06 289.89 659.91 280.36C650.64 279.51 641.8 281.94 632.98 278.77V278.87C632.66 283.81 628.07 299.37 627.88 302.65C627.51 309.27 627.72 328.87 627.96 344.35C630.74 343.97 633.54 343.73 636.33 343.67L636.32 343.66Z"
        fill="#1B2C60"
      />
      <path
        d="M663.56 333.11C663.56 333.11 663.76 337.2 664.04 343.13C672.83 342.96 681.62 342.79 690.42 342.62C689.39 327.4 688.03 308.77 687.14 302.39C686.69 299.13 680.82 284.01 680.11 279.11V279.01C671.56 282.9 662.59 278.76 653.43 280.37C653.07 289.97 658.11 302.39 658.64 311.74C658.88 317.53 663.56 333.12 663.56 333.12V333.11Z"
        fill="#1B2C60"
      />
      <path
        d="M656.74 280.57L658.63 311.73L654.97 301.6L656.74 280.57Z"
        fill="url(#paint298_linear_2072_10275)"
      />
      <path
        d="M656.23 343.27L657.56 324.46L660.35 323.33L662.96 343.14L664.42 343.11L663.97 319.19L658.8 314.14L653.4 322.16L654.25 343.31C654.91 343.3 655.57 343.28 656.23 343.27Z"
        fill="url(#paint299_linear_2072_10275)"
      />
      <path
        d="M636.32 343.66C640.7 343.58 645.07 343.49 649.45 343.41C650.31 325.11 647.77 304.52 643.02 305.4C637.75 306.37 633.5 326.22 632.88 343.82C634.03 343.74 635.17 343.69 636.32 343.67V343.66Z"
        fill="url(#paint300_linear_2072_10275)"
      />
      <path
        d="M657.54 293.82L658.8 314.15L663.97 319.2C663.97 319.2 661.36 314.53 660.61 313.39C659.86 312.25 657.54 293.82 657.54 293.82Z"
        fill="url(#paint301_linear_2072_10275)"
      />
      <path
        d="M685.9 342.7C683.74 325.46 677.98 306.69 672.74 306.17C668.07 305.7 667.15 325.25 669.27 343.03C674.81 342.92 680.36 342.82 685.9 342.71V342.7Z"
        fill="url(#paint302_linear_2072_10275)"
      />
      <path
        d="M639.8 280.41C654.8 283.14 669.48 285.23 684.07 284.51C683.71 282.36 683.46 280.83 683.4 280.45C682 271.49 681.3 252.65 681.3 252.65L677.01 225.31L682.76 205.99L676.32 203.41L670.29 223.48H644.45L638.49 204.07L631.79 206.82C631.79 206.82 635.54 220.79 635.93 225.3C636.32 229.81 631.86 250.23 631.08 252.83C631.08 252.83 631.82 273.24 631.85 278.19C631.85 278.71 631.81 279.35 631.75 280.07C634.52 280.04 637.02 279.78 639.82 280.4L639.8 280.41Z"
        fill="#1B2C60"
      />
      <path
        d="M638.84 232.94C638.57 230.62 643.65 226.85 660.5 228.76C664.56 229.22 672.36 230.37 673.6 231.93C674.85 233.49 670.35 250.11 656.22 250.82C642.09 251.53 639.02 234.5 638.84 232.94Z"
        fill="url(#paint303_linear_2072_10275)"
      />
      <path
        d="M641.57 232.05C641.57 232.05 666.7 233.64 673.17 232.19C673.17 232.19 647.08 231.91 641.57 232.05Z"
        fill="url(#paint304_linear_2072_10275)"
      />
      <path
        d="M641.57 234.39V241.12H673.03V235.15L673.96 242.18L639.95 242.16L641.57 234.39Z"
        fill="url(#paint305_linear_2072_10275)"
      />
      <path
        d="M639.99 208.99L644.69 224.31C644.69 224.31 670.98 224.67 671.5 224.07C672.02 223.48 674.84 208.29 674.84 208.29L670.28 223.47L645.22 223.52L639.98 208.98L639.99 208.99Z"
        fill="url(#paint306_linear_2072_10275)"
      />
      <path
        d="M631.78 206.83L638.48 204.07L639.45 207.23L632.62 210.06L631.78 206.83Z"
        fill="url(#paint307_linear_2072_10275)"
      />
      <path
        d="M675.32 206.71L676.32 203.41L682.75 205.99L681.8 209.19L675.32 206.71Z"
        fill="url(#paint308_linear_2072_10275)"
      />
      <path
        d="M660 254.1C659.6 258.49 659.58 262.39 659.58 262.39H681.84C681.84 262.39 681.9 256.8 681.97 251.12C680.87 247.09 680.19 242.77 678.99 238.8C676.66 249.49 676.69 254.46 660 254.11V254.1Z"
        fill="url(#paint309_linear_2072_10275)"
      />
      <path
        d="M633.74 214.55C633.74 214.55 635.84 223.75 635.91 225.3C635.74 226.86 632.3 248.29 631.06 252.83L631.28 278.19C631.28 278.19 627.55 295.51 627.87 302.63C627.87 302.63 634.2 278.99 633.86 276.9C633.52 274.81 633.73 254.88 633.84 254.21C633.95 253.54 637.08 228.31 637.2 226.03C637.24 225.32 633.73 214.55 633.73 214.55H633.74Z"
        fill="url(#paint310_linear_2072_10275)"
      />
      <path
        d="M679.82 215.83L677 225.3C677 225.3 682.33 250.43 682.54 253.22C682.62 254.29 683.27 277.88 683.32 278.87C683.4 280.44 687.14 302.36 687.14 302.36C687.14 302.36 679.7 279.43 679.7 278.16C679.7 276.89 679.44 253.59 679.44 252.99C679.44 252.39 675.83 226.16 675.83 225.6C675.83 225.04 679.82 215.82 679.82 215.82V215.83Z"
        fill="url(#paint311_linear_2072_10275)"
      />
      <path
        d="M631.29 278.19C631.29 278.19 647.81 281.66 683.1 278.64C683.1 278.64 650.59 278.7 631.29 278.19Z"
        fill="url(#paint312_linear_2072_10275)"
      />
      <path
        d="M630.44 288.02C630.44 288.02 635.42 285.98 636.8 285.06C638.18 284.15 640.1 278.88 640.1 278.88L635.99 283.51L630.44 288.02Z"
        fill="url(#paint313_linear_2072_10275)"
      />
      <path
        d="M684.46 288.02C684.46 288.02 678.96 285.98 677.59 285.06C676.21 284.15 674.29 278.88 674.29 278.88L678.4 283.51L684.46 288.02Z"
        fill="url(#paint314_linear_2072_10275)"
      />
      <path
        d="M674.29 278.88C674.29 278.88 676.76 284.6 677.59 285.06C678.42 285.52 684.46 288.02 684.46 288.02C684.46 288.02 676.4 286.77 675.99 285.96C675.59 285.15 674.28 278.88 674.28 278.88H674.29Z"
        fill="url(#paint315_linear_2072_10275)"
      />
      <path
        d="M630.44 288.02C630.44 288.02 635.96 286 636.8 285.06C637.64 284.12 640.1 278.88 640.1 278.88C640.1 278.88 639.36 285.48 638.18 286.12C637 286.76 630.44 288.02 630.44 288.02Z"
        fill="url(#paint316_linear_2072_10275)"
      />
      <path
        d="M669.27 258.17L663.93 258.06C663.93 258.06 662.68 256.75 661.62 255.63C660.91 254.86 660.25 254.12 660.01 253.76C659.59 253.13 657.94 250.44 657.94 250.44L655.45 247.27C655.06 246.65 654.75 246.12 654.67 245.89C654.67 245.89 654.38 243.14 653.76 242.86C653.69 242.83 653.62 242.82 653.56 242.83C653.35 242.78 653.04 242.78 652.7 242.94C652.41 243.08 652.11 243.32 651.86 243.72C651.65 244.04 651.44 244.48 651.29 245.12C650.94 246.6 651.04 247.98 652.09 249.99C652.49 250.75 653.36 252.35 653.36 252.78C653.36 253.16 652.49 254.21 652.31 254.43L651.4 254.9C651.4 254.9 650.54 255.02 649.53 255.17L649.61 255.15C649.61 255.15 647.36 255.48 646.63 255.61C646.56 255.62 646.51 255.63 646.48 255.64C646.01 255.75 645.32 256.27 645.24 257.19C645.2 257.7 645.34 258.21 645.54 258.6C645.54 258.6 645.56 258.63 645.59 258.68C645.74 258.95 645.91 259.15 646.05 259.24C646.05 259.24 645.32 259.77 645.5 261.04C645.58 261.6 645.74 262.03 645.89 262.35L645.94 262.43C646.04 262.62 646.13 262.76 646.19 262.85C646.22 262.9 646.25 262.94 646.27 262.95C646.27 262.95 646.23 262.98 646.18 263.04C645.99 263.25 645.58 263.84 645.83 264.75C646.07 265.6 646.54 266.11 646.78 266.33L646.8 266.35C646.88 266.42 646.93 266.45 646.93 266.45C646.93 266.45 646.75 267.72 646.82 268.14C646.86 268.38 647.55 269.03 648.24 269.6C648.8 270.08 649.35 270.48 649.54 270.57C649.98 270.78 651.5 271.1 651.94 271.1H657.61C657.68 271.1 657.77 271.09 657.86 271.07C660.24 271.19 666.47 271.21 668.59 272.13L683.11 272.75V262.67L669.28 258.19L669.27 258.17Z"
        fill="url(#paint317_linear_2072_10275)"
      />
      <path
        d="M624.46 237.52L627.06 235.76C627.06 235.76 613.74 223.66 612.99 222.87C612.99 222.87 611.48 224.93 610.96 225.69C610.96 225.69 622.97 236.34 624.46 237.52Z"
        fill="url(#paint318_linear_2072_10275)"
      />
      <path
        d="M622.55 272.73C622.55 272.73 625.73 275.94 626.73 276.51C627.73 277.08 633.89 278.39 634.64 278.55C635.39 278.71 639.36 279.76 640.83 280.66C642.3 281.56 644.93 283.5 645.74 284.46C646.19 285 646.46 285.55 645.84 286.1C645.23 286.66 644.23 286.35 643.28 285.52C642.69 285.01 640.15 283.87 638.94 283.39C637.73 282.91 635.79 282.87 635.41 283.03C634.57 283.39 637.83 285.82 638.95 287.13C640.05 288.41 642.03 290.31 642.59 290.92C643.16 291.53 644.46 293.03 643.44 293.93C642.42 294.82 640.31 292.33 638.91 291.33C637.37 290.23 633.76 286.26 632.52 285.81C631.55 285.47 634.76 288.73 635.61 289.54C636.46 290.35 640.13 293.79 640.13 293.79C640.13 293.79 641.31 295.04 640.46 295.87C639.27 297.03 637.64 295.03 636.43 294C635.6 293.29 632.13 290.43 631.82 290.16C631.51 289.89 630.06 288.49 629.71 288.64C628.85 289 632.4 292.42 632.72 292.79C633.67 293.87 634.44 294.79 634.55 295.31C634.76 296.31 634 296.49 633.23 296.12C632.46 295.75 631.05 294.69 630.8 294.35C630.55 294 625.74 289.23 624.53 287.93C623.32 286.63 619.74 284.06 619.03 281.06C618.7 279.66 617.37 278.78 616.83 278.46L622.57 272.72L622.55 272.73Z"
        fill="url(#paint319_radial_2072_10275)"
      />
      <path
        d="M640.28 294.35C640.01 293.97 637.62 292.01 637.25 291.69C636.33 290.89 633.95 291.05 635.98 293.14C638.42 295.66 639.48 296.13 639.77 296.06C640.06 296 641.03 295.4 640.28 294.34V294.35Z"
        fill="url(#paint320_radial_2072_10275)"
      />
      <path
        d="M638.34 294.2C638.52 293.77 639.07 293.66 639.54 294C639.74 294.15 640.46 294.72 640.5 295.08C640.56 295.56 640.05 295.92 639.97 295.92C639.83 295.93 639.47 296.18 639.04 295.7C638.61 295.21 638.13 294.68 638.33 294.19L638.34 294.2Z"
        fill="url(#paint321_radial_2072_10275)"
      />
      <path
        d="M619.86 279.57C618.7 280.2 623.92 287.81 625.13 287.55C626.01 287.36 633.23 278.58 632.27 278.33C630.4 277.85 627.35 277.64 627.35 277.64C627.52 279.57 620.75 279.08 619.86 279.57Z"
        fill="url(#paint322_radial_2072_10275)"
      />
      <path
        d="M626.9 276.6C629.57 277.64 634.7 278.43 636.77 279.12C636.77 279.12 629.62 278.93 626.68 277.95C624.86 277.34 622.45 274.8 619.87 271.17C620.37 270.94 620.93 270.45 621.43 270.12C623.75 273.29 625.91 276.21 626.91 276.6H626.9Z"
        fill="url(#paint323_radial_2072_10275)"
      />
      <path
        d="M612.83 274.62C612.83 274.62 619.57 279.31 619.86 279.57C620.15 279.83 621.13 283.13 623.93 286.24C626.73 289.35 633.22 296.14 633.22 296.14C633.22 296.14 631.61 295.48 629.39 292.98C626.95 290.23 621.29 285.29 620.33 283.92C618.97 281.97 619.32 281.18 617.36 279.3C615.4 277.42 614.61 276.52 612.83 274.63V274.62Z"
        fill="url(#paint324_radial_2072_10275)"
      />
      <path
        d="M645.85 286.11C645.85 286.11 644.65 286.75 642.14 284.52C639.77 282.42 638.47 281.68 637.59 281.58C636.71 281.48 633.39 281.16 633 281.38C632.61 281.61 639.38 288.07 640.15 288.41C638.06 285.76 634.81 283.49 635.45 283.07C635.76 282.87 637.84 282.91 638.96 283.38C640.08 283.85 643.92 286.16 644.49 286.31C645.06 286.46 645.48 286.51 645.87 286.1L645.85 286.11Z"
        fill="url(#paint325_radial_2072_10275)"
      />
      <path
        d="M641.46 293.45C641.46 293.45 636.59 288.98 636.27 288.64C635.41 287.71 632.21 284.46 631.19 284.11C629.92 283.67 632.13 286.34 633.49 287.82C634.66 289.11 637.13 290.97 637.13 290.97C637.13 290.97 633.14 286.9 632.75 286.44C631.89 285.43 632.75 285.84 633.37 286.44C633.94 286.99 639.25 292.14 641.46 293.44V293.45Z"
        fill="url(#paint326_radial_2072_10275)"
      />
      <path
        d="M635.39 293.14C635.39 293.14 630.29 287.91 629.1 287.22C628.12 286.66 628 287.76 629.26 289.26C630.53 290.77 632.71 292.79 632.71 292.79C632.71 292.79 629.32 289.33 629.58 288.74C629.78 288.3 632.79 291.14 635.38 293.13L635.39 293.14Z"
        fill="url(#paint327_radial_2072_10275)"
      />
      <path
        d="M643.28 292.14C643.01 291.77 640.29 289.32 639.92 289.01C638.99 288.24 637.04 288.59 639.08 290.62C641.53 293.06 642.72 293.95 643.02 293.89C643.32 293.83 644.04 293.16 643.28 292.13V292.14Z"
        fill="url(#paint328_radial_2072_10275)"
      />
      <path
        d="M641.39 292.09C641.57 291.66 642.12 291.55 642.59 291.89C642.79 292.04 643.51 292.61 643.55 292.97C643.61 293.45 643.1 293.81 643.02 293.81C642.88 293.82 642.52 294.07 642.09 293.59C641.66 293.1 641.18 292.57 641.38 292.08L641.39 292.09Z"
        fill="url(#paint329_radial_2072_10275)"
      />
      <path
        d="M642.04 281.69C641.78 281.55 640.84 281.02 640.38 281.54C639.69 282.33 642.92 284.62 643.54 285.2C644.44 286.03 646.73 286.06 645.48 284.52C644.24 282.98 642.3 281.83 642.03 281.69H642.04Z"
        fill="url(#paint330_radial_2072_10275)"
      />
      <path
        d="M644.04 284.29C644.31 284.06 644.78 283.92 645.22 284.29C645.66 284.66 646.19 285.08 646.22 285.49C646.25 285.87 645.81 286.38 645.19 286.26C644.95 286.21 643.8 285.46 643.76 284.94C643.74 284.72 643.85 284.44 644.03 284.28L644.04 284.29Z"
        fill="url(#paint331_radial_2072_10275)"
      />
      <path
        d="M631.86 293.14C631.53 293.46 631.36 294.35 633.69 296.13C634.11 296.45 634.76 295.55 634.05 294.64C633.87 294.4 632.53 292.5 631.86 293.15V293.14Z"
        fill="url(#paint332_radial_2072_10275)"
      />
      <path
        d="M633.2 294.41C633.5 294.32 633.97 294.74 634.33 295.28C634.69 295.82 634.33 296.22 633.94 296.21C633.61 296.2 632.86 295.18 632.86 294.96C632.86 294.74 632.86 294.51 633.19 294.42L633.2 294.41Z"
        fill="url(#paint333_radial_2072_10275)"
      />
      <path
        d="M684.24 253.44C678.88 255.97 669.11 256.4 669.11 256.4C669.76 259.56 669.51 266.81 669.51 266.81C669.51 266.81 675.99 267.58 681.11 267.58C689.06 267.58 697.54 268.88 699.24 267.93C699.96 267.53 702.06 262.76 702.06 261.15C702.06 260.83 702.03 260.43 701.95 259.84C687.76 252.89 684.23 253.44 684.23 253.44H684.24Z"
        fill="url(#paint334_radial_2072_10275)"
      />
      <path
        d="M670.37 257.4C670.37 257.4 692.24 252.58 696.92 258.59C699.56 261.98 670.5 264.8 670.5 264.8L670.37 257.39V257.4Z"
        fill="url(#paint335_radial_2072_10275)"
      />
      <path
        d="M669.11 256.41L664.22 256.31C664.22 256.31 661.62 253.51 660.93 252.72C660.23 251.92 658.93 249.23 658.33 248.73C657.73 248.23 655.93 245.44 655.73 244.84C655.53 244.24 655.16 242.21 654.87 242.01C654.57 241.81 653.34 241.81 652.84 243.54C652.48 244.8 652.34 247.33 654.74 249.73L654.44 252.43L652.74 253.33C652.74 253.33 648.65 253.93 648.25 254.03C647.85 254.13 647.05 254.73 647.15 255.63C647.25 256.53 647.85 257.43 647.85 257.43C647.85 257.43 647.35 257.93 647.35 258.93C647.35 259.93 648.05 260.93 648.05 260.93C648.05 260.93 647.55 261.33 647.65 262.33C647.75 263.33 648.65 264.23 648.65 264.23C648.65 264.23 648.55 265.03 648.55 265.63C648.55 266.23 650.65 267.93 651.05 268.13C651.45 268.33 652.85 268.63 653.25 268.63H658.44C659.24 268.63 662.26 266.86 663.16 266.76C664.06 266.66 672.7 266.97 672.7 266.97L669.12 256.46L669.11 256.41Z"
        fill="url(#paint336_radial_2072_10275)"
      />
      <path
        d="M653.54 252.9C653.54 252.9 656.54 251.52 657.54 251.72C657.54 251.72 654.94 247.83 654.45 246.93C653.95 246.03 653.15 244.43 653.95 242.04C653.93 242.1 653.08 242.15 652.65 244.1C652.34 245.49 652.42 246.8 653.38 248.69C653.74 249.41 654.54 250.92 654.54 251.32C654.54 251.72 653.54 252.9 653.54 252.9Z"
        fill="url(#paint337_radial_2072_10275)"
      />
      <path
        d="M654.9 241.96C655.47 242.23 655.73 244.82 655.73 244.82C655.73 244.82 654.43 245.45 654.33 244.25C654.23 243.05 654.33 241.69 654.9 241.95V241.96Z"
        fill="url(#paint338_radial_2072_10275)"
      />
      <path
        d="M655.96 245.3L658.73 249.12C658.73 249.12 660.24 251.66 660.63 252.25C661.2 253.12 664.26 256.24 664.26 256.24L669.17 256.4C669.17 256.4 664.42 257.5 663.82 257.2C663.22 256.9 660.43 253.41 660.23 253.01C660.03 252.61 656.06 245.59 655.96 245.3Z"
        fill="url(#paint339_radial_2072_10275)"
      />
      <path
        d="M651.14 253.55C651.14 253.55 648.64 253.9 648.2 254C647.77 254.1 647.17 254.62 647.1 255.48C647.03 256.35 647.51 257.2 647.84 257.4C647.84 257.4 647.17 257.9 647.34 259.1C647.51 260.3 648.04 260.9 648.04 260.9C648.04 260.9 647.34 261.5 647.64 262.6C647.94 263.7 648.64 264.2 648.64 264.2C648.64 264.2 648.47 265.4 648.54 265.8C648.61 266.2 650.4 267.75 651.04 268.1C651.04 268.1 649.04 266.5 648.94 265.74C648.84 264.97 648.91 264.31 648.91 264.31C648.91 264.31 648.04 263.18 647.91 262.58C647.78 261.98 648.34 261.02 648.34 261.02C648.34 261.02 647.71 260.19 647.64 259.12C647.57 258.05 648.07 257.49 648.07 257.49C648.07 257.49 647.37 256.76 647.41 255.79C647.44 254.82 647.71 254.46 648.34 254.29C648.97 254.12 651.14 253.56 651.14 253.56V253.55Z"
        fill="url(#paint340_radial_2072_10275)"
      />
      <path
        d="M660.73 265.99C660.73 265.99 655.32 267.52 653.89 267.59C652.89 267.64 652.34 266.59 653.04 266.09C653.74 265.59 652.59 264.79 652.54 264.19C652.39 262.44 653.24 262.29 653.29 261.64C653.31 261.34 653.08 261.11 652.74 260.49C651.79 258.74 653.49 258.09 653.54 257.5C653.58 257.05 652.96 256.7 653.14 255.85C653.44 254.45 655.04 254.75 656.13 255.15C657.23 255.55 662.82 258.79 663.22 259.69C663.62 260.59 666.02 264.48 660.72 265.98L660.73 265.99Z"
        fill="url(#paint341_radial_2072_10275)"
      />
      <path
        d="M647.38 256.8C647.38 256.8 647.56 257.22 647.85 257.4C647.85 257.4 653.27 258.15 653.14 257.85C653.01 257.55 647.7 256.84 647.38 256.8Z"
        fill="url(#paint342_radial_2072_10275)"
      />
      <path
        d="M647.71 260.33C647.71 260.33 647.89 260.72 648.05 260.9C648.05 260.9 652.78 262.11 652.84 261.9C652.91 261.68 647.71 260.33 647.71 260.33Z"
        fill="url(#paint343_radial_2072_10275)"
      />
      <path
        d="M648.65 264.19C648.65 264.19 652.68 265.72 652.64 265.54C652.61 265.36 648.05 263.52 648.05 263.52C648.05 263.52 648.32 263.94 648.64 264.19H648.65Z"
        fill="url(#paint344_radial_2072_10275)"
      />
      <path
        d="M696.72 266.12C695.7 266.33 664.3 265.32 664.3 265.32C663.69 265.32 663.28 265.34 663.22 265.39C662.92 265.59 658.86 268.28 658.53 268.58C659.8 268.33 662.32 266.99 663.02 266.89C663.08 266.89 663.4 266.89 663.4 266.89C663.4 266.89 685.74 268.16 685.97 268.17C686.37 268.18 697.91 268.74 699.15 267.99C700.18 267.37 701 264.81 701 264.81C701 264.81 698.2 265.83 696.72 266.12Z"
        fill="url(#paint345_radial_2072_10275)"
      />
      <path
        d="M675.07 174.97C677.14 175.2 676.76 176.42 675.99 178.57C675.46 184.2 673.72 186.88 672.99 186.58C671.66 186.02 672.57 174.7 675.07 174.98V174.97Z"
        fill="#CD8845"
      />
      <path
        d="M673.89 182.85C673.89 182.85 674.79 181.76 674.29 179.81C673.11 175.22 676.38 174.61 675.94 177.85C675.94 177.85 675.34 176.39 674.96 176.88C674.5 177.48 675.59 177.68 675.29 180.13C675.13 181.4 673.89 182.84 673.89 182.84V182.85Z"
        fill="url(#paint346_linear_2072_10275)"
      />
      <path
        d="M636.48 175.2C634.43 175.54 634.87 176.74 635.75 178.84C636.58 184.43 638.69 186.67 639.4 186.32C640.7 185.69 638.96 174.79 636.48 175.2Z"
        fill="#CD8845"
      />
      <path
        d="M673.18 174.8C673.78 159.68 667.49 153.41 653.69 154.26C653.69 154.26 644.28 154.59 641.93 159.75C639.42 165.26 638.5 170.23 638.69 177.33C639.08 192.16 641.92 192.45 644.23 195.32C645.8 197.27 649.99 201.29 651.34 202.02C653.52 203.2 660.19 203.02 662.27 201.71C664.09 200.56 666.36 197.75 669 194.32C671.16 191.52 673.22 190.93 672.98 182.93C672.84 178.06 673.01 179 673.18 174.81V174.8Z"
        fill="#CD8845"
      />
      <path
        d="M663.8 187.98C666.77 188.26 671.79 189.69 672.62 184.65C673.41 179.9 672.73 177.55 671.26 177.17C667.65 176.22 663.49 178.4 661.8 179.64C657.87 182.53 658.53 187.49 663.8 187.98Z"
        fill="url(#paint347_radial_2072_10275)"
      />
      <path
        d="M656.93 198.4C655.9 198.4 653.31 199.1 653.39 199.48C653.62 200.63 656.01 200.82 657.05 200.81C658.08 200.81 660.17 200.54 660.21 199.56C660.23 199.18 657.97 198.39 656.93 198.39V198.4Z"
        fill="url(#paint348_linear_2072_10275)"
      />
      <path
        d="M649.39 179.19C648.84 178.9 642.44 176.44 640.14 177.41C638.51 178.1 638.37 181.7 639.83 186.45C641.5 191.88 646.21 189.07 648.13 188.02C652.77 185.48 653.69 181.48 649.38 179.19H649.39Z"
        fill="url(#paint349_radial_2072_10275)"
      />
      <path
        d="M658.09 185.47C660.14 184.96 660.94 185.26 660.94 185.26C659.75 184.22 658.09 185.47 658.09 185.47Z"
        fill="url(#paint350_linear_2072_10275)"
      />
      <path
        d="M670.33 177.71C671.62 167.94 659.77 172.11 659.77 172.11C658.83 172.98 658.29 178.04 659.15 178.55C664.49 181.7 670.34 177.71 670.34 177.71H670.33Z"
        fill="url(#paint351_linear_2072_10275)"
      />
      <path
        d="M642.19 177.97C641.33 167.79 652.24 172.2 652.24 172.2C652.93 173.25 654.16 177.71 653.33 178.25C647.87 181.76 642.2 177.97 642.2 177.97H642.19Z"
        fill="url(#paint352_linear_2072_10275)"
      />
      <path
        d="M652.29 185.11C652.29 185.11 653.35 184.94 654.96 185.48C654.96 185.48 653.39 184.29 652.29 185.11Z"
        fill="url(#paint353_linear_2072_10275)"
      />
      <path
        d="M659.68 182.06C660.15 183.25 659.6 184.1 658.78 184.61C657.9 185.19 655.33 185.35 654.37 184.82C653.55 184.4 652.91 183.55 653.14 181.91C653.14 181.91 652.63 182.29 652.17 182.74C651.19 183.62 651.1 185.16 652.17 185.17C652.17 185.17 652.81 184.78 653.62 184.92C654.59 185.09 654.4 186.09 656.65 186.11C658.61 186.13 657.98 185.19 659.23 185.01C660.48 184.83 660.64 185.15 660.92 185.28C661.54 185.28 662.16 183.34 659.67 182.05L659.68 182.06Z"
        fill="url(#paint354_linear_2072_10275)"
      />
      <path
        d="M654.7 154.24C642.79 155.61 639.39 161.7 638.76 167.37C638.56 169.21 639.01 181.52 639.09 183.26C639.51 179.25 640.89 177.84 641.56 175.83C642.65 172.74 643.41 171.45 643.35 167.32C643.43 159.75 650.99 158.6 655.13 158.53C663.99 158.37 667.98 160.76 668.1 166.89C668.18 171.24 669.57 172.59 670.4 175.12C671.45 177.76 672.84 181.34 673.17 184.27C673.17 184.27 672.74 167.81 672.44 164.6C672.05 160.4 668.57 152.65 654.68 154.24H654.7Z"
        fill="url(#paint355_linear_2072_10275)"
      />
      <path
        d="M671.53 179.07C670.99 178.77 670.6 179.21 669.48 179.57C668.39 179.93 665.4 180.49 666.81 181.26C668.36 182.1 670.53 180.95 670.79 180.73C671.05 180.51 672.19 179.44 671.53 179.07Z"
        fill="url(#paint356_linear_2072_10275)"
      />
      <path
        d="M652.43 177.97C652.8 177.55 652.46 176.62 652.28 176.04C651.72 174.22 650.38 173.58 647.58 173.42C646.66 173.37 645.07 173.51 644.06 174.38C643.28 175.05 642.82 176.35 642.88 176.98C642.91 177.3 643.46 178.84 646.51 179.05C648.5 179.18 651.66 178.85 652.43 177.98V177.97Z"
        fill="url(#paint357_linear_2072_10275)"
      />
      <path
        d="M649.46 175.25C650.93 175.46 651.81 177.84 651.81 177.84C651.64 178.14 651.1 178.31 650.7 178.38C649.56 178.57 647.88 178.95 645.33 178.29C644.42 178.05 643.67 177 643.67 177C645.4 174.94 644.52 174.54 649.46 175.25Z"
        fill="url(#paint358_linear_2072_10275)"
      />
      <path
        d="M651.81 177.83C651.81 177.83 650.99 176.77 646.54 176.67C645.24 176.64 644.41 177.34 644.12 177.54C643.87 177.33 643.76 177.14 643.68 177C643.68 177 645.78 174.7 647.37 174.88C648.97 175.06 651.49 175.81 651.81 177.83Z"
        fill="#DEDEDD"
      />
      <path
        d="M650.51 177.24C650.59 175.77 649.32 175.07 647.97 175.13C646.62 175.2 645.42 175.92 645.59 177.35C645.63 177.65 645.66 178.03 646 178.43C646.13 178.47 646.48 178.54 646.89 178.6C646.66 178.34 646.51 178 646.5 177.62C646.49 176.78 647.15 176.09 647.98 176.07C648.81 176.05 649.49 176.72 649.5 177.56C649.5 177.97 649.35 178.34 649.1 178.62C649.45 178.59 649.81 178.54 650.15 178.47C650.21 178.41 650.49 177.79 650.52 177.24H650.51Z"
        fill="url(#paint359_linear_2072_10275)"
      />
      <path
        d="M650.51 177.18C650.51 177.18 647.71 176.31 645.59 176.78C645.59 176.78 645.92 175.04 647.49 175.04C649.2 175.04 650.5 175.35 650.51 177.17V177.18Z"
        fill="url(#paint360_linear_2072_10275)"
      />
      <path
        d="M647.98 176.07C647.15 176.08 646.49 176.78 646.5 177.62C646.5 178 646.65 178.34 646.89 178.6C647.24 178.65 647.63 178.69 647.97 178.68C648.32 178.68 648.71 178.66 649.1 178.62C649.35 178.34 649.51 177.97 649.5 177.56C649.49 176.72 648.8 176.05 647.98 176.07Z"
        fill="url(#paint361_linear_2072_10275)"
      />
      <path
        d="M647.98 176.07C647.15 176.08 646.49 176.78 646.5 177.62C646.5 178 646.65 178.34 646.89 178.6C647.24 178.65 647.63 178.69 647.97 178.68C648.32 178.68 648.71 178.66 649.1 178.62C649.35 178.34 649.51 177.97 649.5 177.56C649.49 176.72 648.8 176.05 647.98 176.07Z"
        fill="url(#paint362_radial_2072_10275)"
      />
      <path
        d="M648.64 177.6C648.49 177.29 648.63 176.9 648.95 176.73C649.27 176.56 649.66 176.68 649.81 176.99C649.96 177.3 649.82 177.69 649.5 177.86C649.18 178.03 648.79 177.91 648.64 177.6Z"
        fill="white"
      />
      <path
        d="M659.51 178.02C659.15 177.6 659.5 176.67 659.68 176.09C660.27 174.28 661.61 173.65 664.41 173.53C665.33 173.49 666.92 173.65 667.92 174.53C668.69 175.21 669.14 176.52 669.07 177.14C669.03 177.46 668.47 179 665.41 179.16C663.41 179.27 660.26 178.89 659.51 178.02Z"
        fill="url(#paint363_linear_2072_10275)"
      />
      <path
        d="M662.51 175.33C661.04 175.53 660.12 177.9 660.12 177.9C660.28 178.2 660.82 178.38 661.22 178.45C662.36 178.65 664.04 179.05 666.59 178.42C667.51 178.19 668.27 177.15 668.27 177.15C666.56 175.07 667.45 174.68 662.51 175.33Z"
        fill="url(#paint364_linear_2072_10275)"
      />
      <path
        d="M660.13 177.88C660.13 177.88 660.96 176.83 665.41 176.78C666.71 176.76 667.53 177.48 667.82 177.68C668.08 177.48 668.18 177.29 668.27 177.15C668.27 177.15 666.2 174.83 664.61 174.99C663.01 175.15 660.47 175.87 660.13 177.89V177.88Z"
        fill="#DEDEDD"
      />
      <path
        d="M664 175.24C662.65 175.16 661.37 175.84 661.43 177.32C661.45 177.88 661.74 178.49 661.8 178.56C661.92 178.6 662.36 178.67 662.84 178.72C662.59 178.44 662.44 178.07 662.45 177.66C662.47 176.82 663.16 176.16 663.99 176.18C664.82 176.2 665.47 176.91 665.45 177.75C665.45 178.13 665.29 178.48 665.05 178.74C665.45 178.68 665.8 178.61 665.93 178.57C666.27 178.18 666.31 177.8 666.35 177.49C666.54 176.07 665.35 175.33 664 175.25V175.24Z"
        fill="url(#paint365_linear_2072_10275)"
      />
      <path
        d="M661.44 177.24C661.44 177.24 664.25 176.41 666.36 176.9C666.36 176.9 666.05 175.16 664.48 175.14C662.77 175.12 661.46 175.41 661.44 177.24Z"
        fill="url(#paint366_linear_2072_10275)"
      />
      <path
        d="M664 176.17C663.17 176.14 662.48 176.8 662.46 177.65C662.45 178.06 662.6 178.43 662.85 178.71C663.26 178.75 663.69 178.79 663.99 178.8C664.33 178.8 664.72 178.77 665.06 178.73C665.3 178.47 665.45 178.13 665.46 177.74C665.48 176.9 664.83 176.2 664 176.17Z"
        fill="url(#paint367_linear_2072_10275)"
      />
      <path
        d="M664 176.17C663.17 176.14 662.48 176.8 662.46 177.65C662.45 178.06 662.6 178.43 662.85 178.71C663.26 178.75 663.69 178.79 663.99 178.8C664.33 178.8 664.72 178.77 665.06 178.73C665.3 178.47 665.45 178.13 665.46 177.74C665.48 176.9 664.83 176.2 664 176.17Z"
        fill="url(#paint368_radial_2072_10275)"
      />
      <path
        d="M665.77 177.6C665.92 177.29 665.79 176.9 665.47 176.73C665.15 176.56 664.76 176.67 664.61 176.98C664.45 177.29 664.59 177.68 664.91 177.85C665.23 178.02 665.62 177.91 665.77 177.6Z"
        fill="white"
      />
      <path
        d="M664.23 178.26C664.35 178.02 664.25 177.71 663.99 177.58C663.74 177.45 663.43 177.53 663.31 177.78C663.19 178.02 663.29 178.33 663.55 178.46C663.8 178.59 664.11 178.5 664.23 178.26Z"
        fill="white"
      />
      <path
        d="M660.13 177.89C660.13 177.89 660.19 176.44 661.54 175.47C662.96 174.45 665.71 174.5 667.15 175.36C668.01 175.88 668.28 177.15 668.28 177.15C668.28 177.15 667.4 176.91 666.45 176.47C665.27 175.91 664.79 175.96 664.05 175.95C662.98 175.95 662.58 176.13 662.1 176.26C660.85 176.59 660.13 177.9 660.13 177.9V177.89Z"
        fill="url(#paint369_linear_2072_10275)"
      />
      <path
        d="M668.28 177.15C668.28 177.15 667.5 178.17 666.42 178.43C665.75 178.59 664.79 178.85 663.3 178.75C663.3 178.75 664.43 179.19 666.61 178.63C667.78 178.33 668.28 177.15 668.28 177.15Z"
        fill="url(#paint370_linear_2072_10275)"
      />
      <path
        d="M647.37 178.26C647.25 178.01 647.36 177.71 647.61 177.58C647.87 177.45 648.17 177.54 648.29 177.79C648.41 178.04 648.3 178.34 648.05 178.47C647.79 178.6 647.49 178.51 647.37 178.26Z"
        fill="white"
      />
      <path
        d="M651.81 177.84C651.81 177.84 651.78 176.39 650.43 175.4C649.02 174.36 646.27 174.38 644.83 175.22C643.96 175.73 643.67 177 643.67 177C643.67 177 644.56 176.77 645.51 176.34C646.7 175.8 647.18 175.85 647.91 175.85C648.98 175.86 649.38 176.05 649.86 176.18C651.1 176.53 651.81 177.84 651.81 177.84Z"
        fill="url(#paint371_linear_2072_10275)"
      />
      <path
        d="M643.67 177C643.67 177 644.44 178.03 645.51 178.31C646.18 178.48 647.17 178.75 648.66 178.66C648.66 178.66 647.48 179.09 645.32 178.5C644.16 178.19 643.66 177 643.66 177H643.67Z"
        fill="url(#paint372_linear_2072_10275)"
      />
      <path
        d="M642.53 179.93C641.4 179.62 640.98 179.21 640.46 179.53C639.82 179.94 641.01 180.95 641.29 181.15C641.56 181.35 643.79 182.4 645.29 181.47C646.65 180.63 643.64 180.23 642.53 179.92V179.93Z"
        fill="url(#paint373_linear_2072_10275)"
      />
      <path
        d="M662.74 185.37C667.39 189.13 663.83 191.56 663.83 191.56C665.26 190.3 667.53 188.79 667.39 188.22C666.93 186.31 662.74 185.38 662.74 185.38V185.37Z"
        fill="url(#paint374_linear_2072_10275)"
      />
      <path
        d="M645.64 188.51C645.72 189.09 647.38 190.53 648.46 191.66C648.46 191.66 645.57 188.55 649.59 185.75C649.59 185.75 645.36 186.55 645.64 188.52V188.51Z"
        fill="url(#paint375_linear_2072_10275)"
      />
      <path
        d="M652.56 196.21C657.59 195.65 660.98 196.27 660.98 196.27C657.17 193.9 652.56 196.21 652.56 196.21Z"
        fill="url(#paint376_linear_2072_10275)"
      />
      <path
        d="M647.08 188.18C647.18 188.29 647.26 188.43 647.39 188.49C649.8 189.56 649.84 190.58 650.87 191.14C654.54 193.12 658.81 192.64 661.69 191.05C663.35 190.14 663.56 189.07 665.54 188.3C665.8 188.2 665.86 187.99 665.86 187.99C655.28 190.58 647.08 188.19 647.08 188.19V188.18Z"
        fill="#96282D"
      />
      <path
        d="M656.56 193.22C655.13 193.22 653.72 192.94 653.72 193.22C653.72 193.5 654.96 194.12 656.39 194.12C657.82 194.12 659.23 193.5 659.23 193.22C659.23 192.94 657.99 193.22 656.56 193.22Z"
        fill="url(#paint377_linear_2072_10275)"
      />
      <path
        d="M651.47 190.42C651.02 190.34 650.83 191.12 650.83 191.12C652.17 192.1 653.79 192.47 656.38 192.49C659.83 192.51 661.74 191.02 661.74 191.02C661.74 191.02 661.25 190.27 660.69 190.38C659.72 190.58 657.89 190.94 656.22 190.94C654.37 190.94 652.5 190.6 651.48 190.42H651.47Z"
        fill="url(#paint378_linear_2072_10275)"
      />
      <path
        d="M651.29 193.58C656.8 197.96 662.08 193.28 662.08 193.28C656.51 196.25 651.29 193.58 651.29 193.58Z"
        fill="url(#paint379_linear_2072_10275)"
      />
      <path
        d="M649.47 188.68C649.47 188.68 649.5 189.59 650.43 189.98C650.96 190.21 652.16 191.12 656.82 190.98C661.48 190.84 662.4 189.71 662.61 189.52C663.01 189.15 663.19 188.54 663.19 188.54C663.19 188.54 656.17 189.91 649.48 188.68H649.47Z"
        fill="url(#paint380_linear_2072_10275)"
      />
      <path
        d="M649.46 188.6C649.46 188.6 649.49 189.01 649.64 189.26C649.77 189.46 653.49 190.01 656.3 190.02C659.11 190.04 662.78 189.31 662.91 189.15C663.11 188.9 663.22 188.45 663.22 188.45C663.22 188.45 660.06 189.51 649.46 188.6Z"
        fill="#F3ECEB"
      />
      <path
        d="M646.5 187.89C646.5 187.89 647.18 188.28 647.07 188.18C647.07 188.18 655.26 190.57 665.85 187.98L666.42 187.69C660.67 188.65 646.49 187.89 646.49 187.89H646.5Z"
        fill="url(#paint381_linear_2072_10275)"
      />
      <path
        d="M638.25 183.05C638.25 183.05 637.3 182.01 637.7 180.04C638.63 175.4 635.34 174.96 635.95 178.17C635.95 178.17 636.47 176.68 636.88 177.15C637.37 177.72 636.29 177.99 636.73 180.42C636.96 181.68 638.27 183.05 638.27 183.05H638.25Z"
        fill="url(#paint382_linear_2072_10275)"
      />
      <path
        d="M647.8 199.06C647.8 199.06 650.88 203.54 656.74 203.52C662.48 203.5 664.74 199.53 664.74 199.53C664.74 199.53 661.79 202.65 656.39 202.58C651.18 202.51 647.8 199.06 647.8 199.06Z"
        fill="url(#paint383_linear_2072_10275)"
      />
      <path
        d="M673.11 179.66C673.11 179.66 673.36 187.55 672.08 190.58C671.3 192.41 665.97 198.01 665.18 199.01C665.18 199.01 665.87 195.37 667.43 193.44C668.99 191.51 672.94 189.86 673.12 179.66H673.11Z"
        fill="url(#paint384_linear_2072_10275)"
      />
      <path
        d="M638.99 180.73C638.99 180.73 638.99 188.66 640.64 191.23C642.13 193.55 646.85 198.16 647.48 198.75C647.48 198.75 647.31 196.07 645.61 194.28C643.9 192.48 639.63 190 638.99 180.74V180.73Z"
        fill="url(#paint385_linear_2072_10275)"
      />
      <path
        d="M644.53 170.83C646.75 170.04 649.65 170.44 651.67 171.25C652.43 171.56 652.34 172.76 651.44 172.77C649.75 172.78 647.83 172.17 645.84 172.27C643.5 172.38 642.48 173.09 642.48 173.09C642.48 173.09 643.68 171.14 644.53 170.84V170.83Z"
        fill="url(#paint386_linear_2072_10275)"
      />
      <path
        d="M667.33 170.67C665.1 169.91 662.21 170.35 660.2 171.19C659.44 171.51 659.55 172.71 660.45 172.7C662.14 172.7 664.05 172.05 666.05 172.12C668.39 172.2 669.42 172.89 669.42 172.89C669.42 172.89 668.19 170.96 667.33 170.67Z"
        fill="url(#paint387_linear_2072_10275)"
      />
      <path
        d="M639 181.03C639 181.03 639.35 177.63 640.17 174.65C640.92 171.91 641.69 171.06 641.61 169.08C641.49 166.21 643.2 160.86 644.2 160.27C651.65 155.93 664.7 158.18 667.43 160.06C668.6 160.87 669.93 166.56 670.02 168.84C670.1 170.97 671.25 172.03 672 174.71C672.72 177.26 673.13 180.35 673.13 180.35C673.13 180.35 673.45 176.11 674.21 175.36C674.15 172.74 674.01 165.56 673.11 160.95C672.57 158.17 669.52 152.06 660.33 151.33C654.97 150.91 650.01 151.42 646.96 152.33C644.1 153.19 639.27 157.48 638.6 162.63C638.06 166.83 637.68 175.87 637.68 175.87C637.68 175.87 639.03 177.58 639 181.02V181.03Z"
        fill="url(#paint388_linear_2072_10275)"
      />
      <path
        d="M656.49 180.09C657.99 180.09 658.46 182.72 658.25 183.47C658.04 184.22 654.7 185.08 654.47 183.16C654.26 181.47 655.55 180.09 656.49 180.09Z"
        fill="url(#paint389_linear_2072_10275)"
      />
      <path
        d="M640.98 157.08C640.98 157.08 642.79 154.24 645.75 152.74C649.17 151 660.32 150.2 665.51 152.17C668.28 153.22 670.47 155.92 670.47 155.92C670.47 155.92 666.75 152.74 659.5 152.36C652.25 151.98 645.95 152.31 640.98 157.08Z"
        fill="url(#paint390_linear_2072_10275)"
      />
      <path
        d="M676.82 161.05H635.88C636.63 153.57 641.42 147.25 648.03 144.3C648.29 144.18 648.56 144.07 648.82 143.97C649.62 143.65 650.45 143.38 651.29 143.17C651.87 143.02 652.47 142.9 653.07 142.8C654.14 142.63 655.24 142.54 656.35 142.54C658.09 142.54 659.79 142.76 661.41 143.17C661.98 143.31 662.53 143.48 663.08 143.67C663.2 143.71 663.32 143.76 663.44 143.8C663.56 143.84 663.68 143.89 663.8 143.94C663.98 144.01 664.16 144.08 664.33 144.16C664.44 144.21 664.55 144.26 664.67 144.31C671.27 147.26 676.07 153.59 676.82 161.06V161.05Z"
        fill="#006838"
        stroke="#231F20"
        strokeWidth="0.2"
        strokeMiterlimit={10}
      />
      <path
        d="M676.92 162.26V168H635.77V162.26C635.77 162.02 635.77 161.79 635.78 161.56H676.9C676.9 161.79 676.91 162.03 676.91 162.26H676.92Z"
        fill="#006838"
        stroke="#231F20"
        strokeWidth="0.2"
        strokeMiterlimit={10}
      />
      <path
        d="M664.67 144.3V161.05H648.02V144.3C648.28 144.18 648.55 144.07 648.81 143.97C649.61 143.65 650.44 143.38 651.28 143.17C651.86 143.02 652.46 142.9 653.06 142.8C654.13 142.63 655.23 142.54 656.34 142.54C658.08 142.54 659.78 142.76 661.4 143.17C661.97 143.31 662.52 143.48 663.07 143.67C663.19 143.71 663.31 143.76 663.43 143.8C663.55 143.84 663.67 143.89 663.79 143.94C663.97 144.01 664.15 144.08 664.32 144.16C664.43 144.21 664.54 144.26 664.66 144.31L664.67 144.3Z"
        fill="#39B54A"
        stroke="#231F20"
        strokeWidth="0.2"
        strokeMiterlimit={10}
      />
      <path
        d="M661.41 143.17V158.27C661.41 158.62 661.3 158.94 661.1 159.2C660.82 159.58 660.37 159.82 659.86 159.82H652.83C652.32 159.82 651.88 159.58 651.59 159.2C651.4 158.94 651.28 158.62 651.28 158.27V143.17C651.28 142.58 651.61 142.06 652.12 141.8C652.25 141.73 652.39 141.68 652.55 141.65C653.78 141.42 655.05 141.3 656.35 141.3C657.65 141.3 658.91 141.42 660.15 141.65C660.88 141.79 661.41 142.42 661.41 143.17Z"
        fill="#006838"
        stroke="#231F20"
        strokeWidth="0.2"
        strokeMiterlimit={10}
      />
      <path
        d="M679.41 168.68C679.41 168.87 679.33 169.04 679.21 169.16C679.09 169.28 678.92 169.36 678.73 169.36H633.96C633.59 169.36 633.28 169.06 633.28 168.68C633.28 168.49 633.36 168.32 633.48 168.2C633.6 168.08 633.77 168 633.96 168H678.73C679.1 168 679.41 168.3 679.41 168.68Z"
        fill="#004715"
        stroke="#231F20"
        strokeWidth="0.2"
        strokeMiterlimit={10}
      />
      <path
        d="M661.2 160.21C661.2 160.5 661.17 160.78 661.13 161.05C661.1 161.22 661.06 161.39 661.01 161.56C660.42 163.59 658.56 165.07 656.34 165.07C655.73 165.07 655.14 164.96 654.6 164.75C653.19 164.21 652.09 163.03 651.67 161.56C651.62 161.39 651.58 161.23 651.55 161.05C651.5 160.78 651.48 160.49 651.48 160.21C651.48 159.86 651.52 159.52 651.59 159.2C652.06 157 654.01 155.36 656.34 155.36C656.78 155.36 657.22 155.42 657.62 155.53C659.36 156.01 660.71 157.42 661.09 159.2C661.16 159.53 661.2 159.87 661.2 160.21Z"
        fill="#BCBEC0"
        stroke="#231F20"
        strokeWidth="0.2"
        strokeMiterlimit={10}
      />
      <path
        d="M656.35 163.46C658.195 163.46 659.69 161.965 659.69 160.12C659.69 158.275 658.195 156.78 656.35 156.78C654.505 156.78 653.01 158.275 653.01 160.12C653.01 161.965 654.505 163.46 656.35 163.46Z"
        fill="#39B54A"
        stroke="#231F20"
        strokeWidth="0.2"
        strokeMiterlimit={10}
      />
      <path
        opacity="0.09"
        d="M657.65 154.78C657.65 155.03 657.65 155.27 657.63 155.52C657.61 156.02 657.57 156.51 657.51 156.99C657.39 157.95 657.19 158.89 656.92 159.81C656.8 160.23 656.66 160.64 656.5 161.05C656.44 161.22 656.37 161.39 656.3 161.56C656.05 162.17 655.77 162.76 655.45 163.34C655.19 163.82 654.91 164.29 654.6 164.74C653.82 165.91 652.91 167.01 651.88 168C651.39 168.47 650.87 168.93 650.33 169.35H633.95C633.58 169.35 633.27 169.05 633.27 168.67C633.27 168.48 633.35 168.31 633.47 168.19C633.59 168.07 633.76 167.99 633.95 167.99H635.76V162.25C635.76 162.01 635.76 161.78 635.77 161.55H651.67C651.62 161.38 651.58 161.22 651.55 161.04H635.86C636.61 153.56 641.4 147.24 648.01 144.29C648.27 144.17 648.54 144.06 648.8 143.96C649.6 143.64 650.43 143.37 651.27 143.16C651.27 142.57 651.6 142.05 652.11 141.79C652.43 142.11 652.75 142.45 653.05 142.79C655.92 146.08 657.63 150.24 657.63 154.78H657.65Z"
        fill="url(#paint391_linear_2072_10275)"
      />
      <path
        d="M265.21 203.73C265.21 203.73 262.08 200.42 261.67 199.56C261.12 198.41 261.22 196.89 261.44 195.52C261.6 194.47 262.41 191.4 262.41 191.4C262.41 191.4 261.96 186.7 261.9 186.09C261.79 185.11 261.99 183.11 261.15 182.61C259.78 181.8 258.86 184.29 258.94 185.82C259.02 187.35 258.25 192.13 258.25 192.13L253.71 192.24L245.35 186.84C245.35 186.84 240.96 184.42 238.91 183.85C237.47 183.45 237.53 185.47 237.53 185.47C237.53 185.47 235.39 183.21 234.3 184.84C233.43 186.13 234.94 187.48 234.94 187.48C234.94 187.48 233.93 187.44 233.61 188.49C233.21 189.8 235.33 191.77 235.5 192.02C234.81 192.02 232.79 193.29 234.55 195.2C235.13 195.83 239.93 199.58 240.46 200C240.99 200.42 245.98 205.97 247.53 206.73C249.08 207.49 257.32 210.02 258.04 210.76L265.22 203.73H265.21Z"
        fill="#F7D4AB"
      />
      <path
        d="M261.86 185.56C261.86 185.56 261.05 185.53 260.84 185.41C260.63 185.29 260.61 182.62 261.05 182.61C261.49 182.59 261.97 183.55 261.86 185.57V185.56Z"
        fill="#F7DBB6"
      />
      <path
        d="M260.5 182.47C260.5 182.47 259.42 182.58 259.12 183.84C258.72 185.51 258.58 191.06 258.1 191.62C257.5 192.31 253.69 192.18 253.69 192.18C250.52 190.15 248.55 188.83 247.65 188.36C247.65 188.36 251.87 192.2 252.95 193.01C253.75 193.61 258.21 193.12 258.64 193.19C259.78 193.37 258.92 191.31 259.02 190.43C259.07 190.02 258.79 185.44 260.5 182.48V182.47Z"
        fill="url(#paint392_linear_2072_10275)"
      />
      <path
        d="M245.34 186.86C245.34 186.86 240.72 184.24 238.83 183.77C238.19 183.61 237.03 184.18 237.51 185.48C237.51 185.48 237.77 183.98 238.77 184.4C239.77 184.82 245.34 186.85 245.34 186.85V186.86Z"
        fill="url(#paint393_linear_2072_10275)"
      />
      <path
        d="M234.92 187.48C234.92 187.48 233.21 186.03 234.23 184.75C235.47 183.19 237.51 185.47 237.51 185.47C237.51 185.47 235.66 184.16 234.74 185.16C233.96 186 234.92 187.47 234.92 187.47V187.48Z"
        fill="url(#paint394_linear_2072_10275)"
      />
      <path
        d="M235.73 192.22C235.73 192.22 232.74 190.13 233.46 188.5C234.05 187.17 234.93 187.47 234.93 187.47C234.93 187.47 233.78 187.66 233.76 189.11C233.75 189.83 235.74 192.21 235.74 192.21L235.73 192.22Z"
        fill="url(#paint395_linear_2072_10275)"
      />
      <path
        d="M240.5 200.05C240.5 200.05 234.42 195.57 233.95 194.61C233.39 193.46 234.08 191.96 235.47 192.03C235.47 192.03 233.76 192.44 234.22 194.14C234.46 195.04 240.5 200.05 240.5 200.05Z"
        fill="url(#paint396_linear_2072_10275)"
      />
      <path
        d="M240.91 200.45C240.91 200.45 243.42 203.31 247.02 206.76C247.46 207.18 258.03 210.76 258.03 210.76L258.72 209.54C258.72 209.54 247.9 206.7 247.48 206.41C247.06 206.12 240.91 200.46 240.91 200.46V200.45Z"
        fill="url(#paint397_linear_2072_10275)"
      />
      <path
        d="M262.22 189.52C262.22 189.52 262.35 190.86 262.4 191.4C262.45 191.94 261.42 197.89 261.35 198.28C261.13 199.67 264.98 203.36 264.98 203.36L262.86 203.67C262.86 203.67 260.45 199.42 260.13 198.82C259.81 198.22 260.97 195.45 261.27 194.66C261.83 193.19 262.1 190.82 262.21 189.52H262.22Z"
        fill="url(#paint398_linear_2072_10275)"
      />
      <path
        d="M244.83 189.66C244.67 189.02 246.4 188.38 246.4 188.38C246.4 188.38 248.42 189.75 248.3 190.36C248.18 190.97 247.32 191.54 247.1 191.55C246.88 191.55 244.88 189.88 244.82 189.66H244.83Z"
        fill="url(#paint399_linear_2072_10275)"
      />
      <path
        d="M242.17 192.66C241.83 192.29 243.7 191 243.83 191.22C243.96 191.44 246.13 192.81 245.89 193.12C245.64 193.43 245.2 194.37 244.83 194.46C244.45 194.55 242.38 192.88 242.18 192.66H242.17Z"
        fill="url(#paint400_linear_2072_10275)"
      />
      <path
        d="M241.39 194.14C241.7 193.9 243.93 195.57 243.97 195.95C244.01 196.33 243.44 197.11 243.22 197.12C243 197.12 240.47 195.63 240.51 195.17C240.55 194.71 241.4 194.14 241.4 194.14H241.39Z"
        fill="url(#paint401_linear_2072_10275)"
      />
      <path
        d="M239.67 188.87C239.96 188.58 240.73 188.45 240.73 188.45C240.73 188.45 242.87 190.27 242.77 190.51C242.68 190.74 241.8 191.62 241.42 191.78C241.04 191.95 238.75 190.21 238.85 189.9C238.95 189.59 239.43 189.12 239.67 188.88V188.87Z"
        fill="url(#paint402_linear_2072_10275)"
      />
      <path
        d="M237.32 191.7C237.32 191.7 237.75 190.92 238.03 191.06C238.31 191.2 240.89 193.08 240.86 193.39C240.84 193.7 240.17 194.64 239.95 194.65C239.73 194.65 236.78 192.87 237.31 191.7H237.32Z"
        fill="url(#paint403_linear_2072_10275)"
      />
      <path
        d="M248.76 191.16C248.5 191.29 246.85 191.87 246.84 191.87C245.62 191.21 239.57 186.51 238 185.77C238.66 186.26 246.2 192.33 246.56 192.62C246.41 193.1 245.9 193.97 246.25 193.43C246.63 192.84 249.01 191.02 248.76 191.16Z"
        fill="url(#paint404_linear_2072_10275)"
      />
      <path
        d="M245.69 194.43C245.53 194.55 244.96 194.79 244.59 194.93C243.29 194.43 235.85 188.01 235.13 187.71C234.44 187.42 242.84 194.49 244.14 195.58C244.14 195.62 244.14 195.66 244.14 195.71C244.14 196.13 243.51 197.28 243.86 196.73C244.23 196.14 245.93 194.25 245.7 194.43H245.69Z"
        fill="url(#paint405_linear_2072_10275)"
      />
      <path
        d="M243.67 196.78C243.55 196.92 243.2 197.33 242.91 197.62C242.29 197.06 236.09 192.21 235.62 192.23C235.18 192.25 241.59 197.24 242.57 197.99C242.57 198.07 242.23 200.91 242.41 200.27C242.48 200.02 243.85 196.57 243.67 196.78Z"
        fill="url(#paint406_linear_2072_10275)"
      />
      <path
        d="M245.87 199.85C245.87 199.85 251.17 194.95 251.42 193.92C251.67 192.88 253.85 200.8 255.09 201.96C256.32 203.11 247.13 200.1 245.88 199.86L245.87 199.85Z"
        fill="url(#paint407_linear_2072_10275)"
      />
      <path
        d="M244.25 201.65C244.25 201.65 246.39 205.3 247.96 205.93C249.53 206.55 254.45 208.57 255.4 207.62C256.36 206.67 257.3 204.12 254.49 203.31C251.69 202.5 242.26 198.91 244.25 201.65Z"
        fill="url(#paint408_linear_2072_10275)"
      />
      <path
        d="M264.99 203.36C264.99 203.36 284 218.2 293.48 220.51C298.98 221.85 312.06 217.12 313.11 216.65C320.09 213.51 325.96 210.11 325.96 210.11L324.25 233.73L289.8 234.37L276.07 226.53L258.17 210.58C258.17 210.58 259.09 208.32 264.99 203.37V203.36Z"
        fill="#F7D4AB"
      />
      <path
        d="M258.02 210.76C258.02 210.76 283.65 234.64 289.08 236.48C294.51 238.33 326.76 234.73 326.76 234.73L324.76 229.97C324.76 229.97 299.39 236.93 288.76 232.05C282.88 229.35 258.71 209.53 258.71 209.53C258.71 209.53 258.24 210.19 258.02 210.75V210.76Z"
        fill="url(#paint409_linear_2072_10275)"
      />
      <path
        d="M264.69 203.16C264.69 203.16 285.67 216.98 292.99 218.9C295.29 219.5 312.76 216.07 312.76 216.07C312.76 216.07 323.23 211.81 326.96 210.09C323.47 213.42 317.26 215.04 315.27 217.14C313.74 218.76 294.35 222.66 293.49 222.66C292.63 222.66 262.88 203.67 262.88 203.67L264.69 203.16Z"
        fill="url(#paint410_linear_2072_10275)"
      />
      <path
        d="M326.41 209.93L313.92 215.18L319.1 235.58L333.31 233.27L326.41 209.93Z"
        fill="#D1D1D1"
      />
      <path
        d="M312.02 216.21L316.61 214.51L320.25 235.41L317.69 235.58L312.02 216.21Z"
        fill="url(#paint411_linear_2072_10275)"
      />
      <path
        d="M391.06 212.46C392.94 213.28 394.66 214.27 395.98 215.5C401.41 220.57 409.38 232.52 411.55 235.42C413.72 238.32 426.4 248.82 424.95 258.24C423.5 267.66 394.65 294.99 394.65 294.99L391.04 285.62C391.04 285.62 393.92 283.69 400.32 273.44C402.51 269.94 409.37 255.69 409.37 255.69C397.06 248.81 391.26 237.94 391.26 237.94C391.26 237.94 389.82 221.47 391.05 212.45L391.06 212.46Z"
        fill="#F7D4AB"
      />
      <path
        d="M418.48 254.93C418.76 253.6 402.58 249.25 395.39 235.1L391.96 239.13C391.96 239.13 396.9 248.64 409.37 255.69C409.37 255.69 403.11 268.76 397.15 278.26C397.69 278.61 398.29 279.15 398.84 279.39C400.55 276.99 402.33 274.16 404.09 271.08C408.74 262.96 418.19 256.25 418.47 254.92L418.48 254.93Z"
        fill="url(#paint412_linear_2072_10275)"
      />
      <path
        d="M408.59 231.28C408.59 231.28 411.2 235.09 411.95 235.91C412.7 236.73 420.54 244.51 422.4 248.43C424.26 252.35 415.38 246.54 413.4 244.49C411.43 242.45 403.67 235.04 403.67 235.04L408.59 231.27V231.28Z"
        fill="url(#paint413_linear_2072_10275)"
      />
      <path
        d="M393.46 241.35L395.59 244.11L408.81 231.58L406.76 228.71L393.46 241.35Z"
        fill="url(#paint414_linear_2072_10275)"
      />
      <path
        d="M425.06 257.36C425.06 261.08 423.15 263.35 416.25 272.19C408.8 281.73 399.05 289.3 398.84 285.54C398.62 281.73 425.06 246.24 425.06 257.37V257.36Z"
        fill="url(#paint415_linear_2072_10275)"
      />
      <path
        d="M376.6 206.27C376.6 206.27 370.67 204.54 369.52 202.94C369.52 202.94 354.52 207.95 348.16 202.16L341.91 205.1C341.91 205.1 347.55 216.52 357.38 216.38C367.21 216.24 376.61 206.26 376.61 206.26L376.6 206.27Z"
        fill="#F7D4AB"
      />
      <path
        d="M326.66 234.61C325.85 229.45 324.69 210.83 324.69 210.83C327.22 208.99 344.08 203.88 344.08 203.88C344.08 203.88 346.42 214.42 358.38 215.08C370.34 215.74 372.35 204.43 372.35 204.43C393.37 212.87 393.43 212.95 393.43 212.95C392.99 213.83 392.07 227.21 390.84 234.61H387.32C386.72 238.18 386.28 241.02 386.2 241.52C384.18 254.41 381.62 281.83 382.16 309.93C380.23 311.16 369.85 312.88 356.83 311.87C342.51 310.75 336.19 307.74 333.3 305.9C334.56 285.45 332.49 268.13 330.19 242.8C330.06 241.31 326.65 234.61 326.65 234.61H326.66Z"
        fill="#D1D1D1"
      />
      <path
        d="M361.1 210.62L357.66 214.75L354.56 209.93L358.69 212L361.1 210.62Z"
        fill="url(#paint416_linear_2072_10275)"
      />
      <path
        d="M341.98 204.8C341.98 204.8 345.95 217.25 359.1 216.38C372.25 215.51 373.84 205.1 373.84 205.1C373.84 205.1 369.92 203.56 369.77 202.55C369.7 202.08 369.65 201.69 369.6 200.85C369.65 197.15 369.66 192.71 369.66 192.71C356.2 197.39 348.51 191.84 348.51 191.84C348.46 192.31 348.28 195.27 348.12 197.94C347.9 199.97 347.57 202.1 347.24 202.35C346.66 202.78 341.97 204.79 341.97 204.79L341.98 204.8ZM346.52 206.77L349.87 204.19C352.64 206.27 356.38 208.02 358.81 208.24C361.01 208.44 364.84 206.61 368.14 203.57C368.29 204.34 368.53 205.06 368.92 205.26C369.5 205.55 370.65 206.42 370.65 206.42C370.65 206.42 368.15 214.33 358.43 214.01C356.26 213.94 349.32 212.64 346.5 206.78L346.52 206.77Z"
        fill="url(#paint417_linear_2072_10275)"
      />
      <path
        d="M372.35 204.43C372.35 204.43 369.89 215.29 358.31 214.79C346.6 214.28 344.08 203.88 344.08 203.88L341.12 204.8C341.12 204.8 345.52 219.57 359.68 218.7C373.85 217.83 375.65 205.76 375.65 205.76L372.35 204.43Z"
        fill="#D1D1D1"
      />
      <path
        d="M381.3 223.03C373.91 218.68 369.64 220.03 358.12 220.36C346.6 220.68 339.21 218.4 335.08 222.53C330.95 226.66 332.57 243.77 355.73 245.35C382.95 247.2 388.69 227.37 381.3 223.03Z"
        fill="#EFEFEF"
        stroke="#F4F4F4"
        strokeWidth="1.06"
        strokeMiterlimit={10}
      />
      <path
        d="M408.47 230.21C408.47 230.21 401.2 219.99 398.82 217.34C396.47 214.72 394.49 213.43 393.42 212.94C392.36 212.45 385.7 236.65 385.7 236.65L393.86 243L408.46 230.2L408.47 230.21Z"
        fill="#D1D1D1"
      />
      <path
        d="M393.87 243L395.79 241.4C395.79 241.4 388.83 236.09 387 235.65C385.6 235.31 382.24 255.74 385.26 276.99C385.26 276.99 384.78 260.64 390.56 240.74C391.66 241.56 393.87 243 393.87 243Z"
        fill="#F2F2F2"
      />
      <path
        d="M386.98 256.62C386.98 256.62 386.51 260.02 386.51 260.54C386.51 260.54 382.22 249.2 382.11 248.3C382 247.4 379.32 228.61 379.32 228.61L384.86 209.46L386.68 210.19C386.68 210.19 382.09 228.38 382.16 228.82C382.23 229.26 386.98 256.62 386.98 256.62Z"
        fill="#D1D1D1"
      />
      <path
        d="M331.9 207.84L329.45 208.72L335.67 228.83L330.49 256.32L331.72 263.17L338.29 230.12L331.9 207.84Z"
        fill="url(#paint418_linear_2072_10275)"
      />
      <path
        d="M319.97 231.69C319.97 231.69 326.46 229.76 327.77 229.81C328.96 229.86 330.96 241.58 333 252.44C333.45 254.84 332.61 265.88 332.61 265.88C332.61 265.88 326.78 236.6 325.39 235.33C324.99 234.96 320.02 235.52 320.02 235.52L319.95 231.69H319.97Z"
        fill="#D1D1D1"
      />
      <path
        d="M372.46 227.13H345.14L338.29 205.7L336.67 206.22L343.89 228.62L372.46 229.65V227.13Z"
        fill="url(#paint419_linear_2072_10275)"
      />
      <path
        d="M349.45 357.85C351.93 346.3 354.84 332.98 354.84 332.98L359.45 342.11C359.45 342.11 358.82 348.3 357.97 356.64C359.54 356.42 361.09 356.2 362.66 355.99C370.77 356.02 378.52 357.34 385.91 359.96C387.53 343.01 389.55 320.5 389.64 313.04C389.68 309.49 385.85 292.36 385.88 287C385.91 281.65 386.71 259.56 386.71 259.56C385.87 256.75 379.32 231.16 379.48 229.64L385.94 209.78L378.69 206.8L372.24 227.8H344.28L337.69 205.88L330.61 208.28L337.01 229.77L332.37 259.35C332.37 259.35 331.62 279.73 330.1 289.43C329.82 291.24 325.34 318.03 325.34 318.03C325.34 318.03 323.67 338.22 323.35 345.91C323.22 349.07 322.12 355.78 320.86 362.61C330.41 360.83 339.88 359.25 349.45 357.83V357.85Z"
        fill="#1B2C60"
      />
      <path
        d="M340.32 238.04C340.03 235.53 345.53 231.45 363.75 233.51C368.15 234.01 376.58 235.25 377.93 236.93C379.28 238.62 374.41 256.6 359.12 257.37C343.83 258.14 340.51 239.71 340.31 238.03L340.32 238.04Z"
        fill="url(#paint420_linear_2072_10275)"
      />
      <path
        d="M358.9 289.04L356.85 322.75L360.8 311.79L358.9 289.04Z"
        fill="url(#paint421_linear_2072_10275)"
      />
      <path
        d="M343.28 237.08C343.28 237.08 370.47 238.8 377.47 237.23C377.47 237.23 349.24 236.93 343.28 237.08Z"
        fill="url(#paint422_linear_2072_10275)"
      />
      <path
        d="M343.28 239.61V246.89H351.7H377.31V240.44L378.32 248.04L341.52 248.02L343.28 239.61Z"
        fill="url(#paint423_linear_2072_10275)"
      />
      <path
        d="M377.07 212.14L371.99 228.72C371.99 228.72 365.82 228.8 359.17 228.83C351.54 228.86 343.28 228.81 342.98 228.47C342.42 227.83 339.36 211.4 339.36 211.4L344.29 227.82L371.4 227.88L377.06 212.15L377.07 212.14Z"
        fill="url(#paint424_linear_2072_10275)"
      />
      <path
        d="M349.85 357.79L354.98 335.3L359.46 342.11L357.98 356.64C358.92 356.51 359.85 356.38 360.79 356.25L363.36 342.69L356.65 325.36L351.06 330.82L347.92 358.08C348.56 357.98 349.2 357.88 349.84 357.79H349.85Z"
        fill="url(#paint425_linear_2072_10275)"
      />
      <path
        d="M341.87 359.01C346.05 348.79 347.49 332.58 347.79 324.91C348.08 317.41 344.9 303.51 335.27 308.08C327.43 311.8 322.77 346.96 326.72 361.56C331.77 360.66 336.82 359.8 341.88 359L341.87 359.01Z"
        fill="url(#paint426_linear_2072_10275)"
      />
      <path
        d="M384.14 359.36C386.31 338.95 383.12 309.9 376.59 308.23C370.88 306.77 366.23 334.9 366.92 356.13C372.85 356.49 378.59 357.57 384.14 359.36Z"
        fill="url(#paint427_linear_2072_10275)"
      />
      <path
        d="M358.02 303.37L356.66 325.36L351.07 330.82C351.07 330.82 353.9 325.77 354.7 324.53C355.51 323.3 358.02 303.36 358.02 303.36V303.37Z"
        fill="url(#paint428_linear_2072_10275)"
      />
      <path
        d="M385.95 209.79L378.7 206.81L377.65 210.23L384.94 212.91L385.95 209.79Z"
        fill="url(#paint429_linear_2072_10275)"
      />
      <path
        d="M338.84 209.67L337.7 205.89L330.63 208.29L331.83 212.35L338.84 209.67Z"
        fill="url(#paint430_linear_2072_10275)"
      />
      <path
        d="M383.99 215.81L379.93 229.83C379.93 229.83 385.38 254.66 386.72 259.57L386.48 287.01C386.48 287.01 389.99 306.1 389.64 313.81C389.64 313.81 383.31 287.88 383.68 285.61C384.05 283.34 383.82 261.79 383.7 261.06C383.58 260.33 378.9 232.48 378.76 230.02C378.72 229.26 383.98 215.81 383.98 215.81H383.99Z"
        fill="url(#paint431_linear_2072_10275)"
      />
      <path
        d="M333.98 219.54L337.03 229.79C337.03 229.79 331.27 256.98 331.04 260C330.95 261.15 330.25 286.68 330.2 287.76C330.12 289.45 325.82 315.28 325.82 315.28C325.82 315.28 334.12 288.37 334.12 286.99C334.12 285.61 334.4 260.41 334.4 259.76C334.4 259.11 338.31 230.74 338.31 230.12C338.31 229.5 334 219.54 334 219.54H333.98Z"
        fill="url(#paint432_linear_2072_10275)"
      />
      <path
        d="M386.48 287.01C386.48 287.01 368.61 290.77 330.42 287.49C330.42 287.49 365.59 287.55 386.48 287.01Z"
        fill="url(#paint433_linear_2072_10275)"
      />
      <path
        d="M387.39 297.64C387.39 297.64 382 295.43 380.51 294.44C379.02 293.45 376.94 287.75 376.94 287.75L381.39 292.76L387.39 297.64Z"
        fill="url(#paint434_linear_2072_10275)"
      />
      <path
        d="M328.95 297.64C328.95 297.64 334.9 295.43 336.39 294.44C337.88 293.45 339.96 287.75 339.96 287.75L335.51 292.76L328.95 297.64Z"
        fill="url(#paint435_linear_2072_10275)"
      />
      <path
        d="M339.96 287.75C339.96 287.75 337.28 293.94 336.39 294.44C335.49 294.94 328.95 297.64 328.95 297.64C328.95 297.64 337.67 296.28 338.11 295.41C338.55 294.54 339.96 287.75 339.96 287.75Z"
        fill="url(#paint436_linear_2072_10275)"
      />
      <path
        d="M387.39 297.64C387.39 297.64 381.42 295.46 380.51 294.44C379.6 293.42 376.94 287.75 376.94 287.75C376.94 287.75 377.74 294.89 379.02 295.58C380.3 296.28 387.39 297.63 387.39 297.63V297.64Z"
        fill="url(#paint437_linear_2072_10275)"
      />
      <path
        d="M393.87 243L391.06 241.1C391.06 241.1 405.47 228.01 406.28 227.15C406.28 227.15 407.91 229.38 408.47 230.2C408.47 230.2 395.48 241.72 393.87 243Z"
        fill="#F2F2F2"
      />
      <path
        d="M395.93 281.1C395.93 281.1 392.49 284.57 391.41 285.19C390.33 285.81 383.66 287.23 382.86 287.4C382.05 287.57 377.75 288.71 376.16 289.68C374.57 290.65 371.73 292.76 370.85 293.8C370.36 294.38 370.08 294.98 370.74 295.58C371.4 296.18 372.48 295.85 373.51 294.95C374.14 294.4 376.89 293.16 378.21 292.64C379.52 292.12 381.61 292.08 382.03 292.25C382.94 292.63 379.41 295.27 378.2 296.68C377.01 298.07 374.87 300.12 374.26 300.78C373.65 301.44 372.24 303.07 373.35 304.03C374.46 305 376.74 302.3 378.26 301.21C379.93 300.02 383.83 295.72 385.18 295.24C386.23 294.87 382.76 298.4 381.83 299.28C380.91 300.15 376.94 303.88 376.94 303.88C376.94 303.88 375.66 305.23 376.59 306.13C377.88 307.38 379.64 305.23 380.95 304.11C381.85 303.34 385.6 300.24 385.94 299.95C386.28 299.66 387.85 298.15 388.22 298.3C389.15 298.69 385.31 302.39 384.96 302.79C383.93 303.96 383.1 304.95 382.98 305.52C382.75 306.6 383.58 306.8 384.41 306.4C385.24 306 386.76 304.86 387.03 304.48C387.3 304.11 392.5 298.94 393.81 297.54C395.12 296.14 398.99 293.35 399.76 290.11C400.12 288.59 401.56 287.65 402.14 287.3L395.93 281.09V281.1Z"
        fill="#F7D4AB"
      />
      <path
        d="M376.75 304.49C377.04 304.08 379.63 301.95 380.02 301.61C381.02 300.75 383.59 300.92 381.4 303.18C378.76 305.9 377.61 306.41 377.3 306.34C376.98 306.27 375.94 305.63 376.75 304.48V304.49Z"
        fill="url(#paint438_linear_2072_10275)"
      />
      <path
        d="M378.85 304.32C378.65 303.85 378.06 303.73 377.55 304.11C377.33 304.27 376.56 304.89 376.51 305.28C376.44 305.8 377 306.19 377.09 306.19C377.24 306.2 377.63 306.47 378.09 305.95C378.55 305.42 379.08 304.84 378.85 304.32Z"
        fill="#FFDEBD"
      />
      <path
        d="M398.85 288.49C400.1 289.18 394.46 297.4 393.15 297.13C392.19 296.93 384.39 287.42 385.42 287.15C387.45 286.63 390.75 286.41 390.75 286.41C390.56 288.49 397.9 287.97 398.85 288.49Z"
        fill="url(#paint439_linear_2072_10275)"
      />
      <path
        d="M391.23 285.28C388.34 286.4 382.79 287.26 380.55 288.01C380.55 288.01 388.29 287.81 391.47 286.74C393.44 286.08 396.04 283.33 398.84 279.41C398.3 279.16 397.7 278.63 397.15 278.28C394.64 281.71 392.3 284.87 391.22 285.29L391.23 285.28Z"
        fill="url(#paint440_linear_2072_10275)"
      />
      <path
        d="M406.45 283.14C406.45 283.14 399.16 288.21 398.84 288.49C398.52 288.77 397.47 292.35 394.44 295.71C391.41 299.07 384.39 306.42 384.39 306.42C384.39 306.42 386.13 305.71 388.53 303C391.17 300.02 397.3 294.68 398.33 293.2C399.81 291.09 399.42 290.23 401.54 288.2C403.66 286.17 404.52 285.19 406.44 283.14H406.45Z"
        fill="url(#paint441_linear_2072_10275)"
      />
      <path
        d="M370.73 295.57C370.73 295.57 372.02 296.26 374.75 293.85C377.31 291.58 378.72 290.78 379.68 290.67C380.63 290.56 384.23 290.21 384.65 290.46C385.07 290.71 377.75 297.7 376.92 298.06C379.18 295.2 382.7 292.73 382.01 292.28C381.67 292.06 379.42 292.11 378.21 292.62C377 293.13 372.85 295.63 372.23 295.79C371.61 295.95 371.16 296 370.74 295.56L370.73 295.57Z"
        fill="url(#paint442_linear_2072_10275)"
      />
      <path
        d="M375.48 303.51C375.48 303.51 380.75 298.68 381.09 298.31C382.02 297.3 385.48 293.79 386.59 293.41C387.96 292.93 385.57 295.82 384.1 297.43C382.83 298.82 380.16 300.84 380.16 300.84C380.16 300.84 384.48 296.44 384.9 295.94C385.83 294.85 384.9 295.29 384.23 295.94C383.61 296.54 377.87 302.11 375.47 303.51H375.48Z"
        fill="url(#paint443_linear_2072_10275)"
      />
      <path
        d="M382.05 303.18C382.05 303.18 387.56 297.52 388.86 296.78C389.92 296.18 390.05 297.36 388.68 298.99C387.31 300.63 384.94 302.81 384.94 302.81C384.94 302.81 388.61 299.07 388.32 298.43C388.1 297.95 384.85 301.03 382.04 303.17L382.05 303.18Z"
        fill="url(#paint444_linear_2072_10275)"
      />
      <path
        d="M373.51 302.09C373.8 301.69 376.75 299.04 377.14 298.71C378.15 297.87 380.26 298.26 378.05 300.45C375.4 303.09 374.11 304.06 373.79 303.99C373.47 303.92 372.69 303.2 373.51 302.09Z"
        fill="url(#paint445_linear_2072_10275)"
      />
      <path
        d="M375.55 302.04C375.35 301.57 374.76 301.45 374.25 301.83C374.03 301.99 373.26 302.61 373.21 303C373.14 303.52 373.7 303.91 373.79 303.91C373.94 303.92 374.33 304.19 374.79 303.67C375.25 303.14 375.78 302.56 375.55 302.04Z"
        fill="#FFDEBD"
      />
      <path
        d="M374.85 290.79C375.13 290.64 376.15 290.07 376.64 290.63C377.38 291.48 373.89 293.96 373.22 294.59C372.25 295.48 369.77 295.52 371.12 293.86C372.47 292.2 374.56 290.95 374.85 290.8V290.79Z"
        fill="url(#paint446_linear_2072_10275)"
      />
      <path
        d="M372.69 293.6C372.4 293.35 371.89 293.2 371.41 293.6C370.93 294 370.36 294.46 370.32 294.9C370.28 295.31 370.76 295.87 371.43 295.73C371.69 295.68 372.93 294.86 372.98 294.3C373 294.06 372.88 293.76 372.68 293.59L372.69 293.6Z"
        fill="#FFDEBD"
      />
      <path
        d="M385.86 303.18C386.21 303.52 386.4 304.49 383.88 306.41C383.43 306.75 382.73 305.79 383.49 304.79C383.69 304.53 385.13 302.47 385.85 303.17L385.86 303.18Z"
        fill="url(#paint447_linear_2072_10275)"
      />
      <path
        d="M384.42 304.55C384.09 304.46 383.59 304.9 383.19 305.49C382.79 306.08 383.19 306.51 383.61 306.49C383.97 306.48 384.78 305.38 384.77 305.14C384.76 304.9 384.77 304.66 384.42 304.56V304.55Z"
        fill="#FFDEBD"
      />
      <path
        d="M313.55 215.34L316.86 213.9L322.64 235.23L319.1 235.58L313.55 215.34Z"
        fill="#D1D1D1"
      />
      <path
        d="M337.9 173.67C335.77 174.06 336.24 175.51 337.17 178.04C338.07 184.78 339.81 186.12 340.54 185.71C341.89 184.96 340.47 173.19 337.9 173.66V173.67Z"
        fill="#F0C499"
      />
      <path
        d="M339.62 183.26C339.62 183.26 338.63 182 339.02 179.63C339.96 174.05 336.53 173.49 337.19 177.37C337.19 177.37 337.72 175.58 338.14 176.15C338.65 176.84 337.53 177.15 338 180.08C338.25 181.6 339.61 183.26 339.61 183.26H339.62Z"
        fill="url(#paint448_linear_2072_10275)"
      />
      <path
        d="M377.65 173.62C379.79 173.91 379.41 175.38 378.63 177.95C378.12 184.72 376.46 186.14 375.7 185.77C374.31 185.08 375.05 173.26 377.65 173.62Z"
        fill="#F0C499"
      />
      <path
        d="M376.48 183.28C376.48 183.28 377.4 181.97 376.87 179.63C375.62 174.1 379 173.38 378.57 177.28C378.57 177.28 377.93 175.52 377.55 176.1C377.08 176.81 378.21 177.07 377.91 180.02C377.75 181.55 376.48 183.27 376.48 183.27V183.28Z"
        fill="url(#paint449_linear_2072_10275)"
      />
      <path
        d="M375.98 173.29C376.61 157.44 371.75 155.31 370.37 153.69C367.55 150.4 363.12 148.97 355.55 149.15C355.55 149.15 345.69 149.5 343.22 154.9C340.58 160.68 340.06 168.63 340.29 176.08C340.57 185.12 340.29 188.07 342.71 191.89C345.13 195.71 349.37 197.93 352.76 201.09C353.62 201.89 360.42 204.16 364.63 200.13C366.6 198.25 371.75 194.59 373.48 191.89C375.21 189.19 375.87 182.41 375.82 181.46C375.57 176.36 375.8 177.7 375.98 173.3V173.29Z"
        fill="url(#paint450_linear_2072_10275)"
      />
      <path
        d="M368.27 188.28C371.39 188.49 375.17 188.09 375.82 181.63C376.19 177.95 375.5 176.02 373.96 175.73C370.69 175.12 366 176.55 364.04 177.57C359.91 179.72 362.75 187.91 368.27 188.28Z"
        fill="url(#paint451_radial_2072_10275)"
      />
      <path
        d="M358.52 196.66C357.44 196.66 354.73 197.4 354.8 197.79C355.04 198.99 357.55 199.19 358.63 199.19C359.71 199.19 361.9 198.91 361.95 197.89C361.97 197.49 359.6 196.66 358.52 196.66Z"
        fill="url(#paint452_linear_2072_10275)"
      />
      <path
        d="M351.03 177.26C350.14 176.93 343.36 175.39 341.33 175.98C340.18 176.32 340.36 178.91 340.56 181.38C340.65 182.56 340.64 184.46 340.9 185.2C342.21 188.85 347.48 189.01 350.35 187.99C355.25 186.25 355.54 178.92 351.02 177.27L351.03 177.26Z"
        fill="url(#paint453_radial_2072_10275)"
      />
      <path
        d="M348.03 186.69C348.03 186.69 347.5 191.98 348.03 192.93C348.56 193.88 353.49 197.3 353.49 197.3C353.49 197.3 349.48 193 349.07 191.44C348.87 190.67 349 188.02 348.79 187.03C348.58 186.01 348.03 186.69 348.03 186.69Z"
        fill="url(#paint454_linear_2072_10275)"
      />
      <path
        d="M368.68 186.56C368.68 186.56 370.33 189.93 368.89 192.67C367.45 195.41 363.13 197.24 363.13 197.24C363.13 197.24 367.24 193.2 367.72 191.44C367.93 190.64 367.78 188 367.95 187.06C368.16 185.93 368.68 186.56 368.68 186.56Z"
        fill="url(#paint455_linear_2072_10275)"
      />
      <path
        d="M373.59 177.49C373.03 177.17 372.61 177.63 371.44 178.02C370.29 178.4 367.16 178.99 368.64 179.79C370.27 180.68 372.54 179.46 372.81 179.24C373.09 179.01 374.28 177.89 373.59 177.5V177.49Z"
        fill="url(#paint456_linear_2072_10275)"
      />
      <path
        d="M367.35 186.95L368.62 186.56C368.62 186.56 368.46 187.07 368.28 187.21C368.1 187.35 366.1 187.82 366.1 187.82L367.34 186.95H367.35Z"
        fill="#E1B18C"
      />
      <path
        d="M349.24 187.08L347.97 186.69C347.97 186.69 348.13 187.2 348.31 187.34C348.49 187.48 350.49 187.95 350.49 187.95L349.25 187.08H349.24Z"
        fill="#E1B18C"
      />
      <path
        d="M354.23 195.42C359.54 194.83 363.13 195.49 363.13 195.49C359.1 192.98 354.23 195.42 354.23 195.42Z"
        fill="url(#paint457_linear_2072_10275)"
      />
      <path
        d="M348.44 186.94C348.55 187.05 348.63 187.21 348.77 187.27C351.32 188.4 351.35 189.48 352.45 190.07C356.33 192.16 360.84 191.65 363.89 189.97C365.64 189 365.86 187.88 367.96 187.06C368.24 186.95 368.29 186.73 368.29 186.73C357.1 189.47 348.45 186.94 348.45 186.94H348.44Z"
        fill="#711E22"
      />
      <path
        d="M358.46 192.26C356.95 192.26 355.46 191.97 355.46 192.26C355.46 192.55 356.77 193.21 358.28 193.21C359.79 193.21 361.28 192.55 361.28 192.26C361.28 191.97 359.97 192.26 358.46 192.26Z"
        fill="#FDD8B3"
      />
      <path
        d="M353.08 189.31C352.61 189.22 352.4 190.05 352.4 190.05C353.82 191.09 355.53 191.48 358.26 191.5C361.91 191.53 363.92 189.95 363.92 189.95C363.92 189.95 363.41 189.16 362.81 189.28C361.78 189.49 359.85 189.87 358.08 189.87C356.13 189.87 354.15 189.51 353.07 189.32L353.08 189.31Z"
        fill="url(#paint458_linear_2072_10275)"
      />
      <path
        d="M352.89 192.65C358.72 197.28 364.29 192.33 364.29 192.33C358.4 195.46 352.89 192.65 352.89 192.65Z"
        fill="url(#paint459_linear_2072_10275)"
      />
      <path
        d="M350.97 187.47C350.97 187.47 351.01 188.43 351.98 188.85C352.55 189.09 353.81 190.06 358.73 189.91C363.65 189.76 364.62 188.57 364.85 188.36C365.27 187.97 365.46 187.32 365.46 187.32C365.46 187.32 358.05 188.77 350.97 187.47Z"
        fill="url(#paint460_linear_2072_10275)"
      />
      <path
        d="M350.95 187.38C350.95 187.38 350.98 187.82 351.14 188.07C351.28 188.28 355.21 188.86 358.18 188.88C361.15 188.9 365.02 188.13 365.16 187.96C365.37 187.69 365.49 187.22 365.49 187.22C365.49 187.22 362.15 188.34 350.95 187.38Z"
        fill="#F3ECEB"
      />
      <path
        d="M347.83 186.64C347.83 186.64 348.55 187.05 348.44 186.94C348.44 186.94 357.1 189.47 368.28 186.73L368.89 186.43C362.82 187.44 347.83 186.64 347.83 186.64Z"
        fill="url(#paint461_linear_2072_10275)"
      />
      <path
        d="M343.94 178.15C342.75 177.83 342.31 177.39 341.77 177.73C341.1 178.16 342.35 179.21 342.64 179.43C342.93 179.64 345.26 180.74 346.84 179.77C348.27 178.89 345.11 178.47 343.95 178.15H343.94Z"
        fill="url(#paint462_linear_2072_10275)"
      />
      <path
        d="M372.97 176.43C373.41 166.84 361.89 169.56 361.89 169.56C361.65 171.1 360.23 176.78 361.14 177.31C366.79 180.64 372.98 176.42 372.98 176.42L372.97 176.43Z"
        fill="url(#paint463_linear_2072_10275)"
      />
      <path
        d="M342.72 176.56C342.23 166.13 353.4 169.7 353.4 169.7C353.64 171.24 355.39 176.28 354.5 176.85C348.72 180.57 342.72 176.55 342.72 176.55V176.56Z"
        fill="url(#paint464_linear_2072_10275)"
      />
      <path
        d="M354.04 176.84C354.42 176.43 353.93 174.78 353.78 174.2C353.49 173.1 351.94 172.5 349.06 172.34C348.11 172.29 346.1 172.57 345.42 173.1C344.22 174.04 343.79 174.88 343.89 175.96C343.92 176.27 345.21 177.49 347.95 177.7C350 177.86 353.25 177.7 354.04 176.85V176.84Z"
        fill="url(#paint465_linear_2072_10275)"
      />
      <path
        d="M351.07 173.48C352.14 173.61 352.7 174.15 352.98 174.77C353.35 175.57 353.25 176.48 353.25 176.48C353.26 176.7 352.7 177.19 352.18 177.29C350.98 177.53 350.08 177.93 347.26 177.39C346.38 177.22 345.68 176.7 345.43 176.33C345.19 175.97 345.16 175.65 345.16 175.65C346.94 173.61 346.68 172.96 351.07 173.49V173.48Z"
        fill="url(#paint466_linear_2072_10275)"
      />
      <path
        d="M345.41 176.3C345.25 176.06 345.16 175.78 345.16 175.64C345.16 175.64 345.65 173.56 347.29 173.74C348.58 173.88 351.19 173.63 352.97 174.77C351.97 174.8 348.56 174.35 345.4 176.3H345.41Z"
        fill="#DDDDDD"
      />
      <path
        d="M349.28 173.73C350.99 173.65 351.98 174.76 351.9 176.21C351.87 176.76 351.56 177.37 351.5 177.43C351.26 177.51 350.33 177.69 349.31 177.65C348.56 177.66 347.51 177.46 347.25 177.38C346.91 176.99 346.87 176.61 346.83 176.31C346.66 174.9 347.84 173.79 349.27 173.72L349.28 173.73Z"
        fill="url(#paint467_linear_2072_10275)"
      />
      <path
        d="M351.55 174.75C351.55 174.75 350.72 173.43 349.18 173.55C347.64 173.68 346.97 174.97 346.88 175.56C346.88 175.56 348.58 174.74 351.55 174.75Z"
        fill="url(#paint468_linear_2072_10275)"
      />
      <path
        d="M349.33 174.14C350.18 174.12 350.88 174.79 350.9 175.62C350.91 176.45 350.23 177.14 349.38 177.15C348.53 177.16 347.82 176.5 347.81 175.67C347.8 174.84 348.48 174.15 349.33 174.14Z"
        fill="url(#paint469_radial_2072_10275)"
      />
      <path
        d="M352.97 174.77C352.97 174.77 352.67 174.07 352.07 173.73C350.52 172.86 348.1 173.03 346.56 173.66C345.05 174.27 345.15 175.65 345.15 175.65C345.15 175.65 345.94 174.75 348.54 174.4C351.14 174.05 352.97 174.78 352.97 174.78V174.77Z"
        fill="url(#paint470_linear_2072_10275)"
      />
      <path
        d="M350.27 176.62C350.11 176.31 350.26 175.93 350.59 175.76C350.92 175.6 351.32 175.71 351.47 176.02C351.63 176.33 351.48 176.71 351.15 176.88C350.82 177.05 350.42 176.93 350.27 176.62Z"
        fill="white"
      />
      <path
        d="M348.96 175.8C348.84 175.56 348.95 175.26 349.21 175.13C349.47 175 349.79 175.09 349.91 175.33C350.03 175.57 349.92 175.87 349.66 176C349.4 176.13 349.08 176.04 348.96 175.79V175.8Z"
        fill="white"
      />
      <path
        d="M361.48 176.84C361.1 176.43 361.59 174.78 361.74 174.2C362.03 173.1 363.58 172.5 366.46 172.34C367.41 172.29 369.42 172.57 370.1 173.1C371.3 174.04 371.73 174.88 371.63 175.96C371.6 176.27 370.31 177.49 367.57 177.7C365.52 177.86 362.27 177.7 361.48 176.85V176.84Z"
        fill="url(#paint471_linear_2072_10275)"
      />
      <path
        d="M364.45 173.48C363.38 173.61 362.82 174.15 362.54 174.77C362.17 175.57 362.27 176.48 362.27 176.48C362.26 176.7 362.82 177.19 363.34 177.29C364.54 177.53 365.44 177.93 368.26 177.39C369.14 177.22 369.84 176.7 370.09 176.33C370.33 175.97 370.36 175.65 370.36 175.65C368.58 173.61 368.84 172.96 364.45 173.49V173.48Z"
        fill="url(#paint472_linear_2072_10275)"
      />
      <path
        d="M370.11 176.3C370.27 176.06 370.36 175.78 370.36 175.64C370.36 175.64 369.87 173.56 368.23 173.74C366.94 173.88 364.33 173.63 362.55 174.77C363.55 174.8 366.96 174.35 370.12 176.3H370.11Z"
        fill="#DDDDDD"
      />
      <path
        d="M366.24 173.73C364.53 173.65 363.54 174.76 363.62 176.21C363.65 176.76 363.96 177.37 364.02 177.43C364.26 177.51 365.19 177.69 366.21 177.65C366.96 177.66 368.01 177.46 368.27 177.38C368.61 176.99 368.65 176.61 368.69 176.31C368.86 174.9 367.68 173.79 366.25 173.72L366.24 173.73Z"
        fill="url(#paint473_linear_2072_10275)"
      />
      <path
        d="M363.97 174.75C363.97 174.75 364.8 173.43 366.34 173.55C367.88 173.68 368.55 174.97 368.64 175.56C368.64 175.56 366.94 174.74 363.97 174.75Z"
        fill="url(#paint474_linear_2072_10275)"
      />
      <path
        d="M366.19 174.14C365.34 174.12 364.64 174.79 364.62 175.62C364.61 176.45 365.29 177.14 366.14 177.15C366.99 177.16 367.7 176.5 367.71 175.67C367.72 174.84 367.04 174.15 366.19 174.14Z"
        fill="url(#paint475_radial_2072_10275)"
      />
      <path
        d="M362.55 174.77C362.55 174.77 362.85 174.07 363.45 173.73C365 172.86 367.42 173.03 368.96 173.66C370.47 174.27 370.37 175.65 370.37 175.65C370.37 175.65 369.58 174.75 366.98 174.4C364.38 174.05 362.55 174.78 362.55 174.78V174.77Z"
        fill="url(#paint476_linear_2072_10275)"
      />
      <path
        d="M367.45 175.69C367.09 175.73 366.82 176.07 366.86 176.44C366.9 176.81 367.23 177.08 367.59 177.03C367.96 176.99 368.22 176.65 368.18 176.28C368.14 175.91 367.81 175.64 367.45 175.69Z"
        fill="white"
      />
      <path
        d="M366.01 175.07C365.72 175.1 365.52 175.37 365.55 175.66C365.59 175.95 365.84 176.16 366.13 176.13C366.42 176.1 366.62 175.83 366.59 175.54C366.56 175.25 366.3 175.04 366.01 175.07Z"
        fill="white"
      />
      <path
        d="M362.1 168.67C362.01 169.14 362.15 169.53 362.42 169.94C362.27 169.49 362.18 169.03 362.42 168.63C364.77 168.54 366.73 168.52 369.88 169.61C371.44 170.15 371.68 171.65 371.68 171.65C371.68 171.65 370.66 171.3 368.19 170.85C366.08 170.47 363.23 170.66 362.13 170.6C362.13 170.6 361.51 168.95 362.11 168.67H362.1Z"
        fill="url(#paint477_linear_2072_10275)"
      />
      <path
        d="M353.31 168.67C353.4 169.14 353.26 169.53 352.99 169.94C353.14 169.49 353.23 169.03 352.99 168.63C350.64 168.54 348.68 168.52 345.53 169.61C343.97 170.15 343.73 171.65 343.73 171.65C343.73 171.65 344.75 171.3 347.22 170.85C349.33 170.47 352.18 170.66 353.28 170.6C353.28 170.6 353.9 168.95 353.3 168.67H353.31Z"
        fill="url(#paint478_linear_2072_10275)"
      />
      <path
        d="M340.34 180.33C340.34 180.33 341.86 172.65 343.87 170.49C345.15 169.12 347.43 168.05 351.54 167.12C353.9 166.59 362.58 165.6 368.4 167.25C371.03 168.59 372.6 170.12 373.1 171.3C373.83 173.03 375.63 179.32 375.63 179.32C375.63 179.32 378.16 161.15 371.24 156.3C364.32 151.45 345.78 156.22 343.88 156.27C341.98 156.32 340.35 180.32 340.35 180.32L340.34 180.33Z"
        fill="url(#paint479_linear_2072_10275)"
      />
      <path
        d="M369.49 186.75C369.49 186.75 370.73 190.36 371.64 190.64C372.55 190.93 374.48 189.08 374.44 182.18C374.44 182.18 373.3 193.54 369.49 186.75Z"
        fill="url(#paint480_linear_2072_10275)"
      />
      <path
        d="M342.2 182.92C342.2 182.92 342.5 189.15 344.38 190.37C346.26 191.59 347.15 186.74 347.15 186.74C347.15 186.74 345.9 189.21 344.67 188.51C343.44 187.81 342.19 182.91 342.19 182.91L342.2 182.92Z"
        fill="url(#paint481_linear_2072_10275)"
      />
      <path
        d="M375.95 177.86L374.8 171.23C374.32 182.19 374.91 189.6 371.76 189.65C371.09 189.66 369.89 186.71 368.45 185.67C368.15 185.45 367.09 185.17 365.62 184.92L362.81 184.18L360.83 183.85L359.38 184.35C359.05 184.35 358.71 184.35 358.37 184.35C357.91 184.35 357.44 184.37 356.98 184.39L355.82 184H353.67L348.41 185.52C348.32 185.54 348.25 185.56 348.21 185.58C347.01 185.99 346.11 189.68 345.19 189.65C341.98 189.56 341.91 180.39 341.55 171.23C341.44 168.37 340.32 180.33 340.32 180.33C340.66 190.35 341.35 188.72 343.27 192.24C344.62 194.71 346.9 196.61 350.61 199.93C352.17 201.32 353.65 203.03 358.77 203.15C362.27 203.23 364.73 201.51 364.73 201.51C369.45 195.62 372.32 194.99 373.78 191.13C376.2 184.72 375.92 177.88 375.92 177.88L375.95 177.86ZM368.43 190.61C368.08 192.88 364.95 196.03 363.14 197.24C361.66 198.23 361.03 194.62 358.39 194.62C355.75 194.62 355.02 198.39 353.29 197.17C352.1 196.32 348.9 193.47 348.46 191.02C348.17 189.44 348.03 187.69 348.05 186.69C348.05 186.69 362.01 187.22 368.7 186.56C368.7 186.56 368.78 188.43 368.44 190.61H368.43Z"
        fill="#A89383"
      />
      <path
        d="M340.34 180.33C340.34 180.33 340.37 186.81 341.57 189.87C342.77 192.93 344.93 195.06 346.22 196.42C347.51 197.78 351.55 200.75 351.55 200.75C351.55 200.75 348.08 195.92 347.22 194.93C346.36 193.94 341.41 191.27 340.34 180.33Z"
        fill="url(#paint482_linear_2072_10275)"
      />
      <path
        d="M375.89 180.73C375.89 180.73 375.86 187.31 374.66 190.38C373.46 193.44 371.63 195.1 370.34 196.46C369.05 197.82 364.76 201.5 364.76 201.5C364.76 201.5 368.23 196.67 369.09 195.68C369.95 194.69 374.82 191.68 375.89 180.74V180.73Z"
        fill="url(#paint483_linear_2072_10275)"
      />
      <path
        d="M355.13 198.44C355.79 197.8 359.56 196.13 361.68 198.56C363.8 200.99 360.09 201.44 358.2 201.26C356.31 201.08 353.03 200.48 355.13 198.44Z"
        fill="url(#paint484_linear_2072_10275)"
      />
      <path
        d="M348.42 185.52L353.68 184L355.72 183.8L358.36 184.76L361.64 183.51L362.81 184.19L367.53 185.33L348.42 185.52Z"
        fill="url(#paint485_linear_2072_10275)"
      />
      <path
        d="M359.64 177.48C359.82 173.93 358.58 173.42 357.66 173.45C356.77 173.48 356.27 174.71 356.45 177.42C356.63 180.12 356.1 181.15 356.22 182.41C356.28 182.99 356.54 183.36 358 183.37C359.6 183.38 360.16 183 360.22 182.47C360.41 181 359.5 180.04 359.63 177.48H359.64Z"
        fill="url(#paint486_linear_2072_10275)"
      />
      <path
        d="M359.81 184.38C361.97 183.84 362.82 184.16 362.82 184.16C361.56 183.06 359.81 184.38 359.81 184.38Z"
        fill="#DCA57B"
      />
      <path
        d="M353.68 184C353.68 184 354.8 183.82 356.5 184.39C356.5 184.39 354.84 183.13 353.68 184Z"
        fill="#DCA57B"
      />
      <path
        d="M361.49 180.78C361.48 181.67 361.68 182.26 361.41 182.77C360.81 183.9 359.25 184.34 358.21 184.26C357.42 184.36 355.57 183.96 354.8 182.78C354.49 182.3 354.68 181.87 354.54 180.92C354.54 180.92 352.4 183.5 353.68 184.01C353.68 184.01 354.06 183.73 355.09 183.82C356.12 183.91 355.91 185.05 358.29 185.07C360.36 185.09 359.7 184.1 361.02 183.91C362.34 183.72 362.51 184.06 362.81 184.19C363.47 184.19 363 182 361.49 180.78Z"
        fill="url(#paint487_linear_2072_10275)"
      />
      <path
        d="M356 182.3C355.91 182.88 356.72 183.5 358.18 183.51C359.78 183.52 360.14 182.89 360 182.36C359.21 179.21 356.33 180.15 356 182.3Z"
        fill="url(#paint488_linear_2072_10275)"
      />
      <path
        d="M355.99 195.8C355.99 195.8 356.91 194.62 358.45 194.56C359.92 194.51 361.14 196.24 361.14 196.24C361.14 196.24 360.02 195.45 358.39 195.42C357.34 195.4 355.99 195.8 355.99 195.8Z"
        fill="url(#paint489_linear_2072_10275)"
      />
      <path
        d="M351.55 200.75C351.55 200.75 354.23 204.14 358.56 203.99C362.9 203.84 364.76 201.49 364.76 201.49C364.76 201.49 361.93 202.81 358.36 202.84C354.53 202.88 351.55 200.74 351.55 200.74V200.75Z"
        fill="url(#paint490_linear_2072_10275)"
      />
      <path
        d="M373.81 153.67C373.15 153.11 373.35 152.06 372.56 151.94C372.4 151.92 372.31 151.9 372.26 151.89C372.65 151.23 373.27 149.38 369.59 147.53C369.59 147.53 369.92 148.28 370.35 149.18C366.32 146.21 365.47 145.73 356.96 147.19C353.4 147.8 346.14 148.62 343.74 151.13C340.42 154.61 343.11 154.91 341.07 154.69C342.27 155.43 339.22 156.51 340.61 156.09C338.99 157.12 339.67 158.86 339 160.63C338.2 162.75 339.05 163.49 339.62 165.6C339.76 166.12 338 167.89 338.16 168.4C338.38 169.08 338.3 169.64 338.25 170.35C338.19 171.25 338.36 173.72 338.36 173.72C338.36 173.72 340.2 175.42 340.27 177.89C340.28 178.31 340.33 179.54 340.33 180.33C340.51 179.41 340.68 178.49 340.85 177.57C341.17 175.83 340.99 173.81 341.7 172.19C342.32 170.8 342.89 169.38 343.56 168.01C343.84 167.44 344.04 167.07 344.14 166.45C344.34 165.09 344.2 163.6 344.14 162.24C344.06 160.59 344.37 158.47 345.92 157.68C347.44 156.9 348.3 157.68 349.98 157.92C351.91 158.2 353.9 158.61 355.78 157.86C355.45 158.49 355.25 159.18 355.18 159.89C356.7 157.36 359.88 157.42 362.49 157.35C364.64 157.29 367.78 157.85 369.37 155.97C370.93 157.73 370.97 159.75 371.22 161.97C371.49 164.28 372.02 166.54 373.13 168.6C373.62 169.5 374.37 170.24 374.58 171.23C374.81 172.33 375.02 173.43 375.22 174.54C375.42 175.64 375.72 179.33 375.89 180.44C376.03 179.26 376.08 175.02 376.91 174.07C377.06 173.9 377.63 173.64 377.63 173.64C377.63 173.64 377.83 171.21 377.83 170.81C377.83 169.63 376.87 166.77 377.11 165.62C377.8 162.29 376.35 161.01 375.87 158.35C375.47 156.14 375.63 155.24 373.79 153.69L373.81 153.67Z"
        fill="url(#paint491_linear_2072_10275)"
      />
      <path
        d="M369.93 153.81C368.45 155.73 353.74 156.95 350.21 156.31C345.16 155.39 343.48 156.43 342.82 158.19C342.02 160.31 342.79 162.94 342.5 165.69C342.21 168.44 340.34 170.49 340.21 176.69C340.35 177.95 340.35 179.72 340.35 180.33C340.53 179.41 340.7 178.49 340.87 177.57C341.19 175.83 341.01 173.81 341.72 172.19C342.34 170.8 342.91 169.38 343.58 168.01C343.86 167.44 344.06 167.07 344.16 166.45C344.36 165.09 344.22 163.6 344.16 162.24C344.08 160.59 344.18 158.9 345.72 158.11C347.24 157.33 348.29 158.08 349.97 158.33C351.9 158.61 353.91 158.61 355.79 157.85C355.46 158.48 355.26 159.17 355.19 159.88C356.71 157.75 359.89 157.41 362.5 157.34C364.65 157.28 367.79 157.84 369.38 155.96C370.94 157.72 370.98 159.74 371.23 161.96C371.5 164.27 372.03 166.53 373.14 168.59C373.63 169.49 374.38 170.23 374.59 171.22C374.82 172.32 375.03 173.42 375.23 174.53C375.43 175.63 375.71 177.75 375.9 180.43C376.89 167.66 373.32 168.9 373.41 162.15C373.48 156.37 371.01 154.92 369.93 153.8V153.81Z"
        fill="url(#paint492_linear_2072_10275)"
      />
      <path
        d="M368.4 149.99C366.23 149.99 364.13 150.68 362.56 152.21C360.8 153.93 359.5 155.95 357.31 157.21C352.36 160.06 347.57 157 344.45 153.03C348.41 154.79 352.39 156.68 356.33 153.81C358.19 152.45 359.69 150.51 361.83 149.56C363.91 148.64 366.49 148.67 368.4 149.99Z"
        fill="url(#paint493_linear_2072_10275)"
      />
      <path
        d="M355.19 159.89C354.6 158.61 355.9 157.1 356.89 156.41C358.38 155.37 360.26 155.26 362 155.59C363.59 155.89 364.97 156.21 366.55 155.59C368.12 154.97 369.33 153.64 369.94 152.08C370.88 155.23 368.51 158.4 365.47 159.14C363.66 159.58 362.09 158.99 360.35 158.57C358.83 158.21 355.94 158.08 355.19 159.88V159.89Z"
        fill="url(#paint494_linear_2072_10275)"
      />
      <path
        d="M368.4 149.99C368.4 149.99 365.37 147.57 361.83 149.56C360.23 150.46 354.65 159.52 344.45 153.04C344.45 153.04 350.61 156.08 354.17 152.72C357.73 149.36 363.74 145.34 368.39 150L368.4 149.99Z"
        fill="url(#paint495_linear_2072_10275)"
      />
      <path
        d="M377.8 169.88C377.8 169.88 377.78 165.75 376.44 158.32C375.2 151.47 369.29 145.46 357.33 145.6C345.26 145.74 339.83 152.04 339.03 158.96C338.22 165.99 338.19 169.88 338.19 169.88C338.19 169.88 347.87 163.21 357.08 163.28C368.61 163.37 371.06 163.91 377.79 169.88H377.8Z"
        fill="#1B2C60"
      />
      <path
        d="M338.73 160.14C338.73 160.14 338.92 145.79 355.97 145.09C374.53 144.33 376.68 154.63 377.23 161.78C377.23 161.78 376.11 145.46 357.2 146.07C340.06 146.62 338.72 160.13 338.72 160.13L338.73 160.14Z"
        fill="url(#paint496_linear_2072_10275)"
      />
      <path
        d="M377.8 169.88C377.8 169.88 378.33 159.87 375.41 153.67L374.62 167.36L377.81 169.88H377.8Z"
        fill="url(#paint497_linear_2072_10275)"
      />
      <path
        d="M338.19 169.88L340.69 168.89L340.65 153.42C340.65 153.42 337.64 157.57 338.19 169.88Z"
        fill="url(#paint498_linear_2072_10275)"
      />
      <path
        d="M338.19 169.88C338.19 169.88 348.5 162.78 358.74 162.83C368.98 162.87 377.8 169.88 377.8 169.88C377.8 169.88 374.83 161.32 358.79 161.32C342.75 161.32 338.2 169.88 338.2 169.88H338.19Z"
        fill="url(#paint499_linear_2072_10275)"
      />
      <path
        d="M338.19 169.88C338.19 169.88 340.5 172.44 340.82 172.12C343 169.9 346.57 164.31 357.88 163.9C369.47 163.48 372.29 168.34 375.59 172.12C375.93 172.51 377.8 169.88 377.8 169.88C377.8 169.88 377.23 168.72 375.63 167.31C373.01 165 367.64 162.03 357.54 162.37C342.17 162.89 338.2 169.88 338.2 169.88H338.19Z"
        fill="url(#paint500_linear_2072_10275)"
      />
      <path
        d="M340.82 172.12C340.82 172.12 347.2 163.79 359.15 163.88C368.65 163.95 371.68 167.45 375.58 172.12C375.58 172.12 371.68 163.2 359.23 163.3C345.15 163.42 340.81 172.12 340.81 172.12H340.82Z"
        fill="#617197"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M252.05 287.84L250.51 296.2C250.51 296.2 360.07 299.31 581.03 299.31C801.99 299.31 921.07 296.2 921.07 296.2L921.05 279.98L252.06 287.84H252.05Z"
        fill="url(#paint501_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M921.04 279.98C921.07 282.3 771.33 285.94 586.59 288.11C401.85 290.28 252.07 290.16 252.05 287.84C252.02 285.52 401.76 281.88 586.5 279.71C771.24 277.54 921.02 277.66 921.04 279.98Z"
        fill="url(#paint502_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M277.82 296.83L295.62 395.46H860.93L886.08 296.83H277.82Z"
        fill="url(#paint503_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M295.62 395.46L294.07 386.9L864.6 381.04L860.93 395.46H295.62Z"
        fill="url(#paint504_radial_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'multiply' }}
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M284.11 331.67C284.11 331.67 344.98 308.76 588.67 305.59C832.37 302.42 877.77 329.4 877.77 329.4L886.08 296.82H277.82L284.11 331.67Z"
        fill="url(#paint505_radial_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'multiply' }}
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M724.7 381.73L736.84 296.83H697.01L684.54 382.89L724.7 381.73Z"
        fill="url(#paint506_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M777.6 296.83L770.44 358.43H781.02L787.56 337.28L806.83 327.63L812.33 296.83H777.6Z"
        fill="url(#paint507_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M864.6 381.04H846.13L863.69 296.83H886.08L864.6 381.04Z"
        fill="url(#paint508_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'multiply' }}
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M770.44 296.83L763.29 381.73H770.44L777.6 296.83H770.44Z"
        fill="url(#paint509_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'multiply' }}
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M441.16 385.12L432.36 296.83H438.81L449.95 385.3L441.16 385.12Z"
        fill="url(#paint510_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M557.02 384.51L555.55 327.63H545.32L541.59 296.83H499.12L507.05 365.59L499.12 366.06L494.45 335.72L487.45 338.93L492.11 385.3L557.02 384.51Z"
        fill="url(#paint511_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'multiply' }}
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M557.02 384.51L553.88 296.83H581.95L583.12 382.89L557.02 384.51Z"
        fill="url(#paint512_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'multiply' }}
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M316.78 386.66L302.46 296.83H334.2L342.29 372.44L347.27 373.37L338.25 306.16H341.05L353.75 386.28L316.78 386.66Z"
        fill="url(#paint513_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M340.11 298.07L353.75 386.28L386.71 385.95L374.34 296.83L340.11 298.07Z"
        fill="url(#paint514_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M583.12 382.89L585.79 296.83H639.45L634.78 383.4L625.13 382.89L627.62 311.14L624.2 310.21L616.11 383.59L583.12 382.89Z"
        fill="url(#paint515_linear_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M573.64 296.83L575.89 384L581.8 383.59L575.97 296.83H573.64Z"
        fill="url(#paint516_linear_2072_10275)"
      />
      <g style={{ mixBlendMode: 'soft-light' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M555.55 395.46L553.88 385.3L619.07 384.95L616.97 395.46H555.55Z"
          fill="white"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M620.62 395.46L622.33 384.95L634.47 384.51L631.05 395.46H620.62Z"
          fill="white"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M512.03 385.3H506.12L512.03 395.46H516.07L512.03 385.3Z"
          fill="white"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }} opacity="0.8">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M601.8 296.83V287.93L637.27 287.47L635.87 296.83H601.8Z"
          fill="#FAFFEF"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M641.94 296.83L644.74 287.37L649.41 287.3L645.67 296.83H641.94Z"
          fill="#FAFFEF"
        />
      </g>
      <g style={{ mixBlendMode: 'soft-light' }} opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M563.53 288.37L566.79 296.83H547.42L541.59 288.6L563.53 288.37Z"
          fill="#FAFFEF"
        />
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
          <path
            d="M693.136 296.766L684.06 382.829L684.985 382.926L694.061 296.864L693.136 296.766Z"
            fill="#D9D2C2"
          />
        </g>
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
          <path
            d="M811.839 296.721L796.627 381.609L797.542 381.773L812.755 296.885L811.839 296.721Z"
            fill="#D9D2C2"
          />
        </g>
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
          <path
            d="M582.66 382.9L580.56 299.33L581.49 299.3L583.59 382.88L582.66 382.9Z"
            fill="#D9D2C2"
          />
        </g>
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
          <path
            d="M479.36 384.99L471.26 296.87L472.19 296.79L480.29 384.9L479.36 384.99Z"
            fill="#D9D2C2"
          />
        </g>
      </g>
      <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
        <g style={{ mixBlendMode: 'multiply' }} opacity="0.5">
          <path
            d="M376.891 296.808L375.968 296.92L386.585 385.042L387.508 384.931L376.891 296.808Z"
            fill="#D9D2C2"
          />
        </g>
      </g>
      <path
        d="M308.83 249.12L303.66 249.18L301.13 253.69L303.77 258.14L307.44 258.1L314.6 270.16L316.84 268.83L309.68 256.77L311.47 253.57L308.83 249.12ZM308.77 253.6L307.56 255.76L305.08 255.79L303.82 253.66L305.03 251.5L307.5 251.47L308.76 253.6H308.77Z"
        fill="#3DC0CD"
      />
      <path
        d="M340.63 252.74L341.58 253.62L336.3 259.82L334.89 258.53L340.63 252.74Z"
        fill="#445164"
      />
      <path
        d="M330.15 268.1L337.6 259.21L335.39 257.18L327.16 265.36C326.41 266.11 326.43 267.33 327.21 268.04L327.46 268.27C328.24 268.99 329.46 268.91 330.14 268.1H330.15ZM328.34 267.08C328.03 266.8 328.01 266.31 328.29 266C328.57 265.69 329.06 265.67 329.36 265.95C329.67 266.23 329.69 266.72 329.41 267.03C329.13 267.34 328.64 267.36 328.33 267.08H328.34Z"
        fill="#3DC0CD"
      />
      <path
        d="M346.48 250.04L346.33 249.9L343.94 252.51L342.1 252.1L341.54 250.3L343.93 247.69L343.78 247.55C342.38 247.17 340.82 247.55 339.77 248.7C338.27 250.33 338.38 252.87 340.01 254.37C341.64 255.87 344.18 255.76 345.68 254.13C346.73 252.99 346.99 251.4 346.49 250.03L346.48 250.04Z"
        fill="#313C3B"
      />
      <path
        d="M330.41 259.84L329.13 260.04L327.59 252.03L329.48 251.74L330.41 259.84Z"
        fill="#445164"
      />
      <path
        d="M324.97 242.06L327.25 253.43L330.22 252.97L328.98 241.44C328.87 240.39 327.9 239.64 326.85 239.81L326.51 239.86C325.46 240.02 324.77 241.02 324.97 242.06ZM326.9 241.29C327.32 241.23 327.7 241.51 327.77 241.93C327.83 242.35 327.55 242.73 327.13 242.8C326.71 242.86 326.33 242.58 326.26 242.16C326.2 241.74 326.48 241.36 326.9 241.29Z"
        fill="#3DC0CD"
      />
      <path
        d="M328.86 266.1L329.06 266.07L328.52 262.57L329.99 261.39L331.75 262.07L332.29 265.57L332.49 265.54C333.67 264.69 334.34 263.22 334.1 261.69C333.76 259.5 331.72 258 329.53 258.33C327.34 258.67 325.84 260.71 326.17 262.9C326.41 264.44 327.48 265.63 328.86 266.09V266.1Z"
        fill="#313C3B"
      />
      <path
        d="M322.1 237.98H323.48L323.8 246.6H321.78L322.1 237.98Z"
        fill="#445164"
      />
      <path
        d="M321.21 245.19H324.38L324.94 257.45C324.99 258.57 324.1 259.5 322.98 259.5H322.61C321.49 259.5 320.6 258.57 320.65 257.45L321.21 245.19Z"
        fill="#FFB91D"
      />
      <path
        d="M324.73 232.5V236.27H320.85V232.5C319.48 233.21 318.55 234.63 318.55 236.27C318.55 238.61 320.45 240.51 322.79 240.51C325.13 240.51 327.03 238.61 327.03 236.27C327.03 234.63 326.09 233.2 324.73 232.5Z"
        fill="#313C3B"
      />
      <path
        d="M333.426 247.83L332.718 249.902L335.973 251.015L336.681 248.943L333.426 247.83Z"
        fill="#F73906"
      />
      <path
        d="M329.85 263.59L334.34 250.45L335.55 250.86C334.23 260.25 331.29 264.11 329.84 263.59H329.85Z"
        fill="#DB6A2A"
      />
      <path
        d="M333.12 250.02L334.34 250.44L329.85 263.58C328.41 263.06 328.46 258.16 333.12 250.02Z"
        fill="#B2440D"
      />
      <path
        d="M334.64 249.54L336.76 243.34L342.96 245.46C341.79 248.88 338.07 250.71 334.65 249.54H334.64Z"
        fill="#F73906"
      />
      <path
        d="M330.56 241.22L336.76 243.34L334.64 249.54C331.22 248.37 329.39 244.65 330.56 241.23V241.22Z"
        fill="#CC2605"
      />
      <path
        d="M342.95 245.46C342.95 245.46 344.09 244.9 344.88 243L337.71 240.55L336.76 243.34L342.96 245.46H342.95Z"
        fill="#F73906"
      />
      <path
        d="M330.56 241.22C330.56 241.22 330 240.08 330.54 238.09L337.71 240.54L336.76 243.33L330.56 241.21V241.22Z"
        fill="#CC2605"
      />
      <path
        d="M309.07 265.54L307.92 265.9L303.81 253.83L305.5 253.29L309.07 265.54Z"
        fill="#445164"
      />
      <path
        d="M306.35 254.32L303.7 255.16L300 245.07C299.66 244.15 300.16 243.14 301.1 242.84L301.41 242.74C302.34 242.45 303.33 242.99 303.59 243.94L306.36 254.32H306.35Z"
        fill="#EA3207"
      />
      <path
        d="M313.984 243.204L310.661 245.321C310.144 245.651 309.992 246.337 310.322 246.854L316.744 256.931C317.074 257.448 317.76 257.6 318.277 257.271L321.599 255.153C322.116 254.824 322.268 254.137 321.939 253.621L315.516 243.543C315.187 243.026 314.501 242.874 313.984 243.204Z"
        fill="#4591CF"
      />
      <path
        d="M314.83 255.36L310.47 260.33L308.78 257.68L315.33 251.12L317.61 254.69L315.85 256.96L314.83 255.36Z"
        fill="#4591CF"
      />
      <path
        d="M315.715 239.055L305.646 245.472L308.478 249.916L318.547 243.499L315.715 239.055Z"
        fill="#D1311A"
      />
      <path
        d="M310.71 239.33L308.03 241.04L306.59 244.86L314.79 239.64L310.71 239.33Z"
        fill="#F73906"
      />
      <path
        d="M308.09 239.68L308.03 241.04L310.71 239.33L309.46 238.81L308.09 239.68Z"
        fill="#4A4C50"
      />
      <path
        d="M307.6 235.9L307.66 234.55L304.99 236.25L306.24 236.77L307.6 235.9Z"
        fill="#4A4C50"
      />
      <path
        d="M305.401 233.3L304.811 233.677L308.482 239.436L309.072 239.06L305.401 233.3Z"
        fill="#4A4C50"
      />
      <path
        d="M306.034 232.505L303.842 233.902C303.753 233.959 303.727 234.076 303.784 234.165L304.547 235.362C304.604 235.451 304.721 235.477 304.81 235.42L307.002 234.023C307.09 233.966 307.116 233.849 307.06 233.76L306.297 232.563C306.24 232.474 306.123 232.448 306.034 232.505Z"
        fill="#4A4C50"
      />
      <path
        d="M312.03 251.87L314.1 250.55L313.66 249.86L310.9 251.62L312.66 254.38L313.35 253.95L312.03 251.87Z"
        fill="#4591CF"
      />
      <path
        d="M311.73 262.31L310.47 260.33L314.83 255.36L315.85 256.96L311.73 262.31Z"
        fill="#D1311A"
      />
      <path
        d="M305.16 260.94V282.66C305.16 283.63 305.95 284.41 306.91 284.41H337.9C338.87 284.41 339.65 283.62 339.65 282.66V260.94H305.15H305.16Z"
        fill="#475150"
      />
      <path d="M339.8 266.19H305.3V269.34H339.8V266.19Z" fill="#313C3B" />
      <path
        d="M326.56 280.03L321.57 275.47L321.33 275.71L316.09 270.7L315.55 271.24L320.56 276.48L320.32 276.72L324.87 281.71C325.08 281.94 325.38 282.06 325.67 282.06C325.95 282.06 326.22 281.95 326.43 281.74L326.57 281.6C327.01 281.16 326.99 280.45 326.53 280.04L326.56 280.03Z"
        fill="#8F9B9A"
      />
      <path
        d="M326.27 273.02L326.81 273.55L323.58 277.03L322.79 276.25L326.27 273.02Z"
        fill="#8F9B9A"
      />
      <path
        d="M323.12 275.47L324.35 276.71L319.8 281.7C319.38 282.15 318.67 282.17 318.24 281.74L318.1 281.6C317.66 281.16 317.68 280.45 318.14 280.04L323.13 275.48L323.12 275.47Z"
        fill="#8F9B9A"
      />
      <path
        d="M329.43 271.91L327.96 273.38L326.45 271.87L327.92 270.4C327.11 270.14 326.2 270.33 325.56 270.97C324.65 271.88 324.65 273.36 325.56 274.27C326.47 275.18 327.95 275.18 328.86 274.27C329.5 273.63 329.69 272.71 329.43 271.91Z"
        fill="#8F9B9A"
      />
      <path d="M317.31 254.28H314.55V258.89H317.31V254.28Z" fill="#313C3B" />
      <path d="M330.56 254.28H327.8V258.89H330.56V254.28Z" fill="#313C3B" />
      <path
        d="M342.28 258.09H302.83C302.443 258.09 302.13 258.403 302.13 258.79V265.8C302.13 266.186 302.443 266.5 302.83 266.5H342.28C342.667 266.5 342.98 266.186 342.98 265.8V258.79C342.98 258.403 342.667 258.09 342.28 258.09Z"
        fill="#475150"
      />
      <path d="M331.57 250.11H313.53V254.36H331.57V250.11Z" fill="#313C3B" />
      <path d="M314.98 257.67H310.36V267.07H314.98V257.67Z" fill="#FFB91D" />
      <path d="M334.75 257.67H330.13V267.07H334.75V257.67Z" fill="#FFB91D" />
      <path
        d="M317.05 253.06C317.05 253.98 315.67 253.97 315.67 253.06V251.55C315.67 250.64 317.05 250.64 317.05 251.55V253.06Z"
        fill="#475150"
      />
      <path
        d="M320.14 253.06C320.14 253.98 318.76 253.97 318.76 253.06V251.55C318.76 250.64 320.14 250.64 320.14 251.55V253.06Z"
        fill="#475150"
      />
      <path
        d="M323.24 253.06C323.24 253.98 321.86 253.97 321.86 253.06V251.55C321.86 250.64 323.24 250.64 323.24 251.55V253.06Z"
        fill="#475150"
      />
      <path
        d="M326.34 253.06C326.34 253.98 324.96 253.97 324.96 253.06V251.55C324.96 250.64 326.34 250.64 326.34 251.55V253.06Z"
        fill="#475150"
      />
      <path
        d="M329.44 253.06C329.44 253.98 328.06 253.97 328.06 253.06V251.55C328.06 250.64 329.44 250.64 329.44 251.55V253.06Z"
        fill="#475150"
      />
      <path
        d="M326.94 279.62L321.95 275.06L321.55 274.7L321.32 274.93L316.48 270.3L316.08 269.92L315.69 270.31L315.15 270.85L314.76 271.24L315.14 271.64L319.77 276.48L319.54 276.71L319.9 277.11L324.45 282.1C324.76 282.44 325.2 282.63 325.66 282.63C326.12 282.63 326.51 282.46 326.82 282.15L326.96 282.01C327.28 281.69 327.45 281.27 327.44 280.81C327.43 280.36 327.24 279.94 326.91 279.64L326.94 279.62ZM326.46 281.74C326.25 281.95 325.97 282.06 325.7 282.06C325.41 282.06 325.12 281.94 324.9 281.71L320.35 276.72L320.59 276.48L315.58 271.24L316.12 270.7L321.36 275.71L321.6 275.47L326.59 280.03C327.04 280.45 327.06 281.16 326.63 281.59L326.49 281.73L326.46 281.74Z"
        fill="#475150"
      />
      <path
        d="M525.65 350.89C524.1 350.89 522.85 350.43 521.9 349.52C520.97 348.59 520.5 347.35 520.5 345.79V337.41C520.5 335.87 520.97 334.65 521.9 333.74C522.85 332.83 524.1 332.37 525.65 332.37C527.2 332.37 528.47 332.83 529.4 333.74C530.35 334.65 530.82 335.88 530.82 337.41V337.69C530.82 337.78 530.79 337.85 530.72 337.92C530.67 337.97 530.6 338 530.51 338L527.48 338.13C527.27 338.13 527.17 338.04 527.17 337.85V337.18C527.17 336.68 527.03 336.27 526.76 335.96C526.48 335.65 526.11 335.49 525.65 335.49C525.19 335.49 524.84 335.65 524.56 335.96C524.28 336.27 524.15 336.68 524.15 337.18V346.11C524.15 346.61 524.29 347.02 524.56 347.33C524.84 347.62 525.2 347.77 525.65 347.77C526.1 347.77 526.49 347.62 526.76 347.33C527.04 347.02 527.17 346.61 527.17 346.11V345.41C527.17 345.32 527.2 345.25 527.25 345.2C527.32 345.13 527.4 345.1 527.48 345.1L530.51 345.23C530.6 345.23 530.67 345.26 530.72 345.33C530.79 345.38 530.82 345.45 530.82 345.54V345.8C530.82 347.35 530.35 348.59 529.4 349.53C528.45 350.44 527.2 350.9 525.65 350.9V350.89ZM537.22 350.89C535.68 350.89 534.48 350.5 533.6 349.73C532.74 348.95 532.31 347.89 532.31 346.55V341.53C532.31 340.22 532.75 339.17 533.63 338.37C534.51 337.58 535.71 337.18 537.23 337.18C538.75 337.18 539.97 337.58 540.85 338.37C541.73 339.16 542.17 340.22 542.17 341.53V346.55C542.17 347.9 541.73 348.96 540.85 349.73C539.99 350.51 538.78 350.89 537.23 350.89H537.22ZM537.22 347.73C537.6 347.73 537.91 347.59 538.15 347.32C538.39 347.04 538.51 346.69 538.51 346.26V341.78C538.51 341.35 538.39 341 538.15 340.72C537.91 340.44 537.6 340.31 537.22 340.31C536.84 340.31 536.53 340.45 536.29 340.72C536.07 341 535.95 341.35 535.95 341.78V346.26C535.95 346.69 536.06 347.05 536.29 347.32C536.53 347.6 536.84 347.73 537.22 347.73ZM546.45 350.68C546.26 350.68 546.14 350.59 546.09 350.42L542.96 337.69V337.59C542.96 337.43 543.06 337.36 543.24 337.36H546.58C546.79 337.36 546.9 337.45 546.92 337.64L548.11 344.76C548.13 344.81 548.15 344.84 548.19 344.84C548.23 344.84 548.25 344.81 548.27 344.76L549.43 337.64C549.45 337.45 549.56 337.36 549.77 337.36L553.11 337.41C553.35 337.41 553.45 337.52 553.39 337.75L550.28 350.43C550.23 350.6 550.11 350.69 549.92 350.69H546.45V350.68ZM563.99 344.86C563.99 344.95 563.96 345.02 563.89 345.09C563.84 345.14 563.77 345.17 563.68 345.17H557.99C557.9 345.17 557.86 345.21 557.86 345.3V346.26C557.86 346.69 557.97 347.05 558.2 347.35C558.44 347.63 558.74 347.76 559.11 347.76C559.44 347.76 559.71 347.66 559.91 347.45C560.12 347.23 560.25 346.95 560.32 346.62C560.37 346.45 560.48 346.36 560.66 346.36L563.64 346.52C563.73 346.52 563.8 346.55 563.85 346.62C563.92 346.67 563.95 346.75 563.93 346.85C563.81 348.18 563.34 349.19 562.53 349.88C561.74 350.55 560.6 350.89 559.11 350.89C557.62 350.89 556.38 350.51 555.51 349.75C554.65 348.97 554.22 347.9 554.22 346.54V341.52C554.22 340.21 554.65 339.16 555.51 338.36C556.39 337.57 557.59 337.17 559.11 337.17C560.63 337.17 561.82 337.57 562.68 338.36C563.56 339.15 564 340.21 564 341.52V344.86H563.99ZM559.1 340.31C558.74 340.31 558.44 340.45 558.19 340.72C557.97 341 557.85 341.35 557.85 341.78V342.79C557.85 342.88 557.89 342.92 557.98 342.92H560.21C560.3 342.92 560.34 342.88 560.34 342.79V341.78C560.34 341.35 560.22 341 559.98 340.72C559.76 340.44 559.46 340.31 559.1 340.31ZM571.61 337.23C572.08 337.23 572.44 337.32 572.7 337.49C572.84 337.58 572.89 337.71 572.86 337.88L572.37 340.91C572.35 341.1 572.23 341.17 572.01 341.12C571.82 341.05 571.59 341.02 571.31 341.02C571.05 341.02 570.83 341.05 570.64 341.12C570.24 341.19 569.92 341.43 569.68 341.84C569.44 342.24 569.32 342.7 569.32 343.24V350.36C569.32 350.45 569.29 350.52 569.22 350.59C569.17 350.64 569.1 350.67 569.01 350.67H565.98C565.89 350.67 565.82 350.64 565.75 350.59C565.7 350.52 565.67 350.44 565.67 350.36V337.71C565.67 337.62 565.7 337.55 565.75 337.5C565.82 337.43 565.9 337.4 565.98 337.4H569.01C569.1 337.4 569.17 337.43 569.22 337.5C569.29 337.55 569.32 337.62 569.32 337.71V338.72C569.32 338.79 569.32 338.83 569.35 338.85C569.38 338.85 569.42 338.82 569.45 338.77C569.92 337.75 570.64 337.24 571.62 337.24L571.61 337.23ZM578.74 337.18C580.21 337.18 581.4 337.58 582.31 338.37C583.22 339.16 583.68 340.21 583.68 341.5V350.38C583.68 350.47 583.65 350.54 583.58 350.61C583.53 350.66 583.46 350.69 583.37 350.69H580.34C580.25 350.69 580.18 350.66 580.11 350.61C580.06 350.54 580.03 350.46 580.03 350.38V349.81C580.03 349.76 580.01 349.72 579.98 349.71C579.95 349.69 579.91 349.71 579.88 349.76C579.31 350.48 578.43 350.86 577.24 350.9C576.24 350.9 575.37 350.62 574.63 350.07C573.91 349.52 573.54 348.47 573.54 346.91C573.54 345.35 573.98 344.2 574.86 343.6C575.76 343 577.04 342.69 578.72 342.69H579.91C580 342.69 580.04 342.65 580.04 342.56V341.91C580.04 341.44 579.91 341.06 579.65 340.77C579.41 340.46 579.1 340.3 578.72 340.3C578.43 340.3 578.18 340.39 577.97 340.58C577.78 340.75 577.66 341 577.61 341.33C577.59 341.54 577.48 341.64 577.27 341.64L574.16 341.61C573.95 341.61 573.85 341.51 573.85 341.3C573.94 340.04 574.43 339.04 575.33 338.3C576.23 337.54 577.37 337.16 578.75 337.16L578.74 337.18ZM578.48 348.07C578.88 348.07 579.23 347.94 579.54 347.68C579.87 347.4 580.03 347.04 580.03 346.59V345.37C580.03 345.28 579.99 345.24 579.9 345.24H578.84C578.37 345.24 577.99 345.38 577.7 345.65C577.42 345.91 577.29 346.27 577.29 346.74C577.29 347.17 577.39 347.5 577.6 347.72C577.82 347.94 578.12 348.06 578.48 348.06V348.07ZM591.4 337.69C591.4 337.6 591.43 337.53 591.48 337.48C591.55 337.41 591.63 337.38 591.71 337.38H594.74C594.83 337.38 594.9 337.41 594.95 337.48C595.02 337.53 595.05 337.6 595.05 337.69V350.06C595.05 351.97 594.59 353.45 593.68 354.49C592.78 355.53 591.16 356.04 588.81 356.04C588.34 356.04 587.98 356.04 587.72 356.01C587.51 355.99 587.41 355.88 587.41 355.67V353.13C587.41 352.91 587.52 352.81 587.75 352.85C588.77 352.88 589.54 352.78 590.05 352.54C590.59 352.32 590.94 351.97 591.11 351.5C591.3 351.03 591.39 350.42 591.39 349.66C591.39 349.61 591.37 349.58 591.34 349.58C591.31 349.58 591.27 349.61 591.24 349.66C590.93 350.07 590.55 350.37 590.1 350.54C589.67 350.7 589.25 350.77 588.83 350.77C587.64 350.77 586.75 350.39 586.16 349.63C585.57 348.85 585.28 347.78 585.28 346.42V341.5C585.28 340.1 585.57 339.03 586.16 338.29C586.76 337.53 587.65 337.15 588.83 337.15C589.88 337.15 590.68 337.54 591.24 338.31C591.27 338.36 591.31 338.38 591.34 338.36C591.37 338.34 591.39 338.31 591.39 338.26V337.66L591.4 337.69ZM590.16 347.63C590.52 347.63 590.82 347.49 591.04 347.22C591.28 346.94 591.4 346.59 591.4 346.16V341.79C591.4 341.36 591.28 341.01 591.04 340.73C590.82 340.45 590.52 340.32 590.16 340.32C589.8 340.32 589.5 340.46 589.28 340.73C589.06 341.01 588.94 341.36 588.94 341.79V346.16C588.94 346.59 589.05 346.95 589.28 347.22C589.5 347.5 589.8 347.63 590.16 347.63ZM606.5 344.86C606.5 344.95 606.47 345.02 606.4 345.09C606.35 345.14 606.28 345.17 606.19 345.17H600.5C600.41 345.17 600.37 345.21 600.37 345.3V346.26C600.37 346.69 600.48 347.05 600.71 347.35C600.95 347.63 601.25 347.76 601.62 347.76C601.95 347.76 602.22 347.66 602.42 347.45C602.63 347.23 602.77 346.95 602.83 346.62C602.88 346.45 602.99 346.36 603.17 346.36L606.15 346.52C606.24 346.52 606.31 346.55 606.36 346.62C606.43 346.67 606.46 346.75 606.44 346.85C606.32 348.18 605.85 349.19 605.04 349.88C604.25 350.55 603.11 350.89 601.62 350.89C600.13 350.89 598.89 350.51 598.02 349.75C597.16 348.97 596.73 347.9 596.73 346.54V341.52C596.73 340.21 597.16 339.16 598.02 338.36C598.9 337.57 600.1 337.17 601.62 337.17C603.14 337.17 604.33 337.57 605.19 338.36C606.07 339.15 606.51 340.21 606.51 341.52V344.86H606.5ZM601.61 340.31C601.25 340.31 600.95 340.45 600.7 340.72C600.48 341 600.36 341.35 600.36 341.78V342.79C600.36 342.88 600.4 342.92 600.49 342.92H602.72C602.81 342.92 602.85 342.88 602.85 342.79V341.78C602.85 341.35 602.73 341 602.49 340.72C602.27 340.44 601.97 340.31 601.61 340.31ZM613.82 350.69C613.73 350.69 613.66 350.66 613.59 350.61C613.54 350.54 613.51 350.46 613.51 350.38V332.89C613.51 332.8 613.54 332.73 613.59 332.68C613.66 332.61 613.74 332.58 613.82 332.58H616.85C616.94 332.58 617.01 332.61 617.06 332.68C617.13 332.73 617.16 332.8 617.16 332.89V350.38C617.16 350.47 617.13 350.54 617.06 350.61C617.01 350.66 616.94 350.69 616.85 350.69H613.82ZM625.5 337.18C626.67 337.18 627.55 337.57 628.14 338.34C628.73 339.12 629.02 340.2 629.02 341.6V350.37C629.02 350.46 628.99 350.53 628.92 350.6C628.87 350.65 628.8 350.68 628.71 350.68H625.68C625.59 350.68 625.52 350.65 625.45 350.6C625.4 350.53 625.37 350.45 625.37 350.37V341.88C625.37 341.38 625.27 340.99 625.06 340.72C624.87 340.44 624.59 340.31 624.21 340.31C623.83 340.31 623.5 340.46 623.28 340.75C623.07 341.03 622.97 341.42 622.97 341.94V350.38C622.97 350.47 622.94 350.54 622.87 350.61C622.82 350.66 622.75 350.69 622.66 350.69H619.63C619.54 350.69 619.47 350.66 619.4 350.61C619.35 350.54 619.32 350.46 619.32 350.38V337.7C619.32 337.61 619.35 337.54 619.4 337.49C619.47 337.42 619.55 337.39 619.63 337.39H622.66C622.75 337.39 622.82 337.42 622.87 337.49C622.94 337.54 622.97 337.61 622.97 337.7V338.19C622.97 338.24 622.99 338.27 623.02 338.27C623.07 338.27 623.13 338.24 623.2 338.17C623.75 337.51 624.52 337.19 625.5 337.19V337.18ZM644.51 332.78C644.58 332.64 644.71 332.57 644.9 332.57H647.9C647.99 332.57 648.06 332.6 648.11 332.67C648.18 332.72 648.21 332.79 648.21 332.88V350.37C648.21 350.46 648.18 350.53 648.11 350.6C648.06 350.65 647.99 350.68 647.9 350.68H644.87C644.78 350.68 644.71 350.65 644.64 350.6C644.59 350.53 644.56 350.45 644.56 350.37V338.75C644.56 338.68 644.54 338.65 644.51 338.65C644.48 338.65 644.44 338.68 644.41 338.73L642.39 342.3C642.3 342.44 642.23 342.51 642.18 342.51C642.13 342.51 642.06 342.44 641.97 342.3L639.95 338.73C639.92 338.68 639.88 338.65 639.85 338.65C639.82 338.65 639.8 338.68 639.8 338.75V350.37C639.8 350.46 639.77 350.53 639.7 350.6C639.65 350.65 639.58 350.68 639.49 350.68H636.46C636.37 350.68 636.3 350.65 636.23 350.6C636.18 350.53 636.15 350.45 636.15 350.37V332.88C636.15 332.79 636.18 332.72 636.23 332.67C636.3 332.6 636.38 332.57 636.46 332.57H639.44C639.61 332.57 639.74 332.64 639.83 332.78L642.13 336.89C642.18 336.96 642.23 336.96 642.29 336.89L644.52 332.78H644.51ZM652.09 335.89C651.5 335.89 651.01 335.7 650.61 335.32C650.23 334.92 650.04 334.43 650.04 333.84C650.04 333.25 650.23 332.74 650.61 332.36C650.99 331.98 651.48 331.79 652.09 331.79C652.7 331.79 653.18 331.98 653.54 332.36C653.92 332.74 654.11 333.23 654.11 333.84C654.11 334.45 653.92 334.92 653.54 335.32C653.16 335.7 652.68 335.89 652.09 335.89ZM650.61 350.69C650.52 350.69 650.45 350.66 650.38 350.61C650.33 350.54 650.3 350.46 650.3 350.38V337.7C650.3 337.61 650.33 337.54 650.38 337.49C650.45 337.42 650.53 337.39 650.61 337.39H653.64C653.73 337.39 653.8 337.42 653.85 337.49C653.92 337.54 653.95 337.61 653.95 337.7V350.38C653.95 350.47 653.92 350.54 653.85 350.61C653.8 350.66 653.73 350.69 653.64 350.69H650.61ZM662.09 337.18C663.26 337.18 664.14 337.57 664.73 338.34C665.32 339.12 665.61 340.2 665.61 341.6V350.37C665.61 350.46 665.58 350.53 665.51 350.6C665.46 350.65 665.39 350.68 665.3 350.68H662.27C662.18 350.68 662.11 350.65 662.04 350.6C661.99 350.53 661.96 350.45 661.96 350.37V341.88C661.96 341.38 661.86 340.99 661.65 340.72C661.46 340.44 661.18 340.31 660.8 340.31C660.42 340.31 660.09 340.46 659.87 340.75C659.66 341.03 659.56 341.42 659.56 341.94V350.38C659.56 350.47 659.53 350.54 659.46 350.61C659.41 350.66 659.34 350.69 659.25 350.69H656.22C656.13 350.69 656.06 350.66 655.99 350.61C655.94 350.54 655.91 350.46 655.91 350.38V337.7C655.91 337.61 655.94 337.54 655.99 337.49C656.06 337.42 656.14 337.39 656.22 337.39H659.25C659.34 337.39 659.41 337.42 659.46 337.49C659.53 337.54 659.56 337.61 659.56 337.7V338.19C659.56 338.24 659.58 338.27 659.61 338.27C659.66 338.27 659.72 338.24 659.79 338.17C660.34 337.51 661.11 337.19 662.09 337.19V337.18ZM673.43 337.7C673.43 337.61 673.46 337.54 673.51 337.49C673.58 337.42 673.66 337.39 673.74 337.39H676.77C676.86 337.39 676.93 337.42 676.98 337.49C677.05 337.54 677.08 337.61 677.08 337.7V350.38C677.08 350.47 677.05 350.54 676.98 350.61C676.93 350.66 676.86 350.69 676.77 350.69H673.74C673.65 350.69 673.58 350.66 673.51 350.61C673.46 350.54 673.43 350.46 673.43 350.38V349.94C673.43 349.89 673.41 349.85 673.38 349.84C673.35 349.82 673.31 349.84 673.28 349.89C673.02 350.25 672.69 350.51 672.3 350.67C671.92 350.81 671.47 350.88 670.95 350.88C669.91 350.88 669.06 350.57 668.39 349.95C667.72 349.31 667.38 348.34 667.38 347.03V337.71C667.38 337.62 667.41 337.55 667.46 337.5C667.53 337.43 667.61 337.4 667.69 337.4H670.72C670.81 337.4 670.88 337.43 670.93 337.5C671 337.55 671.03 337.62 671.03 337.71V346.22C671.03 346.72 671.13 347.11 671.31 347.38C671.52 347.64 671.81 347.77 672.19 347.77C672.57 347.77 672.87 347.62 673.1 347.33C673.32 347.04 673.44 346.64 673.44 346.14V337.7H673.43ZM685.11 339.64C685.11 339.73 685.08 339.8 685.01 339.87C684.96 339.92 684.89 339.95 684.8 339.95H683.35C683.26 339.95 683.22 339.99 683.22 340.08V346.24C683.22 346.74 683.32 347.09 683.5 347.28C683.69 347.47 683.97 347.56 684.35 347.54H684.53C684.62 347.54 684.69 347.57 684.74 347.64C684.81 347.69 684.84 347.76 684.84 347.85V350.39C684.84 350.48 684.81 350.55 684.74 350.62C684.69 350.67 684.62 350.7 684.53 350.7H683.49C682.23 350.7 681.28 350.49 680.64 350.08C680 349.65 679.68 348.84 679.68 347.65V340.09C679.68 340 679.64 339.96 679.55 339.96H678.7C678.61 339.96 678.54 339.93 678.47 339.88C678.42 339.81 678.39 339.73 678.39 339.65V337.71C678.39 337.62 678.42 337.55 678.47 337.5C678.54 337.43 678.62 337.4 678.7 337.4H679.55C679.64 337.4 679.68 337.36 679.68 337.27V334.4C679.68 334.31 679.71 334.24 679.76 334.19C679.83 334.12 679.91 334.09 679.99 334.09H682.89C682.98 334.09 683.05 334.12 683.1 334.19C683.17 334.24 683.2 334.31 683.2 334.4V337.27C683.2 337.36 683.24 337.4 683.33 337.4H684.78C684.87 337.4 684.94 337.43 684.99 337.5C685.06 337.55 685.09 337.62 685.09 337.71V339.65L685.11 339.64ZM696.19 344.87C696.19 344.96 696.16 345.03 696.09 345.1C696.04 345.15 695.97 345.18 695.88 345.18H690.19C690.1 345.18 690.06 345.22 690.06 345.31V346.27C690.06 346.7 690.17 347.06 690.4 347.36C690.64 347.64 690.94 347.77 691.31 347.77C691.64 347.77 691.91 347.67 692.11 347.46C692.32 347.24 692.45 346.96 692.52 346.63C692.57 346.46 692.68 346.37 692.86 346.37L695.84 346.53C695.93 346.53 696 346.56 696.05 346.63C696.12 346.68 696.14 346.76 696.13 346.86C696.01 348.19 695.54 349.2 694.73 349.89C693.94 350.56 692.8 350.9 691.31 350.9C689.82 350.9 688.58 350.52 687.71 349.76C686.85 348.98 686.42 347.91 686.42 346.55V341.53C686.42 340.22 686.85 339.17 687.71 338.37C688.59 337.58 689.79 337.18 691.31 337.18C692.83 337.18 694.02 337.58 694.88 338.37C695.76 339.16 696.2 340.22 696.2 341.53V344.87H696.19ZM691.3 340.32C690.94 340.32 690.64 340.46 690.39 340.73C690.17 341.01 690.05 341.36 690.05 341.79V342.8C690.05 342.89 690.09 342.93 690.18 342.93H692.41C692.5 342.93 692.54 342.89 692.54 342.8V341.79C692.54 341.36 692.42 341.01 692.18 340.73C691.96 340.45 691.66 340.32 691.3 340.32ZM702.29 350.88C700.82 350.88 699.65 350.53 698.77 349.84C697.91 349.13 697.48 348.19 697.48 347.02V346.84C697.48 346.75 697.51 346.68 697.56 346.63C697.63 346.56 697.71 346.53 697.79 346.53H700.64C700.73 346.53 700.8 346.56 700.85 346.63C700.92 346.68 700.95 346.75 700.95 346.84V346.92C700.95 347.28 701.08 347.58 701.34 347.83C701.6 348.05 701.92 348.17 702.3 348.17C702.64 348.17 702.91 348.08 703.1 347.89C703.31 347.68 703.41 347.42 703.41 347.11C703.41 346.73 703.25 346.44 702.92 346.23C702.59 346.01 702.22 345.82 701.81 345.69C701.41 345.53 701.14 345.43 700.98 345.38C700.03 345.03 699.23 344.56 698.57 343.96C697.93 343.34 697.61 342.45 697.61 341.29C697.61 340.03 698.02 339.04 698.85 338.31C699.68 337.59 700.78 337.22 702.16 337.22C703.54 337.22 704.72 337.6 705.55 338.36C706.4 339.12 706.82 340.15 706.82 341.44C706.82 341.53 706.79 341.6 706.72 341.67C706.67 341.72 706.6 341.75 706.51 341.75H703.74C703.65 341.75 703.58 341.72 703.51 341.67C703.46 341.6 703.43 341.52 703.43 341.44V341.23C703.43 340.88 703.32 340.61 703.09 340.4C702.88 340.18 702.61 340.06 702.26 340.06C701.9 340.06 701.61 340.18 701.41 340.42C701.2 340.64 701.1 340.91 701.1 341.22C701.1 341.63 701.27 341.96 701.62 342.2C701.98 342.42 702.53 342.67 703.25 342.95C703.99 343.23 704.62 343.51 705.14 343.8C705.68 344.08 706.13 344.48 706.51 345.02C706.89 345.54 707.08 346.19 707.08 346.99C707.08 348.18 706.64 349.13 705.76 349.84C704.9 350.53 703.74 350.88 702.29 350.88Z"
        fill="#2B2B2B"
      />
      <path
        d="M491.65 363.27C504.01 363.27 514.03 353.25 514.03 340.89C514.03 328.53 504.01 318.51 491.65 318.51C479.29 318.51 469.27 328.53 469.27 340.89C469.27 353.25 479.29 363.27 491.65 363.27Z"
        fill="#27AE60"
      />
      <path
        d="M491.63 328.84L491.01 329.54C488.38 332.5 484.72 333.89 480.36 334.43L479.6 334.52V335.28C479.6 339.72 480.54 344.03 482.49 347.56C484.44 351.09 487.42 353.85 491.41 355.04L491.67 355.12L491.93 355.03C499.64 352.54 503.72 344.42 503.72 335.28V334.59L503.05 334.43C498.81 333.45 494.89 332.26 492.29 329.52L491.64 328.84H491.63ZM491.67 331.13C494.46 333.73 498.12 334.99 501.91 335.89C501.73 344.12 498.13 350.99 491.64 353.25C488.26 352.16 485.71 349.86 483.99 346.73C482.31 343.68 481.48 339.88 481.39 335.92C485.38 335.31 488.93 333.89 491.67 331.14V331.13ZM496.25 338.5L489.97 343.99L487.1 341.12L485.88 342.34L489.89 346.35L497.39 339.79L496.25 338.5Z"
        fill="white"
      />
      <path
        d="M200.918 92.7414C201.577 92.7743 202.15 92.9381 202.635 93.2327C203.121 93.5273 203.487 93.931 203.731 94.4439C203.987 94.9472 204.098 95.5185 204.066 96.1577C204.035 96.7869 203.862 97.334 203.549 97.7989C203.245 98.2644 202.827 98.6189 202.294 98.8627C201.772 99.0969 201.176 99.1973 200.507 99.1639L198.379 99.0576C198.33 99.0551 198.303 99.0788 198.301 99.1287L198.11 102.949C198.108 102.999 198.085 103.043 198.043 103.081C198.012 103.109 197.971 103.122 197.921 103.12L196.168 103.032C196.118 103.03 196.074 103.012 196.036 102.981C196.008 102.939 195.995 102.893 195.998 102.843L196.504 92.7011C196.507 92.6512 196.524 92.612 196.555 92.5835C196.597 92.5455 196.643 92.5278 196.693 92.5303L200.918 92.7414ZM200.367 97.4597C200.826 97.4827 201.202 97.3713 201.495 97.1256C201.788 96.8699 201.945 96.5273 201.967 96.0979C201.989 95.6584 201.866 95.2969 201.6 95.0132C201.334 94.7296 200.971 94.5763 200.512 94.5534L198.609 94.4583C198.559 94.4558 198.533 94.4795 198.531 94.5295L198.393 97.286C198.39 97.336 198.414 97.3622 198.464 97.3647L200.367 97.4597ZM209.093 95.8531C209.452 95.8711 209.734 95.9552 209.936 96.1055C210.014 96.1495 210.041 96.2259 210.015 96.3348L209.615 98.0269C209.599 98.1463 209.527 98.1777 209.4 98.1213C209.253 98.0639 209.079 98.0302 208.88 98.0202C208.8 98.0162 208.689 98.0207 208.548 98.0337C208.187 98.0457 207.876 98.1653 207.614 98.3925C207.353 98.6098 207.213 98.9132 207.193 99.3027L206.989 103.393C206.987 103.443 206.964 103.486 206.922 103.524C206.891 103.553 206.85 103.566 206.8 103.563L205.048 103.476C204.998 103.473 204.953 103.456 204.915 103.424C204.887 103.383 204.874 103.337 204.877 103.287L205.243 95.9462C205.246 95.8963 205.263 95.8571 205.294 95.8286C205.336 95.7906 205.382 95.7729 205.432 95.7754L207.185 95.863C207.235 95.8655 207.274 95.8874 207.302 95.9289C207.34 95.9608 207.358 96.0018 207.356 96.0517L207.327 96.621C207.326 96.651 207.335 96.6714 207.354 96.6824C207.374 96.6934 207.389 96.6892 207.4 96.6697C207.84 96.0909 208.404 95.8187 209.093 95.8531ZM213.807 104.034C212.968 103.992 212.26 103.736 211.683 103.267C211.106 102.797 210.726 102.178 210.544 101.407C210.428 100.931 210.384 100.418 210.411 99.8689C210.44 99.2796 210.537 98.7538 210.7 98.2914C210.967 97.5638 211.41 97.0052 212.03 96.6157C212.651 96.2261 213.38 96.0523 214.219 96.0942C215.038 96.1351 215.727 96.3798 216.285 96.8282C216.844 97.2666 217.225 97.8614 217.427 98.6124C217.562 99.1198 217.616 99.6481 217.589 100.197C217.562 100.737 217.466 101.238 217.303 101.7C217.045 102.468 216.604 103.062 215.983 103.481C215.371 103.891 214.646 104.075 213.807 104.034ZM213.898 102.221C214.228 102.237 214.512 102.151 214.752 101.963C214.992 101.775 215.17 101.508 215.287 101.164C215.383 100.848 215.441 100.501 215.46 100.121C215.481 99.7017 215.458 99.3451 215.393 99.0515C215.3 98.7064 215.143 98.4333 214.923 98.232C214.703 98.0308 214.428 97.9219 214.099 97.9055C213.759 97.8885 213.47 97.9692 213.23 98.1474C213.001 98.3262 212.828 98.5829 212.711 98.9175C212.619 99.1532 212.562 99.5058 212.538 99.9752C212.516 100.425 212.533 100.776 212.591 101.029C212.673 101.384 212.824 101.667 213.044 101.878C213.274 102.09 213.558 102.204 213.898 102.221ZM223.322 96.6541C223.372 96.6566 223.411 96.6786 223.439 96.72C223.477 96.752 223.495 96.7929 223.493 96.8429L223.422 98.2661C223.419 98.316 223.397 98.36 223.355 98.3979C223.324 98.4264 223.283 98.4394 223.233 98.4369L221.78 98.3643C221.73 98.3618 221.704 98.3855 221.701 98.4355L221.417 104.113C221.415 104.163 221.393 104.207 221.351 104.245C221.319 104.274 221.279 104.287 221.229 104.284L219.476 104.197C219.426 104.194 219.382 104.177 219.343 104.145C219.315 104.103 219.303 104.058 219.305 104.008L219.589 98.3299C219.591 98.28 219.567 98.2538 219.518 98.2513L218.634 98.2071C218.584 98.2046 218.54 98.1874 218.501 98.1554C218.473 98.114 218.46 98.0683 218.463 98.0184L218.534 96.5951C218.536 96.5452 218.553 96.506 218.585 96.4775C218.627 96.4396 218.673 96.4218 218.723 96.4243L219.607 96.4685C219.657 96.471 219.683 96.4473 219.685 96.3973L219.702 96.0677C219.733 95.4485 219.851 94.9739 220.058 94.6438C220.265 94.3037 220.582 94.0742 221.009 93.9553C221.446 93.827 222.038 93.7915 222.786 93.8489L223.356 93.8773C223.406 93.8798 223.444 93.9018 223.472 93.9432C223.511 93.9752 223.529 94.0161 223.526 94.0661L223.466 95.2796C223.463 95.3295 223.441 95.3735 223.399 95.4114C223.368 95.4399 223.327 95.4529 223.277 95.4504L222.783 95.4257C222.433 95.4182 222.184 95.4809 222.037 95.6137C221.901 95.7371 221.824 95.9785 221.806 96.3381L221.798 96.5029C221.795 96.5528 221.819 96.579 221.869 96.5815L223.322 96.6541ZM230.921 100.113C230.962 100.495 230.961 100.921 230.917 101.389C230.901 101.508 230.833 101.565 230.713 101.559L226.084 101.328C226.024 101.325 226.003 101.349 226.021 101.4C226.041 101.601 226.086 101.803 226.155 102.007C226.387 102.579 226.903 102.886 227.702 102.925C228.341 102.947 228.859 102.713 229.254 102.222C229.297 102.164 229.343 102.136 229.393 102.139C229.423 102.14 229.457 102.162 229.495 102.204L230.52 103.322C230.568 103.374 230.59 103.42 230.588 103.46C230.587 103.48 230.565 103.519 230.523 103.577C230.173 103.97 229.732 104.268 229.201 104.472C228.671 104.666 228.096 104.747 227.477 104.716C226.618 104.674 225.899 104.442 225.319 104.023C224.749 103.604 224.352 103.038 224.127 102.326C223.942 101.816 223.87 101.157 223.91 100.348C223.938 99.7988 224.037 99.3181 224.208 98.9061C224.473 98.2085 224.901 97.6641 225.491 97.2731C226.091 96.8826 226.786 96.707 227.575 96.7464C228.573 96.7963 229.358 97.1259 229.928 97.7351C230.509 98.3448 230.839 99.1373 230.921 100.113ZM227.498 98.5749C226.869 98.5435 226.44 98.8174 226.211 99.3967C226.164 99.5245 226.121 99.6826 226.082 99.8708C226.079 99.9208 226.103 99.947 226.153 99.9495L228.745 100.079C228.805 100.082 228.826 100.058 228.809 100.007C228.773 99.7149 228.755 99.5738 228.755 99.5838C228.68 99.2797 228.531 99.042 228.31 98.8707C228.098 98.69 227.828 98.5914 227.498 98.5749ZM235.014 105.078C234.345 105.045 233.765 104.92 233.276 104.706C232.786 104.491 232.409 104.207 232.147 103.853C231.894 103.5 231.778 103.109 231.8 102.68L231.807 102.53C231.81 102.48 231.827 102.441 231.858 102.412C231.9 102.374 231.946 102.357 231.996 102.359L233.659 102.442C233.709 102.445 233.748 102.467 233.776 102.508C233.814 102.54 233.832 102.581 233.83 102.631L233.829 102.646C233.818 102.866 233.928 103.061 234.16 103.233C234.402 103.395 234.708 103.486 235.078 103.504C235.417 103.521 235.695 103.47 235.911 103.351C236.128 103.221 236.242 103.057 236.252 102.857C236.261 102.677 236.177 102.538 236.002 102.439C235.827 102.34 235.537 102.231 235.132 102.11C234.669 101.967 234.305 101.834 234.041 101.71C233.413 101.459 232.917 101.163 232.553 100.825C232.19 100.486 232.023 100.017 232.053 99.4182C232.09 98.6791 232.404 98.1091 232.994 97.708C233.596 97.2975 234.371 97.116 235.319 97.1634C235.959 97.1953 236.513 97.3281 236.982 97.5618C237.451 97.7855 237.806 98.0886 238.048 98.4711C238.299 98.8541 238.413 99.2803 238.389 99.7498C238.387 99.7997 238.365 99.8436 238.323 99.8816C238.291 99.9101 238.25 99.923 238.2 99.9206L236.597 99.8405C236.548 99.838 236.503 99.8207 236.465 99.7888C236.437 99.7473 236.424 99.7017 236.427 99.6517C236.438 99.432 236.332 99.2415 236.11 99.0802C235.898 98.9194 235.607 98.8298 235.237 98.8113C234.908 98.7948 234.635 98.8413 234.419 98.9507C234.203 99.06 234.09 99.2196 234.08 99.4293C234.07 99.6291 234.162 99.7839 234.357 99.8937C234.562 100.004 234.901 100.126 235.375 100.26C235.483 100.295 235.607 100.337 235.744 100.384C235.883 100.421 236.03 100.468 236.188 100.526C236.886 100.771 237.432 101.069 237.825 101.419C238.218 101.769 238.399 102.258 238.368 102.888C238.331 103.627 238.007 104.191 237.397 104.581C236.797 104.962 236.003 105.127 235.014 105.078ZM242.432 105.449C241.763 105.415 241.183 105.291 240.693 105.076C240.203 104.862 239.827 104.578 239.564 104.224C239.312 103.871 239.196 103.48 239.217 103.05L239.225 102.9C239.227 102.85 239.244 102.811 239.276 102.783C239.318 102.745 239.364 102.727 239.414 102.73L241.077 102.813C241.126 102.815 241.165 102.837 241.193 102.879C241.232 102.911 241.25 102.951 241.247 103.001L241.247 103.016C241.236 103.236 241.346 103.432 241.578 103.604C241.82 103.766 242.126 103.856 242.495 103.875C242.835 103.892 243.113 103.841 243.329 103.721C243.546 103.592 243.659 103.427 243.669 103.228C243.678 103.048 243.595 102.908 243.42 102.81C243.244 102.711 242.954 102.601 242.55 102.481C242.086 102.337 241.723 102.204 241.459 102.081C240.83 101.829 240.334 101.534 239.971 101.195C239.607 100.857 239.44 100.388 239.47 99.7888C239.507 99.0497 239.821 98.4796 240.412 98.0786C241.013 97.6681 241.788 97.4865 242.737 97.5339C243.376 97.5659 243.93 97.6987 244.399 97.9324C244.869 98.1561 245.224 98.4592 245.465 98.8417C245.716 99.2247 245.83 99.6509 245.807 100.12C245.804 100.17 245.782 100.214 245.74 100.252C245.709 100.281 245.668 100.294 245.618 100.291L244.015 100.211C243.965 100.209 243.921 100.191 243.882 100.159C243.854 100.118 243.842 100.072 243.844 100.022C243.855 99.8026 243.75 99.612 243.527 99.4508C243.315 99.29 243.024 99.2003 242.655 99.1819C242.325 99.1654 242.052 99.2119 241.837 99.3212C241.621 99.4306 241.508 99.5902 241.497 99.7999C241.487 99.9997 241.58 100.154 241.775 100.264C241.979 100.375 242.319 100.497 242.793 100.631C242.901 100.666 243.024 100.707 243.162 100.754C243.3 100.791 243.448 100.839 243.605 100.896C244.304 101.142 244.85 101.439 245.243 101.789C245.636 102.139 245.817 102.629 245.785 103.258C245.748 103.997 245.425 104.562 244.814 104.952C244.215 105.332 243.42 105.498 242.432 105.449ZM248.452 97.0535C248.113 97.0365 247.834 96.9125 247.615 96.6813C247.407 96.4406 247.311 96.1504 247.328 95.8109C247.345 95.4613 247.47 95.1821 247.7 94.9734C247.931 94.7646 248.221 94.669 248.571 94.6865C248.92 94.7039 249.199 94.828 249.408 95.0587C249.617 95.2894 249.712 95.5795 249.695 95.9291C249.678 96.2687 249.549 96.5476 249.308 96.7658C249.077 96.9746 248.792 97.0705 248.452 97.0535ZM247.125 105.578C247.075 105.575 247.031 105.558 246.993 105.526C246.965 105.485 246.952 105.439 246.955 105.389L247.322 98.0333C247.325 97.9834 247.342 97.9442 247.373 97.9157C247.415 97.8778 247.461 97.86 247.511 97.8625L249.264 97.9501C249.314 97.9526 249.353 97.9746 249.381 98.016C249.419 98.048 249.437 98.0889 249.434 98.1389L249.067 105.495C249.064 105.545 249.042 105.589 249 105.627C248.969 105.655 248.928 105.668 248.878 105.665L247.125 105.578ZM254.099 106.046C253.26 106.005 252.552 105.749 251.975 105.279C251.397 104.81 251.018 104.19 250.836 103.42C250.72 102.944 250.675 102.431 250.703 101.882C250.732 101.293 250.828 100.767 250.992 100.304C251.258 99.5766 251.702 99.0181 252.322 98.6285C252.942 98.239 253.672 98.0652 254.511 98.1071C255.33 98.148 256.018 98.3927 256.577 98.8411C257.135 99.2795 257.516 99.8743 257.719 100.625C257.854 101.133 257.907 101.661 257.88 102.21C257.853 102.75 257.758 103.251 257.595 103.713C257.336 104.481 256.896 105.075 256.274 105.494C255.663 105.904 254.938 106.088 254.099 106.046ZM254.189 104.234C254.519 104.25 254.804 104.164 255.043 103.976C255.283 103.788 255.462 103.521 255.579 103.177C255.675 102.861 255.732 102.514 255.751 102.134C255.772 101.715 255.75 101.358 255.684 101.064C255.592 100.719 255.435 100.446 255.215 100.245C254.995 100.044 254.72 99.9348 254.39 99.9183C254.05 99.9014 253.761 99.982 253.522 100.16C253.293 100.339 253.12 100.596 253.003 100.93C252.911 101.166 252.853 101.519 252.83 101.988C252.807 102.438 252.825 102.789 252.882 103.042C252.965 103.397 253.116 103.679 253.336 103.891C253.565 104.102 253.85 104.217 254.189 104.234ZM263.449 98.5536C264.248 98.5936 264.88 98.8704 265.345 99.3843C265.81 99.8981 266.021 100.575 265.98 101.413L265.734 106.327C265.732 106.377 265.709 106.421 265.667 106.459C265.636 106.488 265.595 106.501 265.545 106.498L263.792 106.411C263.743 106.408 263.698 106.391 263.66 106.359C263.632 106.317 263.619 106.272 263.622 106.222L263.845 101.742C263.865 101.343 263.767 101.013 263.55 100.751C263.342 100.491 263.054 100.351 262.684 100.333C262.315 100.314 262.009 100.424 261.767 100.662C261.535 100.901 261.408 101.22 261.389 101.62L261.165 106.099C261.162 106.149 261.14 106.193 261.098 106.231C261.067 106.259 261.026 106.272 260.976 106.27L259.223 106.182C259.173 106.18 259.129 106.163 259.091 106.131C259.063 106.089 259.05 106.043 259.052 105.994L259.419 98.6527C259.422 98.6028 259.439 98.5636 259.47 98.5351C259.512 98.4971 259.558 98.4794 259.608 98.4819L261.361 98.5695C261.411 98.572 261.45 98.5939 261.478 98.6354C261.516 98.6673 261.534 98.7083 261.531 98.7582L261.505 99.2826C261.504 99.3125 261.513 99.333 261.532 99.344C261.552 99.355 261.567 99.3507 261.578 99.3313C262.016 98.7724 262.64 98.5132 263.449 98.5536ZM270.698 98.9158C271.347 98.9482 271.921 99.092 272.419 99.3472C272.917 99.5924 273.296 99.9167 273.557 100.32C273.827 100.724 273.95 101.166 273.926 101.645L273.672 106.724C273.67 106.774 273.648 106.818 273.606 106.856C273.574 106.884 273.533 106.897 273.483 106.895L271.731 106.807C271.681 106.805 271.637 106.787 271.598 106.755C271.57 106.714 271.557 106.668 271.56 106.618L271.585 106.124C271.586 106.094 271.577 106.074 271.558 106.063C271.538 106.052 271.518 106.061 271.496 106.09C271.049 106.618 270.361 106.859 269.433 106.812C268.654 106.774 268.034 106.552 267.573 106.149C267.113 105.745 266.901 105.174 266.938 104.435C266.976 103.666 267.276 103.085 267.836 102.693C268.397 102.29 269.177 102.114 270.175 102.164L271.704 102.24C271.753 102.243 271.78 102.219 271.782 102.169L271.799 101.839C271.815 101.51 271.728 101.25 271.537 101.06C271.347 100.861 271.052 100.751 270.653 100.731C270.343 100.715 270.08 100.757 269.865 100.857C269.66 100.957 269.522 101.105 269.453 101.302C269.417 101.41 269.35 101.457 269.25 101.442L267.45 101.111C267.331 101.085 267.278 101.038 267.291 100.968C267.352 100.551 267.536 100.18 267.843 99.8545C268.159 99.5299 268.562 99.2847 269.051 99.1189C269.55 98.9535 270.099 98.8859 270.698 98.9158ZM270.08 105.268C270.51 105.289 270.88 105.193 271.191 104.978C271.502 104.763 271.667 104.476 271.685 104.117L271.712 103.577C271.714 103.527 271.691 103.501 271.641 103.499L270.562 103.445C270.113 103.422 269.754 103.489 269.486 103.646C269.227 103.803 269.091 104.037 269.075 104.347C269.062 104.616 269.146 104.836 269.328 105.005C269.51 105.164 269.761 105.252 270.08 105.268ZM275.331 106.987C275.281 106.985 275.237 106.967 275.198 106.935C275.17 106.894 275.158 106.848 275.16 106.798L275.666 96.6709C275.669 96.6209 275.686 96.5817 275.717 96.5533C275.759 96.5153 275.805 96.4976 275.855 96.5001L277.608 96.5877C277.658 96.5901 277.697 96.6121 277.725 96.6536C277.763 96.6855 277.781 96.7265 277.779 96.7764L277.273 106.904C277.27 106.954 277.248 106.998 277.206 107.036C277.174 107.064 277.134 107.077 277.084 107.075L275.331 106.987Z"
        fill="#4F4F4F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M233.06 367.96L234.95 323.33L191.05 322L193.87 367.95C207.34 368.99 217.46 368.99 233.06 367.95V367.96Z"
        fill="#27AE60"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M234.95 323.33C234.95 323.33 212.62 328.86 191.05 322C191.05 322 213.21 318.81 234.95 323.33Z"
        fill="#E2E2FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M231.22 323.26C231.22 323.26 213.68 319.92 194.79 322.42C194.79 322.42 206.74 326.76 231.22 323.26Z"
        fill="url(#paint517_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M227.56 323.73C227.56 323.73 216.13 321.29 195.98 322.77C195.98 322.77 206.52 326.54 227.56 323.73Z"
        fill="url(#paint518_radial_2072_10275)"
      />
      <path
        style={{ mixBlendMode: 'screen' }}
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M234.78 327.31C234.78 327.31 229.07 334.87 216.82 340.22L215.3 368.73C215.3 368.73 222.79 369.2 233.06 367.97L234.78 327.32V327.31Z"
        fill="url(#paint519_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M215.62 323.79L214.57 301.38C214.57 301.38 210.35 300.02 209.81 295.25L207.23 261.64L208.59 249.78H205.88V297.44L207.46 303.15C207.46 303.15 209.74 304.96 210.75 306.32C211.76 307.68 210.75 324.01 210.75 324.01L215.62 323.79Z"
        fill="url(#paint520_radial_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M208.81 282.34C208.81 282.34 225.81 273.55 232.65 252.68C232.65 252.68 223.46 251.07 215.61 254.29C207.77 257.51 208.12 273.43 208.12 273.43L208.8 282.33L208.81 282.34Z"
        fill="url(#paint521_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M205.87 276.41C205.87 276.41 200.71 266.45 191.53 261.76C182.35 257.07 167.04 261.76 167.04 261.76C167.04 261.76 193.31 280.08 205.87 276.41Z"
        fill="url(#paint522_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M208.81 282.34C208.81 282.34 216.52 265.99 220.35 264.63C224.18 263.26 234.28 271.47 234.28 271.47C234.28 271.47 223.91 278.03 219.53 280.49C215.16 282.95 208.81 282.34 208.81 282.34Z"
        fill="url(#paint523_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M205.87 293.07C205.87 293.07 204.77 285.97 200.39 282.41C196.02 278.85 184.85 276.89 184.85 276.89C184.85 276.89 193.84 293.88 205.86 293.06L205.87 293.07Z"
        fill="url(#paint524_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M205.87 256.15C205.87 256.15 212.48 235.71 202.88 218.5C202.88 218.5 195.88 231.55 195.86 244.13C195.84 256.71 205.87 256.15 205.87 256.15Z"
        fill="url(#paint525_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M205.87 288.58C205.87 288.58 207.28 265.39 195.36 254.3C195.36 254.3 184.55 280.36 205.87 288.58Z"
        fill="url(#paint526_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M212.61 300.27L212.91 297.17C212.91 297.17 219.95 291.62 219.67 276.9C219.67 276.9 211.68 281.92 210.75 288.59C209.81 295.26 212.25 297.36 212.25 297.36L211.73 299.48L212.61 300.28V300.27Z"
        fill="url(#paint527_linear_2072_10275)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M205.87 264.48L208.82 259.67C208.82 259.67 217.89 260.35 224.09 244.12C224.09 244.12 211.79 244.48 206.96 247.4C202.13 250.32 207.46 259.67 207.46 259.67L205.88 263.26V264.47L205.87 264.48Z"
        fill="url(#paint528_linear_2072_10275)"
      />
      <path
        d="M73.9099 249.35C71.8499 252.93 69.6799 253.61 68.7399 253.36C67.8099 253.11 63.0099 249.49 63.0099 249.49C63.0099 249.49 66.5999 250.55 67.4299 250.27C68.2599 249.99 70.8099 248.78 71.2899 248.41C71.7599 248.03 73.4999 244.24 74.4299 244.49C75.3599 244.74 75.9699 245.76 73.9099 249.35Z"
        fill="url(#paint529_linear_2072_10275)"
      />
      <path
        d="M50.3699 238.75C51.5699 239 55.7499 239.11 59.2799 240.41C62.8099 241.71 74.2199 245.31 74.0399 246.02C73.8599 246.72 74.2199 248.69 67.3199 246.88C60.4299 245.08 60.3399 245.43 60.0699 245.98C59.7999 246.53 61.6299 248.63 63.6399 249.53C65.6499 250.43 69.1199 251.96 69.7699 251.88C70.4099 251.8 74.4099 247.47 75.1799 246.93C75.9499 246.38 78.1399 244.64 78.7899 246C79.2999 247.07 72.2099 254.77 70.0899 256.46C69.1799 257.18 62.5299 254.73 60.0199 253.83C57.5099 252.92 48.9699 245.95 45.9499 244.16C42.9199 242.37 40.5399 240.5 40.5399 240.5L40.6199 235.02C42.1099 235.71 48.3799 238.34 50.3799 238.75H50.3699Z"
        fill="#F7D4AB"
      />
      <path
        d="M66.6599 246.7C66.6599 246.7 60.3299 244.52 59.8499 245.85C59.3799 247.19 63.0599 249.25 63.0599 249.25C63.0599 249.25 60.5499 245.53 66.6499 246.69L66.6599 246.7Z"
        fill="url(#paint530_linear_2072_10275)"
      />
      <path
        d="M71.1599 245.39C70.4699 245.01 70.7399 244.43 70.7399 244.43C70.7399 244.43 72.8099 244.86 74.2099 245.87C74.0999 246.57 72.6499 246.21 71.1599 245.4V245.39Z"
        fill="#FFDEBD"
      />
      <path
        d="M76.7899 249.22C76.7899 249.22 76.2599 248.86 76.6499 248.18C77.4899 246.71 78.5399 245.65 79.0099 246.18C78.3399 247.76 76.7999 249.21 76.7999 249.21L76.7899 249.22Z"
        fill="#FFDEBD"
      />
      <path
        d="M45.8999 242.76C46.2299 243.58 58.8399 253.78 59.2399 251.29C59.5099 249.61 43.8099 237.58 45.8999 242.76Z"
        fill="url(#paint531_linear_2072_10275)"
      />
      <path
        d="M40.5999 235.01L50.0199 238.3C51.5599 238.48 55.1599 238.73 60.0299 240.67C60.0299 240.67 50.6899 239.8 48.3899 239.67L40.6099 235.01H40.5999Z"
        fill="url(#paint532_linear_2072_10275)"
      />
      <path
        d="M55.0399 111.79C54.1399 99.73 56.4199 84.07 65.3799 75.7C70.9299 70.53 84.7999 70.45 84.7999 70.45C124.1 67.78 130.82 139.37 104.03 150.05C101.77 150.4 80.8399 163.44 75.6899 164.34C77.8899 160.65 70.9899 150.81 65.3899 142.9C60.6099 136.16 55.9899 124.67 55.0399 111.78V111.79Z"
        fill="url(#paint533_linear_2072_10275)"
      />
      <path
        d="M102.45 91.73C102.45 91.73 137.31 104.15 102.37 173.07L97.9599 166.22C97.9599 166.22 108.41 131.5 103.2 118.19C99.4899 108.72 102.82 102.5 102.44 91.73H102.45Z"
        fill="url(#paint534_linear_2072_10275)"
      />
      <path
        d="M87.8999 173.46C86.9899 173.46 75.2199 173.2 74.8299 172.7C53.4999 145 51.8799 116 57.6699 105.79C77.1099 71.53 77.6899 79.53 77.6899 79.53C82.0799 95.36 80.3099 106.09 74.6999 115.11C66.9499 127.58 81.2499 159.91 87.8799 173.45L87.8999 173.46Z"
        fill="url(#paint535_linear_2072_10275)"
      />
      <path
        d="M53.9299 155.04C57.1599 153.62 60.0699 147.76 60.9599 147.67C64.0699 147.37 75.2199 143.84 76.5199 139.67C78.1299 134.47 76.1999 127.79 76.1999 127.79L95.5999 126.81C93.4199 130.48 93.4999 134.37 93.5899 138.33C93.6899 142.67 106.61 146.46 111.1 146.95C113.55 147.23 120.87 152.03 122.07 156.28C123.75 162.25 125.06 161.58 124.56 169.42L46.4899 161.88C46.9699 157.52 47.8499 157.72 53.9299 155.03V155.04Z"
        fill="#F7D4AB"
      />
      <path
        d="M66.9699 144.4C66.2999 144.12 66.5999 144 65.9299 143.59C73.5099 141.37 74.7699 141.03 75.3099 140.65C75.8899 140.25 76.4499 138.36 76.6599 136.14C76.7499 135.18 76.8899 132.76 76.9199 131.5C77.1799 131.82 93.7199 131.22 94.3599 130.27L96.2799 130.29C96.2799 130.29 95.9199 135.77 96.6099 140.81C96.7899 141.71 102.15 142.97 105.67 143.71C105.42 143.91 104.52 144.52 104.31 144.63C101.3 144.93 98.7099 145.29 97.4799 145.07C95.9799 144.81 93.4499 143.65 91.6199 142.8C81.7099 138.22 78.6099 136.71 78.6099 136.71C78.1399 140.97 75.0199 143.79 75.1899 143.74C72.6899 144.35 69.6599 144.47 66.9599 144.4H66.9699Z"
        fill="url(#paint536_linear_2072_10275)"
      />
      <path
        d="M82.7699 150.6C82.7699 150.6 83.7999 147.73 87.2799 148.85C87.2799 148.85 83.7099 149.49 82.7699 150.6Z"
        fill="url(#paint537_linear_2072_10275)"
      />
      <path
        d="M82.6499 148.14C82.6499 148.14 81.6499 145.54 80.2599 145.19C78.8699 144.84 67.4499 144.53 65.6599 144.18C65.6599 144.18 68.5599 145.48 72.4999 145.94C76.4499 146.4 79.5499 145.71 82.6499 148.14Z"
        fill="url(#paint538_linear_2072_10275)"
      />
      <path
        d="M87.5599 148.12C87.5599 148.12 88.5199 146.13 90.2299 145.55C91.9399 144.97 104.99 144.16 107.34 144.39C107.34 144.39 90.8799 146.05 87.5599 148.12Z"
        fill="url(#paint539_linear_2072_10275)"
      />
      <path
        d="M96.5599 140.13C96.5599 140.13 96.4799 129.55 96.8199 127.67C96.8199 127.67 77.3799 128.38 76.4899 128.45C76.8499 130.65 76.8699 133.4 76.8699 133.4C76.8699 133.4 85.1599 143.78 96.5499 140.13H96.5599Z"
        fill="url(#paint540_linear_2072_10275)"
      />
      <path
        d="M107.33 108.64C106.52 115.28 106.29 120.32 106.29 120.32C108.92 120.32 109.45 117.48 110.47 114.97C112.05 111.14 112.9 107.01 108.75 106.64C108.06 106.58 107.33 108.63 107.33 108.63V108.64Z"
        fill="#F0C499"
      />
      <path
        d="M107.81 118.1C107.81 118.1 109.1 116.63 108.71 113.74C107.77 106.92 112.06 106.45 111.09 111.11C111.09 111.11 110.5 108.91 109.95 109.57C109.28 110.38 110.66 110.82 109.95 114.35C109.58 116.18 107.81 118.11 107.81 118.11V118.1Z"
        fill="url(#paint541_linear_2072_10275)"
      />
      <path
        d="M83.2799 78.68C95.7099 76.44 104.48 88.29 106.83 102.53C108.15 110.53 107.74 117.57 103.76 123.45C102.15 125.83 100.16 126.99 97.8399 128.87C96.3699 130.07 94.0599 132.63 92.4899 133.87C91.0599 135 89.4999 135.92 87.5699 135.99C81.7199 136.22 77.8799 131.54 76.1899 129.85C70.2799 123.91 64.8599 121.71 66.0199 105.18C66.9399 92.18 75.1299 78.96 83.2799 78.67V78.68Z"
        fill="#F7D4AB"
      />
      <path
        d="M83.6199 111.92C83.0899 105.35 83.3599 99.7201 76.4299 98.4001C69.9599 97.1601 67.9799 101.22 67.3899 102.19C65.8499 104.69 65.9699 111.07 65.9699 111.07C65.9699 111.07 72.4399 116.88 83.6299 111.92H83.6199Z"
        fill="url(#paint542_linear_2072_10275)"
      />
      <path
        d="M79.7099 116.03C78.9999 119.79 76.7199 123.02 73.6299 124.34C69.5899 126.07 66.6299 120.48 65.9299 113.56C65.5399 109.75 70.6799 106.94 73.9299 107.65C77.1899 108.36 80.4199 112.28 79.7099 116.03Z"
        fill="url(#paint543_radial_2072_10275)"
      />
      <path
        d="M88.9999 112.55C89.7799 107.34 88.4399 99.39 97.5999 98.68C100.46 98.46 102.77 99.31 104.24 100.5C107.68 103.27 105.68 110.57 105.68 110.57C105.68 110.57 100.32 117.33 88.9999 112.55Z"
        fill="url(#paint544_linear_2072_10275)"
      />
      <path
        d="M93.8199 116.08C94.5799 119.29 96.7599 125.03 99.7999 124.54C103.73 123.91 106.68 121.59 106.81 113.75C106.87 110.42 102.16 108.04 99.1799 108.85C96.1999 109.67 93.0599 112.86 93.8199 116.09V116.08Z"
        fill="url(#paint545_radial_2072_10275)"
      />
      <path
        d="M70.1099 111.14C71.2199 111.44 71.9899 112.21 71.8399 112.85C71.6899 113.49 70.6699 113.78 69.5699 113.49C68.4699 113.19 67.6899 112.42 67.8399 111.78C67.9899 111.14 69.0099 110.85 70.1199 111.14H70.1099Z"
        fill="url(#paint546_linear_2072_10275)"
      />
      <path
        d="M103.32 111.26C104.43 111.03 105.42 111.37 105.54 112.02C105.65 112.68 104.85 113.39 103.75 113.62C102.64 113.85 101.65 113.51 101.53 112.86C101.42 112.2 102.22 111.49 103.33 111.26H103.32Z"
        fill="url(#paint547_linear_2072_10275)"
      />
      <path
        d="M96.6499 121.45C97.1999 121.27 97.4899 120.83 97.2699 120.4C97.0699 120.02 94.7899 121.65 93.9099 122.93C95.0999 122.04 96.1099 121.63 96.6499 121.45Z"
        fill="url(#paint548_linear_2072_10275)"
      />
      <path
        d="M76.3899 121.28C75.8599 121.06 75.5899 120.6 75.8499 120.2C76.0799 119.84 78.2399 121.63 79.0199 122.97C77.8899 122 76.9199 121.51 76.3899 121.29V121.28Z"
        fill="url(#paint549_linear_2072_10275)"
      />
      <path
        d="M91.7899 125.74C90.7699 127.95 85.1199 131.03 80.9599 125.68C80.9599 125.68 86.8699 128.35 91.7899 125.74Z"
        fill="#F0C499"
      />
      <path
        d="M87.0299 121.97C92.3399 121.91 95.4399 121.1 96.6899 120.84C96.6599 120.9 96.6299 120.93 96.5999 120.99C95.9299 121.29 95.1699 121.48 94.1899 122.19C93.5199 122.68 92.8599 125.96 86.2499 125.89C82.6499 125.85 80.4599 124.6 78.3299 122.12C77.6699 121.34 77.0299 121.11 76.5099 120.8C76.4999 120.74 76.4699 120.71 76.4499 120.65C77.8899 121.06 80.7999 122.05 87.0199 121.98L87.0299 121.97Z"
        fill="#961B27"
      />
      <path
        d="M81.0799 122.55C84.7799 123.39 89.8299 123.29 91.6599 122.95C92.7199 122.48 92.6099 123.84 92.6099 123.84C90.2799 126.23 88.4299 125.78 86.5499 125.83C84.7099 125.88 81.9599 125.13 80.3199 123.66C80.1599 123.22 80.5599 122.43 81.0699 122.54H81.0799V122.55Z"
        fill="url(#paint550_linear_2072_10275)"
      />
      <path
        d="M79.4399 121.16C79.4399 121.16 80.6399 121.75 83.4899 122.06C86.3499 122.37 87.5599 122.2 90.1399 122.07C91.3199 122.01 92.0399 121.84 93.5199 121.48C93.5199 121.48 93.2499 121.82 93.0699 122.22C92.8399 122.74 91.7299 124.51 86.4099 124.44C82.4099 124.38 80.2999 122.95 80.0199 122.08C79.8499 121.56 79.4699 121.32 79.4499 121.15H79.4399V121.16Z"
        fill="url(#paint551_linear_2072_10275)"
      />
      <path
        d="M85.8999 125.64C94.0199 125.64 91.2099 122.29 96.5999 120.98C96.5699 120.98 95.3599 121.64 93.9299 123.3C92.3599 125.13 91.0099 128.01 86.4499 127.96C82.3499 127.92 80.0799 124.9 78.7699 123.25C77.2699 121.35 76.5199 120.79 76.4899 120.79C80.8999 122.01 79.4299 125.44 85.8899 125.65L85.8999 125.64Z"
        fill="#F86D78"
      />
      <path
        d="M90.7099 124.89C91.9599 124.25 93.0699 122.88 93.3099 122.7C93.0099 123.1 91.2499 127.43 86.6799 127.33C81.3899 127.21 80.4399 123.64 79.4999 122.57C79.9499 123.04 81.0699 124.32 82.4399 124.8C83.3499 125.12 84.8799 125.49 86.5899 125.57C87.6799 125.62 89.4999 125.4 90.7099 124.88V124.89Z"
        fill="url(#paint552_linear_2072_10275)"
      />
      <path
        d="M82.5999 125.34C82.5299 125.52 83.0299 126.15 84.1099 126.46C85.4999 126.85 86.5899 126.48 86.6699 126.29C86.7399 126.11 84.9099 125.98 84.3599 125.79C83.8299 125.61 82.6599 125.17 82.5999 125.35V125.34Z"
        fill="#FF9AA2"
      />
      <path
        d="M96.5199 121.3C96.1999 121.44 95.9499 121.21 94.6799 121.67C94.6799 121.67 96.8499 120.53 96.9899 120.6C97.0899 120.65 96.9899 121.09 96.5199 121.31V121.3Z"
        fill="#961B27"
      />
      <path
        d="M76.4899 121.11C76.8099 121.27 77.1599 121.03 78.2799 121.54C78.2799 121.54 76.2099 120.29 76.0399 120.4C75.9499 120.46 76.0299 120.89 76.4899 121.11Z"
        fill="#961B27"
      />
      <path
        d="M93.3999 121.62L93.0499 122.26C93.0499 122.26 90.7399 123.5 86.0199 123.49C82.6099 123.48 80.0299 122.17 80.0299 122.17L79.7699 121.54L93.4099 121.63L93.3999 121.62Z"
        fill="url(#paint553_linear_2072_10275)"
      />
      <path
        d="M83.4699 121.15C85.0499 121.02 85.2199 121.29 86.3599 121.3C87.4599 121.3 88.3599 120.98 89.7199 121.1C91.4999 121.26 93.6699 121.4 96.2599 120.86C96.2599 120.86 95.2999 121.46 90.5399 122.38C89.1199 122.66 87.8699 122.93 86.4099 122.9C84.6599 122.9 83.2199 122.54 81.8699 122.31C79.5799 121.92 76.8799 120.77 76.8699 120.72C78.0899 121.07 81.7299 121.28 83.4699 121.16V121.15Z"
        fill="#F86D78"
      />
      <path
        d="M91.5999 121.62C91.5499 121.46 89.1899 121.24 88.7999 121.24C88.4099 121.24 87.1199 121.47 86.6499 121.47C86.1799 121.47 84.7599 121.38 84.3699 121.29C83.9799 121.2 81.1099 121.45 81.1299 121.66C81.1599 121.87 85.3299 122.37 85.8199 122.42C86.3099 122.47 91.7299 122.12 91.5899 121.63L91.5999 121.62Z"
        fill="url(#paint554_linear_2072_10275)"
      />
      <path
        d="M86.5199 130.53C88.0599 130.41 89.3699 130.79 89.4399 131.37C89.5199 131.95 88.3199 132.51 86.7799 132.62C85.2399 132.73 83.9399 132.36 83.8599 131.78C83.7799 131.2 84.9799 130.64 86.5199 130.53Z"
        fill="url(#paint555_linear_2072_10275)"
      />
      <path
        d="M105.78 109.31C105.78 109.31 108.16 120.27 100.27 126.41C96.5699 129.3 95.5099 131.02 93.5299 132.96C93.5299 132.96 98.4399 128.59 101.4 126.47C102.83 125.45 109.91 120.43 105.79 109.31H105.78Z"
        fill="#F0C499"
      />
      <path
        d="M92.7399 133.66C92.7399 133.66 87.9099 140.53 79.9099 133.36C79.9099 133.36 86.3399 138.75 92.7399 133.66Z"
        fill="url(#paint556_linear_2072_10275)"
      />
      <path
        d="M65.5999 113.08C65.5999 113.08 65.6899 102.4 67.6399 95.2401C69.8099 87.2201 73.0499 80.9701 79.5099 79.5201C79.5099 79.5201 96.9999 74.3501 102.75 88.8501C108.83 104.17 107.52 112.07 107.13 115.65C107.13 115.65 105.72 106.82 103.87 104.09C103.87 104.09 98.2999 99.0601 94.1099 92.4601C85.7199 79.2401 77.3299 81.3201 74.4999 85.5301C69.9099 92.3701 67.8999 101.92 65.6099 113.06L65.5999 113.08Z"
        fill="#F0C499"
      />
      <path
        d="M66.0699 108.63C66.8799 115.27 67.1099 120.31 67.1099 120.31C64.4799 120.31 63.9499 117.47 62.9299 114.96C61.3499 111.13 60.4299 107.02 64.0099 106.8C64.6999 106.76 66.0699 108.63 66.0699 108.63Z"
        fill="#F0C499"
      />
      <path
        d="M65.5999 118.09C65.5999 118.09 64.3099 116.62 64.6999 113.73C65.6399 106.91 61.3499 106.44 62.3199 111.1C62.3199 111.1 62.9099 108.9 63.4599 109.56C64.1299 110.37 62.7399 110.81 63.4599 114.34C63.8299 116.17 65.5999 118.1 65.5999 118.1V118.09Z"
        fill="url(#paint557_linear_2072_10275)"
      />
      <path
        d="M74.4599 98.0201C74.4599 98.0201 71.9199 96.9001 67.9599 99.4101C65.6499 100.87 67.0999 107.4 67.0999 107.4C67.0999 107.4 66.6499 99.1101 74.4499 98.0201H74.4599Z"
        fill="#F7D4AB"
      />
      <path
        d="M66.8999 98.1001C66.8999 98.1001 66.2199 108.65 65.6999 111.17L65.2999 107.39C65.2999 107.39 66.3199 99.4201 66.9099 98.1001H66.8999Z"
        fill="url(#paint558_linear_2072_10275)"
      />
      <path
        d="M106.62 100.25C106.62 100.25 106.94 108.2 107.64 111.17L108.28 105.82L106.62 100.25Z"
        fill="url(#paint559_linear_2072_10275)"
      />
      <path
        d="M116.29 88.1599C105.63 65.1099 85.7199 63.8999 78.1199 71.3399C77.6999 73.7199 76.8399 77.2899 80.9199 80.5499C90.0799 73.2599 94.7899 92.4599 102.83 97.2699C108.74 100.81 111.78 109.91 120.39 120.72C122.84 106.07 118.29 92.4499 116.31 88.1699H116.3L116.29 88.1599Z"
        fill="url(#paint560_linear_2072_10275)"
      />
      <path
        d="M120.02 111.34C119.38 106.1 118.19 96.99 106.2 83.27C100.42 76.72 92.8799 71.99 86.6199 72.81C83.5699 73.16 81.5399 74.78 80.5299 75.99C79.4699 77.2 78.8399 78.1 78.8099 78.12C78.9599 78.02 81.9699 75.12 86.6199 75.96C91.1799 76.7 96.4299 81.47 101.66 87.28C112.1 98.78 120.22 111.05 120.03 111.33L120.02 111.34Z"
        fill="url(#paint561_linear_2072_10275)"
      />
      <path
        d="M57.5299 94.59C57.5299 94.67 60.7599 88.69 66.5299 82.58C69.3599 79.59 72.3999 77.51 74.9199 77.29C77.4299 77.02 78.7299 78.07 78.8199 78.13C78.7099 78.02 77.7899 76.53 74.9199 76.23C72.0599 75.9 68.2999 77.81 65.3699 80.87C59.4399 87 57.5399 94.63 57.5399 94.59H57.5299Z"
        fill="url(#paint562_linear_2072_10275)"
      />
      <path
        d="M78.4199 70.93C78.4199 70.93 71.3699 69.97 63.9699 76.55C58.7599 81.18 55.5399 89.99 55.2899 99.26C55.2899 99.26 57.2199 85.94 64.3499 78.34C68.3099 74.11 75.4899 71.23 78.4599 71.65C78.4599 71.65 86.3999 66.92 96.8599 70.03C105.65 72.63 116.97 81.54 120.68 105.1C120.68 105.1 117.77 68.41 89.6799 67.05C82.5499 66.71 78.4199 70.93 78.4199 70.93H78.4099H78.4199Z"
        fill="url(#paint563_linear_2072_10275)"
      />
      <path
        d="M65.7599 111.63C65.7599 111.63 66.6199 108.65 68.5599 107.7C64.0899 114.58 68.7599 122.15 72.3799 125.64C76.3699 129.49 78.0199 131.68 78.6599 132.33C78.0899 131.79 72.7699 126.81 71.2499 125.66C69.8399 124.6 64.4199 118.85 65.7699 111.64L65.7599 111.63Z"
        fill="url(#paint564_linear_2072_10275)"
      />
      <path
        d="M78.6099 98.55C80.2199 99.31 81.3799 101.45 79.9699 100.99C78.5699 100.52 73.4099 98.55 72.2799 98.53C70.5299 98.49 67.9399 99.42 67.2599 99.84C67.2599 99.84 70.3899 97.39 72.3299 97.19C74.2499 96.99 77.7499 98.15 78.6099 98.55Z"
        fill="url(#paint565_linear_2072_10275)"
      />
      <path
        d="M94.5699 98.54C95.4599 98.17 99.2699 97.01 101.18 97.3C103.1 97.6 106.11 100.22 106.11 100.22C105.45 99.76 102.75 98.59 101.16 98.63C100.03 98.66 94.7799 100.37 93.3699 100.77C91.9499 101.17 92.9299 99.23 94.5699 98.54Z"
        fill="url(#paint566_linear_2072_10275)"
      />
      <path
        d="M99.3199 102.14C100.88 102.27 104.2 102.84 104.15 105.8C104.09 109.54 100.24 110.43 98.5099 110.44C96.3199 110.46 94.7899 109.82 93.4999 109.41C92.5399 109.11 92.0299 109.02 91.5299 108.91C91.6699 106.04 92.8499 102.13 99.3099 102.13L99.3199 102.14Z"
        fill="url(#paint567_linear_2072_10275)"
      />
      <path
        d="M95.4899 104.4C94.8299 105.01 94.0699 106.11 94.0199 107.13C93.9599 108.3 94.3999 108.94 95.1699 109.65C94.1899 109.38 93.2499 108.89 91.8399 108.69C91.8399 108.69 93.1999 105.77 95.4999 104.4H95.4899Z"
        fill="url(#paint568_linear_2072_10275)"
      />
      <path
        d="M95.2999 104.82C94.6599 105.31 94.2199 106.01 94.0799 106.8C92.9499 107.47 92.2399 108.28 91.8399 108.68C91.8399 108.68 93.2099 105.84 95.3099 104.82H95.2999Z"
        fill="#DDDDDD"
      />
      <path
        d="M98.1599 103.81C99.7499 103.95 101.68 104.77 104.02 106.72C104.02 106.72 102.69 109.52 98.9199 110.02C99.8099 109.43 100.44 108.67 100.5 107.45C100.58 105.77 99.5899 104.29 98.1699 103.8L98.1599 103.81Z"
        fill="url(#paint569_linear_2072_10275)"
      />
      <path
        d="M94.0799 106.72C96.3199 105.19 98.7399 105.18 100.58 105.81C100.83 106.33 100.95 106.91 100.92 107.52C100.85 108.69 100.18 109.43 99.2599 110.01C97.8199 110.25 95.4499 109.77 95.1799 109.64C94.3799 108.96 93.9399 108.25 94.0299 107.12C94.0399 106.96 94.0599 106.86 94.0899 106.72H94.0799Z"
        fill="url(#paint570_linear_2072_10275)"
      />
      <path
        d="M103.41 106.81L102.96 107.64C102.96 107.64 102.1 106.92 100.77 106.36C100.52 105.58 99.9699 104.92 99.2399 104.52C100.92 104.84 102.49 105.64 103.41 106.81Z"
        fill="#DDDDDD"
      />
      <path
        d="M95.2999 104.82C95.5799 104.68 95.8899 104.57 96.1999 104.51C97.1799 104.31 98.2199 104.33 99.2399 104.52C99.9599 104.92 100.56 105.57 100.79 106.37C99.8099 105.96 98.5799 105.63 97.2699 105.76C95.9599 105.89 94.8899 106.3 94.0599 106.81C94.1799 106.02 94.6599 105.33 95.2999 104.83V104.82Z"
        fill="url(#paint571_linear_2072_10275)"
      />
      <path
        d="M97.5699 104.74C98.7599 104.83 99.6599 105.84 99.5799 107.01C99.4899 108.17 98.4499 109.05 97.2599 108.95C96.0699 108.86 95.1699 107.85 95.2599 106.68C95.3399 105.52 96.3899 104.64 97.5799 104.74H97.5699Z"
        fill="url(#paint572_radial_2072_10275)"
      />
      <path
        d="M96.9699 106.03C97.2599 105.88 97.6199 106.01 97.7699 106.31C97.9199 106.62 97.7999 106.99 97.5099 107.14C97.2199 107.29 96.8599 107.16 96.7099 106.85C96.5599 106.54 96.6799 106.17 96.9699 106.02V106.03Z"
        fill="white"
      />
      <path
        d="M94.9799 106.86C95.3799 106.65 95.8799 106.82 96.0699 107.22C96.2699 107.62 96.0999 108.11 95.6999 108.31C95.2999 108.51 94.8099 108.35 94.5999 107.94C94.3999 107.54 94.5699 107.05 94.9699 106.86H94.9799Z"
        fill="white"
      />
      <path
        d="M101.64 103.93C103.66 104.95 105.44 104.07 105.47 104.05C105.46 104.13 105.73 106.43 104.08 107.01C104.08 107.04 104.06 107.13 104.02 107.25C104.74 107.19 104.93 107.59 105.12 107.8C105.12 107.81 104.44 107.43 102.95 108.53C101.98 109.24 100.44 110.02 98.8299 110.07C101.02 109.22 102.08 108.7 103.22 106.92C101.44 105.4 99.2999 104.81 97.1999 104.93C94.1499 105.1 91.8399 108.69 91.8399 108.69C92.8299 104.79 95.8999 101.61 101.65 103.94L101.64 103.93Z"
        fill="url(#paint573_linear_2072_10275)"
      />
      <path
        d="M95.9299 102.47C98.0399 101.74 100.15 102.07 101.75 102.64C101.75 102.64 98.3499 102 96.0699 102.87C93.7799 103.75 92.8499 104.72 92.8499 104.72C92.8499 104.72 93.8299 103.19 95.9399 102.46L95.9299 102.47Z"
        fill="url(#paint574_linear_2072_10275)"
      />
      <path
        d="M96.7899 104.6C101.74 104.09 103.23 106.91 103.23 106.91C102.01 105.94 99.7599 104.67 96.9499 104.94C94.1399 105.21 91.8499 108.68 91.8499 108.68C91.8499 108.68 93.0999 104.97 96.7899 104.59V104.6Z"
        fill="#391B13"
      />
      <path
        d="M90.6899 117.26C90.6899 117.26 87.2699 119.56 86.5099 119.46C85.7499 119.36 82.5699 117.26 82.5699 117.26H90.6899Z"
        fill="url(#paint575_linear_2072_10275)"
      />
      <path
        d="M86.6099 113.84C88.7699 113.9 89.3799 114.45 89.2099 115.03C88.8199 116.44 87.9099 116.71 86.5599 116.7C85.1399 116.7 84.0399 116.38 83.8199 114.86C83.7599 114.41 84.4399 113.78 86.5999 113.84H86.6099Z"
        fill="url(#paint576_linear_2072_10275)"
      />
      <path
        d="M85.1599 117.63C85.1599 117.63 82.9099 115.93 82.4799 116.38C81.1999 117.7 85.1599 117.63 85.1599 117.63Z"
        fill="url(#paint577_linear_2072_10275)"
      />
      <path
        d="M87.8199 117.63C87.8199 117.63 90.2099 116.16 90.6699 116.56C91.9899 117.69 87.8199 117.63 87.8199 117.63Z"
        fill="url(#paint578_linear_2072_10275)"
      />
      <path
        d="M90.6899 117.26C90.6899 117.26 90.9199 116.67 90.0199 116.74C89.3699 116.78 88.8499 118.18 86.5299 118.11C84.0499 118.04 83.7099 116.79 83.0799 116.75C82.4999 116.72 82.5599 117.27 82.5599 117.27C82.5599 117.27 81.3899 116.66 81.8299 116.12C82.6399 115.12 82.8799 117.17 86.5799 117.12C90.5899 117.06 91.0499 115.08 91.5999 116.35C91.8299 116.87 91.3999 117.02 90.6899 117.28V117.26Z"
        fill="#F0C499"
      />
      <path
        d="M74.1299 101.92C80.5999 101.92 81.7699 105.81 81.9099 108.7C81.4199 108.81 80.9099 108.91 79.9399 109.2C78.6399 109.6 77.1199 110.25 74.9299 110.23C73.1999 110.22 69.3399 109.32 69.2899 105.59C69.2499 102.63 72.5599 102.06 74.1199 101.93L74.1299 101.92Z"
        fill="url(#paint579_linear_2072_10275)"
      />
      <path
        d="M81.6099 108.46C80.1999 108.67 79.2599 109.15 78.2799 109.42C79.0399 108.71 79.4799 108.07 79.4299 106.9C79.3699 105.89 78.6099 104.78 77.9599 104.17C80.2399 105.53 81.6199 108.46 81.6199 108.46H81.6099Z"
        fill="url(#paint580_linear_2072_10275)"
      />
      <path
        d="M81.6099 108.46C81.2099 108.06 80.4799 107.25 79.3699 106.58C79.2199 105.79 78.7799 105.1 78.1499 104.6C80.2399 105.62 81.6199 108.46 81.6199 108.46H81.6099Z"
        fill="#DDDDDD"
      />
      <path
        d="M72.9499 107.23C73.0099 108.45 73.6399 109.21 74.5299 109.8C70.7599 109.31 69.4299 106.5 69.4299 106.5C71.7599 104.55 73.6899 103.73 75.2899 103.59C73.8699 104.07 72.8699 105.56 72.9599 107.24L72.9499 107.23Z"
        fill="url(#paint581_linear_2072_10275)"
      />
      <path
        d="M79.3699 106.49C79.3999 106.63 79.4099 106.74 79.4299 106.89C79.5099 108.02 79.0799 108.72 78.2799 109.41C78.0199 109.54 75.6499 110.03 74.1999 109.78C73.2699 109.2 72.6099 108.48 72.5399 107.3C72.5099 106.69 72.6299 106.1 72.8799 105.59C74.7099 104.95 77.1299 104.97 79.3799 106.5L79.3699 106.49Z"
        fill="url(#paint582_linear_2072_10275)"
      />
      <path
        d="M74.1999 104.3C73.4799 104.7 72.9299 105.36 72.6699 106.14C71.3499 106.69 70.4799 107.42 70.4799 107.42L70.0299 106.59C70.9499 105.42 72.5199 104.62 74.1999 104.3Z"
        fill="#DDDDDD"
      />
      <path
        d="M74.1999 104.3C75.2099 104.1 76.2699 104.1 77.2399 104.29C77.5599 104.35 77.8499 104.46 78.1399 104.6C78.7799 105.09 79.2599 105.78 79.3799 106.58C78.5499 106.09 77.4799 105.66 76.1699 105.53C74.8599 105.4 73.6299 105.74 72.6499 106.14C72.8799 105.35 73.4699 104.7 74.1999 104.29V104.3Z"
        fill="url(#paint583_linear_2072_10275)"
      />
      <path
        d="M75.8799 104.51C77.0699 104.42 78.1199 105.29 78.1999 106.45C78.2899 107.61 77.3899 108.63 76.1999 108.72C75.0099 108.81 73.9599 107.94 73.8799 106.78C73.7899 105.62 74.6899 104.6 75.8899 104.51H75.8799Z"
        fill="url(#paint584_radial_2072_10275)"
      />
      <path
        d="M75.5099 105.75C75.7899 105.59 76.1699 105.69 76.3399 105.98C76.5199 106.28 76.4299 106.65 76.1499 106.81C75.8699 106.97 75.4899 106.87 75.3199 106.58C75.1399 106.28 75.2299 105.92 75.5199 105.75H75.5099Z"
        fill="white"
      />
      <path
        d="M73.5499 106.64C73.9399 106.41 74.4399 106.54 74.6499 106.92C74.8799 107.31 74.7399 107.81 74.3499 108.04C73.9599 108.27 73.4599 108.14 73.2499 107.76C73.0199 107.38 73.1599 106.87 73.5499 106.64Z"
        fill="white"
      />
      <path
        d="M67.9799 103.82C67.9799 103.82 69.7999 104.73 71.8099 103.7C77.5599 101.36 80.6299 104.54 81.6199 108.45C81.6199 108.45 79.2999 104.86 76.2599 104.69C74.1499 104.57 72.0199 105.16 70.2399 106.68C71.3799 108.46 72.4399 108.98 74.6299 109.83C73.0299 109.77 71.4699 108.99 70.5099 108.29C69.0199 107.2 68.3399 107.58 68.3399 107.56C68.5399 107.36 68.7199 106.96 69.4399 107.01C69.4099 106.88 69.3899 106.8 69.3799 106.77C67.7199 106.18 68.0099 103.9 67.9899 103.81L67.9799 103.82Z"
        fill="url(#paint585_linear_2072_10275)"
      />
      <path
        d="M77.5199 102.24C79.6199 102.97 80.6099 104.5 80.6099 104.5C80.6099 104.5 79.6799 103.53 77.3899 102.65C75.0999 101.77 71.7099 102.42 71.7099 102.42C73.3099 101.86 75.4199 101.53 77.5299 102.25L77.5199 102.24Z"
        fill="url(#paint586_linear_2072_10275)"
      />
      <path
        d="M76.6599 104.37C80.3499 104.75 81.5999 108.46 81.5999 108.46C81.5999 108.46 79.2999 104.99 76.4999 104.72C73.6899 104.45 71.4499 105.72 70.2199 106.69C70.2199 106.69 71.6999 103.87 76.6499 104.38L76.6599 104.37Z"
        fill="#391B13"
      />
      <path
        d="M80.5399 179.83C81.8499 185.94 84.6899 192.96 90.9099 197.31C88.9899 196.76 87.1899 195.78 85.5399 194.36C82.4499 191.72 80.7099 188.35 80.3299 184.27C80.1799 182.73 80.2499 181.24 80.5299 179.83H80.5399Z"
        fill="white"
      />
      <path
        d="M103.78 170.08C100.83 169.42 98.2399 168.49 96.1199 167.33C98.9099 167.46 101.46 168.37 103.78 170.08Z"
        fill="white"
      />
      <path
        d="M91.2099 167.74C89.4499 169.18 87.2299 170.49 84.6499 171.64C86.4999 169.69 88.6899 168.4 91.2099 167.74Z"
        fill="white"
      />
      <path
        d="M108.83 176.22C109.5 177.71 109.93 179.33 110.09 181.1C110.47 185.19 109.38 188.81 106.82 191.98C105.33 193.82 103.59 195.18 101.63 196.08C107.28 190.48 108.74 182.64 108.83 176.21V176.22Z"
        fill="white"
      />
      <path
        d="M82.0699 179.59C81.6699 177.75 81.4199 176 81.2699 174.47C82.8499 173.99 84.2999 173.42 85.6799 172.82C88.0199 171.78 90.0399 170.58 91.6599 169.27C92.3199 168.73 92.9299 168.18 93.4399 167.6L93.7199 167.57C94.3099 168.02 94.9899 168.44 95.7199 168.84C97.6499 169.9 100.01 170.75 102.7 171.35C104.04 171.65 105.45 171.89 106.94 172.05C107.05 173.44 107.13 175.02 107.1 176.71C107.02 182.57 105.68 189.7 100.54 194.8C99.3599 195.97 97.9999 197.06 96.3699 197.96C94.5299 197.34 92.9299 196.48 91.5099 195.49C85.8299 191.53 83.2499 185.14 82.0599 179.58L82.0699 179.59ZM92.0199 192.56C92.6999 193.05 93.4199 193.47 94.1699 193.85C94.5699 194.05 94.9799 194.22 95.3899 194.38C95.5799 194.46 95.8599 194.61 96.0699 194.6C96.2599 194.58 96.5099 194.37 96.6699 194.28C98.0999 193.4 99.4099 192.28 100.47 190.97C100.67 190.72 100.87 190.47 101.05 190.21C102.64 187.97 103.59 185.32 104.06 182.62C104.21 181.74 104.32 180.86 104.38 179.97C104.5 178.22 104.47 176.45 104.32 174.69C104.31 174.56 104.21 174.44 104.08 174.43C103.12 174.32 102.16 174.17 101.22 173.97C100.5 173.82 99.7999 173.65 99.0999 173.43C98.4499 173.23 97.8099 173 97.1799 172.75C97.0899 172.72 96.9999 172.68 96.9199 172.64C96.3199 172.38 95.7299 172.08 95.1599 171.73C94.9099 171.58 94.6599 171.41 94.4199 171.24C94.2799 171.14 94.1699 171.03 93.9999 171.03C93.9399 171.03 93.8599 171.04 93.7999 171.05C93.7099 171.05 93.6499 171.1 93.5999 171.15C93.1699 171.63 92.6899 172.07 92.1799 172.47C89.9399 174.25 87.2399 175.41 84.5299 176.25C84.4099 176.28 84.3299 176.43 84.3399 176.55C84.3699 176.83 84.3999 177.1 84.4299 177.38C84.6499 179.16 84.9899 180.94 85.4999 182.66C85.7599 183.56 86.0699 184.44 86.4399 185.29C87.2899 187.29 88.4499 189.17 89.9399 190.74C90.5799 191.41 91.2699 192.02 92.0299 192.56H92.0199Z"
        fill="white"
      />
      <path
        d="M115.09 148.48C115.09 148.48 118.67 150.57 121.56 154.52C125.47 159.86 145.9 196.67 146.08 197C147.03 198.73 143.74 217.52 140.33 218.2C136.91 218.87 110.93 181.49 106.38 163.48C101.43 143.91 115.1 148.48 115.1 148.48H115.09Z"
        fill="#F7D4AB"
      />
      <path
        d="M145.97 196.76C145.97 196.76 139.65 211.52 162.88 194.69L145.97 196.76Z"
        fill="url(#paint587_linear_2072_10275)"
      />
      <path
        d="M124.3 171.35C124.3 171.35 122.31 166.86 117.73 156.93C117.52 156.48 122.63 174.36 122.63 174.36L124.3 171.34V171.35Z"
        fill="url(#paint588_linear_2072_10275)"
      />
      <path
        d="M49.9299 182.62C51.1699 183.33 51.6599 184.15 52.5699 185.28C54.5399 187.71 59.0599 186.2 60.3099 181.38C61.2499 177.76 60.6699 156.8 54.1399 152.07C54.1399 152.07 49.7699 152.78 46.7699 154.77C38.3999 160.34 20.3099 183.79 19.1399 185.15C17.9699 186.51 0.0399357 206.07 1.21994 213.67C2.04994 219.01 17.9999 227.59 21.8599 230.46C25.7099 233.33 47.5899 245.52 47.5899 245.52L50.6499 237.62C50.6499 237.62 29.1999 220.67 21.6599 209.44C21.6599 209.44 47.0199 185.92 49.9499 182.61H49.9399L49.9299 182.62Z"
        fill="#F7D4AB"
      />
      <path
        d="M100.33 145.49C100.33 145.49 101.97 152.03 89.7299 153.12C73.5199 154.56 70.4599 147.52 70.4599 147.52L58.9599 150.41C58.9599 150.41 75.1199 165.29 92.6199 162.66C110.12 160.03 113.57 148.03 113.57 148.03L100.34 145.5L100.33 145.49Z"
        fill="url(#paint589_linear_2072_10275)"
      />
      <path
        d="M54.3399 260.63C61.1499 240.3 66.1799 227.88 66.8799 225.71C67.8599 222.62 67.2999 212.95 65.6599 209.23C63.8799 205.21 54.6499 188.7 54.6499 188.7L55.1199 182C57.3999 161.76 51.2499 154.35 48.5599 153.54C55.4199 150.86 69.9299 147.68 69.9299 147.68C72.7399 153.56 81.4499 154.8 90.8699 153.86C103.44 152.62 101.03 145.38 101.03 145.38L116.93 149.51C120.08 158.16 119.18 158.95 120.93 167.14C122.61 174.97 124.43 180.41 124.65 187.35C124.84 193.38 116.95 201.11 116.6 215.59C116.28 228.8 120.66 242.9 125.87 262.52C120.24 267.01 82.4599 271.01 54.3199 260.62H54.3299L54.3399 260.63Z"
        fill="#27AE60"
      />
      <path
        d="M122.77 174.86C122.77 174.86 127.69 190.05 111.86 191.46C100.18 192.51 74.3299 197.9 56.2699 172.85C56.2699 172.85 56.9699 175.87 54.8599 181.77C60.7099 194.15 80.1699 210.64 60.1199 242.54C101.4 225.29 117.27 228.24 117.8 227.53C117.62 225.49 114.56 212.08 120.4 201.17C128.23 186.54 122.78 174.84 122.78 174.84L122.77 174.86Z"
        fill="#27AE60"
      />
      <path
        d="M56.0099 171.29C56.0099 171.29 56.7599 182.38 51.5599 184.27C51.5599 184.27 58.1499 192.14 65.6699 210C66.4299 211.8 67.7699 221.29 66.8499 224.38C65.9299 227.47 62.2699 236.26 55.8499 256.1C57.8399 251.97 71.2199 221.39 73.3699 217.06C75.0199 213.75 72.1399 203.58 67.7999 196.16C63.4699 188.73 57.7699 179.14 55.9799 171.28H55.9899L56.0099 171.29Z"
        fill="url(#paint590_linear_2072_10275)"
      />
      <path
        d="M103.77 164.09C98.2499 163 80.9699 162.51 75.8599 166.6C70.7499 170.69 68.0099 179.99 79.6699 180.87C87.5999 181.47 101.97 182.04 114.04 179.56C122.38 177.84 118.8 167.07 103.77 164.09Z"
        fill="#34B769"
      />
      <path
        d="M119.9 161.63C119.9 161.63 124.41 179.26 124.7 180.69C125.03 182.29 126.81 185.9 123.17 196.6C120.23 205.23 117.66 206.86 117.08 214.54C116.24 225.54 121.46 246.07 121.46 246.07C121.46 246.07 109.41 220.78 108.87 212.05C108.47 205.68 121.42 206.38 123.28 185.08C123.77 179.5 119.35 163.46 119.9 161.63Z"
        fill="#27AE60"
      />
      <path
        d="M174.75 195.85L167.84 186.77L165.74 187.83L173.01 197.23L174.75 195.84V195.85Z"
        fill="url(#paint591_linear_2072_10275)"
      />
      <path
        d="M108.05 146.11C108.05 146.11 114.88 147.1 118.44 148.81C120.3 149.71 145.5 194.86 146.27 195.86C146.83 196.6 166.73 186.77 166.73 186.77L175.04 197.38C175.04 197.38 153.88 212.27 152.98 212.68C152.08 213.1 141 219.39 140.48 217.9C139.95 216.42 121.85 193.14 121.85 193.14C121.85 193.14 120.79 180.8 121.04 178.03C121.29 175.26 108.07 146.11 108.07 146.11H108.05Z"
        fill="url(#paint592_linear_2072_10275)"
      />
      <path
        d="M120.18 171.34C117.48 162.71 112.94 153.43 113.85 155.13C118.91 164.62 124.28 176.44 126.51 187.44C128.42 196.87 139.93 215.23 142.11 215.43C147.27 215.9 160.11 207.82 160.11 207.82C160.11 207.82 146.72 218.68 140.88 218.64C138.04 218.62 132.48 211.01 130.2 207.58C127.3 203.66 125.26 199.01 121.96 194.28C121.96 190.28 124.35 184.75 120.17 171.36L120.18 171.34Z"
        fill="url(#paint593_linear_2072_10275)"
      />
      <path
        d="M122.16 188.51C122.7 187.99 124.18 186.52 124.82 183.64C125.18 189.72 122.85 195.03 128.99 205.8C128.99 205.8 121.62 195.36 121.74 194.43C121.67 195.02 121.64 188.78 122.17 188.5L122.16 188.51Z"
        fill="url(#paint594_linear_2072_10275)"
      />
      <path
        d="M11.9299 217.55C8.6299 214.87 1.5099 211.69 5.2099 203.02C5.2099 203.02 0.129902 210.7 0.439902 213.19C0.789902 216.03 7.6399 221.67 13.1599 225.72C18.7099 229.8 48.5399 246.25 48.5399 246.25C48.5399 246.25 30.9199 232.99 11.9199 217.57L11.9299 217.55Z"
        fill="url(#paint595_linear_2072_10275)"
      />
      <path
        d="M75.4799 140.74C75.4799 140.74 67.7799 143.19 67.0999 148.27C66.1899 155.06 76.4099 183.04 76.9099 185.45C77.3999 187.86 79.2199 201.17 79.1499 203.13C79.0799 205.09 77.3799 234.1 76.9099 237.79C76.4399 241.48 75.9699 267.48 73.5399 268.35C67.4299 270.54 50.8199 273.6 50.8199 272.57C50.8199 262.4 55.8899 246.13 57.2699 238.52C57.8899 235.09 62.1599 212.33 61.6599 210.01C61.1599 207.7 55.8499 189.51 55.8499 189.51C55.8499 189.51 57.7599 170.85 56.6699 168.77C55.5799 166.7 47.3599 153.56 47.3599 153.56C47.3599 153.56 53.4999 149.31 73.9799 141.45L75.4899 140.74H75.4799Z"
        fill="url(#paint596_linear_2072_10275)"
      />
      <path
        d="M57.6799 184.38C55.5199 184.38 56.7999 192.22 56.7599 192.63C56.7599 192.63 60.3099 205 60.4599 205.54C60.6099 206.08 61.6599 210.01 61.6599 210.01C61.6599 210.01 57.8799 236.42 56.5499 241.94C56.5499 241.94 61.3699 228.86 62.4899 224.48C63.6099 220.11 65.3999 207.61 65.4799 206.05C65.5699 204.49 59.8299 184.36 57.6699 184.36L57.6799 184.38Z"
        fill="url(#paint597_linear_2072_10275)"
      />
      <path
        d="M69.9399 147.7L67.1099 148.28C67.1099 148.28 61.6699 158.29 66.4099 167.99C71.1499 177.69 75.9699 191.36 76.9699 194.18C77.9699 197.01 76.3199 234.21 76.3199 234.21L78.5499 234.66C78.5499 234.66 79.4599 225.11 79.7699 222.36C80.0799 219.61 82.1499 194.14 81.6899 191.35C81.2199 188.56 73.5999 165.84 71.1199 158.84C68.3099 150.92 69.9499 147.68 69.9499 147.68H69.9399V147.7Z"
        fill="#34B769"
      />
      <path
        d="M63.5399 146.46L56.9499 155.81L64.4099 156.73L56.6499 161.99C56.6499 161.99 69.8799 184.57 70.5999 185.93C71.3199 187.3 72.4499 190.85 72.9299 192.8C73.4199 194.74 74.7799 216.25 74.7799 216.25L76.6099 235.43L76.1399 207.04C76.1399 207.04 74.6099 187.21 72.5299 180.42C70.4399 173.63 63.5499 146.46 63.5499 146.46H63.5399Z"
        fill="url(#paint598_linear_2072_10275)"
      />
      <path
        d="M75.8299 139.87C75.8299 139.87 70.4899 141.76 65.7699 144.03C63.2499 145.25 56.6399 154.84 56.6399 154.84L64.3999 155.85L57.9099 160.6C57.9099 160.6 72.9699 186.09 73.9899 191.07C75.2299 197.06 76.0999 233.5 76.8599 238.25C76.8599 238.25 80.5499 195.41 79.8499 191.89C78.4899 185.1 72.4399 168.33 72.4399 168.33C72.4399 168.33 68.0299 156.31 67.7599 153.63C67.0399 146.54 71.8299 141.96 75.3999 140.8L75.8199 139.86L75.8299 139.87Z"
        fill="url(#paint599_linear_2072_10275)"
      />
      <path
        d="M75.8699 139.8C75.8699 139.8 75.8899 139.8 75.4699 140.75C75.2399 140.85 71.1999 142.94 69.5799 146.07C68.2599 148.61 67.5499 149.61 68.1199 153.86C68.4999 156.7 69.7499 160.63 69.7499 160.63C69.7499 160.63 66.7399 154.14 67.0999 150.77C67.4599 147.4 68.9499 142.32 75.1499 140.77L75.8699 139.8Z"
        fill="url(#paint600_linear_2072_10275)"
      />
      <path
        d="M52.5599 238.73C53.5699 239.5 53.7099 242.59 51.5699 241.07C45.1199 236.46 32.0499 224.36 31.2799 223.76C30.2199 222.93 16.3799 210.23 15.0999 209.4C13.8099 208.57 21.9399 207.11 30.3799 201.32L22.1299 209.51C22.1299 209.51 35.1999 225.73 52.5599 238.73Z"
        fill="url(#paint601_linear_2072_10275)"
      />
      <path
        d="M47.7599 153.38C47.7599 153.38 44.9299 153.87 29.9699 171.88C14.9999 189.9 -0.820091 206.45 0.429909 213.17C1.67991 219.89 36.4399 240.71 36.4399 240.71L44.5299 231.02C44.5299 231.02 25.4299 212.18 25.1099 211.44C24.7899 210.68 48.8499 183.02 50.1999 183.65C51.5499 184.27 56.7499 192.64 56.7499 192.64C56.7499 192.64 57.8699 169.94 57.8599 168.41C57.8499 166.87 47.7599 153.38 47.7599 153.38Z"
        fill="url(#paint602_linear_2072_10275)"
      />
      <path
        d="M106.29 146.41L101.71 145.58C101.71 145.58 104.61 148.77 106.12 151.5C107.64 154.23 119.27 183.78 119.36 186.34C119.45 188.92 114.09 218.43 113.85 220.18C113.61 221.93 114.63 233.24 114.63 233.24C114.63 233.24 117.72 232.16 118.14 231.69C118.14 231.69 118.45 216.51 118.42 215.13C118.39 213.76 123.92 187.06 123.28 185.09C122.64 183.11 106.28 146.41 106.28 146.41H106.29Z"
        fill="#34B769"
      />
      <path
        d="M59.4999 186.58C59.4999 186.58 54.0899 173.1 53.2699 174.4C39.6499 195.89 18.5199 209.38 18.5199 209.38L25.1199 211.44C25.1199 211.44 50.2399 182.39 50.8999 183.33C51.5599 184.28 56.7499 192.63 56.7499 192.63L59.4899 186.58H59.4999Z"
        fill="url(#paint603_linear_2072_10275)"
      />
      <path
        d="M120.25 199.69C120.25 199.69 115.18 219.29 115.03 220.75C114.89 222.21 120.12 265.43 121 266.44C122.3 267.93 128.15 268.41 128.15 268.41C128.15 268.41 121.55 217.61 121.72 216.16C121.9 214.7 123.57 189.92 123.57 189.92L120.25 199.69Z"
        fill="url(#paint604_linear_2072_10275)"
      />
      <path
        d="M116.2 152.64L117.73 153.87L113.05 154.92L121.5 157.51C121.5 157.51 123.16 166.79 123.72 170.03C124.27 173.27 126.95 182.92 126.95 182.92L123.16 197.13L121 193.71L122.6 175.72L111.05 150.61L116.21 152.62L116.2 152.64Z"
        fill="url(#paint605_linear_2072_10275)"
      />
      <path
        d="M96.4799 140.25C96.4799 140.25 99.1399 140.24 106.97 143.84C109.06 144.8 117.72 152.93 117.72 152.93L112.62 153.42L119.94 156.09C119.94 156.09 121.63 166.94 121.83 167.81C122.54 171.02 126.06 181.93 125.64 183.5C125.22 185.08 123.79 192.23 123.79 192.23L117.15 220.55L116.83 237.17C116.83 237.17 114.96 221.75 115.05 220.75C115.14 219.75 119.52 202.4 120.73 185.56C118.83 179.84 108.83 153.14 106.44 149.62C101.39 142.21 96.4899 140.25 96.4899 140.25H96.4799Z"
        fill="url(#paint606_linear_2072_10275)"
      />
      <path
        d="M113.81 166.88C113.81 166.88 108.17 152.96 107.55 151.75C104.97 146.68 100.89 143.87 99.6899 142.92C98.2399 141.78 96.4799 141.25 96.4799 141.25V140.25C96.4799 140.25 98.7899 141.02 100.29 142.03C100.84 142.41 105.59 145.26 108.36 151.12C111.43 157.61 113.82 166.88 113.82 166.88H113.81Z"
        fill="url(#paint607_linear_2072_10275)"
      />
      <path
        d="M102.18 145.66L101.04 145.4C101.04 145.4 101.7 148.83 99.6399 150.62C97.5799 152.41 91.9799 153.99 86.2599 154.14C80.3299 154.3 76.0999 153.11 73.5799 151.59C71.0599 150.07 69.9099 147.64 69.9099 147.64L68.7499 147.93C68.7499 147.93 70.0499 151.01 73.2999 152.58C76.5499 154.16 81.1999 156.22 89.1099 155.21C97.0099 154.2 99.0399 153.02 100.9 151.11C102.75 149.21 102.17 145.64 102.17 145.64L102.18 145.66Z"
        fill="url(#paint608_linear_2072_10275)"
      />
      <path
        d="M5.69991 201.31C5.69991 201.31 -0.480086 209.72 0.0299143 213.02C0.459914 215.8 5.31991 220.82 16.8499 228.27C28.4899 235.8 36.4499 240.72 36.4499 240.72L38.3499 238.45C38.3499 238.45 15.2799 222.18 11.7899 219.73C8.29991 217.28 0.329915 211.93 5.69991 201.33V201.31Z"
        fill="url(#paint609_linear_2072_10275)"
      />
      <path
        d="M44.5399 231.02C44.5399 231.02 25.6299 212.33 25.1199 211.44C25.1199 211.44 20.2199 208.42 18.1699 209.52C16.1199 210.61 42.3699 233.63 42.3699 233.63L44.5399 231.03V231.02Z"
        fill="url(#paint610_linear_2072_10275)"
      />
      <path
        d="M50.1699 163.91C53.1799 157.95 50.1999 151.66 45.9199 154.61C41.6299 157.57 26.7199 173.08 16.4099 195.48C13.4699 201.89 21.2299 205.58 31.7399 191.18C42.9499 175.81 47.4599 169.27 50.1799 163.91H50.1699Z"
        fill="url(#paint611_linear_2072_10275)"
      />
      <path
        d="M169.16 189.9L166.71 186.77C166.71 186.77 148.17 195.76 146.25 195.86C145.88 199.09 146.63 204.31 149.5 202.72C155.52 199.42 169.16 189.88 169.16 189.88H169.15L169.16 189.9Z"
        fill="url(#paint612_linear_2072_10275)"
      />
      <path
        d="M124.62 158.35C124.62 158.35 119.72 149.8 118.59 148.88C117.47 147.96 112.05 146.85 112.05 146.85C112.05 146.85 116.9 149.45 117.73 150.05C118.57 150.65 124.63 158.35 124.63 158.35H124.62Z"
        fill="url(#paint613_linear_2072_10275)"
      />
      <path
        d="M57.3799 127.19C51.7699 101.66 65.5999 86.48 68.2999 82.83C71.2799 78.8 76.6899 75.19 80.0699 79.94C80.0699 79.94 77.2699 78.57 73.6699 81.71C58.2399 100.51 60.4899 112.2 64.0599 126.7C67.6699 141.37 76.8799 144.17 67.7999 161.79C71.2899 140.37 61.3099 145.01 57.3899 127.19H57.3799Z"
        fill="url(#paint614_linear_2072_10275)"
      />
      <path
        d="M60.1099 106.69C60.1099 106.69 58.3299 116.01 59.3699 125.01C60.3999 133.97 67.2899 139.44 67.2899 139.44C67.2899 139.44 62.5999 133.96 60.9699 123.46C60.3199 119.26 60.0899 106.7 60.0899 106.7L60.1099 106.69Z"
        fill="url(#paint615_linear_2072_10275)"
      />
      <path
        d="M107.57 140.01C128.61 118.16 106.49 100.87 97.3199 89.9899C94.3699 86.4899 89.4699 76.2499 82.7399 78.0799C81.0099 78.5499 80.1199 79.8999 80.0099 79.9999C80.0699 79.9599 81.5199 79.1499 83.3299 79.2899C85.3199 79.4399 86.5799 80.3599 88.6999 82.9499C90.8899 85.4899 92.3599 87.9999 94.9799 91.8699C105.06 106.76 120.07 116.99 107.57 140.02V140.01Z"
        fill="url(#paint616_linear_2072_10275)"
      />
      <path
        d="M110.15 350.37L105.71 371.38L89.9899 366.9L95.7999 347.61L110.16 350.36L110.15 350.37Z"
        fill="url(#paint617_linear_2072_10275)"
      />
      <path
        d="M105.73 375.42C105.73 375.42 102.66 402.78 102.66 406.91C102.66 411.04 95.7499 452.33 95.7699 455.98C95.8099 464.56 100.82 475.35 103.21 482C104.92 486.76 97.2199 491.65 88.6499 480C85.8299 476.18 82.9499 465.43 83.2999 460.27C83.3899 458.9 84.6299 454.8 84.7799 454.19C85.1599 451.13 85.6199 447.52 85.7599 444.06C86.2699 431.68 83.1899 403.28 83.1899 403.28L105.73 375.4H105.72L105.73 375.42Z"
        fill="#F7D9AB"
      />
      <path
        d="M84.7799 454.2C84.7799 454.2 87.3099 440.54 83.8799 413.35L105.53 378.35L104.03 391.14C104.03 391.14 99.4699 409.71 95.8599 423.06C94.1099 429.55 93.3999 436.63 90.5599 443.93C89.0699 448.86 87.1399 459.46 88.0299 465.41C89.7099 476.57 91.8999 479.91 93.8299 482.82C93.8299 482.82 89.1199 488.83 83.3399 466.98C82.6299 464.31 83.3399 459.22 84.7799 454.19H84.7899L84.7799 454.2Z"
        fill="url(#paint618_linear_2072_10275)"
      />
      <path
        d="M53.4699 449.9C55.5299 446.81 58.6099 443.04 60.6599 440.46C62.7099 437.88 65.2699 402.78 73.4599 390.91C81.6499 379.04 83.6999 374.91 83.6999 374.91H83.8599C83.6999 368.62 74.5799 343.15 74.5799 343.15L104.67 339.36C107.07 352.1 108.77 375.18 106.23 383.17C105.44 385.68 72.7299 435.7 71.1899 442.41C69.6499 449.12 67.3999 459.67 61.7899 475.93L61.8699 477.92C61.8699 477.92 48.5799 486.23 48.4999 473.65C48.4999 473.65 50.0099 455.04 53.4499 449.91L53.4699 449.9Z"
        fill="#F7D9AB"
      />
      <path
        d="M60.6599 440.46C60.6599 440.46 57.3499 443.83 55.8999 446.74C54.4799 449.61 45.5799 464.6 49.0099 475.06C49.0699 475.24 56.5899 445.91 60.6499 440.46H60.6599Z"
        fill="url(#paint619_linear_2072_10275)"
      />
      <path
        d="M61.8699 477.51C59.5899 479.97 51.3799 477.94 49.4499 472.87C48.2199 469.66 50.7199 456.36 56.5899 445.53C56.5899 445.53 53.0199 447.74 50.5699 451.18C48.1199 454.63 49.4499 461.05 48.4699 464.01C47.4899 466.97 44.8999 472.29 45.6299 475.93C46.9299 482.36 53.2999 490.75 59.0399 489.43C62.6299 488.61 62.1999 482.6 61.8699 477.51Z"
        fill="#434343"
      />
      <path
        d="M71.5899 394.04C73.5999 389.99 79.6299 381.54 79.9599 380.97C79.9599 380.97 83.2099 376.42 83.4799 374.84C83.7299 373.44 72.5399 340.74 72.5399 340.74L81.0899 338.67C81.0899 338.67 88.9599 373.81 88.6199 376.22C88.6799 377.4 76.2999 389.76 72.6199 398.19C66.4799 412.27 64.7899 427.32 61.1199 439.46C64.5499 417.24 67.2599 402.78 71.5999 394.04H71.5899Z"
        fill="url(#paint620_linear_2072_10275)"
      />
      <path
        d="M105.17 346.02C105.17 346.02 106.85 354.56 107.09 359.19C100.14 361.14 79.0899 360.09 79.0899 360.09L75.5399 349.5L105.17 346.01V346.02Z"
        fill="url(#paint621_linear_2072_10275)"
      />
      <path
        d="M84.1399 472.38C82.5399 469.3 80.9499 466.09 81.0999 464.19C81.5299 459.05 84.6099 454.75 84.6099 454.75C83.4799 458.97 83.2499 464.82 84.4499 468.08C87.6599 476.85 89.2699 480.65 90.7499 481.45C97.4599 485.11 103.43 482.58 102.62 480.44C106.02 486.15 106.28 488.65 106.05 490.25C105.7 492.75 101.44 494.25 91.3999 490.2C87.7999 488.75 87.5299 486.39 87.5299 486.39C87.3099 482.84 87.0799 479.69 86.5399 477.58V481.74L85.0999 481.5C85.5899 479.67 84.3399 473.39 84.1399 472.39V472.38Z"
        fill="#434343"
      />
      <path
        d="M89.3099 235.33C97.2599 236.45 105.22 237.62 113.2 238.51C114.15 238.62 115.09 238.67 116.03 238.71C117.66 246.71 120.21 255.59 123.02 266.14C117.67 270.41 81.7499 274.22 54.9799 264.32C60.0399 249.2 64.0699 238.68 65.9099 233.83C73.7499 233.73 81.4999 234.35 89.3099 235.32V235.33Z"
        fill="#27AE60"
      />
      <path
        d="M89.3099 235.33C90.7099 235.53 92.1099 235.73 93.5099 235.92C85.2399 237.92 74.3699 241.31 60.4699 247.13C63.4799 242.34 65.5499 237.92 66.8899 233.82C74.3999 233.78 81.8199 234.39 89.3099 235.33Z"
        fill="#27AE60"
      />
      <path
        d="M68.1499 233.83C63.6499 243.93 57.6899 257.45 56.4399 260.05C60.7999 246.57 63.8199 238.46 65.5099 233.85C66.3899 233.84 67.2699 233.82 68.1499 233.83Z"
        fill="url(#paint622_linear_2072_10275)"
      />
      <path
        d="M116.3 238.72C117.47 245.24 118.81 250.49 118.81 250.49C118.81 250.49 116.24 245.1 113.48 238.53C114.43 238.63 115.36 238.68 116.3 238.71V238.72Z"
        fill="#27AE60"
      />
      <path
        d="M78.5199 234.24C78.2399 237.05 77.9999 239.64 77.9999 239.64L75.8799 239.22C75.8799 239.22 75.9699 237.2 76.0899 234.1C76.8999 234.15 77.7099 234.19 78.5199 234.25V234.24Z"
        fill="#2DBA66"
      />
      <path
        d="M68.4099 236.62C88.2399 243.94 104.42 240.88 112.3 238.4C112.6 238.43 112.9 238.48 113.2 238.51C114.78 238.69 116.34 238.76 117.91 238.74C118.37 241.85 119.3 249.01 121.06 265.17C123.93 291.6 116.28 325.83 111.76 357.42C97.5499 358.33 82.0099 358.75 68.2599 358.75C70.5599 338.97 52.3399 294.14 52.3399 272.71C52.3399 267.56 68.4099 236.62 68.4099 236.62Z"
        fill="url(#paint623_linear_2072_10275)"
      />
      <path
        d="M95.5299 241.17C103.54 240.8 108.9 239.47 112.06 238.38C112.44 238.42 112.82 238.47 113.2 238.52C114.18 238.63 115.15 238.68 116.11 238.72L117.09 242.82C117.09 242.82 111.11 247.09 97.0499 247.8C83.7699 248.46 71.8999 245.37 71.8999 245.37L72.9299 237.52C72.9299 237.52 81.2499 241.82 95.5199 241.17H95.5299Z"
        fill="url(#paint624_linear_2072_10275)"
      />
      <path
        d="M77.8899 239.32C77.8899 239.32 77.4799 251.94 77.1299 256.46C76.7899 260.97 76.1799 271.12 74.5799 272.27C72.9799 273.42 56.8299 276.65 52.5599 277.27L52.1399 272.76L74.7199 238.65L77.8799 239.32H77.8899Z"
        fill="url(#paint625_linear_2072_10275)"
      />
      <path
        d="M59.4499 234.07C59.6899 234.06 59.9299 234.05 60.1599 234.04C65.8599 233.69 71.4899 233.79 77.0999 234.15C76.8199 238.27 76.5799 241.56 76.4399 242.62C75.9899 246.12 75.5499 270.85 73.2299 271.68C67.4299 273.77 51.6199 276.67 51.6199 275.69C51.6199 266.02 56.4499 250.54 57.7499 243.31C57.9699 242.11 58.6599 238.39 59.4199 234.06H59.4299L59.4499 234.07Z"
        fill="url(#paint626_linear_2072_10275)"
      />
      <path
        d="M60.1699 234.04C64.4699 233.78 68.7399 233.77 72.9999 233.94L59.3099 235.93L59.7299 234.06C59.8799 234.06 60.0299 234.05 60.1799 234.04H60.1699Z"
        fill="url(#paint627_linear_2072_10275)"
      />
      <path
        d="M60.1699 234.04C60.6199 234.01 61.0699 234 61.5199 233.98C59.7799 239.26 57.0999 246.57 57.0999 246.57C57.5899 244.53 58.4299 239.49 59.2799 234.08C59.5799 234.07 59.8799 234.05 60.1799 234.04H60.1699Z"
        fill="url(#paint628_linear_2072_10275)"
      />
      <path
        d="M76.0599 234.09L76.1599 240.37L75.5599 234.06C75.7199 234.06 75.8899 234.08 76.0599 234.09Z"
        fill="url(#paint629_linear_2072_10275)"
      />
      <path
        d="M77.1599 234.15C76.7399 239.38 76.4199 243.06 76.4199 243.06C76.2199 241.85 76.0199 238.47 75.8099 234.07C76.2599 234.1 76.7099 234.13 77.1699 234.15H77.1599Z"
        fill="url(#paint630_linear_2072_10275)"
      />
      <path
        d="M113.2 238.52C114.71 238.69 116.21 238.76 117.71 238.76C118.22 243.9 119.5 256.13 121.1 267.05C121.42 269.19 121.67 271.29 121.61 273.39C121.61 273.39 117.54 271.28 117.01 270.59C116.49 269.92 112.6 240.5 112.33 238.42C112.62 238.45 112.91 238.49 113.2 238.52Z"
        fill="url(#paint631_linear_2072_10275)"
      />
      <path
        d="M120.96 238.63C122.76 253.08 125.18 271.72 125.18 271.72C125.18 271.72 119.62 271.26 118.39 269.84C117.84 269.2 115.5 251.21 114 238.57C116.34 238.78 118.66 238.78 120.96 238.62V238.63Z"
        fill="url(#paint632_linear_2072_10275)"
      />
      <path
        d="M114.48 238.62L114.42 242.03C114.42 242.03 114.24 240.59 114 238.58C114.16 238.59 114.32 238.61 114.48 238.62Z"
        fill="url(#paint633_linear_2072_10275)"
      />
      <path
        d="M68.2599 358.75C68.2599 358.75 68.8799 354 68.0199 348.13C67.1599 342.26 60.0799 313.73 57.0999 300.63C57.0999 300.63 62.5999 318.01 67.6399 333.35C72.6499 348.6 74.3999 358.71 74.3999 358.71L68.2699 358.74L68.2599 358.75Z"
        fill="url(#paint634_linear_2072_10275)"
      />
      <path
        d="M111.76 357.42L106.06 357.75C106.06 357.75 116.51 325.82 119.91 303.58C119.91 303.58 117.36 325.93 111.76 357.42Z"
        fill="url(#paint635_linear_2072_10275)"
      />
      <path
        d="M81.2499 287.18C75.7199 289.32 85.4599 346.61 94.8399 348.58C104.22 350.55 100.59 332.23 98.4099 320.04C96.2399 307.84 93.0299 282.63 81.2499 287.19V287.18Z"
        fill="#38373B"
      />
      <path
        d="M111.46 257.21C110.88 255.28 78.4099 257.54 78.4599 258.79C78.5099 260.04 87.0499 275.09 94.9899 274.94C102.93 274.79 112.36 260.22 111.46 257.2V257.21Z"
        fill="url(#paint636_linear_2072_10275)"
      />
      <path
        d="M107.39 365.01C107.39 365.01 108.01 379.49 106.12 383.44C104.43 386.97 78.0099 428.79 75.6199 433.45C73.5299 437.53 71.7499 441.11 71.2999 443.1C70.8499 445.09 64.7799 469.45 62.3899 473.21C60.9099 475.54 56.6899 475.82 55.7699 470.38C54.8599 464.95 60.7699 447.88 62.0799 444.65C63.3899 441.42 74.2799 415.12 74.8599 413.28C75.4499 411.43 101.4 386.68 102.77 383.75C104.14 380.83 107.38 365.01 107.38 365.01H107.39Z"
        fill="url(#paint637_linear_2072_10275)"
      />
      <path
        d="M60.1699 234.04C63.2499 233.85 66.3099 233.8 69.3499 233.84C69.3499 233.96 69.3599 234.07 69.3699 234.17C68.2599 234.3 62.5899 234.35 56.2699 234.16C57.5699 234.16 58.8699 234.12 60.1699 234.03V234.04Z"
        fill="url(#paint638_linear_2072_10275)"
      />
      <path
        d="M171.35 190.98C170.49 189.57 169.84 188.01 169.81 186.46C173.82 183.95 176.26 182.19 176.69 181.67L183.76 186.98C183.76 186.98 179.45 190.74 175.62 194.87C173.51 194.39 171.95 192.68 171.35 190.97V190.98Z"
        fill="#F7D4AB"
      />
      <path
        d="M202.89 163.33C202.89 163.33 203.58 162.61 203.58 162C203.58 161.62 202.75 160.73 202.21 160.92C201.88 161.03 201.7 161.14 201.11 161.59L202.9 163.33H202.89Z"
        fill="#FFDEBD"
      />
      <path
        d="M194.49 171.99C194.49 171.99 199.12 167.14 201.37 165.09C203.67 162.99 203.64 161.84 202.9 161.39C202.24 160.99 201.08 161.51 200.42 162C195.59 165.54 190.39 169.76 190.39 169.76L185.22 173.06L194.49 171.99Z"
        fill="#F7D4AB"
      />
      <path
        d="M194.95 171.51L194.36 172.15L191.31 171.31L185.59 172.71L188.26 171.12C188.26 171.12 191.81 170.31 192.56 170.31C193.31 170.31 194.96 171.51 194.96 171.51H194.95Z"
        fill="url(#paint639_linear_2072_10275)"
      />
      <path
        d="M202.64 161.28C202.64 161.28 201.32 160.9 198.95 162.77C196.63 164.61 192.67 167.91 191.74 168.66C192.87 168.14 194.34 166.75 197.26 164.66C199.47 163.09 202.14 161.41 202.63 161.27L202.64 161.28Z"
        fill="url(#paint640_linear_2072_10275)"
      />
      <path
        d="M196.17 170.28C196.17 170.28 200.54 165.98 201.36 165.09C202.19 164.2 204.23 162.93 203.09 161.54L196.17 170.28Z"
        fill="url(#paint641_linear_2072_10275)"
      />
      <path
        d="M192.73 172.81C192.73 172.81 196.06 170.75 197.16 171.23C198.26 171.71 199.45 173.08 199.3 174.08C199.16 175.08 194.51 177.21 194.51 177.21C194.51 177.21 192.25 179.09 191.64 178.72C191.03 178.35 188.39 175.54 189.13 175.22C189.86 174.9 192.73 172.81 192.73 172.81Z"
        fill="#F7D4AB"
      />
      <path
        d="M197.87 175.45C198.36 175.22 199.13 174.41 199.13 174.41C199.16 174.03 198.66 173.23 197.62 172.83C196.59 172.45 194.66 171.78 194.66 171.78L193.24 172.44C193.24 172.44 197.39 175.68 197.87 175.45Z"
        fill="url(#paint642_linear_2072_10275)"
      />
      <path
        d="M167.47 186.89C167.67 186.98 176.41 181.51 176.72 181.22C177.03 180.92 178.69 177.71 178.98 177.24C179.27 176.77 185.09 172.61 185.09 172.61C185.09 172.61 191.62 171.02 192.1 171.12C192.59 171.23 197.55 173.41 197.92 173.74C198.29 174.06 198.95 175.33 197.43 175.93C195.91 176.53 192.29 175.72 191.78 175.35C191.27 174.98 190.15 175.77 190.17 176.04C190.2 176.3 194.95 187.66 194.95 187.66C194.95 187.66 190.51 189.64 188.69 190.06C186.87 190.48 182.73 190.06 181.81 190.38C180.88 190.7 174.51 195.57 174.51 195.57L167.48 186.9L167.47 186.89Z"
        fill="#F7D4AB"
      />
      <path
        d="M192.13 175.35L189.04 176.32C189.04 176.32 188.69 181.14 183.77 184.37C182.06 185.49 184.32 185.13 187.03 185.38C190.28 185.69 194.29 186.5 194.29 186.5L192.13 175.34V175.35Z"
        fill="url(#paint643_linear_2072_10275)"
      />
      <path
        d="M194.08 186.5L191.12 174.86L188.9 176.04C188.9 176.04 189.31 179.14 187.04 181.37C186.38 182.02 194.09 186.49 194.09 186.49L194.08 186.5Z"
        fill="url(#paint644_linear_2072_10275)"
      />
      <path
        d="M194.74 176.03L191.36 177.1C191.36 177.1 189.99 176.58 190.45 175.62C190.77 174.95 191.4 175.01 191.4 175.01L194.73 176.04L194.74 176.03Z"
        fill="url(#paint645_linear_2072_10275)"
      />
      <path
        d="M179.26 183.1C177.43 183.3 181.16 177.15 181.78 176.89C182.4 176.63 186.11 176.5 186.77 177.2C187.43 177.91 185.94 182.36 179.26 183.1Z"
        fill="url(#paint646_linear_2072_10275)"
      />
      <path
        d="M196.99 180.83C196.99 180.83 197.71 180.42 197.97 179.84C198.23 179.26 198.35 177.87 197.57 176.95C196.75 175.97 195.95 175.64 195.95 175.64C195.95 175.64 190.18 177.27 190.04 177.79C189.89 178.31 190.63 181.13 191.45 181.21C192.27 181.29 197 180.84 197 180.84L196.99 180.83Z"
        fill="#F7D4AB"
      />
      <path
        d="M196.99 180.83C196.99 180.83 198.15 180.33 198.15 179.06L190.55 180.08C190.55 180.08 190.92 181.2 191.45 181.19C191.73 181.19 197 180.82 197 180.82L196.99 180.83Z"
        fill="url(#paint647_linear_2072_10275)"
      />
      <path
        d="M194.94 187.65C194.94 187.65 196.52 186.14 196.91 185.75C197.31 185.37 198.12 183.35 197.97 182.73C197.82 182.11 197.38 181 196.99 180.81C196.59 180.62 191.93 180.72 191.71 180.92C191.49 181.13 190.84 182.46 192.03 183.93C192.2 184.14 194.95 187.64 194.95 187.64L194.94 187.65Z"
        fill="#F7D4AB"
      />
      <path
        d="M196.56 184.48C196.56 184.48 192.14 183.56 191.76 183.55C192.08 184.17 194.65 187.31 194.65 187.31C194.65 187.31 193.96 185.26 194.6 185.22C195.23 185.18 196.57 184.48 196.57 184.48H196.56Z"
        fill="url(#paint648_linear_2072_10275)"
      />
      <path
        d="M197.71 182.76C197.71 182.76 195.16 183.57 191.39 182.67C191.39 182.67 191.57 183.49 191.83 183.6C192.72 183.98 195.65 184.46 196.4 184.07C197.15 183.69 197.71 182.77 197.71 182.77V182.76Z"
        fill="url(#paint649_linear_2072_10275)"
      />
      <path
        d="M199.17 174.35C199.17 174.35 199.74 173.74 199.04 172.62C198.34 171.5 197.41 170.98 196.85 171.04C196.28 171.1 195.43 171.46 195.43 171.46C195.43 171.46 197.37 171.6 197.65 171.81C197.93 172.02 198.76 172.85 199 173.35C199.39 174.14 199.18 174.35 199.18 174.35H199.17Z"
        fill="url(#paint650_linear_2072_10275)"
      />
      <path
        d="M187.16 190.22L181.8 190.37C181.22 190.68 175.39 195.34 175.39 195.34C175.39 195.34 179.13 188.02 179.56 187.82C180 187.61 187.15 190.23 187.15 190.23L187.16 190.22Z"
        fill="url(#paint651_linear_2072_10275)"
      />
      <path
        d="M178.22 178.64C178.22 178.64 176.72 181.12 176.37 181.39C176.02 181.66 167.86 186.79 167.86 186.79C167.86 186.79 176.14 184.09 176.56 183.56C176.99 183.02 178.22 178.64 178.22 178.64Z"
        fill="url(#paint652_linear_2072_10275)"
      />
      <path
        d="M197.01 185.66C197.01 185.66 197.97 183.95 198.02 183.17C198.08 182.39 197.53 181.26 197.06 180.79C196.88 180.61 194.7 180.72 194.7 180.72C194.7 180.72 196.44 181.37 196.79 181.6C197.14 181.83 197.56 183.24 197.6 183.47C197.64 183.7 197 185.66 197 185.66H197.01Z"
        fill="url(#paint653_linear_2072_10275)"
      />
      <path
        d="M177.3 193.81L174.7 195.87C174.7 195.87 171.03 193.53 170.29 190.66C169.55 187.79 170.96 185.24 170.96 185.24C170.96 185.24 170.96 185.61 172.69 188.55C173.55 190.02 175.82 193.27 177.3 193.8V193.81Z"
        fill="url(#paint654_linear_2072_10275)"
      />
      <path
        d="M110.08 173.64C110.34 179.65 109.39 186.89 104.61 192.46C106.27 191.48 107.72 190.13 108.93 188.39C111.19 185.18 112 181.61 111.36 177.72C111.11 176.25 110.69 174.88 110.09 173.64H110.08Z"
        fill="white"
      />
      <path
        d="M85.8999 170.26C88.5099 168.92 90.7099 167.41 92.4199 165.81C89.8399 166.61 87.6599 168.09 85.8999 170.26Z"
        fill="white"
      />
      <path
        d="M97.1199 165C99.1299 165.91 101.53 166.59 104.22 167.02C102.01 165.66 99.6399 164.99 97.1199 165Z"
        fill="white"
      />
      <path
        d="M82.6499 177.22C82.3899 178.78 82.3799 180.39 82.6499 182.07C83.2899 185.97 85.1999 189.08 88.3699 191.4C90.2199 192.75 92.1799 193.59 94.2399 193.94C87.5799 190.11 84.2899 183.18 82.6399 177.22H82.6499Z"
        fill="white"
      />
      <path
        d="M108.58 173.8C108.5 171.99 108.31 170.3 108.08 168.84C106.49 168.78 104.98 168.61 103.55 168.39C101.09 168 98.9099 167.38 97.0799 166.56C96.3299 166.22 95.6199 165.85 94.9999 165.44L94.7199 165.48C94.2699 166.05 93.7399 166.61 93.1499 167.16C91.5999 168.62 89.5999 170 87.2099 171.21C86.0299 171.81 84.7599 172.39 83.4099 172.91C83.6399 174.23 83.9599 175.72 84.3899 177.28C85.8999 182.71 88.8899 189.02 94.9499 192.51C96.3399 193.31 97.8899 193.98 99.6299 194.43C101.21 193.4 102.5 192.21 103.59 190.93C107.95 185.86 108.81 179.26 108.58 173.79V173.8ZM102.4 188.3C101.88 188.92 101.31 189.5 100.7 190.02C100.37 190.3 100.03 190.56 99.6899 190.81C99.5299 190.93 99.3099 191.14 99.0999 191.18C98.9199 191.21 98.6299 191.08 98.4599 191.03C96.8999 190.56 95.4099 189.84 94.0899 188.88C93.8399 188.7 93.5999 188.51 93.3699 188.31C91.3299 186.61 89.7999 184.38 88.6999 181.98C88.3499 181.2 88.0299 180.4 87.7499 179.59C87.2099 177.99 86.8099 176.33 86.5199 174.67C86.4999 174.55 86.5699 174.41 86.6799 174.37C87.5499 174.03 88.4099 173.66 89.2499 173.24C89.8899 172.93 90.4999 172.59 91.0999 172.22C91.6599 171.88 92.2099 171.51 92.7299 171.11C92.8099 171.05 92.8799 171 92.9499 170.94C93.4499 170.55 93.9299 170.13 94.3799 169.66C94.5799 169.45 94.7699 169.24 94.9499 169.02C95.0599 168.89 95.1299 168.76 95.2999 168.72C95.3599 168.7 95.4299 168.7 95.4999 168.69C95.5799 168.68 95.6499 168.69 95.7099 168.74C96.2399 169.09 96.7899 169.37 97.3699 169.62C99.9099 170.72 102.72 171.14 105.47 171.25C105.59 171.25 105.7 171.37 105.72 171.48C105.76 171.74 105.8 172.01 105.83 172.27C106.06 173.98 106.18 175.72 106.11 177.45C106.08 178.35 106 179.25 105.87 180.13C105.56 182.2 104.92 184.24 103.92 186.07C103.49 186.85 102.99 187.59 102.41 188.28H102.4V188.3Z"
        fill="white"
      />
      <g opacity="0.65">
        <path
          opacity="0.65"
          d="M964.71 126.26C964.71 113.92 954.71 103.92 942.37 103.92C930.03 103.92 920.03 113.92 920.03 126.26C920.03 138.6 930.03 148.6 942.37 148.6C954.71 148.6 964.71 138.6 964.71 126.26Z"
          fill="#7E607F"
        />
        <path
          opacity="0.65"
          d="M963.49 126.26C963.49 114.59 954.03 105.14 942.37 105.14C930.71 105.14 921.25 114.6 921.25 126.26C921.25 137.92 930.71 147.38 942.37 147.38C954.03 147.38 963.49 137.92 963.49 126.26Z"
          fill="#F2F2F5"
        />
        <path
          opacity="0.65"
          d="M953.328 114.739L939.134 129.182L939.626 129.666L953.82 115.222L953.328 114.739Z"
          fill="#3B0E19"
        />
        <path
          opacity="0.65"
          d="M933.54 118.065L933.085 118.583L945.434 129.421L945.889 128.902L933.54 118.065Z"
          fill="#3B0E19"
        />
        <path
          opacity="0.65"
          d="M943.46 126.26C943.46 125.66 942.97 125.17 942.37 125.17C941.77 125.17 941.28 125.66 941.28 126.26C941.28 126.86 941.77 127.35 942.37 127.35C942.97 127.35 943.46 126.86 943.46 126.26Z"
          fill="#3B0E19"
        />
        <g opacity="0.65">
          <path
            opacity="0.65"
            d="M950.85 113V109.61H950.08V109.2H951.28V113H950.85Z"
            fill="#3B0E19"
          />
          <path
            opacity="0.65"
            d="M958.07 116.72C958.07 117.08 957.8 117.52 957.4 117.95L956.23 119.19H958.29V119.6H955.68V119.24L957.1 117.69C957.42 117.37 957.62 117.02 957.62 116.77C957.62 116.4 957.34 116.18 956.86 116.18C956.51 116.18 956.13 116.36 955.82 116.65L955.63 116.3C956 115.97 956.46 115.77 956.91 115.77C957.61 115.77 958.07 116.13 958.07 116.7V116.72Z"
            fill="#3B0E19"
          />
          <path
            opacity="0.65"
            d="M959.66 125.97C960.34 126 960.81 126.37 960.81 126.98C960.81 127.68 960.29 128.17 959.48 128.17C959.04 128.17 958.59 128.01 958.28 127.78L958.47 127.42C958.74 127.64 959.1 127.78 959.45 127.78C960.04 127.78 960.39 127.46 960.39 127C960.39 126.54 960.04 126.28 959.45 126.28H958.98V126L960.09 124.77H958.45V124.36H960.64V124.65L959.46 125.96L959.67 125.98L959.66 125.97Z"
            fill="#3B0E19"
          />
          <path
            opacity="0.65"
            d="M957.62 135.31V134.31H958.03V135.31H958.61V135.73H958.03V136.73H957.62V135.73H955.8V135.37L957.16 132.93H957.59L956.27 135.31H957.63H957.62Z"
            fill="#3B0E19"
          />
          <path
            opacity="0.65"
            d="M950.3 139.61V140.68C950.5 140.65 950.77 140.63 950.94 140.63C951.74 140.63 952.25 141.1 952.25 141.75C952.25 142.51 951.72 143 950.91 143C950.49 143 949.99 142.84 949.63 142.59L949.81 142.22C950.12 142.46 950.53 142.6 950.87 142.6C951.44 142.6 951.79 142.29 951.79 141.77C951.79 141.32 951.44 141.04 950.88 141.04C950.63 141.04 950.17 141.08 949.9 141.13V139.19H952.1V139.61H950.3Z"
            fill="#3B0E19"
          />
          <path
            opacity="0.65"
            d="M943.55 141.71L943.38 142.06C943.13 141.91 942.8 141.83 942.51 141.83C941.7 141.83 941.29 142.5 941.35 143.52C941.52 143.07 941.93 142.82 942.48 142.82C943.22 142.82 943.69 143.28 943.69 144.01C943.69 144.79 943.19 145.27 942.4 145.27C941.48 145.27 940.92 144.6 940.92 143.43C940.92 142.26 941.52 141.43 942.48 141.43C942.83 141.43 943.25 141.54 943.55 141.7V141.71ZM941.44 144.04C941.44 144.4 941.72 144.87 942.36 144.87C942.9 144.87 943.27 144.54 943.27 144.01C943.27 143.51 942.93 143.19 942.4 143.19C941.8 143.19 941.44 143.59 941.44 144.04Z"
            fill="#3B0E19"
          />
          <path
            opacity="0.65"
            d="M933.54 143H933.08L934.64 139.62H932.87V140.17H932.48V139.2H935.12V139.56L933.54 143Z"
            fill="#3B0E19"
          />
          <path
            opacity="0.65"
            d="M928.76 133.86C928.76 134.25 928.53 134.54 928.14 134.69C928.63 134.84 928.94 135.18 928.94 135.66C928.94 136.34 928.4 136.75 927.55 136.75C926.7 136.75 926.14 136.34 926.14 135.68C926.14 135.2 926.45 134.85 926.96 134.7C926.56 134.54 926.32 134.25 926.32 133.86C926.32 133.27 926.79 132.92 927.54 132.92C928.29 132.92 928.76 133.28 928.76 133.88V133.86ZM926.55 135.62C926.55 136.1 926.92 136.37 927.54 136.37C928.16 136.37 928.53 136.09 928.53 135.62C928.53 135.17 928.16 134.9 927.54 134.9C926.92 134.9 926.55 135.17 926.55 135.62ZM926.7 133.89C926.7 134.3 927.01 134.54 927.55 134.54C928.09 134.54 928.39 134.3 928.39 133.89C928.39 133.48 928.07 133.24 927.55 133.24C927.03 133.24 926.7 133.48 926.7 133.89Z"
            fill="#3B0E19"
          />
          <path
            opacity="0.65"
            d="M923.98 127.91L924.15 127.56C924.4 127.71 924.73 127.79 925.02 127.79C925.83 127.79 926.24 127.12 926.18 126.1C926.01 126.54 925.6 126.79 925.05 126.79C924.31 126.79 923.84 126.33 923.84 125.6C923.84 124.82 924.34 124.34 925.13 124.34C926.05 124.34 926.61 125.01 926.61 126.17C926.61 127.33 926.01 128.17 925.05 128.17C924.7 128.17 924.28 128.06 923.98 127.9V127.91ZM926.09 125.58C926.09 125.22 925.81 124.75 925.16 124.75C924.62 124.75 924.25 125.07 924.25 125.61C924.25 126.11 924.59 126.43 925.12 126.43C925.72 126.43 926.08 126.03 926.08 125.58H926.09Z"
            fill="#3B0E19"
          />
          <g opacity="0.65">
            <path
              opacity="0.65"
              d="M926.25 119.81V116.42H925.48V116.01H926.68V119.81H926.25Z"
              fill="#3B0E19"
            />
            <path
              opacity="0.65"
              d="M930.89 117.91C930.89 119.14 930.33 119.82 929.32 119.82C928.31 119.82 927.75 119.14 927.75 117.91C927.75 116.68 928.31 116 929.32 116C930.33 116 930.89 116.68 930.89 117.91ZM928.19 117.91C928.19 118.94 928.58 119.45 929.32 119.45C930.06 119.45 930.45 118.93 930.45 117.91C930.45 116.89 930.06 116.37 929.32 116.37C928.58 116.37 928.19 116.88 928.19 117.91Z"
              fill="#3B0E19"
            />
          </g>
          <g opacity="0.65">
            <path
              opacity="0.65"
              d="M932.63 113.57V110.18H931.86V109.77H933.06V113.57H932.63Z"
              fill="#3B0E19"
            />
            <path
              opacity="0.65"
              d="M935.32 113.57V110.18H934.55V109.77H935.75V113.57H935.32Z"
              fill="#3B0E19"
            />
          </g>
          <g opacity="0.65">
            <path
              opacity="0.65"
              d="M940.67 111.11V107.72H939.9V107.31H941.1V111.11H940.67Z"
              fill="#3B0E19"
            />
            <path
              opacity="0.65"
              d="M944.62 108.23C944.62 108.59 944.35 109.03 943.95 109.46L942.78 110.7H944.84V111.11H942.23V110.75L943.65 109.2C943.97 108.88 944.17 108.53 944.17 108.28C944.17 107.91 943.89 107.69 943.41 107.69C943.06 107.69 942.68 107.87 942.37 108.16L942.18 107.81C942.55 107.48 943.01 107.28 943.46 107.28C944.16 107.28 944.62 107.64 944.62 108.21V108.23Z"
              fill="#3B0E19"
            />
          </g>
        </g>
        <path
          opacity="0.65"
          d="M936.45 111.61L944.9 132.96C944.96 133.12 944.92 133.29 944.79 133.41C944.46 133.71 944.33 134.18 944.5 134.62C944.72 135.18 945.35 135.45 945.91 135.23C946.47 135.01 946.74 134.38 946.52 133.82C946.35 133.38 945.92 133.12 945.48 133.14C945.31 133.14 945.16 133.04 945.09 132.89L936.64 111.55C936.62 111.49 936.55 111.46 936.49 111.49C936.43 111.51 936.4 111.58 936.43 111.64L936.45 111.61Z"
          fill="#6C5F84"
        />
        <path
          opacity="0.65"
          d="M943.09 126.26C943.09 125.86 942.77 125.54 942.37 125.54C941.97 125.54 941.65 125.86 941.65 126.26C941.65 126.66 941.97 126.98 942.37 126.98C942.77 126.98 943.09 126.66 943.09 126.26Z"
          fill="#6C5F84"
        />
      </g>
      <path
        d="M823.78 275.38C824.73 275.38 825.46 274.94 825.82 274.13C825.96 273.82 825.82 273.45 825.51 273.31C825.2 273.17 824.83 273.31 824.69 273.62C824.62 273.79 824.42 274.23 823.52 274.12C821.84 273.91 819.38 271.93 819.07 270.12C818.87 268.94 819.01 267.99 819.48 267.43C819.87 266.97 820.52 266.73 821.42 266.73C821.94 266.73 823.51 266.73 823.51 269.82C823.51 270.16 823.79 270.44 824.13 270.44C824.47 270.44 824.75 270.16 824.75 269.82C824.75 266.06 822.67 265.5 821.42 265.5C820.17 265.5 819.17 265.88 818.54 266.64C817.82 267.49 817.59 268.77 817.86 270.33C818.28 272.78 821.22 275.08 823.38 275.35C823.52 275.37 823.66 275.38 823.79 275.38H823.78Z"
        fill="#DFD5DC"
      />
      <path
        d="M840.73 277.6C840.17 278.01 839.51 278.23 838.82 278.23H830.14C829.45 278.23 828.78 278.01 828.23 277.6C825.63 275.68 823.94 272.6 823.94 269.13C823.94 268.18 824.07 267.26 824.31 266.38C824.45 265.86 824.93 265.5 825.47 265.5H843.49C844.03 265.5 844.51 265.86 844.65 266.38C844.89 267.26 845.02 268.18 845.02 269.13C845.02 272.61 843.33 275.68 840.73 277.6Z"
        fill="#F0ECEF"
      />
      <path
        d="M848.27 277.48C848.41 277.48 848.54 277.56 848.61 277.69C848.67 277.82 848.66 277.97 848.57 278.08C848.43 278.26 848.28 278.44 848.13 278.62C847.19 279.72 845.81 280.36 844.36 280.36H824.61C823.16 280.36 821.78 279.73 820.84 278.62C820.67 278.42 820.5 278.21 820.34 278C820.26 277.9 820.25 277.77 820.31 277.66C820.37 277.55 820.48 277.48 820.6 277.48H848.28H848.27Z"
        fill="#DFD5DC"
      />
      <path
        d="M462.56 278.96C463.51 278.96 464.24 278.52 464.6 277.71C464.74 277.4 464.6 277.03 464.29 276.89C463.98 276.75 463.61 276.89 463.47 277.2C463.4 277.37 463.2 277.81 462.3 277.7C460.62 277.49 458.16 275.51 457.85 273.7C457.65 272.52 457.79 271.57 458.26 271.01C458.65 270.55 459.3 270.31 460.2 270.31C460.72 270.31 462.29 270.31 462.29 273.4C462.29 273.74 462.57 274.02 462.91 274.02C463.25 274.02 463.53 273.74 463.53 273.4C463.53 269.64 461.45 269.08 460.2 269.08C458.95 269.08 457.95 269.46 457.32 270.22C456.6 271.07 456.37 272.35 456.64 273.91C457.06 276.36 460 278.66 462.16 278.93C462.3 278.95 462.44 278.96 462.57 278.96H462.56Z"
        fill="#DFD5DC"
      />
      <path
        d="M479.51 281.19C478.95 281.6 478.29 281.82 477.6 281.82H468.92C468.23 281.82 467.56 281.6 467.01 281.19C464.41 279.27 462.72 276.19 462.72 272.72C462.72 271.77 462.85 270.85 463.09 269.97C463.23 269.45 463.71 269.09 464.25 269.09H482.27C482.81 269.09 483.29 269.45 483.43 269.97C483.67 270.85 483.8 271.77 483.8 272.72C483.8 276.2 482.11 279.27 479.51 281.19Z"
        fill="#F0ECEF"
      />
      <path
        d="M487.04 281.07C487.18 281.07 487.31 281.15 487.38 281.28C487.44 281.41 487.43 281.56 487.34 281.67C487.2 281.85 487.05 282.03 486.9 282.21C485.96 283.31 484.58 283.95 483.13 283.95H463.38C461.93 283.95 460.55 283.32 459.61 282.21C459.44 282.01 459.27 281.8 459.11 281.59C459.03 281.49 459.02 281.36 459.08 281.25C459.14 281.14 459.25 281.07 459.37 281.07H487.05H487.04Z"
        fill="#DFD5DC"
      />
      <g opacity="0.8">
        <path
          opacity="0.8"
          d="M957.69 212.27H987.7C987.7 211.84 988.06 211.49 988.49 211.49H995.76V209.17H957.7V212.27H957.69Z"
          fill="#5BA8E5"
        />
        <path
          opacity="0.8"
          d="M988.48 239.53C988.04 239.53 987.69 239.18 987.69 238.74V237.26H957.68V240.36H995.74V239.53H988.47H988.48Z"
          fill="#5BA8E5"
        />
        <path
          opacity="0.8"
          d="M995.75 202.97H957.69V206.07H995.75V202.97Z"
          fill="#5BA8E5"
        />
        <path
          opacity="0.8"
          d="M987.7 215.37H957.69V218.47H987.7V215.37Z"
          fill="#5BA8E5"
        />
        <path
          opacity="0.8"
          d="M987.7 231.22H957.69V234.16H987.7V231.22Z"
          fill="#5BA8E5"
        />
        <path
          opacity="0.8"
          d="M995.75 243.47H957.69V246.37H995.75V243.47Z"
          fill="#5BA8E5"
        />
        <path
          opacity="0.8"
          d="M996.38 202.97C996.82 202.97 997.17 202.62 997.17 202.18V201.48C997.17 198.73 994.94 196.5 992.19 196.5H961.25C958.5 196.5 956.27 198.73 956.27 201.48V202.18C956.27 202.62 956.62 202.97 957.06 202.97H996.39H996.38Z"
          fill="#66B8EC"
        />
        <path
          opacity="0.8"
          d="M957.06 206.07C956.62 206.07 956.27 206.42 956.27 206.86V208.38C956.27 208.82 956.62 209.17 957.06 209.17H996.39C996.83 209.17 997.18 208.82 997.18 208.38V206.86C997.18 206.42 996.83 206.07 996.39 206.07H957.06Z"
          fill="#66B8EC"
        />
        <path
          opacity="0.8"
          d="M987.69 212.28H957.05C956.61 212.28 956.26 212.63 956.26 213.06V214.58C956.26 215.02 956.61 215.37 957.05 215.37H987.69V212.28Z"
          fill="#66B8EC"
        />
        <path
          opacity="0.8"
          d="M987.69 218.48H957.05C956.61 218.48 956.26 218.83 956.26 219.27V230.44C956.26 230.88 956.61 231.23 957.05 231.23H987.69V218.48Z"
          fill="#66B8EC"
        />
        <path
          opacity="0.8"
          d="M957.06 246.37C956.62 246.37 956.27 246.72 956.27 247.16V247.7C956.27 251.32 959.21 254.26 962.83 254.26H965.7C967.16 254.26 973.52 256.57 973.52 260.93V261.4C973.52 261.57 973.66 261.72 973.84 261.72H979.61C979.78 261.72 979.93 261.58 979.93 261.4V260.93C979.93 256.57 986.29 254.26 987.75 254.26H990.62C994.24 254.26 997.18 251.32 997.18 247.7V247.16C997.18 246.72 996.83 246.37 996.39 246.37H957.06Z"
          fill="#66B8EC"
        />
        <path
          opacity="0.8"
          d="M979.53 261.72H973.91V265.15H979.53V261.72Z"
          fill="#5BA8E5"
        />
        <path
          opacity="0.8"
          d="M973.83 265.16C973.66 265.16 973.51 265.3 973.51 265.48V266.11C973.51 266.28 973.65 266.43 973.83 266.43H979.6C979.77 266.43 979.92 266.29 979.92 266.11V265.48C979.92 265.31 979.78 265.16 979.6 265.16H973.83Z"
          fill="#66B8EC"
        />
        <path
          opacity="0.8"
          d="M987.69 234.16H957.05C956.61 234.16 956.26 234.51 956.26 234.95V236.47C956.26 236.91 956.61 237.26 957.05 237.26H987.69V234.16Z"
          fill="#66B8EC"
        />
        <path
          opacity="0.8"
          d="M957.06 240.37C956.62 240.37 956.27 240.72 956.27 241.16V242.68C956.27 243.12 956.62 243.47 957.06 243.47H996.39C996.83 243.47 997.18 243.12 997.18 242.68V241.16C997.18 240.72 996.83 240.37 996.39 240.37H957.06Z"
          fill="#66B8EC"
        />
        <path
          opacity="0.8"
          d="M991.39 239.53H995.75V237.27V234.16V231.22V218.48V215.37V212.27V211.49H991.39V239.53Z"
          fill="#5BA8E5"
        />
      </g>
      <path
        d="M986.4 256.59H967.03C966.38 256.59 965.76 256.86 965.31 257.33L961.8 261.05H991.63L988.12 257.33C987.67 256.86 987.05 256.59 986.4 256.59Z"
        fill="#5A5278"
      />
      <path
        d="M997.15 387.14H956.27C955.83 387.14 955.48 386.79 955.48 386.35V264.11C955.48 262.41 956.85 261.04 958.55 261.04H994.87C996.57 261.04 997.94 262.41 997.94 264.11V386.35C997.94 386.79 997.59 387.14 997.15 387.14Z"
        fill="#E2DFE5"
      />
      <path
        d="M997.15 387.14H956.27C955.83 387.14 955.48 386.79 955.48 386.35V264.19H997.94V386.35C997.94 386.79 997.59 387.14 997.15 387.14Z"
        fill="#D1CCD6"
      />
      <path d="M958.88 264.19V387.14H994.55V264.19H958.88Z" fill="#EEECF0" />
      <path d="M994.55 384.04H958.88V387.14H994.55V384.04Z" fill="#5A5278" />
      <path d="M994.55 322.35H958.88V333.24H994.55V322.35Z" fill="#5A5278" />
      <path d="M994.55 293.24H958.88V322.35H994.55V293.24Z" fill="#686185" />
      <path d="M994.55 264.19H958.88V272.82H994.55V264.19Z" fill="#DAD6DF" />
      <path d="M993.52 293.24H959.9V322.35H993.52V293.24Z" fill="#493D62" />
      <path
        d="M994.07 261.05H959.35C958.76 261.05 958.88 264.19 958.88 264.19H994.55C994.55 264.19 994.51 261.05 994.08 261.05H994.07Z"
        fill="#EEECF0"
      />
      <path
        d="M966.65 293.24V294.37C966.65 294.63 966.68 294.89 966.74 295.15L967.69 299.21C967.74 299.42 967.93 299.58 968.15 299.58H969.25C969.47 299.58 969.66 299.43 969.71 299.21L970.66 295.15C970.72 294.9 970.75 294.63 970.75 294.37V293.24H966.65Z"
        fill="#ED4E5B"
      />
      <path
        d="M982.67 293.24V294.37C982.67 294.63 982.7 294.89 982.76 295.15L983.71 299.21C983.76 299.42 983.95 299.58 984.17 299.58H985.27C985.49 299.58 985.68 299.43 985.73 299.21L986.68 295.15C986.74 294.9 986.77 294.63 986.77 294.37V293.24H982.67Z"
        fill="#66B8EC"
      />
      <path
        d="M972.52 284.21H964.89C964.454 284.21 964.1 284.564 964.1 285V288.47C964.1 288.906 964.454 289.26 964.89 289.26H972.52C972.956 289.26 973.31 288.906 973.31 288.47V285C973.31 284.564 972.956 284.21 972.52 284.21Z"
        fill="#ED4E5B"
      />
      <path
        d="M988.54 284.21H980.91C980.474 284.21 980.12 284.564 980.12 285V288.47C980.12 288.906 980.474 289.26 980.91 289.26H988.54C988.976 289.26 989.33 288.906 989.33 288.47V285C989.33 284.564 988.976 284.21 988.54 284.21Z"
        fill="#66B8EC"
      />
      <path
        d="M970 270.23C970 270.71 969.61 271.1 969.13 271.1C968.65 271.1 968.26 270.71 968.26 270.23C968.26 269.75 968.65 269.36 969.13 269.36C969.61 269.36 970 269.75 970 270.23Z"
        fill="#ED4E5B"
      />
      <path
        d="M977.59 270.23C977.59 270.71 977.2 271.1 976.72 271.1C976.24 271.1 975.85 270.71 975.85 270.23C975.85 269.75 976.24 269.36 976.72 269.36C977.2 269.36 977.59 269.75 977.59 270.23Z"
        fill="#C3D06B"
      />
      <path
        d="M985.18 270.23C985.18 270.71 984.79 271.1 984.31 271.1C983.83 271.1 983.44 270.71 983.44 270.23C983.44 269.75 983.83 269.36 984.31 269.36C984.79 269.36 985.18 269.75 985.18 270.23Z"
        fill="#66B8EC"
      />
      <path
        d="M179.53 176.85C179.82 176.38 185.64 172.22 185.64 172.22C185.64 172.22 192.17 170.63 192.65 170.73C193.14 170.84 198.1 173.02 198.47 173.35C198.84 173.67 199.5 174.94 197.98 175.54C196.46 176.14 192.84 175.33 192.33 174.96C191.82 174.59 190.7 175.38 190.72 175.65"
        fill="#F7D4AB"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2072_10275"
          x1="591.51"
          y1="313.91"
          x2="591.51"
          y2="44.0601"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BDB9D9" />
          <stop offset={1} stopColor="#75699B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2072_10275"
          x1="591.98"
          y1="180.3"
          x2="591.98"
          y2="178.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9E98C7" />
          <stop offset={1} stopColor="#8B6A92" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2072_10275"
          x1="591.21"
          y1={101}
          x2="591.21"
          y2="86.79"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9E98C7" />
          <stop offset={1} stopColor="#8B6A92" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2072_10275"
          x1="591.29"
          y1="269.98"
          x2="591.29"
          y2="253.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9E98C7" />
          <stop offset={1} stopColor="#8B6A92" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2072_10275"
          x1="729.546"
          y1="297.175"
          x2="729.546"
          y2="56.6447"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9E98C7" />
          <stop offset={1} stopColor="#8B6A92" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2072_10275"
          x1="446.461"
          y1="297.598"
          x2="446.461"
          y2="54.7185"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9E98C7" />
          <stop offset={1} stopColor="#8B6A92" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2072_10275"
          x1="598.71"
          y1="291.97"
          x2="598.71"
          y2="59.3201"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BDB9D9" />
          <stop offset={1} stopColor="#75699B" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2072_10275"
          x1="177.59"
          y1="186.6"
          x2="312.14"
          y2="186.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={1} stopColor="#987D8F" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2072_10275"
          x1="179.57"
          y1="255.17"
          x2="314.42"
          y2="255.17"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={1} stopColor="#987D8F" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2072_10275"
          x1="176.77"
          y1="122.99"
          x2="310.56"
          y2="122.99"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={1} stopColor="#987D8F" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_2072_10275"
          x1="235.37"
          y1="367.97"
          x2="235.37"
          y2="338.49"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={1} stopColor="#EEE6E3" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_2072_10275"
          x1="936.67"
          y1="356.97"
          x2="942.37"
          y2="324.65"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={1} stopColor="#EEE6E3" />
        </linearGradient>
        <radialGradient
          id="paint12_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(816.04 293.15) scale(31.85)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint13_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(846.04 279.93) scale(2.52)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint14_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(786.7 320.33) scale(2.52)"
        >
          <stop stopColor="#B998B4" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint15_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(788.24 292.81) scale(22.19)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint16_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(821.977 363.75) scale(9.73631 19.87)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint17_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(803.245 374.918) scale(8.59)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint18_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(795.966 374.24) scale(4.9302 6.6483)"
        >
          <stop stopColor="#B898B3" />
          <stop offset={1} stopColor="#7D5885" />
        </radialGradient>
        <radialGradient
          id="paint19_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(872.71 251.06) scale(59.43)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#B099B4" />
        </radialGradient>
        <linearGradient
          id="paint20_linear_2072_10275"
          x1="758.95"
          y1="324.88"
          x2="891.38"
          y2="324.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6E5F85" />
          <stop offset={1} stopColor="#3F1F49" />
        </linearGradient>
        <radialGradient
          id="paint21_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(872.34 253.6) scale(62.48)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint22_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(790.48 320.93) scale(22.38)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint23_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(891.57 182.6) scale(22.11)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#B099B4" />
        </radialGradient>
        <radialGradient
          id="paint24_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(855.51 304.616) scale(31.82 20.3648)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint25_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(892.95 217.025) scale(89.66 57.3824)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint26_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(836.864 335.09) scale(5.72401 11.3526)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint27_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(839.444 344.417) scale(15.48 8.25599)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint28_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(807.051 363.32) scale(21.857 19.87)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint29_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(777.63 373.86) scale(8.58999)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint30_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(776.662 373.812) scale(4.9302 6.64832)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint31_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(863.881 363.32) rotate(180) scale(21.857 19.87)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint32_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(846.488 363.32) rotate(180) scale(9.73631 19.87)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint33_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(892.5 373.86) rotate(180) scale(8.59002)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint34_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(890.137 373.812) rotate(180) scale(4.9302 6.64832)"
        >
          <stop stopColor="#B898B3" />
          <stop offset={1} stopColor="#7D5885" />
        </radialGradient>
        <radialGradient
          id="paint35_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(863.31 374.51) rotate(180) scale(8.59002)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint36_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(861.163 374.462) rotate(180) scale(4.9302 6.6483)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint37_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(886.15 186.92) scale(19.67)"
        >
          <stop stopColor="#7C7077" />
          <stop offset={1} stopColor="#242235" />
        </radialGradient>
        <radialGradient
          id="paint38_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(875.29 232.44) scale(10.07)"
        >
          <stop stopColor="#7C7077" />
          <stop offset={1} stopColor="#242235" />
        </radialGradient>
        <linearGradient
          id="paint39_linear_2072_10275"
          x1="854.69"
          y1="243.09"
          x2="854.69"
          y2="230.33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#242235" />
          <stop offset={1} stopColor="#7C7077" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_2072_10275"
          x1="856.04"
          y1="212.21"
          x2="856.04"
          y2="195.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#242235" />
          <stop offset={1} stopColor="#7C7077" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_2072_10275"
          x1="880.371"
          y1="208.69"
          x2="880.374"
          y2="208.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DA8E79" />
          <stop offset="0.46" stopColor="#E29B84" />
          <stop offset={1} stopColor="#F0B298" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_2072_10275"
          x1="805.591"
          y1="167.899"
          x2="806.885"
          y2="178.443"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DB8F79" />
          <stop offset="0.47" stopColor="#E39C85" />
          <stop offset={1} stopColor="#F0B299" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_2072_10275"
          x1="943.474"
          y1="179.725"
          x2="939.89"
          y2="189.716"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DB8F79" />
          <stop offset="0.47" stopColor="#E39C85" />
          <stop offset={1} stopColor="#F0B299" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_2072_10275"
          x1="879.407"
          y1="191.369"
          x2="879.733"
          y2="184.623"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C3A9" />
          <stop offset="0.53" stopColor="#F5C0A6" />
          <stop offset="0.87" stopColor="#F2B79E" />
          <stop offset={1} stopColor="#F0B299" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_2072_10275"
          x1="860.101"
          y1="188.77"
          x2="860.406"
          y2="182.334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C3A9" />
          <stop offset="0.53" stopColor="#F5C0A6" />
          <stop offset="0.87" stopColor="#F2B79E" />
          <stop offset={1} stopColor="#F0B299" />
        </linearGradient>
        <radialGradient
          id="paint46_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(880.947 194.864) rotate(7.61) scale(8.14999)"
        >
          <stop stopColor="#F8B09C" />
          <stop offset={1} stopColor="#F7C3A9" />
        </radialGradient>
        <radialGradient
          id="paint47_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(856.622 191.856) rotate(7.61) scale(8.31999)"
        >
          <stop stopColor="#F8B09C" />
          <stop offset={1} stopColor="#F7C3A9" />
        </radialGradient>
        <linearGradient
          id="paint48_linear_2072_10275"
          x1="886.337"
          y1="191.529"
          x2="880.374"
          y2="192.74"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBC6AF" />
          <stop offset={1} stopColor="#F7C3A9" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_2072_10275"
          x1="876.067"
          y1="204.362"
          x2="876.162"
          y2="203.577"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C3A9" />
          <stop offset="0.54" stopColor="#F5C0A6" />
          <stop offset="0.89" stopColor="#F2B79E" />
          <stop offset={1} stopColor="#F1B39A" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_2072_10275"
          x1="876.262"
          y1="213.094"
          x2="878.112"
          y2="197.209"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C3A9" />
          <stop offset="0.54" stopColor="#F5C0A6" />
          <stop offset="0.89" stopColor="#F2B79E" />
          <stop offset={1} stopColor="#F1B39A" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_2072_10275"
          x1="857.998"
          y1="211.38"
          x2="859.897"
          y2="195.129"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C3A9" />
          <stop offset="0.54" stopColor="#F5C0A6" />
          <stop offset="0.89" stopColor="#F2B79E" />
          <stop offset={1} stopColor="#F1B39A" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_2072_10275"
          x1="867.136"
          y1="215.931"
          x2="868.229"
          y2="204.878"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C3A9" />
          <stop offset="0.54" stopColor="#F5C0A6" />
          <stop offset="0.89" stopColor="#F2B79E" />
          <stop offset={1} stopColor="#F1B39A" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_2072_10275"
          x1="861.744"
          y1="201.691"
          x2="875.351"
          y2="203.751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D7DB" />
          <stop offset="0.14" stopColor="#EFE4E6" />
          <stop offset="0.39" stopColor="#FAF7F8" />
          <stop offset="0.57" stopColor="white" />
          <stop offset={1} stopColor="#E8D1D8" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_2072_10275"
          x1="867.175"
          y1="215.714"
          x2="868.227"
          y2="204.969"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C3A9" />
          <stop offset="0.54" stopColor="#F5C0A6" />
          <stop offset="0.89" stopColor="#F2B79E" />
          <stop offset={1} stopColor="#F1B39A" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_2072_10275"
          x1="868.766"
          y1="197.313"
          x2="868.304"
          y2="202.507"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D7DB" />
          <stop offset="0.4" stopColor="#EFE3E6" />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint56_linear_2072_10275"
          x1="866.606"
          y1="217.706"
          x2="869.208"
          y2="195.515"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C3A9" />
          <stop offset="0.54" stopColor="#F5C0A6" />
          <stop offset="0.89" stopColor="#F2B79E" />
          <stop offset={1} stopColor="#F1B39A" />
        </linearGradient>
        <linearGradient
          id="paint57_linear_2072_10275"
          x1="858.355"
          y1="189.677"
          x2="850.177"
          y2="186.476"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBC6AF" />
          <stop offset={1} stopColor="#F7C3A9" />
        </linearGradient>
        <linearGradient
          id="paint58_linear_2072_10275"
          x1="874.729"
          y1="186.356"
          x2="883.442"
          y2="190.012"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B299" />
          <stop offset="0.53" stopColor="#E39C85" />
          <stop offset={1} stopColor="#DB8F79" />
        </linearGradient>
        <linearGradient
          id="paint59_linear_2072_10275"
          x1="882.968"
          y1="189.484"
          x2="876.235"
          y2="186.87"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ECE7EA" />
          <stop offset="0.23" stopColor="#F5F3F4" />
          <stop offset="0.53" stopColor="#FCFCFC" />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint60_linear_2072_10275"
          x1="881.267"
          y1="188.168"
          x2="873.892"
          y2="187.485"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#935955" />
          <stop offset={1} stopColor="#5A3532" />
        </linearGradient>
        <linearGradient
          id="paint61_linear_2072_10275"
          x1="878.621"
          y1="187.511"
          x2="879.302"
          y2="193.363"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A3532" />
          <stop offset={1} stopColor="#935955" />
        </linearGradient>
        <radialGradient
          id="paint62_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(882.903 189.458) rotate(7.61002) scale(4.72939 4.7736)"
        >
          <stop stopColor="#2A3B33" />
          <stop offset={1} stopColor="#1C2721" />
        </radialGradient>
        <linearGradient
          id="paint63_linear_2072_10275"
          x1="874.772"
          y1="186.261"
          x2="883.321"
          y2="186.989"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#281B18" />
          <stop offset="0.45" stopColor="#2C1D1A" />
          <stop offset="0.92" stopColor="#382323" />
          <stop offset={1} stopColor="#3C2525" />
        </linearGradient>
        <linearGradient
          id="paint64_linear_2072_10275"
          x1="855.954"
          y1="183.787"
          x2="865.346"
          y2="187.725"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DB8F79" />
          <stop offset="0.47" stopColor="#E39C85" />
          <stop offset={1} stopColor="#F0B299" />
        </linearGradient>
        <linearGradient
          id="paint65_linear_2072_10275"
          x1="864.952"
          y1="187.198"
          x2="857.709"
          y2="184.395"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ECE7EA" />
          <stop offset="0.23" stopColor="#F5F3F4" />
          <stop offset="0.53" stopColor="#FCFCFC" />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint66_linear_2072_10275"
          x1="863.779"
          y1="185.932"
          x2="856.386"
          y2="185.237"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#935955" />
          <stop offset={1} stopColor="#5A3532" />
        </linearGradient>
        <linearGradient
          id="paint67_linear_2072_10275"
          x1="861.095"
          y1="185.18"
          x2="861.752"
          y2="190.837"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A3532" />
          <stop offset={1} stopColor="#935955" />
        </linearGradient>
        <radialGradient
          id="paint68_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(865.307 187.194) rotate(7.60998) scale(4.72941 4.7736)"
        >
          <stop stopColor="#2A3B33" />
          <stop offset={1} stopColor="#1C2721" />
        </radialGradient>
        <linearGradient
          id="paint69_linear_2072_10275"
          x1="856.2"
          y1="184.062"
          x2="864.699"
          y2="184.784"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#281B18" />
          <stop offset="0.45" stopColor="#2C1D1A" />
          <stop offset="0.92" stopColor="#382323" />
          <stop offset={1} stopColor="#3C2525" />
        </linearGradient>
        <linearGradient
          id="paint70_linear_2072_10275"
          x1="875.24"
          y1="180.946"
          x2="885.797"
          y2="182.356"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#281B18" />
          <stop offset="0.45" stopColor="#2C1D1A" />
          <stop offset="0.92" stopColor="#382323" />
          <stop offset={1} stopColor="#3C2525" />
        </linearGradient>
        <linearGradient
          id="paint71_linear_2072_10275"
          x1="855.723"
          y1="178.419"
          x2="866.279"
          y2="179.829"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#281B18" />
          <stop offset="0.45" stopColor="#2C1D1A" />
          <stop offset="0.92" stopColor="#382323" />
          <stop offset={1} stopColor="#3C2525" />
        </linearGradient>
        <linearGradient
          id="paint72_linear_2072_10275"
          x1="857.559"
          y1="212.099"
          x2="849.634"
          y2="190.317"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6C2AA" />
          <stop offset={1} stopColor="#F0B298" />
        </linearGradient>
        <linearGradient
          id="paint73_linear_2072_10275"
          x1="876.206"
          y1="215.326"
          x2="888.236"
          y2="197.17"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6C2AA" />
          <stop offset={1} stopColor="#FFC8B2" />
        </linearGradient>
        <linearGradient
          id="paint74_linear_2072_10275"
          x1="871.093"
          y1="177.476"
          x2="869.226"
          y2="194.549"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC9B3" />
          <stop offset="0.3" stopColor="#FBC6AE" />
          <stop offset={1} stopColor="#F7C3A9" />
        </linearGradient>
        <linearGradient
          id="paint75_linear_2072_10275"
          x1="868.811"
          y1="199.842"
          x2="869.097"
          y2="195.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C3A9" />
          <stop offset="0.53" stopColor="#F5C0A6" />
          <stop offset="0.87" stopColor="#F2B79E" />
          <stop offset={1} stopColor="#F0B299" />
        </linearGradient>
        <linearGradient
          id="paint76_linear_2072_10275"
          x1="869.858"
          y1="187.285"
          x2="868.864"
          y2="196.928"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C3A9" />
          <stop offset="0.54" stopColor="#F5C0A6" />
          <stop offset="0.89" stopColor="#F2B79E" />
          <stop offset={1} stopColor="#F1B39A" />
        </linearGradient>
        <linearGradient
          id="paint77_linear_2072_10275"
          x1="868.676"
          y1="195.343"
          x2="869.818"
          y2="191.178"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC9B3" />
          <stop offset="0.36" stopColor="#FAC5AD" />
          <stop offset={1} stopColor="#F7C3A9" />
        </linearGradient>
        <linearGradient
          id="paint78_linear_2072_10275"
          x1="873.204"
          y1="146.351"
          x2="870.422"
          y2="186.355"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C3A9" />
          <stop offset="0.43" stopColor="#F3B9A0" />
          <stop offset={1} stopColor="#F0B299" />
        </linearGradient>
        <linearGradient
          id="paint79_linear_2072_10275"
          x1="874.526"
          y1="138.043"
          x2="870.317"
          y2="188.571"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3C2525" />
          <stop offset="0.16" stopColor="#352120" />
          <stop offset="0.54" stopColor="#2B1C1A" />
          <stop offset={1} stopColor="#281B18" />
        </linearGradient>
        <linearGradient
          id="paint80_linear_2072_10275"
          x1="870.249"
          y1="189.611"
          x2="871.733"
          y2="154.418"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#281B18" />
          <stop offset="0.46" stopColor="#2B1C1A" />
          <stop offset="0.84" stopColor="#352120" />
          <stop offset={1} stopColor="#3C2525" />
        </linearGradient>
        <linearGradient
          id="paint81_linear_2072_10275"
          x1="863.774"
          y1="149.803"
          x2="872.579"
          y2="175.869"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4C3338" />
          <stop offset="0.04" stopColor="#4A3236" />
          <stop offset="0.54" stopColor="#3F2829" />
          <stop offset={1} stopColor="#3C2525" />
        </linearGradient>
        <linearGradient
          id="paint82_linear_2072_10275"
          x1="867.411"
          y1="206.696"
          x2="866.898"
          y2="213.407"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC9B3" />
          <stop offset="0.99" stopColor="#F7C3A9" />
          <stop offset={1} stopColor="#F7C3A9" />
        </linearGradient>
        <linearGradient
          id="paint83_linear_2072_10275"
          x1="866.554"
          y1="213.492"
          x2="867.435"
          y2="208.031"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7C3A9" />
          <stop offset="0.64" stopColor="#FAC5AD" />
          <stop offset={1} stopColor="#FFC9B3" />
        </linearGradient>
        <linearGradient
          id="paint84_linear_2072_10275"
          x1="868.458"
          y1="201.731"
          x2="866.179"
          y2="218.264"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DB8F79" />
          <stop offset="0.47" stopColor="#E39C85" />
          <stop offset={1} stopColor="#F0B299" />
        </linearGradient>
        <radialGradient
          id="paint85_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(873.59 288.34) scale(31.85)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint86_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(903.59 275.12) scale(2.52)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint87_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(844.25 315.51) scale(2.52)"
        >
          <stop stopColor="#B998B4" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint88_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(845.79 288) scale(22.19)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint89_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(399.248 290.51) rotate(180) scale(13.8123 16.4943)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint90_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(393.223 290.51) rotate(180) scale(13.7196 16.3836)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint91_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(324.456 290.51) scale(13.8123 16.4943)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint92_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(330.482 290.51) scale(13.7196 16.3836)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint93_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(358.739 249.54) rotate(180) scale(43.0231 41.77)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint94_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(342.351 223.38) rotate(-180) scale(74.8913 46.5344)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint95_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(369.6 339.14) rotate(-180) scale(7.18 14.36)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint96_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(384.47 347.23) rotate(180) scale(6.39629 6.21)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint97_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(383.159 346.525) rotate(180) scale(3.67199 4.806)"
        >
          <stop stopColor="#B898B3" />
          <stop offset={1} stopColor="#7D5885" />
        </radialGradient>
        <linearGradient
          id="paint98_linear_2072_10275"
          x1="399.04"
          y1="311.69"
          x2="320.72"
          y2="311.69"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6E5F85" />
          <stop offset={1} stopColor="#3F1F49" />
        </linearGradient>
        <radialGradient
          id="paint99_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(360.266 309.28) rotate(180) scale(27.8296 16.18)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint100_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(341.63 295.764) rotate(180) scale(19.9511 12.3968)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint101_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(360.472 314.741) rotate(180) scale(4.2435 8.21099)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint102_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(358.566 323.764) rotate(180) scale(11.4759 5.97119)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint103_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(383.036 338.83) rotate(180) scale(16.2268 14.36)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint104_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(404.429 346.45) rotate(180) scale(6.39631 6.21)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint105_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(398.064 346.214) rotate(180) scale(3.67201 4.806)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint106_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(343.219 338.83) scale(16.2268 14.36)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint107_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(348.155 338.83) scale(7.18 14.36)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint108_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(323.897 346.45) scale(6.39631 6.21)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint109_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(315.69 346.214) scale(3.67199 4.806)"
        >
          <stop stopColor="#B898B3" />
          <stop offset={1} stopColor="#7D5885" />
        </radialGradient>
        <radialGradient
          id="paint110_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(345.63 346.92) scale(6.39631 6.21)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint111_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(337.273 346.685) scale(3.67201 4.806)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint112_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(358.028 198.74) rotate(180) scale(21.012 20.4)"
        >
          <stop stopColor="#7C7077" />
          <stop offset={1} stopColor="#242235" />
        </radialGradient>
        <linearGradient
          id="paint113_linear_2072_10275"
          x1="382.75"
          y1="216.1"
          x2="382.75"
          y2="205.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#242235" />
          <stop offset={1} stopColor="#7C7077" />
        </linearGradient>
        <radialGradient
          id="paint114_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(358.563 231.25) rotate(180) scale(16.0989 15.6299)"
        >
          <stop stopColor="#7C7077" />
          <stop offset={1} stopColor="#242235" />
        </radialGradient>
        <linearGradient
          id="paint115_linear_2072_10275"
          x1="383.91"
          y1="234.69"
          x2="383.91"
          y2="227.81"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#242235" />
          <stop offset={1} stopColor="#7C7077" />
        </linearGradient>
        <linearGradient
          id="paint116_linear_2072_10275"
          x1="331.61"
          y1="268.24"
          x2="331.61"
          y2="248.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#242235" />
          <stop offset={1} stopColor="#7C7077" />
        </linearGradient>
        <radialGradient
          id="paint117_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(551.204 286.647) rotate(180) scale(13.8123 16.4943)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint118_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(545.179 286.647) rotate(180) scale(13.7197 16.3836)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint119_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(476.412 286.647) scale(13.8123 16.4943)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint120_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(482.438 286.647) scale(13.7196 16.3836)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint121_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(510.694 245.69) rotate(180) scale(43.0231 41.77)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint122_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(494.317 219.534) rotate(-180) scale(74.8913 46.5344)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint123_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(520.565 335.3) rotate(180) scale(7.18001 14.36)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint124_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(536.436 343.38) rotate(180) scale(6.39629 6.21)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint125_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(534.071 342.689) rotate(180) scale(3.67201 4.806)"
        >
          <stop stopColor="#B898B3" />
          <stop offset={1} stopColor="#7D5885" />
        </radialGradient>
        <linearGradient
          id="paint126_linear_2072_10275"
          x1="550.4"
          y1="307.84"
          x2="472.07"
          y2="307.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6E5F85" />
          <stop offset={1} stopColor="#3F1F49" />
        </linearGradient>
        <radialGradient
          id="paint127_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(511.763 305.43) rotate(180) scale(27.8296 16.18)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint128_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(493.586 291.918) rotate(180) scale(19.9511 12.3968)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint129_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(512.008 310.885) rotate(180) scale(4.2435 8.21101)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint130_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(510.102 319.924) rotate(180) scale(11.4759 5.97121)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint131_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(534.851 334.98) rotate(180) scale(16.2268 14.36)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint132_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(556.385 342.6) rotate(180) scale(6.39629 6.20998)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint133_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(548.976 342.378) rotate(180) scale(3.67201 4.806)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint134_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(495.034 334.98) scale(16.2268 14.36)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint135_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(499.12 334.98) scale(7.18 14.36)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint136_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(475.853 342.6) scale(6.39629 6.20998)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint137_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(466.602 342.378) scale(3.67199 4.806)"
        >
          <stop stopColor="#B898B3" />
          <stop offset={1} stopColor="#7D5885" />
        </radialGradient>
        <radialGradient
          id="paint138_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(497.586 343.07) scale(6.39629 6.20998)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint139_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(488.185 342.849) scale(3.67199 4.806)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint140_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(509.994 194.89) rotate(180) scale(21.012 20.4)"
        >
          <stop stopColor="#7C7077" />
          <stop offset={1} stopColor="#242235" />
        </radialGradient>
        <linearGradient
          id="paint141_linear_2072_10275"
          x1="534.1"
          y1="212.25"
          x2="534.1"
          y2="201.37"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#242235" />
          <stop offset={1} stopColor="#7C7077" />
        </linearGradient>
        <radialGradient
          id="paint142_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(510.519 227.4) rotate(180) scale(16.0989 15.63)"
        >
          <stop stopColor="#7C7077" />
          <stop offset={1} stopColor="#242235" />
        </radialGradient>
        <linearGradient
          id="paint143_linear_2072_10275"
          x1="535.26"
          y1="230.84"
          x2="535.26"
          y2="223.96"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#242235" />
          <stop offset={1} stopColor="#7C7077" />
        </linearGradient>
        <linearGradient
          id="paint144_linear_2072_10275"
          x1="482.96"
          y1="264.39"
          x2="482.96"
          y2="245.12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#242235" />
          <stop offset={1} stopColor="#7C7077" />
        </linearGradient>
        <radialGradient
          id="paint145_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(701.131 288.16) rotate(180) scale(13.8123 16.4943)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint146_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(695.106 288.16) rotate(180) scale(13.7197 16.3836)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint147_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(626.339 288.16) scale(13.8123 16.4943)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint148_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(632.364 288.16) scale(13.7197 16.3836)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint149_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(660.621 247.19) rotate(180) scale(43.0231 41.77)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint150_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(644.234 221.038) rotate(180) scale(74.8913 46.5344)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint151_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(669.5 336.8) rotate(-180) scale(7.18001 14.36)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint152_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(686.353 344.89) rotate(180) scale(6.39629 6.21)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint153_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(682.958 344.185) rotate(180) scale(3.67201 4.806)"
        >
          <stop stopColor="#B898B3" />
          <stop offset={1} stopColor="#7D5885" />
        </radialGradient>
        <linearGradient
          id="paint154_linear_2072_10275"
          x1="699.72"
          y1="309.34"
          x2="621.4"
          y2="309.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6E5F85" />
          <stop offset={1} stopColor="#3F1F49" />
        </linearGradient>
        <radialGradient
          id="paint155_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(661.231 306.94) rotate(180) scale(27.8296 16.18)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint156_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(643.503 293.422) rotate(180) scale(19.9511 12.3968)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint157_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(661.515 312.408) rotate(180) scale(4.2435 8.21101)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#9F84A5" />
        </radialGradient>
        <radialGradient
          id="paint158_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(659.608 321.422) rotate(180) scale(11.4759 5.9712)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint159_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(684.622 336.49) rotate(180) scale(16.2268 14.36)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint160_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(706.312 344.11) rotate(180) scale(6.39629 6.20998)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint161_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(697.862 343.882) rotate(180) scale(3.67201 4.806)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint162_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(644.816 336.49) scale(16.2268 14.36)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint163_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(648.055 336.49) scale(7.18001 14.36)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint164_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(625.769 344.11) scale(6.39629 6.20998)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint165_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(615.488 343.882) scale(3.67201 4.806)"
        >
          <stop stopColor="#B898B3" />
          <stop offset={1} stopColor="#7D5885" />
        </radialGradient>
        <radialGradient
          id="paint166_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(647.502 344.58) scale(6.39629 6.21)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <radialGradient
          id="paint167_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(637.071 344.345) scale(3.67201 4.806)"
        >
          <stop stopColor="#E5D9E3" />
          <stop offset={1} stopColor="#8A6991" />
        </radialGradient>
        <radialGradient
          id="paint168_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(659.91 196.39) rotate(180) scale(21.012 20.4)"
        >
          <stop stopColor="#7C7077" />
          <stop offset={1} stopColor="#242235" />
        </radialGradient>
        <linearGradient
          id="paint169_linear_2072_10275"
          x1="683.42"
          y1="213.76"
          x2="683.42"
          y2="202.87"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#242235" />
          <stop offset={1} stopColor="#7C7077" />
        </linearGradient>
        <radialGradient
          id="paint170_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(660.446 228.91) rotate(180) scale(16.0989 15.63)"
        >
          <stop stopColor="#7C7077" />
          <stop offset={1} stopColor="#242235" />
        </radialGradient>
        <linearGradient
          id="paint171_linear_2072_10275"
          x1="684.59"
          y1="232.35"
          x2="684.59"
          y2="225.46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#242235" />
          <stop offset={1} stopColor="#7C7077" />
        </linearGradient>
        <linearGradient
          id="paint172_linear_2072_10275"
          x1="632.29"
          y1="265.89"
          x2="632.29"
          y2="246.62"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#242235" />
          <stop offset={1} stopColor="#7C7077" />
        </linearGradient>
        <linearGradient
          id="paint173_linear_2072_10275"
          x1="493.91"
          y1="527.9"
          x2="495.04"
          y2="397.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#333333" />
          <stop offset={1} stopColor="#212121" />
        </linearGradient>
        <linearGradient
          id="paint174_linear_2072_10275"
          x1="495.22"
          y1="554.15"
          x2="489.56"
          y2="340.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#333333" />
          <stop offset={1} stopColor="#212121" />
        </linearGradient>
        <linearGradient
          id="paint175_linear_2072_10275"
          x1="520.74"
          y1="527.9"
          x2="519.62"
          y2="397.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#333333" />
          <stop offset={1} stopColor="#212121" />
        </linearGradient>
        <linearGradient
          id="paint176_linear_2072_10275"
          x1="519.41"
          y1="554.15"
          x2="525.07"
          y2="340.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#333333" />
          <stop offset={1} stopColor="#212121" />
        </linearGradient>
        <linearGradient
          id="paint177_linear_2072_10275"
          x1="513.05"
          y1="213.95"
          x2="505.17"
          y2="194.52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.51" stopColor="#E3B086" />
          <stop offset={1} stopColor="#DBA379" />
        </linearGradient>
        <linearGradient
          id="paint178_linear_2072_10275"
          x1="506.66"
          y1="241.57"
          x2="508.19"
          y2="206.53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset="0.64" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint179_linear_2072_10275"
          x1="541.1"
          y1="261.12"
          x2="528.94"
          y2="216.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E1E1E5" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint180_linear_2072_10275"
          x1="474.42"
          y1="260.58"
          x2="486.36"
          y2="216.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E1E1E5" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint181_linear_2072_10275"
          x1="507.111"
          y1="213.356"
          x2="506.818"
          y2="208.814"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint182_linear_2072_10275"
          x1="460.16"
          y1="212.77"
          x2="450.5"
          y2="237.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint183_linear_2072_10275"
          x1="448.97"
          y1="225.42"
          x2="448.42"
          y2="219.26"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint184_linear_2072_10275"
          x1="459.37"
          y1="175.947"
          x2="475.325"
          y2="203.691"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint185_linear_2072_10275"
          x1="459.985"
          y1="187.916"
          x2="465.457"
          y2="197.445"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint186_linear_2072_10275"
          x1="459.37"
          y1="182.692"
          x2="456.088"
          y2="202.403"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint187_linear_2072_10275"
          x1="444.852"
          y1="197.927"
          x2="458.316"
          y2="221.332"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint188_linear_2072_10275"
          x1="457.301"
          y1="175.7"
          x2="468.88"
          y2="195.825"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint189_linear_2072_10275"
          x1="458.793"
          y1="192.22"
          x2="466.631"
          y2="205.85"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint190_linear_2072_10275"
          x1="459.701"
          y1="194.378"
          x2="471.654"
          y2="215.154"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint191_linear_2072_10275"
          x1="451.542"
          y1="190.72"
          x2="450.029"
          y2="199.81"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint192_linear_2072_10275"
          x1="450.182"
          y1="193.347"
          x2="458.672"
          y2="208.09"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint193_linear_2072_10275"
          x1="452.887"
          y1="189.721"
          x2="460.95"
          y2="203.729"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint194_linear_2072_10275"
          x1="456.022"
          y1="184.206"
          x2="458.777"
          y2="188.982"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint195_linear_2072_10275"
          x1="459.943"
          y1="201.019"
          x2="454.954"
          y2="208.94"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint196_linear_2072_10275"
          x1="457.333"
          y1="210.243"
          x2="462.087"
          y2="218.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint197_linear_2072_10275"
          x1="458.07"
          y1="191.55"
          x2="459.36"
          y2="185.53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint198_linear_2072_10275"
          x1="466.6"
          y1="218.56"
          x2="443.03"
          y2="219.64"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint199_linear_2072_10275"
          x1="439.54"
          y1="263.11"
          x2="436.8"
          y2="209.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint200_linear_2072_10275"
          x1="448.75"
          y1="215.4"
          x2="431.31"
          y2="255.42"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint201_linear_2072_10275"
          x1="504.848"
          y1="210.105"
          x2="507.766"
          y2="209.987"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset="0.64" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint202_linear_2072_10275"
          x1="522.023"
          y1="189.59"
          x2="520.994"
          y2="196.093"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.51" stopColor="#E3B086" />
          <stop offset={1} stopColor="#DBA379" />
        </linearGradient>
        <linearGradient
          id="paint203_linear_2072_10275"
          x1="481.31"
          y1="238.03"
          x2="435.67"
          y2="252.54"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E1E1E5" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint204_linear_2072_10275"
          x1="506.761"
          y1="195.506"
          x2="506.844"
          y2="230.791"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint205_linear_2072_10275"
          x1="477.9"
          y1="247.12"
          x2="488.85"
          y2="205.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1D0D4" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint206_linear_2072_10275"
          x1="503.252"
          y1="209.969"
          x2="511.523"
          y2="219.273"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset="0.64" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint207_linear_2072_10275"
          x1="537.51"
          y1="247.62"
          x2="526.3"
          y2="204.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1D0D4" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint208_linear_2072_10275"
          x1="507.96"
          y1="250.17"
          x2="505.11"
          y2="216.87"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#333333" />
          <stop offset="0.75" stopColor="#3B3B3B" />
          <stop offset={1} stopColor="#3F3F3F" />
        </linearGradient>
        <linearGradient
          id="paint209_linear_2072_10275"
          x1="535.21"
          y1="222.4"
          x2="535.42"
          y2="302.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#333333" />
          <stop offset={1} stopColor="#212121" />
        </linearGradient>
        <linearGradient
          id="paint210_linear_2072_10275"
          x1="479.32"
          y1="222.36"
          x2="479.53"
          y2="298.42"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#333333" />
          <stop offset={1} stopColor="#212121" />
        </linearGradient>
        <linearGradient
          id="paint211_linear_2072_10275"
          x1="515.53"
          y1="180.41"
          x2="515.715"
          y2="262.909"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint212_linear_2072_10275"
          x1="498.922"
          y1="182.259"
          x2="498.759"
          y2="258.244"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint213_linear_2072_10275"
          x1="525.52"
          y1="219.26"
          x2="523.81"
          y2="196.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#333333" />
          <stop offset={1} stopColor="#212121" />
        </linearGradient>
        <linearGradient
          id="paint214_linear_2072_10275"
          x1="513.37"
          y1="200.553"
          x2="515.551"
          y2="202.997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset="0.64" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint215_linear_2072_10275"
          x1="496.933"
          y1="197.974"
          x2="504.229"
          y2="206.176"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset="0.64" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint216_linear_2072_10275"
          x1="534.55"
          y1="288.31"
          x2="529.14"
          y2="293.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint217_linear_2072_10275"
          x1="590.77"
          y1="239.6"
          x2="539.53"
          y2="281.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint218_linear_2072_10275"
          x1="541.71"
          y1="277.82"
          x2="541.49"
          y2="261.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint219_linear_2072_10275"
          x1="552.95"
          y1="267.97"
          x2="522.19"
          y2="286.68"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint220_linear_2072_10275"
          x1="556.56"
          y1="271.76"
          x2="524.69"
          y2="291.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint221_linear_2072_10275"
          x1="553.39"
          y1="278.44"
          x2="532.66"
          y2="291.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint222_linear_2072_10275"
          x1="531.46"
          y1="285.63"
          x2="525.7"
          y2="291.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint223_linear_2072_10275"
          x1="529.69"
          y1="277.44"
          x2="523.48"
          y2="282.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint224_linear_2072_10275"
          x1="538.91"
          y1="290.31"
          x2="535.54"
          y2="293.09"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint225_linear_2072_10275"
          x1="542.64"
          y1="297.41"
          x2="549.35"
          y2="278.95"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint226_linear_2072_10275"
          x1="552.91"
          y1="276.73"
          x2="545.06"
          y2="270.66"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint227_linear_2072_10275"
          x1="548.57"
          y1="226.39"
          x2="547.66"
          y2="257.57"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint228_linear_2072_10275"
          x1="570.62"
          y1="245.13"
          x2="552.06"
          y2="275.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint229_linear_2072_10275"
          x1="578.86"
          y1="259.22"
          x2="534.6"
          y2="205.83"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.36" stopColor="#F8F8FA" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint230_linear_2072_10275"
          x1="487.19"
          y1="187.05"
          x2="474.36"
          y2="216.49"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="#F1F0F5" />
        </linearGradient>
        <linearGradient
          id="paint231_linear_2072_10275"
          x1="438.707"
          y1="164.994"
          x2="440.956"
          y2="173.638"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint232_linear_2072_10275"
          x1="572.584"
          y1="160.4"
          x2="570.71"
          y2="169.117"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint233_linear_2072_10275"
          x1="515.22"
          y1="178.76"
          x2="514.75"
          y2="173.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.52" stopColor="#F5D1A8" />
          <stop offset="0.85" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <radialGradient
          id="paint234_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(526.435 182.121) rotate(177.87) scale(8.16001 5.7936)"
        >
          <stop stopColor="#F8C39C" />
          <stop offset={1} stopColor="#F7D4AB" />
        </radialGradient>
        <linearGradient
          id="paint235_linear_2072_10275"
          x1="498.47"
          y1="178.68"
          x2="498.01"
          y2="173.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.52" stopColor="#F5D1A8" />
          <stop offset="0.85" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <radialGradient
          id="paint236_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(516.289 180.323) rotate(-3.63) scale(8.47999 5.8512)"
        >
          <stop stopColor="#F8C39C" />
          <stop offset={1} stopColor="#F7D4AB" />
        </radialGradient>
        <linearGradient
          id="paint237_linear_2072_10275"
          x1="521.1"
          y1="178.09"
          x2="516.21"
          y2="179.78"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBD6AF" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint238_linear_2072_10275"
          x1="497.3"
          y1="179.68"
          x2="490.05"
          y2="177.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBD6AF" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint239_linear_2072_10275"
          x1="518.7"
          y1="174.26"
          x2="509.81"
          y2="176.77"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.51" stopColor="#E3B086" />
          <stop offset={1} stopColor="#DBA379" />
        </linearGradient>
        <linearGradient
          id="paint240_linear_2072_10275"
          x1="511.04"
          y1="175.99"
          x2="519.21"
          y2="175.28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.47" stopColor="#FCFCFC" />
          <stop offset="0.77" stopColor="#F5F3F3" />
          <stop offset={1} stopColor="#ECE7E7" />
        </linearGradient>
        <linearGradient
          id="paint241_linear_2072_10275"
          x1="516.56"
          y1="175.97"
          x2="511.86"
          y2="175.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B89C8C" />
          <stop offset={1} stopColor="#715241" />
        </linearGradient>
        <linearGradient
          id="paint242_linear_2072_10275"
          x1="518.94"
          y1="154.4"
          x2="517.32"
          y2="161.79"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B89C8C" />
          <stop offset={1} stopColor="#715241" />
        </linearGradient>
        <radialGradient
          id="paint243_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(498.253 176.696) rotate(180) scale(4.11948 4.15801)"
        >
          <stop stopColor="#2A3A3B" />
          <stop offset={1} stopColor="#1C2727" />
        </radialGradient>
        <linearGradient
          id="paint244_linear_2072_10275"
          x1="518.32"
          y1="174.89"
          x2="511.26"
          y2="174.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#421F16" />
          <stop offset="0.32" stopColor="#462017" />
          <stop offset="0.66" stopColor="#52261C" />
          <stop offset={1} stopColor="#673024" />
        </linearGradient>
        <linearGradient
          id="paint245_linear_2072_10275"
          x1="494.73"
          y1="174.26"
          x2="503.62"
          y2="176.77"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.51" stopColor="#E3B086" />
          <stop offset={1} stopColor="#DBA379" />
        </linearGradient>
        <linearGradient
          id="paint246_linear_2072_10275"
          x1="502.38"
          y1="175.99"
          x2="494.22"
          y2="175.28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.47" stopColor="#FCFCFC" />
          <stop offset="0.77" stopColor="#F5F3F3" />
          <stop offset={1} stopColor="#ECE7E7" />
        </linearGradient>
        <linearGradient
          id="paint247_linear_2072_10275"
          x1="496.87"
          y1="175.97"
          x2="501.57"
          y2="175.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#715241" />
          <stop offset={1} stopColor="#B89C8C" />
        </linearGradient>
        <linearGradient
          id="paint248_linear_2072_10275"
          x1="494.48"
          y1="154.4"
          x2="496.11"
          y2="161.79"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B89C8C" />
          <stop offset={1} stopColor="#715241" />
        </linearGradient>
        <radialGradient
          id="paint249_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(502.091 -145.771) scale(4.11952 4.15801)"
        >
          <stop stopColor="#2A3A3B" />
          <stop offset={1} stopColor="#1C2727" />
        </radialGradient>
        <linearGradient
          id="paint250_linear_2072_10275"
          x1="495.1"
          y1="174.89"
          x2="502.17"
          y2="174.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#421F16" />
          <stop offset="0.32" stopColor="#462017" />
          <stop offset="0.66" stopColor="#52261C" />
          <stop offset={1} stopColor="#673024" />
        </linearGradient>
        <linearGradient
          id="paint251_linear_2072_10275"
          x1="498.72"
          y1="198.72"
          x2="490.3"
          y2="182.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6D2AA" />
          <stop offset={1} stopColor="#F0C498" />
        </linearGradient>
        <linearGradient
          id="paint252_linear_2072_10275"
          x1="515.21"
          y1="199.55"
          x2="523.32"
          y2="182.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6D2AA" />
          <stop offset={1} stopColor="#FFD8B2" />
        </linearGradient>
        <linearGradient
          id="paint253_linear_2072_10275"
          x1="504.77"
          y1="141.95"
          x2="506.91"
          y2="175.59"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.45" stopColor="#F3CAA0" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint254_linear_2072_10275"
          x1="504.39"
          y1="145.72"
          x2="507.08"
          y2="186.69"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#673024" />
          <stop offset="0.34" stopColor="#52261C" />
          <stop offset="0.68" stopColor="#462017" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint255_linear_2072_10275"
          x1="499.93"
          y1="130.741"
          x2="500.13"
          y2="156.447"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#673024" />
          <stop offset="0.34" stopColor="#52261C" />
          <stop offset="0.68" stopColor="#462017" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint256_linear_2072_10275"
          x1="504.87"
          y1="148.59"
          x2="505.66"
          y2="161.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#673024" />
          <stop offset="0.34" stopColor="#52261C" />
          <stop offset="0.68" stopColor="#462017" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint257_linear_2072_10275"
          x1="497.79"
          y1="146.98"
          x2="515.04"
          y2="172.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.31" stopColor="#EAEAEB" />
          <stop offset="0.73" stopColor="#D4D4D7" />
          <stop offset={1} stopColor="#CCCCD0" />
        </linearGradient>
        <linearGradient
          id="paint258_linear_2072_10275"
          x1="493.95"
          y1="141.83"
          x2="505.25"
          y2="165.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCCCD0" />
          <stop offset={1} stopColor="#B6B6BA" />
        </linearGradient>
        <linearGradient
          id="paint259_linear_2072_10275"
          x1="503.6"
          y1="176.79"
          x2="507.1"
          y2="150.81"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AAAAAD" />
          <stop offset={1} stopColor="#B6B6BA" />
        </linearGradient>
        <linearGradient
          id="paint260_linear_2072_10275"
          x1="488.41"
          y1="131.2"
          x2="507.24"
          y2="159.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.31" stopColor="#EAEAEB" />
          <stop offset="0.73" stopColor="#D4D4D7" />
          <stop offset={1} stopColor="#CCCCD0" />
        </linearGradient>
        <linearGradient
          id="paint261_linear_2072_10275"
          x1="518.31"
          y1="153.95"
          x2="527.93"
          y2="168.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCCCD0" />
          <stop offset={1} stopColor="#B6B6BA" />
        </linearGradient>
        <linearGradient
          id="paint262_linear_2072_10275"
          x1="507.64"
          y1="192.91"
          x2="507.19"
          y2="202.03"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.28" stopColor="#FBD6AF" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint263_linear_2072_10275"
          x1="514.76"
          y1="196.67"
          x2="514.55"
          y2="183.87"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.53" stopColor="#F6D1A8" />
          <stop offset="0.87" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F1C59A" />
        </linearGradient>
        <linearGradient
          id="paint264_linear_2072_10275"
          x1="513.68"
          y1="189.77"
          x2="513.67"
          y2="189.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.53" stopColor="#F6D1A8" />
          <stop offset="0.87" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F1C59A" />
        </linearGradient>
        <linearGradient
          id="paint265_linear_2072_10275"
          x1="513.5"
          y1="186.72"
          x2="515.5"
          y2="186.72"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.53" stopColor="#F6D1A8" />
          <stop offset="0.87" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F1C59A" />
        </linearGradient>
        <linearGradient
          id="paint266_linear_2072_10275"
          x1="500.09"
          y1="197.25"
          x2="499.88"
          y2="184.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.53" stopColor="#F6D1A8" />
          <stop offset="0.87" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F1C59A" />
        </linearGradient>
        <linearGradient
          id="paint267_linear_2072_10275"
          x1="499.07"
          y1="186.82"
          x2="501.08"
          y2="186.82"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.53" stopColor="#F6D1A8" />
          <stop offset="0.87" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F1C59A" />
        </linearGradient>
        <linearGradient
          id="paint268_linear_2072_10275"
          x1="507.82"
          y1="199.89"
          x2="507.52"
          y2="191.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.53" stopColor="#F6D1A8" />
          <stop offset="0.87" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F1C59A" />
        </linearGradient>
        <linearGradient
          id="paint269_linear_2072_10275"
          x1="502.04"
          y1="189.16"
          x2="513.05"
          y2="189.35"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D9D7" />
          <stop offset="0.14" stopColor="#EFE5E4" />
          <stop offset="0.39" stopColor="#FAF8F7" />
          <stop offset="0.57" stopColor="white" />
          <stop offset={1} stopColor="#E8D3D1" />
        </linearGradient>
        <linearGradient
          id="paint270_linear_2072_10275"
          x1="507.83"
          y1="199.71"
          x2="507.53"
          y2="191.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.53" stopColor="#F6D1A8" />
          <stop offset="0.87" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F1C59A" />
        </linearGradient>
        <linearGradient
          id="paint271_linear_2072_10275"
          x1="507.14"
          y1="184.95"
          x2="507.32"
          y2="189.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D9D7" />
          <stop offset="0.4" stopColor="#EFE5E3" />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint272_linear_2072_10275"
          x1="507.59"
          y1="201.35"
          x2="507.3"
          y2="183.47"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.53" stopColor="#F6D1A8" />
          <stop offset="0.87" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F1C59A" />
        </linearGradient>
        <linearGradient
          id="paint273_linear_2072_10275"
          x1="506.9"
          y1="165.79"
          x2="507.31"
          y2="182.71"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.2" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint274_linear_2072_10275"
          x1="510.73"
          y1="190.24"
          x2="510.52"
          y2="184.72"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.51" stopColor="#E3B086" />
          <stop offset={1} stopColor="#DBA379" />
        </linearGradient>
        <linearGradient
          id="paint275_linear_2072_10275"
          x1="504.3"
          y1="190.48"
          x2="504.09"
          y2="184.96"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.51" stopColor="#E3B086" />
          <stop offset={1} stopColor="#DBA379" />
        </linearGradient>
        <linearGradient
          id="paint276_linear_2072_10275"
          x1={507}
          y1="175.09"
          x2="507.28"
          y2="184.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.51" stopColor="#F4CEA5" />
          <stop offset={1} stopColor="#F1C59A" />
        </linearGradient>
        <linearGradient
          id="paint277_linear_2072_10275"
          x1="506.87"
          y1="183.22"
          x2="507.44"
          y2={179}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.28" stopColor="#FBD6AF" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint278_linear_2072_10275"
          x1="506.08"
          y1="168.2"
          x2="518.42"
          y2="172.12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#673024" />
          <stop offset="0.34" stopColor="#52261C" />
          <stop offset="0.68" stopColor="#462017" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint279_linear_2072_10275"
          x1="507.37"
          y1="168.8"
          x2="492.5"
          y2="171.82"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#673024" />
          <stop offset="0.34" stopColor="#52261C" />
          <stop offset="0.68" stopColor="#462017" />
          <stop offset={1} stopColor="#421F16" />
        </linearGradient>
        <linearGradient
          id="paint280_linear_2072_10275"
          x1="509.17"
          y1="192.26"
          x2="508.36"
          y2="195.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.51" stopColor="#E3B086" />
          <stop offset={1} stopColor="#DBA379" />
        </linearGradient>
        <linearGradient
          id="paint281_linear_2072_10275"
          x1="488.99"
          y1="219.28"
          x2="490.69"
          y2="196.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#333333" />
          <stop offset={1} stopColor="#212121" />
        </linearGradient>
        <radialGradient
          id="paint282_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(692.08 235.19) scale(18.79)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint283_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(688.4 241.35) scale(12.04)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint284_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(693.02 226.78) scale(11)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint285_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(611.57 247.43) scale(29.23)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint286_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(613.97 250.7) rotate(180) scale(16.87)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint287_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(606.63 235.23) rotate(180) scale(8.66)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint288_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(607.75 263.27) rotate(180) scale(13.35)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <linearGradient
          id="paint289_linear_2072_10275"
          x1="640.42"
          y1="206.35"
          x2="672.49"
          y2="206.35"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <radialGradient
          id="paint290_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(657.77 209.18) scale(2.66002)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <linearGradient
          id="paint291_linear_2072_10275"
          x1="696.75"
          y1="227.33"
          x2="683.95"
          y2="229.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#908989" />
          <stop offset="0.49" stopColor="#848282" />
          <stop offset={1} stopColor="#7F7F7F" />
        </linearGradient>
        <radialGradient
          id="paint292_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(657.69 201.6) scale(13.15)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <linearGradient
          id="paint293_linear_2072_10275"
          x1="657.39"
          y1="216.42"
          x2="657.21"
          y2="198.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#908989" />
          <stop offset="0.49" stopColor="#848282" />
          <stop offset={1} stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id="paint294_linear_2072_10275"
          x1="656.14"
          y1="241.24"
          x2="657.58"
          y2="208.29"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#908989" />
          <stop offset={1} stopColor="#919191" />
        </linearGradient>
        <linearGradient
          id="paint295_linear_2072_10275"
          x1="682.22"
          y1="262.07"
          x2="680.99"
          y2="220.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#908989" />
          <stop offset="0.49" stopColor="#848282" />
          <stop offset={1} stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id="paint296_linear_2072_10275"
          x1="635.89"
          y1="190.14"
          x2="632.58"
          y2="250.99"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#908989" />
          <stop offset={1} stopColor="#919191" />
        </linearGradient>
        <linearGradient
          id="paint297_linear_2072_10275"
          x1="681.92"
          y1="188.46"
          x2="678.49"
          y2="251.68"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#908989" />
          <stop offset="0.49" stopColor="#848282" />
          <stop offset={1} stopColor="#7F7F7F" />
        </linearGradient>
        <linearGradient
          id="paint298_linear_2072_10275"
          x1="657.9"
          y1="327.84"
          x2="655.45"
          y2="280.59"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1834" />
          <stop offset={1} stopColor="#1B2C60" />
        </linearGradient>
        <linearGradient
          id="paint299_linear_2072_10275"
          x1="653.66"
          y1="281.44"
          x2="662.22"
          y2="359.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1834" />
          <stop offset={1} stopColor="#1B2C60" />
        </linearGradient>
        <linearGradient
          id="paint300_linear_2072_10275"
          x1="637.767"
          y1="312.507"
          x2="652.185"
          y2="402.529"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint301_linear_2072_10275"
          x1="656.77"
          y1="296.59"
          x2="665.09"
          y2="332.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint302_linear_2072_10275"
          x1="678.496"
          y1="312.791"
          x2="671.566"
          y2="403.695"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint303_linear_2072_10275"
          x1="654.51"
          y1="253.51"
          x2="656.93"
          y2="225.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint304_linear_2072_10275"
          x1="656.25"
          y1="257.37"
          x2="657.53"
          y2="228.66"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#0D1834" />
        </linearGradient>
        <linearGradient
          id="paint305_linear_2072_10275"
          x1="656.33"
          y1="256.31"
          x2="657.55"
          y2="228.74"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#0D1834" />
        </linearGradient>
        <linearGradient
          id="paint306_linear_2072_10275"
          x1="639.99"
          y1="216.36"
          x2="674.84"
          y2="216.36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#0D1834" />
        </linearGradient>
        <linearGradient
          id="paint307_linear_2072_10275"
          x1="635.91"
          y1="212.81"
          x2="635.47"
          y2="204.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint308_linear_2072_10275"
          x1="679.35"
          y1="212.44"
          x2="678.88"
          y2="203.26"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint309_linear_2072_10275"
          x1="660.28"
          y1="241.01"
          x2="704.18"
          y2="287.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#0D1834" />
        </linearGradient>
        <linearGradient
          id="paint310_linear_2072_10275"
          x1="631.68"
          y1="216.24"
          x2="633.21"
          y2="301.27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#0D1834" />
        </linearGradient>
        <linearGradient
          id="paint311_linear_2072_10275"
          x1="680.63"
          y1="216.37"
          x2="682.17"
          y2="302.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#0D1834" />
        </linearGradient>
        <linearGradient
          id="paint312_linear_2072_10275"
          x1="656.17"
          y1="221.58"
          x2="657.63"
          y2="302.52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1834" />
          <stop offset={1} stopColor="#1B2C60" />
        </linearGradient>
        <linearGradient
          id="paint313_linear_2072_10275"
          x1="630.44"
          y1="283.45"
          x2="640.1"
          y2="283.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1834" />
          <stop offset={1} stopColor="#1B2C60" />
        </linearGradient>
        <linearGradient
          id="paint314_linear_2072_10275"
          x1="684.46"
          y1="283.45"
          x2="674.28"
          y2="283.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1834" />
          <stop offset={1} stopColor="#1B2C60" />
        </linearGradient>
        <linearGradient
          id="paint315_linear_2072_10275"
          x1="678.24"
          y1="305.27"
          x2="679.68"
          y2="277.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint316_linear_2072_10275"
          x1="634.24"
          y1="303.27"
          x2="635.69"
          y2="275.38"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint317_linear_2072_10275"
          x1="650.54"
          y1="250.12"
          x2="693.95"
          y2="296.28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#0D1834" />
        </linearGradient>
        <linearGradient
          id="paint318_linear_2072_10275"
          x1="606.69"
          y1="215.34"
          x2="625.1"
          y2="238.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#908989" />
          <stop offset="0.49" stopColor="#848282" />
          <stop offset={1} stopColor="#7F7F7F" />
        </linearGradient>
        <radialGradient
          id="paint319_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(631.51 284.52) scale(13.32)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint320_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(637.87 293.66) rotate(180) scale(2.56)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint321_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(639.41 294.9) scale(1.10999)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint322_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(626.03 282.6) rotate(180) scale(5.68999)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint323_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(628.32 274.62) rotate(180) scale(6.77001)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint324_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(623.03 285.38) rotate(180) scale(10.48)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint325_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(639.42 284.87) rotate(180) scale(5.2)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint326_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(636.14 288.76) rotate(180) scale(5.02001)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint327_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(631.87 290.11) rotate(180) scale(3.29)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint328_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(640.9 291.26) rotate(180) scale(2.67)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint329_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(642.46 292.79) scale(1.11002)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint330_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(643.07 283.54) rotate(180) scale(2.52002)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint331_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(644.99 285.18) scale(1.17001)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint332_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(633.02 294.6) rotate(180) scale(1.48)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint333_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(633.68 295.3) scale(0.859983)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint334_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(685.59 260.86) scale(12.78)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint335_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(683.73 260.19) scale(9.99002)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint336_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(659.92 255.25) scale(13.06)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint337_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(655.01 247.46) scale(4.24002)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint338_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(655.02 243.46) scale(1.20002)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint339_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(662.56 251.28) scale(6.30001)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint340_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(649.12 260.82) scale(5.32997)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint341_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(658.28 261.21) scale(6.11002)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint342_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(650.26 257.36) scale(2.07)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint343_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(650.27 261.13) scale(1.9)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint344_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(650.35 264.54) scale(1.76999)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <radialGradient
          id="paint345_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(679.77 266.69) scale(15.08)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <linearGradient
          id="paint346_linear_2072_10275"
          x1="675.37"
          y1="183.56"
          x2="674.45"
          y2="175.96"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <radialGradient
          id="paint347_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(667.28 182.746) rotate(176.98) scale(7.38997)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <linearGradient
          id="paint348_linear_2072_10275"
          x1="656.8"
          y1="198.34"
          x2="656.8"
          y2="201.35"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#D59149" />
        </linearGradient>
        <radialGradient
          id="paint349_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(644.505 183.221) rotate(-5.28001) scale(7.44999)"
        >
          <stop stopColor="#D78144" />
          <stop offset={1} stopColor="#CD8845" />
        </radialGradient>
        <linearGradient
          id="paint350_linear_2072_10275"
          x1="658.89"
          y1="191.51"
          x2="659.47"
          y2="185.82"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint351_linear_2072_10275"
          x1="667.59"
          y1="179.71"
          x2="654.72"
          y2="164.33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset="0.3" stopColor="#C98243" />
          <stop offset="0.66" stopColor="#C0733E" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint352_linear_2072_10275"
          x1="641.27"
          y1="180.78"
          x2="660.24"
          y2="166.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset="0.3" stopColor="#C98243" />
          <stop offset="0.66" stopColor="#C0733E" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint353_linear_2072_10275"
          x1="653.05"
          y1="190.9"
          x2="653.64"
          y2="185.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint354_linear_2072_10275"
          x1="656.32"
          y1="180.84"
          x2="656.59"
          y2="188.79"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint355_linear_2072_10275"
          x1="656.98"
          y1="184.16"
          x2="653.22"
          y2="152.14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint356_linear_2072_10275"
          x1="667.08"
          y1="180.98"
          x2="673.35"
          y2="179.36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#D59149" />
        </linearGradient>
        <linearGradient
          id="paint357_linear_2072_10275"
          x1="641.14"
          y1="180.38"
          x2="651.73"
          y2="174.12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint358_linear_2072_10275"
          x1="651.781"
          y1="177.79"
          x2="645.091"
          y2="176.182"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.46" stopColor="#FCFCFC" />
          <stop offset="0.76" stopColor="#F6F3F3" />
          <stop offset={1} stopColor="#ECE7E6" />
        </linearGradient>
        <linearGradient
          id="paint359_linear_2072_10275"
          x1="650.541"
          y1="176.77"
          x2="643.741"
          y2="177.043"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9734F" />
          <stop offset={1} stopColor="#633726" />
        </linearGradient>
        <linearGradient
          id="paint360_linear_2072_10275"
          x1="650.681"
          y1="176.57"
          x2="646.28"
          y2="175.762"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#936444" />
          <stop offset={1} stopColor="#593427" />
        </linearGradient>
        <linearGradient
          id="paint361_linear_2072_10275"
          x1="650.561"
          y1="177.25"
          x2="643.761"
          y2="177.523"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9734F" />
          <stop offset={1} stopColor="#633726" />
        </linearGradient>
        <radialGradient
          id="paint362_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(648.837 178.604) rotate(177.19) scale(4.2336 4.4982)"
        >
          <stop stopColor="#2B3B3B" />
          <stop offset={1} stopColor="#1D2827" />
        </radialGradient>
        <linearGradient
          id="paint363_linear_2072_10275"
          x1="670.8"
          y1="180.536"
          x2="660.286"
          y2="174.139"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint364_linear_2072_10275"
          x1="660.186"
          y1="177.872"
          x2="666.885"
          y2="176.335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.46" stopColor="#FCFCFC" />
          <stop offset="0.76" stopColor="#F6F3F3" />
          <stop offset={1} stopColor="#ECE7E6" />
        </linearGradient>
        <linearGradient
          id="paint365_linear_2072_10275"
          x1="661.438"
          y1="176.867"
          x2="668.224"
          y2="177.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9734F" />
          <stop offset={1} stopColor="#633726" />
        </linearGradient>
        <linearGradient
          id="paint366_linear_2072_10275"
          x1="661.291"
          y1="176.655"
          x2="665.7"
          y2="175.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#936444" />
          <stop offset={1} stopColor="#593427" />
        </linearGradient>
        <linearGradient
          id="paint367_linear_2072_10275"
          x1="661.412"
          y1="177.347"
          x2="668.198"
          y2="177.701"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A9734F" />
          <stop offset={1} stopColor="#633726" />
        </linearGradient>
        <radialGradient
          id="paint368_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(661.546 178.563) rotate(3.50001) scale(4.2336 4.49821)"
        >
          <stop stopColor="#2B3B3B" />
          <stop offset={1} stopColor="#1D2827" />
        </radialGradient>
        <linearGradient
          id="paint369_linear_2072_10275"
          x1="659.998"
          y1="176.363"
          x2="667.918"
          y2="175.973"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#43241D" />
          <stop offset="0.36" stopColor="#3F221B" />
          <stop offset="0.66" stopColor="#351D17" />
          <stop offset="0.93" stopColor="#241411" />
          <stop offset={1} stopColor="#1F120F" />
        </linearGradient>
        <linearGradient
          id="paint370_linear_2072_10275"
          x1="667.42"
          y1="197.137"
          x2="665.996"
          y2="180.058"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint371_linear_2072_10275"
          x1="651.972"
          y1="176.383"
          x2="644.057"
          y2="175.898"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#43241D" />
          <stop offset="0.36" stopColor="#3F221B" />
          <stop offset="0.66" stopColor="#351D17" />
          <stop offset="0.93" stopColor="#241411" />
          <stop offset={1} stopColor="#1F120F" />
        </linearGradient>
        <linearGradient
          id="paint372_linear_2072_10275"
          x1="644.34"
          y1="197.02"
          x2="645.97"
          y2="179.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint373_linear_2072_10275"
          x1="645.893"
          y1="181.522"
          x2="638.242"
          y2="179.655"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#D59149" />
        </linearGradient>
        <linearGradient
          id="paint374_linear_2072_10275"
          x1="663.92"
          y1="188.38"
          x2="668.12"
          y2="187.81"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint375_linear_2072_10275"
          x1="649.3"
          y1="188.74"
          x2="644.72"
          y2="187.98"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint376_linear_2072_10275"
          x1="656.85"
          y1="192.55"
          x2="656.75"
          y2="197.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint377_linear_2072_10275"
          x1="653.73"
          y1="193.61"
          x2="659.24"
          y2="193.61"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#D59149" />
        </linearGradient>
        <linearGradient
          id="paint378_linear_2072_10275"
          x1="650.156"
          y1="191.261"
          x2="663.266"
          y2="191.476"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D9D7" />
          <stop offset="0.14" stopColor="#EFE5E4" />
          <stop offset="0.39" stopColor="#FAF8F7" />
          <stop offset="0.57" stopColor="white" />
          <stop offset={1} stopColor="#E8D3D1" />
        </linearGradient>
        <linearGradient
          id="paint379_linear_2072_10275"
          x1="656.7"
          y1="192.55"
          x2="656.61"
          y2="197.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint380_linear_2072_10275"
          x1="656.23"
          y1="186.33"
          x2="656.44"
          y2="191.23"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D9D7" />
          <stop offset="0.4" stopColor="#EFE5E3" />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint381_linear_2072_10275"
          x1="656.771"
          y1="205.639"
          x2="656.424"
          y2="184.559"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint382_linear_2072_10275"
          x1="638.01"
          y1="187.35"
          x2="637.09"
          y2="179.74"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint383_linear_2072_10275"
          x1="656.317"
          y1="194.659"
          x2="656.23"
          y2="202.689"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint384_linear_2072_10275"
          x1="664.859"
          y1="201.016"
          x2="673.723"
          y2="182.773"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#D59149" />
        </linearGradient>
        <linearGradient
          id="paint385_linear_2072_10275"
          x1="648.28"
          y1="200.441"
          x2="638.515"
          y2="183.831"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#B35F38" />
        </linearGradient>
        <linearGradient
          id="paint386_linear_2072_10275"
          x1="643.315"
          y1="171.737"
          x2="653.06"
          y2="171.417"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#43241D" />
          <stop offset="0.36" stopColor="#3F221B" />
          <stop offset="0.66" stopColor="#351D17" />
          <stop offset="0.93" stopColor="#241411" />
          <stop offset={1} stopColor="#1F120F" />
        </linearGradient>
        <linearGradient
          id="paint387_linear_2072_10275"
          x1="670.428"
          y1="171.644"
          x2="660.679"
          y2="171.466"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#43241D" />
          <stop offset="0.36" stopColor="#3F221B" />
          <stop offset="0.66" stopColor="#351D17" />
          <stop offset="0.93" stopColor="#241411" />
          <stop offset={1} stopColor="#1F120F" />
        </linearGradient>
        <linearGradient
          id="paint388_linear_2072_10275"
          x1="654.61"
          y1="150.96"
          x2="656.36"
          y2="181.78"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#43241D" />
          <stop offset="0.36" stopColor="#3F221B" />
          <stop offset="0.66" stopColor="#351D17" />
          <stop offset="0.93" stopColor="#241411" />
          <stop offset={1} stopColor="#1F120F" />
        </linearGradient>
        <linearGradient
          id="paint389_linear_2072_10275"
          x1="655.48"
          y1="178.85"
          x2="656.66"
          y2="184.14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CD8845" />
          <stop offset={1} stopColor="#D59149" />
        </linearGradient>
        <linearGradient
          id="paint390_linear_2072_10275"
          x1="656.07"
          y1="157.98"
          x2="654.47"
          y2="151.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3F221A" />
          <stop offset="0.41" stopColor="#43241C" />
          <stop offset="0.87" stopColor="#502C25" />
          <stop offset={1} stopColor="#563029" />
        </linearGradient>
        <linearGradient
          id="paint391_linear_2072_10275"
          x1="634.74"
          y1="170.41"
          x2="657.74"
          y2="147.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF33B" />
          <stop offset="0.04" stopColor="#FEE62D" />
          <stop offset="0.12" stopColor="#FDD51B" />
          <stop offset="0.2" stopColor="#FDCA0F" />
          <stop offset="0.28" stopColor="#FDC70C" />
          <stop offset="0.67" stopColor="#808285" />
          <stop offset="0.89" stopColor="#D1D3D4" />
          <stop offset={1} stopColor="#F1F2F2" />
        </linearGradient>
        <linearGradient
          id="paint392_linear_2072_10275"
          x1="257.307"
          y1="196.182"
          x2="254.29"
          y2="186.076"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint393_linear_2072_10275"
          x1="237.405"
          y1="185.18"
          x2="245.384"
          y2="185.348"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint394_linear_2072_10275"
          x1="233.911"
          y1="185.806"
          x2="237.51"
          y2="185.882"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint395_linear_2072_10275"
          x1="233.337"
          y1="189.775"
          x2="235.787"
          y2="189.827"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint396_linear_2072_10275"
          x1="233.727"
          y1="195.934"
          x2="240.596"
          y2="196.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint397_linear_2072_10275"
          x1="253.117"
          y1="216.038"
          x2="248.587"
          y2="200.829"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1C59A" />
          <stop offset="0.53" stopColor="#F1C79C" />
          <stop offset="0.87" stopColor="#F5CFA5" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint398_linear_2072_10275"
          x1="265.011"
          y1="206.988"
          x2="260.696"
          y2="192.513"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint399_linear_2072_10275"
          x1="242.878"
          y1="186.546"
          x2="247.924"
          y2="191.013"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint400_linear_2072_10275"
          x1="240.227"
          y1="189.38"
          x2="245.382"
          y2="193.95"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint401_linear_2072_10275"
          x1="238.369"
          y1="192.112"
          x2="243.622"
          y2="196.774"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint402_linear_2072_10275"
          x1="236.973"
          y1="186.721"
          x2="242.127"
          y2="191.291"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint403_linear_2072_10275"
          x1="234.428"
          y1="188.828"
          x2="240.466"
          y2="194.176"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint404_linear_2072_10275"
          x1="247.554"
          y1="192.436"
          x2="237.669"
          y2="183.585"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1C59A" />
          <stop offset="0.53" stopColor="#F1C79C" />
          <stop offset="0.87" stopColor="#F5CFA5" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint405_linear_2072_10275"
          x1="244.53"
          y1="195.433"
          x2="229.66"
          y2="181.536"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1C59A" />
          <stop offset="0.53" stopColor="#F1C79C" />
          <stop offset="0.87" stopColor="#F5CFA5" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint406_linear_2072_10275"
          x1="243.742"
          y1="199.147"
          x2="228.697"
          y2="186.426"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1C59A" />
          <stop offset="0.53" stopColor="#F1C79C" />
          <stop offset="0.87" stopColor="#F5CFA5" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint407_linear_2072_10275"
          x1="278.706"
          y1="211.648"
          x2="248.019"
          y2="196.486"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1C59A" />
          <stop offset="0.53" stopColor="#F1C79C" />
          <stop offset="0.87" stopColor="#F5CFA5" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint408_linear_2072_10275"
          x1="252.571"
          y1="211.106"
          x2="249.526"
          y2="200.909"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint409_linear_2072_10275"
          x1="259.21"
          y1={213}
          x2="324.81"
          y2="240.82"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2C59A" />
          <stop offset="0.37" stopColor="#F6D1A8" />
          <stop offset={1} stopColor="#F3C79D" />
        </linearGradient>
        <linearGradient
          id="paint410_linear_2072_10275"
          x1="268.84"
          y1="209.27"
          x2="336.15"
          y2="220.83"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint411_linear_2072_10275"
          x1="314.18"
          y1="214.76"
          x2="319.1"
          y2="236.54"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6D1A8" />
          <stop offset={1} stopColor="#F2C59A" />
        </linearGradient>
        <linearGradient
          id="paint412_linear_2072_10275"
          x1="404.38"
          y1="229.46"
          x2="407.7"
          y2="298.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint413_linear_2072_10275"
          x1="412.89"
          y1="231.04"
          x2="413.48"
          y2="254.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint414_linear_2072_10275"
          x1="394.67"
          y1="242.93"
          x2="407.25"
          y2="230.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint415_linear_2072_10275"
          x1="411.55"
          y1="255.31"
          x2="412.52"
          y2="293.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint416_linear_2072_10275"
          x1="354.61"
          y1="212.56"
          x2="360.27"
          y2="211.74"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.13" stopColor="#F5CFA5" />
          <stop offset="0.47" stopColor="#F1C79C" />
          <stop offset={1} stopColor="#F1C59A" />
        </linearGradient>
        <linearGradient
          id="paint417_linear_2072_10275"
          x1="342.81"
          y1="195.86"
          x2="373.94"
          y2="210.07"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.13" stopColor="#F5CFA5" />
          <stop offset="0.47" stopColor="#F1C79C" />
          <stop offset={1} stopColor="#F1C59A" />
        </linearGradient>
        <linearGradient
          id="paint418_linear_2072_10275"
          x1="331.42"
          y1="188.51"
          x2="335.28"
          y2="259.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE4E21" />
          <stop offset="0.52" stopColor="#F24027" />
          <stop offset={1} stopColor="#ED3B2B" />
        </linearGradient>
        <linearGradient
          id="paint419_linear_2072_10275"
          x1="353.43"
          y1="195.85"
          x2="355.23"
          y2="229.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE4E21" />
          <stop offset="0.52" stopColor="#F24027" />
          <stop offset={1} stopColor="#ED3B2B" />
        </linearGradient>
        <linearGradient
          id="paint420_linear_2072_10275"
          x1="357.28"
          y1="260.3"
          x2="359.89"
          y2="230.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint421_linear_2072_10275"
          x1="357.64"
          y1="340.18"
          x2="360.28"
          y2="289.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1834" />
          <stop offset={1} stopColor="#1B2C60" />
        </linearGradient>
        <linearGradient
          id="paint422_linear_2072_10275"
          x1="359.17"
          y1="264.48"
          x2="360.54"
          y2="233.42"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1834" />
          <stop offset={1} stopColor="#1B2C60" />
        </linearGradient>
        <linearGradient
          id="paint423_linear_2072_10275"
          x1="359.24"
          y1="263.33"
          x2="360.57"
          y2="233.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1834" />
          <stop offset={1} stopColor="#1B2C60" />
        </linearGradient>
        <linearGradient
          id="paint424_linear_2072_10275"
          x1="377.07"
          y1="220.11"
          x2="339.36"
          y2="220.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1834" />
          <stop offset={1} stopColor="#1B2C60" />
        </linearGradient>
        <linearGradient
          id="paint425_linear_2072_10275"
          x1="363.21"
          y1="281.33"
          x2="351.7"
          y2="386.49"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1834" />
          <stop offset={1} stopColor="#1B2C60" />
        </linearGradient>
        <linearGradient
          id="paint426_linear_2072_10275"
          x1="341.56"
          y1="313.68"
          x2="322.18"
          y2="397.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint427_linear_2072_10275"
          x1="382.47"
          y1="316.46"
          x2="360.37"
          y2="412.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint428_linear_2072_10275"
          x1="358.86"
          y1="306.37"
          x2="349.86"
          y2="345.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint429_linear_2072_10275"
          x1="381.51"
          y1="215.7"
          x2="381.96"
          y2="206.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint430_linear_2072_10275"
          x1="334.37"
          y1="215.96"
          x2="334.9"
          y2="205.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint431_linear_2072_10275"
          x1="385.18"
          y1="217.67"
          x2="383.48"
          y2="312.28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1834" />
          <stop offset={1} stopColor="#1B2C60" />
        </linearGradient>
        <linearGradient
          id="paint432_linear_2072_10275"
          x1="332.99"
          y1="220.14"
          x2="331.29"
          y2="315.09"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1834" />
          <stop offset={1} stopColor="#1B2C60" />
        </linearGradient>
        <linearGradient
          id="paint433_linear_2072_10275"
          x1="359.56"
          y1="225.761"
          x2="357.98"
          y2="313.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1834" />
          <stop offset={1} stopColor="#1B2C60" />
        </linearGradient>
        <linearGradient
          id="paint434_linear_2072_10275"
          x1="387.39"
          y1="292.7"
          x2="376.94"
          y2="292.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1834" />
          <stop offset={1} stopColor="#1B2C60" />
        </linearGradient>
        <linearGradient
          id="paint435_linear_2072_10275"
          x1="328.95"
          y1="292.7"
          x2="339.96"
          y2="292.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1834" />
          <stop offset={1} stopColor="#1B2C60" />
        </linearGradient>
        <linearGradient
          id="paint436_linear_2072_10275"
          x1="335.69"
          y1="316.3"
          x2="334.12"
          y2="286.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint437_linear_2072_10275"
          x1="383.29"
          y1="314.14"
          x2="381.71"
          y2="283.96"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint438_linear_2072_10275"
          x1="381.86"
          y1="301.24"
          x2="376.35"
          y2="306.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint439_linear_2072_10275"
          x1="439.07"
          y1="251.68"
          x2="386.92"
          y2="294.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint440_linear_2072_10275"
          x1="387.2"
          y1="231.59"
          x2="390.42"
          y2="298.66"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint441_linear_2072_10275"
          x1="389.76"
          y1="310.36"
          x2="396.53"
          y2="291.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA779" />
          <stop offset="0.5" stopColor="#E4B386" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint442_linear_2072_10275"
          x1="400.58"
          y1="280.55"
          x2="369.28"
          y2="299.59"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA779" />
          <stop offset="0.5" stopColor="#E4B386" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint443_linear_2072_10275"
          x1="404.26"
          y1="284.41"
          x2="371.82"
          y2="304.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA779" />
          <stop offset="0.5" stopColor="#E4B386" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint444_linear_2072_10275"
          x1="401.03"
          y1="291.2"
          x2="379.94"
          y2="304.03"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA779" />
          <stop offset="0.5" stopColor="#E4B386" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint445_linear_2072_10275"
          x1="378.72"
          y1="298.51"
          x2="372.85"
          y2="304.02"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint446_linear_2072_10275"
          x1="376.91"
          y1="290.19"
          x2="370.59"
          y2="295.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint447_linear_2072_10275"
          x1="386.29"
          y1="303.28"
          x2="382.87"
          y2="306.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint448_linear_2072_10275"
          x1="285.981"
          y1="164.23"
          x2="288.466"
          y2="173.786"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint449_linear_2072_10275"
          x1="424.575"
          y1="160.411"
          x2="422.506"
          y2="170.046"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint450_linear_2072_10275"
          x1="358.42"
          y1="156.63"
          x2="358.06"
          y2="175.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.28" stopColor="#FBD6AF" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <radialGradient
          id="paint451_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(378.837 182.495) rotate(177.87) scale(9.02 6.40419)"
        >
          <stop stopColor="#F8C39C" />
          <stop offset={1} stopColor="#F7D4AB" />
        </radialGradient>
        <linearGradient
          id="paint452_linear_2072_10275"
          x1="358.18"
          y1="194.42"
          x2="358.54"
          y2="200.74"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <radialGradient
          id="paint453_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(366.822 180.685) rotate(-3.63) scale(9.25999 6.3894)"
        >
          <stop stopColor="#F8C39C" />
          <stop offset={1} stopColor="#F7D4AB" />
        </radialGradient>
        <linearGradient
          id="paint454_linear_2072_10275"
          x1="352.29"
          y1="241.59"
          x2="350.39"
          y2="187.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint455_linear_2072_10275"
          x1="367.92"
          y1="239.99"
          x2="366.08"
          y2="187.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint456_linear_2072_10275"
          x1="373.75"
          y1="178.1"
          x2="368.35"
          y2="179.96"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBD6AF" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint457_linear_2072_10275"
          x1="358.849"
          y1="203.2"
          x2="358.617"
          y2="192.606"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint458_linear_2072_10275"
          x1="351.695"
          y1="190.205"
          x2="365.546"
          y2="190.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D9D7" />
          <stop offset="0.14" stopColor="#EFE5E4" />
          <stop offset="0.39" stopColor="#FAF8F7" />
          <stop offset="0.57" stopColor="white" />
          <stop offset={1} stopColor="#E8D3D1" />
        </linearGradient>
        <linearGradient
          id="paint459_linear_2072_10275"
          x1="358.98"
          y1="203.312"
          x2="358.596"
          y2="192.582"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint460_linear_2072_10275"
          x1="358.11"
          y1="184.98"
          x2="358.33"
          y2="190.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D9D7" />
          <stop offset="0.4" stopColor="#EFE5E3" />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint461_linear_2072_10275"
          x1="358.681"
          y1="205.402"
          x2="358.313"
          y2="183.122"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint462_linear_2072_10275"
          x1="347.45"
          y1="179.85"
          x2="339.43"
          y2="177.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBD6AF" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint463_linear_2072_10275"
          x1="367.162"
          y1="178.829"
          x2="366.629"
          y2="172.66"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.52" stopColor="#F5D1A8" />
          <stop offset="0.85" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint464_linear_2072_10275"
          x1="348.504"
          y1="178.825"
          x2="349.002"
          y2="172.734"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.52" stopColor="#F5D1A8" />
          <stop offset="0.85" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint465_linear_2072_10275"
          x1="353.739"
          y1="174.253"
          x2="343.572"
          y2="176.968"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint466_linear_2072_10275"
          x1="353.24"
          y1="176.8"
          x2="346.59"
          y2="175.202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ECE7E7" />
          <stop offset="0.23" stopColor="#F5F3F3" />
          <stop offset="0.53" stopColor="#FCFCFC" />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint467_linear_2072_10275"
          x1="351.93"
          y1={176}
          x2="344.94"
          y2="176.283"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#94958D" />
          <stop offset={1} stopColor="#C5C6C0" />
        </linearGradient>
        <linearGradient
          id="paint468_linear_2072_10275"
          x1="350.85"
          y1="173.79"
          x2="342.39"
          y2="178.1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#94958D" />
          <stop offset={1} stopColor="#C5C6C0" />
        </linearGradient>
        <radialGradient
          id="paint469_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(348.311 177.266) rotate(177.29) scale(4.34999 4.43701)"
        >
          <stop stopColor="#2A3A3B" />
          <stop offset={1} stopColor="#1C2727" />
        </radialGradient>
        <linearGradient
          id="paint470_linear_2072_10275"
          x1="345.15"
          y1="174.39"
          x2="352.97"
          y2="174.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3C2A25" />
          <stop offset="0.08" stopColor="#382723" />
          <stop offset="0.55" stopColor="#2C1E1A" />
          <stop offset={1} stopColor="#281B18" />
        </linearGradient>
        <linearGradient
          id="paint471_linear_2072_10275"
          x1="361.703"
          y1="174.009"
          x2="371.87"
          y2="176.725"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint472_linear_2072_10275"
          x1="362.289"
          y1="176.462"
          x2="368.93"
          y2="174.864"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ECE7E7" />
          <stop offset="0.23" stopColor="#F5F3F3" />
          <stop offset="0.53" stopColor="#FCFCFC" />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint473_linear_2072_10275"
          x1="363.59"
          y1="175.662"
          x2="370.579"
          y2="175.944"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#94958D" />
          <stop offset={1} stopColor="#C5C6C0" />
        </linearGradient>
        <linearGradient
          id="paint474_linear_2072_10275"
          x1="364.67"
          y1="173.79"
          x2="373.14"
          y2="178.1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#94958D" />
          <stop offset={1} stopColor="#C5C6C0" />
        </linearGradient>
        <radialGradient
          id="paint475_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(366.933 176.886) rotate(2.71001) scale(4.34999 4.43701)"
        >
          <stop stopColor="#2A3A3B" />
          <stop offset={1} stopColor="#1C2727" />
        </radialGradient>
        <linearGradient
          id="paint476_linear_2072_10275"
          x1="362.55"
          y1="-23.1202"
          x2="370.37"
          y2="-23.1202"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3C2A25" />
          <stop offset="0.08" stopColor="#382723" />
          <stop offset="0.55" stopColor="#2C1E1A" />
          <stop offset={1} stopColor="#281B18" />
        </linearGradient>
        <linearGradient
          id="paint477_linear_2072_10275"
          x1="361.84"
          y1="170.12"
          x2="371.67"
          y2="170.12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#281B18" />
          <stop offset="0.45" stopColor="#2C1E1A" />
          <stop offset="0.92" stopColor="#382723" />
          <stop offset={1} stopColor="#3C2A25" />
        </linearGradient>
        <linearGradient
          id="paint478_linear_2072_10275"
          x1="343.73"
          y1="-23.1204"
          x2="353.57"
          y2="-23.1204"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#281B18" />
          <stop offset="0.45" stopColor="#2C1E1A" />
          <stop offset="0.92" stopColor="#382723" />
          <stop offset={1} stopColor="#3C2A25" />
        </linearGradient>
        <linearGradient
          id="paint479_linear_2072_10275"
          x1="356.24"
          y1="151.38"
          x2="358.39"
          y2="177.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.45" stopColor="#F3CAA0" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint480_linear_2072_10275"
          x1="373.36"
          y1="224.38"
          x2="371.91"
          y2="182.85"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint481_linear_2072_10275"
          x1="345.97"
          y1="221.68"
          x2="344.63"
          y2="183.37"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint482_linear_2072_10275"
          x1="336.2"
          y1="164.32"
          x2="348.7"
          y2="201.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#867569" />
          <stop offset={1} stopColor="#A89383" />
        </linearGradient>
        <linearGradient
          id="paint483_linear_2072_10275"
          x1="378.22"
          y1="165.56"
          x2="368.11"
          y2="201.74"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#867569" />
          <stop offset={1} stopColor="#A89383" />
        </linearGradient>
        <linearGradient
          id="paint484_linear_2072_10275"
          x1="358.25"
          y1="202.11"
          x2="358.9"
          y2="190.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A89383" />
          <stop offset={1} stopColor="#C0AFA2" />
        </linearGradient>
        <linearGradient
          id="paint485_linear_2072_10275"
          x1="357.84"
          y1="181.97"
          x2="357.99"
          y2="185.83"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#867569" />
          <stop offset={1} stopColor="#A89383" />
        </linearGradient>
        <linearGradient
          id="paint486_linear_2072_10275"
          x1="357.86"
          y1="166.76"
          x2="358.25"
          y2="182.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.2" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint487_linear_2072_10275"
          x1="358.02"
          y1="177.62"
          x2="358.16"
          y2="182.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.52" stopColor="#F5D1A8" />
          <stop offset="0.85" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint488_linear_2072_10275"
          x1="357.84"
          y1="183.73"
          x2="358.38"
          y2="179.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.28" stopColor="#FBD6AF" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint489_linear_2072_10275"
          x1="358.44"
          y1="193.08"
          x2="358.58"
          y2="196.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#867569" />
          <stop offset={1} stopColor="#A89383" />
        </linearGradient>
        <linearGradient
          id="paint490_linear_2072_10275"
          x1="358.25"
          y1="198.92"
          x2={358}
          y2="204.71"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#867569" />
          <stop offset={1} stopColor="#A89383" />
        </linearGradient>
        <linearGradient
          id="paint491_linear_2072_10275"
          x1="359.26"
          y1="146.69"
          x2="357.65"
          y2="176.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3C2A25" />
          <stop offset="0.16" stopColor="#352520" />
          <stop offset="0.54" stopColor="#2B1D1A" />
          <stop offset={1} stopColor="#281B18" />
        </linearGradient>
        <linearGradient
          id="paint492_linear_2072_10275"
          x1="340.2"
          y1="167.12"
          x2="376.08"
          y2="167.12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3C2A25" />
          <stop offset="0.16" stopColor="#352520" />
          <stop offset="0.54" stopColor="#2B1D1A" />
          <stop offset={1} stopColor="#281B18" />
        </linearGradient>
        <linearGradient
          id="paint493_linear_2072_10275"
          x1="357.14"
          y1="147.08"
          x2="355.28"
          y2="158.68"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3C2A25" />
          <stop offset="0.16" stopColor="#352520" />
          <stop offset="0.54" stopColor="#2B1D1A" />
          <stop offset={1} stopColor="#281B18" />
        </linearGradient>
        <linearGradient
          id="paint494_linear_2072_10275"
          x1="365.83"
          y1="148.26"
          x2="362.02"
          y2="158.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3C2A25" />
          <stop offset="0.16" stopColor="#352520" />
          <stop offset="0.54" stopColor="#2B1D1A" />
          <stop offset={1} stopColor="#281B18" />
        </linearGradient>
        <linearGradient
          id="paint495_linear_2072_10275"
          x1="370.97"
          y1="136.86"
          x2="352.07"
          y2="155.9"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4C3633" />
          <stop offset="0.5" stopColor="#402D28" />
          <stop offset={1} stopColor="#3C2A25" />
        </linearGradient>
        <linearGradient
          id="paint496_linear_2072_10275"
          x1="357.82"
          y1="156.71"
          x2="357.19"
          y2="140.17"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <linearGradient
          id="paint497_linear_2072_10275"
          x1="375.58"
          y1="154.17"
          x2="376.39"
          y2="170.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#0D1834" />
        </linearGradient>
        <linearGradient
          id="paint498_linear_2072_10275"
          x1="339.07"
          y1="154.78"
          x2="339.94"
          y2="172.03"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#0D1834" />
        </linearGradient>
        <linearGradient
          id="paint499_linear_2072_10275"
          x1="356.43"
          y1="148.85"
          x2="358.34"
          y2="174.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#0D1834" />
        </linearGradient>
        <linearGradient
          id="paint500_linear_2072_10275"
          x1="358.68"
          y1="176.59"
          x2="357.43"
          y2="164.43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B2C60" />
          <stop offset={1} stopColor="#394E7D" />
        </linearGradient>
        <radialGradient
          id="paint501_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(585.79 289.65) scale(237.17)"
        >
          <stop offset="0.02" stopColor="#E0DED2" />
          <stop offset="0.99" stopColor="#D4CAB4" />
        </radialGradient>
        <linearGradient
          id="paint502_linear_2072_10275"
          x1="252.064"
          y1="287.835"
          x2="921.068"
          y2="280.011"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F6F7E1" />
          <stop offset={1} stopColor="#F8FDDC" />
        </linearGradient>
        <radialGradient
          id="paint503_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(581.95 346.15) scale(217.86)"
        >
          <stop offset="0.02" stopColor="#E1DEC5" />
          <stop offset="0.99" stopColor="#CBBE9F" />
        </radialGradient>
        <radialGradient
          id="paint504_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(579.34 388.25) scale(201.78 201.78)"
        >
          <stop stopColor="#F8F3F6" />
          <stop offset={1} stopColor="#E1DEDC" />
        </radialGradient>
        <radialGradient
          id="paint505_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(581.95 314.25) scale(215.41)"
        >
          <stop stopColor="#D7D3C9" />
          <stop offset={1} stopColor="#EBEAE0" />
        </radialGradient>
        <linearGradient
          id="paint506_linear_2072_10275"
          x1="710.69"
          y1="382.89"
          x2="710.69"
          y2="296.83"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D8D0C2" />
          <stop offset={1} stopColor="#FFFFF2" />
        </linearGradient>
        <linearGradient
          id="paint507_linear_2072_10275"
          x1="766.76"
          y1="356.31"
          x2="803.91"
          y2="291.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset={1} stopColor="#E3E7DA" />
        </linearGradient>
        <linearGradient
          id="paint508_linear_2072_10275"
          x1="841.41"
          y1="378.31"
          x2="887.86"
          y2="297.86"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E3E7DA" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="paint509_linear_2072_10275"
          x1="770.44"
          y1="381.73"
          x2="770.44"
          y2="-23.1199"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D8D0C2" />
          <stop offset={1} stopColor="#FFFFF2" />
        </linearGradient>
        <linearGradient
          id="paint510_linear_2072_10275"
          x1="441.16"
          y1="385.3"
          x2="441.16"
          y2="-23.1199"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D8D0C2" />
          <stop offset={1} stopColor="#FFFFF2" />
        </linearGradient>
        <linearGradient
          id="paint511_linear_2072_10275"
          x1="522.24"
          y1="385.3"
          x2="522.24"
          y2="296.83"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9ED684" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="paint512_linear_2072_10275"
          x1="568.5"
          y1="384.51"
          x2="568.5"
          y2="296.83"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFFFF2" />
          <stop offset={1} stopColor="#D8D0C2" />
        </linearGradient>
        <linearGradient
          id="paint513_linear_2072_10275"
          x1="328.1"
          y1="386.66"
          x2="328.1"
          y2="-23.1199"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D8D0C2" />
          <stop offset={1} stopColor="#FFFFF2" />
        </linearGradient>
        <linearGradient
          id="paint514_linear_2072_10275"
          x1="363.41"
          y1="386.28"
          x2="363.41"
          y2="-23.1199"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9ED684" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="paint515_linear_2072_10275"
          x1="611.29"
          y1="383.59"
          x2="611.29"
          y2="-23.1198"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9ED684" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="paint516_linear_2072_10275"
          x1="577.72"
          y1={384}
          x2="577.72"
          y2="-23.1199"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9ED684" />
          <stop offset={1} />
        </linearGradient>
        <linearGradient
          id="paint517_linear_2072_10275"
          x1="213.01"
          y1="324.62"
          x2="213.01"
          y2="321.49"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C5AEBD" />
          <stop offset={1} stopColor="#8481D2" />
        </linearGradient>
        <radialGradient
          id="paint518_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(203.75 317.947) rotate(180) scale(7.75 4.95999)"
        >
          <stop offset="0.02" stopColor="#402743" />
          <stop offset="0.99" stopColor="#2A1032" />
        </radialGradient>
        <linearGradient
          id="paint519_linear_2072_10275"
          x1="234.79"
          y1="348.06"
          x2="215.3"
          y2="348.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#71656C" />
          <stop offset={1} />
        </linearGradient>
        <radialGradient
          id="paint520_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(210.74 286.89) rotate(180) scale(26.47)"
        >
          <stop offset="0.02" stopColor="#B54533" />
          <stop offset="0.99" stopColor="#791D36" />
        </radialGradient>
        <linearGradient
          id="paint521_linear_2072_10275"
          x1="220.39"
          y1="282.34"
          x2="220.39"
          y2="252.28"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2F2C08" />
          <stop offset={1} stopColor="#615A0E" />
        </linearGradient>
        <linearGradient
          id="paint522_linear_2072_10275"
          x1="186.45"
          y1="276.89"
          x2="186.45"
          y2="259.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#484525" />
          <stop offset={1} stopColor="#798633" />
        </linearGradient>
        <linearGradient
          id="paint523_linear_2072_10275"
          x1="221.55"
          y1="282.41"
          x2="221.55"
          y2="264.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#484525" />
          <stop offset={1} stopColor="#798633" />
        </linearGradient>
        <linearGradient
          id="paint524_linear_2072_10275"
          x1="195.36"
          y1="293.09"
          x2="195.36"
          y2="276.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#484525" />
          <stop offset={1} stopColor="#798633" />
        </linearGradient>
        <linearGradient
          id="paint525_linear_2072_10275"
          x1="201.97"
          y1="256.15"
          x2="201.97"
          y2="218.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2F2C08" />
          <stop offset={1} stopColor="#615A0E" />
        </linearGradient>
        <linearGradient
          id="paint526_linear_2072_10275"
          x1="199.27"
          y1="288.58"
          x2="199.27"
          y2="254.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2F2C08" />
          <stop offset={1} stopColor="#615A0E" />
        </linearGradient>
        <linearGradient
          id="paint527_linear_2072_10275"
          x1="215.1"
          y1="300.27"
          x2="215.1"
          y2="276.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#706500" />
          <stop offset={1} stopColor="#818400" />
        </linearGradient>
        <linearGradient
          id="paint528_linear_2072_10275"
          x1="214.51"
          y1="264.48"
          x2="214.51"
          y2="244.12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#706500" />
          <stop offset={1} stopColor="#818400" />
        </linearGradient>
        <linearGradient
          id="paint529_linear_2072_10275"
          x1="70.2999"
          y1="243.42"
          x2="67.7599"
          y2="253.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint530_linear_2072_10275"
          x1="63.3999"
          y1="245.76"
          x2="62.5199"
          y2="249.12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint531_linear_2072_10275"
          x1="57.0299"
          y1="252.57"
          x2="47.4499"
          y2="240.35"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint532_linear_2072_10275"
          x1="50.5399"
          y1="237.3"
          x2="48.6299"
          y2="241.9"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.51" stopColor="#E3B086" />
          <stop offset={1} stopColor="#DBA379" />
        </linearGradient>
        <linearGradient
          id="paint533_linear_2072_10275"
          x1="79.5699"
          y1="48.96"
          x2="87.1699"
          y2="109.02"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0B163" />
          <stop offset={1} stopColor="#A3753D" />
        </linearGradient>
        <linearGradient
          id="paint534_linear_2072_10275"
          x1="103.97"
          y1="158.48"
          x2="110.41"
          y2="106.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0B163" />
          <stop offset={1} stopColor="#A3753D" />
        </linearGradient>
        <linearGradient
          id="paint535_linear_2072_10275"
          x1="78.1799"
          y1="211.3"
          x2="68.8099"
          y2="121.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0B163" />
          <stop offset={1} stopColor="#A3753D" />
        </linearGradient>
        <linearGradient
          id="paint536_linear_2072_10275"
          x1="94.3699"
          y1="133.96"
          x2="78.2499"
          y2="152.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint537_linear_2072_10275"
          x1="96.6099"
          y1="147.68"
          x2="81.6799"
          y2="149.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint538_linear_2072_10275"
          x1="84.6399"
          y1="147.19"
          x2="67.3799"
          y2="144.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint539_linear_2072_10275"
          x1="86.2499"
          y1="148.39"
          x2="104.76"
          y2="143.33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint540_linear_2072_10275"
          x1="87.8099"
          y1="128.66"
          x2="85.1599"
          y2="140.3"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint541_linear_2072_10275"
          x1="109.65"
          y1="109.01"
          x2="109.13"
          y2="127.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint542_linear_2072_10275"
          x1="1269.17"
          y1="4077.09"
          x2="1264.9"
          y2="4062.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.52" stopColor="#F5D1A8" />
          <stop offset="0.85" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <radialGradient
          id="paint543_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(1115.86 347.897) rotate(12.3) scale(7.4284 8.2663)"
        >
          <stop stopColor="#F9B38E" />
          <stop offset="0.61" stopColor="#F7C59E" />
          <stop offset={1} stopColor="#F7D4AB" />
        </radialGradient>
        <linearGradient
          id="paint544_linear_2072_10275"
          x1="-1024.02"
          y1="3992.02"
          x2="-1019.88"
          y2="3977.69"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.52" stopColor="#F5D1A8" />
          <stop offset="0.85" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <radialGradient
          id="paint545_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-1040.27 422.917) rotate(164.69) scale(7.0952 7.35)"
        >
          <stop stopColor="#F9B38E" />
          <stop offset="0.61" stopColor="#F7C59E" />
          <stop offset={1} stopColor="#F7D4AB" />
        </radialGradient>
        <linearGradient
          id="paint546_linear_2072_10275"
          x1="71.9999"
          y1="112.55"
          x2="67.9299"
          y2="112.12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint547_linear_2072_10275"
          x1="103.46"
          y1="112.45"
          x2="99.3699"
          y2="112.47"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint548_linear_2072_10275"
          x1="91.9099"
          y1="124.97"
          x2="94.5999"
          y2="122.69"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.52" stopColor="#F5D1A8" />
          <stop offset="0.85" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint549_linear_2072_10275"
          x1="77.2399"
          y1="121.35"
          x2="73.1899"
          y2="118.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.52" stopColor="#F5D1A8" />
          <stop offset="0.85" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint550_linear_2072_10275"
          x1="87.7099"
          y1="124.28"
          x2="99.6999"
          y2="124.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D8D7" />
          <stop offset="0.14" stopColor="#EFE4E4" />
          <stop offset="0.39" stopColor="#FAF8F7" />
          <stop offset="0.57" stopColor="white" />
          <stop offset={1} stopColor="#E8D2D1" />
        </linearGradient>
        <linearGradient
          id="paint551_linear_2072_10275"
          x1="1364.22"
          y1="135.3"
          x2="1345.32"
          y2="135.12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D8D7" />
          <stop offset="0.04" stopColor="#EBDDDC" />
          <stop offset="0.21" stopColor="#F6F0EF" />
          <stop offset="0.38" stopColor="#FCFBFB" />
          <stop offset="0.57" stopColor="white" />
          <stop offset="0.69" stopColor="#FBF7F7" />
          <stop offset="0.87" stopColor="#F1E3E3" />
          <stop offset={1} stopColor="#E8D2D1" />
        </linearGradient>
        <linearGradient
          id="paint552_linear_2072_10275"
          x1="94.9599"
          y1="125.61"
          x2="81.3099"
          y2="124.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F96E7E" />
          <stop offset="0.03" stopColor="#F9707F" />
          <stop offset="0.25" stopColor="#FD7985" />
          <stop offset="0.53" stopColor="#FF7D88" />
          <stop offset="0.76" stopColor="#FD7985" />
          <stop offset={1} stopColor="#F86D7D" />
        </linearGradient>
        <linearGradient
          id="paint553_linear_2072_10275"
          x1="99.2599"
          y1="122.43"
          x2="84.6299"
          y2="122.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E8D8D7" />
          <stop offset="0.05" stopColor="#EADCDB" />
          <stop offset="0.31" stopColor="#F6EFEE" />
          <stop offset="0.48" stopColor="#FBF6F6" />
          <stop offset={1} stopColor="#E8D2D1" />
        </linearGradient>
        <linearGradient
          id="paint554_linear_2072_10275"
          x1="93.8299"
          y1="121.9"
          x2="83.3599"
          y2="121.79"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F96E7E" />
          <stop offset="0.03" stopColor="#F9707F" />
          <stop offset="0.25" stopColor="#FD7985" />
          <stop offset="0.53" stopColor="#FF7D88" />
          <stop offset="0.76" stopColor="#FD7985" />
          <stop offset={1} stopColor="#F86D7D" />
        </linearGradient>
        <linearGradient
          id="paint555_linear_2072_10275"
          x1="86.6699"
          y1="129.9"
          x2="86.6299"
          y2="132.75"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint556_linear_2072_10275"
          x1="86.1699"
          y1="135.07"
          x2="84.6699"
          y2="149.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint557_linear_2072_10275"
          x1="65.4399"
          y1="170.26"
          x2="65.9499"
          y2="189.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint558_linear_2072_10275"
          x1="66.2999"
          y1="105.17"
          x2="69.8799"
          y2="146.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A3753D" />
          <stop offset={1} stopColor="#E0B163" />
        </linearGradient>
        <linearGradient
          id="paint559_linear_2072_10275"
          x1="105.71"
          y1="116.92"
          x2="110.29"
          y2="80.69"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A3753D" />
          <stop offset={1} stopColor="#E0B163" />
        </linearGradient>
        <linearGradient
          id="paint560_linear_2072_10275"
          x1="104.4"
          y1="31.7399"
          x2="98.0299"
          y2="111.42"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0B163" />
          <stop offset={1} stopColor="#A3753D" />
        </linearGradient>
        <linearGradient
          id="paint561_linear_2072_10275"
          x1="118.41"
          y1="89.62"
          x2="83.2599"
          y2="95.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0B163" />
          <stop offset={1} stopColor="#F4C381" />
        </linearGradient>
        <linearGradient
          id="paint562_linear_2072_10275"
          x1="47.8199"
          y1="106.78"
          x2="70.3399"
          y2="81.46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0B163" />
          <stop offset={1} stopColor="#F4C381" />
        </linearGradient>
        <linearGradient
          id="paint563_linear_2072_10275"
          x1="120.69"
          y1="86.07"
          x2="55.3699"
          y2="86.07"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0B163" />
          <stop offset={1} stopColor="#F4C381" />
        </linearGradient>
        <linearGradient
          id="paint564_linear_2072_10275"
          x1="74.4599"
          y1="119.86"
          x2="65.0299"
          y2="121.68"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint565_linear_2072_10275"
          x1="80.6699"
          y1="99.11"
          x2="67.3299"
          y2="99.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#956134" />
          <stop offset="0.34" stopColor="#80552B" />
          <stop offset="0.68" stopColor="#744D26" />
          <stop offset={1} stopColor="#704B25" />
        </linearGradient>
        <linearGradient
          id="paint566_linear_2072_10275"
          x1="106.15"
          y1="99.05"
          x2="92.7299"
          y2="99.05"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#704B25" />
          <stop offset="0.32" stopColor="#744D26" />
          <stop offset="0.66" stopColor="#80552B" />
          <stop offset={1} stopColor="#956134" />
        </linearGradient>
        <linearGradient
          id="paint567_linear_2072_10275"
          x1="93.0499"
          y1="104.33"
          x2="103.49"
          y2="108.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.51" stopColor="#E3B086" />
          <stop offset={1} stopColor="#DBA379" />
        </linearGradient>
        <linearGradient
          id="paint568_linear_2072_10275"
          x1="95.6199"
          y1="107.03"
          x2="91.9699"
          y2="107.03"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.47" stopColor="#FCFCFC" />
          <stop offset="0.77" stopColor="#F5F3F3" />
          <stop offset={1} stopColor="#ECE7E7" />
        </linearGradient>
        <linearGradient
          id="paint569_linear_2072_10275"
          x1="102.29"
          y1="106.91"
          x2="99.2499"
          y2="106.91"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.47" stopColor="#FCFCFC" />
          <stop offset="0.77" stopColor="#F5F3F3" />
          <stop offset={1} stopColor="#ECE7E7" />
        </linearGradient>
        <linearGradient
          id="paint570_linear_2072_10275"
          x1="92.1599"
          y1="111.71"
          x2="100.77"
          y2="105.35"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B89C8C" />
          <stop offset={1} stopColor="#715241" />
        </linearGradient>
        <linearGradient
          id="paint571_linear_2072_10275"
          x1="85.6999"
          y1="112.47"
          x2="94.6399"
          y2="107.49"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B89C8C" />
          <stop offset={1} stopColor="#715241" />
        </linearGradient>
        <radialGradient
          id="paint572_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(97.6141 113.252) rotate(180) scale(2.4941 2.5137)"
        >
          <stop stopColor="#2A3A3B" />
          <stop offset={1} stopColor="#1C2727" />
        </radialGradient>
        <linearGradient
          id="paint573_linear_2072_10275"
          x1="105.6"
          y1="106.61"
          x2="91.9699"
          y2="106.61"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#391B13" />
          <stop offset="0.34" stopColor="#3D1C14" />
          <stop offset="0.71" stopColor="#492219" />
          <stop offset={1} stopColor="#5A2A1F" />
        </linearGradient>
        <linearGradient
          id="paint574_linear_2072_10275"
          x1="98.1699"
          y1="102.39"
          x2="92.2199"
          y2="111.19"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint575_linear_2072_10275"
          x1="86.5899"
          y1="120.43"
          x2="86.6299"
          y2="117.18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.52" stopColor="#F5D1A8" />
          <stop offset="0.85" stopColor="#F2C99F" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint576_linear_2072_10275"
          x1="86.4999"
          y1="117.14"
          x2="86.5899"
          y2="110.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint577_linear_2072_10275"
          x1="82.4299"
          y1="116.61"
          x2="85.0999"
          y2="117.99"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint578_linear_2072_10275"
          x1="90.7899"
          y1="116.72"
          x2="87.9199"
          y2="117.93"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint579_linear_2072_10275"
          x1="69.9199"
          y1="104.01"
          x2="81.9399"
          y2="108.87"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint580_linear_2072_10275"
          x1="81.7399"
          y1="106.8"
          x2="78.0899"
          y2="106.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.47" stopColor="#FCFCFC" />
          <stop offset="0.77" stopColor="#F5F3F3" />
          <stop offset={1} stopColor="#ECE7E7" />
        </linearGradient>
        <linearGradient
          id="paint581_linear_2072_10275"
          x1="73.5799"
          y1="106.7"
          x2="70.5499"
          y2="106.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.47" stopColor="#FCFCFC" />
          <stop offset="0.77" stopColor="#F5F3F3" />
          <stop offset={1} stopColor="#ECE7E7" />
        </linearGradient>
        <linearGradient
          id="paint582_linear_2072_10275"
          x1="71.7899"
          y1="109.98"
          x2="80.1899"
          y2="104.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B89C8C" />
          <stop offset={1} stopColor="#715241" />
        </linearGradient>
        <linearGradient
          id="paint583_linear_2072_10275"
          x1="64.6999"
          y1="106.93"
          x2="75.7499"
          y2="105.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B89C8C" />
          <stop offset={1} stopColor="#715241" />
        </linearGradient>
        <radialGradient
          id="paint584_radial_2072_10275"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(76.1756 112.987) rotate(180) scale(2.4941 2.5137)"
        >
          <stop stopColor="#2A3A3B" />
          <stop offset={1} stopColor="#1C2727" />
        </radialGradient>
        <linearGradient
          id="paint585_linear_2072_10275"
          x1="81.7399"
          y1="106.37"
          x2="68.0999"
          y2="106.37"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A2A1F" />
          <stop offset="0.29" stopColor="#492219" />
          <stop offset="0.66" stopColor="#3D1C14" />
          <stop offset={1} stopColor="#391B13" />
        </linearGradient>
        <linearGradient
          id="paint586_linear_2072_10275"
          x1="75.6099"
          y1="102.74"
          x2="84.3599"
          y2="114.32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint587_linear_2072_10275"
          x1="170.29"
          y1="187.55"
          x2="151.47"
          y2="197.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint588_linear_2072_10275"
          x1="126.67"
          y1="297.21"
          x2="120.81"
          y2="159.36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint589_linear_2072_10275"
          x1="99.9099"
          y1="145.18"
          x2="48.7399"
          y2="171.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint590_linear_2072_10275"
          x1="66.6799"
          y1="292.82"
          x2="61.7299"
          y2="176.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint591_linear_2072_10275"
          x1="171.93"
          y1="197.43"
          x2={168}
          y2="184.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint592_linear_2072_10275"
          x1="153.92"
          y1="213.48"
          x2="127.09"
          y2="124.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#39383C" />
          <stop offset="0.37" stopColor="#333236" />
          <stop offset={1} stopColor="#2F2E31" />
        </linearGradient>
        <linearGradient
          id="paint593_linear_2072_10275"
          x1="106.61"
          y1="148.62"
          x2="144.7"
          y2="207.05"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#272628" />
          <stop offset={1} stopColor="#2F2E31" />
        </linearGradient>
        <linearGradient
          id="paint594_linear_2072_10275"
          x1="116.55"
          y1="195.6"
          x2="130.69"
          y2="194.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#272628" />
          <stop offset="0.25" stopColor="#2A292C" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint595_linear_2072_10275"
          x1="3.5199"
          y1="209.83"
          x2="36.2599"
          y2="236.81"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint596_linear_2072_10275"
          x1="63.9499"
          y1="151.03"
          x2="60.6599"
          y2="280.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#39383C" />
          <stop offset="0.37" stopColor="#333236" />
          <stop offset={1} stopColor="#2F2E31" />
        </linearGradient>
        <linearGradient
          id="paint597_linear_2072_10275"
          x1="67.1299"
          y1="175.57"
          x2="52.9099"
          y2="230.98"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#272628" />
          <stop offset={1} stopColor="#2F2E31" />
        </linearGradient>
        <linearGradient
          id="paint598_linear_2072_10275"
          x1="74.5699"
          y1="234.76"
          x2="60.2199"
          y2="141.76"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#272628" />
          <stop offset={1} stopColor="#2F2E31" />
        </linearGradient>
        <linearGradient
          id="paint599_linear_2072_10275"
          x1="76.7599"
          y1="205.65"
          x2="62.8799"
          y2="128.79"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A3A3E" />
          <stop offset={1} stopColor="#39383C" />
        </linearGradient>
        <linearGradient
          id="paint600_linear_2072_10275"
          x1="75.9399"
          y1="150.22"
          x2="67.1499"
          y2="150.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#272628" />
          <stop offset={1} stopColor="#2F2E31" />
        </linearGradient>
        <linearGradient
          id="paint601_linear_2072_10275"
          x1="36.7599"
          y1="217.81"
          x2="0.819927"
          y2="187.88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C499" />
          <stop offset="0.52" stopColor="#F1C69B" />
          <stop offset="0.85" stopColor="#F4CEA4" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint602_linear_2072_10275"
          x1="30.1199"
          y1="151.36"
          x2="26.8499"
          y2="279.1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#39383C" />
          <stop offset="0.37" stopColor="#333236" />
          <stop offset={1} stopColor="#2F2E31" />
        </linearGradient>
        <linearGradient
          id="paint603_linear_2072_10275"
          x1="46.1499"
          y1="170.15"
          x2="32.0599"
          y2="225.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#272628" />
          <stop offset={1} stopColor="#2F2E31" />
        </linearGradient>
        <linearGradient
          id="paint604_linear_2072_10275"
          x1="128.15"
          y1="229.16"
          x2="115.05"
          y2="229.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#38373B" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint605_linear_2072_10275"
          x1={121}
          y1="198.91"
          x2="117.81"
          y2="147.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#272628" />
          <stop offset={1} stopColor="#2F2E31" />
        </linearGradient>
        <linearGradient
          id="paint606_linear_2072_10275"
          x1="126.9"
          y1="241.82"
          x2="97.4499"
          y2="92.18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A3A3E" />
          <stop offset={1} stopColor="#39383C" />
        </linearGradient>
        <linearGradient
          id="paint607_linear_2072_10275"
          x1="113.84"
          y1="153.57"
          x2="96.5199"
          y2="153.57"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#272628" />
          <stop offset={1} stopColor="#2F2E31" />
        </linearGradient>
        <linearGradient
          id="paint608_linear_2072_10275"
          x1="85.4899"
          y1="146.85"
          x2="85.8899"
          y2="160.03"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint609_linear_2072_10275"
          x1="2.07991"
          y1="207.62"
          x2="37.5199"
          y2="238.18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3F3E42" />
          <stop offset="0.32" stopColor="#39383C" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint610_linear_2072_10275"
          x1="43.8899"
          y1="231.01"
          x2="11.9999"
          y2="204.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#272628" />
          <stop offset={1} stopColor="#2F2E31" />
        </linearGradient>
        <linearGradient
          id="paint611_linear_2072_10275"
          x1="51.1599"
          y1="160.35"
          x2="10.7299"
          y2="201.66"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3F3F43" />
          <stop offset="0.48" stopColor="#353437" />
          <stop offset={1} stopColor="#2F2E31" />
        </linearGradient>
        <linearGradient
          id="paint612_linear_2072_10275"
          x1="169.13"
          y1="189.87"
          x2="120.98"
          y2="211.29"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3F3F43" />
          <stop offset="0.48" stopColor="#353437" />
          <stop offset={1} stopColor="#2F2E31" />
        </linearGradient>
        <linearGradient
          id="paint613_linear_2072_10275"
          x1="114.88"
          y1="146.61"
          x2="125.33"
          y2="164.74"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3F3E42" />
          <stop offset="0.32" stopColor="#39383C" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint614_linear_2072_10275"
          x1="73.0499"
          y1="80.46"
          x2="59.2899"
          y2="155.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A3753D" />
          <stop offset={1} stopColor="#E0B163" />
        </linearGradient>
        <linearGradient
          id="paint615_linear_2072_10275"
          x1="57.0599"
          y1="74.2399"
          x2="63.8199"
          y2="136.71"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A3753D" />
          <stop offset={1} stopColor="#E0B163" />
        </linearGradient>
        <linearGradient
          id="paint616_linear_2072_10275"
          x1="91.0499"
          y1="80.5599"
          x2="111.87"
          y2="133.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A3753D" />
          <stop offset={1} stopColor="#E0B163" />
        </linearGradient>
        <linearGradient
          id="paint617_linear_2072_10275"
          x1="110.18"
          y1="359.51"
          x2="90.0099"
          y2="359.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA779" />
          <stop offset="0.38" stopColor="#E0B081" />
          <stop offset="0.99" stopColor="#EFC898" />
          <stop offset={1} stopColor="#F0C999" />
        </linearGradient>
        <linearGradient
          id="paint618_linear_2072_10275"
          x1="74.2199"
          y1="428.92"
          x2="101.92"
          y2="431.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C999" />
          <stop offset="0.52" stopColor="#F1CB9B" />
          <stop offset="0.85" stopColor="#F4D3A4" />
          <stop offset={1} stopColor="#F7D9AB" />
        </linearGradient>
        <linearGradient
          id="paint619_linear_2072_10275"
          x1="55.3299"
          y1="437.44"
          x2="52.9699"
          y2="483.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3D0A0" />
          <stop offset={1} stopColor="#F7D9AB" />
        </linearGradient>
        <linearGradient
          id="paint620_linear_2072_10275"
          x1="88.6699"
          y1="389.06"
          x2="61.1699"
          y2="389.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3D0A0" />
          <stop offset={1} stopColor="#F7D9AB" />
        </linearGradient>
        <linearGradient
          id="paint621_linear_2072_10275"
          x1="107.08"
          y1="353.2"
          x2="75.5299"
          y2="353.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0C999" />
          <stop offset="0.52" stopColor="#F1CB9B" />
          <stop offset="0.85" stopColor="#F4D3A4" />
          <stop offset={1} stopColor="#F7D9AB" />
        </linearGradient>
        <linearGradient
          id="paint622_linear_2072_10275"
          x1="62.8799"
          y1="260.89"
          x2="58.1899"
          y2="150.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F0F5" />
          <stop offset={1} stopColor="#E1E1E5" />
        </linearGradient>
        <linearGradient
          id="paint623_linear_2072_10275"
          x1="106.45"
          y1="366.96"
          x2="68.6999"
          y2="175.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#38373B" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint624_linear_2072_10275"
          x1="73.3899"
          y1="242.92"
          x2="117.14"
          y2="242.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2B2A2D" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint625_linear_2072_10275"
          x1="67.8299"
          y1="238.95"
          x2="60.9899"
          y2="296.45"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2B2A2D" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint626_linear_2072_10275"
          x1="66.6099"
          y1={167}
          x2="63.6599"
          y2="282.48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#38373B" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint627_linear_2072_10275"
          x1="82.7799"
          y1="200.74"
          x2="64.6901"
          y2="237.37"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2B2A2D" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint628_linear_2072_10275"
          x1="72.9299"
          y1="185.18"
          x2="59.4599"
          y2="237.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2B2A2D" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint629_linear_2072_10275"
          x1="76.4499"
          y1="239.47"
          x2="64.0499"
          y2="159.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2B2A2D" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint630_linear_2072_10275"
          x1="72.3399"
          y1="213.94"
          x2="59.63"
          y2="143.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A3A3E" />
          <stop offset={1} stopColor="#38373B" />
        </linearGradient>
        <linearGradient
          id="paint631_linear_2072_10275"
          x1="118.6"
          y1="242.17"
          x2="110.97"
          y2="306.38"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2B2A2D" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint632_linear_2072_10275"
          x1="125.19"
          y1="255.16"
          x2="112.73"
          y2="255.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#38373B" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint633_linear_2072_10275"
          x1="115.96"
          y1="248.01"
          x2="88.02"
          y2="106.071"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A3A3E" />
          <stop offset={1} stopColor="#38373B" />
        </linearGradient>
        <linearGradient
          id="paint634_linear_2072_10275"
          x1="68.8599"
          y1="303.57"
          x2="59.4399"
          y2="382.72"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2B2A2D" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint635_linear_2072_10275"
          x1="114.44"
          y1="308.54"
          x2="111.04"
          y2="360.04"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#38373B" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint636_linear_2072_10275"
          x1="95.0599"
          y1="261.48"
          x2="95.9499"
          y2="300.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#38373B" />
          <stop offset="0.64" stopColor="#302F32" />
          <stop offset={1} stopColor="#2A292C" />
        </linearGradient>
        <linearGradient
          id="paint637_linear_2072_10275"
          x1="58.1899"
          y1="463.98"
          x2={106}
          y2="369.18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFDEB3" />
          <stop offset="0.68" stopColor="#FCDCB0" />
          <stop offset={1} stopColor="#F7D9AB" />
        </linearGradient>
        <linearGradient
          id="paint638_linear_2072_10275"
          x1="66.0899"
          y1="226.68"
          x2="58.5396"
          y2={244}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2B2A2D" />
          <stop offset={1} stopColor="#333236" />
        </linearGradient>
        <linearGradient
          id="paint639_linear_2072_10275"
          x1="187.32"
          y1="172.18"
          x2="196.35"
          y2="170.78"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.45" stopColor="#F1C69C" />
          <stop offset="0.46" stopColor="#F1C69C" />
          <stop offset="0.71" stopColor="#F5D0A7" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint640_linear_2072_10275"
          x1="200.8"
          y1="160.35"
          x2="192.18"
          y2="171.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint641_linear_2072_10275"
          x1="203.1"
          y1="162.37"
          x2="194.46"
          y2="173.46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint642_linear_2072_10275"
          x1="202.84"
          y1="174.57"
          x2="196.6"
          y2="173.68"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.29" stopColor="#F5D0A7" />
          <stop offset="0.54" stopColor="#F1C69C" />
          <stop offset="0.55" stopColor="#F1C69C" />
        </linearGradient>
        <linearGradient
          id="paint643_linear_2072_10275"
          x1="185.43"
          y1="190.8"
          x2="194.01"
          y2="177.56"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.23" stopColor="#F5D0A7" />
          <stop offset="0.44" stopColor="#F1C69C" />
          <stop offset="0.45" stopColor="#F1C69C" />
        </linearGradient>
        <linearGradient
          id="paint644_linear_2072_10275"
          x1="200.81"
          y1="174.86"
          x2="188.76"
          y2="183.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint645_linear_2072_10275"
          x1="196.59"
          y1="172.89"
          x2="190.91"
          y2="176.94"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <linearGradient
          id="paint646_linear_2072_10275"
          x1="178.44"
          y1="182.16"
          x2="186.69"
          y2="176.77"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint647_linear_2072_10275"
          x1="202.24"
          y1="178.51"
          x2="191.39"
          y2="181.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.29" stopColor="#F5D0A7" />
          <stop offset="0.54" stopColor="#F1C69C" />
          <stop offset="0.55" stopColor="#F1C69C" />
        </linearGradient>
        <linearGradient
          id="paint648_linear_2072_10275"
          x1="198.07"
          y1="189.77"
          x2="194.73"
          y2="184.87"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.29" stopColor="#F5D0A7" />
          <stop offset="0.54" stopColor="#F1C69C" />
          <stop offset="0.55" stopColor="#F1C69C" />
        </linearGradient>
        <linearGradient
          id="paint649_linear_2072_10275"
          x1="198.15"
          y1="182.13"
          x2="184.92"
          y2="186.02"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.29" stopColor="#F5D0A7" />
          <stop offset="0.54" stopColor="#F1C69C" />
          <stop offset="0.55" stopColor="#F1C69C" />
        </linearGradient>
        <linearGradient
          id="paint650_linear_2072_10275"
          x1="196.86"
          y1="175.66"
          x2="197.22"
          y2="173.66"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD9B3" />
          <stop offset="0.68" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#F7D4AB" />
        </linearGradient>
        <linearGradient
          id="paint651_linear_2072_10275"
          x1="176.34"
          y1="199.8"
          x2="183.41"
          y2="188.89"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.29" stopColor="#F5D0A7" />
          <stop offset="0.54" stopColor="#F1C69C" />
          <stop offset="0.55" stopColor="#F1C69C" />
        </linearGradient>
        <linearGradient
          id="paint652_linear_2072_10275"
          x1="168.2"
          y1="191.35"
          x2="176.46"
          y2="178.62"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.29" stopColor="#F5D0A7" />
          <stop offset="0.54" stopColor="#F1C69C" />
          <stop offset="0.55" stopColor="#F1C69C" />
        </linearGradient>
        <linearGradient
          id="paint653_linear_2072_10275"
          x1="195.32"
          y1="187.8"
          x2="195.93"
          y2="184.42"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7D4AB" />
          <stop offset="0.32" stopColor="#FCD7B0" />
          <stop offset={1} stopColor="#FFD9B3" />
        </linearGradient>
        <linearGradient
          id="paint654_linear_2072_10275"
          x1="168.92"
          y1="185.3"
          x2="176.49"
          y2="196.51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBA379" />
          <stop offset="0.49" stopColor="#E3B086" />
          <stop offset={1} stopColor="#F0C499" />
        </linearGradient>
        <clipPath id="clip0_2072_10275">
          <rect
            width={84}
            height={22}
            fill="white"
            transform="translate(193.719 161.101) rotate(-2.23746)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
